import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigFloat: any;
  BigInt: any;
  Cursor: any;
  Date: any;
  Datetime: any;
  GeoJSON: any;
  Geometry: any;
  JSON: any;
  UUID: any;
  Upload: any;
};

export enum AccessTokenType {
  MACHINE = 'MACHINE',
  USER = 'USER'
}

/** A filter to be used against AccessTokenType fields. All fields are combined with a logical ‘and.’ */
export type AccessTokenTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<AccessTokenType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<AccessTokenType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<AccessTokenType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<AccessTokenType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<AccessTokenType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<AccessTokenType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<AccessTokenType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<AccessTokenType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<AccessTokenType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<AccessTokenType>>;
};

export type AccountCharge = Node & {
  __typename?: 'AccountCharge';
  /** Reads a single `AccountStatement` that is related to this `AccountCharge`. */
  accountStatement?: Maybe<AccountStatement>;
  accountStatementId: Scalars['Int'];
  /** The category of the account charge. */
  category: UtilityAccountChargeCategory;
  /** The time the charge was created. */
  createdAt: Scalars['Datetime'];
  /** The time the charge was deleted. */
  deletedAt?: Maybe<Scalars['Datetime']>;
  id: Scalars['Int'];
  /** The end date of the account charge. */
  intervalEnd: Scalars['Date'];
  /** The start date of the account charge. */
  intervalStart: Scalars['Date'];
  /** The label of the account charge. */
  label: Scalars['String'];
  /** This is used to further distinguish otherwise duplicate rows that need to be present */
  lineNumber: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  overrideAt?: Maybe<Scalars['Datetime']>;
  /** Overrides the normalized month of the account_statement. */
  overrideStatementMonth?: Maybe<Scalars['Int']>;
  /** Overrides the normalized year of the account_statement. */
  overrideStatementYear?: Maybe<Scalars['Int']>;
  statementDate: Scalars['Date'];
  statementMonth?: Maybe<Scalars['Int']>;
  statementYear?: Maybe<Scalars['Int']>;
  /** The time the charge was updated. */
  updatedAt: Scalars['Datetime'];
  /** This original value of the charge. */
  value: Scalars['Float'];
};

/**
 * A condition to be used against `AccountCharge` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AccountChargeCondition = {
  /** Checks for equality with the object’s `accountStatementId` field. */
  accountStatementId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `category` field. */
  category?: InputMaybe<UtilityAccountChargeCategory>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `intervalEnd` field. */
  intervalEnd?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `intervalStart` field. */
  intervalStart?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `lineNumber` field. */
  lineNumber?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `normalizedValue` field. */
  normalizedValue?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `overrideAt` field. */
  overrideAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `overrideStatementMonth` field. */
  overrideStatementMonth?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `overrideStatementYear` field. */
  overrideStatementYear?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `statementDate` field. */
  statementDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `AccountCharge` object types. All fields are combined with a logical ‘and.’ */
export type AccountChargeFilter = {
  /** Filter by the object’s `accountStatementId` field. */
  accountStatementId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AccountChargeFilter>>;
  /** Filter by the object’s `category` field. */
  category?: InputMaybe<UtilityAccountChargeCategoryFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `intervalEnd` field. */
  intervalEnd?: InputMaybe<DateFilter>;
  /** Filter by the object’s `intervalStart` field. */
  intervalStart?: InputMaybe<DateFilter>;
  /** Filter by the object's `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lineNumber` field. */
  lineNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `normalizedValue` field. */
  normalizedValue?: InputMaybe<FloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AccountChargeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AccountChargeFilter>>;
  /** Filter by the object’s `overrideAt` field. */
  overrideAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `overrideStatementMonth` field. */
  overrideStatementMonth?: InputMaybe<IntFilter>;
  /** Filter by the object’s `overrideStatementYear` field. */
  overrideStatementYear?: InputMaybe<IntFilter>;
  /** Filter by the object’s `statementDate` field. */
  statementDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `statementMonth` field. */
  statementMonth?: InputMaybe<IntFilter>;
  /** Filter by the object’s `statementYear` field. */
  statementYear?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object's `value` field. */
  value?: InputMaybe<FloatFilter>;
};

/** An input for mutations affecting `AccountCharge` */
export type AccountChargeInput = {
  /** Mutates a `AccountStatement` as part of the payload */
  accountStatement?: InputMaybe<AccountStatementInput>;
  accountStatementId?: InputMaybe<Scalars['Int']>;
  /** The category of the account charge. */
  category: UtilityAccountChargeCategory;
  id?: InputMaybe<Scalars['Int']>;
  /** The end date of the account charge. */
  intervalEnd: Scalars['Date'];
  /** The start date of the account charge. */
  intervalStart: Scalars['Date'];
  /** The label of the account charge. */
  label: Scalars['String'];
  /** This is used to further distinguish otherwise duplicate rows that need to be present */
  lineNumber?: InputMaybe<Scalars['Int']>;
  statementDate: Scalars['Date'];
  /** This original value of the charge. */
  value: Scalars['Float'];
};

/** Represents an update to a `AccountCharge`. Fields that are set will be updated. */
export type AccountChargePatch = {
  label?: InputMaybe<Scalars['String']>;
  /** Overrides the normalized month of the account_statement. */
  overrideStatementMonth?: InputMaybe<Scalars['Int']>;
  /** Overrides the normalized year of the account_statement. */
  overrideStatementYear?: InputMaybe<Scalars['Int']>;
  statementDate?: InputMaybe<Scalars['Date']>;
  /** Overrides the value of the charge. */
  value?: InputMaybe<Scalars['Float']>;
};

/** A connection to a list of `AccountCharge` values. */
export type AccountChargesConnection = {
  __typename?: 'AccountChargesConnection';
  /** A list of edges which contains the `AccountCharge` and cursor to aid in pagination. */
  edges: Array<AccountChargesEdge>;
  /** A list of `AccountCharge` objects. */
  nodes: Array<AccountCharge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AccountCharge` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AccountCharge` edge in the connection. */
export type AccountChargesEdge = {
  __typename?: 'AccountChargesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AccountCharge` at the end of the edge. */
  node: AccountCharge;
};

/** Methods to use when ordering `AccountCharge`. */
export enum AccountChargesOrderBy {
  ACCOUNT_STATEMENT_ID_ASC = 'ACCOUNT_STATEMENT_ID_ASC',
  ACCOUNT_STATEMENT_ID_DESC = 'ACCOUNT_STATEMENT_ID_DESC',
  CATEGORY_ASC = 'CATEGORY_ASC',
  CATEGORY_DESC = 'CATEGORY_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DELETED_AT_ASC = 'DELETED_AT_ASC',
  DELETED_AT_DESC = 'DELETED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  INTERVAL_END_ASC = 'INTERVAL_END_ASC',
  INTERVAL_END_DESC = 'INTERVAL_END_DESC',
  INTERVAL_START_ASC = 'INTERVAL_START_ASC',
  INTERVAL_START_DESC = 'INTERVAL_START_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  LINE_NUMBER_ASC = 'LINE_NUMBER_ASC',
  LINE_NUMBER_DESC = 'LINE_NUMBER_DESC',
  NATURAL = 'NATURAL',
  NORMALIZED_VALUE_ASC = 'NORMALIZED_VALUE_ASC',
  NORMALIZED_VALUE_DESC = 'NORMALIZED_VALUE_DESC',
  OVERRIDE_AT_ASC = 'OVERRIDE_AT_ASC',
  OVERRIDE_AT_DESC = 'OVERRIDE_AT_DESC',
  OVERRIDE_LABEL_ASC = 'OVERRIDE_LABEL_ASC',
  OVERRIDE_LABEL_DESC = 'OVERRIDE_LABEL_DESC',
  OVERRIDE_STATEMENT_MONTH_ASC = 'OVERRIDE_STATEMENT_MONTH_ASC',
  OVERRIDE_STATEMENT_MONTH_DESC = 'OVERRIDE_STATEMENT_MONTH_DESC',
  OVERRIDE_STATEMENT_YEAR_ASC = 'OVERRIDE_STATEMENT_YEAR_ASC',
  OVERRIDE_STATEMENT_YEAR_DESC = 'OVERRIDE_STATEMENT_YEAR_DESC',
  OVERRIDE_VALUE_ASC = 'OVERRIDE_VALUE_ASC',
  OVERRIDE_VALUE_DESC = 'OVERRIDE_VALUE_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  STATEMENT_DATE_ASC = 'STATEMENT_DATE_ASC',
  STATEMENT_DATE_DESC = 'STATEMENT_DATE_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VALUE_ASC = 'VALUE_ASC',
  VALUE_DESC = 'VALUE_DESC'
}

export type AccountMissingStatement = {
  __typename?: 'AccountMissingStatement';
  metadata?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  statementDate?: Maybe<Scalars['Date']>;
  statementMonth?: Maybe<Scalars['Int']>;
  statementYear?: Maybe<Scalars['Int']>;
  utilityAccountId?: Maybe<Scalars['Int']>;
  /** Reads and enables pagination through a set of `UtilityMeter`. */
  utilityMeters: UtilityMetersConnection;
};

export type AccountMissingStatementUtilityMetersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  facilityId?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<UtilityMeterFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `AccountMissingStatement` object types. All fields are combined with a logical ‘and.’ */
export type AccountMissingStatementFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AccountMissingStatementFilter>>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonListFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AccountMissingStatementFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AccountMissingStatementFilter>>;
  /** Filter by the object’s `statementDate` field. */
  statementDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `statementMonth` field. */
  statementMonth?: InputMaybe<IntFilter>;
  /** Filter by the object’s `statementYear` field. */
  statementYear?: InputMaybe<IntFilter>;
  /** Filter by the object’s `utilityAccountId` field. */
  utilityAccountId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `AccountMissingStatement` values. */
export type AccountMissingStatementsConnection = {
  __typename?: 'AccountMissingStatementsConnection';
  /** A list of edges which contains the `AccountMissingStatement` and cursor to aid in pagination. */
  edges: Array<AccountMissingStatementsEdge>;
  /** A list of `AccountMissingStatement` objects. */
  nodes: Array<AccountMissingStatement>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AccountMissingStatement` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AccountMissingStatement` edge in the connection. */
export type AccountMissingStatementsEdge = {
  __typename?: 'AccountMissingStatementsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AccountMissingStatement` at the end of the edge. */
  node: AccountMissingStatement;
};

export type AccountStatement = Node & {
  __typename?: 'AccountStatement';
  /** Reads and enables pagination through a set of `AccountCharge`. */
  accountCharges: AccountChargesConnection;
  /** Reads and enables pagination through a set of `AccountStatementHistory`. */
  accountStatementHistories: AccountStatementHistoriesConnection;
  /** Reads and enables pagination through a set of `AccountStatementPdf`. */
  accountStatementPdfs: AccountStatementPdfsConnection;
  /** The time the statement was created. */
  createdAt: Scalars['Datetime'];
  /** The currency code of the statement. */
  currencyCode: Scalars['String'];
  /** Returns the deleted_at column of this record or its parent */
  deletedAt?: Maybe<Scalars['Datetime']>;
  id: Scalars['Int'];
  integration: UtilityIntegration;
  /** The identifier provided by the integration source */
  integrationKey: Scalars['String'];
  /** The overall statement billing interval end */
  intervalEnd: Scalars['Date'];
  /** The overall statement billing interval start */
  intervalStart: Scalars['Date'];
  isValidated: Scalars['Boolean'];
  metadata: Scalars['JSON'];
  /** Reads and enables pagination through a set of `MeterStatement`. */
  meterStatements: MeterStatementsConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  normalizedTotalCharges?: Maybe<Scalars['Float']>;
  overrideAt?: Maybe<Scalars['Datetime']>;
  /** The normalized month of the statement. */
  statementMonth: Scalars['Int'];
  /** The normalized year of the statement. */
  statementYear: Scalars['Int'];
  totalCharges?: Maybe<Scalars['Float']>;
  /** The time the statement was updated. */
  updatedAt: Scalars['Datetime'];
  /** Reads a single `UtilityAccount` that is related to this `AccountStatement`. */
  utilityAccount?: Maybe<UtilityAccount>;
  utilityAccountId: Scalars['Int'];
  /** Reads a single `UtilityAccountStatement` that is related to this `AccountStatement`. */
  utilityAccountStatement?: Maybe<UtilityAccountStatement>;
  /** Reads a single `UtilityAccountStatementRollup` that is related to this `AccountStatement`. */
  utilityAccountStatementRollup?: Maybe<UtilityAccountStatementRollup>;
  /** Reads and enables pagination through a set of `UtilityMeterStatement`. */
  utilityMeterStatements: UtilityMeterStatementsConnection;
};

export type AccountStatementAccountChargesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountChargeCondition>;
  filter?: InputMaybe<AccountChargeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountChargesOrderBy>>;
};

export type AccountStatementAccountStatementHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountStatementHistoryCondition>;
  filter?: InputMaybe<AccountStatementHistoryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountStatementHistoriesOrderBy>>;
};

export type AccountStatementAccountStatementPdfsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountStatementPdfCondition>;
  filter?: InputMaybe<AccountStatementPdfFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountStatementPdfsOrderBy>>;
};

export type AccountStatementMeterStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MeterStatementCondition>;
  filter?: InputMaybe<MeterStatementFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MeterStatementsOrderBy>>;
};

export type AccountStatementUtilityMeterStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UtilityMeterStatementCondition>;
  filter?: InputMaybe<UtilityMeterStatementFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UtilityMeterStatementsOrderBy>>;
};

/**
 * A condition to be used against `AccountStatement` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AccountStatementCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `integration` field. */
  integration?: InputMaybe<UtilityIntegration>;
  /** Checks for equality with the object’s `integrationKey` field. */
  integrationKey?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `intervalEnd` field. */
  intervalEnd?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `intervalStart` field. */
  intervalStart?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `isValidated` field. */
  isValidated?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `normalizedCurrencyCode` field. */
  normalizedCurrencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `overrideAt` field. */
  overrideAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `statementMonth` field. */
  statementMonth?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `statementYear` field. */
  statementYear?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `utilityAccountId` field. */
  utilityAccountId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `AccountStatement` object types. All fields are combined with a logical ‘and.’ */
export type AccountStatementFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AccountStatementFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object's `currencyCode` field. */
  currencyCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `integration` field. */
  integration?: InputMaybe<UtilityIntegrationFilter>;
  /** Filter by the object’s `integrationKey` field. */
  integrationKey?: InputMaybe<StringFilter>;
  /** Filter by the object’s `intervalEnd` field. */
  intervalEnd?: InputMaybe<DateFilter>;
  /** Filter by the object’s `intervalStart` field. */
  intervalStart?: InputMaybe<DateFilter>;
  /** Filter by the object’s `isValidated` field. */
  isValidated?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `normalizedCurrencyCode` field. */
  normalizedCurrencyCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `normalizedTotalCharges` field. */
  normalizedTotalCharges?: InputMaybe<FloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AccountStatementFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AccountStatementFilter>>;
  /** Filter by the object’s `overrideAt` field. */
  overrideAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `statementMonth` field. */
  statementMonth?: InputMaybe<IntFilter>;
  /** Filter by the object’s `statementYear` field. */
  statementYear?: InputMaybe<IntFilter>;
  /** Filter by the object’s `totalCharges` field. */
  totalCharges?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `utilityAccountId` field. */
  utilityAccountId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `AccountStatementHistory` values. */
export type AccountStatementHistoriesConnection = {
  __typename?: 'AccountStatementHistoriesConnection';
  /** A list of edges which contains the `AccountStatementHistory` and cursor to aid in pagination. */
  edges: Array<AccountStatementHistoriesEdge>;
  /** A list of `AccountStatementHistory` objects. */
  nodes: Array<AccountStatementHistory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AccountStatementHistory` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AccountStatementHistory` edge in the connection. */
export type AccountStatementHistoriesEdge = {
  __typename?: 'AccountStatementHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AccountStatementHistory` at the end of the edge. */
  node: AccountStatementHistory;
};

/** Methods to use when ordering `AccountStatementHistory`. */
export enum AccountStatementHistoriesOrderBy {
  ACCOUNT_STATEMENT_ID_ASC = 'ACCOUNT_STATEMENT_ID_ASC',
  ACCOUNT_STATEMENT_ID_DESC = 'ACCOUNT_STATEMENT_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  NATURAL = 'NATURAL'
}

export type AccountStatementHistory = {
  __typename?: 'AccountStatementHistory';
  /** Reads a single `AccountStatement` that is related to this `AccountStatementHistory`. */
  accountStatement?: Maybe<AccountStatement>;
  accountStatementId: Scalars['Int'];
  /** The time this statement was created. */
  createdAt: Scalars['Datetime'];
  description: Scalars['String'];
};

/**
 * A condition to be used against `AccountStatementHistory` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type AccountStatementHistoryCondition = {
  /** Checks for equality with the object’s `accountStatementId` field. */
  accountStatementId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `AccountStatementHistory` object types. All fields are combined with a logical ‘and.’ */
export type AccountStatementHistoryFilter = {
  /** Filter by the object’s `accountStatementId` field. */
  accountStatementId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AccountStatementHistoryFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AccountStatementHistoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AccountStatementHistoryFilter>>;
};

/** An input for mutations affecting `AccountStatementHistory` */
export type AccountStatementHistoryInput = {
  /** Mutates a `AccountStatement` as part of the payload */
  accountStatement?: InputMaybe<AccountStatementInput>;
  accountStatementId?: InputMaybe<Scalars['Int']>;
  description: Scalars['String'];
};

/** An input for mutations affecting `AccountStatement` */
export type AccountStatementInput = {
  /** The currency code of the statement. */
  currencyCode: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  integration: UtilityIntegration;
  /** The identifier provided by the integration source */
  integrationKey?: InputMaybe<Scalars['String']>;
  /** The overall statement billing interval end */
  intervalEnd: Scalars['Date'];
  /** The overall statement billing interval start */
  intervalStart: Scalars['Date'];
  isValidated?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  /** The normalized month of the statement. */
  statementMonth: Scalars['Int'];
  /** The normalized year of the statement. */
  statementYear: Scalars['Int'];
  /** Mutates a `UtilityAccount` as part of the payload */
  utilityAccount?: InputMaybe<UtilityAccountInput>;
  utilityAccountId?: InputMaybe<Scalars['Int']>;
};

/** Represents an update to a `AccountStatement`. Fields that are set will be updated. */
export type AccountStatementPatch = {
  /** Overrides the currencyCode of the statement. */
  currencyCode?: InputMaybe<Scalars['String']>;
  isValidated?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  /** The normalized month of the statement. */
  statementMonth?: InputMaybe<Scalars['Int']>;
  /** The normalized year of the statement. */
  statementYear?: InputMaybe<Scalars['Int']>;
};

export type AccountStatementPdf = Node & {
  __typename?: 'AccountStatementPdf';
  /** Reads a single `AccountStatement` that is related to this `AccountStatementPdf`. */
  accountStatement?: Maybe<AccountStatement>;
  accountStatementId: Scalars['Int'];
  /** The time this record was created. */
  createdAt: Scalars['Datetime'];
  /** The time the record was deleted. */
  deletedAt?: Maybe<Scalars['Datetime']>;
  fileKey: Scalars['String'];
  id: Scalars['Int'];
  /** Reads and enables pagination through a set of `MeterStatement`. */
  meterStatements: MeterStatementsConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  path: Scalars['String'];
  /** The time this record was updated. */
  updatedAt: Scalars['Datetime'];
  uri: Scalars['String'];
};

export type AccountStatementPdfMeterStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MeterStatementCondition>;
  filter?: InputMaybe<MeterStatementFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MeterStatementsOrderBy>>;
};

/**
 * A condition to be used against `AccountStatementPdf` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type AccountStatementPdfCondition = {
  /** Checks for equality with the object’s `accountStatementId` field. */
  accountStatementId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `fileKey` field. */
  fileKey?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `path` field. */
  path?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `AccountStatementPdf` object types. All fields are combined with a logical ‘and.’ */
export type AccountStatementPdfFilter = {
  /** Filter by the object’s `accountStatementId` field. */
  accountStatementId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AccountStatementPdfFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `fileKey` field. */
  fileKey?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AccountStatementPdfFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AccountStatementPdfFilter>>;
  /** Filter by the object’s `path` field. */
  path?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `AccountStatementPdf` */
export type AccountStatementPdfInput = {
  /** Mutates a `AccountStatement` as part of the payload */
  accountStatement?: InputMaybe<AccountStatementInput>;
  accountStatementId?: InputMaybe<Scalars['Int']>;
  fileKey: Scalars['String'];
  path?: InputMaybe<Scalars['Upload']>;
};

/** A connection to a list of `AccountStatementPdf` values. */
export type AccountStatementPdfsConnection = {
  __typename?: 'AccountStatementPdfsConnection';
  /** A list of edges which contains the `AccountStatementPdf` and cursor to aid in pagination. */
  edges: Array<AccountStatementPdfsEdge>;
  /** A list of `AccountStatementPdf` objects. */
  nodes: Array<AccountStatementPdf>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AccountStatementPdf` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AccountStatementPdf` edge in the connection. */
export type AccountStatementPdfsEdge = {
  __typename?: 'AccountStatementPdfsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AccountStatementPdf` at the end of the edge. */
  node: AccountStatementPdf;
};

/** Methods to use when ordering `AccountStatementPdf`. */
export enum AccountStatementPdfsOrderBy {
  ACCOUNT_STATEMENT_ID_ASC = 'ACCOUNT_STATEMENT_ID_ASC',
  ACCOUNT_STATEMENT_ID_DESC = 'ACCOUNT_STATEMENT_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DELETED_AT_ASC = 'DELETED_AT_ASC',
  DELETED_AT_DESC = 'DELETED_AT_DESC',
  FILE_KEY_ASC = 'FILE_KEY_ASC',
  FILE_KEY_DESC = 'FILE_KEY_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PATH_ASC = 'PATH_ASC',
  PATH_DESC = 'PATH_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A connection to a list of `AccountStatement` values. */
export type AccountStatementsConnection = {
  __typename?: 'AccountStatementsConnection';
  /** A list of edges which contains the `AccountStatement` and cursor to aid in pagination. */
  edges: Array<AccountStatementsEdge>;
  /** A list of `AccountStatement` objects. */
  nodes: Array<AccountStatement>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AccountStatement` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AccountStatement` edge in the connection. */
export type AccountStatementsEdge = {
  __typename?: 'AccountStatementsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AccountStatement` at the end of the edge. */
  node: AccountStatement;
};

/** Methods to use when ordering `AccountStatement`. */
export enum AccountStatementsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CURRENCY_CODE_ASC = 'CURRENCY_CODE_ASC',
  CURRENCY_CODE_DESC = 'CURRENCY_CODE_DESC',
  DELETED_AT_ASC = 'DELETED_AT_ASC',
  DELETED_AT_DESC = 'DELETED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  INTEGRATION_ASC = 'INTEGRATION_ASC',
  INTEGRATION_DESC = 'INTEGRATION_DESC',
  INTEGRATION_KEY_ASC = 'INTEGRATION_KEY_ASC',
  INTEGRATION_KEY_DESC = 'INTEGRATION_KEY_DESC',
  INTERVAL_END_ASC = 'INTERVAL_END_ASC',
  INTERVAL_END_DESC = 'INTERVAL_END_DESC',
  INTERVAL_START_ASC = 'INTERVAL_START_ASC',
  INTERVAL_START_DESC = 'INTERVAL_START_DESC',
  IS_VALIDATED_ASC = 'IS_VALIDATED_ASC',
  IS_VALIDATED_DESC = 'IS_VALIDATED_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  NATURAL = 'NATURAL',
  NORMALIZED_CURRENCY_CODE_ASC = 'NORMALIZED_CURRENCY_CODE_ASC',
  NORMALIZED_CURRENCY_CODE_DESC = 'NORMALIZED_CURRENCY_CODE_DESC',
  OVERRIDE_AT_ASC = 'OVERRIDE_AT_ASC',
  OVERRIDE_AT_DESC = 'OVERRIDE_AT_DESC',
  OVERRIDE_CURRENCY_CODE_ASC = 'OVERRIDE_CURRENCY_CODE_ASC',
  OVERRIDE_CURRENCY_CODE_DESC = 'OVERRIDE_CURRENCY_CODE_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  STATEMENT_MONTH_ASC = 'STATEMENT_MONTH_ASC',
  STATEMENT_MONTH_DESC = 'STATEMENT_MONTH_DESC',
  STATEMENT_YEAR_ASC = 'STATEMENT_YEAR_ASC',
  STATEMENT_YEAR_DESC = 'STATEMENT_YEAR_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_COUNT_ASC = 'UTILITY_METER_STATEMENTS_COUNT_ASC',
  UTILITY_METER_STATEMENTS_COUNT_DESC = 'UTILITY_METER_STATEMENTS_COUNT_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_MAX_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_MAX_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_MAX_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_MAX_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_MAX_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_MAX_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_MAX_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_MAX_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_MAX_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_MAX_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_MAX_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_MAX_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_MAX_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_MAX_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_MAX_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_MAX_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_MAX_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_MAX_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_MAX_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_MAX_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_MAX_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_MAX_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_MAX_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_MAX_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_MAX_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_MAX_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_MAX_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_MAX_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_MAX_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_MAX_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_MAX_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_MAX_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_MAX_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_MAX_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_MAX_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_MAX_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_MAX_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_MAX_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_MAX_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_MAX_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_MAX_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_MAX_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_MAX_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_MAX_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_MAX_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_MAX_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_MAX_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_MAX_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_MAX_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_MAX_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_MAX_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_MAX_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_MAX_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_MAX_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_MAX_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_MAX_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_MAX_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_MAX_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_MAX_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_MIN_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_MIN_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_MIN_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_MIN_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_MIN_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_MIN_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_MIN_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_MIN_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_MIN_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_MIN_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_MIN_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_MIN_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_MIN_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_MIN_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_MIN_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_MIN_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_MIN_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_MIN_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_MIN_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_MIN_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_MIN_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_MIN_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_MIN_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_MIN_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_MIN_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_MIN_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_MIN_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_MIN_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_MIN_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_MIN_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_MIN_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_MIN_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_MIN_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_MIN_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_MIN_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_MIN_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_MIN_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_MIN_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_MIN_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_MIN_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_MIN_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_MIN_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_MIN_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_MIN_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_MIN_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_MIN_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_MIN_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_MIN_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_MIN_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_MIN_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_MIN_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_MIN_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_MIN_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_MIN_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_MIN_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_MIN_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_MIN_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_MIN_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_MIN_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_SUM_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_SUM_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_SUM_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_SUM_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_SUM_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_SUM_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_SUM_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_SUM_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_SUM_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_SUM_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_SUM_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_SUM_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_SUM_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_SUM_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_SUM_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_SUM_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_SUM_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_SUM_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_SUM_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_SUM_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_SUM_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_SUM_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_SUM_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_SUM_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_SUM_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_SUM_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_SUM_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_SUM_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_SUM_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_SUM_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_SUM_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_SUM_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_SUM_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_SUM_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_SUM_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_SUM_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_SUM_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_SUM_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_SUM_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_SUM_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_SUM_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_SUM_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_SUM_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_SUM_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_SUM_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_SUM_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_SUM_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_SUM_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_SUM_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_SUM_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_SUM_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_SUM_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_SUM_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_SUM_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_SUM_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_SUM_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_SUM_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_SUM_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_SUM_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_METER_ID_DESC'
}

export type AcknowledgeControlEventInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  controlEventId: Scalars['Int'];
};

export type AcknowledgeSuggestionInput = {
  acknowledge: Scalars['Boolean'];
  id: Scalars['Int'];
};

export enum Acknowledgement {
  ACKNOWLEDGED = 'ACKNOWLEDGED',
  REJECTED = 'REJECTED',
  UNACKNOWLEDGED = 'UNACKNOWLEDGED'
}

/** A filter to be used against Acknowledgement fields. All fields are combined with a logical ‘and.’ */
export type AcknowledgementFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Acknowledgement>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Acknowledgement>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Acknowledgement>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Acknowledgement>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Acknowledgement>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Acknowledgement>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Acknowledgement>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Acknowledgement>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Acknowledgement>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Acknowledgement>>;
};

/** Represents an accessor of the platform */
export type Actor = {
  __typename?: 'Actor';
  /** The display name of the actor. */
  displayName?: Maybe<Scalars['String']>;
  /** The ID of the actor. */
  id?: Maybe<Scalars['String']>;
  /** The associated machine user for the given actor. */
  machineUser?: Maybe<MachineUser>;
  type?: Maybe<AccessTokenType>;
  /** The associated user for the given actor. */
  user?: Maybe<User>;
};

/** A filter to be used against `Actor` object types. All fields are combined with a logical ‘and.’ */
export type ActorFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ActorFilter>>;
  /** Filter by the object’s `displayName` field. */
  displayName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ActorFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ActorFilter>>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<AccessTokenTypeFilter>;
};

/** An input for mutations affecting `Actor` */
export type ActorInput = {
  type?: InputMaybe<AccessTokenType>;
};

/** All input for the `addFavoriteFacility` mutation. */
export type AddFavoriteFacilityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  facilityId?: InputMaybe<Scalars['Int']>;
};

/** The output of our `addFavoriteFacility` mutation. */
export type AddFavoriteFacilityPayload = {
  __typename?: 'AddFavoriteFacilityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};

/** The output of our `addFavoriteFacility` mutation. */
export type AddFavoriteFacilityPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the `addMetricMetadataDependency` mutation. */
export type AddMetricMetadataDependencyInput = {
  childMetric: Scalars['String'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  parentMetric: Scalars['String'];
};

/** The output of our `addMetricMetadataDependency` mutation. */
export type AddMetricMetadataDependencyPayload = {
  __typename?: 'AddMetricMetadataDependencyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  metricMetadata?: Maybe<Array<MetricMetadatum>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type AddProjectControllerInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['Int'];
  userId: Scalars['String'];
};

export type AddProjectControllerPayload = {
  __typename?: 'AddProjectControllerPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  project: Project;
  user: User;
};

export type AddReportManagerInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  reportId: Scalars['Int'];
  userId: Scalars['String'];
};

export type AddReportManagerPayload = {
  __typename?: 'AddReportManagerPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  report: Report;
  user: User;
};

export type Asset = {
  nodeId: Scalars['ID'];
};

/** A connection to a list of `BalancingAuthority` values. */
export type BalancingAuthoritiesConnection = {
  __typename?: 'BalancingAuthoritiesConnection';
  /** A list of edges which contains the `BalancingAuthority` and cursor to aid in pagination. */
  edges: Array<BalancingAuthoritiesEdge>;
  /** The grid demand value for the associated balancing authority. */
  gridDemand?: Maybe<MetricDataConnection>;
  /** A list of `BalancingAuthority` objects. */
  nodes: Array<BalancingAuthority>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BalancingAuthority` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A connection to a list of `BalancingAuthority` values. */
export type BalancingAuthoritiesConnectionGridDemandArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A `BalancingAuthority` edge in the connection. */
export type BalancingAuthoritiesEdge = {
  __typename?: 'BalancingAuthoritiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `BalancingAuthority` at the end of the edge. */
  node: BalancingAuthority;
};

/** Methods to use when ordering `BalancingAuthority`. */
export enum BalancingAuthoritiesOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  GEOMETRY_ASC = 'GEOMETRY_ASC',
  GEOMETRY_DESC = 'GEOMETRY_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SLUG_ASC = 'SLUG_ASC',
  SLUG_DESC = 'SLUG_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** Represents a balancing authority associated with emissions rate data. */
export type BalancingAuthority = Node & {
  __typename?: 'BalancingAuthority';
  /** The time the program was created. */
  createdAt: Scalars['Datetime'];
  /** The facilities located in the region supported by the balancing authority. */
  facilitiesByArea: FacilitiesConnection;
  /** The geometry information of the balancing authority. */
  geometry?: Maybe<GeometryInterface>;
  /** The grid demand value for the associated balancing authority. */
  gridDemand?: Maybe<MetricDataConnection>;
  /** The identifer of the balancing authority. */
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `PricingNode`. */
  pricingNodes: PricingNodesConnection;
  /** The slug identifier of the balancing authority. */
  slug: Scalars['String'];
  /** The time the program was updated. */
  updatedAt: Scalars['Datetime'];
};

/** Represents a balancing authority associated with emissions rate data. */
export type BalancingAuthorityFacilitiesByAreaArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<FacilityFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** Represents a balancing authority associated with emissions rate data. */
export type BalancingAuthorityGridDemandArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** Represents a balancing authority associated with emissions rate data. */
export type BalancingAuthorityPricingNodesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PricingNodeCondition>;
  filter?: InputMaybe<PricingNodeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricingNodesOrderBy>>;
};

/**
 * A condition to be used against `BalancingAuthority` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BalancingAuthorityCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `geometry` field. */
  geometry?: InputMaybe<Scalars['GeoJSON']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `BalancingAuthority` object types. All fields are combined with a logical ‘and.’ */
export type BalancingAuthorityFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BalancingAuthorityFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BalancingAuthorityFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BalancingAuthorityFilter>>;
  /** Filter by the object’s `slug` field. */
  slug?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `BalancingAuthority` */
export type BalancingAuthorityInput = {
  /** The geometry information of the balancing authority. */
  geometry?: InputMaybe<Scalars['GeoJSON']>;
  name?: InputMaybe<Scalars['String']>;
  /** The slug identifier of the balancing authority. */
  slug: Scalars['String'];
};

/** Represents an update to a `BalancingAuthority`. Fields that are set will be updated. */
export type BalancingAuthorityPatch = {
  /** The geometry information of the balancing authority. */
  geometry?: InputMaybe<Scalars['GeoJSON']>;
  name?: InputMaybe<Scalars['String']>;
  /** The slug identifier of the balancing authority. */
  slug?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against BigFloat fields. All fields are combined with a logical ‘and.’ */
export type BigFloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigFloat']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigFloat']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigFloat']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigFloat']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigFloat']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigFloat']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigFloat']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigFloat']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigFloat']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigFloat']>>;
};

/** A filter to be used against BigInt fields. All fields are combined with a logical ‘and.’ */
export type BigIntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigInt']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigInt']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigInt']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigInt']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigInt']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigInt']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigInt']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigInt']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigInt']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigInt']>>;
};

/** A single or multiple blast locations. This could be a blast cell, a grouping of blast locations, or some other type of blast. */
export type Blast = Node & {
  __typename?: 'Blast';
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  actualUtilization?: Maybe<DataPoint>;
  /** The actual utilization metric */
  actualUtilizationId?: Maybe<Scalars['BigInt']>;
  /** The total capacity of the blast, which is set when warehouse data is unavailable */
  assumedPalletCapacity?: Maybe<Scalars['Int']>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  automationState?: Maybe<DataPoint>;
  /** An IOT datapoint indicating the current automation state, usually indicating if the facility has enabled automation (where available) */
  automationStateId?: Maybe<Scalars['BigInt']>;
  /** Reads and enables pagination through a set of `BlastEvaporator`. */
  blastEvaporators: BlastEvaporatorsConnection;
  /** Reads and enables pagination through a set of `BlastPallet`. */
  blastPallets: BlastPalletsConnection;
  /** Reads and enables pagination through a set of `BlastRotation`. */
  blastRotations: BlastRotationsConnection;
  /** Reads a single `BlastType` that is related to this `Blast`. */
  blastType?: Maybe<BlastType>;
  /** The type of blast */
  blastTypeId: Scalars['Int'];
  /** Reads a single `BuildingArea` that is related to this `Blast`. */
  buildingArea?: Maybe<BuildingArea>;
  /** The associated physical location within the facility */
  buildingAreaId?: Maybe<Scalars['Int']>;
  /** Reads a single `Component` that is related to this `Blast`. */
  component?: Maybe<Component>;
  /** The associated component for control purposes, if available */
  componentId?: Maybe<Scalars['Int']>;
  /** The time at which the record was created */
  createdAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `Evaporator`. */
  evaporators: EvaporatorsConnection;
  /** Reads a single `Facility` that is related to this `Blast`. */
  facility?: Maybe<Facility>;
  /** The facility a blast is within */
  facilityId: Scalars['Int'];
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int'];
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  idealUtilization?: Maybe<DataPoint>;
  /** The ideal utilization metric */
  idealUtilizationId?: Maybe<Scalars['BigInt']>;
  /** Indicator for noting if a blast is currently being used as a blast. In some cases, a blast can be used as a general storage location */
  isActive: Scalars['Boolean'];
  /** The unique local (facility-level) human-readable label of the blast */
  label: Scalars['String'];
  /** Metadata information for a blast */
  metadata: Scalars['JSON'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `PalletLocation`. */
  palletLocations: PalletLocationsConnection;
  /** Indicator for determining an automation-enabled blast */
  remoteEnabled: Scalars['Boolean'];
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  stagingTimer?: Maybe<DataPoint>;
  /** An IOT datapoint indicating the time-delay if a blast has had its start time delayed by the control system */
  stagingTimerId?: Maybe<Scalars['BigInt']>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  state?: Maybe<DataPoint>;
  /** An IOT datapoint indicating the state of the blast */
  stateId?: Maybe<Scalars['BigInt']>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  timer?: Maybe<DataPoint>;
  /** An IOT datapoint indicating the amount of time left with a blast refrigeration cycle (if the facility uses this method) */
  timerId?: Maybe<Scalars['BigInt']>;
  /** The time at which the record was updated */
  updatedAt: Scalars['Datetime'];
  /**
   * The date when warehouse data is
   * available for the facility, which will inform when pallet information can be automatically gathered
   */
  warehouseDataAvailabilityStartDate?: Maybe<Scalars['Date']>;
};

/** A single or multiple blast locations. This could be a blast cell, a grouping of blast locations, or some other type of blast. */
export type BlastBlastEvaporatorsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BlastEvaporatorCondition>;
  filter?: InputMaybe<BlastEvaporatorFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BlastEvaporatorsOrderBy>>;
};

/** A single or multiple blast locations. This could be a blast cell, a grouping of blast locations, or some other type of blast. */
export type BlastBlastPalletsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BlastPalletCondition>;
  filter?: InputMaybe<BlastPalletFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BlastPalletsOrderBy>>;
};

/** A single or multiple blast locations. This could be a blast cell, a grouping of blast locations, or some other type of blast. */
export type BlastBlastRotationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BlastRotationCondition>;
  filter?: InputMaybe<BlastRotationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BlastRotationsOrderBy>>;
};

/** A single or multiple blast locations. This could be a blast cell, a grouping of blast locations, or some other type of blast. */
export type BlastEvaporatorsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<EvaporatorFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** A single or multiple blast locations. This could be a blast cell, a grouping of blast locations, or some other type of blast. */
export type BlastPalletLocationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<PalletLocationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** A condition to be used against `Blast` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type BlastCondition = {
  /** Checks for equality with the object’s `actualUtilizationId` field. */
  actualUtilizationId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `assumedPalletCapacity` field. */
  assumedPalletCapacity?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `automationStateId` field. */
  automationStateId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `blastTypeId` field. */
  blastTypeId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `buildingAreaId` field. */
  buildingAreaId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `componentId` field. */
  componentId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `idealUtilizationId` field. */
  idealUtilizationId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `isActive` field. */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `remoteEnabled` field. */
  remoteEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `stagingTimerId` field. */
  stagingTimerId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `stateId` field. */
  stateId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `timerId` field. */
  timerId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A linker for indicating which evaporators are used for a blast location */
export type BlastEvaporator = Node & {
  __typename?: 'BlastEvaporator';
  /** Reads a single `Blast` that is related to this `BlastEvaporator`. */
  blast?: Maybe<Blast>;
  /** The associated blast */
  blastId?: Maybe<Scalars['Int']>;
  /** The time at which the record was created */
  createdAt: Scalars['Datetime'];
  /** Reads a single `Evaporator` that is related to this `BlastEvaporator`. */
  evaporator?: Maybe<Evaporator>;
  /** The associated evaporator */
  evaporatorId?: Maybe<Scalars['Int']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The time at which the record was updated */
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `BlastEvaporator` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BlastEvaporatorCondition = {
  /** Checks for equality with the object’s `blastId` field. */
  blastId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `evaporatorId` field. */
  evaporatorId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `BlastEvaporator` object types. All fields are combined with a logical ‘and.’ */
export type BlastEvaporatorFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BlastEvaporatorFilter>>;
  /** Filter by the object’s `blastId` field. */
  blastId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `evaporatorId` field. */
  evaporatorId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BlastEvaporatorFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BlastEvaporatorFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `BlastEvaporator` */
export type BlastEvaporatorInput = {
  /** Mutates a `Blast` as part of the payload */
  blast?: InputMaybe<BlastInput>;
  /** The associated blast */
  blastId?: InputMaybe<Scalars['Int']>;
  /** Mutates a `Evaporator` as part of the payload */
  evaporator?: InputMaybe<EvaporatorInput>;
  /** The associated evaporator */
  evaporatorId?: InputMaybe<Scalars['Int']>;
};

/** Represents an update to a `BlastEvaporator`. Fields that are set will be updated. */
export type BlastEvaporatorPatch = {
  /** The associated blast */
  blastId?: InputMaybe<Scalars['Int']>;
  /** The associated evaporator */
  evaporatorId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `BlastEvaporator` values. */
export type BlastEvaporatorsConnection = {
  __typename?: 'BlastEvaporatorsConnection';
  /** A list of edges which contains the `BlastEvaporator` and cursor to aid in pagination. */
  edges: Array<BlastEvaporatorsEdge>;
  /** A list of `BlastEvaporator` objects. */
  nodes: Array<BlastEvaporator>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BlastEvaporator` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `BlastEvaporator` edge in the connection. */
export type BlastEvaporatorsEdge = {
  __typename?: 'BlastEvaporatorsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `BlastEvaporator` at the end of the edge. */
  node: BlastEvaporator;
};

/** Methods to use when ordering `BlastEvaporator`. */
export enum BlastEvaporatorsOrderBy {
  BLAST_ID_ASC = 'BLAST_ID_ASC',
  BLAST_ID_DESC = 'BLAST_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  EVAPORATOR_ID_ASC = 'EVAPORATOR_ID_ASC',
  EVAPORATOR_ID_DESC = 'EVAPORATOR_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A filter to be used against `Blast` object types. All fields are combined with a logical ‘and.’ */
export type BlastFilter = {
  /** Filter by the object’s `actualUtilizationId` field. */
  actualUtilizationId?: InputMaybe<BigIntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BlastFilter>>;
  /** Filter by the object’s `assumedPalletCapacity` field. */
  assumedPalletCapacity?: InputMaybe<IntFilter>;
  /** Filter by the object’s `automationStateId` field. */
  automationStateId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `blastTypeId` field. */
  blastTypeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `buildingAreaId` field. */
  buildingAreaId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `componentId` field. */
  componentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `idealUtilizationId` field. */
  idealUtilizationId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `isActive` field. */
  isActive?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BlastFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BlastFilter>>;
  /** Filter by the object’s `remoteEnabled` field. */
  remoteEnabled?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `stagingTimerId` field. */
  stagingTimerId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `stateId` field. */
  stateId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `timerId` field. */
  timerId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `warehouseDataAvailabilityStartDate` field. */
  warehouseDataAvailabilityStartDate?: InputMaybe<DateFilter>;
};

/** An input for mutations affecting `Blast` */
export type BlastInput = {
  /** The actual utilization metric */
  actualUtilizationId?: InputMaybe<Scalars['BigInt']>;
  /** The total capacity of the blast, which is set when warehouse data is unavailable */
  assumedPalletCapacity?: InputMaybe<Scalars['Int']>;
  /** An IOT datapoint indicating the current automation state, usually indicating if the facility has enabled automation (where available) */
  automationStateId?: InputMaybe<Scalars['BigInt']>;
  /** Mutates a `BlastType` as part of the payload */
  blastType?: InputMaybe<BlastTypeInput>;
  /** The type of blast */
  blastTypeId?: InputMaybe<Scalars['Int']>;
  /** Mutates a `BuildingArea` as part of the payload */
  buildingArea?: InputMaybe<BuildingAreaInput>;
  /** The associated physical location within the facility */
  buildingAreaId?: InputMaybe<Scalars['Int']>;
  /** The associated component for control purposes, if available */
  componentId?: InputMaybe<Scalars['Int']>;
  /** Mutates a `DataPoint` as part of the payload */
  dataPoint?: InputMaybe<DataPointInput>;
  /** The facility a blast is within */
  facilityId: Scalars['Int'];
  /** The ideal utilization metric */
  idealUtilizationId?: InputMaybe<Scalars['BigInt']>;
  /** Indicator for noting if a blast is currently being used as a blast. In some cases, a blast can be used as a general storage location */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** The unique local (facility-level) human-readable label of the blast */
  label: Scalars['String'];
  /** Metadata information for a blast */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Indicator for determining an automation-enabled blast */
  remoteEnabled?: InputMaybe<Scalars['Boolean']>;
  /** An IOT datapoint indicating the time-delay if a blast has had its start time delayed by the control system */
  stagingTimerId?: InputMaybe<Scalars['BigInt']>;
  /** An IOT datapoint indicating the state of the blast */
  stateId?: InputMaybe<Scalars['BigInt']>;
  /** An IOT datapoint indicating the amount of time left with a blast refrigeration cycle (if the facility uses this method) */
  timerId?: InputMaybe<Scalars['BigInt']>;
};

/** Pallets that have entered a blast at some point in their pallet event history */
export type BlastPallet = Node & {
  __typename?: 'BlastPallet';
  /** Reads a single `Blast` that is related to this `BlastPallet`. */
  blast?: Maybe<Blast>;
  /** The associated blast (determined by the pallet locations registered in blastPalletLocations) */
  blastId: Scalars['Int'];
  /** The time at which the record was created */
  createdAt: Scalars['Datetime'];
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Pallet` that is related to this `BlastPallet`. */
  pallet?: Maybe<Pallet>;
  /** The time when a pallet was placed / dropped in the pallet location */
  palletDropTime?: Maybe<Scalars['Datetime']>;
  /** The associated pallet */
  palletId: Scalars['Int'];
  /** The time when a pallet was removed / picked from the pallet location */
  palletPickTime?: Maybe<Scalars['Datetime']>;
  /** The time at which the record was updated */
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `BlastPallet` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type BlastPalletCondition = {
  /** Checks for equality with the object’s `blastId` field. */
  blastId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `palletDropTime` field. */
  palletDropTime?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `palletId` field. */
  palletId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `palletPickTime` field. */
  palletPickTime?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `BlastPallet` object types. All fields are combined with a logical ‘and.’ */
export type BlastPalletFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BlastPalletFilter>>;
  /** Filter by the object’s `blastId` field. */
  blastId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BlastPalletFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BlastPalletFilter>>;
  /** Filter by the object’s `palletDropTime` field. */
  palletDropTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `palletId` field. */
  palletId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `palletPickTime` field. */
  palletPickTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `BlastPallet` */
export type BlastPalletInput = {
  /** Mutates a `Blast` as part of the payload */
  blast?: InputMaybe<BlastInput>;
  /** The associated blast (determined by the pallet locations registered in blastPalletLocations) */
  blastId?: InputMaybe<Scalars['Int']>;
  /** Mutates a `Pallet` as part of the payload */
  pallet?: InputMaybe<PalletInput>;
  /** The time when a pallet was placed / dropped in the pallet location */
  palletDropTime?: InputMaybe<Scalars['Datetime']>;
  /** The associated pallet */
  palletId?: InputMaybe<Scalars['Int']>;
  /** The time when a pallet was removed / picked from the pallet location */
  palletPickTime?: InputMaybe<Scalars['Datetime']>;
};

/** A list of all pallet locations contained within a physical blast location */
export type BlastPalletLocation = Node & {
  __typename?: 'BlastPalletLocation';
  /** Reads a single `Blast` that is related to this `BlastPalletLocation`. */
  blast?: Maybe<Blast>;
  /** The associated blast */
  blastId?: Maybe<Scalars['Int']>;
  /** The time at which the record was created */
  createdAt: Scalars['Datetime'];
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `PalletLocation` that is related to this `BlastPalletLocation`. */
  palletLocation?: Maybe<PalletLocation>;
  /** The associated pallet location within the same facility */
  palletLocationId?: Maybe<Scalars['Int']>;
  /** The time at which the record was updated */
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `BlastPalletLocation` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type BlastPalletLocationCondition = {
  /** Checks for equality with the object’s `blastId` field. */
  blastId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `palletLocationId` field. */
  palletLocationId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `BlastPalletLocation` object types. All fields are combined with a logical ‘and.’ */
export type BlastPalletLocationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BlastPalletLocationFilter>>;
  /** Filter by the object’s `blastId` field. */
  blastId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BlastPalletLocationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BlastPalletLocationFilter>>;
  /** Filter by the object’s `palletLocationId` field. */
  palletLocationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `BlastPalletLocation` */
export type BlastPalletLocationInput = {
  /** Mutates a `Blast` as part of the payload */
  blast?: InputMaybe<BlastInput>;
  /** The associated blast */
  blastId?: InputMaybe<Scalars['Int']>;
  /** Mutates a `PalletLocation` as part of the payload */
  palletLocation?: InputMaybe<PalletLocationInput>;
  /** The associated pallet location within the same facility */
  palletLocationId?: InputMaybe<Scalars['Int']>;
};

/** Represents an update to a `BlastPalletLocation`. Fields that are set will be updated. */
export type BlastPalletLocationPatch = {
  /** The associated blast */
  blastId?: InputMaybe<Scalars['Int']>;
  /** The associated pallet location within the same facility */
  palletLocationId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `BlastPalletLocation` values. */
export type BlastPalletLocationsConnection = {
  __typename?: 'BlastPalletLocationsConnection';
  /** A list of edges which contains the `BlastPalletLocation` and cursor to aid in pagination. */
  edges: Array<BlastPalletLocationsEdge>;
  /** A list of `BlastPalletLocation` objects. */
  nodes: Array<BlastPalletLocation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BlastPalletLocation` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `BlastPalletLocation` edge in the connection. */
export type BlastPalletLocationsEdge = {
  __typename?: 'BlastPalletLocationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `BlastPalletLocation` at the end of the edge. */
  node: BlastPalletLocation;
};

/** Methods to use when ordering `BlastPalletLocation`. */
export enum BlastPalletLocationsOrderBy {
  BLAST_ID_ASC = 'BLAST_ID_ASC',
  BLAST_ID_DESC = 'BLAST_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PALLET_LOCATION_ID_ASC = 'PALLET_LOCATION_ID_ASC',
  PALLET_LOCATION_ID_DESC = 'PALLET_LOCATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** Represents an update to a `BlastPallet`. Fields that are set will be updated. */
export type BlastPalletPatch = {
  /** The associated blast (determined by the pallet locations registered in blastPalletLocations) */
  blastId?: InputMaybe<Scalars['Int']>;
  /** The time when a pallet was placed / dropped in the pallet location */
  palletDropTime?: InputMaybe<Scalars['Datetime']>;
  /** The associated pallet */
  palletId?: InputMaybe<Scalars['Int']>;
  /** The time when a pallet was removed / picked from the pallet location */
  palletPickTime?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `BlastPallet` values. */
export type BlastPalletsConnection = {
  __typename?: 'BlastPalletsConnection';
  /** A list of edges which contains the `BlastPallet` and cursor to aid in pagination. */
  edges: Array<BlastPalletsEdge>;
  /** A list of `BlastPallet` objects. */
  nodes: Array<BlastPallet>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BlastPallet` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `BlastPallet` edge in the connection. */
export type BlastPalletsEdge = {
  __typename?: 'BlastPalletsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `BlastPallet` at the end of the edge. */
  node: BlastPallet;
};

/** Methods to use when ordering `BlastPallet`. */
export enum BlastPalletsOrderBy {
  BLAST_ID_ASC = 'BLAST_ID_ASC',
  BLAST_ID_DESC = 'BLAST_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PALLET_DROP_TIME_ASC = 'PALLET_DROP_TIME_ASC',
  PALLET_DROP_TIME_DESC = 'PALLET_DROP_TIME_DESC',
  PALLET_ID_ASC = 'PALLET_ID_ASC',
  PALLET_ID_DESC = 'PALLET_ID_DESC',
  PALLET_PICK_TIME_ASC = 'PALLET_PICK_TIME_ASC',
  PALLET_PICK_TIME_DESC = 'PALLET_PICK_TIME_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** Represents an update to a `Blast`. Fields that are set will be updated. */
export type BlastPatch = {
  /** The actual utilization metric */
  actualUtilizationId?: InputMaybe<Scalars['BigInt']>;
  /** The total capacity of the blast, which is set when warehouse data is unavailable */
  assumedPalletCapacity?: InputMaybe<Scalars['Int']>;
  /** An IOT datapoint indicating the current automation state, usually indicating if the facility has enabled automation (where available) */
  automationStateId?: InputMaybe<Scalars['BigInt']>;
  /** The type of blast */
  blastTypeId?: InputMaybe<Scalars['Int']>;
  /** The associated physical location within the facility */
  buildingAreaId?: InputMaybe<Scalars['Int']>;
  /** The associated component for control purposes, if available */
  componentId?: InputMaybe<Scalars['Int']>;
  /** The facility a blast is within */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** The ideal utilization metric */
  idealUtilizationId?: InputMaybe<Scalars['BigInt']>;
  /** Indicator for noting if a blast is currently being used as a blast. In some cases, a blast can be used as a general storage location */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** The unique local (facility-level) human-readable label of the blast */
  label?: InputMaybe<Scalars['String']>;
  /** Metadata information for a blast */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Indicator for determining an automation-enabled blast */
  remoteEnabled?: InputMaybe<Scalars['Boolean']>;
  /** An IOT datapoint indicating the time-delay if a blast has had its start time delayed by the control system */
  stagingTimerId?: InputMaybe<Scalars['BigInt']>;
  /** An IOT datapoint indicating the state of the blast */
  stateId?: InputMaybe<Scalars['BigInt']>;
  /** An IOT datapoint indicating the amount of time left with a blast refrigeration cycle (if the facility uses this method) */
  timerId?: InputMaybe<Scalars['BigInt']>;
};

/** A blast rotation, which encompasses the loading, running of refrigeration, and unloading of a blast */
export type BlastRotation = Node & {
  __typename?: 'BlastRotation';
  /** The total assumed pallets in the rotation, assuming warehouse data is unavailable for the rotation */
  assumedPalletCount?: Maybe<Scalars['Int']>;
  /** Reads a single `Blast` that is related to this `BlastRotation`. */
  blast?: Maybe<Blast>;
  /** The associated blast */
  blastId: Scalars['Int'];
  /** Reads and enables pagination through a set of `BlastRotationAlert`. */
  blastRotationAlerts: BlastRotationAlertsConnection;
  /** Reads and enables pagination through a set of `BlastRotationEventLog`. */
  blastRotationEventLogs: BlastRotationEventLogsConnection;
  /** The time at which the record was created */
  createdAt: Scalars['Datetime'];
  /** The current status of the blast rotation */
  currentStatus: Scalars['String'];
  defrosts: BlastRotationsDefrostsConnection;
  /** The estimated end time of the refrigeration portion of the rotation */
  estimatedRefrigerationEndTime?: Maybe<Scalars['Datetime']>;
  freezeEndTime?: Maybe<Scalars['Datetime']>;
  freezeStartTime?: Maybe<Scalars['Datetime']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int'];
  loadEndTime?: Maybe<Scalars['Datetime']>;
  loadStartTime?: Maybe<Scalars['Datetime']>;
  metadata: Scalars['JSON'];
  /** The methodology used to determine the metadata of the rotation, along with what pallets belong in the rotation */
  methodologyType?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The end time of a rotation */
  overallEndTime?: Maybe<Scalars['Datetime']>;
  /** The start time of a rotation */
  overallStartTime: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `Pallet`. */
  pallets: PalletsConnection;
  /** The planned amount of time the freezing cycle is expected to take (if applicable) */
  plannedFreezingHours?: Maybe<Scalars['Float']>;
  unloadEndTime?: Maybe<Scalars['Datetime']>;
  unloadStartTime?: Maybe<Scalars['Datetime']>;
  /** The time at which the record was updated */
  updatedAt: Scalars['Datetime'];
};

/** A blast rotation, which encompasses the loading, running of refrigeration, and unloading of a blast */
export type BlastRotationBlastRotationAlertsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BlastRotationAlertCondition>;
  filter?: InputMaybe<BlastRotationAlertFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BlastRotationAlertsOrderBy>>;
};

/** A blast rotation, which encompasses the loading, running of refrigeration, and unloading of a blast */
export type BlastRotationBlastRotationEventLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BlastRotationEventLogCondition>;
  filter?: InputMaybe<BlastRotationEventLogFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BlastRotationEventLogsOrderBy>>;
};

/** A blast rotation, which encompasses the loading, running of refrigeration, and unloading of a blast */
export type BlastRotationDefrostsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<BlastRotationsDefrostsRecordFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** A blast rotation, which encompasses the loading, running of refrigeration, and unloading of a blast */
export type BlastRotationPalletsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<PalletFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** An alert on a blast rotation to indicate an action to be taken in a blast rotation */
export type BlastRotationAlert = Node & {
  __typename?: 'BlastRotationAlert';
  /** The short, human-readable type of this alert */
  alertType: Scalars['String'];
  /** Reads a single `BlastRotation` that is related to this `BlastRotationAlert`. */
  blastRotation?: Maybe<BlastRotation>;
  /** The id of the blast rotation the alert is associated with */
  blastRotationId: Scalars['Int'];
  /** The time the rotation alert was created. */
  createdAt: Scalars['Datetime'];
  /** A short description describing the action to be taken */
  description: Scalars['String'];
  /** The time the alert was no longer valid */
  endTime?: Maybe<Scalars['Datetime']>;
  /** The identifer of the blast rotation alert */
  id: Scalars['Int'];
  /** Indication of whether or not this alert is still active */
  isActive: Scalars['Boolean'];
  /** The severity level of the alert */
  level: EnumBlastRotationAlertLevel;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The time the alert started */
  startTime: Scalars['Datetime'];
  /** The time the rotation alert was updated. */
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `BlastRotationAlert` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BlastRotationAlertCondition = {
  /** Checks for equality with the object’s `alertType` field. */
  alertType?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `blastRotationId` field. */
  blastRotationId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `endTime` field. */
  endTime?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `isActive` field. */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `level` field. */
  level?: InputMaybe<EnumBlastRotationAlertLevel>;
  /** Checks for equality with the object’s `startTime` field. */
  startTime?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `BlastRotationAlert` object types. All fields are combined with a logical ‘and.’ */
export type BlastRotationAlertFilter = {
  /** Filter by the object’s `alertType` field. */
  alertType?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BlastRotationAlertFilter>>;
  /** Filter by the object’s `blastRotationId` field. */
  blastRotationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `endTime` field. */
  endTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isActive` field. */
  isActive?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `level` field. */
  level?: InputMaybe<EnumBlastRotationAlertLevelFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BlastRotationAlertFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BlastRotationAlertFilter>>;
  /** Filter by the object’s `startTime` field. */
  startTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `BlastRotationAlert` */
export type BlastRotationAlertInput = {
  /** The short, human-readable type of this alert */
  alertType: Scalars['String'];
  /** Mutates a `BlastRotation` as part of the payload */
  blastRotation?: InputMaybe<BlastRotationInput>;
  /** The id of the blast rotation the alert is associated with */
  blastRotationId?: InputMaybe<Scalars['Int']>;
  /** A short description describing the action to be taken */
  description: Scalars['String'];
  /** The time the alert was no longer valid */
  endTime?: InputMaybe<Scalars['Datetime']>;
  /** Indication of whether or not this alert is still active */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** The severity level of the alert */
  level: EnumBlastRotationAlertLevel;
  /** The time the alert started */
  startTime: Scalars['Datetime'];
};

/** Represents an update to a `BlastRotationAlert`. Fields that are set will be updated. */
export type BlastRotationAlertPatch = {
  /** The short, human-readable type of this alert */
  alertType?: InputMaybe<Scalars['String']>;
  /** The id of the blast rotation the alert is associated with */
  blastRotationId?: InputMaybe<Scalars['Int']>;
  /** A short description describing the action to be taken */
  description?: InputMaybe<Scalars['String']>;
  /** The time the alert was no longer valid */
  endTime?: InputMaybe<Scalars['Datetime']>;
  /** Indication of whether or not this alert is still active */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** The severity level of the alert */
  level?: InputMaybe<EnumBlastRotationAlertLevel>;
  /** The time the alert started */
  startTime?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `BlastRotationAlert` values. */
export type BlastRotationAlertsConnection = {
  __typename?: 'BlastRotationAlertsConnection';
  /** A list of edges which contains the `BlastRotationAlert` and cursor to aid in pagination. */
  edges: Array<BlastRotationAlertsEdge>;
  /** A list of `BlastRotationAlert` objects. */
  nodes: Array<BlastRotationAlert>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BlastRotationAlert` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `BlastRotationAlert` edge in the connection. */
export type BlastRotationAlertsEdge = {
  __typename?: 'BlastRotationAlertsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `BlastRotationAlert` at the end of the edge. */
  node: BlastRotationAlert;
};

/** Methods to use when ordering `BlastRotationAlert`. */
export enum BlastRotationAlertsOrderBy {
  ALERT_TYPE_ASC = 'ALERT_TYPE_ASC',
  ALERT_TYPE_DESC = 'ALERT_TYPE_DESC',
  BLAST_ROTATION_ID_ASC = 'BLAST_ROTATION_ID_ASC',
  BLAST_ROTATION_ID_DESC = 'BLAST_ROTATION_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  END_TIME_ASC = 'END_TIME_ASC',
  END_TIME_DESC = 'END_TIME_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IS_ACTIVE_ASC = 'IS_ACTIVE_ASC',
  IS_ACTIVE_DESC = 'IS_ACTIVE_DESC',
  LEVEL_ASC = 'LEVEL_ASC',
  LEVEL_DESC = 'LEVEL_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  START_TIME_ASC = 'START_TIME_ASC',
  START_TIME_DESC = 'START_TIME_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/**
 * A condition to be used against `BlastRotation` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BlastRotationCondition = {
  /** Checks for equality with the object’s `assumedPalletCount` field. */
  assumedPalletCount?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `blastId` field. */
  blastId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `currentStatus` field. */
  currentStatus?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `estimatedRefrigerationEndTime` field. */
  estimatedRefrigerationEndTime?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `methodologyType` field. */
  methodologyType?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `overallEndTime` field. */
  overallEndTime?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `overallStartTime` field. */
  overallStartTime?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `plannedFreezingHours` field. */
  plannedFreezingHours?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A log of events that occur during a blast rotation */
export type BlastRotationEventLog = Node & {
  __typename?: 'BlastRotationEventLog';
  /** Reads a single `BlastRotation` that is related to this `BlastRotationEventLog`. */
  blastRotation?: Maybe<BlastRotation>;
  /** Reads a single `BlastRotationEventType` that is related to this `BlastRotationEventLog`. */
  blastRotationEventType?: Maybe<BlastRotationEventType>;
  /** The type of event for this record */
  blastRotationEventTypeId: Scalars['String'];
  /** The associated blast rotation */
  blastRotationId: Scalars['Int'];
  /** The time at which the record was created */
  createdAt: Scalars['Datetime'];
  /** A short description of the event */
  description: Scalars['String'];
  /** The time of the event */
  eventTime: Scalars['Datetime'];
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int'];
  /** Additional, arbitrary information about the event */
  metadata?: Maybe<Scalars['JSON']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The time at which the record was updated */
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `BlastRotationEventLog` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type BlastRotationEventLogCondition = {
  /** Checks for equality with the object’s `blastRotationEventTypeId` field. */
  blastRotationEventTypeId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `blastRotationId` field. */
  blastRotationId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `eventTime` field. */
  eventTime?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `BlastRotationEventLog` object types. All fields are combined with a logical ‘and.’ */
export type BlastRotationEventLogFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BlastRotationEventLogFilter>>;
  /** Filter by the object’s `blastRotationEventTypeId` field. */
  blastRotationEventTypeId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `blastRotationId` field. */
  blastRotationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `eventTime` field. */
  eventTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BlastRotationEventLogFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BlastRotationEventLogFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `BlastRotationEventLog` */
export type BlastRotationEventLogInput = {
  /** Mutates a `BlastRotation` as part of the payload */
  blastRotation?: InputMaybe<BlastRotationInput>;
  /** Mutates a `BlastRotationEventType` as part of the payload */
  blastRotationEventType?: InputMaybe<BlastRotationEventTypeInput>;
  /** The type of event for this record */
  blastRotationEventTypeId?: InputMaybe<Scalars['String']>;
  /** The associated blast rotation */
  blastRotationId?: InputMaybe<Scalars['Int']>;
  /** A short description of the event */
  description: Scalars['String'];
  /** The time of the event */
  eventTime: Scalars['Datetime'];
  /** Additional, arbitrary information about the event */
  metadata?: InputMaybe<Scalars['JSON']>;
};

/** Represents an update to a `BlastRotationEventLog`. Fields that are set will be updated. */
export type BlastRotationEventLogPatch = {
  /** The type of event for this record */
  blastRotationEventTypeId?: InputMaybe<Scalars['String']>;
  /** The associated blast rotation */
  blastRotationId?: InputMaybe<Scalars['Int']>;
  /** A short description of the event */
  description?: InputMaybe<Scalars['String']>;
  /** The time of the event */
  eventTime?: InputMaybe<Scalars['Datetime']>;
  /** Additional, arbitrary information about the event */
  metadata?: InputMaybe<Scalars['JSON']>;
};

/** A connection to a list of `BlastRotationEventLog` values. */
export type BlastRotationEventLogsConnection = {
  __typename?: 'BlastRotationEventLogsConnection';
  /** A list of edges which contains the `BlastRotationEventLog` and cursor to aid in pagination. */
  edges: Array<BlastRotationEventLogsEdge>;
  /** A list of `BlastRotationEventLog` objects. */
  nodes: Array<BlastRotationEventLog>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BlastRotationEventLog` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `BlastRotationEventLog` edge in the connection. */
export type BlastRotationEventLogsEdge = {
  __typename?: 'BlastRotationEventLogsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `BlastRotationEventLog` at the end of the edge. */
  node: BlastRotationEventLog;
};

/** Methods to use when ordering `BlastRotationEventLog`. */
export enum BlastRotationEventLogsOrderBy {
  BLAST_ROTATION_EVENT_TYPE_ID_ASC = 'BLAST_ROTATION_EVENT_TYPE_ID_ASC',
  BLAST_ROTATION_EVENT_TYPE_ID_DESC = 'BLAST_ROTATION_EVENT_TYPE_ID_DESC',
  BLAST_ROTATION_ID_ASC = 'BLAST_ROTATION_ID_ASC',
  BLAST_ROTATION_ID_DESC = 'BLAST_ROTATION_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  EVENT_TIME_ASC = 'EVENT_TIME_ASC',
  EVENT_TIME_DESC = 'EVENT_TIME_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A type of event that occurs within a blast rotation */
export type BlastRotationEventType = Node & {
  __typename?: 'BlastRotationEventType';
  /** Reads and enables pagination through a set of `BlastRotationEventLog`. */
  blastRotationEventLogs: BlastRotationEventLogsConnection;
  /** The time at which the record was created */
  createdAt: Scalars['Datetime'];
  /** A unique, readable type of event that can occur within a blast rotation */
  eventType: Scalars['String'];
  /** A UI-friendly label for the type of event */
  label: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The time at which the record was updated */
  updatedAt: Scalars['Datetime'];
};

/** A type of event that occurs within a blast rotation */
export type BlastRotationEventTypeBlastRotationEventLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BlastRotationEventLogCondition>;
  filter?: InputMaybe<BlastRotationEventLogFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BlastRotationEventLogsOrderBy>>;
};

/**
 * A condition to be used against `BlastRotationEventType` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type BlastRotationEventTypeCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `eventType` field. */
  eventType?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `BlastRotationEventType` object types. All fields are combined with a logical ‘and.’ */
export type BlastRotationEventTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BlastRotationEventTypeFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `eventType` field. */
  eventType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BlastRotationEventTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BlastRotationEventTypeFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `BlastRotationEventType` */
export type BlastRotationEventTypeInput = {
  /** A unique, readable type of event that can occur within a blast rotation */
  eventType: Scalars['String'];
  /** A UI-friendly label for the type of event */
  label: Scalars['String'];
};

/** Represents an update to a `BlastRotationEventType`. Fields that are set will be updated. */
export type BlastRotationEventTypePatch = {
  /** A unique, readable type of event that can occur within a blast rotation */
  eventType?: InputMaybe<Scalars['String']>;
  /** A UI-friendly label for the type of event */
  label?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `BlastRotationEventType` values. */
export type BlastRotationEventTypesConnection = {
  __typename?: 'BlastRotationEventTypesConnection';
  /** A list of edges which contains the `BlastRotationEventType` and cursor to aid in pagination. */
  edges: Array<BlastRotationEventTypesEdge>;
  /** A list of `BlastRotationEventType` objects. */
  nodes: Array<BlastRotationEventType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BlastRotationEventType` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `BlastRotationEventType` edge in the connection. */
export type BlastRotationEventTypesEdge = {
  __typename?: 'BlastRotationEventTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `BlastRotationEventType` at the end of the edge. */
  node: BlastRotationEventType;
};

/** Methods to use when ordering `BlastRotationEventType`. */
export enum BlastRotationEventTypesOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  EVENT_TYPE_ASC = 'EVENT_TYPE_ASC',
  EVENT_TYPE_DESC = 'EVENT_TYPE_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A filter to be used against `BlastRotation` object types. All fields are combined with a logical ‘and.’ */
export type BlastRotationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BlastRotationFilter>>;
  /** Filter by the object’s `assumedPalletCount` field. */
  assumedPalletCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `blastId` field. */
  blastId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `currentStatus` field. */
  currentStatus?: InputMaybe<StringFilter>;
  /** Filter by the object’s `estimatedRefrigerationEndTime` field. */
  estimatedRefrigerationEndTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `freezeEndTime` field. */
  freezeEndTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `freezeStartTime` field. */
  freezeStartTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `loadEndTime` field. */
  loadEndTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `loadStartTime` field. */
  loadStartTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `methodologyType` field. */
  methodologyType?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BlastRotationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BlastRotationFilter>>;
  /** Filter by the object’s `overallEndTime` field. */
  overallEndTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `overallStartTime` field. */
  overallStartTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `plannedFreezingHours` field. */
  plannedFreezingHours?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `unloadEndTime` field. */
  unloadEndTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `unloadStartTime` field. */
  unloadStartTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `BlastRotation` */
export type BlastRotationInput = {
  /** The total assumed pallets in the rotation, assuming warehouse data is unavailable for the rotation */
  assumedPalletCount?: InputMaybe<Scalars['Int']>;
  /** Mutates a `Blast` as part of the payload */
  blast?: InputMaybe<BlastInput>;
  /** The associated blast */
  blastId?: InputMaybe<Scalars['Int']>;
  /** The current status of the blast rotation */
  currentStatus?: InputMaybe<Scalars['String']>;
  /** The estimated end time of the refrigeration portion of the rotation */
  estimatedRefrigerationEndTime?: InputMaybe<Scalars['Datetime']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  /** The methodology used to determine the metadata of the rotation, along with what pallets belong in the rotation */
  methodologyType?: InputMaybe<Scalars['String']>;
  /** The end time of a rotation */
  overallEndTime?: InputMaybe<Scalars['Datetime']>;
  /** The start time of a rotation */
  overallStartTime: Scalars['Datetime'];
  /** The planned amount of time the freezing cycle is expected to take (if applicable) */
  plannedFreezingHours?: InputMaybe<Scalars['Float']>;
};

/** A linker for indicating which pallets were present in a blast rotation */
export type BlastRotationPallet = Node & {
  __typename?: 'BlastRotationPallet';
  /** Reads a single `BlastRotation` that is related to this `BlastRotationPallet`. */
  blastRotation?: Maybe<BlastRotation>;
  /** The associated blast rotation */
  blastRotationId: Scalars['Int'];
  /** The time at which the record was created */
  createdAt: Scalars['Datetime'];
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Pallet` that is related to this `BlastRotationPallet`. */
  pallet?: Maybe<Pallet>;
  /** The associated pallet */
  palletId: Scalars['Int'];
  /** The time at which the record was updated */
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `BlastRotationPallet` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type BlastRotationPalletCondition = {
  /** Checks for equality with the object’s `blastRotationId` field. */
  blastRotationId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `palletId` field. */
  palletId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `BlastRotationPallet` object types. All fields are combined with a logical ‘and.’ */
export type BlastRotationPalletFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BlastRotationPalletFilter>>;
  /** Filter by the object’s `blastRotationId` field. */
  blastRotationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BlastRotationPalletFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BlastRotationPalletFilter>>;
  /** Filter by the object’s `palletId` field. */
  palletId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `BlastRotationPallet` */
export type BlastRotationPalletInput = {
  /** Mutates a `BlastRotation` as part of the payload */
  blastRotation?: InputMaybe<BlastRotationInput>;
  /** The associated blast rotation */
  blastRotationId?: InputMaybe<Scalars['Int']>;
  /** Mutates a `Pallet` as part of the payload */
  pallet?: InputMaybe<PalletInput>;
  /** The associated pallet */
  palletId?: InputMaybe<Scalars['Int']>;
};

/** Represents an update to a `BlastRotationPallet`. Fields that are set will be updated. */
export type BlastRotationPalletPatch = {
  /** The associated blast rotation */
  blastRotationId?: InputMaybe<Scalars['Int']>;
  /** The associated pallet */
  palletId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `BlastRotationPallet` values. */
export type BlastRotationPalletsConnection = {
  __typename?: 'BlastRotationPalletsConnection';
  /** A list of edges which contains the `BlastRotationPallet` and cursor to aid in pagination. */
  edges: Array<BlastRotationPalletsEdge>;
  /** A list of `BlastRotationPallet` objects. */
  nodes: Array<BlastRotationPallet>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BlastRotationPallet` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `BlastRotationPallet` edge in the connection. */
export type BlastRotationPalletsEdge = {
  __typename?: 'BlastRotationPalletsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `BlastRotationPallet` at the end of the edge. */
  node: BlastRotationPallet;
};

/** Methods to use when ordering `BlastRotationPallet`. */
export enum BlastRotationPalletsOrderBy {
  BLAST_ROTATION_ID_ASC = 'BLAST_ROTATION_ID_ASC',
  BLAST_ROTATION_ID_DESC = 'BLAST_ROTATION_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PALLET_ID_ASC = 'PALLET_ID_ASC',
  PALLET_ID_DESC = 'PALLET_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** Represents an update to a `BlastRotation`. Fields that are set will be updated. */
export type BlastRotationPatch = {
  /** The total assumed pallets in the rotation, assuming warehouse data is unavailable for the rotation */
  assumedPalletCount?: InputMaybe<Scalars['Int']>;
  /** The associated blast */
  blastId?: InputMaybe<Scalars['Int']>;
  /** The current status of the blast rotation */
  currentStatus?: InputMaybe<Scalars['String']>;
  /** The estimated end time of the refrigeration portion of the rotation */
  estimatedRefrigerationEndTime?: InputMaybe<Scalars['Datetime']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  /** The methodology used to determine the metadata of the rotation, along with what pallets belong in the rotation */
  methodologyType?: InputMaybe<Scalars['String']>;
  /** The end time of a rotation */
  overallEndTime?: InputMaybe<Scalars['Datetime']>;
  /** The start time of a rotation */
  overallStartTime?: InputMaybe<Scalars['Datetime']>;
  /** The planned amount of time the freezing cycle is expected to take (if applicable) */
  plannedFreezingHours?: InputMaybe<Scalars['Float']>;
};

/** A connection to a list of `BlastRotation` values. */
export type BlastRotationsConnection = {
  __typename?: 'BlastRotationsConnection';
  /** A list of edges which contains the `BlastRotation` and cursor to aid in pagination. */
  edges: Array<BlastRotationsEdge>;
  /** A list of `BlastRotation` objects. */
  nodes: Array<BlastRotation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BlastRotation` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `BlastRotationsDefrostsRecord` edge in the connection. */
export type BlastRotationsDefrostEdge = {
  __typename?: 'BlastRotationsDefrostEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `BlastRotationsDefrostsRecord` at the end of the edge. */
  node: BlastRotationsDefrostsRecord;
};

/** A connection to a list of `BlastRotationsDefrostsRecord` values. */
export type BlastRotationsDefrostsConnection = {
  __typename?: 'BlastRotationsDefrostsConnection';
  /** A list of edges which contains the `BlastRotationsDefrostsRecord` and cursor to aid in pagination. */
  edges: Array<BlastRotationsDefrostEdge>;
  /** A list of `BlastRotationsDefrostsRecord` objects. */
  nodes: Array<BlastRotationsDefrostsRecord>;
  /** The count of *all* `BlastRotationsDefrostsRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** The return type of our `defrosts` query. */
export type BlastRotationsDefrostsRecord = {
  __typename?: 'BlastRotationsDefrostsRecord';
  endTime?: Maybe<Scalars['Datetime']>;
  startTime?: Maybe<Scalars['Datetime']>;
  totalMinutes?: Maybe<Scalars['Int']>;
};

/** A filter to be used against `BlastRotationsDefrostsRecord` object types. All fields are combined with a logical ‘and.’ */
export type BlastRotationsDefrostsRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BlastRotationsDefrostsRecordFilter>>;
  /** Filter by the object’s `endTime` field. */
  endTime?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BlastRotationsDefrostsRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BlastRotationsDefrostsRecordFilter>>;
  /** Filter by the object’s `startTime` field. */
  startTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `totalMinutes` field. */
  totalMinutes?: InputMaybe<IntFilter>;
};

/** A `BlastRotation` edge in the connection. */
export type BlastRotationsEdge = {
  __typename?: 'BlastRotationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `BlastRotation` at the end of the edge. */
  node: BlastRotation;
};

/** Methods to use when ordering `BlastRotation`. */
export enum BlastRotationsOrderBy {
  ASSUMED_PALLET_COUNT_ASC = 'ASSUMED_PALLET_COUNT_ASC',
  ASSUMED_PALLET_COUNT_DESC = 'ASSUMED_PALLET_COUNT_DESC',
  BLAST_ID_ASC = 'BLAST_ID_ASC',
  BLAST_ID_DESC = 'BLAST_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CURRENT_STATUS_ASC = 'CURRENT_STATUS_ASC',
  CURRENT_STATUS_DESC = 'CURRENT_STATUS_DESC',
  ESTIMATED_REFRIGERATION_END_TIME_ASC = 'ESTIMATED_REFRIGERATION_END_TIME_ASC',
  ESTIMATED_REFRIGERATION_END_TIME_DESC = 'ESTIMATED_REFRIGERATION_END_TIME_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  METHODOLOGY_TYPE_ASC = 'METHODOLOGY_TYPE_ASC',
  METHODOLOGY_TYPE_DESC = 'METHODOLOGY_TYPE_DESC',
  NATURAL = 'NATURAL',
  OVERALL_END_TIME_ASC = 'OVERALL_END_TIME_ASC',
  OVERALL_END_TIME_DESC = 'OVERALL_END_TIME_DESC',
  OVERALL_START_TIME_ASC = 'OVERALL_START_TIME_ASC',
  OVERALL_START_TIME_DESC = 'OVERALL_START_TIME_DESC',
  PLANNED_FREEZING_HOURS_ASC = 'PLANNED_FREEZING_HOURS_ASC',
  PLANNED_FREEZING_HOURS_DESC = 'PLANNED_FREEZING_HOURS_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A type or category of a blast to indicate a different operating environment across facilities */
export type BlastType = Node & {
  __typename?: 'BlastType';
  /** Reads and enables pagination through a set of `Blast`. */
  blasts: BlastsConnection;
  /** The time at which the record was created */
  createdAt: Scalars['Datetime'];
  /** A brief description of this blast type or category */
  description: Scalars['String'];
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int'];
  /** A human-readable label for the type or category */
  label: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The time at which the record was updated */
  updatedAt: Scalars['Datetime'];
};

/** A type or category of a blast to indicate a different operating environment across facilities */
export type BlastTypeBlastsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BlastCondition>;
  filter?: InputMaybe<BlastFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BlastsOrderBy>>;
};

/**
 * A condition to be used against `BlastType` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type BlastTypeCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `BlastType` object types. All fields are combined with a logical ‘and.’ */
export type BlastTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BlastTypeFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BlastTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BlastTypeFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `BlastType` */
export type BlastTypeInput = {
  /** A brief description of this blast type or category */
  description: Scalars['String'];
  /** A human-readable label for the type or category */
  label: Scalars['String'];
};

/** Represents an update to a `BlastType`. Fields that are set will be updated. */
export type BlastTypePatch = {
  /** A brief description of this blast type or category */
  description?: InputMaybe<Scalars['String']>;
  /** A human-readable label for the type or category */
  label?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `BlastType` values. */
export type BlastTypesConnection = {
  __typename?: 'BlastTypesConnection';
  /** A list of edges which contains the `BlastType` and cursor to aid in pagination. */
  edges: Array<BlastTypesEdge>;
  /** A list of `BlastType` objects. */
  nodes: Array<BlastType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BlastType` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `BlastType` edge in the connection. */
export type BlastTypesEdge = {
  __typename?: 'BlastTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `BlastType` at the end of the edge. */
  node: BlastType;
};

/** Methods to use when ordering `BlastType`. */
export enum BlastTypesOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A connection to a list of `Blast` values. */
export type BlastsConnection = {
  __typename?: 'BlastsConnection';
  /** Returns the aggregate actualUtilization timeseries data for the BlastsConnection  */
  actualUtilization?: Maybe<MetricDataConnection>;
  /** Returns the aggregate automationState timeseries data for the BlastsConnection  */
  automationState?: Maybe<MetricDataConnection>;
  /** A list of edges which contains the `Blast` and cursor to aid in pagination. */
  edges: Array<BlastsEdge>;
  /** Returns the aggregate idealUtilization timeseries data for the BlastsConnection  */
  idealUtilization?: Maybe<MetricDataConnection>;
  /** A list of `Blast` objects. */
  nodes: Array<Blast>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Returns the aggregate stagingTimer timeseries data for the BlastsConnection  */
  stagingTimer?: Maybe<MetricDataConnection>;
  /** Returns the aggregate state timeseries data for the BlastsConnection  */
  state?: Maybe<MetricDataConnection>;
  /** Returns the aggregate timer timeseries data for the BlastsConnection  */
  timer?: Maybe<MetricDataConnection>;
  /** The count of *all* `Blast` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A connection to a list of `Blast` values. */
export type BlastsConnectionActualUtilizationArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Blast` values. */
export type BlastsConnectionAutomationStateArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Blast` values. */
export type BlastsConnectionIdealUtilizationArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Blast` values. */
export type BlastsConnectionStagingTimerArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Blast` values. */
export type BlastsConnectionStateArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Blast` values. */
export type BlastsConnectionTimerArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A `Blast` edge in the connection. */
export type BlastsEdge = {
  __typename?: 'BlastsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Blast` at the end of the edge. */
  node: Blast;
};

/** Methods to use when ordering `Blast`. */
export enum BlastsOrderBy {
  ACTUAL_UTILIZATION_ID_ASC = 'ACTUAL_UTILIZATION_ID_ASC',
  ACTUAL_UTILIZATION_ID_DESC = 'ACTUAL_UTILIZATION_ID_DESC',
  ASSUMED_PALLET_CAPACITY_ASC = 'ASSUMED_PALLET_CAPACITY_ASC',
  ASSUMED_PALLET_CAPACITY_DESC = 'ASSUMED_PALLET_CAPACITY_DESC',
  AUTOMATION_STATE_ID_ASC = 'AUTOMATION_STATE_ID_ASC',
  AUTOMATION_STATE_ID_DESC = 'AUTOMATION_STATE_ID_DESC',
  BLAST_TYPE_ID_ASC = 'BLAST_TYPE_ID_ASC',
  BLAST_TYPE_ID_DESC = 'BLAST_TYPE_ID_DESC',
  BUILDING_AREA_ID_ASC = 'BUILDING_AREA_ID_ASC',
  BUILDING_AREA_ID_DESC = 'BUILDING_AREA_ID_DESC',
  COMPONENT_ID_ASC = 'COMPONENT_ID_ASC',
  COMPONENT_ID_DESC = 'COMPONENT_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  IDEAL_UTILIZATION_ID_ASC = 'IDEAL_UTILIZATION_ID_ASC',
  IDEAL_UTILIZATION_ID_DESC = 'IDEAL_UTILIZATION_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IS_ACTIVE_ASC = 'IS_ACTIVE_ASC',
  IS_ACTIVE_DESC = 'IS_ACTIVE_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  REMOTE_ENABLED_ASC = 'REMOTE_ENABLED_ASC',
  REMOTE_ENABLED_DESC = 'REMOTE_ENABLED_DESC',
  STAGING_TIMER_ID_ASC = 'STAGING_TIMER_ID_ASC',
  STAGING_TIMER_ID_DESC = 'STAGING_TIMER_ID_DESC',
  STATE_ID_ASC = 'STATE_ID_ASC',
  STATE_ID_DESC = 'STATE_ID_DESC',
  TIMER_ID_ASC = 'TIMER_ID_ASC',
  TIMER_ID_DESC = 'TIMER_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A filter to be used against Boolean fields. All fields are combined with a logical ‘and.’ */
export type BooleanFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Boolean']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Boolean']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Boolean']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Boolean']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Boolean']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Boolean']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Boolean']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Boolean']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Boolean']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Boolean']>>;
};

/** This represents a physical building area or room that exists in a facility. */
export type BuildingArea = Node & {
  __typename?: 'BuildingArea';
  /** Reads and enables pagination through a set of `Blast`. */
  blasts: BlastsConnection;
  /** Reads and enables pagination through a set of `BuildingAreaComplianceGroup`. */
  buildingAreaComplianceGroups: BuildingAreaComplianceGroupsConnection;
  /** Reads a single `BuildingAreaType` that is related to this `BuildingArea`. */
  buildingAreaType?: Maybe<BuildingAreaType>;
  /** This associates the building area with a building area type. */
  buildingAreaTypeId: Scalars['String'];
  /** Reads and enables pagination through a set of `ComplianceGroup`. */
  complianceGroups: ComplianceGroupsConnection;
  /** Reads and enables pagination through a set of `Compressor`. */
  compressor: CompressorsConnection;
  /** The time the building area was created. */
  createdAt: Scalars['Datetime'];
  /** Long-form description of the building area. */
  description?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `Evaporator`. */
  evaporators: EvaporatorsConnection;
  /** Reads a single `Facility` that is related to this `BuildingArea`. */
  facility?: Maybe<Facility>;
  /** This represents the facility that the building area belongs to. */
  facilityId: Scalars['Int'];
  /** The GIS geometry which specifies how the building area should be displayed on a map. */
  geometry?: Maybe<GeometryInterface>;
  id: Scalars['Int'];
  /** Human-readable label for the building area. */
  label: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `PalletLocation`. */
  palletLocations: PalletLocationsConnection;
  /** Reads and enables pagination through a set of `BuildingAreaPalletHistory`. */
  pallets: BuildingAreaPalletHistoriesConnection;
  /** Reads and enables pagination through a set of `TemperatureSensor`. */
  temperatureSensors: TemperatureSensorsConnection;
  /** The time the building area was updated. */
  updatedAt: Scalars['Datetime'];
};

/** This represents a physical building area or room that exists in a facility. */
export type BuildingAreaBlastsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BlastCondition>;
  filter?: InputMaybe<BlastFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BlastsOrderBy>>;
};

/** This represents a physical building area or room that exists in a facility. */
export type BuildingAreaBuildingAreaComplianceGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BuildingAreaComplianceGroupCondition>;
  filter?: InputMaybe<BuildingAreaComplianceGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BuildingAreaComplianceGroupsOrderBy>>;
};

/** This represents a physical building area or room that exists in a facility. */
export type BuildingAreaComplianceGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<ComplianceGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** This represents a physical building area or room that exists in a facility. */
export type BuildingAreaCompressorArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompressorCondition>;
  filter?: InputMaybe<CompressorFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompressorsOrderBy>>;
};

/** This represents a physical building area or room that exists in a facility. */
export type BuildingAreaEvaporatorsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EvaporatorCondition>;
  filter?: InputMaybe<EvaporatorFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EvaporatorsOrderBy>>;
};

/** This represents a physical building area or room that exists in a facility. */
export type BuildingAreaPalletLocationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PalletLocationCondition>;
  filter?: InputMaybe<PalletLocationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PalletLocationsOrderBy>>;
};

/** This represents a physical building area or room that exists in a facility. */
export type BuildingAreaPalletsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  endTime: Scalars['Datetime'];
  filter?: InputMaybe<BuildingAreaPalletHistoryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  startTime: Scalars['Datetime'];
};

/** This represents a physical building area or room that exists in a facility. */
export type BuildingAreaTemperatureSensorsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<TemperatureSensorFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** A building areas compliance groups */
export type BuildingAreaComplianceGroup = Node & {
  __typename?: 'BuildingAreaComplianceGroup';
  /** Reads a single `BuildingArea` that is related to this `BuildingAreaComplianceGroup`. */
  buildingArea?: Maybe<BuildingArea>;
  /** The building area the compliance group applies to */
  buildingAreaId: Scalars['Int'];
  /** Reads a single `ComplianceGroup` that is related to this `BuildingAreaComplianceGroup`. */
  complianceGroup?: Maybe<ComplianceGroup>;
  /** The associated compliance group */
  complianceGroupId: Scalars['Int'];
  /** The type of compliance group for this relationship */
  complianceType: ComplianceType;
  /** The time at which the Building Area Compliance Range was created */
  createdAt: Scalars['Datetime'];
  /** The id of the building area compliance group */
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The time at which the Building Area Compliance Range was updated */
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `BuildingAreaComplianceGroup` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type BuildingAreaComplianceGroupCondition = {
  /** Checks for equality with the object’s `buildingAreaId` field. */
  buildingAreaId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `complianceGroupId` field. */
  complianceGroupId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `complianceType` field. */
  complianceType?: InputMaybe<ComplianceType>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `BuildingAreaComplianceGroup` object types. All fields are combined with a logical ‘and.’ */
export type BuildingAreaComplianceGroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BuildingAreaComplianceGroupFilter>>;
  /** Filter by the object’s `buildingAreaId` field. */
  buildingAreaId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `complianceGroupId` field. */
  complianceGroupId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `complianceType` field. */
  complianceType?: InputMaybe<ComplianceTypeFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BuildingAreaComplianceGroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BuildingAreaComplianceGroupFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `BuildingAreaComplianceGroup` */
export type BuildingAreaComplianceGroupInput = {
  /** Mutates a `BuildingArea` as part of the payload */
  buildingArea?: InputMaybe<BuildingAreaInput>;
  /** The building area the compliance group applies to */
  buildingAreaId?: InputMaybe<Scalars['Int']>;
  /** Mutates a `ComplianceGroup` as part of the payload */
  complianceGroup?: InputMaybe<ComplianceGroupInput>;
  /** The associated compliance group */
  complianceGroupId?: InputMaybe<Scalars['Int']>;
  /** The type of compliance group for this relationship */
  complianceType: ComplianceType;
};

/** Represents an update to a `BuildingAreaComplianceGroup`. Fields that are set will be updated. */
export type BuildingAreaComplianceGroupPatch = {
  /** The building area the compliance group applies to */
  buildingAreaId?: InputMaybe<Scalars['Int']>;
  /** The associated compliance group */
  complianceGroupId?: InputMaybe<Scalars['Int']>;
  /** The type of compliance group for this relationship */
  complianceType?: InputMaybe<ComplianceType>;
};

/** A connection to a list of `BuildingAreaComplianceGroup` values. */
export type BuildingAreaComplianceGroupsConnection = {
  __typename?: 'BuildingAreaComplianceGroupsConnection';
  /** A list of edges which contains the `BuildingAreaComplianceGroup` and cursor to aid in pagination. */
  edges: Array<BuildingAreaComplianceGroupsEdge>;
  /** A list of `BuildingAreaComplianceGroup` objects. */
  nodes: Array<BuildingAreaComplianceGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BuildingAreaComplianceGroup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `BuildingAreaComplianceGroup` edge in the connection. */
export type BuildingAreaComplianceGroupsEdge = {
  __typename?: 'BuildingAreaComplianceGroupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `BuildingAreaComplianceGroup` at the end of the edge. */
  node: BuildingAreaComplianceGroup;
};

/** Methods to use when ordering `BuildingAreaComplianceGroup`. */
export enum BuildingAreaComplianceGroupsOrderBy {
  BUILDING_AREA_ID_ASC = 'BUILDING_AREA_ID_ASC',
  BUILDING_AREA_ID_DESC = 'BUILDING_AREA_ID_DESC',
  COMPLIANCE_GROUP_ID_ASC = 'COMPLIANCE_GROUP_ID_ASC',
  COMPLIANCE_GROUP_ID_DESC = 'COMPLIANCE_GROUP_ID_DESC',
  COMPLIANCE_TYPE_ASC = 'COMPLIANCE_TYPE_ASC',
  COMPLIANCE_TYPE_DESC = 'COMPLIANCE_TYPE_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/**
 * A condition to be used against `BuildingArea` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BuildingAreaCondition = {
  /** Checks for equality with the object’s `buildingAreaTypeId` field. */
  buildingAreaTypeId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `geometry` field. */
  geometry?: InputMaybe<Scalars['GeoJSON']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `BuildingArea` object types. All fields are combined with a logical ‘and.’ */
export type BuildingAreaFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BuildingAreaFilter>>;
  /** Filter by the object’s `buildingAreaTypeId` field. */
  buildingAreaTypeId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BuildingAreaFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BuildingAreaFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `BuildingArea` */
export type BuildingAreaInput = {
  /** Mutates a `BuildingAreaType` as part of the payload */
  buildingAreaType?: InputMaybe<BuildingAreaTypeInput>;
  /** This associates the building area with a building area type. */
  buildingAreaTypeId?: InputMaybe<Scalars['String']>;
  /** Long-form description of the building area. */
  description?: InputMaybe<Scalars['String']>;
  /** This represents the facility that the building area belongs to. */
  facilityId: Scalars['Int'];
  /** The GIS geometry which specifies how the building area should be displayed on a map. */
  geometry?: InputMaybe<Scalars['GeoJSON']>;
  /** Human-readable label for the building area. */
  label: Scalars['String'];
};

/** A connection to a list of `BuildingAreaPalletHistory` values. */
export type BuildingAreaPalletHistoriesConnection = {
  __typename?: 'BuildingAreaPalletHistoriesConnection';
  /** A list of edges which contains the `BuildingAreaPalletHistory` and cursor to aid in pagination. */
  edges: Array<BuildingAreaPalletHistoriesEdge>;
  /** A list of `BuildingAreaPalletHistory` objects. */
  nodes: Array<BuildingAreaPalletHistory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BuildingAreaPalletHistory` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `BuildingAreaPalletHistory` edge in the connection. */
export type BuildingAreaPalletHistoriesEdge = {
  __typename?: 'BuildingAreaPalletHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `BuildingAreaPalletHistory` at the end of the edge. */
  node: BuildingAreaPalletHistory;
};

/** Contains the history of pallets existing in a particular building area within a facility */
export type BuildingAreaPalletHistory = Node & {
  __typename?: 'BuildingAreaPalletHistory';
  /** Reads a single `BuildingArea` that is related to this `BuildingAreaPalletHistory`. */
  buildingArea?: Maybe<BuildingArea>;
  /** The referenced building area */
  buildingAreaId: Scalars['Int'];
  /** The time at which the record was created */
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['BigInt'];
  /** The date and time of the pallet entering the building area */
  inTime: Scalars['Datetime'];
  /** Reads a single `PalletHistory` that is related to this `BuildingAreaPalletHistory`. */
  inTransaction?: Maybe<PalletHistory>;
  /** The referenced transaction that registered the pallet as entering this building area */
  inTransactionId?: Maybe<Scalars['BigInt']>;
  metadata?: Maybe<Scalars['JSON']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The data and time of the pallet exiting the building area */
  outTime?: Maybe<Scalars['Datetime']>;
  /** Reads a single `PalletHistory` that is related to this `BuildingAreaPalletHistory`. */
  outTransaction?: Maybe<PalletHistory>;
  /** The referenced transaction that registered the pallet as leaving this building area */
  outTransactionId?: Maybe<Scalars['BigInt']>;
  /** Reads a single `Pallet` that is related to this `BuildingAreaPalletHistory`. */
  pallet?: Maybe<Pallet>;
  /** The referenced warehouse pallet */
  palletId: Scalars['BigInt'];
  /** Reads a single `PalletLocation` that is related to this `BuildingAreaPalletHistory`. */
  palletLocation?: Maybe<PalletLocation>;
  /** The pallet location within the building area this pallet is located in */
  palletLocationId?: Maybe<Scalars['BigInt']>;
  /** The time at which the record was updated */
  updatedAt: Scalars['Datetime'];
};

/** A filter to be used against `BuildingAreaPalletHistory` object types. All fields are combined with a logical ‘and.’ */
export type BuildingAreaPalletHistoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BuildingAreaPalletHistoryFilter>>;
  /** Filter by the object’s `buildingAreaId` field. */
  buildingAreaId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `inTime` field. */
  inTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `inTransactionId` field. */
  inTransactionId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BuildingAreaPalletHistoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BuildingAreaPalletHistoryFilter>>;
  /** Filter by the object’s `outTime` field. */
  outTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `outTransactionId` field. */
  outTransactionId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `palletId` field. */
  palletId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `palletLocationId` field. */
  palletLocationId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Represents an update to a `BuildingArea`. Fields that are set will be updated. */
export type BuildingAreaPatch = {
  /** This associates the building area with a building area type. */
  buildingAreaTypeId?: InputMaybe<Scalars['String']>;
  /** Long-form description of the building area. */
  description?: InputMaybe<Scalars['String']>;
  /** This represents the facility that the building area belongs to. */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** The GIS geometry which specifies how the building area should be displayed on a map. */
  geometry?: InputMaybe<Scalars['GeoJSON']>;
  /** Human-readable label for the building area. */
  label?: InputMaybe<Scalars['String']>;
};

/** This represents the types or categories of building areas that exist in a facility. */
export type BuildingAreaType = Node & {
  __typename?: 'BuildingAreaType';
  /** Reads and enables pagination through a set of `BuildingArea`. */
  buildingAreas: BuildingAreasConnection;
  /** Long-form field used to elaborate on the type or capture alternate names of the type. */
  description: Scalars['String'];
  /** Unstructured metadata associated with a building area */
  metadata: Scalars['JSON'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The short name of the building area type. */
  type: Scalars['String'];
};

/** This represents the types or categories of building areas that exist in a facility. */
export type BuildingAreaTypeBuildingAreasArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BuildingAreaCondition>;
  filter?: InputMaybe<BuildingAreaFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BuildingAreasOrderBy>>;
};

/**
 * A condition to be used against `BuildingAreaType` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BuildingAreaTypeCondition = {
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `BuildingAreaType` object types. All fields are combined with a logical ‘and.’ */
export type BuildingAreaTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BuildingAreaTypeFilter>>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BuildingAreaTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BuildingAreaTypeFilter>>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `BuildingAreaType` */
export type BuildingAreaTypeInput = {
  /** Long-form field used to elaborate on the type or capture alternate names of the type. */
  description: Scalars['String'];
  /** Unstructured metadata associated with a building area */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** The short name of the building area type. */
  type: Scalars['String'];
};

/** Represents an update to a `BuildingAreaType`. Fields that are set will be updated. */
export type BuildingAreaTypePatch = {
  /** Long-form field used to elaborate on the type or capture alternate names of the type. */
  description?: InputMaybe<Scalars['String']>;
  /** Unstructured metadata associated with a building area */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** The short name of the building area type. */
  type?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `BuildingAreaType` values. */
export type BuildingAreaTypesConnection = {
  __typename?: 'BuildingAreaTypesConnection';
  /** A list of edges which contains the `BuildingAreaType` and cursor to aid in pagination. */
  edges: Array<BuildingAreaTypesEdge>;
  /** A list of `BuildingAreaType` objects. */
  nodes: Array<BuildingAreaType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BuildingAreaType` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `BuildingAreaType` edge in the connection. */
export type BuildingAreaTypesEdge = {
  __typename?: 'BuildingAreaTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `BuildingAreaType` at the end of the edge. */
  node: BuildingAreaType;
};

/** Methods to use when ordering `BuildingAreaType`. */
export enum BuildingAreaTypesOrderBy {
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC'
}

/** A connection to a list of `BuildingArea` values. */
export type BuildingAreasConnection = {
  __typename?: 'BuildingAreasConnection';
  /** A list of edges which contains the `BuildingArea` and cursor to aid in pagination. */
  edges: Array<BuildingAreasEdge>;
  /** A list of `BuildingArea` objects. */
  nodes: Array<BuildingArea>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BuildingArea` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `BuildingArea` edge in the connection. */
export type BuildingAreasEdge = {
  __typename?: 'BuildingAreasEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `BuildingArea` at the end of the edge. */
  node: BuildingArea;
};

/** Methods to use when ordering `BuildingArea`. */
export enum BuildingAreasOrderBy {
  BUILDING_AREA_TYPE_ID_ASC = 'BUILDING_AREA_TYPE_ID_ASC',
  BUILDING_AREA_TYPE_ID_DESC = 'BUILDING_AREA_TYPE_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  GEOMETRY_ASC = 'GEOMETRY_ASC',
  GEOMETRY_DESC = 'GEOMETRY_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

export type BulkProjectUser = {
  controller?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['Boolean']>;
  projectId: Scalars['Int'];
  sms?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['String'];
  watcher?: InputMaybe<Scalars['Boolean']>;
};

export type Chart = Node & {
  __typename?: 'Chart';
  config: Scalars['JSON'];
  createdAt: Scalars['Datetime'];
  description?: Maybe<Scalars['String']>;
  /** Reads a single `Facility` that is related to this `Chart`. */
  facility?: Maybe<Facility>;
  facilityId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  updatedAt: Scalars['Datetime'];
};

/** A condition to be used against `Chart` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ChartCondition = {
  /** Checks for equality with the object’s `config` field. */
  config?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `Chart` object types. All fields are combined with a logical ‘and.’ */
export type ChartFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ChartFilter>>;
  /** Filter by the object’s `config` field. */
  config?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ChartFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ChartFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Chart` */
export type ChartInput = {
  config?: InputMaybe<Scalars['JSON']>;
  description?: InputMaybe<Scalars['String']>;
  facilityId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

/** Represents an update to a `Chart`. Fields that are set will be updated. */
export type ChartPatch = {
  config?: InputMaybe<Scalars['JSON']>;
  description?: InputMaybe<Scalars['String']>;
  facilityId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `Chart` values. */
export type ChartsConnection = {
  __typename?: 'ChartsConnection';
  /** A list of edges which contains the `Chart` and cursor to aid in pagination. */
  edges: Array<ChartsEdge>;
  /** A list of `Chart` objects. */
  nodes: Array<Chart>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Chart` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Chart` edge in the connection. */
export type ChartsEdge = {
  __typename?: 'ChartsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Chart` at the end of the edge. */
  node: Chart;
};

/** Methods to use when ordering `Chart`. */
export enum ChartsOrderBy {
  CONFIG_ASC = 'CONFIG_ASC',
  CONFIG_DESC = 'CONFIG_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** All input for the `clearFacilityCommunication` mutation. */
export type ClearFacilityCommunicationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  facilityCommunicationId: Scalars['Int'];
};

/** The output of our `clearFacilityCommunication` mutation. */
export type ClearFacilityCommunicationPayload = {
  __typename?: 'ClearFacilityCommunicationPayload';
  boolean?: Maybe<Scalars['Boolean']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** A grouping of compliance ranges that make up a single unique group */
export type ComplianceGroup = Node & {
  __typename?: 'ComplianceGroup';
  /** Reads and enables pagination through a set of `BuildingAreaComplianceGroup`. */
  buildingAreaComplianceGroups: BuildingAreaComplianceGroupsConnection;
  /** Reads and enables pagination through a set of `ComplianceRange`. */
  complianceRanges: ComplianceRangesConnection;
  /** The time at which the Compliance Group was created */
  createdAt: Scalars['Datetime'];
  /** The id of the compliance group */
  id: Scalars['Int'];
  /** The unique label of the compliance group (ex: Freezer, Cooler, Ice Cream Freezer) */
  label: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Whether or not the duration of time in/out of compliance is tracked for this compliance group */
  trackOutOfSpecification: Scalars['Boolean'];
  /** The time at which the Compliance Group was updated */
  updatedAt: Scalars['Datetime'];
};

/** A grouping of compliance ranges that make up a single unique group */
export type ComplianceGroupBuildingAreaComplianceGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BuildingAreaComplianceGroupCondition>;
  filter?: InputMaybe<BuildingAreaComplianceGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BuildingAreaComplianceGroupsOrderBy>>;
};

/** A grouping of compliance ranges that make up a single unique group */
export type ComplianceGroupComplianceRangesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ComplianceRangeCondition>;
  filter?: InputMaybe<ComplianceRangeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ComplianceRangesOrderBy>>;
};

/**
 * A condition to be used against `ComplianceGroup` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ComplianceGroupCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `trackOutOfSpecification` field. */
  trackOutOfSpecification?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `ComplianceGroup` object types. All fields are combined with a logical ‘and.’ */
export type ComplianceGroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ComplianceGroupFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ComplianceGroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ComplianceGroupFilter>>;
  /** Filter by the object’s `trackOutOfSpecification` field. */
  trackOutOfSpecification?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ComplianceGroup` */
export type ComplianceGroupInput = {
  /** The unique label of the compliance group (ex: Freezer, Cooler, Ice Cream Freezer) */
  label: Scalars['String'];
  /** Whether or not the duration of time in/out of compliance is tracked for this compliance group */
  trackOutOfSpecification?: InputMaybe<Scalars['Boolean']>;
};

/** Represents an update to a `ComplianceGroup`. Fields that are set will be updated. */
export type ComplianceGroupPatch = {
  /** The unique label of the compliance group (ex: Freezer, Cooler, Ice Cream Freezer) */
  label?: InputMaybe<Scalars['String']>;
  /** Whether or not the duration of time in/out of compliance is tracked for this compliance group */
  trackOutOfSpecification?: InputMaybe<Scalars['Boolean']>;
};

/** A connection to a list of `ComplianceGroup` values. */
export type ComplianceGroupsConnection = {
  __typename?: 'ComplianceGroupsConnection';
  /** A list of edges which contains the `ComplianceGroup` and cursor to aid in pagination. */
  edges: Array<ComplianceGroupsEdge>;
  /** A list of `ComplianceGroup` objects. */
  nodes: Array<ComplianceGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ComplianceGroup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ComplianceGroup` edge in the connection. */
export type ComplianceGroupsEdge = {
  __typename?: 'ComplianceGroupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ComplianceGroup` at the end of the edge. */
  node: ComplianceGroup;
};

/** Methods to use when ordering `ComplianceGroup`. */
export enum ComplianceGroupsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  TRACK_OUT_OF_SPECIFICATION_ASC = 'TRACK_OUT_OF_SPECIFICATION_ASC',
  TRACK_OUT_OF_SPECIFICATION_DESC = 'TRACK_OUT_OF_SPECIFICATION_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A grouping of compliance ranges that make up a single unique group */
export type ComplianceRange = Node & {
  __typename?: 'ComplianceRange';
  /** Reads a single `ComplianceGroup` that is related to this `ComplianceRange`. */
  complianceGroup?: Maybe<ComplianceGroup>;
  /** The group this compliance range belongs to */
  complianceGroupId?: Maybe<Scalars['Int']>;
  /** The time at which the Compliance Range was created */
  createdAt: Scalars['Datetime'];
  /** The low value of the range (exclusive, < value) */
  highValue: Scalars['Float'];
  /** The id of the compliance range */
  id: Scalars['Int'];
  /** Set if the values in this range should be considered within the specification */
  isWithinSpecification: Scalars['Boolean'];
  /** The unique label of the compliance range (ex: Out of Compliance, Above Compliance) */
  label: Scalars['String'];
  /** The low value of the range (inclusive, >= value) */
  lowValue: Scalars['Float'];
  /** Arbitrary data for storage */
  metadata?: Maybe<Scalars['JSON']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The time at which the Compliance Range was updated */
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `ComplianceRange` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ComplianceRangeCondition = {
  /** Checks for equality with the object’s `complianceGroupId` field. */
  complianceGroupId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `highValue` field. */
  highValue?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `isWithinSpecification` field. */
  isWithinSpecification?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `lowValue` field. */
  lowValue?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `ComplianceRange` object types. All fields are combined with a logical ‘and.’ */
export type ComplianceRangeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ComplianceRangeFilter>>;
  /** Filter by the object’s `complianceGroupId` field. */
  complianceGroupId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `highValue` field. */
  highValue?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isWithinSpecification` field. */
  isWithinSpecification?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lowValue` field. */
  lowValue?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ComplianceRangeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ComplianceRangeFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ComplianceRange` */
export type ComplianceRangeInput = {
  /** Mutates a `ComplianceGroup` as part of the payload */
  complianceGroup?: InputMaybe<ComplianceGroupInput>;
  /** The group this compliance range belongs to */
  complianceGroupId?: InputMaybe<Scalars['Int']>;
  /** The low value of the range (exclusive, < value) */
  highValue: Scalars['Float'];
  /** Set if the values in this range should be considered within the specification */
  isWithinSpecification: Scalars['Boolean'];
  /** The unique label of the compliance range (ex: Out of Compliance, Above Compliance) */
  label: Scalars['String'];
  /** The low value of the range (inclusive, >= value) */
  lowValue: Scalars['Float'];
  /** Arbitrary data for storage */
  metadata?: InputMaybe<Scalars['JSON']>;
};

/** Represents an update to a `ComplianceRange`. Fields that are set will be updated. */
export type ComplianceRangePatch = {
  /** The group this compliance range belongs to */
  complianceGroupId?: InputMaybe<Scalars['Int']>;
  /** The low value of the range (exclusive, < value) */
  highValue?: InputMaybe<Scalars['Float']>;
  /** Set if the values in this range should be considered within the specification */
  isWithinSpecification?: InputMaybe<Scalars['Boolean']>;
  /** The unique label of the compliance range (ex: Out of Compliance, Above Compliance) */
  label?: InputMaybe<Scalars['String']>;
  /** The low value of the range (inclusive, >= value) */
  lowValue?: InputMaybe<Scalars['Float']>;
  /** Arbitrary data for storage */
  metadata?: InputMaybe<Scalars['JSON']>;
};

/** A connection to a list of `ComplianceRange` values. */
export type ComplianceRangesConnection = {
  __typename?: 'ComplianceRangesConnection';
  /** A list of edges which contains the `ComplianceRange` and cursor to aid in pagination. */
  edges: Array<ComplianceRangesEdge>;
  /** A list of `ComplianceRange` objects. */
  nodes: Array<ComplianceRange>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ComplianceRange` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ComplianceRange` edge in the connection. */
export type ComplianceRangesEdge = {
  __typename?: 'ComplianceRangesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ComplianceRange` at the end of the edge. */
  node: ComplianceRange;
};

/** Methods to use when ordering `ComplianceRange`. */
export enum ComplianceRangesOrderBy {
  COMPLIANCE_GROUP_ID_ASC = 'COMPLIANCE_GROUP_ID_ASC',
  COMPLIANCE_GROUP_ID_DESC = 'COMPLIANCE_GROUP_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  HIGH_VALUE_ASC = 'HIGH_VALUE_ASC',
  HIGH_VALUE_DESC = 'HIGH_VALUE_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IS_WITHIN_SPECIFICATION_ASC = 'IS_WITHIN_SPECIFICATION_ASC',
  IS_WITHIN_SPECIFICATION_DESC = 'IS_WITHIN_SPECIFICATION_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  LOW_VALUE_ASC = 'LOW_VALUE_ASC',
  LOW_VALUE_DESC = 'LOW_VALUE_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

export enum ComplianceType {
  AMMONIA = 'AMMONIA',
  HUMIDITY = 'HUMIDITY',
  TEMPERATURE = 'TEMPERATURE'
}

/** A filter to be used against ComplianceType fields. All fields are combined with a logical ‘and.’ */
export type ComplianceTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ComplianceType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ComplianceType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ComplianceType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ComplianceType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ComplianceType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ComplianceType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ComplianceType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ComplianceType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ComplianceType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ComplianceType>>;
};

/** A component. */
export type Component = Node & {
  __typename?: 'Component';
  /** An optional alias for the component. */
  alias?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `ControlEvent`. */
  controlEvents: ControlEventsConnection;
  /** The date the component was created at */
  createdAt: Scalars['Datetime'];
  /** Reads a single `Facility` that is related to this `Component`. */
  facility?: Maybe<Facility>;
  /** The identifier of the facility associated with the component */
  facilityId: Scalars['Int'];
  /** The identifier of the component */
  id: Scalars['Int'];
  /** Reads a single `MachineUser` that is related to this `Component`. */
  machineUser?: Maybe<MachineUser>;
  /** The identifier of the machine user associated with the component */
  machineUserId: Scalars['BigInt'];
  /** Human readable name of the component */
  name: Scalars['String'];
  /** The next or current `ControlEvent` associated with the component. */
  nextControlEvents: ControlEventsConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Whether the component is out of service */
  outOfService: Scalars['Boolean'];
  /** Available permissions for the Component. */
  permissions?: Maybe<ComponentPermissions>;
  /** The date the component was updated at */
  updatedAt: Scalars['Datetime'];
};

/** A component. */
export type ComponentControlEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ControlEventCondition>;
  filter?: InputMaybe<ControlEventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ControlEventsOrderBy>>;
};

/** A component. */
export type ComponentNextControlEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<ControlEventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/**
 * A condition to be used against `Component` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ComponentCondition = {
  /** Checks for equality with the object’s `alias` field. */
  alias?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `machineUserId` field. */
  machineUserId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `outOfService` field. */
  outOfService?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `Component` object types. All fields are combined with a logical ‘and.’ */
export type ComponentFilter = {
  /** Filter by the object’s `alias` field. */
  alias?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ComponentFilter>>;
  /** Filter by the permission can_write */
  canWrite?: InputMaybe<PermissionBooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `machineUserId` field. */
  machineUserId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ComponentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ComponentFilter>>;
  /** Filter by the object’s `outOfService` field. */
  outOfService?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Component` */
export type ComponentInput = {
  /** An optional alias for the component. */
  alias?: InputMaybe<Scalars['String']>;
  /** The date the component was created at */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** The identifier of the facility associated with the component */
  facilityId: Scalars['Int'];
  /** The identifier of the component */
  id?: InputMaybe<Scalars['Int']>;
  /** Mutates a `MachineUser` as part of the payload */
  machineUser?: InputMaybe<MachineUserInput>;
  /** The identifier of the machine user associated with the component */
  machineUserId?: InputMaybe<Scalars['BigInt']>;
  /** Human readable name of the component */
  name: Scalars['String'];
  /** Whether the component is out of service */
  outOfService?: InputMaybe<Scalars['Boolean']>;
  /** The date the component was updated at */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `Component`. Fields that are set will be updated. */
export type ComponentPatch = {
  /** An optional alias for the component. */
  alias?: InputMaybe<Scalars['String']>;
  /** The date the component was created at */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** The identifier of the facility associated with the component */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** The identifier of the component */
  id?: InputMaybe<Scalars['Int']>;
  /** The identifier of the machine user associated with the component */
  machineUserId?: InputMaybe<Scalars['BigInt']>;
  /** Human readable name of the component */
  name?: InputMaybe<Scalars['String']>;
  /** Whether the component is out of service */
  outOfService?: InputMaybe<Scalars['Boolean']>;
  /** The date the component was updated at */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Permissive capabilities on a Component. */
export type ComponentPermissions = {
  __typename?: 'ComponentPermissions';
  /** Whether a user can update the component. */
  canWrite: Scalars['Boolean'];
};

/** A connection to a list of `Component` values. */
export type ComponentsConnection = {
  __typename?: 'ComponentsConnection';
  /** A list of edges which contains the `Component` and cursor to aid in pagination. */
  edges: Array<ComponentsEdge>;
  /** A list of `Component` objects. */
  nodes: Array<Component>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Component` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Component` edge in the connection. */
export type ComponentsEdge = {
  __typename?: 'ComponentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Component` at the end of the edge. */
  node: Component;
};

/** Methods to use when ordering `Component`. */
export enum ComponentsOrderBy {
  ALIAS_ASC = 'ALIAS_ASC',
  ALIAS_DESC = 'ALIAS_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  MACHINE_USER_ID_ASC = 'MACHINE_USER_ID_ASC',
  MACHINE_USER_ID_DESC = 'MACHINE_USER_ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  OUT_OF_SERVICE_ASC = 'OUT_OF_SERVICE_ASC',
  OUT_OF_SERVICE_DESC = 'OUT_OF_SERVICE_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** This represents a compressor that exists in a facility */
export type Compressor = Node & {
  __typename?: 'Compressor';
  /** Reads a single `BuildingArea` that is related to this `Compressor`. */
  buildingArea?: Maybe<BuildingArea>;
  /** The associated area of within a building */
  buildingAreaId?: Maybe<Scalars['Int']>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  capacity?: Maybe<DataPoint>;
  /** The capacity */
  capacityId?: Maybe<Scalars['BigInt']>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  controlMode?: Maybe<DataPoint>;
  /** The control mode state value */
  controlModeId?: Maybe<Scalars['BigInt']>;
  /** The time at which the Compressor was created. */
  createdAt: Scalars['Datetime'];
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  differentialPressure?: Maybe<DataPoint>;
  /** The differential pressure */
  differentialPressureId?: Maybe<Scalars['BigInt']>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  dischargePressure?: Maybe<DataPoint>;
  /** The discharge pressure */
  dischargePressureId?: Maybe<Scalars['BigInt']>;
  /** Reads a single `Facility` that is related to this `Compressor`. */
  facility?: Maybe<Facility>;
  /** The facility a compressor is installed within */
  facilityId?: Maybe<Scalars['Int']>;
  /** The geocoded location of a compressor */
  geometry?: Maybe<GeometryInterface>;
  /** The rated horsepower of a compressor */
  horsepower?: Maybe<Scalars['Int']>;
  /** The id of the compressor. */
  id: Scalars['Int'];
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  kwDemand?: Maybe<DataPoint>;
  /** The electrical demand (KW) */
  kwDemandId?: Maybe<Scalars['BigInt']>;
  /** A human-readable label for a compressor */
  label: Scalars['String'];
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  motorAmps?: Maybe<DataPoint>;
  /** The measured amperage (A) */
  motorAmpsId?: Maybe<Scalars['BigInt']>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  motorState?: Maybe<DataPoint>;
  /** The motor state */
  motorStateId?: Maybe<Scalars['BigInt']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  oilPressure?: Maybe<DataPoint>;
  /** The oil pressure */
  oilPressureId?: Maybe<Scalars['BigInt']>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  oilTemperature?: Maybe<DataPoint>;
  /** The oil temperature */
  oilTemperatureId?: Maybe<Scalars['BigInt']>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  runtimeHours?: Maybe<DataPoint>;
  /** The current runtime */
  runtimeHoursId?: Maybe<Scalars['BigInt']>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  setpoint?: Maybe<DataPoint>;
  /** The setpoint */
  setpointId?: Maybe<Scalars['BigInt']>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  slideValvePosition?: Maybe<DataPoint>;
  /** The slide valve position */
  slideValvePositionId?: Maybe<Scalars['BigInt']>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  state?: Maybe<DataPoint>;
  /** The current state */
  stateId?: Maybe<Scalars['BigInt']>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  suctionPressure?: Maybe<DataPoint>;
  /** The suction pressure */
  suctionPressureId?: Maybe<Scalars['BigInt']>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  suctionTemperature?: Maybe<DataPoint>;
  /** The suction temperature */
  suctionTemperatureId?: Maybe<Scalars['BigInt']>;
  /** The time at which the Compressor was updated. */
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `Compressor` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type CompressorCondition = {
  /** Checks for equality with the object’s `buildingAreaId` field. */
  buildingAreaId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `capacityId` field. */
  capacityId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `controlModeId` field. */
  controlModeId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `differentialPressureId` field. */
  differentialPressureId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `dischargePressureId` field. */
  dischargePressureId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `geometry` field. */
  geometry?: InputMaybe<Scalars['GeoJSON']>;
  /** Checks for equality with the object’s `horsepower` field. */
  horsepower?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `kwDemandId` field. */
  kwDemandId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `motorAmpsId` field. */
  motorAmpsId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `motorStateId` field. */
  motorStateId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `oilPressureId` field. */
  oilPressureId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `oilTemperatureId` field. */
  oilTemperatureId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `runtimeHoursId` field. */
  runtimeHoursId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `setpointId` field. */
  setpointId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `slideValvePositionId` field. */
  slideValvePositionId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `stateId` field. */
  stateId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `suctionPressureId` field. */
  suctionPressureId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `suctionTemperatureId` field. */
  suctionTemperatureId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `Compressor` object types. All fields are combined with a logical ‘and.’ */
export type CompressorFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CompressorFilter>>;
  /** Filter by the object’s `buildingAreaId` field. */
  buildingAreaId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `capacityId` field. */
  capacityId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `controlModeId` field. */
  controlModeId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `differentialPressureId` field. */
  differentialPressureId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `dischargePressureId` field. */
  dischargePressureId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `horsepower` field. */
  horsepower?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `kwDemandId` field. */
  kwDemandId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Filter by the object’s `motorAmpsId` field. */
  motorAmpsId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `motorStateId` field. */
  motorStateId?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CompressorFilter>;
  /** Filter by the object’s `oilPressureId` field. */
  oilPressureId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `oilTemperatureId` field. */
  oilTemperatureId?: InputMaybe<BigIntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CompressorFilter>>;
  /** Filter by the object’s `runtimeHoursId` field. */
  runtimeHoursId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `setpointId` field. */
  setpointId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `slideValvePositionId` field. */
  slideValvePositionId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `stateId` field. */
  stateId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `suctionPressureId` field. */
  suctionPressureId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `suctionTemperatureId` field. */
  suctionTemperatureId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Compressor` */
export type CompressorInput = {
  /** Mutates a `BuildingArea` as part of the payload */
  buildingArea?: InputMaybe<BuildingAreaInput>;
  /** The associated area of within a building */
  buildingAreaId?: InputMaybe<Scalars['Int']>;
  /** The capacity */
  capacityId?: InputMaybe<Scalars['BigInt']>;
  /** The control mode state value */
  controlModeId?: InputMaybe<Scalars['BigInt']>;
  /** Mutates a `DataPoint` as part of the payload */
  dataPoint?: InputMaybe<DataPointInput>;
  /** The differential pressure */
  differentialPressureId?: InputMaybe<Scalars['BigInt']>;
  /** The discharge pressure */
  dischargePressureId?: InputMaybe<Scalars['BigInt']>;
  /** The facility a compressor is installed within */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** The geocoded location of a compressor */
  geometry?: InputMaybe<Scalars['GeoJSON']>;
  /** The rated horsepower of a compressor */
  horsepower?: InputMaybe<Scalars['Int']>;
  /** The electrical demand (KW) */
  kwDemandId?: InputMaybe<Scalars['BigInt']>;
  /** A human-readable label for a compressor */
  label: Scalars['String'];
  /** The measured amperage (A) */
  motorAmpsId?: InputMaybe<Scalars['BigInt']>;
  /** The motor state */
  motorStateId?: InputMaybe<Scalars['BigInt']>;
  /** The oil pressure */
  oilPressureId?: InputMaybe<Scalars['BigInt']>;
  /** The oil temperature */
  oilTemperatureId?: InputMaybe<Scalars['BigInt']>;
  /** The current runtime */
  runtimeHoursId?: InputMaybe<Scalars['BigInt']>;
  /** The setpoint */
  setpointId?: InputMaybe<Scalars['BigInt']>;
  /** The slide valve position */
  slideValvePositionId?: InputMaybe<Scalars['BigInt']>;
  /** The current state */
  stateId?: InputMaybe<Scalars['BigInt']>;
  /** The suction pressure */
  suctionPressureId?: InputMaybe<Scalars['BigInt']>;
  /** The suction temperature */
  suctionTemperatureId?: InputMaybe<Scalars['BigInt']>;
};

/** Represents an update to a `Compressor`. Fields that are set will be updated. */
export type CompressorPatch = {
  /** The associated area of within a building */
  buildingAreaId?: InputMaybe<Scalars['Int']>;
  /** The capacity */
  capacityId?: InputMaybe<Scalars['BigInt']>;
  /** The control mode state value */
  controlModeId?: InputMaybe<Scalars['BigInt']>;
  /** The differential pressure */
  differentialPressureId?: InputMaybe<Scalars['BigInt']>;
  /** The discharge pressure */
  dischargePressureId?: InputMaybe<Scalars['BigInt']>;
  /** The facility a compressor is installed within */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** The geocoded location of a compressor */
  geometry?: InputMaybe<Scalars['GeoJSON']>;
  /** The rated horsepower of a compressor */
  horsepower?: InputMaybe<Scalars['Int']>;
  /** The electrical demand (KW) */
  kwDemandId?: InputMaybe<Scalars['BigInt']>;
  /** A human-readable label for a compressor */
  label?: InputMaybe<Scalars['String']>;
  /** The measured amperage (A) */
  motorAmpsId?: InputMaybe<Scalars['BigInt']>;
  /** The motor state */
  motorStateId?: InputMaybe<Scalars['BigInt']>;
  /** The oil pressure */
  oilPressureId?: InputMaybe<Scalars['BigInt']>;
  /** The oil temperature */
  oilTemperatureId?: InputMaybe<Scalars['BigInt']>;
  /** The current runtime */
  runtimeHoursId?: InputMaybe<Scalars['BigInt']>;
  /** The setpoint */
  setpointId?: InputMaybe<Scalars['BigInt']>;
  /** The slide valve position */
  slideValvePositionId?: InputMaybe<Scalars['BigInt']>;
  /** The current state */
  stateId?: InputMaybe<Scalars['BigInt']>;
  /** The suction pressure */
  suctionPressureId?: InputMaybe<Scalars['BigInt']>;
  /** The suction temperature */
  suctionTemperatureId?: InputMaybe<Scalars['BigInt']>;
};

/** A connection to a list of `Compressor` values. */
export type CompressorsConnection = {
  __typename?: 'CompressorsConnection';
  /** Returns the aggregate capacity timeseries data for the CompressorsConnection  */
  capacity?: Maybe<MetricDataConnection>;
  /** Returns the aggregate controlMode timeseries data for the CompressorsConnection  */
  controlMode?: Maybe<MetricDataConnection>;
  /** Returns the aggregate differentialPressure timeseries data for the CompressorsConnection  */
  differentialPressure?: Maybe<MetricDataConnection>;
  /** Returns the aggregate dischargePressure timeseries data for the CompressorsConnection  */
  dischargePressure?: Maybe<MetricDataConnection>;
  /** A list of edges which contains the `Compressor` and cursor to aid in pagination. */
  edges: Array<CompressorsEdge>;
  /** Returns the aggregate kwDemand timeseries data for the CompressorsConnection  */
  kwDemand?: Maybe<MetricDataConnection>;
  /** Returns the aggregate motorAmps timeseries data for the CompressorsConnection  */
  motorAmps?: Maybe<MetricDataConnection>;
  /** Returns the aggregate motorState timeseries data for the CompressorsConnection  */
  motorState?: Maybe<MetricDataConnection>;
  /** A list of `Compressor` objects. */
  nodes: Array<Compressor>;
  /** Returns the aggregate oilPressure timeseries data for the CompressorsConnection  */
  oilPressure?: Maybe<MetricDataConnection>;
  /** Returns the aggregate oilTemperature timeseries data for the CompressorsConnection  */
  oilTemperature?: Maybe<MetricDataConnection>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Returns the aggregate runtimeHours timeseries data for the CompressorsConnection  */
  runtimeHours?: Maybe<MetricDataConnection>;
  /** Returns the aggregate setpoint timeseries data for the CompressorsConnection  */
  setpoint?: Maybe<MetricDataConnection>;
  /** Returns the aggregate slideValvePosition timeseries data for the CompressorsConnection  */
  slideValvePosition?: Maybe<MetricDataConnection>;
  /** Returns the aggregate state timeseries data for the CompressorsConnection  */
  state?: Maybe<MetricDataConnection>;
  /** Returns the aggregate suctionPressure timeseries data for the CompressorsConnection  */
  suctionPressure?: Maybe<MetricDataConnection>;
  /** Returns the aggregate suctionTemperature timeseries data for the CompressorsConnection  */
  suctionTemperature?: Maybe<MetricDataConnection>;
  /** The count of *all* `Compressor` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A connection to a list of `Compressor` values. */
export type CompressorsConnectionCapacityArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Compressor` values. */
export type CompressorsConnectionControlModeArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Compressor` values. */
export type CompressorsConnectionDifferentialPressureArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Compressor` values. */
export type CompressorsConnectionDischargePressureArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Compressor` values. */
export type CompressorsConnectionKwDemandArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Compressor` values. */
export type CompressorsConnectionMotorAmpsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Compressor` values. */
export type CompressorsConnectionMotorStateArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Compressor` values. */
export type CompressorsConnectionOilPressureArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Compressor` values. */
export type CompressorsConnectionOilTemperatureArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Compressor` values. */
export type CompressorsConnectionRuntimeHoursArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Compressor` values. */
export type CompressorsConnectionSetpointArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Compressor` values. */
export type CompressorsConnectionSlideValvePositionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Compressor` values. */
export type CompressorsConnectionStateArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Compressor` values. */
export type CompressorsConnectionSuctionPressureArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Compressor` values. */
export type CompressorsConnectionSuctionTemperatureArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A `Compressor` edge in the connection. */
export type CompressorsEdge = {
  __typename?: 'CompressorsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Compressor` at the end of the edge. */
  node: Compressor;
};

/** Methods to use when ordering `Compressor`. */
export enum CompressorsOrderBy {
  BUILDING_AREA_ID_ASC = 'BUILDING_AREA_ID_ASC',
  BUILDING_AREA_ID_DESC = 'BUILDING_AREA_ID_DESC',
  CAPACITY_ID_ASC = 'CAPACITY_ID_ASC',
  CAPACITY_ID_DESC = 'CAPACITY_ID_DESC',
  CONTROL_MODE_ID_ASC = 'CONTROL_MODE_ID_ASC',
  CONTROL_MODE_ID_DESC = 'CONTROL_MODE_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DIFFERENTIAL_PRESSURE_ID_ASC = 'DIFFERENTIAL_PRESSURE_ID_ASC',
  DIFFERENTIAL_PRESSURE_ID_DESC = 'DIFFERENTIAL_PRESSURE_ID_DESC',
  DISCHARGE_PRESSURE_ID_ASC = 'DISCHARGE_PRESSURE_ID_ASC',
  DISCHARGE_PRESSURE_ID_DESC = 'DISCHARGE_PRESSURE_ID_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  GEOMETRY_ASC = 'GEOMETRY_ASC',
  GEOMETRY_DESC = 'GEOMETRY_DESC',
  HORSEPOWER_ASC = 'HORSEPOWER_ASC',
  HORSEPOWER_DESC = 'HORSEPOWER_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  KW_DEMAND_ID_ASC = 'KW_DEMAND_ID_ASC',
  KW_DEMAND_ID_DESC = 'KW_DEMAND_ID_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  MOTOR_AMPS_ID_ASC = 'MOTOR_AMPS_ID_ASC',
  MOTOR_AMPS_ID_DESC = 'MOTOR_AMPS_ID_DESC',
  MOTOR_STATE_ID_ASC = 'MOTOR_STATE_ID_ASC',
  MOTOR_STATE_ID_DESC = 'MOTOR_STATE_ID_DESC',
  NATURAL = 'NATURAL',
  OIL_PRESSURE_ID_ASC = 'OIL_PRESSURE_ID_ASC',
  OIL_PRESSURE_ID_DESC = 'OIL_PRESSURE_ID_DESC',
  OIL_TEMPERATURE_ID_ASC = 'OIL_TEMPERATURE_ID_ASC',
  OIL_TEMPERATURE_ID_DESC = 'OIL_TEMPERATURE_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  RUNTIME_HOURS_ID_ASC = 'RUNTIME_HOURS_ID_ASC',
  RUNTIME_HOURS_ID_DESC = 'RUNTIME_HOURS_ID_DESC',
  SETPOINT_ID_ASC = 'SETPOINT_ID_ASC',
  SETPOINT_ID_DESC = 'SETPOINT_ID_DESC',
  SLIDE_VALVE_POSITION_ID_ASC = 'SLIDE_VALVE_POSITION_ID_ASC',
  SLIDE_VALVE_POSITION_ID_DESC = 'SLIDE_VALVE_POSITION_ID_DESC',
  STATE_ID_ASC = 'STATE_ID_ASC',
  STATE_ID_DESC = 'STATE_ID_DESC',
  SUCTION_PRESSURE_ID_ASC = 'SUCTION_PRESSURE_ID_ASC',
  SUCTION_PRESSURE_ID_DESC = 'SUCTION_PRESSURE_ID_DESC',
  SUCTION_TEMPERATURE_ID_ASC = 'SUCTION_TEMPERATURE_ID_ASC',
  SUCTION_TEMPERATURE_ID_DESC = 'SUCTION_TEMPERATURE_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A control event. */
export type ControlEvent = Node & {
  __typename?: 'ControlEvent';
  /** The timestamp of the last acknowledgement. */
  acknowledgedAt?: Maybe<Scalars['Datetime']>;
  availableStates: Array<ControlEventState>;
  /** Reads a single `Component` that is related to this `ControlEvent`. */
  component?: Maybe<Component>;
  /** Returns the specific configuration for the component for this event. */
  componentConfiguration?: Maybe<ProjectComponent>;
  /** The identifier of the component associated with the control event */
  componentId: Scalars['Int'];
  /** Reads and enables pagination through a set of `ControlEventActivityLog`. */
  controlEventActivityLogs: ControlEventActivityLogsConnection;
  /** Reads and enables pagination through a set of `ControlEventLog`. */
  controlEventLogs: ControlEventLogsConnection;
  /** Reads and enables pagination through a set of `ControlEventStateTransition`. */
  controlEventStateTransitions: ControlEventStateTransitionsConnection;
  /** The date the control event was created at */
  createdAt: Scalars['Datetime'];
  /** The current Project Enrollment associated with the control event. */
  currentEnrollment?: Maybe<ProjectEnrollment>;
  currentState?: Maybe<ControlEventState>;
  /** The current `ControlEventState` associated with the control event. */
  currentStateRef?: Maybe<ControlEventStateTransition>;
  /** The time the control event ended */
  endTime: Scalars['Datetime'];
  /** The identifier of the control event */
  id: Scalars['Int'];
  /** Whether the control event is acknowledged. */
  isAcknowledged?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Available permissions for the ControlEvent. */
  permissions?: Maybe<ControlEventPermissions>;
  /** Key-value store for remote metadata. */
  remoteMetadata: Scalars['JSON'];
  /** The time the control event started */
  startTime: Scalars['Datetime'];
  /** The associated suggestion, if exists. */
  suggestion?: Maybe<Suggestion>;
  /** Reads a single `SuggestionControlEvent` that is related to this `ControlEvent`. */
  suggestionControlEvent?: Maybe<SuggestionControlEvent>;
  /** Reads and enables pagination through a set of `Suggestion`. */
  suggestions: SuggestionsConnection;
  updatedAt: Scalars['Datetime'];
};

/** A control event. */
export type ControlEventControlEventActivityLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ControlEventActivityLogCondition>;
  filter?: InputMaybe<ControlEventActivityLogFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ControlEventActivityLogsOrderBy>>;
};

/** A control event. */
export type ControlEventControlEventLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ControlEventLogCondition>;
  filter?: InputMaybe<ControlEventLogFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ControlEventLogsOrderBy>>;
};

/** A control event. */
export type ControlEventControlEventStateTransitionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ControlEventStateTransitionCondition>;
  filter?: InputMaybe<ControlEventStateTransitionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ControlEventStateTransitionsOrderBy>>;
};

/** A control event. */
export type ControlEventSuggestionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<SuggestionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type ControlEventActivityLog = {
  __typename?: 'ControlEventActivityLog';
  /** The actor who performed the activity. */
  actor?: Maybe<Actor>;
  /** Reads a single `ControlEvent` that is related to this `ControlEventActivityLog`. */
  controlEvent?: Maybe<ControlEvent>;
  /** The control event associated with this activity log. */
  controlEventId?: Maybe<Scalars['Int']>;
  /** The metadata associated with the activity. */
  metadata?: Maybe<Scalars['JSON']>;
  /** The time at which the activity occurred. */
  time?: Maybe<Scalars['Datetime']>;
  /** The type of activity that occurred. */
  type?: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `ControlEventActivityLog` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ControlEventActivityLogCondition = {
  /** Checks for equality with the object’s `actor` field. */
  actor?: InputMaybe<ActorInput>;
  /** Checks for equality with the object’s `controlEventId` field. */
  controlEventId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `time` field. */
  time?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `ControlEventActivityLog` object types. All fields are combined with a logical ‘and.’ */
export type ControlEventActivityLogFilter = {
  /** Filter by the object’s `actor` field. */
  actor?: InputMaybe<ActorFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ControlEventActivityLogFilter>>;
  /** Filter by the object’s `controlEventId` field. */
  controlEventId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ControlEventActivityLogFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ControlEventActivityLogFilter>>;
  /** Filter by the object’s `time` field. */
  time?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
};

/** A connection to a list of `ControlEventActivityLog` values. */
export type ControlEventActivityLogsConnection = {
  __typename?: 'ControlEventActivityLogsConnection';
  /** A list of edges which contains the `ControlEventActivityLog` and cursor to aid in pagination. */
  edges: Array<ControlEventActivityLogsEdge>;
  /** A list of `ControlEventActivityLog` objects. */
  nodes: Array<ControlEventActivityLog>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ControlEventActivityLog` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ControlEventActivityLog` edge in the connection. */
export type ControlEventActivityLogsEdge = {
  __typename?: 'ControlEventActivityLogsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ControlEventActivityLog` at the end of the edge. */
  node: ControlEventActivityLog;
};

/** Methods to use when ordering `ControlEventActivityLog`. */
export enum ControlEventActivityLogsOrderBy {
  ACTOR_ASC = 'ACTOR_ASC',
  ACTOR_DESC = 'ACTOR_DESC',
  CONTROL_EVENT_ID_ASC = 'CONTROL_EVENT_ID_ASC',
  CONTROL_EVENT_ID_DESC = 'CONTROL_EVENT_ID_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  NATURAL = 'NATURAL',
  TIME_ASC = 'TIME_ASC',
  TIME_DESC = 'TIME_DESC',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC'
}

/**
 * A condition to be used against `ControlEvent` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ControlEventCondition = {
  /** Checks for equality with the object’s `acknowledgedAt` field. */
  acknowledgedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `componentId` field. */
  componentId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `endTime` field. */
  endTime?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `remoteMetadata` field. */
  remoteMetadata?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `startTime` field. */
  startTime?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `ControlEvent` object types. All fields are combined with a logical ‘and.’ */
export type ControlEventFilter = {
  /** Filter by the object’s `acknowledgedAt` field. */
  acknowledgedAt?: InputMaybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ControlEventFilter>>;
  /** Filter by the permission can_write */
  canWrite?: InputMaybe<PermissionBooleanFilter>;
  /** Filter by the object’s `componentId` field. */
  componentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `currentState` field. */
  currentState?: InputMaybe<ControlEventStateFilter>;
  /** Filter by the object’s `endTime` field. */
  endTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isAcknowledged` field. */
  isAcknowledged?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ControlEventFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ControlEventFilter>>;
  /** Filter by the object’s `remoteMetadata` field. */
  remoteMetadata?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `startTime` field. */
  startTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ControlEvent` */
export type ControlEventInput = {
  /** The identifier of the component associated with the control event */
  componentId: Scalars['Int'];
  /** The date the control event was created at */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** The time the control event ended */
  endTime: Scalars['Datetime'];
  /** The identifier of the control event */
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  /** Key-value store for remote metadata. */
  remoteMetadata?: InputMaybe<Scalars['JSON']>;
  /** The time the control event started */
  startTime: Scalars['Datetime'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Log messages for a given control event. */
export type ControlEventLog = Node & {
  __typename?: 'ControlEventLog';
  /** The identifier of the actor who logged the message. */
  actor?: Maybe<Actor>;
  /** Reads a single `ControlEvent` that is related to this `ControlEventLog`. */
  controlEvent?: Maybe<ControlEvent>;
  /** The identifier of the control event associated with the control event log entry */
  controlEventId: Scalars['Int'];
  /** The date the control event log entry was created at */
  createdAt: Scalars['Datetime'];
  /** The identifier of the control event log entry */
  id: Scalars['Int'];
  /** The message of the log statement. */
  message: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
};

/**
 * A condition to be used against `ControlEventLog` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ControlEventLogCondition = {
  /** Checks for equality with the object’s `actor` field. */
  actor?: InputMaybe<ActorInput>;
  /** Checks for equality with the object’s `controlEventId` field. */
  controlEventId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `message` field. */
  message?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `ControlEventLog` object types. All fields are combined with a logical ‘and.’ */
export type ControlEventLogFilter = {
  /** Filter by the object’s `actor` field. */
  actor?: InputMaybe<ActorFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ControlEventLogFilter>>;
  /** Filter by the object’s `controlEventId` field. */
  controlEventId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `message` field. */
  message?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ControlEventLogFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ControlEventLogFilter>>;
};

/** An input for mutations affecting `ControlEventLog` */
export type ControlEventLogInput = {
  /** Mutates a `ControlEvent` as part of the payload */
  controlEvent?: InputMaybe<ControlEventInput>;
  /** The identifier of the control event associated with the control event log entry */
  controlEventId?: InputMaybe<Scalars['Int']>;
  /** The message of the log statement. */
  message: Scalars['String'];
};

/** Represents an update to a `ControlEventLog`. Fields that are set will be updated. */
export type ControlEventLogPatch = {
  /** The identifier of the control event associated with the control event log entry */
  controlEventId?: InputMaybe<Scalars['Int']>;
  /** The message of the log statement. */
  message?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `ControlEventLog` values. */
export type ControlEventLogsConnection = {
  __typename?: 'ControlEventLogsConnection';
  /** A list of edges which contains the `ControlEventLog` and cursor to aid in pagination. */
  edges: Array<ControlEventLogsEdge>;
  /** A list of `ControlEventLog` objects. */
  nodes: Array<ControlEventLog>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ControlEventLog` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ControlEventLog` edge in the connection. */
export type ControlEventLogsEdge = {
  __typename?: 'ControlEventLogsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ControlEventLog` at the end of the edge. */
  node: ControlEventLog;
};

/** Methods to use when ordering `ControlEventLog`. */
export enum ControlEventLogsOrderBy {
  ACTOR_ASC = 'ACTOR_ASC',
  ACTOR_DESC = 'ACTOR_DESC',
  CONTROL_EVENT_ID_ASC = 'CONTROL_EVENT_ID_ASC',
  CONTROL_EVENT_ID_DESC = 'CONTROL_EVENT_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  MESSAGE_ASC = 'MESSAGE_ASC',
  MESSAGE_DESC = 'MESSAGE_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** Represents an update to a `ControlEvent`. Fields that are set will be updated. */
export type ControlEventPatch = {
  /** The time the control event ended */
  endTime?: InputMaybe<Scalars['Datetime']>;
  /** The identifier of the control event */
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  /** Key-value store for remote metadata. */
  remoteMetadata?: InputMaybe<Scalars['JSON']>;
  /** The time the control event started */
  startTime?: InputMaybe<Scalars['Datetime']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Permissive capabilities on a ControlEvent. */
export type ControlEventPermissions = {
  __typename?: 'ControlEventPermissions';
  /** Whether a user can write to the control event. */
  canWrite: Scalars['Boolean'];
};

export enum ControlEventState {
  CANCELLED = 'CANCELLED',
  CANCEL_REQUESTED = 'CANCEL_REQUESTED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  SCHEDULED = 'SCHEDULED',
  STARTED = 'STARTED'
}

/** A filter to be used against ControlEventState fields. All fields are combined with a logical ‘and.’ */
export type ControlEventStateFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ControlEventState>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ControlEventState>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ControlEventState>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ControlEventState>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ControlEventState>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ControlEventState>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ControlEventState>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ControlEventState>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ControlEventState>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ControlEventState>>;
};

export type ControlEventStateTransition = Node & {
  __typename?: 'ControlEventStateTransition';
  /** The identifier of the actor who performed the control event state transition. */
  actor?: Maybe<Actor>;
  /** Reads a single `ControlEvent` that is related to this `ControlEventStateTransition`. */
  controlEvent?: Maybe<ControlEvent>;
  /** The identifier of the control event associated with the control event state transition */
  controlEventId: Scalars['Int'];
  /** The date the control event state transition was created at */
  createdAt: Scalars['Datetime'];
  /** A description of the control event state transition */
  description?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The new state of the control event */
  state: ControlEventState;
};

/**
 * A condition to be used against `ControlEventStateTransition` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ControlEventStateTransitionCondition = {
  /** Checks for equality with the object’s `actor` field. */
  actor?: InputMaybe<ActorInput>;
  /** Checks for equality with the object’s `controlEventId` field. */
  controlEventId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<ControlEventState>;
};

/** A filter to be used against `ControlEventStateTransition` object types. All fields are combined with a logical ‘and.’ */
export type ControlEventStateTransitionFilter = {
  /** Filter by the object’s `actor` field. */
  actor?: InputMaybe<ActorFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ControlEventStateTransitionFilter>>;
  /** Filter by the object’s `controlEventId` field. */
  controlEventId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ControlEventStateTransitionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ControlEventStateTransitionFilter>>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<ControlEventStateFilter>;
};

/** A connection to a list of `ControlEventStateTransition` values. */
export type ControlEventStateTransitionsConnection = {
  __typename?: 'ControlEventStateTransitionsConnection';
  /** A list of edges which contains the `ControlEventStateTransition` and cursor to aid in pagination. */
  edges: Array<ControlEventStateTransitionsEdge>;
  /** A list of `ControlEventStateTransition` objects. */
  nodes: Array<ControlEventStateTransition>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ControlEventStateTransition` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ControlEventStateTransition` edge in the connection. */
export type ControlEventStateTransitionsEdge = {
  __typename?: 'ControlEventStateTransitionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ControlEventStateTransition` at the end of the edge. */
  node: ControlEventStateTransition;
};

/** Methods to use when ordering `ControlEventStateTransition`. */
export enum ControlEventStateTransitionsOrderBy {
  ACTOR_ASC = 'ACTOR_ASC',
  ACTOR_DESC = 'ACTOR_DESC',
  CONTROL_EVENT_ID_ASC = 'CONTROL_EVENT_ID_ASC',
  CONTROL_EVENT_ID_DESC = 'CONTROL_EVENT_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  STATE_ASC = 'STATE_ASC',
  STATE_DESC = 'STATE_DESC'
}

/** A connection to a list of `ControlEvent` values. */
export type ControlEventsConnection = {
  __typename?: 'ControlEventsConnection';
  /** A list of edges which contains the `ControlEvent` and cursor to aid in pagination. */
  edges: Array<ControlEventsEdge>;
  /** A list of `ControlEvent` objects. */
  nodes: Array<ControlEvent>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ControlEvent` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ControlEvent` edge in the connection. */
export type ControlEventsEdge = {
  __typename?: 'ControlEventsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ControlEvent` at the end of the edge. */
  node: ControlEvent;
};

/** Methods to use when ordering `ControlEvent`. */
export enum ControlEventsOrderBy {
  ACKNOWLEDGED_AT_ASC = 'ACKNOWLEDGED_AT_ASC',
  ACKNOWLEDGED_AT_DESC = 'ACKNOWLEDGED_AT_DESC',
  COMPONENT_ID_ASC = 'COMPONENT_ID_ASC',
  COMPONENT_ID_DESC = 'COMPONENT_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  END_TIME_ASC = 'END_TIME_ASC',
  END_TIME_DESC = 'END_TIME_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  REMOTE_METADATA_ASC = 'REMOTE_METADATA_ASC',
  REMOTE_METADATA_DESC = 'REMOTE_METADATA_DESC',
  START_TIME_ASC = 'START_TIME_ASC',
  START_TIME_DESC = 'START_TIME_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

export enum ControlType {
  AUTOMATIC = 'AUTOMATIC',
  MANUAL = 'MANUAL'
}

/** A filter to be used against ControlType fields. All fields are combined with a logical ‘and.’ */
export type ControlTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ControlType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ControlType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ControlType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ControlType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ControlType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ControlType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ControlType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ControlType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ControlType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ControlType>>;
};

export enum Country {
  ABW = 'ABW',
  AFG = 'AFG',
  AGO = 'AGO',
  AIA = 'AIA',
  ALA = 'ALA',
  ALB = 'ALB',
  AND = 'AND',
  ARE = 'ARE',
  ARG = 'ARG',
  ARM = 'ARM',
  ASM = 'ASM',
  ATA = 'ATA',
  ATF = 'ATF',
  ATG = 'ATG',
  AUS = 'AUS',
  AUT = 'AUT',
  AZE = 'AZE',
  BDI = 'BDI',
  BEL = 'BEL',
  BEN = 'BEN',
  BES = 'BES',
  BFA = 'BFA',
  BGD = 'BGD',
  BGR = 'BGR',
  BHR = 'BHR',
  BHS = 'BHS',
  BIH = 'BIH',
  BLM = 'BLM',
  BLR = 'BLR',
  BLZ = 'BLZ',
  BMU = 'BMU',
  BOL = 'BOL',
  BRA = 'BRA',
  BRB = 'BRB',
  BRN = 'BRN',
  BTN = 'BTN',
  BVT = 'BVT',
  BWA = 'BWA',
  CAF = 'CAF',
  CAN = 'CAN',
  CCK = 'CCK',
  CHE = 'CHE',
  CHL = 'CHL',
  CHN = 'CHN',
  CIV = 'CIV',
  CMR = 'CMR',
  COD = 'COD',
  COG = 'COG',
  COK = 'COK',
  COL = 'COL',
  COM = 'COM',
  CPV = 'CPV',
  CRI = 'CRI',
  CUB = 'CUB',
  CUW = 'CUW',
  CXR = 'CXR',
  CYM = 'CYM',
  CYP = 'CYP',
  CZE = 'CZE',
  DEU = 'DEU',
  DJI = 'DJI',
  DMA = 'DMA',
  DNK = 'DNK',
  DOM = 'DOM',
  DZA = 'DZA',
  ECU = 'ECU',
  EGY = 'EGY',
  ERI = 'ERI',
  ESH = 'ESH',
  ESP = 'ESP',
  EST = 'EST',
  ETH = 'ETH',
  FIN = 'FIN',
  FJI = 'FJI',
  FLK = 'FLK',
  FRA = 'FRA',
  FRO = 'FRO',
  FSM = 'FSM',
  GAB = 'GAB',
  GBR = 'GBR',
  GEO = 'GEO',
  GGY = 'GGY',
  GHA = 'GHA',
  GIB = 'GIB',
  GIN = 'GIN',
  GLP = 'GLP',
  GMB = 'GMB',
  GNB = 'GNB',
  GNQ = 'GNQ',
  GRC = 'GRC',
  GRD = 'GRD',
  GRL = 'GRL',
  GTM = 'GTM',
  GUF = 'GUF',
  GUM = 'GUM',
  GUY = 'GUY',
  HKG = 'HKG',
  HMD = 'HMD',
  HND = 'HND',
  HRV = 'HRV',
  HTI = 'HTI',
  HUN = 'HUN',
  IDN = 'IDN',
  IMN = 'IMN',
  IND = 'IND',
  IOT = 'IOT',
  IRL = 'IRL',
  IRN = 'IRN',
  IRQ = 'IRQ',
  ISL = 'ISL',
  ISR = 'ISR',
  ITA = 'ITA',
  JAM = 'JAM',
  JEY = 'JEY',
  JOR = 'JOR',
  JPN = 'JPN',
  KAZ = 'KAZ',
  KEN = 'KEN',
  KGZ = 'KGZ',
  KHM = 'KHM',
  KIR = 'KIR',
  KNA = 'KNA',
  KOR = 'KOR',
  KWT = 'KWT',
  LAO = 'LAO',
  LBN = 'LBN',
  LBR = 'LBR',
  LBY = 'LBY',
  LCA = 'LCA',
  LIE = 'LIE',
  LKA = 'LKA',
  LSO = 'LSO',
  LTU = 'LTU',
  LUX = 'LUX',
  LVA = 'LVA',
  MAC = 'MAC',
  MAF = 'MAF',
  MAR = 'MAR',
  MCO = 'MCO',
  MDA = 'MDA',
  MDG = 'MDG',
  MDV = 'MDV',
  MEX = 'MEX',
  MHL = 'MHL',
  MKD = 'MKD',
  MLI = 'MLI',
  MLT = 'MLT',
  MMR = 'MMR',
  MNE = 'MNE',
  MNG = 'MNG',
  MNP = 'MNP',
  MOZ = 'MOZ',
  MRT = 'MRT',
  MSR = 'MSR',
  MTQ = 'MTQ',
  MUS = 'MUS',
  MWI = 'MWI',
  MYS = 'MYS',
  MYT = 'MYT',
  NAM = 'NAM',
  NCL = 'NCL',
  NER = 'NER',
  NFK = 'NFK',
  NGA = 'NGA',
  NIC = 'NIC',
  NIU = 'NIU',
  NLD = 'NLD',
  NOR = 'NOR',
  NPL = 'NPL',
  NRU = 'NRU',
  NZL = 'NZL',
  OMN = 'OMN',
  PAK = 'PAK',
  PAN = 'PAN',
  PCN = 'PCN',
  PER = 'PER',
  PHL = 'PHL',
  PLW = 'PLW',
  PNG = 'PNG',
  POL = 'POL',
  PRI = 'PRI',
  PRK = 'PRK',
  PRT = 'PRT',
  PRY = 'PRY',
  PSE = 'PSE',
  PYF = 'PYF',
  QAT = 'QAT',
  REU = 'REU',
  ROU = 'ROU',
  RUS = 'RUS',
  RWA = 'RWA',
  SAU = 'SAU',
  SDN = 'SDN',
  SEN = 'SEN',
  SGP = 'SGP',
  SGS = 'SGS',
  SHN = 'SHN',
  SJM = 'SJM',
  SLB = 'SLB',
  SLE = 'SLE',
  SLV = 'SLV',
  SMR = 'SMR',
  SOM = 'SOM',
  SPM = 'SPM',
  SRB = 'SRB',
  SSD = 'SSD',
  STP = 'STP',
  SUR = 'SUR',
  SVK = 'SVK',
  SVN = 'SVN',
  SWE = 'SWE',
  SWZ = 'SWZ',
  SXM = 'SXM',
  SYC = 'SYC',
  SYR = 'SYR',
  TCA = 'TCA',
  TCD = 'TCD',
  TGO = 'TGO',
  THA = 'THA',
  TJK = 'TJK',
  TKL = 'TKL',
  TKM = 'TKM',
  TLS = 'TLS',
  TON = 'TON',
  TTO = 'TTO',
  TUN = 'TUN',
  TUR = 'TUR',
  TUV = 'TUV',
  TZA = 'TZA',
  UGA = 'UGA',
  UKR = 'UKR',
  UMI = 'UMI',
  URY = 'URY',
  USA = 'USA',
  UZB = 'UZB',
  VAT = 'VAT',
  VCT = 'VCT',
  VEN = 'VEN',
  VGB = 'VGB',
  VIR = 'VIR',
  VNM = 'VNM',
  VUT = 'VUT',
  WLF = 'WLF',
  WSM = 'WSM',
  YEM = 'YEM',
  ZAF = 'ZAF',
  ZMB = 'ZMB',
  ZWE = 'ZWE'
}

/** A filter to be used against Country fields. All fields are combined with a logical ‘and.’ */
export type CountryFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Country>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Country>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Country>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Country>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Country>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Country>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Country>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Country>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Country>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Country>>;
};

export type CreateAccessTokenPayload = {
  accessKey: Scalars['String'];
  clientMutationId?: Maybe<Scalars['String']>;
  token: PlatformAccessToken;
};

/** All input for the create `AccountCharge` mutation. */
export type CreateAccountChargeInput = {
  /** The `AccountCharge` to be created by this mutation. */
  accountCharge: AccountChargeInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `AccountCharge` mutation. */
export type CreateAccountChargePayload = {
  __typename?: 'CreateAccountChargePayload';
  /** The `AccountCharge` that was created by this mutation. */
  accountCharge?: Maybe<AccountCharge>;
  /** An edge for our `AccountCharge`. May be used by Relay 1. */
  accountChargeEdge?: Maybe<AccountChargesEdge>;
  /** Reads a single `AccountStatement` that is related to this `AccountCharge`. */
  accountStatement?: Maybe<AccountStatement>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `AccountCharge` mutation. */
export type CreateAccountChargePayloadAccountChargeEdgeArgs = {
  orderBy?: InputMaybe<Array<AccountChargesOrderBy>>;
};

/** All input for the create `AccountStatementHistory` mutation. */
export type CreateAccountStatementHistoryInput = {
  /** The `AccountStatementHistory` to be created by this mutation. */
  accountStatementHistory: AccountStatementHistoryInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `AccountStatementHistory` mutation. */
export type CreateAccountStatementHistoryPayload = {
  __typename?: 'CreateAccountStatementHistoryPayload';
  /** Reads a single `AccountStatement` that is related to this `AccountStatementHistory`. */
  accountStatement?: Maybe<AccountStatement>;
  /** The `AccountStatementHistory` that was created by this mutation. */
  accountStatementHistory?: Maybe<AccountStatementHistory>;
  /** An edge for our `AccountStatementHistory`. May be used by Relay 1. */
  accountStatementHistoryEdge?: Maybe<AccountStatementHistoriesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `AccountStatementHistory` mutation. */
export type CreateAccountStatementHistoryPayloadAccountStatementHistoryEdgeArgs =
  {
    orderBy?: InputMaybe<Array<AccountStatementHistoriesOrderBy>>;
  };

/** All input for the create `AccountStatement` mutation. */
export type CreateAccountStatementInput = {
  /** The `AccountStatement` to be created by this mutation. */
  accountStatement: AccountStatementInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `AccountStatement` mutation. */
export type CreateAccountStatementPayload = {
  __typename?: 'CreateAccountStatementPayload';
  /** The `AccountStatement` that was created by this mutation. */
  accountStatement?: Maybe<AccountStatement>;
  /** An edge for our `AccountStatement`. May be used by Relay 1. */
  accountStatementEdge?: Maybe<AccountStatementsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UtilityAccount` that is related to this `AccountStatement`. */
  utilityAccount?: Maybe<UtilityAccount>;
};

/** The output of our create `AccountStatement` mutation. */
export type CreateAccountStatementPayloadAccountStatementEdgeArgs = {
  orderBy?: InputMaybe<Array<AccountStatementsOrderBy>>;
};

/** All input for the create `AccountStatementPdf` mutation. */
export type CreateAccountStatementPdfInput = {
  /** The `AccountStatementPdf` to be created by this mutation. */
  accountStatementPdf: AccountStatementPdfInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `AccountStatementPdf` mutation. */
export type CreateAccountStatementPdfPayload = {
  __typename?: 'CreateAccountStatementPdfPayload';
  /** Reads a single `AccountStatement` that is related to this `AccountStatementPdf`. */
  accountStatement?: Maybe<AccountStatement>;
  /** The `AccountStatementPdf` that was created by this mutation. */
  accountStatementPdf?: Maybe<AccountStatementPdf>;
  /** An edge for our `AccountStatementPdf`. May be used by Relay 1. */
  accountStatementPdfEdge?: Maybe<AccountStatementPdfsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `AccountStatementPdf` mutation. */
export type CreateAccountStatementPdfPayloadAccountStatementPdfEdgeArgs = {
  orderBy?: InputMaybe<Array<AccountStatementPdfsOrderBy>>;
};

/** All input for the create `BalancingAuthority` mutation. */
export type CreateBalancingAuthorityInput = {
  /** The `BalancingAuthority` to be created by this mutation. */
  balancingAuthority: BalancingAuthorityInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `BalancingAuthority` mutation. */
export type CreateBalancingAuthorityPayload = {
  __typename?: 'CreateBalancingAuthorityPayload';
  /** The `BalancingAuthority` that was created by this mutation. */
  balancingAuthority?: Maybe<BalancingAuthority>;
  /** An edge for our `BalancingAuthority`. May be used by Relay 1. */
  balancingAuthorityEdge?: Maybe<BalancingAuthoritiesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BalancingAuthority` mutation. */
export type CreateBalancingAuthorityPayloadBalancingAuthorityEdgeArgs = {
  orderBy?: InputMaybe<Array<BalancingAuthoritiesOrderBy>>;
};

/** All input for the create `BlastEvaporator` mutation. */
export type CreateBlastEvaporatorInput = {
  /** The `BlastEvaporator` to be created by this mutation. */
  blastEvaporator: BlastEvaporatorInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `BlastEvaporator` mutation. */
export type CreateBlastEvaporatorPayload = {
  __typename?: 'CreateBlastEvaporatorPayload';
  /** Reads a single `Blast` that is related to this `BlastEvaporator`. */
  blast?: Maybe<Blast>;
  /** The `BlastEvaporator` that was created by this mutation. */
  blastEvaporator?: Maybe<BlastEvaporator>;
  /** An edge for our `BlastEvaporator`. May be used by Relay 1. */
  blastEvaporatorEdge?: Maybe<BlastEvaporatorsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Evaporator` that is related to this `BlastEvaporator`. */
  evaporator?: Maybe<Evaporator>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BlastEvaporator` mutation. */
export type CreateBlastEvaporatorPayloadBlastEvaporatorEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastEvaporatorsOrderBy>>;
};

/** All input for the create `Blast` mutation. */
export type CreateBlastInput = {
  /** The `Blast` to be created by this mutation. */
  blast: BlastInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** All input for the create `BlastPallet` mutation. */
export type CreateBlastPalletInput = {
  /** The `BlastPallet` to be created by this mutation. */
  blastPallet: BlastPalletInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** All input for the create `BlastPalletLocation` mutation. */
export type CreateBlastPalletLocationInput = {
  /** The `BlastPalletLocation` to be created by this mutation. */
  blastPalletLocation: BlastPalletLocationInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `BlastPalletLocation` mutation. */
export type CreateBlastPalletLocationPayload = {
  __typename?: 'CreateBlastPalletLocationPayload';
  /** Reads a single `Blast` that is related to this `BlastPalletLocation`. */
  blast?: Maybe<Blast>;
  /** The `BlastPalletLocation` that was created by this mutation. */
  blastPalletLocation?: Maybe<BlastPalletLocation>;
  /** An edge for our `BlastPalletLocation`. May be used by Relay 1. */
  blastPalletLocationEdge?: Maybe<BlastPalletLocationsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `PalletLocation` that is related to this `BlastPalletLocation`. */
  palletLocation?: Maybe<PalletLocation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BlastPalletLocation` mutation. */
export type CreateBlastPalletLocationPayloadBlastPalletLocationEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastPalletLocationsOrderBy>>;
};

/** The output of our create `BlastPallet` mutation. */
export type CreateBlastPalletPayload = {
  __typename?: 'CreateBlastPalletPayload';
  /** Reads a single `Blast` that is related to this `BlastPallet`. */
  blast?: Maybe<Blast>;
  /** The `BlastPallet` that was created by this mutation. */
  blastPallet?: Maybe<BlastPallet>;
  /** An edge for our `BlastPallet`. May be used by Relay 1. */
  blastPalletEdge?: Maybe<BlastPalletsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Pallet` that is related to this `BlastPallet`. */
  pallet?: Maybe<Pallet>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BlastPallet` mutation. */
export type CreateBlastPalletPayloadBlastPalletEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastPalletsOrderBy>>;
};

/** The output of our create `Blast` mutation. */
export type CreateBlastPayload = {
  __typename?: 'CreateBlastPayload';
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  actualUtilization?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  automationState?: Maybe<DataPoint>;
  /** The `Blast` that was created by this mutation. */
  blast?: Maybe<Blast>;
  /** An edge for our `Blast`. May be used by Relay 1. */
  blastEdge?: Maybe<BlastsEdge>;
  /** Reads a single `BlastType` that is related to this `Blast`. */
  blastType?: Maybe<BlastType>;
  /** Reads a single `BuildingArea` that is related to this `Blast`. */
  buildingArea?: Maybe<BuildingArea>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Component` that is related to this `Blast`. */
  component?: Maybe<Component>;
  /** Reads a single `Facility` that is related to this `Blast`. */
  facility?: Maybe<Facility>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  idealUtilization?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  stagingTimer?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  state?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  timer?: Maybe<DataPoint>;
};

/** The output of our create `Blast` mutation. */
export type CreateBlastPayloadBlastEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastsOrderBy>>;
};

/** All input for the create `BlastRotationAlert` mutation. */
export type CreateBlastRotationAlertInput = {
  /** The `BlastRotationAlert` to be created by this mutation. */
  blastRotationAlert: BlastRotationAlertInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `BlastRotationAlert` mutation. */
export type CreateBlastRotationAlertPayload = {
  __typename?: 'CreateBlastRotationAlertPayload';
  /** Reads a single `BlastRotation` that is related to this `BlastRotationAlert`. */
  blastRotation?: Maybe<BlastRotation>;
  /** The `BlastRotationAlert` that was created by this mutation. */
  blastRotationAlert?: Maybe<BlastRotationAlert>;
  /** An edge for our `BlastRotationAlert`. May be used by Relay 1. */
  blastRotationAlertEdge?: Maybe<BlastRotationAlertsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BlastRotationAlert` mutation. */
export type CreateBlastRotationAlertPayloadBlastRotationAlertEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastRotationAlertsOrderBy>>;
};

/** All input for the create `BlastRotationEventLog` mutation. */
export type CreateBlastRotationEventLogInput = {
  /** The `BlastRotationEventLog` to be created by this mutation. */
  blastRotationEventLog: BlastRotationEventLogInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `BlastRotationEventLog` mutation. */
export type CreateBlastRotationEventLogPayload = {
  __typename?: 'CreateBlastRotationEventLogPayload';
  /** Reads a single `BlastRotation` that is related to this `BlastRotationEventLog`. */
  blastRotation?: Maybe<BlastRotation>;
  /** The `BlastRotationEventLog` that was created by this mutation. */
  blastRotationEventLog?: Maybe<BlastRotationEventLog>;
  /** An edge for our `BlastRotationEventLog`. May be used by Relay 1. */
  blastRotationEventLogEdge?: Maybe<BlastRotationEventLogsEdge>;
  /** Reads a single `BlastRotationEventType` that is related to this `BlastRotationEventLog`. */
  blastRotationEventType?: Maybe<BlastRotationEventType>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BlastRotationEventLog` mutation. */
export type CreateBlastRotationEventLogPayloadBlastRotationEventLogEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastRotationEventLogsOrderBy>>;
};

/** All input for the create `BlastRotationEventType` mutation. */
export type CreateBlastRotationEventTypeInput = {
  /** The `BlastRotationEventType` to be created by this mutation. */
  blastRotationEventType: BlastRotationEventTypeInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `BlastRotationEventType` mutation. */
export type CreateBlastRotationEventTypePayload = {
  __typename?: 'CreateBlastRotationEventTypePayload';
  /** The `BlastRotationEventType` that was created by this mutation. */
  blastRotationEventType?: Maybe<BlastRotationEventType>;
  /** An edge for our `BlastRotationEventType`. May be used by Relay 1. */
  blastRotationEventTypeEdge?: Maybe<BlastRotationEventTypesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BlastRotationEventType` mutation. */
export type CreateBlastRotationEventTypePayloadBlastRotationEventTypeEdgeArgs =
  {
    orderBy?: InputMaybe<Array<BlastRotationEventTypesOrderBy>>;
  };

/** All input for the create `BlastRotation` mutation. */
export type CreateBlastRotationInput = {
  /** The `BlastRotation` to be created by this mutation. */
  blastRotation: BlastRotationInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** All input for the create `BlastRotationPallet` mutation. */
export type CreateBlastRotationPalletInput = {
  /** The `BlastRotationPallet` to be created by this mutation. */
  blastRotationPallet: BlastRotationPalletInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `BlastRotationPallet` mutation. */
export type CreateBlastRotationPalletPayload = {
  __typename?: 'CreateBlastRotationPalletPayload';
  /** Reads a single `BlastRotation` that is related to this `BlastRotationPallet`. */
  blastRotation?: Maybe<BlastRotation>;
  /** The `BlastRotationPallet` that was created by this mutation. */
  blastRotationPallet?: Maybe<BlastRotationPallet>;
  /** An edge for our `BlastRotationPallet`. May be used by Relay 1. */
  blastRotationPalletEdge?: Maybe<BlastRotationPalletsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Pallet` that is related to this `BlastRotationPallet`. */
  pallet?: Maybe<Pallet>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BlastRotationPallet` mutation. */
export type CreateBlastRotationPalletPayloadBlastRotationPalletEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastRotationPalletsOrderBy>>;
};

/** The output of our create `BlastRotation` mutation. */
export type CreateBlastRotationPayload = {
  __typename?: 'CreateBlastRotationPayload';
  /** Reads a single `Blast` that is related to this `BlastRotation`. */
  blast?: Maybe<Blast>;
  /** The `BlastRotation` that was created by this mutation. */
  blastRotation?: Maybe<BlastRotation>;
  /** An edge for our `BlastRotation`. May be used by Relay 1. */
  blastRotationEdge?: Maybe<BlastRotationsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BlastRotation` mutation. */
export type CreateBlastRotationPayloadBlastRotationEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastRotationsOrderBy>>;
};

/** All input for the create `BlastType` mutation. */
export type CreateBlastTypeInput = {
  /** The `BlastType` to be created by this mutation. */
  blastType: BlastTypeInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `BlastType` mutation. */
export type CreateBlastTypePayload = {
  __typename?: 'CreateBlastTypePayload';
  /** The `BlastType` that was created by this mutation. */
  blastType?: Maybe<BlastType>;
  /** An edge for our `BlastType`. May be used by Relay 1. */
  blastTypeEdge?: Maybe<BlastTypesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BlastType` mutation. */
export type CreateBlastTypePayloadBlastTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastTypesOrderBy>>;
};

/** All input for the create `BuildingAreaComplianceGroup` mutation. */
export type CreateBuildingAreaComplianceGroupInput = {
  /** The `BuildingAreaComplianceGroup` to be created by this mutation. */
  buildingAreaComplianceGroup: BuildingAreaComplianceGroupInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `BuildingAreaComplianceGroup` mutation. */
export type CreateBuildingAreaComplianceGroupPayload = {
  __typename?: 'CreateBuildingAreaComplianceGroupPayload';
  /** Reads a single `BuildingArea` that is related to this `BuildingAreaComplianceGroup`. */
  buildingArea?: Maybe<BuildingArea>;
  /** The `BuildingAreaComplianceGroup` that was created by this mutation. */
  buildingAreaComplianceGroup?: Maybe<BuildingAreaComplianceGroup>;
  /** An edge for our `BuildingAreaComplianceGroup`. May be used by Relay 1. */
  buildingAreaComplianceGroupEdge?: Maybe<BuildingAreaComplianceGroupsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `ComplianceGroup` that is related to this `BuildingAreaComplianceGroup`. */
  complianceGroup?: Maybe<ComplianceGroup>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BuildingAreaComplianceGroup` mutation. */
export type CreateBuildingAreaComplianceGroupPayloadBuildingAreaComplianceGroupEdgeArgs =
  {
    orderBy?: InputMaybe<Array<BuildingAreaComplianceGroupsOrderBy>>;
  };

/** All input for the create `BuildingArea` mutation. */
export type CreateBuildingAreaInput = {
  /** The `BuildingArea` to be created by this mutation. */
  buildingArea: BuildingAreaInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `BuildingArea` mutation. */
export type CreateBuildingAreaPayload = {
  __typename?: 'CreateBuildingAreaPayload';
  /** The `BuildingArea` that was created by this mutation. */
  buildingArea?: Maybe<BuildingArea>;
  /** An edge for our `BuildingArea`. May be used by Relay 1. */
  buildingAreaEdge?: Maybe<BuildingAreasEdge>;
  /** Reads a single `BuildingAreaType` that is related to this `BuildingArea`. */
  buildingAreaType?: Maybe<BuildingAreaType>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Facility` that is related to this `BuildingArea`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BuildingArea` mutation. */
export type CreateBuildingAreaPayloadBuildingAreaEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingAreasOrderBy>>;
};

/** All input for the create `BuildingAreaType` mutation. */
export type CreateBuildingAreaTypeInput = {
  /** The `BuildingAreaType` to be created by this mutation. */
  buildingAreaType: BuildingAreaTypeInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `BuildingAreaType` mutation. */
export type CreateBuildingAreaTypePayload = {
  __typename?: 'CreateBuildingAreaTypePayload';
  /** The `BuildingAreaType` that was created by this mutation. */
  buildingAreaType?: Maybe<BuildingAreaType>;
  /** An edge for our `BuildingAreaType`. May be used by Relay 1. */
  buildingAreaTypeEdge?: Maybe<BuildingAreaTypesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BuildingAreaType` mutation. */
export type CreateBuildingAreaTypePayloadBuildingAreaTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingAreaTypesOrderBy>>;
};

/** All input for the create `Chart` mutation. */
export type CreateChartInput = {
  /** The `Chart` to be created by this mutation. */
  chart: ChartInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `Chart` mutation. */
export type CreateChartPayload = {
  __typename?: 'CreateChartPayload';
  /** The `Chart` that was created by this mutation. */
  chart?: Maybe<Chart>;
  /** An edge for our `Chart`. May be used by Relay 1. */
  chartEdge?: Maybe<ChartsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Facility` that is related to this `Chart`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `Chart` mutation. */
export type CreateChartPayloadChartEdgeArgs = {
  orderBy?: InputMaybe<Array<ChartsOrderBy>>;
};

/** All input for the create `ComplianceGroup` mutation. */
export type CreateComplianceGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ComplianceGroup` to be created by this mutation. */
  complianceGroup: ComplianceGroupInput;
};

/** The output of our create `ComplianceGroup` mutation. */
export type CreateComplianceGroupPayload = {
  __typename?: 'CreateComplianceGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ComplianceGroup` that was created by this mutation. */
  complianceGroup?: Maybe<ComplianceGroup>;
  /** An edge for our `ComplianceGroup`. May be used by Relay 1. */
  complianceGroupEdge?: Maybe<ComplianceGroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `ComplianceGroup` mutation. */
export type CreateComplianceGroupPayloadComplianceGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<ComplianceGroupsOrderBy>>;
};

/** All input for the create `ComplianceRange` mutation. */
export type CreateComplianceRangeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ComplianceRange` to be created by this mutation. */
  complianceRange: ComplianceRangeInput;
};

/** The output of our create `ComplianceRange` mutation. */
export type CreateComplianceRangePayload = {
  __typename?: 'CreateComplianceRangePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `ComplianceGroup` that is related to this `ComplianceRange`. */
  complianceGroup?: Maybe<ComplianceGroup>;
  /** The `ComplianceRange` that was created by this mutation. */
  complianceRange?: Maybe<ComplianceRange>;
  /** An edge for our `ComplianceRange`. May be used by Relay 1. */
  complianceRangeEdge?: Maybe<ComplianceRangesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `ComplianceRange` mutation. */
export type CreateComplianceRangePayloadComplianceRangeEdgeArgs = {
  orderBy?: InputMaybe<Array<ComplianceRangesOrderBy>>;
};

/** All input for the create `Component` mutation. */
export type CreateComponentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Component` to be created by this mutation. */
  component: ComponentInput;
};

/** The output of our create `Component` mutation. */
export type CreateComponentPayload = {
  __typename?: 'CreateComponentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Component` that was created by this mutation. */
  component?: Maybe<Component>;
  /** An edge for our `Component`. May be used by Relay 1. */
  componentEdge?: Maybe<ComponentsEdge>;
  /** Reads a single `Facility` that is related to this `Component`. */
  facility?: Maybe<Facility>;
  /** Reads a single `MachineUser` that is related to this `Component`. */
  machineUser?: Maybe<MachineUser>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `Component` mutation. */
export type CreateComponentPayloadComponentEdgeArgs = {
  orderBy?: InputMaybe<Array<ComponentsOrderBy>>;
};

/** All input for the create `Compressor` mutation. */
export type CreateCompressorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Compressor` to be created by this mutation. */
  compressor: CompressorInput;
};

/** The output of our create `Compressor` mutation. */
export type CreateCompressorPayload = {
  __typename?: 'CreateCompressorPayload';
  /** Reads a single `BuildingArea` that is related to this `Compressor`. */
  buildingArea?: Maybe<BuildingArea>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  capacity?: Maybe<DataPoint>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Compressor` that was created by this mutation. */
  compressor?: Maybe<Compressor>;
  /** An edge for our `Compressor`. May be used by Relay 1. */
  compressorEdge?: Maybe<CompressorsEdge>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  controlMode?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  differentialPressure?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  dischargePressure?: Maybe<DataPoint>;
  /** Reads a single `Facility` that is related to this `Compressor`. */
  facility?: Maybe<Facility>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  kwDemand?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  motorAmps?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  motorState?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  oilPressure?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  oilTemperature?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  runtimeHours?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  setpoint?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  slideValvePosition?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  state?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  suctionPressure?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  suctionTemperature?: Maybe<DataPoint>;
};

/** The output of our create `Compressor` mutation. */
export type CreateCompressorPayloadCompressorEdgeArgs = {
  orderBy?: InputMaybe<Array<CompressorsOrderBy>>;
};

/** All input for the create `ControlEvent` mutation. */
export type CreateControlEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ControlEvent` to be created by this mutation. */
  controlEvent: ControlEventInput;
};

/** All input for the create `ControlEventLog` mutation. */
export type CreateControlEventLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ControlEventLog` to be created by this mutation. */
  controlEventLog: ControlEventLogInput;
};

/** The output of our create `ControlEventLog` mutation. */
export type CreateControlEventLogPayload = {
  __typename?: 'CreateControlEventLogPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `ControlEvent` that is related to this `ControlEventLog`. */
  controlEvent?: Maybe<ControlEvent>;
  /** The `ControlEventLog` that was created by this mutation. */
  controlEventLog?: Maybe<ControlEventLog>;
  /** An edge for our `ControlEventLog`. May be used by Relay 1. */
  controlEventLogEdge?: Maybe<ControlEventLogsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `ControlEventLog` mutation. */
export type CreateControlEventLogPayloadControlEventLogEdgeArgs = {
  orderBy?: InputMaybe<Array<ControlEventLogsOrderBy>>;
};

/** The output of our create `ControlEvent` mutation. */
export type CreateControlEventPayload = {
  __typename?: 'CreateControlEventPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Component` that is related to this `ControlEvent`. */
  component?: Maybe<Component>;
  /** The `ControlEvent` that was created by this mutation. */
  controlEvent?: Maybe<ControlEvent>;
  /** An edge for our `ControlEvent`. May be used by Relay 1. */
  controlEventEdge?: Maybe<ControlEventsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `ControlEvent` mutation. */
export type CreateControlEventPayloadControlEventEdgeArgs = {
  orderBy?: InputMaybe<Array<ControlEventsOrderBy>>;
};

/** All input for the create `Customer` mutation. */
export type CreateCustomerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Customer` to be created by this mutation. */
  customer: CustomerInput;
};

/** The output of our create `Customer` mutation. */
export type CreateCustomerPayload = {
  __typename?: 'CreateCustomerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Customer` that was created by this mutation. */
  customer?: Maybe<Customer>;
  /** An edge for our `Customer`. May be used by Relay 1. */
  customerEdge?: Maybe<CustomersEdge>;
  /** Reads a single `Facility` that is related to this `Customer`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `Customer` mutation. */
export type CreateCustomerPayloadCustomerEdgeArgs = {
  orderBy?: InputMaybe<Array<CustomersOrderBy>>;
};

/** All input for the create `Dashboard` mutation. */
export type CreateDashboardInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Dashboard` to be created by this mutation. */
  dashboard: DashboardInput;
};

/** The output of our create `Dashboard` mutation. */
export type CreateDashboardPayload = {
  __typename?: 'CreateDashboardPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Dashboard` that was created by this mutation. */
  dashboard?: Maybe<Dashboard>;
  /** An edge for our `Dashboard`. May be used by Relay 1. */
  dashboardEdge?: Maybe<DashboardsEdge>;
  /** Reads a single `Facility` that is related to this `Dashboard`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `Dashboard` mutation. */
export type CreateDashboardPayloadDashboardEdgeArgs = {
  orderBy?: InputMaybe<Array<DashboardsOrderBy>>;
};

/** All input for the create `DataPoint` mutation. */
export type CreateDataPointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `DataPoint` to be created by this mutation. */
  dataPoint: DataPointInput;
};

/** The output of our create `DataPoint` mutation. */
export type CreateDataPointPayload = {
  __typename?: 'CreateDataPointPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `DataPoint` that was created by this mutation. */
  dataPoint?: Maybe<DataPoint>;
  /** An edge for our `DataPoint`. May be used by Relay 1. */
  dataPointEdge?: Maybe<DataPointsEdge>;
  /** Reads a single `DataSource` that is related to this `DataPoint`. */
  dataSourceByDataSourceName?: Maybe<DataSource>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `DataPoint` mutation. */
export type CreateDataPointPayloadDataPointEdgeArgs = {
  orderBy?: InputMaybe<Array<DataPointsOrderBy>>;
};

/** All input for the create `DataPointTag` mutation. */
export type CreateDataPointTagInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `DataPointTag` to be created by this mutation. */
  dataPointTag: DataPointTagInput;
};

/** The output of our create `DataPointTag` mutation. */
export type CreateDataPointTagPayload = {
  __typename?: 'CreateDataPointTagPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `DataPointTag` that was created by this mutation. */
  dataPointTag?: Maybe<DataPointTag>;
  /** An edge for our `DataPointTag`. May be used by Relay 1. */
  dataPointTagEdge?: Maybe<DataPointTagsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `DataPointTag` mutation. */
export type CreateDataPointTagPayloadDataPointTagEdgeArgs = {
  orderBy?: InputMaybe<Array<DataPointTagsOrderBy>>;
};

/** All input for the create `DataSource` mutation. */
export type CreateDataSourceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `DataSource` to be created by this mutation. */
  dataSource: DataSourceInput;
};

/** The output of our create `DataSource` mutation. */
export type CreateDataSourcePayload = {
  __typename?: 'CreateDataSourcePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `DataSource` that was created by this mutation. */
  dataSource?: Maybe<DataSource>;
  /** An edge for our `DataSource`. May be used by Relay 1. */
  dataSourceEdge?: Maybe<DataSourcesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `DataSource` mutation. */
export type CreateDataSourcePayloadDataSourceEdgeArgs = {
  orderBy?: InputMaybe<Array<DataSourcesOrderBy>>;
};

/** All input for the create `Dependency` mutation. */
export type CreateDependencyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Dependency` to be created by this mutation. */
  dependency: DependencyInput;
};

/** The output of our create `Dependency` mutation. */
export type CreateDependencyPayload = {
  __typename?: 'CreateDependencyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Dependency` that was created by this mutation. */
  dependency?: Maybe<Dependency>;
  /** An edge for our `Dependency`. May be used by Relay 1. */
  dependencyEdge?: Maybe<DependenciesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `Dependency` mutation. */
export type CreateDependencyPayloadDependencyEdgeArgs = {
  orderBy?: InputMaybe<Array<DependenciesOrderBy>>;
};

/** All input for the create `Door` mutation. */
export type CreateDoorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Door` to be created by this mutation. */
  door: DoorInput;
};

/** The output of our create `Door` mutation. */
export type CreateDoorPayload = {
  __typename?: 'CreateDoorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Door` that was created by this mutation. */
  door?: Maybe<Door>;
  /** An edge for our `Door`. May be used by Relay 1. */
  doorEdge?: Maybe<DoorsEdge>;
  /** Reads a single `DataPoint` that is related to this `Door`. */
  doorState?: Maybe<DataPoint>;
  /** Reads a single `Facility` that is related to this `Door`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `Door` mutation. */
export type CreateDoorPayloadDoorEdgeArgs = {
  orderBy?: InputMaybe<Array<DoorsOrderBy>>;
};

/** All input for the create `Evaporator` mutation. */
export type CreateEvaporatorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Evaporator` to be created by this mutation. */
  evaporator: EvaporatorInput;
};

/** The output of our create `Evaporator` mutation. */
export type CreateEvaporatorPayload = {
  __typename?: 'CreateEvaporatorPayload';
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  ammoniaState?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  bleedSolenoid?: Maybe<DataPoint>;
  /** Reads a single `BuildingArea` that is related to this `Evaporator`. */
  buildingArea?: Maybe<BuildingArea>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  defrostState?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  defrostTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  defrostTimer?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  differentialAirTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  estimatedKwDemand?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  evapState?: Maybe<DataPoint>;
  /** The `Evaporator` that was created by this mutation. */
  evaporator?: Maybe<Evaporator>;
  /** An edge for our `Evaporator`. May be used by Relay 1. */
  evaporatorEdge?: Maybe<EvaporatorsEdge>;
  /** Reads a single `Facility` that is related to this `Evaporator`. */
  facility?: Maybe<Facility>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  fanState?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  fanTimer?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  hotGasSolenoid?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  liquidFeedRuntime?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  liquidFeedRuntimeSetpoint?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  liquidSolenoid?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  returnAirTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  setpoint?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  softHotGasSolenoid?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  suctionSolenoid?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  suctionTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  supplyAirTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  zoneTemperature?: Maybe<DataPoint>;
};

/** The output of our create `Evaporator` mutation. */
export type CreateEvaporatorPayloadEvaporatorEdgeArgs = {
  orderBy?: InputMaybe<Array<EvaporatorsOrderBy>>;
};

/** All input for the create `FacilityCommunication` mutation. */
export type CreateFacilityCommunicationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `FacilityCommunication` to be created by this mutation. */
  facilityCommunication: FacilityCommunicationInput;
};

/** The output of our create `FacilityCommunication` mutation. */
export type CreateFacilityCommunicationPayload = {
  __typename?: 'CreateFacilityCommunicationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Facility` that is related to this `FacilityCommunication`. */
  facility?: Maybe<Facility>;
  /** The `FacilityCommunication` that was created by this mutation. */
  facilityCommunication?: Maybe<FacilityCommunication>;
  /** An edge for our `FacilityCommunication`. May be used by Relay 1. */
  facilityCommunicationEdge?: Maybe<FacilityCommunicationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `FacilityCommunication` mutation. */
export type CreateFacilityCommunicationPayloadFacilityCommunicationEdgeArgs = {
  orderBy?: InputMaybe<Array<FacilityCommunicationsOrderBy>>;
};

/** All input for the create `FacilityDataSource` mutation. */
export type CreateFacilityDataSourceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `FacilityDataSource` to be created by this mutation. */
  facilityDataSource: FacilityDataSourceInput;
};

/** The output of our create `FacilityDataSource` mutation. */
export type CreateFacilityDataSourcePayload = {
  __typename?: 'CreateFacilityDataSourcePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `DataSource` that is related to this `FacilityDataSource`. */
  dataSourceByDataSourceName?: Maybe<DataSource>;
  /** Reads a single `Facility` that is related to this `FacilityDataSource`. */
  facility?: Maybe<Facility>;
  /** The `FacilityDataSource` that was created by this mutation. */
  facilityDataSource?: Maybe<FacilityDataSource>;
  /** An edge for our `FacilityDataSource`. May be used by Relay 1. */
  facilityDataSourceEdge?: Maybe<FacilityDataSourcesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `FacilityDataSource` mutation. */
export type CreateFacilityDataSourcePayloadFacilityDataSourceEdgeArgs = {
  orderBy?: InputMaybe<Array<FacilityDataSourcesOrderBy>>;
};

/** All input for the create `FacilityGroup` mutation. */
export type CreateFacilityGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `FacilityGroup` to be created by this mutation. */
  facilityGroup: FacilityGroupInput;
};

/** The output of our create `FacilityGroup` mutation. */
export type CreateFacilityGroupPayload = {
  __typename?: 'CreateFacilityGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `FacilityGroup` that was created by this mutation. */
  facilityGroup?: Maybe<FacilityGroup>;
  /** An edge for our `FacilityGroup`. May be used by Relay 1. */
  facilityGroupEdge?: Maybe<FacilityGroupsEdge>;
  /** Reads a single `FacilityGroup` that is related to this `FacilityGroup`. */
  parent?: Maybe<FacilityGroup>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `FacilityGroup` mutation. */
export type CreateFacilityGroupPayloadFacilityGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<FacilityGroupsOrderBy>>;
};

/** All input for the create `FacilityGroupsLinker` mutation. */
export type CreateFacilityGroupsLinkerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `FacilityGroupsLinker` to be created by this mutation. */
  facilityGroupsLinker: FacilityGroupsLinkerInput;
};

/** The output of our create `FacilityGroupsLinker` mutation. */
export type CreateFacilityGroupsLinkerPayload = {
  __typename?: 'CreateFacilityGroupsLinkerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Facility` that is related to this `FacilityGroupsLinker`. */
  facility?: Maybe<Facility>;
  /** Reads a single `FacilityGroup` that is related to this `FacilityGroupsLinker`. */
  facilityGrouping?: Maybe<FacilityGroup>;
  /** The `FacilityGroupsLinker` that was created by this mutation. */
  facilityGroupsLinker?: Maybe<FacilityGroupsLinker>;
  /** An edge for our `FacilityGroupsLinker`. May be used by Relay 1. */
  facilityGroupsLinkerEdge?: Maybe<FacilityGroupsLinkersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `FacilityGroupsLinker` mutation. */
export type CreateFacilityGroupsLinkerPayloadFacilityGroupsLinkerEdgeArgs = {
  orderBy?: InputMaybe<Array<FacilityGroupsLinkersOrderBy>>;
};

/** All input for the create `Facility` mutation. */
export type CreateFacilityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Facility` to be created by this mutation. */
  facility: FacilityInput;
};

/** The output of our create `Facility` mutation. */
export type CreateFacilityPayload = {
  __typename?: 'CreateFacilityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Facility` that was created by this mutation. */
  facility?: Maybe<Facility>;
  /** An edge for our `Facility`. May be used by Relay 1. */
  facilityEdge?: Maybe<FacilitiesEdge>;
  /** Reads a single `PricingNode` that is related to this `Facility`. */
  pricingNode?: Maybe<PricingNode>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Timezone` that is related to this `Facility`. */
  timezone?: Maybe<Timezone>;
  /** Reads a single `UnitGroup` that is related to this `Facility`. */
  unitGroupByUnitGroup?: Maybe<UnitGroup>;
};

/** The output of our create `Facility` mutation. */
export type CreateFacilityPayloadFacilityEdgeArgs = {
  orderBy?: InputMaybe<Array<FacilitiesOrderBy>>;
};

/** All input for the create `FacilityTaggedDataPoint` mutation. */
export type CreateFacilityTaggedDataPointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `FacilityTaggedDataPoint` to be created by this mutation. */
  facilityTaggedDataPoint: FacilityTaggedDataPointInput;
};

/** The output of our create `FacilityTaggedDataPoint` mutation. */
export type CreateFacilityTaggedDataPointPayload = {
  __typename?: 'CreateFacilityTaggedDataPointPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `DataPoint` that is related to this `FacilityTaggedDataPoint`. */
  dataPoint?: Maybe<DataPoint>;
  /** Reads a single `Facility` that is related to this `FacilityTaggedDataPoint`. */
  facility?: Maybe<Facility>;
  /** The `FacilityTaggedDataPoint` that was created by this mutation. */
  facilityTaggedDataPoint?: Maybe<FacilityTaggedDataPoint>;
  /** An edge for our `FacilityTaggedDataPoint`. May be used by Relay 1. */
  facilityTaggedDataPointEdge?: Maybe<FacilityTaggedDataPointsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPointTag` that is related to this `FacilityTaggedDataPoint`. */
  tag?: Maybe<DataPointTag>;
};

/** The output of our create `FacilityTaggedDataPoint` mutation. */
export type CreateFacilityTaggedDataPointPayloadFacilityTaggedDataPointEdgeArgs =
  {
    orderBy?: InputMaybe<Array<FacilityTaggedDataPointsOrderBy>>;
  };

/** All input for the create `InboundOutboundLoad` mutation. */
export type CreateInboundOutboundLoadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `InboundOutboundLoad` to be created by this mutation. */
  inboundOutboundLoad: InboundOutboundLoadInput;
};

/** The output of our create `InboundOutboundLoad` mutation. */
export type CreateInboundOutboundLoadPayload = {
  __typename?: 'CreateInboundOutboundLoadPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Facility` that is related to this `InboundOutboundLoad`. */
  facility?: Maybe<Facility>;
  /** The `InboundOutboundLoad` that was created by this mutation. */
  inboundOutboundLoad?: Maybe<InboundOutboundLoad>;
  /** An edge for our `InboundOutboundLoad`. May be used by Relay 1. */
  inboundOutboundLoadEdge?: Maybe<InboundOutboundLoadsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `InboundOutboundLoad` mutation. */
export type CreateInboundOutboundLoadPayloadInboundOutboundLoadEdgeArgs = {
  orderBy?: InputMaybe<Array<InboundOutboundLoadsOrderBy>>;
};

export type CreateMachineAccessTokenInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  expiresAt?: InputMaybe<Scalars['Datetime']>;
  machineUserId: Scalars['BigInt'];
};

export type CreateMachineAccessTokenPayload = CreateAccessTokenPayload & {
  __typename?: 'CreateMachineAccessTokenPayload';
  accessKey: Scalars['String'];
  clientMutationId?: Maybe<Scalars['String']>;
  machineUser: MachineUser;
  token: PlatformAccessToken;
};

/** All input for the create `MachineUser` mutation. */
export type CreateMachineUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `MachineUser` to be created by this mutation. */
  machineUser: MachineUserInput;
};

/** The output of our create `MachineUser` mutation. */
export type CreateMachineUserPayload = {
  __typename?: 'CreateMachineUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `MachineUser` that was created by this mutation. */
  machineUser?: Maybe<MachineUser>;
  /** An edge for our `MachineUser`. May be used by Relay 1. */
  machineUserEdge?: Maybe<MachineUsersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `MachineUser` mutation. */
export type CreateMachineUserPayloadMachineUserEdgeArgs = {
  orderBy?: InputMaybe<Array<MachineUsersOrderBy>>;
};

/** All input for the create `MainService` mutation. */
export type CreateMainServiceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `MainService` to be created by this mutation. */
  mainService: MainServiceInput;
};

/** The output of our create `MainService` mutation. */
export type CreateMainServicePayload = {
  __typename?: 'CreateMainServicePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  demand?: Maybe<DataPoint>;
  /** Reads a single `Facility` that is related to this `MainService`. */
  facility?: Maybe<Facility>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  gridDemand?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  gridUsage?: Maybe<DataPoint>;
  /** The `MainService` that was created by this mutation. */
  mainService?: Maybe<MainService>;
  /** An edge for our `MainService`. May be used by Relay 1. */
  mainServiceEdge?: Maybe<MainServicesEdge>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  meterDemand?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  meterUsage?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  usage?: Maybe<DataPoint>;
};

/** The output of our create `MainService` mutation. */
export type CreateMainServicePayloadMainServiceEdgeArgs = {
  orderBy?: InputMaybe<Array<MainServicesOrderBy>>;
};

/** All input for the create `MeterCharge` mutation. */
export type CreateMeterChargeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `MeterCharge` to be created by this mutation. */
  meterCharge: MeterChargeInput;
};

/** The output of our create `MeterCharge` mutation. */
export type CreateMeterChargePayload = {
  __typename?: 'CreateMeterChargePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `MeterCharge` that was created by this mutation. */
  meterCharge?: Maybe<MeterCharge>;
  /** An edge for our `MeterCharge`. May be used by Relay 1. */
  meterChargeEdge?: Maybe<MeterChargesEdge>;
  /** Reads a single `MeterStatement` that is related to this `MeterCharge`. */
  meterStatement?: Maybe<MeterStatement>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `MeterCharge` mutation. */
export type CreateMeterChargePayloadMeterChargeEdgeArgs = {
  orderBy?: InputMaybe<Array<MeterChargesOrderBy>>;
};

/** All input for the create `MeterStatementHistory` mutation. */
export type CreateMeterStatementHistoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `MeterStatementHistory` to be created by this mutation. */
  meterStatementHistory: MeterStatementHistoryInput;
};

/** The output of our create `MeterStatementHistory` mutation. */
export type CreateMeterStatementHistoryPayload = {
  __typename?: 'CreateMeterStatementHistoryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `MeterStatement` that is related to this `MeterStatementHistory`. */
  meterStatement?: Maybe<MeterStatement>;
  /** The `MeterStatementHistory` that was created by this mutation. */
  meterStatementHistory?: Maybe<MeterStatementHistory>;
  /** An edge for our `MeterStatementHistory`. May be used by Relay 1. */
  meterStatementHistoryEdge?: Maybe<MeterStatementHistoriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `MeterStatementHistory` mutation. */
export type CreateMeterStatementHistoryPayloadMeterStatementHistoryEdgeArgs = {
  orderBy?: InputMaybe<Array<MeterStatementHistoriesOrderBy>>;
};

/** All input for the create `MeterStatement` mutation. */
export type CreateMeterStatementInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `MeterStatement` to be created by this mutation. */
  meterStatement: MeterStatementInput;
};

/** The output of our create `MeterStatement` mutation. */
export type CreateMeterStatementPayload = {
  __typename?: 'CreateMeterStatementPayload';
  /** Reads a single `AccountStatement` that is related to this `MeterStatement`. */
  accountStatement?: Maybe<AccountStatement>;
  /** Reads a single `AccountStatementPdf` that is related to this `MeterStatement`. */
  accountStatementPdf?: Maybe<AccountStatementPdf>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `MeterStatement` that was created by this mutation. */
  meterStatement?: Maybe<MeterStatement>;
  /** An edge for our `MeterStatement`. May be used by Relay 1. */
  meterStatementEdge?: Maybe<MeterStatementsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UtilityMeter` that is related to this `MeterStatement`. */
  utilityMeter?: Maybe<UtilityMeter>;
};

/** The output of our create `MeterStatement` mutation. */
export type CreateMeterStatementPayloadMeterStatementEdgeArgs = {
  orderBy?: InputMaybe<Array<MeterStatementsOrderBy>>;
};

/** All input for the create `MeterUsage` mutation. */
export type CreateMeterUsageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `MeterUsage` to be created by this mutation. */
  meterUsage: MeterUsageInput;
};

/** The output of our create `MeterUsage` mutation. */
export type CreateMeterUsagePayload = {
  __typename?: 'CreateMeterUsagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `MeterStatement` that is related to this `MeterUsage`. */
  meterStatement?: Maybe<MeterStatement>;
  /** The `MeterUsage` that was created by this mutation. */
  meterUsage?: Maybe<MeterUsage>;
  /** An edge for our `MeterUsage`. May be used by Relay 1. */
  meterUsageEdge?: Maybe<MeterUsagesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `MeterUsage` mutation. */
export type CreateMeterUsagePayloadMeterUsageEdgeArgs = {
  orderBy?: InputMaybe<Array<MeterUsagesOrderBy>>;
};

/** All input for the create `PalletHistory` mutation. */
export type CreatePalletHistoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PalletHistory` to be created by this mutation. */
  palletHistory: PalletHistoryInput;
};

/** The output of our create `PalletHistory` mutation. */
export type CreatePalletHistoryPayload = {
  __typename?: 'CreatePalletHistoryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `PalletHistory` that was created by this mutation. */
  palletHistory?: Maybe<PalletHistory>;
  /** An edge for our `PalletHistory`. May be used by Relay 1. */
  palletHistoryEdge?: Maybe<PalletHistoriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `PalletHistory` mutation. */
export type CreatePalletHistoryPayloadPalletHistoryEdgeArgs = {
  orderBy?: InputMaybe<Array<PalletHistoriesOrderBy>>;
};

/** All input for the create `Pallet` mutation. */
export type CreatePalletInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Pallet` to be created by this mutation. */
  pallet: PalletInput;
};

/** All input for the create `PalletLocation` mutation. */
export type CreatePalletLocationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PalletLocation` to be created by this mutation. */
  palletLocation: PalletLocationInput;
};

/** The output of our create `PalletLocation` mutation. */
export type CreatePalletLocationPayload = {
  __typename?: 'CreatePalletLocationPayload';
  /** Reads a single `BuildingArea` that is related to this `PalletLocation`. */
  buildingArea?: Maybe<BuildingArea>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Facility` that is related to this `PalletLocation`. */
  facility?: Maybe<Facility>;
  /** The `PalletLocation` that was created by this mutation. */
  palletLocation?: Maybe<PalletLocation>;
  /** An edge for our `PalletLocation`. May be used by Relay 1. */
  palletLocationEdge?: Maybe<PalletLocationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `PalletLocation` mutation. */
export type CreatePalletLocationPayloadPalletLocationEdgeArgs = {
  orderBy?: InputMaybe<Array<PalletLocationsOrderBy>>;
};

/** The output of our create `Pallet` mutation. */
export type CreatePalletPayload = {
  __typename?: 'CreatePalletPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Pallet` that was created by this mutation. */
  pallet?: Maybe<Pallet>;
  /** An edge for our `Pallet`. May be used by Relay 1. */
  palletEdge?: Maybe<PalletsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `Pallet` mutation. */
export type CreatePalletPayloadPalletEdgeArgs = {
  orderBy?: InputMaybe<Array<PalletsOrderBy>>;
};

/** All input for the create `PricingNode` mutation. */
export type CreatePricingNodeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PricingNode` to be created by this mutation. */
  pricingNode: PricingNodeInput;
};

/** The output of our create `PricingNode` mutation. */
export type CreatePricingNodePayload = {
  __typename?: 'CreatePricingNodePayload';
  /** Reads a single `BalancingAuthority` that is related to this `PricingNode`. */
  balancingAuthority?: Maybe<BalancingAuthority>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `PricingNode` that was created by this mutation. */
  pricingNode?: Maybe<PricingNode>;
  /** An edge for our `PricingNode`. May be used by Relay 1. */
  pricingNodeEdge?: Maybe<PricingNodesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `PricingNode` mutation. */
export type CreatePricingNodePayloadPricingNodeEdgeArgs = {
  orderBy?: InputMaybe<Array<PricingNodesOrderBy>>;
};

/** All input for the create `Product` mutation. */
export type CreateProductInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Product` to be created by this mutation. */
  product: ProductInput;
};

/** The output of our create `Product` mutation. */
export type CreateProductPayload = {
  __typename?: 'CreateProductPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Facility` that is related to this `Product`. */
  facility?: Maybe<Facility>;
  /** The `Product` that was created by this mutation. */
  product?: Maybe<Product>;
  /** An edge for our `Product`. May be used by Relay 1. */
  productEdge?: Maybe<ProductsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `Product` mutation. */
export type CreateProductPayloadProductEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};

/** All input for the create `ProgramEnrollment` mutation. */
export type CreateProgramEnrollmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProgramEnrollment` to be created by this mutation. */
  programEnrollment: ProgramEnrollmentInput;
};

/** The output of our create `ProgramEnrollment` mutation. */
export type CreateProgramEnrollmentPayload = {
  __typename?: 'CreateProgramEnrollmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Program` that is related to this `ProgramEnrollment`. */
  program?: Maybe<Program>;
  /** The `ProgramEnrollment` that was created by this mutation. */
  programEnrollment?: Maybe<ProgramEnrollment>;
  /** An edge for our `ProgramEnrollment`. May be used by Relay 1. */
  programEnrollmentEdge?: Maybe<ProgramEnrollmentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `ProgramEnrollment` mutation. */
export type CreateProgramEnrollmentPayloadProgramEnrollmentEdgeArgs = {
  orderBy?: InputMaybe<Array<ProgramEnrollmentsOrderBy>>;
};

/** All input for the create `Program` mutation. */
export type CreateProgramInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Program` to be created by this mutation. */
  program: ProgramInput;
};

/** The output of our create `Program` mutation. */
export type CreateProgramPayload = {
  __typename?: 'CreateProgramPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Program` that was created by this mutation. */
  program?: Maybe<Program>;
  /** An edge for our `Program`. May be used by Relay 1. */
  programEdge?: Maybe<ProgramsEdge>;
  /** Reads a single `ProjectType` that is related to this `Program`. */
  projectType?: Maybe<ProjectType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `Program` mutation. */
export type CreateProgramPayloadProgramEdgeArgs = {
  orderBy?: InputMaybe<Array<ProgramsOrderBy>>;
};

/** All input for the create `ProjectComponent` mutation. */
export type CreateProjectComponentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProjectComponent` to be created by this mutation. */
  projectComponent: ProjectComponentInput;
};

/** The output of our create `ProjectComponent` mutation. */
export type CreateProjectComponentPayload = {
  __typename?: 'CreateProjectComponentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Component` that is related to this `ProjectComponent`. */
  component?: Maybe<Component>;
  /** Reads a single `Project` that is related to this `ProjectComponent`. */
  project?: Maybe<Project>;
  /** The `ProjectComponent` that was created by this mutation. */
  projectComponent?: Maybe<ProjectComponent>;
  /** An edge for our `ProjectComponent`. May be used by Relay 1. */
  projectComponentEdge?: Maybe<ProjectComponentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `ProjectComponent` mutation. */
export type CreateProjectComponentPayloadProjectComponentEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectComponentsOrderBy>>;
};

/** All input for the create `ProjectEnrollmentDataPointGroup` mutation. */
export type CreateProjectEnrollmentDataPointGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProjectEnrollmentDataPointGroup` to be created by this mutation. */
  projectEnrollmentDataPointGroup: ProjectEnrollmentDataPointGroupInput;
};

/** The output of our create `ProjectEnrollmentDataPointGroup` mutation. */
export type CreateProjectEnrollmentDataPointGroupPayload = {
  __typename?: 'CreateProjectEnrollmentDataPointGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ProjectEnrollmentDataPointGroup` that was created by this mutation. */
  projectEnrollmentDataPointGroup?: Maybe<ProjectEnrollmentDataPointGroup>;
  /** An edge for our `ProjectEnrollmentDataPointGroup`. May be used by Relay 1. */
  projectEnrollmentDataPointGroupEdge?: Maybe<ProjectEnrollmentDataPointGroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `ProjectEnrollmentDataPointGroup` mutation. */
export type CreateProjectEnrollmentDataPointGroupPayloadProjectEnrollmentDataPointGroupEdgeArgs =
  {
    orderBy?: InputMaybe<Array<ProjectEnrollmentDataPointGroupsOrderBy>>;
  };

/** All input for the create `ProjectEnrollmentDataPoint` mutation. */
export type CreateProjectEnrollmentDataPointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProjectEnrollmentDataPoint` to be created by this mutation. */
  projectEnrollmentDataPoint: ProjectEnrollmentDataPointInput;
};

/** The output of our create `ProjectEnrollmentDataPoint` mutation. */
export type CreateProjectEnrollmentDataPointPayload = {
  __typename?: 'CreateProjectEnrollmentDataPointPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `DataPoint` that is related to this `ProjectEnrollmentDataPoint`. */
  dataPoint?: Maybe<DataPoint>;
  /** Reads a single `ProjectEnrollmentDataPointGroup` that is related to this `ProjectEnrollmentDataPoint`. */
  group?: Maybe<ProjectEnrollmentDataPointGroup>;
  /** Reads a single `ProjectEnrollment` that is related to this `ProjectEnrollmentDataPoint`. */
  projectEnrollment?: Maybe<ProjectEnrollment>;
  /** The `ProjectEnrollmentDataPoint` that was created by this mutation. */
  projectEnrollmentDataPoint?: Maybe<ProjectEnrollmentDataPoint>;
  /** An edge for our `ProjectEnrollmentDataPoint`. May be used by Relay 1. */
  projectEnrollmentDataPointEdge?: Maybe<ProjectEnrollmentDataPointsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `ProjectEnrollmentDataPoint` mutation. */
export type CreateProjectEnrollmentDataPointPayloadProjectEnrollmentDataPointEdgeArgs =
  {
    orderBy?: InputMaybe<Array<ProjectEnrollmentDataPointsOrderBy>>;
  };

/** All input for the create `ProjectEnrollment` mutation. */
export type CreateProjectEnrollmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProjectEnrollment` to be created by this mutation. */
  projectEnrollment: ProjectEnrollmentInput;
};

/** The output of our create `ProjectEnrollment` mutation. */
export type CreateProjectEnrollmentPayload = {
  __typename?: 'CreateProjectEnrollmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `ProgramEnrollment` that is related to this `ProjectEnrollment`. */
  programEnrollment?: Maybe<ProgramEnrollment>;
  /** Reads a single `Project` that is related to this `ProjectEnrollment`. */
  project?: Maybe<Project>;
  /** The `ProjectEnrollment` that was created by this mutation. */
  projectEnrollment?: Maybe<ProjectEnrollment>;
  /** An edge for our `ProjectEnrollment`. May be used by Relay 1. */
  projectEnrollmentEdge?: Maybe<ProjectEnrollmentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `ProjectEnrollment` mutation. */
export type CreateProjectEnrollmentPayloadProjectEnrollmentEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectEnrollmentsOrderBy>>;
};

/** All input for the create `Project` mutation. */
export type CreateProjectInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Project` to be created by this mutation. */
  project: ProjectInput;
};

/** The output of our create `Project` mutation. */
export type CreateProjectPayload = {
  __typename?: 'CreateProjectPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Facility` that is related to this `Project`. */
  facility?: Maybe<Facility>;
  /** Reads a single `Program` that is related to this `Project`. */
  program?: Maybe<Program>;
  /** The `Project` that was created by this mutation. */
  project?: Maybe<Project>;
  /** An edge for our `Project`. May be used by Relay 1. */
  projectEdge?: Maybe<ProjectsEdge>;
  /** Reads a single `ProjectType` that is related to this `Project`. */
  projectType?: Maybe<ProjectType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `Project` mutation. */
export type CreateProjectPayloadProjectEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};

/** All input for the create `ProjectWatcher` mutation. */
export type CreateProjectWatcherInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProjectWatcher` to be created by this mutation. */
  projectWatcher: ProjectWatcherInput;
};

/** The output of our create `ProjectWatcher` mutation. */
export type CreateProjectWatcherPayload = {
  __typename?: 'CreateProjectWatcherPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Project` that is related to this `ProjectWatcher`. */
  project?: Maybe<Project>;
  /** The `ProjectWatcher` that was created by this mutation. */
  projectWatcher?: Maybe<ProjectWatcher>;
  /** An edge for our `ProjectWatcher`. May be used by Relay 1. */
  projectWatcherEdge?: Maybe<ProjectWatchersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `ProjectWatcher`. */
  user?: Maybe<User>;
};

/** The output of our create `ProjectWatcher` mutation. */
export type CreateProjectWatcherPayloadProjectWatcherEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectWatchersOrderBy>>;
};

/** All input for the create `ReportExecution` mutation. */
export type CreateReportExecutionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ReportExecution` to be created by this mutation. */
  reportExecution: ReportExecutionInput;
};

/** The output of our create `ReportExecution` mutation. */
export type CreateReportExecutionPayload = {
  __typename?: 'CreateReportExecutionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Report` that is related to this `ReportExecution`. */
  report?: Maybe<Report>;
  /** The `ReportExecution` that was created by this mutation. */
  reportExecution?: Maybe<ReportExecution>;
  /** An edge for our `ReportExecution`. May be used by Relay 1. */
  reportExecutionEdge?: Maybe<ReportExecutionsEdge>;
};

/** The output of our create `ReportExecution` mutation. */
export type CreateReportExecutionPayloadReportExecutionEdgeArgs = {
  orderBy?: InputMaybe<Array<ReportExecutionsOrderBy>>;
};

/** All input for the create `SavingsEvent` mutation. */
export type CreateSavingsEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SavingsEvent` to be created by this mutation. */
  savingsEvent: SavingsEventInput;
};

/** The output of our create `SavingsEvent` mutation. */
export type CreateSavingsEventPayload = {
  __typename?: 'CreateSavingsEventPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Project` that is related to this `SavingsEvent`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SavingsEvent` that was created by this mutation. */
  savingsEvent?: Maybe<SavingsEvent>;
  /** An edge for our `SavingsEvent`. May be used by Relay 1. */
  savingsEventEdge?: Maybe<SavingsEventsEdge>;
};

/** The output of our create `SavingsEvent` mutation. */
export type CreateSavingsEventPayloadSavingsEventEdgeArgs = {
  orderBy?: InputMaybe<Array<SavingsEventsOrderBy>>;
};

/** All input for the create `SuggestionActivityLog` mutation. */
export type CreateSuggestionActivityLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SuggestionActivityLog` to be created by this mutation. */
  suggestionActivityLog: SuggestionActivityLogInput;
};

/** The output of our create `SuggestionActivityLog` mutation. */
export type CreateSuggestionActivityLogPayload = {
  __typename?: 'CreateSuggestionActivityLogPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Suggestion` that is related to this `SuggestionActivityLog`. */
  suggestion?: Maybe<Suggestion>;
  /** The `SuggestionActivityLog` that was created by this mutation. */
  suggestionActivityLog?: Maybe<SuggestionActivityLog>;
  /** An edge for our `SuggestionActivityLog`. May be used by Relay 1. */
  suggestionActivityLogEdge?: Maybe<SuggestionActivityLogsEdge>;
};

/** The output of our create `SuggestionActivityLog` mutation. */
export type CreateSuggestionActivityLogPayloadSuggestionActivityLogEdgeArgs = {
  orderBy?: InputMaybe<Array<SuggestionActivityLogsOrderBy>>;
};

/** All input for the create `SuggestionControlEvent` mutation. */
export type CreateSuggestionControlEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SuggestionControlEvent` to be created by this mutation. */
  suggestionControlEvent: SuggestionControlEventInput;
};

/** The output of our create `SuggestionControlEvent` mutation. */
export type CreateSuggestionControlEventPayload = {
  __typename?: 'CreateSuggestionControlEventPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `ControlEvent` that is related to this `SuggestionControlEvent`. */
  controlEvent?: Maybe<ControlEvent>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Suggestion` that is related to this `SuggestionControlEvent`. */
  suggestion?: Maybe<Suggestion>;
  /** The `SuggestionControlEvent` that was created by this mutation. */
  suggestionControlEvent?: Maybe<SuggestionControlEvent>;
};

/** All input for the create `Suggestion` mutation. */
export type CreateSuggestionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Suggestion` to be created by this mutation. */
  suggestion: SuggestionInput;
};

/** The output of our create `Suggestion` mutation. */
export type CreateSuggestionPayload = {
  __typename?: 'CreateSuggestionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Project` that is related to this `Suggestion`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Suggestion` that was created by this mutation. */
  suggestion?: Maybe<Suggestion>;
  /** An edge for our `Suggestion`. May be used by Relay 1. */
  suggestionEdge?: Maybe<SuggestionsEdge>;
};

/** The output of our create `Suggestion` mutation. */
export type CreateSuggestionPayloadSuggestionEdgeArgs = {
  orderBy?: InputMaybe<Array<SuggestionsOrderBy>>;
};

/** All input for the create `TemperatureSensor` mutation. */
export type CreateTemperatureSensorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TemperatureSensor` to be created by this mutation. */
  temperatureSensor: TemperatureSensorInput;
};

/** The output of our create `TemperatureSensor` mutation. */
export type CreateTemperatureSensorPayload = {
  __typename?: 'CreateTemperatureSensorPayload';
  /** Reads a single `DataPoint` that is related to this `TemperatureSensor`. */
  battery?: Maybe<DataPoint>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Facility` that is related to this `TemperatureSensor`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `TemperatureSensor`. */
  signal?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `TemperatureSensor`. */
  temperature?: Maybe<DataPoint>;
  /** The `TemperatureSensor` that was created by this mutation. */
  temperatureSensor?: Maybe<TemperatureSensor>;
  /** An edge for our `TemperatureSensor`. May be used by Relay 1. */
  temperatureSensorEdge?: Maybe<TemperatureSensorsEdge>;
};

/** The output of our create `TemperatureSensor` mutation. */
export type CreateTemperatureSensorPayloadTemperatureSensorEdgeArgs = {
  orderBy?: InputMaybe<Array<TemperatureSensorsOrderBy>>;
};

/** All input for the create `TrailerPosition` mutation. */
export type CreateTrailerPositionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TrailerPosition` to be created by this mutation. */
  trailerPosition: TrailerPositionInput;
};

/** The output of our create `TrailerPosition` mutation. */
export type CreateTrailerPositionPayload = {
  __typename?: 'CreateTrailerPositionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Facility` that is related to this `TrailerPosition`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `TrailerPosition`. */
  trailerIsPresent?: Maybe<DataPoint>;
  /** The `TrailerPosition` that was created by this mutation. */
  trailerPosition?: Maybe<TrailerPosition>;
  /** An edge for our `TrailerPosition`. May be used by Relay 1. */
  trailerPositionEdge?: Maybe<TrailerPositionsEdge>;
};

/** The output of our create `TrailerPosition` mutation. */
export type CreateTrailerPositionPayloadTrailerPositionEdgeArgs = {
  orderBy?: InputMaybe<Array<TrailerPositionsOrderBy>>;
};

export type CreateUserAccessTokenInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  expiresAt?: InputMaybe<Scalars['Datetime']>;
};

export type CreateUserAccessTokenPayload = CreateAccessTokenPayload & {
  __typename?: 'CreateUserAccessTokenPayload';
  accessKey: Scalars['String'];
  clientMutationId?: Maybe<Scalars['String']>;
  token: PlatformAccessToken;
  user: User;
};

/** All input for the create `UtilityAccount` mutation. */
export type CreateUtilityAccountInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UtilityAccount` to be created by this mutation. */
  utilityAccount: UtilityAccountInput;
};

/** The output of our create `UtilityAccount` mutation. */
export type CreateUtilityAccountPayload = {
  __typename?: 'CreateUtilityAccountPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UtilityAccount` that was created by this mutation. */
  utilityAccount?: Maybe<UtilityAccount>;
  /** An edge for our `UtilityAccount`. May be used by Relay 1. */
  utilityAccountEdge?: Maybe<UtilityAccountsEdge>;
  /** Reads a single `UtilityProvider` that is related to this `UtilityAccount`. */
  utilityProvider?: Maybe<UtilityProvider>;
};

/** The output of our create `UtilityAccount` mutation. */
export type CreateUtilityAccountPayloadUtilityAccountEdgeArgs = {
  orderBy?: InputMaybe<Array<UtilityAccountsOrderBy>>;
};

/** All input for the create `UtilityMeter` mutation. */
export type CreateUtilityMeterInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UtilityMeter` to be created by this mutation. */
  utilityMeter: UtilityMeterInput;
};

/** The output of our create `UtilityMeter` mutation. */
export type CreateUtilityMeterPayload = {
  __typename?: 'CreateUtilityMeterPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Facility` that is related to this `UtilityMeter`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UtilityAccount` that is related to this `UtilityMeter`. */
  utilityAccount?: Maybe<UtilityAccount>;
  /** The `UtilityMeter` that was created by this mutation. */
  utilityMeter?: Maybe<UtilityMeter>;
  /** An edge for our `UtilityMeter`. May be used by Relay 1. */
  utilityMeterEdge?: Maybe<UtilityMetersEdge>;
};

/** The output of our create `UtilityMeter` mutation. */
export type CreateUtilityMeterPayloadUtilityMeterEdgeArgs = {
  orderBy?: InputMaybe<Array<UtilityMetersOrderBy>>;
};

/** All input for the create `UtilityProvider` mutation. */
export type CreateUtilityProviderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UtilityProvider` to be created by this mutation. */
  utilityProvider: UtilityProviderInput;
};

/** The output of our create `UtilityProvider` mutation. */
export type CreateUtilityProviderPayload = {
  __typename?: 'CreateUtilityProviderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UtilityProvider` that was created by this mutation. */
  utilityProvider?: Maybe<UtilityProvider>;
  /** An edge for our `UtilityProvider`. May be used by Relay 1. */
  utilityProviderEdge?: Maybe<UtilityProvidersEdge>;
};

/** The output of our create `UtilityProvider` mutation. */
export type CreateUtilityProviderPayloadUtilityProviderEdgeArgs = {
  orderBy?: InputMaybe<Array<UtilityProvidersOrderBy>>;
};

/** All input for the create `VendorUser` mutation. */
export type CreateVendorUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `VendorUser` to be created by this mutation. */
  vendorUser: VendorUserInput;
};

/** All input for the create `VendorUserMachineUser` mutation. */
export type CreateVendorUserMachineUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `VendorUserMachineUser` to be created by this mutation. */
  vendorUserMachineUser: VendorUserMachineUserInput;
};

/** The output of our create `VendorUserMachineUser` mutation. */
export type CreateVendorUserMachineUserPayload = {
  __typename?: 'CreateVendorUserMachineUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VendorUserMachineUser` that was created by this mutation. */
  vendorUserMachineUser?: Maybe<VendorUserMachineUser>;
};

/** The output of our create `VendorUser` mutation. */
export type CreateVendorUserPayload = {
  __typename?: 'CreateVendorUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VendorUser` that was created by this mutation. */
  vendorUser?: Maybe<VendorUser>;
  /** An edge for our `VendorUser`. May be used by Relay 1. */
  vendorUserEdge?: Maybe<VendorUsersEdge>;
};

/** The output of our create `VendorUser` mutation. */
export type CreateVendorUserPayloadVendorUserEdgeArgs = {
  orderBy?: InputMaybe<Array<VendorUsersOrderBy>>;
};

/** All input for the create `VirtualPointInterval` mutation. */
export type CreateVirtualPointIntervalInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `VirtualPointInterval` to be created by this mutation. */
  virtualPointInterval: VirtualPointIntervalInput;
};

/** The output of our create `VirtualPointInterval` mutation. */
export type CreateVirtualPointIntervalPayload = {
  __typename?: 'CreateVirtualPointIntervalPayload';
  /** Reads a single `DataPoint` that is related to this `VirtualPointInterval`. */
  child?: Maybe<DataPoint>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `DataPoint` that is related to this `VirtualPointInterval`. */
  parent?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VirtualPointInterval` that was created by this mutation. */
  virtualPointInterval?: Maybe<VirtualPointInterval>;
  /** An edge for our `VirtualPointInterval`. May be used by Relay 1. */
  virtualPointIntervalEdge?: Maybe<VirtualPointIntervalsEdge>;
};

/** The output of our create `VirtualPointInterval` mutation. */
export type CreateVirtualPointIntervalPayloadVirtualPointIntervalEdgeArgs = {
  orderBy?: InputMaybe<Array<VirtualPointIntervalsOrderBy>>;
};

export type Customer = Node & {
  __typename?: 'Customer';
  /** The time at which the record was created */
  createdAt: Scalars['Datetime'];
  /** The unique local (facility-level) identifier of the customer */
  customerCode?: Maybe<Scalars['String']>;
  /** The globally unique external deletion identifier of the record. Sometimes this is different from sourceId due to change tracking semantics */
  deleteId?: Maybe<Scalars['String']>;
  /** The time at which the record was deleted */
  deletedAt?: Maybe<Scalars['Datetime']>;
  /** Reads a single `Facility` that is related to this `Customer`. */
  facility?: Maybe<Facility>;
  /** The originating facility of the customer record */
  facilityId?: Maybe<Scalars['Int']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['BigInt'];
  /** The name of the customer */
  name?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `Product`. */
  products: ProductsConnection;
  /** A readable, short name of the customer */
  shortName?: Maybe<Scalars['String']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String'];
  /** The time at which the record was updated */
  updatedAt: Scalars['Datetime'];
  /** The version of the record */
  version?: Maybe<Scalars['BigInt']>;
};

export type CustomerProductsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<ProductFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/**
 * A condition to be used against `Customer` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type CustomerCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `customerCode` field. */
  customerCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `deleteId` field. */
  deleteId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `shortName` field. */
  shortName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `sourceId` field. */
  sourceId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `version` field. */
  version?: InputMaybe<Scalars['BigInt']>;
};

/** A filter to be used against `Customer` object types. All fields are combined with a logical ‘and.’ */
export type CustomerFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CustomerFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `customerCode` field. */
  customerCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `deleteId` field. */
  deleteId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CustomerFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CustomerFilter>>;
  /** Filter by the object’s `shortName` field. */
  shortName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `sourceId` field. */
  sourceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `version` field. */
  version?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `Customer` */
export type CustomerInput = {
  /** The unique local (facility-level) identifier of the customer */
  customerCode?: InputMaybe<Scalars['String']>;
  /** The originating facility of the customer record */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** The name of the customer */
  name?: InputMaybe<Scalars['String']>;
  /** A readable, short name of the customer */
  shortName?: InputMaybe<Scalars['String']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String'];
};

/** Represents an update to a `Customer`. Fields that are set will be updated. */
export type CustomerPatch = {
  /** The unique local (facility-level) identifier of the customer */
  customerCode?: InputMaybe<Scalars['String']>;
  /** The originating facility of the customer record */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** The name of the customer */
  name?: InputMaybe<Scalars['String']>;
  /** A readable, short name of the customer */
  shortName?: InputMaybe<Scalars['String']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `Customer` values. */
export type CustomersConnection = {
  __typename?: 'CustomersConnection';
  /** A list of edges which contains the `Customer` and cursor to aid in pagination. */
  edges: Array<CustomersEdge>;
  /** A list of `Customer` objects. */
  nodes: Array<Customer>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Customer` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Customer` edge in the connection. */
export type CustomersEdge = {
  __typename?: 'CustomersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Customer` at the end of the edge. */
  node: Customer;
};

/** Methods to use when ordering `Customer`. */
export enum CustomersOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CUSTOMER_CODE_ASC = 'CUSTOMER_CODE_ASC',
  CUSTOMER_CODE_DESC = 'CUSTOMER_CODE_DESC',
  DELETED_AT_ASC = 'DELETED_AT_ASC',
  DELETED_AT_DESC = 'DELETED_AT_DESC',
  DELETE_ID_ASC = 'DELETE_ID_ASC',
  DELETE_ID_DESC = 'DELETE_ID_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SHORT_NAME_ASC = 'SHORT_NAME_ASC',
  SHORT_NAME_DESC = 'SHORT_NAME_DESC',
  SOURCE_ID_ASC = 'SOURCE_ID_ASC',
  SOURCE_ID_DESC = 'SOURCE_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VERSION_ASC = 'VERSION_ASC',
  VERSION_DESC = 'VERSION_DESC'
}

export type Dashboard = Node & {
  __typename?: 'Dashboard';
  config: Scalars['JSON'];
  createdAt: Scalars['Datetime'];
  description?: Maybe<Scalars['String']>;
  /** Reads a single `Facility` that is related to this `Dashboard`. */
  facility?: Maybe<Facility>;
  facilityId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `Dashboard` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type DashboardCondition = {
  /** Checks for equality with the object’s `config` field. */
  config?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `Dashboard` object types. All fields are combined with a logical ‘and.’ */
export type DashboardFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DashboardFilter>>;
  /** Filter by the object’s `config` field. */
  config?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DashboardFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DashboardFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Dashboard` */
export type DashboardInput = {
  config?: InputMaybe<Scalars['JSON']>;
  description?: InputMaybe<Scalars['String']>;
  facilityId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

/** Represents an update to a `Dashboard`. Fields that are set will be updated. */
export type DashboardPatch = {
  config?: InputMaybe<Scalars['JSON']>;
  description?: InputMaybe<Scalars['String']>;
  facilityId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `Dashboard` values. */
export type DashboardsConnection = {
  __typename?: 'DashboardsConnection';
  /** A list of edges which contains the `Dashboard` and cursor to aid in pagination. */
  edges: Array<DashboardsEdge>;
  /** A list of `Dashboard` objects. */
  nodes: Array<Dashboard>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Dashboard` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Dashboard` edge in the connection. */
export type DashboardsEdge = {
  __typename?: 'DashboardsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Dashboard` at the end of the edge. */
  node: Dashboard;
};

/** Methods to use when ordering `Dashboard`. */
export enum DashboardsOrderBy {
  CONFIG_ASC = 'CONFIG_ASC',
  CONFIG_DESC = 'CONFIG_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** This represents the data points for a data source. */
export type DataPoint = Node & {
  __typename?: 'DataPoint';
  /** The human readable name of the data point. */
  alias: Scalars['String'];
  /** Returns a list of all downstream dependencies for a data point. */
  allDependencies: DataPointsConnection;
  /** Returns a list of all upstream dependents for a data point. */
  allDependents: DataPointsConnection;
  /** Reads and enables pagination through a set of `Blast`. */
  blastsByStateId: BlastsConnection;
  /** The time the data point was created. */
  createdAt: Scalars['Datetime'];
  /** Aggregates a data point for the specified filter expression */
  data?: Maybe<MetricDataConnection>;
  /** Reads a single `DataSource` that is related to this `DataPoint`. */
  dataSourceByDataSourceName?: Maybe<DataSource>;
  /** The name of the data source. */
  dataSourceName: Scalars['String'];
  /** The data type of the data point. */
  dataType?: Maybe<Scalars['String']>;
  /** Returns a list of direct dependencies for a data point. */
  dependencies: DataPointsConnection;
  /** Returns a list of direct dependents for a data point. */
  dependents: DataPointsConnection;
  /** The description of the data point. */
  description?: Maybe<Scalars['String']>;
  /** The expression of the data point. */
  expression?: Maybe<Scalars['String']>;
  /** The maximum sampling rate, in seconds, to use when accessing a point's data. */
  frequency?: Maybe<Scalars['Int']>;
  /** The threshold used to determine the health of a given data point. */
  freshnessThresholdSeconds?: Maybe<Scalars['Int']>;
  id: Scalars['BigInt'];
  /** @deprecated Use `dataPoint.type` instead. */
  isComposite?: Maybe<Scalars['Boolean']>;
  /** Where the data point`s data originates from. */
  locationType?: Maybe<Scalars['String']>;
  /** The name of the data point. */
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The child point intervals for a VIRTUAL data point. */
  pointIntervals: VirtualPointIntervalsConnection;
  /** Returns raw data for the given data point, if applicable. */
  rawData?: Maybe<MetricDataConnection>;
  /** Indicates that the stream of data is a metered / right aligned periodic aggregate. */
  rightAligned?: Maybe<Scalars['Boolean']>;
  /** The type of data stream a point represents. */
  type: DataPointType;
  /** The units of thee data point. */
  units?: Maybe<Scalars['String']>;
  /** The time the data point was updated. */
  updatedAt: Scalars['Datetime'];
};

/** This represents the data points for a data source. */
export type DataPointAllDependenciesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<DataPointFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** This represents the data points for a data source. */
export type DataPointAllDependentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<DataPointFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** This represents the data points for a data source. */
export type DataPointBlastsByStateIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BlastCondition>;
  filter?: InputMaybe<BlastFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BlastsOrderBy>>;
};

/** This represents the data points for a data source. */
export type DataPointDataArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** This represents the data points for a data source. */
export type DataPointDependenciesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<DataPointFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** This represents the data points for a data source. */
export type DataPointDependentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<DataPointFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** This represents the data points for a data source. */
export type DataPointPointIntervalsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<VirtualPointIntervalFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** This represents the data points for a data source. */
export type DataPointRawDataArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
};

/**
 * A condition to be used against `DataPoint` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type DataPointCondition = {
  /** Checks for equality with the object’s `alias` field. */
  alias?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `dataSourceName` field. */
  dataSourceName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `dataType` field. */
  dataType?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `expression` field. */
  expression?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `formattedExpression` field. */
  formattedExpression?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `frequency` field. */
  frequency?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `freshnessThresholdSeconds` field. */
  freshnessThresholdSeconds?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `locationType` field. */
  locationType?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `rightAligned` field. */
  rightAligned?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<DataPointType>;
  /** Checks for equality with the object’s `units` field. */
  units?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `DataPoint` object types. All fields are combined with a logical ‘and.’ */
export type DataPointFilter = {
  /** Filter by the object’s `alias` field. */
  alias?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DataPointFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dataSourceName` field. */
  dataSourceName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `dataType` field. */
  dataType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `expression` field. */
  expression?: InputMaybe<StringFilter>;
  /** Filter by the object’s `formattedExpression` field. */
  formattedExpression?: InputMaybe<StringFilter>;
  /** Filter by the object’s `frequency` field. */
  frequency?: InputMaybe<IntFilter>;
  /** Filter by the object’s `freshnessThresholdSeconds` field. */
  freshnessThresholdSeconds?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `isComposite` field. */
  isComposite?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `locationType` field. */
  locationType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DataPointFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DataPointFilter>>;
  /** Filter by the object’s `rightAligned` field. */
  rightAligned?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<DataPointTypeFilter>;
  /** Filter by the object’s `units` field. */
  units?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `DataPoint` */
export type DataPointInput = {
  /** The human readable name of the data point. */
  alias: Scalars['String'];
  /** Mutates a `DataSource` as part of the payload */
  dataSource?: InputMaybe<DataSourceInput>;
  /** The name of the data source. */
  dataSourceName?: InputMaybe<Scalars['String']>;
  /** The data type of the data point. */
  dataType?: InputMaybe<Scalars['String']>;
  /** The description of the data point. */
  description?: InputMaybe<Scalars['String']>;
  /** The expression of the data point. */
  expression?: InputMaybe<Scalars['String']>;
  /** The maximum sampling rate, in seconds, to use when accessing a point's data. */
  frequency?: InputMaybe<Scalars['Int']>;
  /** The threshold used to determine the health of a given data point. */
  freshnessThresholdSeconds?: InputMaybe<Scalars['Int']>;
  /** Where the data point`s data originates from. */
  locationType?: InputMaybe<Scalars['String']>;
  /** The name of the data point. */
  name: Scalars['String'];
  /** Indicates that the stream of data is a metered / right aligned periodic aggregate. */
  rightAligned?: InputMaybe<Scalars['Boolean']>;
  /** The type of data stream a point represents. */
  type?: InputMaybe<DataPointType>;
  /** The units of thee data point. */
  units?: InputMaybe<Scalars['String']>;
};

/** Represents an update to a `DataPoint`. Fields that are set will be updated. */
export type DataPointPatch = {
  /** The human readable name of the data point. */
  alias?: InputMaybe<Scalars['String']>;
  /** The data type of the data point. */
  dataType?: InputMaybe<Scalars['String']>;
  /** The description of the data point. */
  description?: InputMaybe<Scalars['String']>;
  /** The expression of the data point. */
  expression?: InputMaybe<Scalars['String']>;
  /** The maximum sampling rate, in seconds, to use when accessing a point's data. */
  frequency?: InputMaybe<Scalars['Int']>;
  /** The threshold used to determine the health of a given data point. */
  freshnessThresholdSeconds?: InputMaybe<Scalars['Int']>;
  /** Where the data point`s data originates from. */
  locationType?: InputMaybe<Scalars['String']>;
  /** Indicates that the stream of data is a metered / right aligned periodic aggregate. */
  rightAligned?: InputMaybe<Scalars['Boolean']>;
  /** The type of data stream a point represents. */
  type?: InputMaybe<DataPointType>;
  /** The units of thee data point. */
  units?: InputMaybe<Scalars['String']>;
};

/** Well-known tags for identifying special data points */
export type DataPointTag = Node & {
  __typename?: 'DataPointTag';
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `DataPointTag` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DataPointTagCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `DataPointTag` object types. All fields are combined with a logical ‘and.’ */
export type DataPointTagFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DataPointTagFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DataPointTagFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DataPointTagFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `DataPointTag` */
export type DataPointTagInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `DataPointTag` values. */
export type DataPointTagsConnection = {
  __typename?: 'DataPointTagsConnection';
  /** A list of edges which contains the `DataPointTag` and cursor to aid in pagination. */
  edges: Array<DataPointTagsEdge>;
  /** A list of `DataPointTag` objects. */
  nodes: Array<DataPointTag>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DataPointTag` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `DataPointTag` edge in the connection. */
export type DataPointTagsEdge = {
  __typename?: 'DataPointTagsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `DataPointTag` at the end of the edge. */
  node: DataPointTag;
};

/** Methods to use when ordering `DataPointTag`. */
export enum DataPointTagsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

export enum DataPointType {
  COMPOSITE = 'COMPOSITE',
  RAW = 'RAW',
  VIRTUAL = 'VIRTUAL'
}

/** A filter to be used against DataPointType fields. All fields are combined with a logical ‘and.’ */
export type DataPointTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<DataPointType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<DataPointType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<DataPointType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<DataPointType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<DataPointType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<DataPointType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<DataPointType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<DataPointType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<DataPointType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<DataPointType>>;
};

/** A connection to a list of `DataPoint` values. */
export type DataPointsConnection = {
  __typename?: 'DataPointsConnection';
  /** A list of edges which contains the `DataPoint` and cursor to aid in pagination. */
  edges: Array<DataPointsEdge>;
  /** A list of `DataPoint` objects. */
  nodes: Array<DataPoint>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DataPoint` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `DataPoint` edge in the connection. */
export type DataPointsEdge = {
  __typename?: 'DataPointsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `DataPoint` at the end of the edge. */
  node: DataPoint;
};

/** Methods to use when ordering `DataPoint`. */
export enum DataPointsOrderBy {
  ALIAS_ASC = 'ALIAS_ASC',
  ALIAS_DESC = 'ALIAS_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DATA_SOURCE_NAME_ASC = 'DATA_SOURCE_NAME_ASC',
  DATA_SOURCE_NAME_DESC = 'DATA_SOURCE_NAME_DESC',
  DATA_TYPE_ASC = 'DATA_TYPE_ASC',
  DATA_TYPE_DESC = 'DATA_TYPE_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  EXPRESSION_ASC = 'EXPRESSION_ASC',
  EXPRESSION_DESC = 'EXPRESSION_DESC',
  FORMATTED_EXPRESSION_ASC = 'FORMATTED_EXPRESSION_ASC',
  FORMATTED_EXPRESSION_DESC = 'FORMATTED_EXPRESSION_DESC',
  FREQUENCY_ASC = 'FREQUENCY_ASC',
  FREQUENCY_DESC = 'FREQUENCY_DESC',
  FRESHNESS_THRESHOLD_SECONDS_ASC = 'FRESHNESS_THRESHOLD_SECONDS_ASC',
  FRESHNESS_THRESHOLD_SECONDS_DESC = 'FRESHNESS_THRESHOLD_SECONDS_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LOCATION_TYPE_ASC = 'LOCATION_TYPE_ASC',
  LOCATION_TYPE_DESC = 'LOCATION_TYPE_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  RIGHT_ALIGNED_ASC = 'RIGHT_ALIGNED_ASC',
  RIGHT_ALIGNED_DESC = 'RIGHT_ALIGNED_DESC',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC',
  UNITS_ASC = 'UNITS_ASC',
  UNITS_DESC = 'UNITS_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** This represents the iot data sources. */
export type DataSource = Node & {
  __typename?: 'DataSource';
  /** A human-readable name for this data source */
  alias?: Maybe<Scalars['String']>;
  /** The time the data source was created. */
  createdAt: Scalars['Datetime'];
  /** The threshold used to determine the health of a given data source from the freshness of its data points. */
  criticalThreshold?: Maybe<Scalars['Float']>;
  /** Reads and enables pagination through a set of `DataPoint`. */
  dataPoints: DataPointsConnection;
  /** The description of the data source. */
  description?: Maybe<Scalars['String']>;
  /** Returns the alias, if set, or the name of this data source */
  displayName?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `Facility`. */
  facilities: FacilitiesConnection;
  /** Reads and enables pagination through a set of `FacilityDataSource`. */
  facilityDataSourcesByDataSourceName: FacilityDataSourcesConnection;
  /** The threshold used to determine the liveness of a given data source. */
  livenessThresholdSeconds?: Maybe<Scalars['Int']>;
  /** The data source name. */
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The time the data source was updated. */
  updatedAt: Scalars['Datetime'];
};

/** This represents the iot data sources. */
export type DataSourceDataPointsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DataPointCondition>;
  filter?: InputMaybe<DataPointFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DataPointsOrderBy>>;
};

/** This represents the iot data sources. */
export type DataSourceFacilitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<FacilityFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** This represents the iot data sources. */
export type DataSourceFacilityDataSourcesByDataSourceNameArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FacilityDataSourceCondition>;
  filter?: InputMaybe<FacilityDataSourceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FacilityDataSourcesOrderBy>>;
};

/**
 * A condition to be used against `DataSource` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type DataSourceCondition = {
  /** Checks for equality with the object’s `alias` field. */
  alias?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `criticalThreshold` field. */
  criticalThreshold?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `livenessThresholdSeconds` field. */
  livenessThresholdSeconds?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `DataSource` object types. All fields are combined with a logical ‘and.’ */
export type DataSourceFilter = {
  /** Filter by the object’s `alias` field. */
  alias?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DataSourceFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `criticalThreshold` field. */
  criticalThreshold?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `displayName` field. */
  displayName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `livenessThresholdSeconds` field. */
  livenessThresholdSeconds?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DataSourceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DataSourceFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `DataSource` */
export type DataSourceInput = {
  /** A human-readable name for this data source */
  alias?: InputMaybe<Scalars['String']>;
  /** The threshold used to determine the health of a given data source from the freshness of its data points. */
  criticalThreshold?: InputMaybe<Scalars['Float']>;
  /** The description of the data source. */
  description?: InputMaybe<Scalars['String']>;
  /** The threshold used to determine the liveness of a given data source. */
  livenessThresholdSeconds?: InputMaybe<Scalars['Int']>;
  /** The data source name. */
  name: Scalars['String'];
};

/** A connection to a list of `DataSource` values. */
export type DataSourcesConnection = {
  __typename?: 'DataSourcesConnection';
  /** A list of edges which contains the `DataSource` and cursor to aid in pagination. */
  edges: Array<DataSourcesEdge>;
  /** A list of `DataSource` objects. */
  nodes: Array<DataSource>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DataSource` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `DataSource` edge in the connection. */
export type DataSourcesEdge = {
  __typename?: 'DataSourcesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `DataSource` at the end of the edge. */
  node: DataSource;
};

/** Methods to use when ordering `DataSource`. */
export enum DataSourcesOrderBy {
  ALIAS_ASC = 'ALIAS_ASC',
  ALIAS_DESC = 'ALIAS_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CRITICAL_THRESHOLD_ASC = 'CRITICAL_THRESHOLD_ASC',
  CRITICAL_THRESHOLD_DESC = 'CRITICAL_THRESHOLD_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  DISPLAY_NAME_ASC = 'DISPLAY_NAME_ASC',
  DISPLAY_NAME_DESC = 'DISPLAY_NAME_DESC',
  LIVENESS_THRESHOLD_SECONDS_ASC = 'LIVENESS_THRESHOLD_SECONDS_ASC',
  LIVENESS_THRESHOLD_SECONDS_DESC = 'LIVENESS_THRESHOLD_SECONDS_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A filter to be used against Date fields. All fields are combined with a logical ‘and.’ */
export type DateFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Date']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Date']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Date']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Date']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Date']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Date']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Date']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Date']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Date']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Date']>>;
};

/** A filter to be used against Datetime fields. All fields are combined with a logical ‘and.’ */
export type DatetimeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Datetime']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Datetime']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Datetime']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Datetime']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Datetime']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Datetime']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Datetime']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Datetime']>>;
};

/** All input for the `deleteAccountCharge` mutation. */
export type DeleteAccountChargeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our `deleteAccountCharge` mutation. */
export type DeleteAccountChargePayload = {
  __typename?: 'DeleteAccountChargePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deleted?: Maybe<Scalars['Boolean']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteAccountStatement` mutation. */
export type DeleteAccountStatementInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our `deleteAccountStatement` mutation. */
export type DeleteAccountStatementPayload = {
  __typename?: 'DeleteAccountStatementPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deleted?: Maybe<Scalars['Boolean']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteBalancingAuthorityByNodeId` mutation. */
export type DeleteBalancingAuthorityByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `BalancingAuthority` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteBalancingAuthorityBySlug` mutation. */
export type DeleteBalancingAuthorityBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The slug identifier of the balancing authority. */
  slug: Scalars['String'];
};

/** All input for the `deleteBalancingAuthority` mutation. */
export type DeleteBalancingAuthorityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The identifer of the balancing authority. */
  id: Scalars['Int'];
};

/** The output of our delete `BalancingAuthority` mutation. */
export type DeleteBalancingAuthorityPayload = {
  __typename?: 'DeleteBalancingAuthorityPayload';
  /** The `BalancingAuthority` that was deleted by this mutation. */
  balancingAuthority?: Maybe<BalancingAuthority>;
  /** An edge for our `BalancingAuthority`. May be used by Relay 1. */
  balancingAuthorityEdge?: Maybe<BalancingAuthoritiesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedBalancingAuthorityNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `BalancingAuthority` mutation. */
export type DeleteBalancingAuthorityPayloadBalancingAuthorityEdgeArgs = {
  orderBy?: InputMaybe<Array<BalancingAuthoritiesOrderBy>>;
};

/** All input for the `deleteBlastByLabelAndFacilityId` mutation. */
export type DeleteBlastByLabelAndFacilityIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The facility a blast is within */
  facilityId: Scalars['Int'];
  /** The unique local (facility-level) human-readable label of the blast */
  label: Scalars['String'];
};

/** All input for the `deleteBlastByNodeId` mutation. */
export type DeleteBlastByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Blast` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteBlastEvaporatorByNodeId` mutation. */
export type DeleteBlastEvaporatorByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `BlastEvaporator` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteBlastEvaporator` mutation. */
export type DeleteBlastEvaporatorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int'];
};

/** The output of our delete `BlastEvaporator` mutation. */
export type DeleteBlastEvaporatorPayload = {
  __typename?: 'DeleteBlastEvaporatorPayload';
  /** Reads a single `Blast` that is related to this `BlastEvaporator`. */
  blast?: Maybe<Blast>;
  /** The `BlastEvaporator` that was deleted by this mutation. */
  blastEvaporator?: Maybe<BlastEvaporator>;
  /** An edge for our `BlastEvaporator`. May be used by Relay 1. */
  blastEvaporatorEdge?: Maybe<BlastEvaporatorsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedBlastEvaporatorNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Evaporator` that is related to this `BlastEvaporator`. */
  evaporator?: Maybe<Evaporator>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `BlastEvaporator` mutation. */
export type DeleteBlastEvaporatorPayloadBlastEvaporatorEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastEvaporatorsOrderBy>>;
};

/** All input for the `deleteBlast` mutation. */
export type DeleteBlastInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int'];
};

/** All input for the `deleteBlastPalletByNodeId` mutation. */
export type DeleteBlastPalletByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `BlastPallet` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteBlastPallet` mutation. */
export type DeleteBlastPalletInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int'];
};

/** All input for the `deleteBlastPalletLocationByNodeId` mutation. */
export type DeleteBlastPalletLocationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `BlastPalletLocation` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteBlastPalletLocation` mutation. */
export type DeleteBlastPalletLocationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int'];
};

/** The output of our delete `BlastPalletLocation` mutation. */
export type DeleteBlastPalletLocationPayload = {
  __typename?: 'DeleteBlastPalletLocationPayload';
  /** Reads a single `Blast` that is related to this `BlastPalletLocation`. */
  blast?: Maybe<Blast>;
  /** The `BlastPalletLocation` that was deleted by this mutation. */
  blastPalletLocation?: Maybe<BlastPalletLocation>;
  /** An edge for our `BlastPalletLocation`. May be used by Relay 1. */
  blastPalletLocationEdge?: Maybe<BlastPalletLocationsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedBlastPalletLocationNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `PalletLocation` that is related to this `BlastPalletLocation`. */
  palletLocation?: Maybe<PalletLocation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `BlastPalletLocation` mutation. */
export type DeleteBlastPalletLocationPayloadBlastPalletLocationEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastPalletLocationsOrderBy>>;
};

/** The output of our delete `BlastPallet` mutation. */
export type DeleteBlastPalletPayload = {
  __typename?: 'DeleteBlastPalletPayload';
  /** Reads a single `Blast` that is related to this `BlastPallet`. */
  blast?: Maybe<Blast>;
  /** The `BlastPallet` that was deleted by this mutation. */
  blastPallet?: Maybe<BlastPallet>;
  /** An edge for our `BlastPallet`. May be used by Relay 1. */
  blastPalletEdge?: Maybe<BlastPalletsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedBlastPalletNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Pallet` that is related to this `BlastPallet`. */
  pallet?: Maybe<Pallet>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `BlastPallet` mutation. */
export type DeleteBlastPalletPayloadBlastPalletEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastPalletsOrderBy>>;
};

/** The output of our delete `Blast` mutation. */
export type DeleteBlastPayload = {
  __typename?: 'DeleteBlastPayload';
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  actualUtilization?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  automationState?: Maybe<DataPoint>;
  /** The `Blast` that was deleted by this mutation. */
  blast?: Maybe<Blast>;
  /** An edge for our `Blast`. May be used by Relay 1. */
  blastEdge?: Maybe<BlastsEdge>;
  /** Reads a single `BlastType` that is related to this `Blast`. */
  blastType?: Maybe<BlastType>;
  /** Reads a single `BuildingArea` that is related to this `Blast`. */
  buildingArea?: Maybe<BuildingArea>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Component` that is related to this `Blast`. */
  component?: Maybe<Component>;
  deletedBlastNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Facility` that is related to this `Blast`. */
  facility?: Maybe<Facility>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  idealUtilization?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  stagingTimer?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  state?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  timer?: Maybe<DataPoint>;
};

/** The output of our delete `Blast` mutation. */
export type DeleteBlastPayloadBlastEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastsOrderBy>>;
};

/** All input for the `deleteBlastRotationAlertByNodeId` mutation. */
export type DeleteBlastRotationAlertByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `BlastRotationAlert` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteBlastRotationAlert` mutation. */
export type DeleteBlastRotationAlertInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The identifer of the blast rotation alert */
  id: Scalars['Int'];
};

/** The output of our delete `BlastRotationAlert` mutation. */
export type DeleteBlastRotationAlertPayload = {
  __typename?: 'DeleteBlastRotationAlertPayload';
  /** Reads a single `BlastRotation` that is related to this `BlastRotationAlert`. */
  blastRotation?: Maybe<BlastRotation>;
  /** The `BlastRotationAlert` that was deleted by this mutation. */
  blastRotationAlert?: Maybe<BlastRotationAlert>;
  /** An edge for our `BlastRotationAlert`. May be used by Relay 1. */
  blastRotationAlertEdge?: Maybe<BlastRotationAlertsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedBlastRotationAlertNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `BlastRotationAlert` mutation. */
export type DeleteBlastRotationAlertPayloadBlastRotationAlertEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastRotationAlertsOrderBy>>;
};

/** All input for the `deleteBlastRotationByNodeId` mutation. */
export type DeleteBlastRotationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `BlastRotation` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteBlastRotationEventLogByBlastRotationIdAndDescriptionAndBlastRotationEventTypeId` mutation. */
export type DeleteBlastRotationEventLogByBlastRotationIdAndDescriptionAndBlastRotationEventTypeIdInput =
  {
    /** The type of event for this record */
    blastRotationEventTypeId: Scalars['String'];
    /** The associated blast rotation */
    blastRotationId: Scalars['Int'];
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars['String']>;
    /** A short description of the event */
    description: Scalars['String'];
  };

/** All input for the `deleteBlastRotationEventLogByNodeId` mutation. */
export type DeleteBlastRotationEventLogByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `BlastRotationEventLog` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteBlastRotationEventLog` mutation. */
export type DeleteBlastRotationEventLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int'];
};

/** The output of our delete `BlastRotationEventLog` mutation. */
export type DeleteBlastRotationEventLogPayload = {
  __typename?: 'DeleteBlastRotationEventLogPayload';
  /** Reads a single `BlastRotation` that is related to this `BlastRotationEventLog`. */
  blastRotation?: Maybe<BlastRotation>;
  /** The `BlastRotationEventLog` that was deleted by this mutation. */
  blastRotationEventLog?: Maybe<BlastRotationEventLog>;
  /** An edge for our `BlastRotationEventLog`. May be used by Relay 1. */
  blastRotationEventLogEdge?: Maybe<BlastRotationEventLogsEdge>;
  /** Reads a single `BlastRotationEventType` that is related to this `BlastRotationEventLog`. */
  blastRotationEventType?: Maybe<BlastRotationEventType>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedBlastRotationEventLogNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `BlastRotationEventLog` mutation. */
export type DeleteBlastRotationEventLogPayloadBlastRotationEventLogEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastRotationEventLogsOrderBy>>;
};

/** All input for the `deleteBlastRotationEventTypeByNodeId` mutation. */
export type DeleteBlastRotationEventTypeByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `BlastRotationEventType` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteBlastRotationEventType` mutation. */
export type DeleteBlastRotationEventTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** A unique, readable type of event that can occur within a blast rotation */
  eventType: Scalars['String'];
};

/** The output of our delete `BlastRotationEventType` mutation. */
export type DeleteBlastRotationEventTypePayload = {
  __typename?: 'DeleteBlastRotationEventTypePayload';
  /** The `BlastRotationEventType` that was deleted by this mutation. */
  blastRotationEventType?: Maybe<BlastRotationEventType>;
  /** An edge for our `BlastRotationEventType`. May be used by Relay 1. */
  blastRotationEventTypeEdge?: Maybe<BlastRotationEventTypesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedBlastRotationEventTypeNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `BlastRotationEventType` mutation. */
export type DeleteBlastRotationEventTypePayloadBlastRotationEventTypeEdgeArgs =
  {
    orderBy?: InputMaybe<Array<BlastRotationEventTypesOrderBy>>;
  };

/** All input for the `deleteBlastRotation` mutation. */
export type DeleteBlastRotationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int'];
};

/** All input for the `deleteBlastRotationPalletByBlastRotationIdAndPalletId` mutation. */
export type DeleteBlastRotationPalletByBlastRotationIdAndPalletIdInput = {
  /** The associated blast rotation */
  blastRotationId: Scalars['Int'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The associated pallet */
  palletId: Scalars['Int'];
};

/** All input for the `deleteBlastRotationPalletByNodeId` mutation. */
export type DeleteBlastRotationPalletByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `BlastRotationPallet` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteBlastRotationPallet` mutation. */
export type DeleteBlastRotationPalletInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int'];
};

/** The output of our delete `BlastRotationPallet` mutation. */
export type DeleteBlastRotationPalletPayload = {
  __typename?: 'DeleteBlastRotationPalletPayload';
  /** Reads a single `BlastRotation` that is related to this `BlastRotationPallet`. */
  blastRotation?: Maybe<BlastRotation>;
  /** The `BlastRotationPallet` that was deleted by this mutation. */
  blastRotationPallet?: Maybe<BlastRotationPallet>;
  /** An edge for our `BlastRotationPallet`. May be used by Relay 1. */
  blastRotationPalletEdge?: Maybe<BlastRotationPalletsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedBlastRotationPalletNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Pallet` that is related to this `BlastRotationPallet`. */
  pallet?: Maybe<Pallet>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `BlastRotationPallet` mutation. */
export type DeleteBlastRotationPalletPayloadBlastRotationPalletEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastRotationPalletsOrderBy>>;
};

/** The output of our delete `BlastRotation` mutation. */
export type DeleteBlastRotationPayload = {
  __typename?: 'DeleteBlastRotationPayload';
  /** Reads a single `Blast` that is related to this `BlastRotation`. */
  blast?: Maybe<Blast>;
  /** The `BlastRotation` that was deleted by this mutation. */
  blastRotation?: Maybe<BlastRotation>;
  /** An edge for our `BlastRotation`. May be used by Relay 1. */
  blastRotationEdge?: Maybe<BlastRotationsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedBlastRotationNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `BlastRotation` mutation. */
export type DeleteBlastRotationPayloadBlastRotationEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastRotationsOrderBy>>;
};

/** All input for the `deleteBlastTypeByNodeId` mutation. */
export type DeleteBlastTypeByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `BlastType` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteBlastType` mutation. */
export type DeleteBlastTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int'];
};

/** The output of our delete `BlastType` mutation. */
export type DeleteBlastTypePayload = {
  __typename?: 'DeleteBlastTypePayload';
  /** The `BlastType` that was deleted by this mutation. */
  blastType?: Maybe<BlastType>;
  /** An edge for our `BlastType`. May be used by Relay 1. */
  blastTypeEdge?: Maybe<BlastTypesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedBlastTypeNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `BlastType` mutation. */
export type DeleteBlastTypePayloadBlastTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastTypesOrderBy>>;
};

/** All input for the `deleteBuildingAreaByFacilityIdAndLabel` mutation. */
export type DeleteBuildingAreaByFacilityIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** This represents the facility that the building area belongs to. */
  facilityId: Scalars['Int'];
  /** Human-readable label for the building area. */
  label: Scalars['String'];
};

/** All input for the `deleteBuildingAreaByNodeId` mutation. */
export type DeleteBuildingAreaByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `BuildingArea` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteBuildingAreaComplianceGroupByBuildingAreaIdAndComplianceType` mutation. */
export type DeleteBuildingAreaComplianceGroupByBuildingAreaIdAndComplianceTypeInput =
  {
    /** The building area the compliance group applies to */
    buildingAreaId: Scalars['Int'];
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars['String']>;
    /** The type of compliance group for this relationship */
    complianceType: ComplianceType;
  };

/** All input for the `deleteBuildingAreaComplianceGroupByNodeId` mutation. */
export type DeleteBuildingAreaComplianceGroupByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `BuildingAreaComplianceGroup` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteBuildingAreaComplianceGroup` mutation. */
export type DeleteBuildingAreaComplianceGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The id of the building area compliance group */
  id: Scalars['Int'];
};

/** The output of our delete `BuildingAreaComplianceGroup` mutation. */
export type DeleteBuildingAreaComplianceGroupPayload = {
  __typename?: 'DeleteBuildingAreaComplianceGroupPayload';
  /** Reads a single `BuildingArea` that is related to this `BuildingAreaComplianceGroup`. */
  buildingArea?: Maybe<BuildingArea>;
  /** The `BuildingAreaComplianceGroup` that was deleted by this mutation. */
  buildingAreaComplianceGroup?: Maybe<BuildingAreaComplianceGroup>;
  /** An edge for our `BuildingAreaComplianceGroup`. May be used by Relay 1. */
  buildingAreaComplianceGroupEdge?: Maybe<BuildingAreaComplianceGroupsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `ComplianceGroup` that is related to this `BuildingAreaComplianceGroup`. */
  complianceGroup?: Maybe<ComplianceGroup>;
  deletedBuildingAreaComplianceGroupNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `BuildingAreaComplianceGroup` mutation. */
export type DeleteBuildingAreaComplianceGroupPayloadBuildingAreaComplianceGroupEdgeArgs =
  {
    orderBy?: InputMaybe<Array<BuildingAreaComplianceGroupsOrderBy>>;
  };

/** All input for the `deleteBuildingArea` mutation. */
export type DeleteBuildingAreaInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `BuildingArea` mutation. */
export type DeleteBuildingAreaPayload = {
  __typename?: 'DeleteBuildingAreaPayload';
  /** The `BuildingArea` that was deleted by this mutation. */
  buildingArea?: Maybe<BuildingArea>;
  /** An edge for our `BuildingArea`. May be used by Relay 1. */
  buildingAreaEdge?: Maybe<BuildingAreasEdge>;
  /** Reads a single `BuildingAreaType` that is related to this `BuildingArea`. */
  buildingAreaType?: Maybe<BuildingAreaType>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedBuildingAreaNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Facility` that is related to this `BuildingArea`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `BuildingArea` mutation. */
export type DeleteBuildingAreaPayloadBuildingAreaEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingAreasOrderBy>>;
};

/** All input for the `deleteBuildingAreaTypeByNodeId` mutation. */
export type DeleteBuildingAreaTypeByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `BuildingAreaType` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteBuildingAreaType` mutation. */
export type DeleteBuildingAreaTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The short name of the building area type. */
  type: Scalars['String'];
};

/** The output of our delete `BuildingAreaType` mutation. */
export type DeleteBuildingAreaTypePayload = {
  __typename?: 'DeleteBuildingAreaTypePayload';
  /** The `BuildingAreaType` that was deleted by this mutation. */
  buildingAreaType?: Maybe<BuildingAreaType>;
  /** An edge for our `BuildingAreaType`. May be used by Relay 1. */
  buildingAreaTypeEdge?: Maybe<BuildingAreaTypesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedBuildingAreaTypeNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `BuildingAreaType` mutation. */
export type DeleteBuildingAreaTypePayloadBuildingAreaTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingAreaTypesOrderBy>>;
};

/** All input for the `deleteChartByNodeId` mutation. */
export type DeleteChartByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Chart` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteChart` mutation. */
export type DeleteChartInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `Chart` mutation. */
export type DeleteChartPayload = {
  __typename?: 'DeleteChartPayload';
  /** The `Chart` that was deleted by this mutation. */
  chart?: Maybe<Chart>;
  /** An edge for our `Chart`. May be used by Relay 1. */
  chartEdge?: Maybe<ChartsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedChartNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Facility` that is related to this `Chart`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `Chart` mutation. */
export type DeleteChartPayloadChartEdgeArgs = {
  orderBy?: InputMaybe<Array<ChartsOrderBy>>;
};

/** All input for the `deleteComplianceGroupByLabel` mutation. */
export type DeleteComplianceGroupByLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The unique label of the compliance group (ex: Freezer, Cooler, Ice Cream Freezer) */
  label: Scalars['String'];
};

/** All input for the `deleteComplianceGroupByNodeId` mutation. */
export type DeleteComplianceGroupByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ComplianceGroup` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteComplianceGroup` mutation. */
export type DeleteComplianceGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The id of the compliance group */
  id: Scalars['Int'];
};

/** The output of our delete `ComplianceGroup` mutation. */
export type DeleteComplianceGroupPayload = {
  __typename?: 'DeleteComplianceGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ComplianceGroup` that was deleted by this mutation. */
  complianceGroup?: Maybe<ComplianceGroup>;
  /** An edge for our `ComplianceGroup`. May be used by Relay 1. */
  complianceGroupEdge?: Maybe<ComplianceGroupsEdge>;
  deletedComplianceGroupNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `ComplianceGroup` mutation. */
export type DeleteComplianceGroupPayloadComplianceGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<ComplianceGroupsOrderBy>>;
};

/** All input for the `deleteComplianceRangeByComplianceGroupIdAndLabel` mutation. */
export type DeleteComplianceRangeByComplianceGroupIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The group this compliance range belongs to */
  complianceGroupId: Scalars['Int'];
  /** The unique label of the compliance range (ex: Out of Compliance, Above Compliance) */
  label: Scalars['String'];
};

/** All input for the `deleteComplianceRangeByNodeId` mutation. */
export type DeleteComplianceRangeByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ComplianceRange` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteComplianceRange` mutation. */
export type DeleteComplianceRangeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The id of the compliance range */
  id: Scalars['Int'];
};

/** The output of our delete `ComplianceRange` mutation. */
export type DeleteComplianceRangePayload = {
  __typename?: 'DeleteComplianceRangePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `ComplianceGroup` that is related to this `ComplianceRange`. */
  complianceGroup?: Maybe<ComplianceGroup>;
  /** The `ComplianceRange` that was deleted by this mutation. */
  complianceRange?: Maybe<ComplianceRange>;
  /** An edge for our `ComplianceRange`. May be used by Relay 1. */
  complianceRangeEdge?: Maybe<ComplianceRangesEdge>;
  deletedComplianceRangeNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `ComplianceRange` mutation. */
export type DeleteComplianceRangePayloadComplianceRangeEdgeArgs = {
  orderBy?: InputMaybe<Array<ComplianceRangesOrderBy>>;
};

/** All input for the `deleteComponentByNodeId` mutation. */
export type DeleteComponentByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Component` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteComponent` mutation. */
export type DeleteComponentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The identifier of the component */
  id: Scalars['Int'];
};

/** The output of our delete `Component` mutation. */
export type DeleteComponentPayload = {
  __typename?: 'DeleteComponentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Component` that was deleted by this mutation. */
  component?: Maybe<Component>;
  /** An edge for our `Component`. May be used by Relay 1. */
  componentEdge?: Maybe<ComponentsEdge>;
  deletedComponentNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Facility` that is related to this `Component`. */
  facility?: Maybe<Facility>;
  /** Reads a single `MachineUser` that is related to this `Component`. */
  machineUser?: Maybe<MachineUser>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `Component` mutation. */
export type DeleteComponentPayloadComponentEdgeArgs = {
  orderBy?: InputMaybe<Array<ComponentsOrderBy>>;
};

/** All input for the `deleteCompressorByFacilityIdAndLabel` mutation. */
export type DeleteCompressorByFacilityIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The facility a compressor is installed within */
  facilityId: Scalars['Int'];
  /** A human-readable label for a compressor */
  label: Scalars['String'];
};

/** All input for the `deleteCompressorByNodeId` mutation. */
export type DeleteCompressorByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Compressor` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteCompressor` mutation. */
export type DeleteCompressorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The id of the compressor. */
  id: Scalars['Int'];
};

/** The output of our delete `Compressor` mutation. */
export type DeleteCompressorPayload = {
  __typename?: 'DeleteCompressorPayload';
  /** Reads a single `BuildingArea` that is related to this `Compressor`. */
  buildingArea?: Maybe<BuildingArea>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  capacity?: Maybe<DataPoint>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Compressor` that was deleted by this mutation. */
  compressor?: Maybe<Compressor>;
  /** An edge for our `Compressor`. May be used by Relay 1. */
  compressorEdge?: Maybe<CompressorsEdge>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  controlMode?: Maybe<DataPoint>;
  deletedCompressorNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  differentialPressure?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  dischargePressure?: Maybe<DataPoint>;
  /** Reads a single `Facility` that is related to this `Compressor`. */
  facility?: Maybe<Facility>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  kwDemand?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  motorAmps?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  motorState?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  oilPressure?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  oilTemperature?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  runtimeHours?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  setpoint?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  slideValvePosition?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  state?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  suctionPressure?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  suctionTemperature?: Maybe<DataPoint>;
};

/** The output of our delete `Compressor` mutation. */
export type DeleteCompressorPayloadCompressorEdgeArgs = {
  orderBy?: InputMaybe<Array<CompressorsOrderBy>>;
};

/** All input for the `deleteControlEventByNodeId` mutation. */
export type DeleteControlEventByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ControlEvent` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteControlEvent` mutation. */
export type DeleteControlEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The identifier of the control event */
  id: Scalars['Int'];
};

/** All input for the `deleteControlEventLogByNodeId` mutation. */
export type DeleteControlEventLogByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ControlEventLog` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteControlEventLog` mutation. */
export type DeleteControlEventLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The identifier of the control event log entry */
  id: Scalars['Int'];
};

/** The output of our delete `ControlEventLog` mutation. */
export type DeleteControlEventLogPayload = {
  __typename?: 'DeleteControlEventLogPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `ControlEvent` that is related to this `ControlEventLog`. */
  controlEvent?: Maybe<ControlEvent>;
  /** The `ControlEventLog` that was deleted by this mutation. */
  controlEventLog?: Maybe<ControlEventLog>;
  /** An edge for our `ControlEventLog`. May be used by Relay 1. */
  controlEventLogEdge?: Maybe<ControlEventLogsEdge>;
  deletedControlEventLogNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `ControlEventLog` mutation. */
export type DeleteControlEventLogPayloadControlEventLogEdgeArgs = {
  orderBy?: InputMaybe<Array<ControlEventLogsOrderBy>>;
};

/** The output of our delete `ControlEvent` mutation. */
export type DeleteControlEventPayload = {
  __typename?: 'DeleteControlEventPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Component` that is related to this `ControlEvent`. */
  component?: Maybe<Component>;
  /** The `ControlEvent` that was deleted by this mutation. */
  controlEvent?: Maybe<ControlEvent>;
  /** An edge for our `ControlEvent`. May be used by Relay 1. */
  controlEventEdge?: Maybe<ControlEventsEdge>;
  deletedControlEventNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `ControlEvent` mutation. */
export type DeleteControlEventPayloadControlEventEdgeArgs = {
  orderBy?: InputMaybe<Array<ControlEventsOrderBy>>;
};

/** All input for the `deleteCustomerByNodeId` mutation. */
export type DeleteCustomerByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Customer` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteCustomerBySourceId` mutation. */
export type DeleteCustomerBySourceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String'];
};

/** All input for the `deleteCustomer` mutation. */
export type DeleteCustomerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['BigInt'];
};

/** The output of our delete `Customer` mutation. */
export type DeleteCustomerPayload = {
  __typename?: 'DeleteCustomerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Customer` that was deleted by this mutation. */
  customer?: Maybe<Customer>;
  /** An edge for our `Customer`. May be used by Relay 1. */
  customerEdge?: Maybe<CustomersEdge>;
  deletedCustomerNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Facility` that is related to this `Customer`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `Customer` mutation. */
export type DeleteCustomerPayloadCustomerEdgeArgs = {
  orderBy?: InputMaybe<Array<CustomersOrderBy>>;
};

/** All input for the `deleteDashboardByNodeId` mutation. */
export type DeleteDashboardByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Dashboard` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteDashboard` mutation. */
export type DeleteDashboardInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `Dashboard` mutation. */
export type DeleteDashboardPayload = {
  __typename?: 'DeleteDashboardPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Dashboard` that was deleted by this mutation. */
  dashboard?: Maybe<Dashboard>;
  /** An edge for our `Dashboard`. May be used by Relay 1. */
  dashboardEdge?: Maybe<DashboardsEdge>;
  deletedDashboardNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Facility` that is related to this `Dashboard`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `Dashboard` mutation. */
export type DeleteDashboardPayloadDashboardEdgeArgs = {
  orderBy?: InputMaybe<Array<DashboardsOrderBy>>;
};

/** All input for the `deleteDataPointByDataSourceNameAndName` mutation. */
export type DeleteDataPointByDataSourceNameAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The name of the data source. */
  dataSourceName: Scalars['String'];
  /** The name of the data point. */
  name: Scalars['String'];
};

/** All input for the `deleteDataPointByNodeId` mutation. */
export type DeleteDataPointByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `DataPoint` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteDataPoint` mutation. */
export type DeleteDataPointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['BigInt'];
};

/** The output of our delete `DataPoint` mutation. */
export type DeleteDataPointPayload = {
  __typename?: 'DeleteDataPointPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `DataPoint` that was deleted by this mutation. */
  dataPoint?: Maybe<DataPoint>;
  /** An edge for our `DataPoint`. May be used by Relay 1. */
  dataPointEdge?: Maybe<DataPointsEdge>;
  /** Reads a single `DataSource` that is related to this `DataPoint`. */
  dataSourceByDataSourceName?: Maybe<DataSource>;
  deletedDataPointNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `DataPoint` mutation. */
export type DeleteDataPointPayloadDataPointEdgeArgs = {
  orderBy?: InputMaybe<Array<DataPointsOrderBy>>;
};

/** All input for the `deleteDataSourceByNodeId` mutation. */
export type DeleteDataSourceByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `DataSource` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteDataSource` mutation. */
export type DeleteDataSourceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The data source name. */
  name: Scalars['String'];
};

/** The output of our delete `DataSource` mutation. */
export type DeleteDataSourcePayload = {
  __typename?: 'DeleteDataSourcePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `DataSource` that was deleted by this mutation. */
  dataSource?: Maybe<DataSource>;
  /** An edge for our `DataSource`. May be used by Relay 1. */
  dataSourceEdge?: Maybe<DataSourcesEdge>;
  deletedDataSourceNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `DataSource` mutation. */
export type DeleteDataSourcePayloadDataSourceEdgeArgs = {
  orderBy?: InputMaybe<Array<DataSourcesOrderBy>>;
};

/** All input for the `deleteDependencyByNodeId` mutation. */
export type DeleteDependencyByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Dependency` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteDependencyByPath` mutation. */
export type DeleteDependencyByPathInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  path: Scalars['String'];
};

/** All input for the `deleteDependency` mutation. */
export type DeleteDependencyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['BigInt'];
};

/** The output of our delete `Dependency` mutation. */
export type DeleteDependencyPayload = {
  __typename?: 'DeleteDependencyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedDependencyNodeId?: Maybe<Scalars['ID']>;
  /** The `Dependency` that was deleted by this mutation. */
  dependency?: Maybe<Dependency>;
  /** An edge for our `Dependency`. May be used by Relay 1. */
  dependencyEdge?: Maybe<DependenciesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `Dependency` mutation. */
export type DeleteDependencyPayloadDependencyEdgeArgs = {
  orderBy?: InputMaybe<Array<DependenciesOrderBy>>;
};

/** All input for the `deleteDoorByFacilityIdAndLabel` mutation. */
export type DeleteDoorByFacilityIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The facility where the door is located */
  facilityId: Scalars['Int'];
  /** The Human-readable label for the door */
  label: Scalars['String'];
};

/** All input for the `deleteDoorByNodeId` mutation. */
export type DeleteDoorByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Door` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteDoor` mutation. */
export type DeleteDoorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The id of the door */
  id: Scalars['Int'];
};

/** The output of our delete `Door` mutation. */
export type DeleteDoorPayload = {
  __typename?: 'DeleteDoorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedDoorNodeId?: Maybe<Scalars['ID']>;
  /** The `Door` that was deleted by this mutation. */
  door?: Maybe<Door>;
  /** An edge for our `Door`. May be used by Relay 1. */
  doorEdge?: Maybe<DoorsEdge>;
  /** Reads a single `DataPoint` that is related to this `Door`. */
  doorState?: Maybe<DataPoint>;
  /** Reads a single `Facility` that is related to this `Door`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `Door` mutation. */
export type DeleteDoorPayloadDoorEdgeArgs = {
  orderBy?: InputMaybe<Array<DoorsOrderBy>>;
};

/** All input for the `deleteEvaporatorByFacilityIdAndLabel` mutation. */
export type DeleteEvaporatorByFacilityIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The facility an evaporator is installed within */
  facilityId: Scalars['Int'];
  /** A human-readable label */
  label: Scalars['String'];
};

/** All input for the `deleteEvaporatorByNodeId` mutation. */
export type DeleteEvaporatorByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Evaporator` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteEvaporator` mutation. */
export type DeleteEvaporatorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The id of the evaporator */
  id: Scalars['Int'];
};

/** The output of our delete `Evaporator` mutation. */
export type DeleteEvaporatorPayload = {
  __typename?: 'DeleteEvaporatorPayload';
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  ammoniaState?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  bleedSolenoid?: Maybe<DataPoint>;
  /** Reads a single `BuildingArea` that is related to this `Evaporator`. */
  buildingArea?: Maybe<BuildingArea>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  defrostState?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  defrostTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  defrostTimer?: Maybe<DataPoint>;
  deletedEvaporatorNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  differentialAirTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  estimatedKwDemand?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  evapState?: Maybe<DataPoint>;
  /** The `Evaporator` that was deleted by this mutation. */
  evaporator?: Maybe<Evaporator>;
  /** An edge for our `Evaporator`. May be used by Relay 1. */
  evaporatorEdge?: Maybe<EvaporatorsEdge>;
  /** Reads a single `Facility` that is related to this `Evaporator`. */
  facility?: Maybe<Facility>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  fanState?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  fanTimer?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  hotGasSolenoid?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  liquidFeedRuntime?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  liquidFeedRuntimeSetpoint?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  liquidSolenoid?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  returnAirTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  setpoint?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  softHotGasSolenoid?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  suctionSolenoid?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  suctionTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  supplyAirTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  zoneTemperature?: Maybe<DataPoint>;
};

/** The output of our delete `Evaporator` mutation. */
export type DeleteEvaporatorPayloadEvaporatorEdgeArgs = {
  orderBy?: InputMaybe<Array<EvaporatorsOrderBy>>;
};

/** All input for the `deleteFacilityByNodeId` mutation. */
export type DeleteFacilityByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Facility` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteFacilityBySlug` mutation. */
export type DeleteFacilityBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The facility’s slug. */
  slug: Scalars['String'];
};

/** All input for the `deleteFacilityConfig` mutation. */
export type DeleteFacilityConfigInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  facilityId?: InputMaybe<Scalars['Int']>;
  key?: InputMaybe<Scalars['String']>;
};

/** The output of our `deleteFacilityConfig` mutation. */
export type DeleteFacilityConfigPayload = {
  __typename?: 'DeleteFacilityConfigPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteFacilityDataSourceByNodeId` mutation. */
export type DeleteFacilityDataSourceByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `FacilityDataSource` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteFacilityDataSource` mutation. */
export type DeleteFacilityDataSourceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The data source for the facility. */
  dataSourceName: Scalars['String'];
  /** The facility id for the data source. */
  facilityId: Scalars['Int'];
};

/** The output of our delete `FacilityDataSource` mutation. */
export type DeleteFacilityDataSourcePayload = {
  __typename?: 'DeleteFacilityDataSourcePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `DataSource` that is related to this `FacilityDataSource`. */
  dataSourceByDataSourceName?: Maybe<DataSource>;
  deletedFacilityDataSourceNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Facility` that is related to this `FacilityDataSource`. */
  facility?: Maybe<Facility>;
  /** The `FacilityDataSource` that was deleted by this mutation. */
  facilityDataSource?: Maybe<FacilityDataSource>;
  /** An edge for our `FacilityDataSource`. May be used by Relay 1. */
  facilityDataSourceEdge?: Maybe<FacilityDataSourcesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `FacilityDataSource` mutation. */
export type DeleteFacilityDataSourcePayloadFacilityDataSourceEdgeArgs = {
  orderBy?: InputMaybe<Array<FacilityDataSourcesOrderBy>>;
};

/** All input for the `deleteFacilityGroupByNodeId` mutation. */
export type DeleteFacilityGroupByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `FacilityGroup` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteFacilityGroup` mutation. */
export type DeleteFacilityGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The facility group’s id. */
  id: Scalars['BigInt'];
};

/** The output of our delete `FacilityGroup` mutation. */
export type DeleteFacilityGroupPayload = {
  __typename?: 'DeleteFacilityGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedFacilityGroupNodeId?: Maybe<Scalars['ID']>;
  /** The `FacilityGroup` that was deleted by this mutation. */
  facilityGroup?: Maybe<FacilityGroup>;
  /** An edge for our `FacilityGroup`. May be used by Relay 1. */
  facilityGroupEdge?: Maybe<FacilityGroupsEdge>;
  /** Reads a single `FacilityGroup` that is related to this `FacilityGroup`. */
  parent?: Maybe<FacilityGroup>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `FacilityGroup` mutation. */
export type DeleteFacilityGroupPayloadFacilityGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<FacilityGroupsOrderBy>>;
};

/** All input for the `deleteFacilityGroupsLinkerByNodeId` mutation. */
export type DeleteFacilityGroupsLinkerByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `FacilityGroupsLinker` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteFacilityGroupsLinker` mutation. */
export type DeleteFacilityGroupsLinkerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  facilityGroupingId: Scalars['BigInt'];
  facilityId: Scalars['Int'];
};

/** The output of our delete `FacilityGroupsLinker` mutation. */
export type DeleteFacilityGroupsLinkerPayload = {
  __typename?: 'DeleteFacilityGroupsLinkerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedFacilityGroupsLinkerNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Facility` that is related to this `FacilityGroupsLinker`. */
  facility?: Maybe<Facility>;
  /** Reads a single `FacilityGroup` that is related to this `FacilityGroupsLinker`. */
  facilityGrouping?: Maybe<FacilityGroup>;
  /** The `FacilityGroupsLinker` that was deleted by this mutation. */
  facilityGroupsLinker?: Maybe<FacilityGroupsLinker>;
  /** An edge for our `FacilityGroupsLinker`. May be used by Relay 1. */
  facilityGroupsLinkerEdge?: Maybe<FacilityGroupsLinkersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `FacilityGroupsLinker` mutation. */
export type DeleteFacilityGroupsLinkerPayloadFacilityGroupsLinkerEdgeArgs = {
  orderBy?: InputMaybe<Array<FacilityGroupsLinkersOrderBy>>;
};

/** All input for the `deleteFacility` mutation. */
export type DeleteFacilityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The primary unique identifier for the facility. */
  id: Scalars['Int'];
};

/** The output of our delete `Facility` mutation. */
export type DeleteFacilityPayload = {
  __typename?: 'DeleteFacilityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedFacilityNodeId?: Maybe<Scalars['ID']>;
  /** The `Facility` that was deleted by this mutation. */
  facility?: Maybe<Facility>;
  /** An edge for our `Facility`. May be used by Relay 1. */
  facilityEdge?: Maybe<FacilitiesEdge>;
  /** Reads a single `PricingNode` that is related to this `Facility`. */
  pricingNode?: Maybe<PricingNode>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Timezone` that is related to this `Facility`. */
  timezone?: Maybe<Timezone>;
  /** Reads a single `UnitGroup` that is related to this `Facility`. */
  unitGroupByUnitGroup?: Maybe<UnitGroup>;
};

/** The output of our delete `Facility` mutation. */
export type DeleteFacilityPayloadFacilityEdgeArgs = {
  orderBy?: InputMaybe<Array<FacilitiesOrderBy>>;
};

/** All input for the `deleteFacilityTaggedDataPointByNodeId` mutation. */
export type DeleteFacilityTaggedDataPointByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `FacilityTaggedDataPoint` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteFacilityTaggedDataPoint` mutation. */
export type DeleteFacilityTaggedDataPointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `FacilityTaggedDataPoint` mutation. */
export type DeleteFacilityTaggedDataPointPayload = {
  __typename?: 'DeleteFacilityTaggedDataPointPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `DataPoint` that is related to this `FacilityTaggedDataPoint`. */
  dataPoint?: Maybe<DataPoint>;
  deletedFacilityTaggedDataPointNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Facility` that is related to this `FacilityTaggedDataPoint`. */
  facility?: Maybe<Facility>;
  /** The `FacilityTaggedDataPoint` that was deleted by this mutation. */
  facilityTaggedDataPoint?: Maybe<FacilityTaggedDataPoint>;
  /** An edge for our `FacilityTaggedDataPoint`. May be used by Relay 1. */
  facilityTaggedDataPointEdge?: Maybe<FacilityTaggedDataPointsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPointTag` that is related to this `FacilityTaggedDataPoint`. */
  tag?: Maybe<DataPointTag>;
};

/** The output of our delete `FacilityTaggedDataPoint` mutation. */
export type DeleteFacilityTaggedDataPointPayloadFacilityTaggedDataPointEdgeArgs =
  {
    orderBy?: InputMaybe<Array<FacilityTaggedDataPointsOrderBy>>;
  };

/** All input for the `deleteInboundOutboundLoadByFacilityIdAndDirectionAndSourceId` mutation. */
export type DeleteInboundOutboundLoadByFacilityIdAndDirectionAndSourceIdInput =
  {
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars['String']>;
    /** The direction of load */
    direction: WmsLoadDirectionType;
    /** The facility where the order occurred */
    facilityId: Scalars['Int'];
    /** The globally unique external identifier of the record from the original source system */
    sourceId: Scalars['String'];
  };

/** All input for the `deleteInboundOutboundLoadByNodeId` mutation. */
export type DeleteInboundOutboundLoadByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `InboundOutboundLoad` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteInboundOutboundLoad` mutation. */
export type DeleteInboundOutboundLoadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['BigInt'];
};

/** The output of our delete `InboundOutboundLoad` mutation. */
export type DeleteInboundOutboundLoadPayload = {
  __typename?: 'DeleteInboundOutboundLoadPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedInboundOutboundLoadNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Facility` that is related to this `InboundOutboundLoad`. */
  facility?: Maybe<Facility>;
  /** The `InboundOutboundLoad` that was deleted by this mutation. */
  inboundOutboundLoad?: Maybe<InboundOutboundLoad>;
  /** An edge for our `InboundOutboundLoad`. May be used by Relay 1. */
  inboundOutboundLoadEdge?: Maybe<InboundOutboundLoadsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `InboundOutboundLoad` mutation. */
export type DeleteInboundOutboundLoadPayloadInboundOutboundLoadEdgeArgs = {
  orderBy?: InputMaybe<Array<InboundOutboundLoadsOrderBy>>;
};

/** All input for the `deleteMachineUserByNodeId` mutation. */
export type DeleteMachineUserByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `MachineUser` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteMachineUser` mutation. */
export type DeleteMachineUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The identifier of the machine user. */
  id: Scalars['BigInt'];
};

/** The output of our delete `MachineUser` mutation. */
export type DeleteMachineUserPayload = {
  __typename?: 'DeleteMachineUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedMachineUserNodeId?: Maybe<Scalars['ID']>;
  /** The `MachineUser` that was deleted by this mutation. */
  machineUser?: Maybe<MachineUser>;
  /** An edge for our `MachineUser`. May be used by Relay 1. */
  machineUserEdge?: Maybe<MachineUsersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `MachineUser` mutation. */
export type DeleteMachineUserPayloadMachineUserEdgeArgs = {
  orderBy?: InputMaybe<Array<MachineUsersOrderBy>>;
};

/** All input for the `deleteMainServiceByFacilityIdAndName` mutation. */
export type DeleteMainServiceByFacilityIdAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The facility this main service belongs to */
  facilityId: Scalars['Int'];
  /** The name for this main service */
  name: Scalars['String'];
};

/** All input for the `deleteMainServiceByFacilityIdAndUsageDataPointIdAndDemandDataPointId` mutation. */
export type DeleteMainServiceByFacilityIdAndUsageDataPointIdAndDemandDataPointIdInput =
  {
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars['String']>;
    /** The demand data point that represents this main service's contribution to/from the facility */
    demandDataPointId: Scalars['Int'];
    /** The facility this main service belongs to */
    facilityId: Scalars['Int'];
    /** The usage data point that represents this main service's contribution to/from the facility */
    usageDataPointId: Scalars['Int'];
  };

/** All input for the `deleteMainServiceByNodeId` mutation. */
export type DeleteMainServiceByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `MainService` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteMainService` mutation. */
export type DeleteMainServiceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The id of the main service */
  id: Scalars['Int'];
};

/** The output of our delete `MainService` mutation. */
export type DeleteMainServicePayload = {
  __typename?: 'DeleteMainServicePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedMainServiceNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  demand?: Maybe<DataPoint>;
  /** Reads a single `Facility` that is related to this `MainService`. */
  facility?: Maybe<Facility>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  gridDemand?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  gridUsage?: Maybe<DataPoint>;
  /** The `MainService` that was deleted by this mutation. */
  mainService?: Maybe<MainService>;
  /** An edge for our `MainService`. May be used by Relay 1. */
  mainServiceEdge?: Maybe<MainServicesEdge>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  meterDemand?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  meterUsage?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  usage?: Maybe<DataPoint>;
};

/** The output of our delete `MainService` mutation. */
export type DeleteMainServicePayloadMainServiceEdgeArgs = {
  orderBy?: InputMaybe<Array<MainServicesOrderBy>>;
};

/** All input for the `deleteMeterCharge` mutation. */
export type DeleteMeterChargeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our `deleteMeterCharge` mutation. */
export type DeleteMeterChargePayload = {
  __typename?: 'DeleteMeterChargePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deleted?: Maybe<Scalars['Boolean']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteMeterStatement` mutation. */
export type DeleteMeterStatementInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our `deleteMeterStatement` mutation. */
export type DeleteMeterStatementPayload = {
  __typename?: 'DeleteMeterStatementPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deleted?: Maybe<Scalars['Boolean']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteMeterUsage` mutation. */
export type DeleteMeterUsageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our `deleteMeterUsage` mutation. */
export type DeleteMeterUsagePayload = {
  __typename?: 'DeleteMeterUsagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deleted?: Maybe<Scalars['Boolean']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deletePalletByNodeId` mutation. */
export type DeletePalletByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Pallet` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deletePalletBySourceId` mutation. */
export type DeletePalletBySourceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String'];
};

/** All input for the `deletePalletHistoryByNodeId` mutation. */
export type DeletePalletHistoryByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PalletHistory` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deletePalletHistoryBySourceId` mutation. */
export type DeletePalletHistoryBySourceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String'];
};

/** All input for the `deletePalletHistory` mutation. */
export type DeletePalletHistoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['BigInt'];
};

/** The output of our delete `PalletHistory` mutation. */
export type DeletePalletHistoryPayload = {
  __typename?: 'DeletePalletHistoryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedPalletHistoryNodeId?: Maybe<Scalars['ID']>;
  /** The `PalletHistory` that was deleted by this mutation. */
  palletHistory?: Maybe<PalletHistory>;
  /** An edge for our `PalletHistory`. May be used by Relay 1. */
  palletHistoryEdge?: Maybe<PalletHistoriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `PalletHistory` mutation. */
export type DeletePalletHistoryPayloadPalletHistoryEdgeArgs = {
  orderBy?: InputMaybe<Array<PalletHistoriesOrderBy>>;
};

/** All input for the `deletePallet` mutation. */
export type DeletePalletInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['BigInt'];
};

/** All input for the `deletePalletLocationByNodeId` mutation. */
export type DeletePalletLocationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PalletLocation` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deletePalletLocationBySourceId` mutation. */
export type DeletePalletLocationBySourceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String'];
};

/** All input for the `deletePalletLocation` mutation. */
export type DeletePalletLocationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['BigInt'];
};

/** The output of our delete `PalletLocation` mutation. */
export type DeletePalletLocationPayload = {
  __typename?: 'DeletePalletLocationPayload';
  /** Reads a single `BuildingArea` that is related to this `PalletLocation`. */
  buildingArea?: Maybe<BuildingArea>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedPalletLocationNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Facility` that is related to this `PalletLocation`. */
  facility?: Maybe<Facility>;
  /** The `PalletLocation` that was deleted by this mutation. */
  palletLocation?: Maybe<PalletLocation>;
  /** An edge for our `PalletLocation`. May be used by Relay 1. */
  palletLocationEdge?: Maybe<PalletLocationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `PalletLocation` mutation. */
export type DeletePalletLocationPayloadPalletLocationEdgeArgs = {
  orderBy?: InputMaybe<Array<PalletLocationsOrderBy>>;
};

/** The output of our delete `Pallet` mutation. */
export type DeletePalletPayload = {
  __typename?: 'DeletePalletPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedPalletNodeId?: Maybe<Scalars['ID']>;
  /** The `Pallet` that was deleted by this mutation. */
  pallet?: Maybe<Pallet>;
  /** An edge for our `Pallet`. May be used by Relay 1. */
  palletEdge?: Maybe<PalletsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `Pallet` mutation. */
export type DeletePalletPayloadPalletEdgeArgs = {
  orderBy?: InputMaybe<Array<PalletsOrderBy>>;
};

export type DeletePhoneNumberInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type DeletePhoneNumberResponse = {
  __typename?: 'DeletePhoneNumberResponse';
  clientMutationId?: Maybe<Scalars['String']>;
  user: User;
};

/** All input for the `deletePricingNodeByNodeId` mutation. */
export type DeletePricingNodeByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PricingNode` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deletePricingNode` mutation. */
export type DeletePricingNodeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The identifer of the pricing node. */
  id: Scalars['Int'];
};

/** The output of our delete `PricingNode` mutation. */
export type DeletePricingNodePayload = {
  __typename?: 'DeletePricingNodePayload';
  /** Reads a single `BalancingAuthority` that is related to this `PricingNode`. */
  balancingAuthority?: Maybe<BalancingAuthority>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedPricingNodeNodeId?: Maybe<Scalars['ID']>;
  /** The `PricingNode` that was deleted by this mutation. */
  pricingNode?: Maybe<PricingNode>;
  /** An edge for our `PricingNode`. May be used by Relay 1. */
  pricingNodeEdge?: Maybe<PricingNodesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `PricingNode` mutation. */
export type DeletePricingNodePayloadPricingNodeEdgeArgs = {
  orderBy?: InputMaybe<Array<PricingNodesOrderBy>>;
};

/** All input for the `deleteProductByNodeId` mutation. */
export type DeleteProductByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Product` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteProductBySourceId` mutation. */
export type DeleteProductBySourceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String'];
};

/** All input for the `deleteProduct` mutation. */
export type DeleteProductInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['BigInt'];
};

/** The output of our delete `Product` mutation. */
export type DeleteProductPayload = {
  __typename?: 'DeleteProductPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedProductNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Facility` that is related to this `Product`. */
  facility?: Maybe<Facility>;
  /** The `Product` that was deleted by this mutation. */
  product?: Maybe<Product>;
  /** An edge for our `Product`. May be used by Relay 1. */
  productEdge?: Maybe<ProductsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `Product` mutation. */
export type DeleteProductPayloadProductEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};

/** All input for the `deleteProgramByNodeId` mutation. */
export type DeleteProgramByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Program` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteProgramByProjectTypeIdAndName` mutation. */
export type DeleteProgramByProjectTypeIdAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The name of the program. */
  name: Scalars['String'];
  /** The id of the project type the program is associated with. */
  projectTypeId: Scalars['Int'];
};

/** All input for the `deleteProgramEnrollmentByNodeId` mutation. */
export type DeleteProgramEnrollmentByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProgramEnrollment` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteProgramEnrollmentByProgramIdAndName` mutation. */
export type DeleteProgramEnrollmentByProgramIdAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The name of this program enrollment. */
  name: Scalars['String'];
  /** The program this program enrollment belongs to. */
  programId: Scalars['Int'];
};

/** All input for the `deleteProgramEnrollment` mutation. */
export type DeleteProgramEnrollmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The identifer of the program enrollment. */
  id: Scalars['Int'];
};

/** The output of our delete `ProgramEnrollment` mutation. */
export type DeleteProgramEnrollmentPayload = {
  __typename?: 'DeleteProgramEnrollmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedProgramEnrollmentNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Program` that is related to this `ProgramEnrollment`. */
  program?: Maybe<Program>;
  /** The `ProgramEnrollment` that was deleted by this mutation. */
  programEnrollment?: Maybe<ProgramEnrollment>;
  /** An edge for our `ProgramEnrollment`. May be used by Relay 1. */
  programEnrollmentEdge?: Maybe<ProgramEnrollmentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `ProgramEnrollment` mutation. */
export type DeleteProgramEnrollmentPayloadProgramEnrollmentEdgeArgs = {
  orderBy?: InputMaybe<Array<ProgramEnrollmentsOrderBy>>;
};

/** All input for the `deleteProgram` mutation. */
export type DeleteProgramInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The identifer of the program. */
  id: Scalars['Int'];
};

/** The output of our delete `Program` mutation. */
export type DeleteProgramPayload = {
  __typename?: 'DeleteProgramPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedProgramNodeId?: Maybe<Scalars['ID']>;
  /** The `Program` that was deleted by this mutation. */
  program?: Maybe<Program>;
  /** An edge for our `Program`. May be used by Relay 1. */
  programEdge?: Maybe<ProgramsEdge>;
  /** Reads a single `ProjectType` that is related to this `Program`. */
  projectType?: Maybe<ProjectType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `Program` mutation. */
export type DeleteProgramPayloadProgramEdgeArgs = {
  orderBy?: InputMaybe<Array<ProgramsOrderBy>>;
};

/** All input for the `deleteProjectByFacilityIdAndProgramId` mutation. */
export type DeleteProjectByFacilityIdAndProgramIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The identifier of the facility. */
  facilityId: Scalars['Int'];
  /** The id of the program the project is associated with */
  programId: Scalars['Int'];
};

/** All input for the `deleteProjectByNodeId` mutation. */
export type DeleteProjectByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Project` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteProjectComponentByNodeId` mutation. */
export type DeleteProjectComponentByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProjectComponent` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteProjectComponent` mutation. */
export type DeleteProjectComponentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  componentId: Scalars['Int'];
  projectId: Scalars['Int'];
};

/** The output of our delete `ProjectComponent` mutation. */
export type DeleteProjectComponentPayload = {
  __typename?: 'DeleteProjectComponentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Component` that is related to this `ProjectComponent`. */
  component?: Maybe<Component>;
  deletedProjectComponentNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Project` that is related to this `ProjectComponent`. */
  project?: Maybe<Project>;
  /** The `ProjectComponent` that was deleted by this mutation. */
  projectComponent?: Maybe<ProjectComponent>;
  /** An edge for our `ProjectComponent`. May be used by Relay 1. */
  projectComponentEdge?: Maybe<ProjectComponentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `ProjectComponent` mutation. */
export type DeleteProjectComponentPayloadProjectComponentEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectComponentsOrderBy>>;
};

/** All input for the `deleteProjectConfig` mutation. */
export type DeleteProjectConfigInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['Int']>;
};

/** The output of our `deleteProjectConfig` mutation. */
export type DeleteProjectConfigPayload = {
  __typename?: 'DeleteProjectConfigPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteProjectEnrollmentByNodeId` mutation. */
export type DeleteProjectEnrollmentByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProjectEnrollment` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteProjectEnrollmentByProjectIdAndProgramEnrollmentId` mutation. */
export type DeleteProjectEnrollmentByProjectIdAndProgramEnrollmentIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The program enrollment this project enrollment belongs to. */
  programEnrollmentId: Scalars['Int'];
  /** The project this project enrollment belongs to. */
  projectId: Scalars['Int'];
};

/** All input for the `deleteProjectEnrollmentDataPointByNodeId` mutation. */
export type DeleteProjectEnrollmentDataPointByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProjectEnrollmentDataPoint` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteProjectEnrollmentDataPointByProjectEnrollmentIdAndDataPointId` mutation. */
export type DeleteProjectEnrollmentDataPointByProjectEnrollmentIdAndDataPointIdInput =
  {
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars['String']>;
    /** The data point being referenced. */
    dataPointId: Scalars['Int'];
    /** The project enrollment this data point belongs to. */
    projectEnrollmentId: Scalars['Int'];
  };

/** All input for the `deleteProjectEnrollmentDataPointGroupByNodeId` mutation. */
export type DeleteProjectEnrollmentDataPointGroupByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProjectEnrollmentDataPointGroup` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteProjectEnrollmentDataPointGroup` mutation. */
export type DeleteProjectEnrollmentDataPointGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The identifer of the project enrollment. */
  id: Scalars['Int'];
};

/** The output of our delete `ProjectEnrollmentDataPointGroup` mutation. */
export type DeleteProjectEnrollmentDataPointGroupPayload = {
  __typename?: 'DeleteProjectEnrollmentDataPointGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedProjectEnrollmentDataPointGroupNodeId?: Maybe<Scalars['ID']>;
  /** The `ProjectEnrollmentDataPointGroup` that was deleted by this mutation. */
  projectEnrollmentDataPointGroup?: Maybe<ProjectEnrollmentDataPointGroup>;
  /** An edge for our `ProjectEnrollmentDataPointGroup`. May be used by Relay 1. */
  projectEnrollmentDataPointGroupEdge?: Maybe<ProjectEnrollmentDataPointGroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `ProjectEnrollmentDataPointGroup` mutation. */
export type DeleteProjectEnrollmentDataPointGroupPayloadProjectEnrollmentDataPointGroupEdgeArgs =
  {
    orderBy?: InputMaybe<Array<ProjectEnrollmentDataPointGroupsOrderBy>>;
  };

/** All input for the `deleteProjectEnrollmentDataPoint` mutation. */
export type DeleteProjectEnrollmentDataPointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The identifer of the project enrollment data point. */
  id: Scalars['Int'];
};

/** The output of our delete `ProjectEnrollmentDataPoint` mutation. */
export type DeleteProjectEnrollmentDataPointPayload = {
  __typename?: 'DeleteProjectEnrollmentDataPointPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `DataPoint` that is related to this `ProjectEnrollmentDataPoint`. */
  dataPoint?: Maybe<DataPoint>;
  deletedProjectEnrollmentDataPointNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `ProjectEnrollmentDataPointGroup` that is related to this `ProjectEnrollmentDataPoint`. */
  group?: Maybe<ProjectEnrollmentDataPointGroup>;
  /** Reads a single `ProjectEnrollment` that is related to this `ProjectEnrollmentDataPoint`. */
  projectEnrollment?: Maybe<ProjectEnrollment>;
  /** The `ProjectEnrollmentDataPoint` that was deleted by this mutation. */
  projectEnrollmentDataPoint?: Maybe<ProjectEnrollmentDataPoint>;
  /** An edge for our `ProjectEnrollmentDataPoint`. May be used by Relay 1. */
  projectEnrollmentDataPointEdge?: Maybe<ProjectEnrollmentDataPointsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `ProjectEnrollmentDataPoint` mutation. */
export type DeleteProjectEnrollmentDataPointPayloadProjectEnrollmentDataPointEdgeArgs =
  {
    orderBy?: InputMaybe<Array<ProjectEnrollmentDataPointsOrderBy>>;
  };

/** All input for the `deleteProjectEnrollment` mutation. */
export type DeleteProjectEnrollmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The identifer of the project enrollment. */
  id: Scalars['Int'];
};

/** The output of our delete `ProjectEnrollment` mutation. */
export type DeleteProjectEnrollmentPayload = {
  __typename?: 'DeleteProjectEnrollmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedProjectEnrollmentNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `ProgramEnrollment` that is related to this `ProjectEnrollment`. */
  programEnrollment?: Maybe<ProgramEnrollment>;
  /** Reads a single `Project` that is related to this `ProjectEnrollment`. */
  project?: Maybe<Project>;
  /** The `ProjectEnrollment` that was deleted by this mutation. */
  projectEnrollment?: Maybe<ProjectEnrollment>;
  /** An edge for our `ProjectEnrollment`. May be used by Relay 1. */
  projectEnrollmentEdge?: Maybe<ProjectEnrollmentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `ProjectEnrollment` mutation. */
export type DeleteProjectEnrollmentPayloadProjectEnrollmentEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectEnrollmentsOrderBy>>;
};

/** All input for the `deleteProject` mutation. */
export type DeleteProjectInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The identifier of the optimization project. */
  id: Scalars['Int'];
};

/** The output of our delete `Project` mutation. */
export type DeleteProjectPayload = {
  __typename?: 'DeleteProjectPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedProjectNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Facility` that is related to this `Project`. */
  facility?: Maybe<Facility>;
  /** Reads a single `Program` that is related to this `Project`. */
  program?: Maybe<Program>;
  /** The `Project` that was deleted by this mutation. */
  project?: Maybe<Project>;
  /** An edge for our `Project`. May be used by Relay 1. */
  projectEdge?: Maybe<ProjectsEdge>;
  /** Reads a single `ProjectType` that is related to this `Project`. */
  projectType?: Maybe<ProjectType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `Project` mutation. */
export type DeleteProjectPayloadProjectEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};

/** All input for the `deleteProjectWatcherByNodeId` mutation. */
export type DeleteProjectWatcherByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProjectWatcher` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteProjectWatcher` mutation. */
export type DeleteProjectWatcherInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['Int'];
  userId: Scalars['String'];
};

/** The output of our delete `ProjectWatcher` mutation. */
export type DeleteProjectWatcherPayload = {
  __typename?: 'DeleteProjectWatcherPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedProjectWatcherNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Project` that is related to this `ProjectWatcher`. */
  project?: Maybe<Project>;
  /** The `ProjectWatcher` that was deleted by this mutation. */
  projectWatcher?: Maybe<ProjectWatcher>;
  /** An edge for our `ProjectWatcher`. May be used by Relay 1. */
  projectWatcherEdge?: Maybe<ProjectWatchersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `ProjectWatcher`. */
  user?: Maybe<User>;
};

/** The output of our delete `ProjectWatcher` mutation. */
export type DeleteProjectWatcherPayloadProjectWatcherEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectWatchersOrderBy>>;
};

/** All input for the `deleteReportExecutionByNodeId` mutation. */
export type DeleteReportExecutionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ReportExecution` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteReportExecution` mutation. */
export type DeleteReportExecutionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The id of the report execution. */
  id: Scalars['Int'];
};

/** The output of our delete `ReportExecution` mutation. */
export type DeleteReportExecutionPayload = {
  __typename?: 'DeleteReportExecutionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedReportExecutionNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Report` that is related to this `ReportExecution`. */
  report?: Maybe<Report>;
  /** The `ReportExecution` that was deleted by this mutation. */
  reportExecution?: Maybe<ReportExecution>;
  /** An edge for our `ReportExecution`. May be used by Relay 1. */
  reportExecutionEdge?: Maybe<ReportExecutionsEdge>;
};

/** The output of our delete `ReportExecution` mutation. */
export type DeleteReportExecutionPayloadReportExecutionEdgeArgs = {
  orderBy?: InputMaybe<Array<ReportExecutionsOrderBy>>;
};

/** All input for the `deleteSavingsEventByNodeId` mutation. */
export type DeleteSavingsEventByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SavingsEvent` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteSavingsEventByProjectIdAndStartTimeAndEndTime` mutation. */
export type DeleteSavingsEventByProjectIdAndStartTimeAndEndTimeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The time that the savings_event ended */
  endTime: Scalars['Datetime'];
  /** This maps the savings_event to a project */
  projectId: Scalars['Int'];
  /** The time that the savings_event started */
  startTime: Scalars['Datetime'];
};

/** All input for the `deleteSavingsEvent` mutation. */
export type DeleteSavingsEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `SavingsEvent` mutation. */
export type DeleteSavingsEventPayload = {
  __typename?: 'DeleteSavingsEventPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedSavingsEventNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Project` that is related to this `SavingsEvent`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SavingsEvent` that was deleted by this mutation. */
  savingsEvent?: Maybe<SavingsEvent>;
  /** An edge for our `SavingsEvent`. May be used by Relay 1. */
  savingsEventEdge?: Maybe<SavingsEventsEdge>;
};

/** The output of our delete `SavingsEvent` mutation. */
export type DeleteSavingsEventPayloadSavingsEventEdgeArgs = {
  orderBy?: InputMaybe<Array<SavingsEventsOrderBy>>;
};

/** All input for the `deleteSuggestionControlEventByControlEventId` mutation. */
export type DeleteSuggestionControlEventByControlEventIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  controlEventId: Scalars['Int'];
};

/** All input for the `deleteSuggestionControlEventByNodeId` mutation. */
export type DeleteSuggestionControlEventByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SuggestionControlEvent` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteSuggestionControlEvent` mutation. */
export type DeleteSuggestionControlEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  controlEventId: Scalars['Int'];
  suggestionId: Scalars['Int'];
};

/** The output of our delete `SuggestionControlEvent` mutation. */
export type DeleteSuggestionControlEventPayload = {
  __typename?: 'DeleteSuggestionControlEventPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `ControlEvent` that is related to this `SuggestionControlEvent`. */
  controlEvent?: Maybe<ControlEvent>;
  deletedSuggestionControlEventNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Suggestion` that is related to this `SuggestionControlEvent`. */
  suggestion?: Maybe<Suggestion>;
  /** The `SuggestionControlEvent` that was deleted by this mutation. */
  suggestionControlEvent?: Maybe<SuggestionControlEvent>;
};

/** All input for the `deleteTemperatureSensorByFacilityIdAndLabel` mutation. */
export type DeleteTemperatureSensorByFacilityIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The facility where the temperature sensor is installed */
  facilityId: Scalars['Int'];
  /** The Human-readable label for the sensor */
  label: Scalars['String'];
};

/** All input for the `deleteTemperatureSensorByNodeId` mutation. */
export type DeleteTemperatureSensorByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `TemperatureSensor` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteTemperatureSensor` mutation. */
export type DeleteTemperatureSensorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The id of the temperature sensor */
  id: Scalars['Int'];
};

/** The output of our delete `TemperatureSensor` mutation. */
export type DeleteTemperatureSensorPayload = {
  __typename?: 'DeleteTemperatureSensorPayload';
  /** Reads a single `DataPoint` that is related to this `TemperatureSensor`. */
  battery?: Maybe<DataPoint>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedTemperatureSensorNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Facility` that is related to this `TemperatureSensor`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `TemperatureSensor`. */
  signal?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `TemperatureSensor`. */
  temperature?: Maybe<DataPoint>;
  /** The `TemperatureSensor` that was deleted by this mutation. */
  temperatureSensor?: Maybe<TemperatureSensor>;
  /** An edge for our `TemperatureSensor`. May be used by Relay 1. */
  temperatureSensorEdge?: Maybe<TemperatureSensorsEdge>;
};

/** The output of our delete `TemperatureSensor` mutation. */
export type DeleteTemperatureSensorPayloadTemperatureSensorEdgeArgs = {
  orderBy?: InputMaybe<Array<TemperatureSensorsOrderBy>>;
};

/** All input for the `deleteTrailerPositionByFacilityIdAndLabel` mutation. */
export type DeleteTrailerPositionByFacilityIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The facility where the trailer position is located */
  facilityId: Scalars['Int'];
  /** The Human-readable label for the trailer position */
  label: Scalars['String'];
};

/** All input for the `deleteTrailerPositionByNodeId` mutation. */
export type DeleteTrailerPositionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `TrailerPosition` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteTrailerPosition` mutation. */
export type DeleteTrailerPositionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The id of the trailer position */
  id: Scalars['Int'];
};

/** The output of our delete `TrailerPosition` mutation. */
export type DeleteTrailerPositionPayload = {
  __typename?: 'DeleteTrailerPositionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedTrailerPositionNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Facility` that is related to this `TrailerPosition`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `TrailerPosition`. */
  trailerIsPresent?: Maybe<DataPoint>;
  /** The `TrailerPosition` that was deleted by this mutation. */
  trailerPosition?: Maybe<TrailerPosition>;
  /** An edge for our `TrailerPosition`. May be used by Relay 1. */
  trailerPositionEdge?: Maybe<TrailerPositionsEdge>;
};

/** The output of our delete `TrailerPosition` mutation. */
export type DeleteTrailerPositionPayloadTrailerPositionEdgeArgs = {
  orderBy?: InputMaybe<Array<TrailerPositionsOrderBy>>;
};

/** All input for the `deleteUserByNodeId` mutation. */
export type DeleteUserByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `User` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteUser` mutation. */
export type DeleteUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The primary unique identifier of the user. */
  id: Scalars['String'];
};

/** The output of our delete `User` mutation. */
export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedUserNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was deleted by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};

/** The output of our delete `User` mutation. */
export type DeleteUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the `deleteUtilityAccount` mutation. */
export type DeleteUtilityAccountInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our `deleteUtilityAccount` mutation. */
export type DeleteUtilityAccountPayload = {
  __typename?: 'DeleteUtilityAccountPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deleted?: Maybe<Scalars['Boolean']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteUtilityMeter` mutation. */
export type DeleteUtilityMeterInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our `deleteUtilityMeter` mutation. */
export type DeleteUtilityMeterPayload = {
  __typename?: 'DeleteUtilityMeterPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deleted?: Maybe<Scalars['Boolean']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteUtilityProviderByName` mutation. */
export type DeleteUtilityProviderByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The name of the provider. */
  name: Scalars['String'];
};

/** All input for the `deleteUtilityProviderByNodeId` mutation. */
export type DeleteUtilityProviderByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `UtilityProvider` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteUtilityProvider` mutation. */
export type DeleteUtilityProviderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The primary unique identifier for the provider. */
  id: Scalars['Int'];
};

/** The output of our delete `UtilityProvider` mutation. */
export type DeleteUtilityProviderPayload = {
  __typename?: 'DeleteUtilityProviderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedUtilityProviderNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UtilityProvider` that was deleted by this mutation. */
  utilityProvider?: Maybe<UtilityProvider>;
  /** An edge for our `UtilityProvider`. May be used by Relay 1. */
  utilityProviderEdge?: Maybe<UtilityProvidersEdge>;
};

/** The output of our delete `UtilityProvider` mutation. */
export type DeleteUtilityProviderPayloadUtilityProviderEdgeArgs = {
  orderBy?: InputMaybe<Array<UtilityProvidersOrderBy>>;
};

/** All input for the `deleteVendorUserByEmail` mutation. */
export type DeleteVendorUserByEmailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The email of the vendor user. */
  email: Scalars['String'];
};

/** All input for the `deleteVendorUserByNodeId` mutation. */
export type DeleteVendorUserByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `VendorUser` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteVendorUser` mutation. */
export type DeleteVendorUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The id of the vendor user. */
  id: Scalars['Int'];
};

/** All input for the `deleteVendorUserMachineUserByMachineUserId` mutation. */
export type DeleteVendorUserMachineUserByMachineUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The machine user associated with the vendor user. */
  machineUserId: Scalars['BigInt'];
};

/** All input for the `deleteVendorUserMachineUserByNodeId` mutation. */
export type DeleteVendorUserMachineUserByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `VendorUserMachineUser` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteVendorUserMachineUser` mutation. */
export type DeleteVendorUserMachineUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The machine user associated with the vendor user. */
  machineUserId: Scalars['BigInt'];
  /** The id of the vendor user. */
  vendorUserId: Scalars['Int'];
};

/** The output of our delete `VendorUserMachineUser` mutation. */
export type DeleteVendorUserMachineUserPayload = {
  __typename?: 'DeleteVendorUserMachineUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedVendorUserMachineUserNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VendorUserMachineUser` that was deleted by this mutation. */
  vendorUserMachineUser?: Maybe<VendorUserMachineUser>;
};

/** The output of our delete `VendorUser` mutation. */
export type DeleteVendorUserPayload = {
  __typename?: 'DeleteVendorUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedVendorUserNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VendorUser` that was deleted by this mutation. */
  vendorUser?: Maybe<VendorUser>;
  /** An edge for our `VendorUser`. May be used by Relay 1. */
  vendorUserEdge?: Maybe<VendorUsersEdge>;
};

/** The output of our delete `VendorUser` mutation. */
export type DeleteVendorUserPayloadVendorUserEdgeArgs = {
  orderBy?: InputMaybe<Array<VendorUsersOrderBy>>;
};

/** All input for the `deleteVirtualPointIntervalByNodeId` mutation. */
export type DeleteVirtualPointIntervalByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `VirtualPointInterval` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteVirtualPointInterval` mutation. */
export type DeleteVirtualPointIntervalInput = {
  /** The id of the child data point. */
  childId: Scalars['BigInt'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The id of the VIRTUAL data point. */
  parentId: Scalars['BigInt'];
};

/** The output of our delete `VirtualPointInterval` mutation. */
export type DeleteVirtualPointIntervalPayload = {
  __typename?: 'DeleteVirtualPointIntervalPayload';
  /** Reads a single `DataPoint` that is related to this `VirtualPointInterval`. */
  child?: Maybe<DataPoint>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedVirtualPointIntervalNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `DataPoint` that is related to this `VirtualPointInterval`. */
  parent?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VirtualPointInterval` that was deleted by this mutation. */
  virtualPointInterval?: Maybe<VirtualPointInterval>;
  /** An edge for our `VirtualPointInterval`. May be used by Relay 1. */
  virtualPointIntervalEdge?: Maybe<VirtualPointIntervalsEdge>;
};

/** The output of our delete `VirtualPointInterval` mutation. */
export type DeleteVirtualPointIntervalPayloadVirtualPointIntervalEdgeArgs = {
  orderBy?: InputMaybe<Array<VirtualPointIntervalsOrderBy>>;
};

/** A connection to a list of `Dependency` values. */
export type DependenciesConnection = {
  __typename?: 'DependenciesConnection';
  /** A list of edges which contains the `Dependency` and cursor to aid in pagination. */
  edges: Array<DependenciesEdge>;
  /** A list of `Dependency` objects. */
  nodes: Array<Dependency>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Dependency` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Dependency` edge in the connection. */
export type DependenciesEdge = {
  __typename?: 'DependenciesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Dependency` at the end of the edge. */
  node: Dependency;
};

/** Methods to use when ordering `Dependency`. */
export enum DependenciesOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PATH_ASC = 'PATH_ASC',
  PATH_DESC = 'PATH_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC'
}

export type Dependency = Node & {
  __typename?: 'Dependency';
  id: Scalars['BigInt'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  path: Scalars['String'];
  type: Scalars['String'];
};

/**
 * A condition to be used against `Dependency` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type DependencyCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `path` field. */
  path?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `Dependency` object types. All fields are combined with a logical ‘and.’ */
export type DependencyFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DependencyFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DependencyFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DependencyFilter>>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `Dependency` */
export type DependencyInput = {
  name: Scalars['String'];
  path: Scalars['String'];
  type: Scalars['String'];
};

/** Represents an update to a `Dependency`. Fields that are set will be updated. */
export type DependencyPatch = {
  name?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type DerivedStatementDate = {
  __typename?: 'DerivedStatementDate';
  statementDate?: Maybe<Scalars['Date']>;
  statementMonth?: Maybe<Scalars['Int']>;
  statementYear?: Maybe<Scalars['Int']>;
};

/** This represents a physical location of a door in a facility */
export type Door = Node & {
  __typename?: 'Door';
  /** The time at which the Door was created */
  createdAt: Scalars['Datetime'];
  /** Reads a single `DataPoint` that is related to this `Door`. */
  doorState?: Maybe<DataPoint>;
  /** The state of the door indicating whether the door is open or closed */
  doorStateId?: Maybe<Scalars['BigInt']>;
  /** Reads a single `Facility` that is related to this `Door`. */
  facility?: Maybe<Facility>;
  /** The facility where the door is located */
  facilityId?: Maybe<Scalars['Int']>;
  /** The GIS geometry specifies the physical location of the door */
  geometry?: Maybe<GeometryInterface>;
  /** The id of the door */
  id: Scalars['Int'];
  /** The Human-readable label for the door */
  label: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The time at which the Door was updated */
  updatedAt: Scalars['Datetime'];
};

/** A condition to be used against `Door` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type DoorCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `doorStateId` field. */
  doorStateId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `geometry` field. */
  geometry?: InputMaybe<Scalars['GeoJSON']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `Door` object types. All fields are combined with a logical ‘and.’ */
export type DoorFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DoorFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `doorStateId` field. */
  doorStateId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DoorFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DoorFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Door` */
export type DoorInput = {
  /** Mutates a `DataPoint` as part of the payload */
  dataPoint?: InputMaybe<DataPointInput>;
  /** The state of the door indicating whether the door is open or closed */
  doorStateId?: InputMaybe<Scalars['BigInt']>;
  /** The facility where the door is located */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** The GIS geometry specifies the physical location of the door */
  geometry?: InputMaybe<Scalars['GeoJSON']>;
  /** The Human-readable label for the door */
  label: Scalars['String'];
};

/** Represents an update to a `Door`. Fields that are set will be updated. */
export type DoorPatch = {
  /** The state of the door indicating whether the door is open or closed */
  doorStateId?: InputMaybe<Scalars['BigInt']>;
  /** The facility where the door is located */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** The GIS geometry specifies the physical location of the door */
  geometry?: InputMaybe<Scalars['GeoJSON']>;
  /** The Human-readable label for the door */
  label?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `Door` values. */
export type DoorsConnection = {
  __typename?: 'DoorsConnection';
  /** Returns the aggregate doorState timeseries data for the DoorsConnection  */
  doorState?: Maybe<MetricDataConnection>;
  /** A list of edges which contains the `Door` and cursor to aid in pagination. */
  edges: Array<DoorsEdge>;
  /** A list of `Door` objects. */
  nodes: Array<Door>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Door` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A connection to a list of `Door` values. */
export type DoorsConnectionDoorStateArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A `Door` edge in the connection. */
export type DoorsEdge = {
  __typename?: 'DoorsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Door` at the end of the edge. */
  node: Door;
};

/** Methods to use when ordering `Door`. */
export enum DoorsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DOOR_STATE_ID_ASC = 'DOOR_STATE_ID_ASC',
  DOOR_STATE_ID_DESC = 'DOOR_STATE_ID_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  GEOMETRY_ASC = 'GEOMETRY_ASC',
  GEOMETRY_DESC = 'GEOMETRY_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

export enum EnumBlastRotationAlertLevel {
  ALERT = 'ALERT',
  WARNING = 'WARNING'
}

/** A filter to be used against EnumBlastRotationAlertLevel fields. All fields are combined with a logical ‘and.’ */
export type EnumBlastRotationAlertLevelFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<EnumBlastRotationAlertLevel>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<EnumBlastRotationAlertLevel>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<EnumBlastRotationAlertLevel>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<EnumBlastRotationAlertLevel>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<EnumBlastRotationAlertLevel>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<EnumBlastRotationAlertLevel>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<EnumBlastRotationAlertLevel>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<EnumBlastRotationAlertLevel>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<EnumBlastRotationAlertLevel>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<EnumBlastRotationAlertLevel>>;
};

/** This represents an evaporator that exists in a facility */
export type Evaporator = Node & {
  __typename?: 'Evaporator';
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  ammoniaState?: Maybe<DataPoint>;
  /** The ammonia state value */
  ammoniaStateId?: Maybe<Scalars['BigInt']>;
  /** Reads and enables pagination through a set of `BlastEvaporator`. */
  blastEvaporators: BlastEvaporatorsConnection;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  bleedSolenoid?: Maybe<DataPoint>;
  /** The bleed solenoid */
  bleedSolenoidId?: Maybe<Scalars['BigInt']>;
  /** Reads a single `BuildingArea` that is related to this `Evaporator`. */
  buildingArea?: Maybe<BuildingArea>;
  /** The associated area of within a building */
  buildingAreaId?: Maybe<Scalars['Int']>;
  /** The time at which the Evaporator was created. */
  createdAt: Scalars['Datetime'];
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  defrostState?: Maybe<DataPoint>;
  /** The defrost state value */
  defrostStateId?: Maybe<Scalars['BigInt']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  defrostTemperature?: Maybe<DataPoint>;
  /** The defrost temperature */
  defrostTemperatureId?: Maybe<Scalars['BigInt']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  defrostTimer?: Maybe<DataPoint>;
  /** The defrost time */
  defrostTimerId?: Maybe<Scalars['BigInt']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  differentialAirTemperature?: Maybe<DataPoint>;
  /** The differential air temperature */
  differentialAirTemperatureId?: Maybe<Scalars['BigInt']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  estimatedKwDemand?: Maybe<DataPoint>;
  /** The estimated kw demand (evaluated from compressor demand) */
  estimatedKwDemandId?: Maybe<Scalars['BigInt']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  evapState?: Maybe<DataPoint>;
  /** The state of the evap */
  evapStateId?: Maybe<Scalars['BigInt']>;
  /** Reads a single `Facility` that is related to this `Evaporator`. */
  facility?: Maybe<Facility>;
  /** The facility an evaporator is installed within */
  facilityId?: Maybe<Scalars['Int']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  fanState?: Maybe<DataPoint>;
  /** The fan state */
  fanStateId?: Maybe<Scalars['BigInt']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  fanTimer?: Maybe<DataPoint>;
  /** The fan timer */
  fanTimerId?: Maybe<Scalars['BigInt']>;
  /** The geocoded location of an evaporator */
  geometry?: Maybe<GeometryInterface>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  hotGasSolenoid?: Maybe<DataPoint>;
  /** The hot gas solenoid */
  hotGasSolenoidId?: Maybe<Scalars['BigInt']>;
  /** The id of the evaporator */
  id: Scalars['Int'];
  /** A human-readable label */
  label: Scalars['String'];
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  liquidFeedRuntime?: Maybe<DataPoint>;
  /** The liquid feed runtime */
  liquidFeedRuntimeId?: Maybe<Scalars['BigInt']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  liquidFeedRuntimeSetpoint?: Maybe<DataPoint>;
  /** The liquid feed runtime setpoint */
  liquidFeedRuntimeSetpointId?: Maybe<Scalars['BigInt']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  liquidSolenoid?: Maybe<DataPoint>;
  /** The liquid solenoid state */
  liquidSolenoidId?: Maybe<Scalars['BigInt']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The rated refrigeration capacity of the evaporator (constant) */
  ratedTonnage?: Maybe<Scalars['Int']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  returnAirTemperature?: Maybe<DataPoint>;
  /** The return air temperature */
  returnAirTemperatureId?: Maybe<Scalars['BigInt']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  setpoint?: Maybe<DataPoint>;
  /** The setpoint value */
  setpointId?: Maybe<Scalars['BigInt']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  softHotGasSolenoid?: Maybe<DataPoint>;
  /** The soft hot gas solenoid */
  softHotGasSolenoidId?: Maybe<Scalars['BigInt']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  suctionSolenoid?: Maybe<DataPoint>;
  /** The suction solenoid */
  suctionSolenoidId?: Maybe<Scalars['BigInt']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  suctionTemperature?: Maybe<DataPoint>;
  /** The suction temperature */
  suctionTemperatureId?: Maybe<Scalars['BigInt']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  supplyAirTemperature?: Maybe<DataPoint>;
  /** The supply air temperature, which is air temperature going out of the evaporator */
  supplyAirTemperatureId?: Maybe<Scalars['BigInt']>;
  /** The time at which the Evaporator was updated. */
  updatedAt: Scalars['Datetime'];
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  zoneTemperature?: Maybe<DataPoint>;
  /** The zone temperature, or the best available representation of air temperature in the evaporator cooling zone */
  zoneTemperatureId?: Maybe<Scalars['BigInt']>;
};

/** This represents an evaporator that exists in a facility */
export type EvaporatorBlastEvaporatorsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BlastEvaporatorCondition>;
  filter?: InputMaybe<BlastEvaporatorFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BlastEvaporatorsOrderBy>>;
};

/**
 * A condition to be used against `Evaporator` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type EvaporatorCondition = {
  /** Checks for equality with the object’s `ammoniaStateId` field. */
  ammoniaStateId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `bleedSolenoidId` field. */
  bleedSolenoidId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `buildingAreaId` field. */
  buildingAreaId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `defrostStateId` field. */
  defrostStateId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `defrostTemperatureId` field. */
  defrostTemperatureId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `defrostTimerId` field. */
  defrostTimerId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `differentialAirTemperatureId` field. */
  differentialAirTemperatureId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `estimatedKwDemandId` field. */
  estimatedKwDemandId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `evapStateId` field. */
  evapStateId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `fanStateId` field. */
  fanStateId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `fanTimerId` field. */
  fanTimerId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `geometry` field. */
  geometry?: InputMaybe<Scalars['GeoJSON']>;
  /** Checks for equality with the object’s `hotGasSolenoidId` field. */
  hotGasSolenoidId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `liquidFeedRuntimeId` field. */
  liquidFeedRuntimeId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `liquidFeedRuntimeSetpointId` field. */
  liquidFeedRuntimeSetpointId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `liquidSolenoidId` field. */
  liquidSolenoidId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `ratedTonnage` field. */
  ratedTonnage?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `returnAirTemperatureId` field. */
  returnAirTemperatureId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `setpointId` field. */
  setpointId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `softHotGasSolenoidId` field. */
  softHotGasSolenoidId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `suctionSolenoidId` field. */
  suctionSolenoidId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `suctionTemperatureId` field. */
  suctionTemperatureId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `supplyAirTemperatureId` field. */
  supplyAirTemperatureId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `zoneTemperatureId` field. */
  zoneTemperatureId?: InputMaybe<Scalars['BigInt']>;
};

/** A filter to be used against `Evaporator` object types. All fields are combined with a logical ‘and.’ */
export type EvaporatorFilter = {
  /** Filter by the object’s `ammoniaStateId` field. */
  ammoniaStateId?: InputMaybe<BigIntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EvaporatorFilter>>;
  /** Filter by the object’s `bleedSolenoidId` field. */
  bleedSolenoidId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `buildingAreaId` field. */
  buildingAreaId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `defrostStateId` field. */
  defrostStateId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `defrostTemperatureId` field. */
  defrostTemperatureId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `defrostTimerId` field. */
  defrostTimerId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `differentialAirTemperatureId` field. */
  differentialAirTemperatureId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `estimatedKwDemandId` field. */
  estimatedKwDemandId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `evapStateId` field. */
  evapStateId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `fanStateId` field. */
  fanStateId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `fanTimerId` field. */
  fanTimerId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `hotGasSolenoidId` field. */
  hotGasSolenoidId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Filter by the object’s `liquidFeedRuntimeId` field. */
  liquidFeedRuntimeId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `liquidFeedRuntimeSetpointId` field. */
  liquidFeedRuntimeSetpointId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `liquidSolenoidId` field. */
  liquidSolenoidId?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EvaporatorFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EvaporatorFilter>>;
  /** Filter by the object’s `ratedTonnage` field. */
  ratedTonnage?: InputMaybe<IntFilter>;
  /** Filter by the object’s `returnAirTemperatureId` field. */
  returnAirTemperatureId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `setpointId` field. */
  setpointId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `softHotGasSolenoidId` field. */
  softHotGasSolenoidId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `suctionSolenoidId` field. */
  suctionSolenoidId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `suctionTemperatureId` field. */
  suctionTemperatureId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `supplyAirTemperatureId` field. */
  supplyAirTemperatureId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `zoneTemperatureId` field. */
  zoneTemperatureId?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `Evaporator` */
export type EvaporatorInput = {
  /** The ammonia state value */
  ammoniaStateId?: InputMaybe<Scalars['BigInt']>;
  /** The bleed solenoid */
  bleedSolenoidId?: InputMaybe<Scalars['BigInt']>;
  /** Mutates a `BuildingArea` as part of the payload */
  buildingArea?: InputMaybe<BuildingAreaInput>;
  /** The associated area of within a building */
  buildingAreaId?: InputMaybe<Scalars['Int']>;
  /** Mutates a `DataPoint` as part of the payload */
  dataPoint?: InputMaybe<DataPointInput>;
  /** The defrost state value */
  defrostStateId?: InputMaybe<Scalars['BigInt']>;
  /** The defrost temperature */
  defrostTemperatureId?: InputMaybe<Scalars['BigInt']>;
  /** The defrost time */
  defrostTimerId?: InputMaybe<Scalars['BigInt']>;
  /** The differential air temperature */
  differentialAirTemperatureId?: InputMaybe<Scalars['BigInt']>;
  /** The estimated kw demand (evaluated from compressor demand) */
  estimatedKwDemandId?: InputMaybe<Scalars['BigInt']>;
  /** The state of the evap */
  evapStateId?: InputMaybe<Scalars['BigInt']>;
  /** The facility an evaporator is installed within */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** The fan state */
  fanStateId?: InputMaybe<Scalars['BigInt']>;
  /** The fan timer */
  fanTimerId?: InputMaybe<Scalars['BigInt']>;
  /** The geocoded location of an evaporator */
  geometry?: InputMaybe<Scalars['GeoJSON']>;
  /** The hot gas solenoid */
  hotGasSolenoidId?: InputMaybe<Scalars['BigInt']>;
  /** A human-readable label */
  label: Scalars['String'];
  /** The liquid feed runtime */
  liquidFeedRuntimeId?: InputMaybe<Scalars['BigInt']>;
  /** The liquid feed runtime setpoint */
  liquidFeedRuntimeSetpointId?: InputMaybe<Scalars['BigInt']>;
  /** The liquid solenoid state */
  liquidSolenoidId?: InputMaybe<Scalars['BigInt']>;
  /** The rated refrigeration capacity of the evaporator (constant) */
  ratedTonnage?: InputMaybe<Scalars['Int']>;
  /** The return air temperature */
  returnAirTemperatureId?: InputMaybe<Scalars['BigInt']>;
  /** The setpoint value */
  setpointId?: InputMaybe<Scalars['BigInt']>;
  /** The soft hot gas solenoid */
  softHotGasSolenoidId?: InputMaybe<Scalars['BigInt']>;
  /** The suction solenoid */
  suctionSolenoidId?: InputMaybe<Scalars['BigInt']>;
  /** The suction temperature */
  suctionTemperatureId?: InputMaybe<Scalars['BigInt']>;
  /** The supply air temperature, which is air temperature going out of the evaporator */
  supplyAirTemperatureId?: InputMaybe<Scalars['BigInt']>;
  /** The zone temperature, or the best available representation of air temperature in the evaporator cooling zone */
  zoneTemperatureId?: InputMaybe<Scalars['BigInt']>;
};

/** Represents an update to a `Evaporator`. Fields that are set will be updated. */
export type EvaporatorPatch = {
  /** The ammonia state value */
  ammoniaStateId?: InputMaybe<Scalars['BigInt']>;
  /** The bleed solenoid */
  bleedSolenoidId?: InputMaybe<Scalars['BigInt']>;
  /** The associated area of within a building */
  buildingAreaId?: InputMaybe<Scalars['Int']>;
  /** The defrost state value */
  defrostStateId?: InputMaybe<Scalars['BigInt']>;
  /** The defrost temperature */
  defrostTemperatureId?: InputMaybe<Scalars['BigInt']>;
  /** The defrost time */
  defrostTimerId?: InputMaybe<Scalars['BigInt']>;
  /** The differential air temperature */
  differentialAirTemperatureId?: InputMaybe<Scalars['BigInt']>;
  /** The estimated kw demand (evaluated from compressor demand) */
  estimatedKwDemandId?: InputMaybe<Scalars['BigInt']>;
  /** The state of the evap */
  evapStateId?: InputMaybe<Scalars['BigInt']>;
  /** The facility an evaporator is installed within */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** The fan state */
  fanStateId?: InputMaybe<Scalars['BigInt']>;
  /** The fan timer */
  fanTimerId?: InputMaybe<Scalars['BigInt']>;
  /** The geocoded location of an evaporator */
  geometry?: InputMaybe<Scalars['GeoJSON']>;
  /** The hot gas solenoid */
  hotGasSolenoidId?: InputMaybe<Scalars['BigInt']>;
  /** A human-readable label */
  label?: InputMaybe<Scalars['String']>;
  /** The liquid feed runtime */
  liquidFeedRuntimeId?: InputMaybe<Scalars['BigInt']>;
  /** The liquid feed runtime setpoint */
  liquidFeedRuntimeSetpointId?: InputMaybe<Scalars['BigInt']>;
  /** The liquid solenoid state */
  liquidSolenoidId?: InputMaybe<Scalars['BigInt']>;
  /** The rated refrigeration capacity of the evaporator (constant) */
  ratedTonnage?: InputMaybe<Scalars['Int']>;
  /** The return air temperature */
  returnAirTemperatureId?: InputMaybe<Scalars['BigInt']>;
  /** The setpoint value */
  setpointId?: InputMaybe<Scalars['BigInt']>;
  /** The soft hot gas solenoid */
  softHotGasSolenoidId?: InputMaybe<Scalars['BigInt']>;
  /** The suction solenoid */
  suctionSolenoidId?: InputMaybe<Scalars['BigInt']>;
  /** The suction temperature */
  suctionTemperatureId?: InputMaybe<Scalars['BigInt']>;
  /** The supply air temperature, which is air temperature going out of the evaporator */
  supplyAirTemperatureId?: InputMaybe<Scalars['BigInt']>;
  /** The zone temperature, or the best available representation of air temperature in the evaporator cooling zone */
  zoneTemperatureId?: InputMaybe<Scalars['BigInt']>;
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnection = {
  __typename?: 'EvaporatorsConnection';
  /** Returns the aggregate ammoniaState timeseries data for the EvaporatorsConnection  */
  ammoniaState?: Maybe<MetricDataConnection>;
  /** Returns the aggregate bleedSolenoid timeseries data for the EvaporatorsConnection  */
  bleedSolenoid?: Maybe<MetricDataConnection>;
  /** Returns the aggregate defrostState timeseries data for the EvaporatorsConnection  */
  defrostState?: Maybe<MetricDataConnection>;
  /** Returns the aggregate defrostTemperature timeseries data for the EvaporatorsConnection  */
  defrostTemperature?: Maybe<MetricDataConnection>;
  /** Returns the aggregate defrostTimer timeseries data for the EvaporatorsConnection  */
  defrostTimer?: Maybe<MetricDataConnection>;
  /** Returns the aggregate differentialAirTemperature timeseries data for the EvaporatorsConnection  */
  differentialAirTemperature?: Maybe<MetricDataConnection>;
  /** A list of edges which contains the `Evaporator` and cursor to aid in pagination. */
  edges: Array<EvaporatorsEdge>;
  /** Returns the aggregate estimatedKwDemand timeseries data for the EvaporatorsConnection  */
  estimatedKwDemand?: Maybe<MetricDataConnection>;
  /** Returns the aggregate evapState timeseries data for the EvaporatorsConnection  */
  evapState?: Maybe<MetricDataConnection>;
  /** Returns the aggregate fanState timeseries data for the EvaporatorsConnection  */
  fanState?: Maybe<MetricDataConnection>;
  /** Returns the aggregate fanTimer timeseries data for the EvaporatorsConnection  */
  fanTimer?: Maybe<MetricDataConnection>;
  /** Returns the aggregate hotGasSolenoid timeseries data for the EvaporatorsConnection  */
  hotGasSolenoid?: Maybe<MetricDataConnection>;
  /** Returns the aggregate liquidFeedRuntime timeseries data for the EvaporatorsConnection  */
  liquidFeedRuntime?: Maybe<MetricDataConnection>;
  /** Returns the aggregate liquidFeedRuntimeSetpoint timeseries data for the EvaporatorsConnection  */
  liquidFeedRuntimeSetpoint?: Maybe<MetricDataConnection>;
  /** Returns the aggregate liquidSolenoid timeseries data for the EvaporatorsConnection  */
  liquidSolenoid?: Maybe<MetricDataConnection>;
  /** A list of `Evaporator` objects. */
  nodes: Array<Evaporator>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Returns the aggregate returnAirTemperature timeseries data for the EvaporatorsConnection  */
  returnAirTemperature?: Maybe<MetricDataConnection>;
  /** Returns the aggregate setpoint timeseries data for the EvaporatorsConnection  */
  setpoint?: Maybe<MetricDataConnection>;
  /** Returns the aggregate softHotGasSolenoid timeseries data for the EvaporatorsConnection  */
  softHotGasSolenoid?: Maybe<MetricDataConnection>;
  /** Returns the aggregate suctionSolenoid timeseries data for the EvaporatorsConnection  */
  suctionSolenoid?: Maybe<MetricDataConnection>;
  /** Returns the aggregate suctionTemperature timeseries data for the EvaporatorsConnection  */
  suctionTemperature?: Maybe<MetricDataConnection>;
  /** Returns the aggregate supplyAirTemperature timeseries data for the EvaporatorsConnection  */
  supplyAirTemperature?: Maybe<MetricDataConnection>;
  /** The count of *all* `Evaporator` you could get from the connection. */
  totalCount: Scalars['Int'];
  /** Returns the aggregate zoneTemperature timeseries data for the EvaporatorsConnection  */
  zoneTemperature?: Maybe<MetricDataConnection>;
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionAmmoniaStateArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionBleedSolenoidArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionDefrostStateArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionDefrostTemperatureArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionDefrostTimerArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionDifferentialAirTemperatureArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionEstimatedKwDemandArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionEvapStateArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionFanStateArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionFanTimerArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionHotGasSolenoidArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionLiquidFeedRuntimeArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionLiquidFeedRuntimeSetpointArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionLiquidSolenoidArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionReturnAirTemperatureArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionSetpointArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionSoftHotGasSolenoidArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionSuctionSolenoidArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionSuctionTemperatureArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionSupplyAirTemperatureArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionZoneTemperatureArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A `Evaporator` edge in the connection. */
export type EvaporatorsEdge = {
  __typename?: 'EvaporatorsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Evaporator` at the end of the edge. */
  node: Evaporator;
};

/** Methods to use when ordering `Evaporator`. */
export enum EvaporatorsOrderBy {
  AMMONIA_STATE_ID_ASC = 'AMMONIA_STATE_ID_ASC',
  AMMONIA_STATE_ID_DESC = 'AMMONIA_STATE_ID_DESC',
  BLEED_SOLENOID_ID_ASC = 'BLEED_SOLENOID_ID_ASC',
  BLEED_SOLENOID_ID_DESC = 'BLEED_SOLENOID_ID_DESC',
  BUILDING_AREA_ID_ASC = 'BUILDING_AREA_ID_ASC',
  BUILDING_AREA_ID_DESC = 'BUILDING_AREA_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DEFROST_STATE_ID_ASC = 'DEFROST_STATE_ID_ASC',
  DEFROST_STATE_ID_DESC = 'DEFROST_STATE_ID_DESC',
  DEFROST_TEMPERATURE_ID_ASC = 'DEFROST_TEMPERATURE_ID_ASC',
  DEFROST_TEMPERATURE_ID_DESC = 'DEFROST_TEMPERATURE_ID_DESC',
  DEFROST_TIMER_ID_ASC = 'DEFROST_TIMER_ID_ASC',
  DEFROST_TIMER_ID_DESC = 'DEFROST_TIMER_ID_DESC',
  DIFFERENTIAL_AIR_TEMPERATURE_ID_ASC = 'DIFFERENTIAL_AIR_TEMPERATURE_ID_ASC',
  DIFFERENTIAL_AIR_TEMPERATURE_ID_DESC = 'DIFFERENTIAL_AIR_TEMPERATURE_ID_DESC',
  ESTIMATED_KW_DEMAND_ID_ASC = 'ESTIMATED_KW_DEMAND_ID_ASC',
  ESTIMATED_KW_DEMAND_ID_DESC = 'ESTIMATED_KW_DEMAND_ID_DESC',
  EVAP_STATE_ID_ASC = 'EVAP_STATE_ID_ASC',
  EVAP_STATE_ID_DESC = 'EVAP_STATE_ID_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  FAN_STATE_ID_ASC = 'FAN_STATE_ID_ASC',
  FAN_STATE_ID_DESC = 'FAN_STATE_ID_DESC',
  FAN_TIMER_ID_ASC = 'FAN_TIMER_ID_ASC',
  FAN_TIMER_ID_DESC = 'FAN_TIMER_ID_DESC',
  GEOMETRY_ASC = 'GEOMETRY_ASC',
  GEOMETRY_DESC = 'GEOMETRY_DESC',
  HOT_GAS_SOLENOID_ID_ASC = 'HOT_GAS_SOLENOID_ID_ASC',
  HOT_GAS_SOLENOID_ID_DESC = 'HOT_GAS_SOLENOID_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  LIQUID_FEED_RUNTIME_ID_ASC = 'LIQUID_FEED_RUNTIME_ID_ASC',
  LIQUID_FEED_RUNTIME_ID_DESC = 'LIQUID_FEED_RUNTIME_ID_DESC',
  LIQUID_FEED_RUNTIME_SETPOINT_ID_ASC = 'LIQUID_FEED_RUNTIME_SETPOINT_ID_ASC',
  LIQUID_FEED_RUNTIME_SETPOINT_ID_DESC = 'LIQUID_FEED_RUNTIME_SETPOINT_ID_DESC',
  LIQUID_SOLENOID_ID_ASC = 'LIQUID_SOLENOID_ID_ASC',
  LIQUID_SOLENOID_ID_DESC = 'LIQUID_SOLENOID_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  RATED_TONNAGE_ASC = 'RATED_TONNAGE_ASC',
  RATED_TONNAGE_DESC = 'RATED_TONNAGE_DESC',
  RETURN_AIR_TEMPERATURE_ID_ASC = 'RETURN_AIR_TEMPERATURE_ID_ASC',
  RETURN_AIR_TEMPERATURE_ID_DESC = 'RETURN_AIR_TEMPERATURE_ID_DESC',
  SETPOINT_ID_ASC = 'SETPOINT_ID_ASC',
  SETPOINT_ID_DESC = 'SETPOINT_ID_DESC',
  SOFT_HOT_GAS_SOLENOID_ID_ASC = 'SOFT_HOT_GAS_SOLENOID_ID_ASC',
  SOFT_HOT_GAS_SOLENOID_ID_DESC = 'SOFT_HOT_GAS_SOLENOID_ID_DESC',
  SUCTION_SOLENOID_ID_ASC = 'SUCTION_SOLENOID_ID_ASC',
  SUCTION_SOLENOID_ID_DESC = 'SUCTION_SOLENOID_ID_DESC',
  SUCTION_TEMPERATURE_ID_ASC = 'SUCTION_TEMPERATURE_ID_ASC',
  SUCTION_TEMPERATURE_ID_DESC = 'SUCTION_TEMPERATURE_ID_DESC',
  SUPPLY_AIR_TEMPERATURE_ID_ASC = 'SUPPLY_AIR_TEMPERATURE_ID_ASC',
  SUPPLY_AIR_TEMPERATURE_ID_DESC = 'SUPPLY_AIR_TEMPERATURE_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  ZONE_TEMPERATURE_ID_ASC = 'ZONE_TEMPERATURE_ID_ASC',
  ZONE_TEMPERATURE_ID_DESC = 'ZONE_TEMPERATURE_ID_DESC'
}

/** An event */
export type Event = Node & {
  __typename?: 'Event';
  /** The associated action. */
  action?: Maybe<Scalars['String']>;
  /** The actor that triggered the event. */
  actor?: Maybe<Actor>;
  /** The time the event was created. */
  createdAt: Scalars['Datetime'];
  event: Scalars['JSON'];
  /** Reads a single `EventType` that is related to this `Event`. */
  eventTypeByType?: Maybe<EventType>;
  /** Reads a single `Facility` that is related to this `Event`. */
  facility?: Maybe<Facility>;
  /** The associated Facility. */
  facilityId: Scalars['Int'];
  /** The identifier of the event. */
  id: Scalars['BigInt'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The type of event. */
  type: Scalars['String'];
};

/** Handler for events. */
export type EventHandler = Node & {
  __typename?: 'EventHandler';
  /** The name of the event handler. */
  handler: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
};

/** Event metadata for specific handlers. */
export type EventHandlerMetadatum = Node & {
  __typename?: 'EventHandlerMetadatum';
  event: Scalars['JSON'];
  /** Reads a single `EventHandler` that is related to this `EventHandlerMetadatum`. */
  eventHandlerByHandler?: Maybe<EventHandler>;
  /** Reads a single `EventType` that is related to this `EventHandlerMetadatum`. */
  eventTypeByType?: Maybe<EventType>;
  /** The event handler. */
  handler: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The type of event. */
  type: Scalars['String'];
};

/** Type of event that user can subscribe to. */
export type EventType = Node & {
  __typename?: 'EventType';
  /** The name of the event type. */
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
};

/** A connection to a list of `Facility` values. */
export type FacilitiesConnection = {
  __typename?: 'FacilitiesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<FacilityAggregates>;
  /** The dayahead rate for the associated pricing node. */
  dayaheadRate?: Maybe<MetricDataConnection>;
  /** A list of edges which contains the `Facility` and cursor to aid in pagination. */
  edges: Array<FacilitiesEdge>;
  /** The grid demand value for the associated balancing authority. */
  gridDemand?: Maybe<MetricDataConnection>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<FacilityAggregates>>;
  /** Aggregates a metric by label for the specified filter expression. */
  metricData?: Maybe<MetricDataConnection>;
  /** A list of `Facility` objects. */
  nodes: Array<Facility>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The realtime rate for the associated pricing node. */
  realtimeRate?: Maybe<MetricDataConnection>;
  /** The count of *all* `Facility` you could get from the connection. */
  totalCount: Scalars['Int'];
  /** The hourly cloud cover reading for the associated location. */
  weatherCloudCover?: Maybe<MetricDataConnection>;
  /** The hourly outside dewpoint reading for the associated location. */
  weatherDewpoint?: Maybe<MetricDataConnection>;
  /** The hourly outside humidity reading for the associated location. */
  weatherHumidity?: Maybe<MetricDataConnection>;
  /** The hourly outside solar energy reading for the associated location. */
  weatherSolarEnergy?: Maybe<MetricDataConnection>;
  /** The hourly outside solar radiation reading for the associated location. */
  weatherSolarRadiation?: Maybe<MetricDataConnection>;
  /** The hourly outside temperature reading for the associated location. */
  weatherTemperature?: Maybe<MetricDataConnection>;
  /** The hourly wet-bulb thermometer reading for the associated location. */
  weatherTemperatureWetBulb?: Maybe<MetricDataConnection>;
  /** The difference between the hourly wet-bulb and dry-bulb values. */
  weatherTemperatureWetBulbDepression?: Maybe<MetricDataConnection>;
  /** The hourly visibility reading for the associated location. */
  weatherVisibility?: Maybe<MetricDataConnection>;
};

/** A connection to a list of `Facility` values. */
export type FacilitiesConnectionDayaheadRateArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Facility` values. */
export type FacilitiesConnectionGridDemandArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Facility` values. */
export type FacilitiesConnectionGroupedAggregatesArgs = {
  groupBy: Array<FacilitiesGroupBy>;
  having?: InputMaybe<FacilitiesHavingInput>;
};

/** A connection to a list of `Facility` values. */
export type FacilitiesConnectionMetricDataArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Facility` values. */
export type FacilitiesConnectionRealtimeRateArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Facility` values. */
export type FacilitiesConnectionWeatherCloudCoverArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Facility` values. */
export type FacilitiesConnectionWeatherDewpointArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Facility` values. */
export type FacilitiesConnectionWeatherHumidityArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Facility` values. */
export type FacilitiesConnectionWeatherSolarEnergyArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Facility` values. */
export type FacilitiesConnectionWeatherSolarRadiationArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Facility` values. */
export type FacilitiesConnectionWeatherTemperatureArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Facility` values. */
export type FacilitiesConnectionWeatherTemperatureWetBulbArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Facility` values. */
export type FacilitiesConnectionWeatherTemperatureWetBulbDepressionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `Facility` values. */
export type FacilitiesConnectionWeatherVisibilityArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A `Facility` edge in the connection. */
export type FacilitiesEdge = {
  __typename?: 'FacilitiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Facility` at the end of the edge. */
  node: Facility;
};

/** Grouping methods for `Facility` for usage during aggregation. */
export enum FacilitiesGroupBy {
  ADDRESS = 'ADDRESS',
  ADDRESS_DISTINCT = 'ADDRESS_DISTINCT',
  BONUS_LTR = 'BONUS_LTR',
  BONUS_LTR_DISTINCT = 'BONUS_LTR_DISTINCT',
  CITY = 'CITY',
  CITY_DISTINCT = 'CITY_DISTINCT',
  CONTXT_9249 = 'CONTXT_9249',
  CONTXT_9249_DISTINCT = 'CONTXT_9249_DISTINCT',
  COUNTRY = 'COUNTRY',
  COUNTRY_DISTINCT = 'COUNTRY_DISTINCT',
  CREATED_AT = 'CREATED_AT',
  CREATED_AT_DISTINCT = 'CREATED_AT_DISTINCT',
  CREATED_AT_TRUNCATED_TO_DAY = 'CREATED_AT_TRUNCATED_TO_DAY',
  CREATED_AT_TRUNCATED_TO_HOUR = 'CREATED_AT_TRUNCATED_TO_HOUR',
  DATATYPE_1_TEST = 'DATATYPE_1_TEST',
  DATATYPE_1_TEST_DISTINCT = 'DATATYPE_1_TEST_DISTINCT',
  DATATYPE_1_TEST_TRUNCATED_TO_DAY = 'DATATYPE_1_TEST_TRUNCATED_TO_DAY',
  DATATYPE_1_TEST_TRUNCATED_TO_HOUR = 'DATATYPE_1_TEST_TRUNCATED_TO_HOUR',
  DATA_TYPE_2_TEST = 'DATA_TYPE_2_TEST',
  DATA_TYPE_2_TEST_DISTINCT = 'DATA_TYPE_2_TEST_DISTINCT',
  DATA_TYPE_3_TEST = 'DATA_TYPE_3_TEST',
  DATA_TYPE_3_TEST_DISTINCT = 'DATA_TYPE_3_TEST_DISTINCT',
  FACILITY_CONTACTS = 'FACILITY_CONTACTS',
  FACILITY_CONTACTS_DISTINCT = 'FACILITY_CONTACTS_DISTINCT',
  GEOMETRY = 'GEOMETRY',
  GEOMETRY_DISTINCT = 'GEOMETRY_DISTINCT',
  LATITUDE = 'LATITUDE',
  LATITUDE_DISTINCT = 'LATITUDE_DISTINCT',
  LINK_ACTIVE = 'LINK_ACTIVE',
  LINK_ACTIVE_DISTINCT = 'LINK_ACTIVE_DISTINCT',
  LONGITUDE = 'LONGITUDE',
  LONGITUDE_DISTINCT = 'LONGITUDE_DISTINCT',
  METRICS_ONE_ACTIVE = 'METRICS_ONE_ACTIVE',
  METRICS_ONE_ACTIVE_DISTINCT = 'METRICS_ONE_ACTIVE_DISTINCT',
  NAME = 'NAME',
  NAME_DISTINCT = 'NAME_DISTINCT',
  NOTE = 'NOTE',
  NOTE_DISTINCT = 'NOTE_DISTINCT',
  N_SIGHT_2_ACTIVE = 'N_SIGHT_2_ACTIVE',
  N_SIGHT_2_ACTIVE_DISTINCT = 'N_SIGHT_2_ACTIVE_DISTINCT',
  N_SIGHT_ACTIVE = 'N_SIGHT_ACTIVE',
  N_SIGHT_ACTIVE_DISTINCT = 'N_SIGHT_ACTIVE_DISTINCT',
  PRE_BONUS_EBITDA = 'PRE_BONUS_EBITDA',
  PRE_BONUS_EBITDA_DISTINCT = 'PRE_BONUS_EBITDA_DISTINCT',
  PRICING_NODE_ID = 'PRICING_NODE_ID',
  PRICING_NODE_ID_DISTINCT = 'PRICING_NODE_ID_DISTINCT',
  REAL_TIME_ENABLED = 'REAL_TIME_ENABLED',
  REAL_TIME_ENABLED_DISTINCT = 'REAL_TIME_ENABLED_DISTINCT',
  REFRIGERATIONVENDOR = 'REFRIGERATIONVENDOR',
  REFRIGERATIONVENDOR_DISTINCT = 'REFRIGERATIONVENDOR_DISTINCT',
  REFRIGERATION_CONTROL_SYSTEM_VENDOR = 'REFRIGERATION_CONTROL_SYSTEM_VENDOR',
  REFRIGERATION_CONTROL_SYSTEM_VENDOR_DISTINCT = 'REFRIGERATION_CONTROL_SYSTEM_VENDOR_DISTINCT',
  RETIRED_AT = 'RETIRED_AT',
  RETIRED_AT_DISTINCT = 'RETIRED_AT_DISTINCT',
  RETIRED_AT_TRUNCATED_TO_DAY = 'RETIRED_AT_TRUNCATED_TO_DAY',
  RETIRED_AT_TRUNCATED_TO_HOUR = 'RETIRED_AT_TRUNCATED_TO_HOUR',
  STATE = 'STATE',
  STATE_DISTINCT = 'STATE_DISTINCT',
  SUPPRESSE_FINANCIALS = 'SUPPRESSE_FINANCIALS',
  SUPPRESSE_FINANCIALS_DISTINCT = 'SUPPRESSE_FINANCIALS_DISTINCT',
  TIMEZONE_NAME = 'TIMEZONE_NAME',
  TIMEZONE_NAME_DISTINCT = 'TIMEZONE_NAME_DISTINCT',
  UNIT_GROUP = 'UNIT_GROUP',
  UNIT_GROUP_DISTINCT = 'UNIT_GROUP_DISTINCT',
  UPDATED_AT = 'UPDATED_AT',
  UPDATED_AT_DISTINCT = 'UPDATED_AT_DISTINCT',
  UPDATED_AT_TRUNCATED_TO_DAY = 'UPDATED_AT_TRUNCATED_TO_DAY',
  UPDATED_AT_TRUNCATED_TO_HOUR = 'UPDATED_AT_TRUNCATED_TO_HOUR',
  ZIP = 'ZIP',
  ZIP_DISTINCT = 'ZIP_DISTINCT'
}

export type FacilitiesHavingAverageFacilitiesActiveMeterDatesCountArgsInput = {
  from?: InputMaybe<Scalars['String']>;
  meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  to?: InputMaybe<Scalars['String']>;
};

export type FacilitiesHavingAverageFacilitiesActiveMeterDatesCountInput = {
  args?: InputMaybe<FacilitiesHavingAverageFacilitiesActiveMeterDatesCountArgsInput>;
  filter?: InputMaybe<HavingIntFilter>;
};

export type FacilitiesHavingAverageInput = {
  activeMeterDatesCount?: InputMaybe<FacilitiesHavingAverageFacilitiesActiveMeterDatesCountInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dataType2Test?: InputMaybe<HavingFloatFilter>;
  dataType3Test?: InputMaybe<HavingIntFilter>;
  datatype1Test?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingIntFilter>;
  latitude?: InputMaybe<HavingFloatFilter>;
  longitude?: InputMaybe<HavingFloatFilter>;
  pricingNodeId?: InputMaybe<HavingIntFilter>;
  retiredAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type FacilitiesHavingDistinctCountFacilitiesActiveMeterDatesCountArgsInput =
  {
    from?: InputMaybe<Scalars['String']>;
    meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
    to?: InputMaybe<Scalars['String']>;
  };

export type FacilitiesHavingDistinctCountFacilitiesActiveMeterDatesCountInput =
  {
    args?: InputMaybe<FacilitiesHavingDistinctCountFacilitiesActiveMeterDatesCountArgsInput>;
    filter?: InputMaybe<HavingIntFilter>;
  };

export type FacilitiesHavingDistinctCountInput = {
  activeMeterDatesCount?: InputMaybe<FacilitiesHavingDistinctCountFacilitiesActiveMeterDatesCountInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dataType2Test?: InputMaybe<HavingFloatFilter>;
  dataType3Test?: InputMaybe<HavingIntFilter>;
  datatype1Test?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingIntFilter>;
  latitude?: InputMaybe<HavingFloatFilter>;
  longitude?: InputMaybe<HavingFloatFilter>;
  pricingNodeId?: InputMaybe<HavingIntFilter>;
  retiredAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type FacilitiesHavingDistinctFacilitiesActiveMeterDatesCountArgsInput = {
  from?: InputMaybe<Scalars['String']>;
  meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  to?: InputMaybe<Scalars['String']>;
};

export type FacilitiesHavingDistinctFacilitiesActiveMeterDatesCountInput = {
  args?: InputMaybe<FacilitiesHavingDistinctFacilitiesActiveMeterDatesCountArgsInput>;
  filter?: InputMaybe<HavingIntFilter>;
};

export type FacilitiesHavingDistinctInput = {
  activeMeterDatesCount?: InputMaybe<FacilitiesHavingDistinctFacilitiesActiveMeterDatesCountInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dataType2Test?: InputMaybe<HavingFloatFilter>;
  dataType3Test?: InputMaybe<HavingIntFilter>;
  datatype1Test?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingIntFilter>;
  latitude?: InputMaybe<HavingFloatFilter>;
  longitude?: InputMaybe<HavingFloatFilter>;
  pricingNodeId?: InputMaybe<HavingIntFilter>;
  retiredAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `Facility` aggregates. */
export type FacilitiesHavingInput = {
  AND?: InputMaybe<Array<FacilitiesHavingInput>>;
  OR?: InputMaybe<Array<FacilitiesHavingInput>>;
  average?: InputMaybe<FacilitiesHavingAverageInput>;
  distinct?: InputMaybe<FacilitiesHavingDistinctInput>;
  distinctCount?: InputMaybe<FacilitiesHavingDistinctCountInput>;
  max?: InputMaybe<FacilitiesHavingMaxInput>;
  min?: InputMaybe<FacilitiesHavingMinInput>;
  stddevPopulation?: InputMaybe<FacilitiesHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<FacilitiesHavingStddevSampleInput>;
  sum?: InputMaybe<FacilitiesHavingSumInput>;
  variancePopulation?: InputMaybe<FacilitiesHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<FacilitiesHavingVarianceSampleInput>;
};

export type FacilitiesHavingMaxFacilitiesActiveMeterDatesCountArgsInput = {
  from?: InputMaybe<Scalars['String']>;
  meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  to?: InputMaybe<Scalars['String']>;
};

export type FacilitiesHavingMaxFacilitiesActiveMeterDatesCountInput = {
  args?: InputMaybe<FacilitiesHavingMaxFacilitiesActiveMeterDatesCountArgsInput>;
  filter?: InputMaybe<HavingIntFilter>;
};

export type FacilitiesHavingMaxInput = {
  activeMeterDatesCount?: InputMaybe<FacilitiesHavingMaxFacilitiesActiveMeterDatesCountInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dataType2Test?: InputMaybe<HavingFloatFilter>;
  dataType3Test?: InputMaybe<HavingIntFilter>;
  datatype1Test?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingIntFilter>;
  latitude?: InputMaybe<HavingFloatFilter>;
  longitude?: InputMaybe<HavingFloatFilter>;
  pricingNodeId?: InputMaybe<HavingIntFilter>;
  retiredAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type FacilitiesHavingMinFacilitiesActiveMeterDatesCountArgsInput = {
  from?: InputMaybe<Scalars['String']>;
  meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  to?: InputMaybe<Scalars['String']>;
};

export type FacilitiesHavingMinFacilitiesActiveMeterDatesCountInput = {
  args?: InputMaybe<FacilitiesHavingMinFacilitiesActiveMeterDatesCountArgsInput>;
  filter?: InputMaybe<HavingIntFilter>;
};

export type FacilitiesHavingMinInput = {
  activeMeterDatesCount?: InputMaybe<FacilitiesHavingMinFacilitiesActiveMeterDatesCountInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dataType2Test?: InputMaybe<HavingFloatFilter>;
  dataType3Test?: InputMaybe<HavingIntFilter>;
  datatype1Test?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingIntFilter>;
  latitude?: InputMaybe<HavingFloatFilter>;
  longitude?: InputMaybe<HavingFloatFilter>;
  pricingNodeId?: InputMaybe<HavingIntFilter>;
  retiredAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type FacilitiesHavingStddevPopulationFacilitiesActiveMeterDatesCountArgsInput =
  {
    from?: InputMaybe<Scalars['String']>;
    meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
    to?: InputMaybe<Scalars['String']>;
  };

export type FacilitiesHavingStddevPopulationFacilitiesActiveMeterDatesCountInput =
  {
    args?: InputMaybe<FacilitiesHavingStddevPopulationFacilitiesActiveMeterDatesCountArgsInput>;
    filter?: InputMaybe<HavingIntFilter>;
  };

export type FacilitiesHavingStddevPopulationInput = {
  activeMeterDatesCount?: InputMaybe<FacilitiesHavingStddevPopulationFacilitiesActiveMeterDatesCountInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dataType2Test?: InputMaybe<HavingFloatFilter>;
  dataType3Test?: InputMaybe<HavingIntFilter>;
  datatype1Test?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingIntFilter>;
  latitude?: InputMaybe<HavingFloatFilter>;
  longitude?: InputMaybe<HavingFloatFilter>;
  pricingNodeId?: InputMaybe<HavingIntFilter>;
  retiredAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type FacilitiesHavingStddevSampleFacilitiesActiveMeterDatesCountArgsInput =
  {
    from?: InputMaybe<Scalars['String']>;
    meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
    to?: InputMaybe<Scalars['String']>;
  };

export type FacilitiesHavingStddevSampleFacilitiesActiveMeterDatesCountInput = {
  args?: InputMaybe<FacilitiesHavingStddevSampleFacilitiesActiveMeterDatesCountArgsInput>;
  filter?: InputMaybe<HavingIntFilter>;
};

export type FacilitiesHavingStddevSampleInput = {
  activeMeterDatesCount?: InputMaybe<FacilitiesHavingStddevSampleFacilitiesActiveMeterDatesCountInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dataType2Test?: InputMaybe<HavingFloatFilter>;
  dataType3Test?: InputMaybe<HavingIntFilter>;
  datatype1Test?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingIntFilter>;
  latitude?: InputMaybe<HavingFloatFilter>;
  longitude?: InputMaybe<HavingFloatFilter>;
  pricingNodeId?: InputMaybe<HavingIntFilter>;
  retiredAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type FacilitiesHavingSumFacilitiesActiveMeterDatesCountArgsInput = {
  from?: InputMaybe<Scalars['String']>;
  meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  to?: InputMaybe<Scalars['String']>;
};

export type FacilitiesHavingSumFacilitiesActiveMeterDatesCountInput = {
  args?: InputMaybe<FacilitiesHavingSumFacilitiesActiveMeterDatesCountArgsInput>;
  filter?: InputMaybe<HavingIntFilter>;
};

export type FacilitiesHavingSumInput = {
  activeMeterDatesCount?: InputMaybe<FacilitiesHavingSumFacilitiesActiveMeterDatesCountInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dataType2Test?: InputMaybe<HavingFloatFilter>;
  dataType3Test?: InputMaybe<HavingIntFilter>;
  datatype1Test?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingIntFilter>;
  latitude?: InputMaybe<HavingFloatFilter>;
  longitude?: InputMaybe<HavingFloatFilter>;
  pricingNodeId?: InputMaybe<HavingIntFilter>;
  retiredAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type FacilitiesHavingVariancePopulationFacilitiesActiveMeterDatesCountArgsInput =
  {
    from?: InputMaybe<Scalars['String']>;
    meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
    to?: InputMaybe<Scalars['String']>;
  };

export type FacilitiesHavingVariancePopulationFacilitiesActiveMeterDatesCountInput =
  {
    args?: InputMaybe<FacilitiesHavingVariancePopulationFacilitiesActiveMeterDatesCountArgsInput>;
    filter?: InputMaybe<HavingIntFilter>;
  };

export type FacilitiesHavingVariancePopulationInput = {
  activeMeterDatesCount?: InputMaybe<FacilitiesHavingVariancePopulationFacilitiesActiveMeterDatesCountInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dataType2Test?: InputMaybe<HavingFloatFilter>;
  dataType3Test?: InputMaybe<HavingIntFilter>;
  datatype1Test?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingIntFilter>;
  latitude?: InputMaybe<HavingFloatFilter>;
  longitude?: InputMaybe<HavingFloatFilter>;
  pricingNodeId?: InputMaybe<HavingIntFilter>;
  retiredAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type FacilitiesHavingVarianceSampleFacilitiesActiveMeterDatesCountArgsInput =
  {
    from?: InputMaybe<Scalars['String']>;
    meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
    to?: InputMaybe<Scalars['String']>;
  };

export type FacilitiesHavingVarianceSampleFacilitiesActiveMeterDatesCountInput =
  {
    args?: InputMaybe<FacilitiesHavingVarianceSampleFacilitiesActiveMeterDatesCountArgsInput>;
    filter?: InputMaybe<HavingIntFilter>;
  };

export type FacilitiesHavingVarianceSampleInput = {
  activeMeterDatesCount?: InputMaybe<FacilitiesHavingVarianceSampleFacilitiesActiveMeterDatesCountInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dataType2Test?: InputMaybe<HavingFloatFilter>;
  dataType3Test?: InputMaybe<HavingIntFilter>;
  datatype1Test?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingIntFilter>;
  latitude?: InputMaybe<HavingFloatFilter>;
  longitude?: InputMaybe<HavingFloatFilter>;
  pricingNodeId?: InputMaybe<HavingIntFilter>;
  retiredAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Methods to use when ordering `Facility`. */
export enum FacilitiesOrderBy {
  ADDRESS_ASC = 'ADDRESS_ASC',
  ADDRESS_DESC = 'ADDRESS_DESC',
  BONUS_LTR_ASC = 'BONUS_LTR_ASC',
  BONUS_LTR_DESC = 'BONUS_LTR_DESC',
  CITY_ASC = 'CITY_ASC',
  CITY_DESC = 'CITY_DESC',
  CONTXT_9249_ASC = 'CONTXT_9249_ASC',
  CONTXT_9249_DESC = 'CONTXT_9249_DESC',
  COUNTRY_ASC = 'COUNTRY_ASC',
  COUNTRY_DESC = 'COUNTRY_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DATATYPE_1_TEST_ASC = 'DATATYPE_1_TEST_ASC',
  DATATYPE_1_TEST_DESC = 'DATATYPE_1_TEST_DESC',
  DATA_TYPE_2_TEST_ASC = 'DATA_TYPE_2_TEST_ASC',
  DATA_TYPE_2_TEST_DESC = 'DATA_TYPE_2_TEST_DESC',
  DATA_TYPE_3_TEST_ASC = 'DATA_TYPE_3_TEST_ASC',
  DATA_TYPE_3_TEST_DESC = 'DATA_TYPE_3_TEST_DESC',
  FACILITY_CONTACTS_ASC = 'FACILITY_CONTACTS_ASC',
  FACILITY_CONTACTS_DESC = 'FACILITY_CONTACTS_DESC',
  GEOMETRY_ASC = 'GEOMETRY_ASC',
  GEOMETRY_DESC = 'GEOMETRY_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LATITUDE_ASC = 'LATITUDE_ASC',
  LATITUDE_DESC = 'LATITUDE_DESC',
  LINK_ACTIVE_ASC = 'LINK_ACTIVE_ASC',
  LINK_ACTIVE_DESC = 'LINK_ACTIVE_DESC',
  LONGITUDE_ASC = 'LONGITUDE_ASC',
  LONGITUDE_DESC = 'LONGITUDE_DESC',
  METRICS_ONE_ACTIVE_ASC = 'METRICS_ONE_ACTIVE_ASC',
  METRICS_ONE_ACTIVE_DESC = 'METRICS_ONE_ACTIVE_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  NOTE_ASC = 'NOTE_ASC',
  NOTE_DESC = 'NOTE_DESC',
  N_SIGHT_2_ACTIVE_ASC = 'N_SIGHT_2_ACTIVE_ASC',
  N_SIGHT_2_ACTIVE_DESC = 'N_SIGHT_2_ACTIVE_DESC',
  N_SIGHT_ACTIVE_ASC = 'N_SIGHT_ACTIVE_ASC',
  N_SIGHT_ACTIVE_DESC = 'N_SIGHT_ACTIVE_DESC',
  PRE_BONUS_EBITDA_ASC = 'PRE_BONUS_EBITDA_ASC',
  PRE_BONUS_EBITDA_DESC = 'PRE_BONUS_EBITDA_DESC',
  PRICING_NODE_ID_ASC = 'PRICING_NODE_ID_ASC',
  PRICING_NODE_ID_DESC = 'PRICING_NODE_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  REAL_TIME_ENABLED_ASC = 'REAL_TIME_ENABLED_ASC',
  REAL_TIME_ENABLED_DESC = 'REAL_TIME_ENABLED_DESC',
  REFRIGERATIONVENDOR_ASC = 'REFRIGERATIONVENDOR_ASC',
  REFRIGERATIONVENDOR_DESC = 'REFRIGERATIONVENDOR_DESC',
  REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  RETIRED_AT_ASC = 'RETIRED_AT_ASC',
  RETIRED_AT_DESC = 'RETIRED_AT_DESC',
  SLUG_ASC = 'SLUG_ASC',
  SLUG_DESC = 'SLUG_DESC',
  STATE_ASC = 'STATE_ASC',
  STATE_DESC = 'STATE_DESC',
  SUPPRESSE_FINANCIALS_ASC = 'SUPPRESSE_FINANCIALS_ASC',
  SUPPRESSE_FINANCIALS_DESC = 'SUPPRESSE_FINANCIALS_DESC',
  TIMEZONE_NAME_ASC = 'TIMEZONE_NAME_ASC',
  TIMEZONE_NAME_DESC = 'TIMEZONE_NAME_DESC',
  UNIT_GROUP_ASC = 'UNIT_GROUP_ASC',
  UNIT_GROUP_DESC = 'UNIT_GROUP_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  UTILITY_BILL_CURRENCY_ASC = 'UTILITY_BILL_CURRENCY_ASC',
  UTILITY_BILL_CURRENCY_DESC = 'UTILITY_BILL_CURRENCY_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_COUNT_ASC = 'UTILITY_METER_STATEMENTS_COUNT_ASC',
  UTILITY_METER_STATEMENTS_COUNT_DESC = 'UTILITY_METER_STATEMENTS_COUNT_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_MAX_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_MAX_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_MAX_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_MAX_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_MAX_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_MAX_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_MAX_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_MAX_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_MAX_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_MAX_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_MAX_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_MAX_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_MAX_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_MAX_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_MAX_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_MAX_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_MAX_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_MAX_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_MAX_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_MAX_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_MAX_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_MAX_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_MAX_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_MAX_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_MAX_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_MAX_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_MAX_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_MAX_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_MAX_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_MAX_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_MAX_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_MAX_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_MAX_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_MAX_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_MAX_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_MAX_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_MAX_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_MAX_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_MAX_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_MAX_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_MAX_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_MAX_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_MAX_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_MAX_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_MAX_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_MAX_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_MAX_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_MAX_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_MAX_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_MAX_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_MAX_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_MAX_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_MAX_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_MAX_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_MAX_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_MAX_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_MAX_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_MAX_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_MAX_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_MIN_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_MIN_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_MIN_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_MIN_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_MIN_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_MIN_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_MIN_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_MIN_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_MIN_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_MIN_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_MIN_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_MIN_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_MIN_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_MIN_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_MIN_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_MIN_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_MIN_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_MIN_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_MIN_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_MIN_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_MIN_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_MIN_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_MIN_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_MIN_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_MIN_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_MIN_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_MIN_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_MIN_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_MIN_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_MIN_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_MIN_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_MIN_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_MIN_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_MIN_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_MIN_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_MIN_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_MIN_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_MIN_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_MIN_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_MIN_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_MIN_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_MIN_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_MIN_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_MIN_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_MIN_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_MIN_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_MIN_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_MIN_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_MIN_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_MIN_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_MIN_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_MIN_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_MIN_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_MIN_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_MIN_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_MIN_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_MIN_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_MIN_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_MIN_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_SUM_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_SUM_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_SUM_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_SUM_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_SUM_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_SUM_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_SUM_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_SUM_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_SUM_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_SUM_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_SUM_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_SUM_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_SUM_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_SUM_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_SUM_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_SUM_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_SUM_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_SUM_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_SUM_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_SUM_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_SUM_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_SUM_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_SUM_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_SUM_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_SUM_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_SUM_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_SUM_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_SUM_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_SUM_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_SUM_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_SUM_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_SUM_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_SUM_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_SUM_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_SUM_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_SUM_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_SUM_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_SUM_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_SUM_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_SUM_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_SUM_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_SUM_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_SUM_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_SUM_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_SUM_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_SUM_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_SUM_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_SUM_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_SUM_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_SUM_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_SUM_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_SUM_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_SUM_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_SUM_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_SUM_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_SUM_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_SUM_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_SUM_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_SUM_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_COUNT_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_COUNT_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_COUNT_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_COUNT_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_METER_ID_DESC',
  ZIP_ASC = 'ZIP_ASC',
  ZIP_DESC = 'ZIP_DESC'
}

/** A facility. */
export type Facility = Asset &
  Node & {
    __typename?: 'Facility';
    /** Reads and enables pagination through a set of `AccountStatement`. */
    accountStatements: AccountStatementsConnection;
    /** Returns the active communication for the facility, if one exists. */
    activeCommunication?: Maybe<FacilityCommunication>;
    /** The number of days we have active utility meters for a given serive type and time range. */
    activeMeterDatesCount?: Maybe<Scalars['Int']>;
    /** Returns a rollup of account statements for a given facility where there are active meter_statements. */
    activeUtilityAccountStatementRollups: UtilityAccountStatementRollupsConnection;
    /** Returns a summary of account statements for a given facility where there are active meter_statements. */
    activeUtilityAccountStatements: UtilityAccountStatementsConnection;
    /** The facility’s street address. */
    address?: Maybe<Scalars['String']>;
    /** Reads and enables pagination through a set of `BlastRotation`. */
    blastRotations: BlastRotationsConnection;
    /** Reads and enables pagination through a set of `Blast`. */
    blasts: BlastsConnection;
    /** Bonus LTR */
    bonusLtr: Scalars['Boolean'];
    /** Reads and enables pagination through a set of `BuildingArea`. */
    buildingAreas: BuildingAreasConnection;
    /** Reads and enables pagination through a set of `Chart`. */
    charts: ChartsConnection;
    /** The facility’s city. */
    city?: Maybe<Scalars['String']>;
    /** Reads and enables pagination through a set of `FacilityCommunication`. */
    communications: FacilityCommunicationsConnection;
    /** Reads and enables pagination through a set of `Component`. */
    components: ComponentsConnection;
    /** Reads and enables pagination through a set of `Compressor`. */
    compressor: CompressorsConnection;
    /** Serialized configuration for the facility */
    config?: Maybe<Scalars['JSON']>;
    /** Reads and enables pagination through a set of `FacilityConfig`. */
    configs: FacilityConfigsConnection;
    /** CONTXT-9249 testing */
    contxt9249?: Maybe<Scalars['String']>;
    country: Country;
    /** The time this facility was created. */
    createdAt?: Maybe<Scalars['Datetime']>;
    /** Reads and enables pagination through a set of `Customer`. */
    customers: CustomersConnection;
    /** Reads and enables pagination through a set of `Dashboard`. */
    dashboards: DashboardsConnection;
    /** Reads and enables pagination through a set of `DataSource`. */
    dataSources: DataSourcesConnection;
    /** DataType2Test */
    dataType2Test?: Maybe<Scalars['Float']>;
    /** dataType3Test */
    dataType3Test?: Maybe<Scalars['Int']>;
    /** Datatype1Test */
    datatype1Test?: Maybe<Scalars['Datetime']>;
    /** The dayahead rate for the associated pricing node. */
    dayaheadRate?: Maybe<MetricDataConnection>;
    /** Reads and enables pagination through a set of `Door`. */
    door: DoorsConnection;
    /** Reads and enables pagination through a set of `Evaporator`. */
    evaporator: EvaporatorsConnection;
    /** User contacts for facility */
    facilityContacts?: Maybe<Scalars['String']>;
    /** Reads and enables pagination through a set of `FacilityDataSource`. */
    facilityDataSources: FacilityDataSourcesConnection;
    /** Reads and enables pagination through a set of `FacilityGroup`. */
    facilityGroups: FacilityGroupsConnection;
    /** Reads and enables pagination through a set of `FacilityGroupsLinker`. */
    facilityGroupsLinkers: FacilityGroupsLinkersConnection;
    geometry?: Maybe<GeometryInterface>;
    /** The grid demand value for the associated balancing authority. */
    gridDemand?: Maybe<MetricDataConnection>;
    /** The primary unique identifier for the facility. */
    id: Scalars['Int'];
    /** Reads and enables pagination through a set of `InboundOutboundLoad`. */
    inboundOutboundLoads: InboundOutboundLoadsConnection;
    /** Facility Latitude */
    latitude?: Maybe<Scalars['Float']>;
    /** Link Active */
    linkActive: Scalars['Boolean'];
    /** Facility Longitude */
    longitude?: Maybe<Scalars['Float']>;
    /** Reads and enables pagination through a set of `MainService`. */
    mainServices: MainServicesConnection;
    /** Aggregates a metric by label for the specified filter expression. */
    metricData?: Maybe<MetricDataConnection>;
    metricLabels: Array<MetricLabel>;
    /** metricsOne Active */
    metricsOneActive: Scalars['Boolean'];
    mutableMetricData?: Maybe<MetricDataConnection>;
    /** Enabled in nSight. */
    nSight2Active: Scalars['Boolean'];
    /** nSight Active */
    nSightActive: Scalars['Boolean'];
    /** The facility’s name. */
    name: Scalars['String'];
    /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
    nodeId: Scalars['ID'];
    /** The note of Facility */
    note?: Maybe<Scalars['String']>;
    /** Reads and enables pagination through a set of `PalletLocation`. */
    palletLocations: PalletLocationsConnection;
    /** Pre-Bonus EBITDA */
    preBonusEbitda: Scalars['Boolean'];
    /** Reads a single `PricingNode` that is related to this `Facility`. */
    pricingNode?: Maybe<PricingNode>;
    /** The id of the pricing node the facility is associated with. */
    pricingNodeId?: Maybe<Scalars['Int']>;
    /** Reads and enables pagination through a set of `Product`. */
    products: ProductsConnection;
    /** Reads and enables pagination through a set of `Project`. */
    projects: ProjectsConnection;
    /** Flag to use real-time data or just utility data */
    realTimeEnabled: Scalars['Boolean'];
    /** The realtime rate for the associated pricing node. */
    realtimeRate?: Maybe<MetricDataConnection>;
    /** same desc */
    refrigerationControlSystemVendor?: Maybe<Scalars['String']>;
    /** refrigeration control system vendor */
    refrigerationvendor?: Maybe<Scalars['String']>;
    /** The time a facility was retired. This allows us to leave the facility enabled for nsight kpis when it was active, while hiding it after the facility was retired (sold / closed) */
    retiredAt?: Maybe<Scalars['Datetime']>;
    /** The facility’s slug. */
    slug: Scalars['String'];
    /** The facility’s state. */
    state?: Maybe<Scalars['String']>;
    /** Suppresse Financials */
    suppresseFinancials: Scalars['Boolean'];
    /** Reads and enables pagination through a set of `FacilityTaggedDataPoint`. */
    taggedDataPoints: FacilityTaggedDataPointsConnection;
    /** Reads and enables pagination through a set of `TemperatureSensor`. */
    temperatureSensor: TemperatureSensorsConnection;
    /** Reads a single `Timezone` that is related to this `Facility`. */
    timezone?: Maybe<Timezone>;
    /** The name of the timezone for the facility. */
    timezoneName?: Maybe<Scalars['String']>;
    /** Reads and enables pagination through a set of `TrailerPosition`. */
    trailerPosition: TrailerPositionsConnection;
    /** The unit grouping of the facility. */
    unitGroup?: Maybe<Scalars['String']>;
    /** Reads a single `UnitGroup` that is related to this `Facility`. */
    unitGroupByUnitGroup?: Maybe<UnitGroup>;
    /** The time this facility was updated. */
    updatedAt?: Maybe<Scalars['Datetime']>;
    /** Returns a rollup of account statements for a given facility. */
    utilityAccountStatementRollups: UtilityAccountStatementRollupsConnection;
    /** Returns a top level of account statements for a given facility. */
    utilityAccountStatements: UtilityAccountStatementsConnection;
    /** Returns a set of distinct utility accounts for a given facility. */
    utilityAccounts: UtilityAccountsConnection;
    /** Returns the currency used when ingesting utility bills */
    utilityBillCurrency?: Maybe<Scalars['String']>;
    /** The distinct service types for a facility's active utility meters. */
    utilityMeterServiceTypes?: Maybe<Array<Maybe<UtilityMeterServiceType>>>;
    /** Reads and enables pagination through a set of `UtilityMeterStatementRollup`. */
    utilityMeterStatementRollups: UtilityMeterStatementRollupsConnection;
    /** Reads and enables pagination through a set of `UtilityMeterStatement`. */
    utilityMeterStatements: UtilityMeterStatementsConnection;
    /** Reads and enables pagination through a set of `UtilityMeter`. */
    utilityMeters: UtilityMetersConnection;
    /** The hourly cloud cover reading for the associated location. */
    weatherCloudCover?: Maybe<MetricDataConnection>;
    /** The hourly outside dewpoint reading for the associated location. */
    weatherDewpoint?: Maybe<MetricDataConnection>;
    /** The hourly outside humidity reading for the associated location. */
    weatherHumidity?: Maybe<MetricDataConnection>;
    /** The hourly outside solar energy reading for the associated location. */
    weatherSolarEnergy?: Maybe<MetricDataConnection>;
    /** The hourly outside solar radiation reading for the associated location. */
    weatherSolarRadiation?: Maybe<MetricDataConnection>;
    /** The hourly outside temperature reading for the associated location. */
    weatherTemperature?: Maybe<MetricDataConnection>;
    /** The hourly wet-bulb thermometer reading for the associated location. */
    weatherTemperatureWetBulb?: Maybe<MetricDataConnection>;
    /** The difference between the hourly wet-bulb and dry-bulb values. */
    weatherTemperatureWetBulbDepression?: Maybe<MetricDataConnection>;
    /** The hourly visibility reading for the associated location. */
    weatherVisibility?: Maybe<MetricDataConnection>;
    /** The facility’s zip code. */
    zip?: Maybe<Scalars['String']>;
  };

/** A facility. */
export type FacilityAccountStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<AccountStatementFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** A facility. */
export type FacilityActiveMeterDatesCountArgs = {
  from?: InputMaybe<Scalars['String']>;
  meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  to?: InputMaybe<Scalars['String']>;
};

/** A facility. */
export type FacilityActiveUtilityAccountStatementRollupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<UtilityAccountStatementRollupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** A facility. */
export type FacilityActiveUtilityAccountStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<UtilityAccountStatementFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** A facility. */
export type FacilityBlastRotationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<BlastRotationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BlastRotationsOrderBy>>;
};

/** A facility. */
export type FacilityBlastsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BlastCondition>;
  filter?: InputMaybe<BlastFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BlastsOrderBy>>;
};

/** A facility. */
export type FacilityBuildingAreasArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BuildingAreaCondition>;
  filter?: InputMaybe<BuildingAreaFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BuildingAreasOrderBy>>;
};

/** A facility. */
export type FacilityChartsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ChartCondition>;
  filter?: InputMaybe<ChartFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ChartsOrderBy>>;
};

/** A facility. */
export type FacilityCommunicationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FacilityCommunicationCondition>;
  filter?: InputMaybe<FacilityCommunicationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FacilityCommunicationsOrderBy>>;
};

/** A facility. */
export type FacilityComponentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ComponentCondition>;
  filter?: InputMaybe<ComponentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ComponentsOrderBy>>;
};

/** A facility. */
export type FacilityCompressorArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompressorCondition>;
  filter?: InputMaybe<CompressorFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompressorsOrderBy>>;
};

/** A facility. */
export type FacilityConfigsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FacilityConfigCondition>;
  filter?: InputMaybe<FacilityConfigFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FacilityConfigsOrderBy>>;
};

/** A facility. */
export type FacilityCustomersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CustomerCondition>;
  filter?: InputMaybe<CustomerFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CustomersOrderBy>>;
};

/** A facility. */
export type FacilityDashboardsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DashboardCondition>;
  filter?: InputMaybe<DashboardFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DashboardsOrderBy>>;
};

/** A facility. */
export type FacilityDataSourcesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<DataSourceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** A facility. */
export type FacilityDayaheadRateArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A facility. */
export type FacilityDoorArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DoorCondition>;
  filter?: InputMaybe<DoorFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DoorsOrderBy>>;
};

/** A facility. */
export type FacilityEvaporatorArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EvaporatorCondition>;
  filter?: InputMaybe<EvaporatorFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EvaporatorsOrderBy>>;
};

/** A facility. */
export type FacilityFacilityDataSourcesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FacilityDataSourceCondition>;
  filter?: InputMaybe<FacilityDataSourceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FacilityDataSourcesOrderBy>>;
};

/** A facility. */
export type FacilityFacilityGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<FacilityGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** A facility. */
export type FacilityFacilityGroupsLinkersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FacilityGroupsLinkerCondition>;
  filter?: InputMaybe<FacilityGroupsLinkerFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FacilityGroupsLinkersOrderBy>>;
};

/** A facility. */
export type FacilityGridDemandArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A facility. */
export type FacilityInboundOutboundLoadsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<InboundOutboundLoadCondition>;
  filter?: InputMaybe<InboundOutboundLoadFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InboundOutboundLoadsOrderBy>>;
};

/** A facility. */
export type FacilityMainServicesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MainServiceCondition>;
  filter?: InputMaybe<MainServiceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MainServicesOrderBy>>;
};

/** A facility. */
export type FacilityMetricDataArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: InputMaybe<MetricDataAggregationMethod>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A facility. */
export type FacilityMetricLabelsArgs = {
  mutableOnly?: InputMaybe<Scalars['Boolean']>;
};

/** A facility. */
export type FacilityMutableMetricDataArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  to?: InputMaybe<Scalars['String']>;
};

/** A facility. */
export type FacilityPalletLocationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PalletLocationCondition>;
  filter?: InputMaybe<PalletLocationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PalletLocationsOrderBy>>;
};

/** A facility. */
export type FacilityProductsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProductCondition>;
  filter?: InputMaybe<ProductFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};

/** A facility. */
export type FacilityProjectsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectCondition>;
  filter?: InputMaybe<ProjectFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};

/** A facility. */
export type FacilityRealtimeRateArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A facility. */
export type FacilityTaggedDataPointsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FacilityTaggedDataPointCondition>;
  filter?: InputMaybe<FacilityTaggedDataPointFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FacilityTaggedDataPointsOrderBy>>;
};

/** A facility. */
export type FacilityTemperatureSensorArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TemperatureSensorCondition>;
  filter?: InputMaybe<TemperatureSensorFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TemperatureSensorsOrderBy>>;
};

/** A facility. */
export type FacilityTrailerPositionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TrailerPositionCondition>;
  filter?: InputMaybe<TrailerPositionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TrailerPositionsOrderBy>>;
};

/** A facility. */
export type FacilityUtilityAccountStatementRollupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<UtilityAccountStatementRollupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** A facility. */
export type FacilityUtilityAccountStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<UtilityAccountStatementFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** A facility. */
export type FacilityUtilityAccountsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<UtilityAccountFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** A facility. */
export type FacilityUtilityMeterStatementRollupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UtilityMeterStatementRollupCondition>;
  filter?: InputMaybe<UtilityMeterStatementRollupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UtilityMeterStatementRollupsOrderBy>>;
};

/** A facility. */
export type FacilityUtilityMeterStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UtilityMeterStatementCondition>;
  filter?: InputMaybe<UtilityMeterStatementFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UtilityMeterStatementsOrderBy>>;
};

/** A facility. */
export type FacilityUtilityMetersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UtilityMeterCondition>;
  filter?: InputMaybe<UtilityMeterFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UtilityMetersOrderBy>>;
};

/** A facility. */
export type FacilityWeatherCloudCoverArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A facility. */
export type FacilityWeatherDewpointArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A facility. */
export type FacilityWeatherHumidityArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A facility. */
export type FacilityWeatherSolarEnergyArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A facility. */
export type FacilityWeatherSolarRadiationArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A facility. */
export type FacilityWeatherTemperatureArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A facility. */
export type FacilityWeatherTemperatureWetBulbArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A facility. */
export type FacilityWeatherTemperatureWetBulbDepressionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A facility. */
export type FacilityWeatherVisibilityArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

export type FacilityAggregates = {
  __typename?: 'FacilityAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<FacilityAverageAggregates>;
  /** Distinct aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinct?: Maybe<FacilityDistinctAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<FacilityDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<FacilityMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<FacilityMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<FacilityStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<FacilityStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<FacilitySumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<FacilityVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<FacilityVarianceSampleAggregates>;
};

export type FacilityAverageAggregates = {
  __typename?: 'FacilityAverageAggregates';
  /**
   * Mean average of this field across the matching connection.
   *
   * ---
   *
   * The number of days we have active utility meters for a given serive type and time range.
   */
  activeMeterDatesCount?: Maybe<Scalars['BigFloat']>;
  /** Mean average of dataType2Test across the matching connection */
  dataType2Test?: Maybe<Scalars['Float']>;
  /** Mean average of dataType3Test across the matching connection */
  dataType3Test?: Maybe<Scalars['BigFloat']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']>;
  /** Mean average of latitude across the matching connection */
  latitude?: Maybe<Scalars['Float']>;
  /** Mean average of longitude across the matching connection */
  longitude?: Maybe<Scalars['Float']>;
  /** Mean average of pricingNodeId across the matching connection */
  pricingNodeId?: Maybe<Scalars['BigFloat']>;
};

export type FacilityAverageAggregatesActiveMeterDatesCountArgs = {
  from?: InputMaybe<Scalars['String']>;
  meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  to?: InputMaybe<Scalars['String']>;
};

/** A communication associated with the facility. */
export type FacilityCommunication = Node & {
  __typename?: 'FacilityCommunication';
  /** The time the communication was cleared. */
  clearedAt?: Maybe<Scalars['Datetime']>;
  /** The time the communication was created. */
  createdAt: Scalars['Datetime'];
  /** Reads a single `Facility` that is related to this `FacilityCommunication`. */
  facility?: Maybe<Facility>;
  /** The associated facility. */
  facilityId: Scalars['Int'];
  id: Scalars['Int'];
  /** Whether the communication is cleared or active. */
  isCleared?: Maybe<Scalars['Boolean']>;
  /** The message. */
  message: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The time the communication was updated. */
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `FacilityCommunication` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type FacilityCommunicationCondition = {
  /** Checks for equality with the object’s `clearedAt` field. */
  clearedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `message` field. */
  message?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `FacilityCommunication` object types. All fields are combined with a logical ‘and.’ */
export type FacilityCommunicationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FacilityCommunicationFilter>>;
  /** Filter by the object’s `clearedAt` field. */
  clearedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isCleared` field. */
  isCleared?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `message` field. */
  message?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FacilityCommunicationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FacilityCommunicationFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `FacilityCommunication` */
export type FacilityCommunicationInput = {
  /** The associated facility. */
  facilityId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  /** The message. */
  message: Scalars['String'];
};

/** A connection to a list of `FacilityCommunication` values. */
export type FacilityCommunicationsConnection = {
  __typename?: 'FacilityCommunicationsConnection';
  /** A list of edges which contains the `FacilityCommunication` and cursor to aid in pagination. */
  edges: Array<FacilityCommunicationsEdge>;
  /** A list of `FacilityCommunication` objects. */
  nodes: Array<FacilityCommunication>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FacilityCommunication` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `FacilityCommunication` edge in the connection. */
export type FacilityCommunicationsEdge = {
  __typename?: 'FacilityCommunicationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `FacilityCommunication` at the end of the edge. */
  node: FacilityCommunication;
};

/** Methods to use when ordering `FacilityCommunication`. */
export enum FacilityCommunicationsOrderBy {
  CLEARED_AT_ASC = 'CLEARED_AT_ASC',
  CLEARED_AT_DESC = 'CLEARED_AT_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  MESSAGE_ASC = 'MESSAGE_ASC',
  MESSAGE_DESC = 'MESSAGE_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/**
 * A condition to be used against `Facility` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type FacilityCondition = {
  /** Checks for equality with the object’s `address` field. */
  address?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `bonusLtr` field. */
  bonusLtr?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `city` field. */
  city?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `config` field. */
  config?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `contxt9249` field. */
  contxt9249?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `country` field. */
  country?: InputMaybe<Country>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `dataType2Test` field. */
  dataType2Test?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `dataType3Test` field. */
  dataType3Test?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `datatype1Test` field. */
  datatype1Test?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `facilityContacts` field. */
  facilityContacts?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `geometry` field. */
  geometry?: InputMaybe<Scalars['GeoJSON']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `latitude` field. */
  latitude?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `linkActive` field. */
  linkActive?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `longitude` field. */
  longitude?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `metricsOneActive` field. */
  metricsOneActive?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `nSight2Active` field. */
  nSight2Active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `nSightActive` field. */
  nSightActive?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `note` field. */
  note?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `preBonusEbitda` field. */
  preBonusEbitda?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pricingNodeId` field. */
  pricingNodeId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `realTimeEnabled` field. */
  realTimeEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `refrigerationControlSystemVendor` field. */
  refrigerationControlSystemVendor?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `refrigerationvendor` field. */
  refrigerationvendor?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `retiredAt` field. */
  retiredAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `suppresseFinancials` field. */
  suppresseFinancials?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `timezoneName` field. */
  timezoneName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `unitGroup` field. */
  unitGroup?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `zip` field. */
  zip?: InputMaybe<Scalars['String']>;
};

export type FacilityConfig = Node & {
  __typename?: 'FacilityConfig';
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Reads a single `Facility` that is related to this `FacilityConfig`. */
  facility?: Maybe<Facility>;
  facilityId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  key?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  updatedAt?: Maybe<Scalars['Datetime']>;
  value?: Maybe<Scalars['JSON']>;
};

/**
 * A condition to be used against `FacilityConfig` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FacilityConfigCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['JSON']>;
};

/** A filter to be used against `FacilityConfig` object types. All fields are combined with a logical ‘and.’ */
export type FacilityConfigFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FacilityConfigFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FacilityConfigFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FacilityConfigFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<JsonFilter>;
};

/** A connection to a list of `FacilityConfig` values. */
export type FacilityConfigsConnection = {
  __typename?: 'FacilityConfigsConnection';
  /** A list of edges which contains the `FacilityConfig` and cursor to aid in pagination. */
  edges: Array<FacilityConfigsEdge>;
  /** A list of `FacilityConfig` objects. */
  nodes: Array<FacilityConfig>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FacilityConfig` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `FacilityConfig` edge in the connection. */
export type FacilityConfigsEdge = {
  __typename?: 'FacilityConfigsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `FacilityConfig` at the end of the edge. */
  node: FacilityConfig;
};

/** Methods to use when ordering `FacilityConfig`. */
export enum FacilityConfigsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  KEY_ASC = 'KEY_ASC',
  KEY_DESC = 'KEY_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VALUE_ASC = 'VALUE_ASC',
  VALUE_DESC = 'VALUE_DESC'
}

/** This maps facilities to one or more data sources. */
export type FacilityDataSource = Node & {
  __typename?: 'FacilityDataSource';
  /** Reads a single `DataSource` that is related to this `FacilityDataSource`. */
  dataSourceByDataSourceName?: Maybe<DataSource>;
  /** The data source for the facility. */
  dataSourceName: Scalars['String'];
  /** Reads a single `Facility` that is related to this `FacilityDataSource`. */
  facility?: Maybe<Facility>;
  /** The facility id for the data source. */
  facilityId: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
};

/**
 * A condition to be used against `FacilityDataSource` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FacilityDataSourceCondition = {
  /** Checks for equality with the object’s `dataSourceName` field. */
  dataSourceName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `FacilityDataSource` object types. All fields are combined with a logical ‘and.’ */
export type FacilityDataSourceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FacilityDataSourceFilter>>;
  /** Filter by the object’s `dataSourceName` field. */
  dataSourceName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FacilityDataSourceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FacilityDataSourceFilter>>;
};

/** An input for mutations affecting `FacilityDataSource` */
export type FacilityDataSourceInput = {
  /** Mutates a `DataSource` as part of the payload */
  dataSource?: InputMaybe<DataSourceInput>;
  /** The data source for the facility. */
  dataSourceName?: InputMaybe<Scalars['String']>;
  /** The facility id for the data source. */
  facilityId: Scalars['Int'];
};

/** A connection to a list of `FacilityDataSource` values. */
export type FacilityDataSourcesConnection = {
  __typename?: 'FacilityDataSourcesConnection';
  /** A list of edges which contains the `FacilityDataSource` and cursor to aid in pagination. */
  edges: Array<FacilityDataSourcesEdge>;
  /** A list of `FacilityDataSource` objects. */
  nodes: Array<FacilityDataSource>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FacilityDataSource` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `FacilityDataSource` edge in the connection. */
export type FacilityDataSourcesEdge = {
  __typename?: 'FacilityDataSourcesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `FacilityDataSource` at the end of the edge. */
  node: FacilityDataSource;
};

/** Methods to use when ordering `FacilityDataSource`. */
export enum FacilityDataSourcesOrderBy {
  DATA_SOURCE_NAME_ASC = 'DATA_SOURCE_NAME_ASC',
  DATA_SOURCE_NAME_DESC = 'DATA_SOURCE_NAME_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

export type FacilityDistinctAggregates = {
  __typename?: 'FacilityDistinctAggregates';
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * Returns the active communication for the facility, if one exists.
   */
  activeCommunication?: Maybe<Scalars['JSON']>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * The number of days we have active utility meters for a given serive type and time range.
   */
  activeMeterDatesCount?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Distinct of address across the matching connection */
  address?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Distinct of bonusLtr across the matching connection */
  bonusLtr?: Maybe<Scalars['JSON']>;
  /** Distinct of city across the matching connection */
  city?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * Serialized configuration for the facility
   */
  config?: Maybe<Scalars['JSON']>;
  /** Distinct of contxt9249 across the matching connection */
  contxt9249?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Distinct of country across the matching connection */
  country?: Maybe<Scalars['JSON']>;
  /** Distinct of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['JSON']>;
  /** Distinct of dataType2Test across the matching connection */
  dataType2Test?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Distinct of dataType3Test across the matching connection */
  dataType3Test?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Distinct of datatype1Test across the matching connection */
  datatype1Test?: Maybe<Scalars['JSON']>;
  /** Distinct of facilityContacts across the matching connection */
  facilityContacts?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Distinct of geometry across the matching connection */
  geometry?: Maybe<Scalars['JSON']>;
  /** Distinct of id across the matching connection */
  id?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Distinct of latitude across the matching connection */
  latitude?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Distinct of linkActive across the matching connection */
  linkActive?: Maybe<Scalars['JSON']>;
  /** Distinct of longitude across the matching connection */
  longitude?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Distinct of metricsOneActive across the matching connection */
  metricsOneActive?: Maybe<Scalars['JSON']>;
  /** Distinct of nSight2Active across the matching connection */
  nSight2Active?: Maybe<Scalars['JSON']>;
  /** Distinct of nSightActive across the matching connection */
  nSightActive?: Maybe<Scalars['JSON']>;
  /** Distinct of name across the matching connection */
  name?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Distinct of note across the matching connection */
  note?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Distinct of preBonusEbitda across the matching connection */
  preBonusEbitda?: Maybe<Scalars['JSON']>;
  /** Distinct of pricingNodeId across the matching connection */
  pricingNodeId?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Distinct of realTimeEnabled across the matching connection */
  realTimeEnabled?: Maybe<Scalars['JSON']>;
  /** Distinct of refrigerationControlSystemVendor across the matching connection */
  refrigerationControlSystemVendor?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Distinct of refrigerationvendor across the matching connection */
  refrigerationvendor?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Distinct of retiredAt across the matching connection */
  retiredAt?: Maybe<Scalars['JSON']>;
  /** Distinct of slug across the matching connection */
  slug?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Distinct of state across the matching connection */
  state?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Distinct of suppresseFinancials across the matching connection */
  suppresseFinancials?: Maybe<Scalars['JSON']>;
  /** Distinct of timezoneName across the matching connection */
  timezoneName?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Distinct of unitGroup across the matching connection */
  unitGroup?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Distinct of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['JSON']>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * Returns the currency used when ingesting utility bills
   */
  utilityBillCurrency?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * The distinct service types for a facility's active utility meters.
   */
  utilityMeterServiceTypes?: Maybe<Scalars['JSON']>;
  /** Distinct of zip across the matching connection */
  zip?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type FacilityDistinctAggregatesActiveMeterDatesCountArgs = {
  from?: InputMaybe<Scalars['String']>;
  meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  to?: InputMaybe<Scalars['String']>;
};

export type FacilityDistinctCountAggregates = {
  __typename?: 'FacilityDistinctCountAggregates';
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * Returns the active communication for the facility, if one exists.
   */
  activeCommunication?: Maybe<Scalars['BigInt']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * The number of days we have active utility meters for a given serive type and time range.
   */
  activeMeterDatesCount?: Maybe<Scalars['BigInt']>;
  /** Distinct count of address across the matching connection */
  address?: Maybe<Scalars['BigInt']>;
  /** Distinct count of bonusLtr across the matching connection */
  bonusLtr?: Maybe<Scalars['BigInt']>;
  /** Distinct count of city across the matching connection */
  city?: Maybe<Scalars['BigInt']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * Serialized configuration for the facility
   */
  config?: Maybe<Scalars['BigInt']>;
  /** Distinct count of contxt9249 across the matching connection */
  contxt9249?: Maybe<Scalars['BigInt']>;
  /** Distinct count of country across the matching connection */
  country?: Maybe<Scalars['BigInt']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of dataType2Test across the matching connection */
  dataType2Test?: Maybe<Scalars['BigInt']>;
  /** Distinct count of dataType3Test across the matching connection */
  dataType3Test?: Maybe<Scalars['BigInt']>;
  /** Distinct count of datatype1Test across the matching connection */
  datatype1Test?: Maybe<Scalars['BigInt']>;
  /** Distinct count of facilityContacts across the matching connection */
  facilityContacts?: Maybe<Scalars['BigInt']>;
  /** Distinct count of geometry across the matching connection */
  geometry?: Maybe<Scalars['BigInt']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']>;
  /** Distinct count of latitude across the matching connection */
  latitude?: Maybe<Scalars['BigInt']>;
  /** Distinct count of linkActive across the matching connection */
  linkActive?: Maybe<Scalars['BigInt']>;
  /** Distinct count of longitude across the matching connection */
  longitude?: Maybe<Scalars['BigInt']>;
  /** Distinct count of metricsOneActive across the matching connection */
  metricsOneActive?: Maybe<Scalars['BigInt']>;
  /** Distinct count of nSight2Active across the matching connection */
  nSight2Active?: Maybe<Scalars['BigInt']>;
  /** Distinct count of nSightActive across the matching connection */
  nSightActive?: Maybe<Scalars['BigInt']>;
  /** Distinct count of name across the matching connection */
  name?: Maybe<Scalars['BigInt']>;
  /** Distinct count of note across the matching connection */
  note?: Maybe<Scalars['BigInt']>;
  /** Distinct count of preBonusEbitda across the matching connection */
  preBonusEbitda?: Maybe<Scalars['BigInt']>;
  /** Distinct count of pricingNodeId across the matching connection */
  pricingNodeId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of realTimeEnabled across the matching connection */
  realTimeEnabled?: Maybe<Scalars['BigInt']>;
  /** Distinct count of refrigerationControlSystemVendor across the matching connection */
  refrigerationControlSystemVendor?: Maybe<Scalars['BigInt']>;
  /** Distinct count of refrigerationvendor across the matching connection */
  refrigerationvendor?: Maybe<Scalars['BigInt']>;
  /** Distinct count of retiredAt across the matching connection */
  retiredAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of slug across the matching connection */
  slug?: Maybe<Scalars['BigInt']>;
  /** Distinct count of state across the matching connection */
  state?: Maybe<Scalars['BigInt']>;
  /** Distinct count of suppresseFinancials across the matching connection */
  suppresseFinancials?: Maybe<Scalars['BigInt']>;
  /** Distinct count of timezoneName across the matching connection */
  timezoneName?: Maybe<Scalars['BigInt']>;
  /** Distinct count of unitGroup across the matching connection */
  unitGroup?: Maybe<Scalars['BigInt']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * Returns the currency used when ingesting utility bills
   */
  utilityBillCurrency?: Maybe<Scalars['BigInt']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * The distinct service types for a facility's active utility meters.
   */
  utilityMeterServiceTypes?: Maybe<Scalars['BigInt']>;
  /** Distinct count of zip across the matching connection */
  zip?: Maybe<Scalars['BigInt']>;
};

export type FacilityDistinctCountAggregatesActiveMeterDatesCountArgs = {
  from?: InputMaybe<Scalars['String']>;
  meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  to?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `Facility` object types. All fields are combined with a logical ‘and.’ */
export type FacilityFilter = {
  /** Filter by the object’s `address` field. */
  address?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FacilityFilter>>;
  /** Filter by the object’s `bonusLtr` field. */
  bonusLtr?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `city` field. */
  city?: InputMaybe<StringFilter>;
  /** Filter by the object’s `config` field. */
  config?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `contxt9249` field. */
  contxt9249?: InputMaybe<StringFilter>;
  /** Filter by the object’s `country` field. */
  country?: InputMaybe<CountryFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dataType2Test` field. */
  dataType2Test?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `dataType3Test` field. */
  dataType3Test?: InputMaybe<IntFilter>;
  /** Filter by the object’s `datatype1Test` field. */
  datatype1Test?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `facilityContacts` field. */
  facilityContacts?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `latitude` field. */
  latitude?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `linkActive` field. */
  linkActive?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `longitude` field. */
  longitude?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `metricsOneActive` field. */
  metricsOneActive?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `nSight2Active` field. */
  nSight2Active?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `nSightActive` field. */
  nSightActive?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FacilityFilter>;
  /** Filter by the object’s `note` field. */
  note?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FacilityFilter>>;
  /** Filter by the object’s `preBonusEbitda` field. */
  preBonusEbitda?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `pricingNodeId` field. */
  pricingNodeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `realTimeEnabled` field. */
  realTimeEnabled?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `refrigerationControlSystemVendor` field. */
  refrigerationControlSystemVendor?: InputMaybe<StringFilter>;
  /** Filter by the object’s `refrigerationvendor` field. */
  refrigerationvendor?: InputMaybe<StringFilter>;
  /** Filter by the object’s `retiredAt` field. */
  retiredAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `slug` field. */
  slug?: InputMaybe<StringFilter>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<StringFilter>;
  /** Filter by the object’s `suppresseFinancials` field. */
  suppresseFinancials?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `timezoneName` field. */
  timezoneName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `unitGroup` field. */
  unitGroup?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `utilityBillCurrency` field. */
  utilityBillCurrency?: InputMaybe<StringFilter>;
  /** Filter by the object’s `utilityMeterServiceTypes` field. */
  utilityMeterServiceTypes?: InputMaybe<UtilityMeterServiceTypeListFilter>;
  /** Filter by the object’s `zip` field. */
  zip?: InputMaybe<StringFilter>;
};

/** A grouping of facilities. */
export type FacilityGroup = Node & {
  __typename?: 'FacilityGroup';
  /** Reads and enables pagination through a set of `Facility`. */
  allFacilities: FacilitiesConnection;
  /** Reads and enables pagination through a set of `FacilityGroup`. */
  childFacilityGroups: FacilityGroupsConnection;
  /** Reads and enables pagination through a set of `Facility`. */
  facilities: FacilitiesConnection;
  /** Reads and enables pagination through a set of `FacilityGroupsLinker`. */
  facilityGroupsLinkersByFacilityGroupingId: FacilityGroupsLinkersConnection;
  /** The facility group’s id. */
  id: Scalars['BigInt'];
  /** The facility group’s name. */
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `FacilityGroup` that is related to this `FacilityGroup`. */
  parent?: Maybe<FacilityGroup>;
  /** The id of the facility group’s parent node. */
  parentId?: Maybe<Scalars['BigInt']>;
};

/** A grouping of facilities. */
export type FacilityGroupAllFacilitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<FacilityFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** A grouping of facilities. */
export type FacilityGroupChildFacilityGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FacilityGroupCondition>;
  filter?: InputMaybe<FacilityGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FacilityGroupsOrderBy>>;
};

/** A grouping of facilities. */
export type FacilityGroupFacilitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<FacilityFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** A grouping of facilities. */
export type FacilityGroupFacilityGroupsLinkersByFacilityGroupingIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FacilityGroupsLinkerCondition>;
  filter?: InputMaybe<FacilityGroupsLinkerFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FacilityGroupsLinkersOrderBy>>;
};

/**
 * A condition to be used against `FacilityGroup` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FacilityGroupCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `parentId` field. */
  parentId?: InputMaybe<Scalars['BigInt']>;
};

/** A filter to be used against `FacilityGroup` object types. All fields are combined with a logical ‘and.’ */
export type FacilityGroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FacilityGroupFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FacilityGroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FacilityGroupFilter>>;
  /** Filter by the object’s `parentId` field. */
  parentId?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `FacilityGroup` */
export type FacilityGroupInput = {
  /** The facility group’s name. */
  name: Scalars['String'];
  /** The id of the facility group’s parent node. */
  parentId?: InputMaybe<Scalars['BigInt']>;
};

/** Represents an update to a `FacilityGroup`. Fields that are set will be updated. */
export type FacilityGroupPatch = {
  /** The facility group’s name. */
  name?: InputMaybe<Scalars['String']>;
  /** The id of the facility group’s parent node. */
  parentId?: InputMaybe<Scalars['BigInt']>;
};

/** A connection to a list of `FacilityGroup` values. */
export type FacilityGroupsConnection = {
  __typename?: 'FacilityGroupsConnection';
  /** A list of edges which contains the `FacilityGroup` and cursor to aid in pagination. */
  edges: Array<FacilityGroupsEdge>;
  /** A list of `FacilityGroup` objects. */
  nodes: Array<FacilityGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FacilityGroup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `FacilityGroup` edge in the connection. */
export type FacilityGroupsEdge = {
  __typename?: 'FacilityGroupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `FacilityGroup` at the end of the edge. */
  node: FacilityGroup;
};

export type FacilityGroupsLinker = Node & {
  __typename?: 'FacilityGroupsLinker';
  /** Reads a single `Facility` that is related to this `FacilityGroupsLinker`. */
  facility?: Maybe<Facility>;
  /** Reads a single `FacilityGroup` that is related to this `FacilityGroupsLinker`. */
  facilityGrouping?: Maybe<FacilityGroup>;
  facilityGroupingId: Scalars['BigInt'];
  facilityId: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
};

/**
 * A condition to be used against `FacilityGroupsLinker` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type FacilityGroupsLinkerCondition = {
  /** Checks for equality with the object’s `facilityGroupingId` field. */
  facilityGroupingId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `FacilityGroupsLinker` object types. All fields are combined with a logical ‘and.’ */
export type FacilityGroupsLinkerFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FacilityGroupsLinkerFilter>>;
  /** Filter by the object’s `facilityGroupingId` field. */
  facilityGroupingId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FacilityGroupsLinkerFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FacilityGroupsLinkerFilter>>;
};

/** An input for mutations affecting `FacilityGroupsLinker` */
export type FacilityGroupsLinkerInput = {
  /** Mutates a `FacilityGroup` as part of the payload */
  facilityGroup?: InputMaybe<FacilityGroupInput>;
  facilityGroupingId?: InputMaybe<Scalars['BigInt']>;
  facilityId: Scalars['Int'];
};

/** Represents an update to a `FacilityGroupsLinker`. Fields that are set will be updated. */
export type FacilityGroupsLinkerPatch = {
  facilityGroupingId?: InputMaybe<Scalars['BigInt']>;
  facilityId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `FacilityGroupsLinker` values. */
export type FacilityGroupsLinkersConnection = {
  __typename?: 'FacilityGroupsLinkersConnection';
  /** A list of edges which contains the `FacilityGroupsLinker` and cursor to aid in pagination. */
  edges: Array<FacilityGroupsLinkersEdge>;
  /** A list of `FacilityGroupsLinker` objects. */
  nodes: Array<FacilityGroupsLinker>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FacilityGroupsLinker` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `FacilityGroupsLinker` edge in the connection. */
export type FacilityGroupsLinkersEdge = {
  __typename?: 'FacilityGroupsLinkersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `FacilityGroupsLinker` at the end of the edge. */
  node: FacilityGroupsLinker;
};

/** Methods to use when ordering `FacilityGroupsLinker`. */
export enum FacilityGroupsLinkersOrderBy {
  FACILITY_GROUPING_ID_ASC = 'FACILITY_GROUPING_ID_ASC',
  FACILITY_GROUPING_ID_DESC = 'FACILITY_GROUPING_ID_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** Methods to use when ordering `FacilityGroup`. */
export enum FacilityGroupsOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PARENT_ID_ASC = 'PARENT_ID_ASC',
  PARENT_ID_DESC = 'PARENT_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** An input for mutations affecting `Facility` */
export type FacilityInput = {
  /** The facility’s street address. */
  address?: InputMaybe<Scalars['String']>;
  /** Bonus LTR */
  bonusLtr?: InputMaybe<Scalars['Boolean']>;
  /** The facility’s city. */
  city?: InputMaybe<Scalars['String']>;
  /** CONTXT-9249 testing */
  contxt9249?: InputMaybe<Scalars['String']>;
  country: Country;
  /** The time this facility was created. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** DataType2Test */
  dataType2Test?: InputMaybe<Scalars['Float']>;
  /** dataType3Test */
  dataType3Test?: InputMaybe<Scalars['Int']>;
  /** Datatype1Test */
  datatype1Test?: InputMaybe<Scalars['Datetime']>;
  /** User contacts for facility */
  facilityContacts?: InputMaybe<Scalars['String']>;
  geometry?: InputMaybe<Scalars['GeoJSON']>;
  /** The primary unique identifier for the facility. */
  id?: InputMaybe<Scalars['Int']>;
  /** Facility Latitude */
  latitude?: InputMaybe<Scalars['Float']>;
  /** Link Active */
  linkActive?: InputMaybe<Scalars['Boolean']>;
  /** Facility Longitude */
  longitude?: InputMaybe<Scalars['Float']>;
  /** metricsOne Active */
  metricsOneActive?: InputMaybe<Scalars['Boolean']>;
  /** Enabled in nSight. */
  nSight2Active?: InputMaybe<Scalars['Boolean']>;
  /** nSight Active */
  nSightActive?: InputMaybe<Scalars['Boolean']>;
  /** The facility’s name. */
  name: Scalars['String'];
  /** The note of Facility */
  note?: InputMaybe<Scalars['String']>;
  /** Pre-Bonus EBITDA */
  preBonusEbitda?: InputMaybe<Scalars['Boolean']>;
  /** Mutates a `PricingNode` as part of the payload */
  pricingNode?: InputMaybe<PricingNodeInput>;
  /** The id of the pricing node the facility is associated with. */
  pricingNodeId?: InputMaybe<Scalars['Int']>;
  /** Flag to use real-time data or just utility data */
  realTimeEnabled?: InputMaybe<Scalars['Boolean']>;
  /** same desc */
  refrigerationControlSystemVendor?: InputMaybe<Scalars['String']>;
  /** refrigeration control system vendor */
  refrigerationvendor?: InputMaybe<Scalars['String']>;
  /** The time a facility was retired. This allows us to leave the facility enabled for nsight kpis when it was active, while hiding it after the facility was retired (sold / closed) */
  retiredAt?: InputMaybe<Scalars['Datetime']>;
  /** The facility’s slug. */
  slug: Scalars['String'];
  /** The facility’s state. */
  state?: InputMaybe<Scalars['String']>;
  /** Suppresse Financials */
  suppresseFinancials?: InputMaybe<Scalars['Boolean']>;
  /** The name of the timezone for the facility. */
  timezoneName?: InputMaybe<Scalars['String']>;
  /** The unit grouping of the facility. */
  unitGroup?: InputMaybe<Scalars['String']>;
  /** The time this facility was updated. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** The facility’s zip code. */
  zip?: InputMaybe<Scalars['String']>;
};

export type FacilityMaxAggregates = {
  __typename?: 'FacilityMaxAggregates';
  /**
   * Maximum of this field across the matching connection.
   *
   * ---
   *
   * The number of days we have active utility meters for a given serive type and time range.
   */
  activeMeterDatesCount?: Maybe<Scalars['Int']>;
  /** Maximum of dataType2Test across the matching connection */
  dataType2Test?: Maybe<Scalars['Float']>;
  /** Maximum of dataType3Test across the matching connection */
  dataType3Test?: Maybe<Scalars['Int']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']>;
  /** Maximum of latitude across the matching connection */
  latitude?: Maybe<Scalars['Float']>;
  /** Maximum of longitude across the matching connection */
  longitude?: Maybe<Scalars['Float']>;
  /** Maximum of pricingNodeId across the matching connection */
  pricingNodeId?: Maybe<Scalars['Int']>;
};

export type FacilityMaxAggregatesActiveMeterDatesCountArgs = {
  from?: InputMaybe<Scalars['String']>;
  meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  to?: InputMaybe<Scalars['String']>;
};

export type FacilityMinAggregates = {
  __typename?: 'FacilityMinAggregates';
  /**
   * Minimum of this field across the matching connection.
   *
   * ---
   *
   * The number of days we have active utility meters for a given serive type and time range.
   */
  activeMeterDatesCount?: Maybe<Scalars['Int']>;
  /** Minimum of dataType2Test across the matching connection */
  dataType2Test?: Maybe<Scalars['Float']>;
  /** Minimum of dataType3Test across the matching connection */
  dataType3Test?: Maybe<Scalars['Int']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']>;
  /** Minimum of latitude across the matching connection */
  latitude?: Maybe<Scalars['Float']>;
  /** Minimum of longitude across the matching connection */
  longitude?: Maybe<Scalars['Float']>;
  /** Minimum of pricingNodeId across the matching connection */
  pricingNodeId?: Maybe<Scalars['Int']>;
};

export type FacilityMinAggregatesActiveMeterDatesCountArgs = {
  from?: InputMaybe<Scalars['String']>;
  meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  to?: InputMaybe<Scalars['String']>;
};

/** Represents an update to a `Facility`. Fields that are set will be updated. */
export type FacilityPatch = {
  /** The facility’s street address. */
  address?: InputMaybe<Scalars['String']>;
  /** Bonus LTR */
  bonusLtr?: InputMaybe<Scalars['Boolean']>;
  /** The facility’s city. */
  city?: InputMaybe<Scalars['String']>;
  /** CONTXT-9249 testing */
  contxt9249?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Country>;
  /** The time this facility was created. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** DataType2Test */
  dataType2Test?: InputMaybe<Scalars['Float']>;
  /** dataType3Test */
  dataType3Test?: InputMaybe<Scalars['Int']>;
  /** Datatype1Test */
  datatype1Test?: InputMaybe<Scalars['Datetime']>;
  /** User contacts for facility */
  facilityContacts?: InputMaybe<Scalars['String']>;
  geometry?: InputMaybe<Scalars['GeoJSON']>;
  /** The primary unique identifier for the facility. */
  id?: InputMaybe<Scalars['Int']>;
  /** Facility Latitude */
  latitude?: InputMaybe<Scalars['Float']>;
  /** Link Active */
  linkActive?: InputMaybe<Scalars['Boolean']>;
  /** Facility Longitude */
  longitude?: InputMaybe<Scalars['Float']>;
  /** metricsOne Active */
  metricsOneActive?: InputMaybe<Scalars['Boolean']>;
  /** Enabled in nSight. */
  nSight2Active?: InputMaybe<Scalars['Boolean']>;
  /** nSight Active */
  nSightActive?: InputMaybe<Scalars['Boolean']>;
  /** The facility’s name. */
  name?: InputMaybe<Scalars['String']>;
  /** The note of Facility */
  note?: InputMaybe<Scalars['String']>;
  /** Pre-Bonus EBITDA */
  preBonusEbitda?: InputMaybe<Scalars['Boolean']>;
  /** The id of the pricing node the facility is associated with. */
  pricingNodeId?: InputMaybe<Scalars['Int']>;
  /** Flag to use real-time data or just utility data */
  realTimeEnabled?: InputMaybe<Scalars['Boolean']>;
  /** same desc */
  refrigerationControlSystemVendor?: InputMaybe<Scalars['String']>;
  /** refrigeration control system vendor */
  refrigerationvendor?: InputMaybe<Scalars['String']>;
  /** The time a facility was retired. This allows us to leave the facility enabled for nsight kpis when it was active, while hiding it after the facility was retired (sold / closed) */
  retiredAt?: InputMaybe<Scalars['Datetime']>;
  /** The facility’s slug. */
  slug?: InputMaybe<Scalars['String']>;
  /** The facility’s state. */
  state?: InputMaybe<Scalars['String']>;
  /** Suppresse Financials */
  suppresseFinancials?: InputMaybe<Scalars['Boolean']>;
  /** The name of the timezone for the facility. */
  timezoneName?: InputMaybe<Scalars['String']>;
  /** The unit grouping of the facility. */
  unitGroup?: InputMaybe<Scalars['String']>;
  /** The time this facility was updated. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** The facility’s zip code. */
  zip?: InputMaybe<Scalars['String']>;
};

export type FacilityStddevPopulationAggregates = {
  __typename?: 'FacilityStddevPopulationAggregates';
  /**
   * Population standard deviation of this field across the matching connection.
   *
   * ---
   *
   * The number of days we have active utility meters for a given serive type and time range.
   */
  activeMeterDatesCount?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of dataType2Test across the matching connection */
  dataType2Test?: Maybe<Scalars['Float']>;
  /** Population standard deviation of dataType3Test across the matching connection */
  dataType3Test?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of latitude across the matching connection */
  latitude?: Maybe<Scalars['Float']>;
  /** Population standard deviation of longitude across the matching connection */
  longitude?: Maybe<Scalars['Float']>;
  /** Population standard deviation of pricingNodeId across the matching connection */
  pricingNodeId?: Maybe<Scalars['BigFloat']>;
};

export type FacilityStddevPopulationAggregatesActiveMeterDatesCountArgs = {
  from?: InputMaybe<Scalars['String']>;
  meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  to?: InputMaybe<Scalars['String']>;
};

export type FacilityStddevSampleAggregates = {
  __typename?: 'FacilityStddevSampleAggregates';
  /**
   * Sample standard deviation of this field across the matching connection.
   *
   * ---
   *
   * The number of days we have active utility meters for a given serive type and time range.
   */
  activeMeterDatesCount?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of dataType2Test across the matching connection */
  dataType2Test?: Maybe<Scalars['Float']>;
  /** Sample standard deviation of dataType3Test across the matching connection */
  dataType3Test?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of latitude across the matching connection */
  latitude?: Maybe<Scalars['Float']>;
  /** Sample standard deviation of longitude across the matching connection */
  longitude?: Maybe<Scalars['Float']>;
  /** Sample standard deviation of pricingNodeId across the matching connection */
  pricingNodeId?: Maybe<Scalars['BigFloat']>;
};

export type FacilityStddevSampleAggregatesActiveMeterDatesCountArgs = {
  from?: InputMaybe<Scalars['String']>;
  meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  to?: InputMaybe<Scalars['String']>;
};

export type FacilitySumAggregates = {
  __typename?: 'FacilitySumAggregates';
  /**
   * Sum of this field across the matching connection.
   *
   * ---
   *
   * The number of days we have active utility meters for a given serive type and time range.
   */
  activeMeterDatesCount?: Maybe<Scalars['BigInt']>;
  /** Sum of dataType2Test across the matching connection */
  dataType2Test: Scalars['Float'];
  /** Sum of dataType3Test across the matching connection */
  dataType3Test: Scalars['BigInt'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt'];
  /** Sum of latitude across the matching connection */
  latitude: Scalars['Float'];
  /** Sum of longitude across the matching connection */
  longitude: Scalars['Float'];
  /** Sum of pricingNodeId across the matching connection */
  pricingNodeId: Scalars['BigInt'];
};

export type FacilitySumAggregatesActiveMeterDatesCountArgs = {
  from?: InputMaybe<Scalars['String']>;
  meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  to?: InputMaybe<Scalars['String']>;
};

/** Tags for specific data points at a facility */
export type FacilityTaggedDataPoint = Node & {
  __typename?: 'FacilityTaggedDataPoint';
  createdAt: Scalars['Datetime'];
  /** Reads a single `DataPoint` that is related to this `FacilityTaggedDataPoint`. */
  dataPoint?: Maybe<DataPoint>;
  dataPointId: Scalars['BigInt'];
  /** Reads a single `Facility` that is related to this `FacilityTaggedDataPoint`. */
  facility?: Maybe<Facility>;
  facilityId: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `DataPointTag` that is related to this `FacilityTaggedDataPoint`. */
  tag?: Maybe<DataPointTag>;
  tagId: Scalars['Int'];
  tagName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `FacilityTaggedDataPoint` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type FacilityTaggedDataPointCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `dataPointId` field. */
  dataPointId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `tagId` field. */
  tagId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `tagName` field. */
  tagName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `FacilityTaggedDataPoint` object types. All fields are combined with a logical ‘and.’ */
export type FacilityTaggedDataPointFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FacilityTaggedDataPointFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dataPointId` field. */
  dataPointId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FacilityTaggedDataPointFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FacilityTaggedDataPointFilter>>;
  /** Filter by the object’s `tagId` field. */
  tagId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tagName` field. */
  tagName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `FacilityTaggedDataPoint` */
export type FacilityTaggedDataPointInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Mutates a `DataPoint` as part of the payload */
  dataPoint?: InputMaybe<DataPointInput>;
  dataPointId?: InputMaybe<Scalars['BigInt']>;
  /** Mutates a `DataPointTag` as part of the payload */
  dataPointTag?: InputMaybe<DataPointTagInput>;
  facilityId: Scalars['Int'];
  name: Scalars['String'];
  tagId?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `FacilityTaggedDataPoint`. Fields that are set will be updated. */
export type FacilityTaggedDataPointPatch = {
  dataPointId?: InputMaybe<Scalars['BigInt']>;
  facilityId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  tagId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `FacilityTaggedDataPoint` values. */
export type FacilityTaggedDataPointsConnection = {
  __typename?: 'FacilityTaggedDataPointsConnection';
  /** Returns the aggregate data timeseries data for the FacilityTaggedDataPointsConnection  */
  data?: Maybe<MetricDataConnection>;
  /** A list of edges which contains the `FacilityTaggedDataPoint` and cursor to aid in pagination. */
  edges: Array<FacilityTaggedDataPointsEdge>;
  /** A list of `FacilityTaggedDataPoint` objects. */
  nodes: Array<FacilityTaggedDataPoint>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FacilityTaggedDataPoint` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A connection to a list of `FacilityTaggedDataPoint` values. */
export type FacilityTaggedDataPointsConnectionDataArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A `FacilityTaggedDataPoint` edge in the connection. */
export type FacilityTaggedDataPointsEdge = {
  __typename?: 'FacilityTaggedDataPointsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `FacilityTaggedDataPoint` at the end of the edge. */
  node: FacilityTaggedDataPoint;
};

/** Methods to use when ordering `FacilityTaggedDataPoint`. */
export enum FacilityTaggedDataPointsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DATA_POINT_ID_ASC = 'DATA_POINT_ID_ASC',
  DATA_POINT_ID_DESC = 'DATA_POINT_ID_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  TAG_ID_ASC = 'TAG_ID_ASC',
  TAG_ID_DESC = 'TAG_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

export type FacilityVariancePopulationAggregates = {
  __typename?: 'FacilityVariancePopulationAggregates';
  /**
   * Population variance of this field across the matching connection.
   *
   * ---
   *
   * The number of days we have active utility meters for a given serive type and time range.
   */
  activeMeterDatesCount?: Maybe<Scalars['BigFloat']>;
  /** Population variance of dataType2Test across the matching connection */
  dataType2Test?: Maybe<Scalars['Float']>;
  /** Population variance of dataType3Test across the matching connection */
  dataType3Test?: Maybe<Scalars['BigFloat']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']>;
  /** Population variance of latitude across the matching connection */
  latitude?: Maybe<Scalars['Float']>;
  /** Population variance of longitude across the matching connection */
  longitude?: Maybe<Scalars['Float']>;
  /** Population variance of pricingNodeId across the matching connection */
  pricingNodeId?: Maybe<Scalars['BigFloat']>;
};

export type FacilityVariancePopulationAggregatesActiveMeterDatesCountArgs = {
  from?: InputMaybe<Scalars['String']>;
  meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  to?: InputMaybe<Scalars['String']>;
};

export type FacilityVarianceSampleAggregates = {
  __typename?: 'FacilityVarianceSampleAggregates';
  /**
   * Sample variance of this field across the matching connection.
   *
   * ---
   *
   * The number of days we have active utility meters for a given serive type and time range.
   */
  activeMeterDatesCount?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of dataType2Test across the matching connection */
  dataType2Test?: Maybe<Scalars['Float']>;
  /** Sample variance of dataType3Test across the matching connection */
  dataType3Test?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of latitude across the matching connection */
  latitude?: Maybe<Scalars['Float']>;
  /** Sample variance of longitude across the matching connection */
  longitude?: Maybe<Scalars['Float']>;
  /** Sample variance of pricingNodeId across the matching connection */
  pricingNodeId?: Maybe<Scalars['BigFloat']>;
};

export type FacilityVarianceSampleAggregatesActiveMeterDatesCountArgs = {
  from?: InputMaybe<Scalars['String']>;
  meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  to?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against Float fields. All fields are combined with a logical ‘and.’ */
export type FloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Float']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Float']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Float']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Float']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Float']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Float']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Float']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Float']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Float']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

/** All geometry XY types implement this interface */
export type GeometryGeometry = {
  /** Converts the object to GeoJSON */
  geojson?: Maybe<Scalars['GeoJSON']>;
  /** Spatial reference identifier (SRID) */
  srid: Scalars['Int'];
};

export type GeometryGeometryCollection = GeometryGeometry &
  GeometryInterface & {
    __typename?: 'GeometryGeometryCollection';
    geojson?: Maybe<Scalars['GeoJSON']>;
    geometries?: Maybe<Array<Maybe<GeometryGeometry>>>;
    srid: Scalars['Int'];
  };

export type GeometryGeometryCollectionM = GeometryGeometryM &
  GeometryInterface & {
    __typename?: 'GeometryGeometryCollectionM';
    geojson?: Maybe<Scalars['GeoJSON']>;
    geometries?: Maybe<Array<Maybe<GeometryGeometryM>>>;
    srid: Scalars['Int'];
  };

export type GeometryGeometryCollectionZ = GeometryGeometryZ &
  GeometryInterface & {
    __typename?: 'GeometryGeometryCollectionZ';
    geojson?: Maybe<Scalars['GeoJSON']>;
    geometries?: Maybe<Array<Maybe<GeometryGeometryZ>>>;
    srid: Scalars['Int'];
  };

export type GeometryGeometryCollectionZm = GeometryGeometryZm &
  GeometryInterface & {
    __typename?: 'GeometryGeometryCollectionZM';
    geojson?: Maybe<Scalars['GeoJSON']>;
    geometries?: Maybe<Array<Maybe<GeometryGeometryZm>>>;
    srid: Scalars['Int'];
  };

/** All geometry XYM types implement this interface */
export type GeometryGeometryM = {
  /** Converts the object to GeoJSON */
  geojson?: Maybe<Scalars['GeoJSON']>;
  /** Spatial reference identifier (SRID) */
  srid: Scalars['Int'];
};

/** All geometry XYZ types implement this interface */
export type GeometryGeometryZ = {
  /** Converts the object to GeoJSON */
  geojson?: Maybe<Scalars['GeoJSON']>;
  /** Spatial reference identifier (SRID) */
  srid: Scalars['Int'];
};

/** All geometry XYZM types implement this interface */
export type GeometryGeometryZm = {
  /** Converts the object to GeoJSON */
  geojson?: Maybe<Scalars['GeoJSON']>;
  /** Spatial reference identifier (SRID) */
  srid: Scalars['Int'];
};

/** All geometry types implement this interface */
export type GeometryInterface = {
  /** Converts the object to GeoJSON */
  geojson?: Maybe<Scalars['GeoJSON']>;
  /** Spatial reference identifier (SRID) */
  srid: Scalars['Int'];
};

export type GeometryLineString = GeometryGeometry &
  GeometryInterface & {
    __typename?: 'GeometryLineString';
    geojson?: Maybe<Scalars['GeoJSON']>;
    points?: Maybe<Array<Maybe<GeometryPoint>>>;
    srid: Scalars['Int'];
  };

export type GeometryLineStringM = GeometryGeometryM &
  GeometryInterface & {
    __typename?: 'GeometryLineStringM';
    geojson?: Maybe<Scalars['GeoJSON']>;
    points?: Maybe<Array<Maybe<GeometryPointM>>>;
    srid: Scalars['Int'];
  };

export type GeometryLineStringZ = GeometryGeometryZ &
  GeometryInterface & {
    __typename?: 'GeometryLineStringZ';
    geojson?: Maybe<Scalars['GeoJSON']>;
    points?: Maybe<Array<Maybe<GeometryPointZ>>>;
    srid: Scalars['Int'];
  };

export type GeometryLineStringZm = GeometryGeometryZm &
  GeometryInterface & {
    __typename?: 'GeometryLineStringZM';
    geojson?: Maybe<Scalars['GeoJSON']>;
    points?: Maybe<Array<Maybe<GeometryPointZm>>>;
    srid: Scalars['Int'];
  };

export type GeometryMultiLineString = GeometryGeometry &
  GeometryInterface & {
    __typename?: 'GeometryMultiLineString';
    geojson?: Maybe<Scalars['GeoJSON']>;
    lines?: Maybe<Array<Maybe<GeometryLineString>>>;
    srid: Scalars['Int'];
  };

export type GeometryMultiLineStringM = GeometryGeometryM &
  GeometryInterface & {
    __typename?: 'GeometryMultiLineStringM';
    geojson?: Maybe<Scalars['GeoJSON']>;
    lines?: Maybe<Array<Maybe<GeometryLineStringM>>>;
    srid: Scalars['Int'];
  };

export type GeometryMultiLineStringZ = GeometryGeometryZ &
  GeometryInterface & {
    __typename?: 'GeometryMultiLineStringZ';
    geojson?: Maybe<Scalars['GeoJSON']>;
    lines?: Maybe<Array<Maybe<GeometryLineStringZ>>>;
    srid: Scalars['Int'];
  };

export type GeometryMultiLineStringZm = GeometryGeometryZm &
  GeometryInterface & {
    __typename?: 'GeometryMultiLineStringZM';
    geojson?: Maybe<Scalars['GeoJSON']>;
    lines?: Maybe<Array<Maybe<GeometryLineStringZm>>>;
    srid: Scalars['Int'];
  };

export type GeometryMultiPoint = GeometryGeometry &
  GeometryInterface & {
    __typename?: 'GeometryMultiPoint';
    geojson?: Maybe<Scalars['GeoJSON']>;
    points?: Maybe<Array<Maybe<GeometryPoint>>>;
    srid: Scalars['Int'];
  };

export type GeometryMultiPointM = GeometryGeometryM &
  GeometryInterface & {
    __typename?: 'GeometryMultiPointM';
    geojson?: Maybe<Scalars['GeoJSON']>;
    points?: Maybe<Array<Maybe<GeometryPointM>>>;
    srid: Scalars['Int'];
  };

export type GeometryMultiPointZ = GeometryGeometryZ &
  GeometryInterface & {
    __typename?: 'GeometryMultiPointZ';
    geojson?: Maybe<Scalars['GeoJSON']>;
    points?: Maybe<Array<Maybe<GeometryPointZ>>>;
    srid: Scalars['Int'];
  };

export type GeometryMultiPointZm = GeometryGeometryZm &
  GeometryInterface & {
    __typename?: 'GeometryMultiPointZM';
    geojson?: Maybe<Scalars['GeoJSON']>;
    points?: Maybe<Array<Maybe<GeometryPointZm>>>;
    srid: Scalars['Int'];
  };

export type GeometryMultiPolygon = GeometryGeometry &
  GeometryInterface & {
    __typename?: 'GeometryMultiPolygon';
    geojson?: Maybe<Scalars['GeoJSON']>;
    polygons?: Maybe<Array<Maybe<GeometryPolygon>>>;
    srid: Scalars['Int'];
  };

export type GeometryMultiPolygonM = GeometryGeometryM &
  GeometryInterface & {
    __typename?: 'GeometryMultiPolygonM';
    geojson?: Maybe<Scalars['GeoJSON']>;
    polygons?: Maybe<Array<Maybe<GeometryPolygonM>>>;
    srid: Scalars['Int'];
  };

export type GeometryMultiPolygonZ = GeometryGeometryZ &
  GeometryInterface & {
    __typename?: 'GeometryMultiPolygonZ';
    geojson?: Maybe<Scalars['GeoJSON']>;
    polygons?: Maybe<Array<Maybe<GeometryPolygonZ>>>;
    srid: Scalars['Int'];
  };

export type GeometryMultiPolygonZm = GeometryGeometryZm &
  GeometryInterface & {
    __typename?: 'GeometryMultiPolygonZM';
    geojson?: Maybe<Scalars['GeoJSON']>;
    polygons?: Maybe<Array<Maybe<GeometryPolygonZm>>>;
    srid: Scalars['Int'];
  };

export type GeometryPoint = GeometryGeometry &
  GeometryInterface & {
    __typename?: 'GeometryPoint';
    geojson?: Maybe<Scalars['GeoJSON']>;
    srid: Scalars['Int'];
    x: Scalars['Float'];
    y: Scalars['Float'];
  };

export type GeometryPointM = GeometryGeometryM &
  GeometryInterface & {
    __typename?: 'GeometryPointM';
    geojson?: Maybe<Scalars['GeoJSON']>;
    srid: Scalars['Int'];
    x: Scalars['Float'];
    y: Scalars['Float'];
  };

export type GeometryPointZ = GeometryGeometryZ &
  GeometryInterface & {
    __typename?: 'GeometryPointZ';
    geojson?: Maybe<Scalars['GeoJSON']>;
    srid: Scalars['Int'];
    x: Scalars['Float'];
    y: Scalars['Float'];
    z: Scalars['Float'];
  };

export type GeometryPointZm = GeometryGeometryZm &
  GeometryInterface & {
    __typename?: 'GeometryPointZM';
    geojson?: Maybe<Scalars['GeoJSON']>;
    srid: Scalars['Int'];
    x: Scalars['Float'];
    y: Scalars['Float'];
    z: Scalars['Float'];
  };

export type GeometryPolygon = GeometryGeometry &
  GeometryInterface & {
    __typename?: 'GeometryPolygon';
    exterior?: Maybe<GeometryLineString>;
    geojson?: Maybe<Scalars['GeoJSON']>;
    interiors?: Maybe<Array<Maybe<GeometryLineString>>>;
    srid: Scalars['Int'];
  };

export type GeometryPolygonM = GeometryGeometryM &
  GeometryInterface & {
    __typename?: 'GeometryPolygonM';
    exterior?: Maybe<GeometryLineStringM>;
    geojson?: Maybe<Scalars['GeoJSON']>;
    interiors?: Maybe<Array<Maybe<GeometryLineStringM>>>;
    srid: Scalars['Int'];
  };

export type GeometryPolygonZ = GeometryGeometryZ &
  GeometryInterface & {
    __typename?: 'GeometryPolygonZ';
    exterior?: Maybe<GeometryLineStringZ>;
    geojson?: Maybe<Scalars['GeoJSON']>;
    interiors?: Maybe<Array<Maybe<GeometryLineStringZ>>>;
    srid: Scalars['Int'];
  };

export type GeometryPolygonZm = GeometryGeometryZm &
  GeometryInterface & {
    __typename?: 'GeometryPolygonZM';
    exterior?: Maybe<GeometryLineStringZm>;
    geojson?: Maybe<Scalars['GeoJSON']>;
    interiors?: Maybe<Array<Maybe<GeometryLineStringZm>>>;
    srid: Scalars['Int'];
  };

/** A `JSON` edge in the connection. */
export type GroupingEdge = {
  __typename?: 'GroupingEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `JSON` at the end of the edge. */
  node?: Maybe<Scalars['JSON']>;
};

/** A connection to a list of `JSON` values. */
export type GroupingsConnection = {
  __typename?: 'GroupingsConnection';
  /** A list of edges which contains the `JSON` and cursor to aid in pagination. */
  edges: Array<GroupingEdge>;
  /** A list of `JSON` objects. */
  nodes: Array<Maybe<Scalars['JSON']>>;
  /** The count of *all* `JSON` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A connection to a list of `JSON` values. */
export type GroupingsWithFacilitiesConnection = {
  __typename?: 'GroupingsWithFacilitiesConnection';
  /** A list of edges which contains the `JSON` and cursor to aid in pagination. */
  edges: Array<GroupingsWithFacilityEdge>;
  /** A list of `JSON` objects. */
  nodes: Array<Maybe<Scalars['JSON']>>;
  /** The count of *all* `JSON` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `JSON` edge in the connection. */
export type GroupingsWithFacilityEdge = {
  __typename?: 'GroupingsWithFacilityEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `JSON` at the end of the edge. */
  node?: Maybe<Scalars['JSON']>;
};

export type HavingDatetimeFilter = {
  equalTo?: InputMaybe<Scalars['Datetime']>;
  greaterThan?: InputMaybe<Scalars['Datetime']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']>;
  lessThan?: InputMaybe<Scalars['Datetime']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']>;
  notEqualTo?: InputMaybe<Scalars['Datetime']>;
};

export type HavingFloatFilter = {
  equalTo?: InputMaybe<Scalars['Float']>;
  greaterThan?: InputMaybe<Scalars['Float']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['Float']>;
  lessThan?: InputMaybe<Scalars['Float']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['Float']>;
  notEqualTo?: InputMaybe<Scalars['Float']>;
};

export type HavingIntFilter = {
  equalTo?: InputMaybe<Scalars['Int']>;
  greaterThan?: InputMaybe<Scalars['Int']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']>;
  lessThan?: InputMaybe<Scalars['Int']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']>;
  notEqualTo?: InputMaybe<Scalars['Int']>;
};

export type Identity = {
  authorizationType: Scalars['String'];
  id: Scalars['String'];
  type: AccessTokenType;
};

/** An inbound or outbound load */
export type InboundOutboundLoad = Node & {
  __typename?: 'InboundOutboundLoad';
  /** The time when the order occurred */
  appointmentTime?: Maybe<Scalars['Datetime']>;
  /** The unique reference number for the load */
  confirmationId?: Maybe<Scalars['String']>;
  /** The time at which the record was created */
  createdAt: Scalars['Datetime'];
  /** The globally unique external deletion identifier of the record. Sometimes this is different from sourceId due to change tracking semantics */
  deleteId?: Maybe<Scalars['String']>;
  /** The time at which the record was deleted */
  deletedAt?: Maybe<Scalars['Datetime']>;
  /** The direction of load */
  direction: WmsLoadDirectionType;
  /** Reads a single `Facility` that is related to this `InboundOutboundLoad`. */
  facility?: Maybe<Facility>;
  /** The facility where the order occurred */
  facilityId?: Maybe<Scalars['Int']>;
  id: Scalars['BigInt'];
  /** The type of load */
  loadType?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String'];
  /** The time at which the record was updated */
  updatedAt: Scalars['Datetime'];
  /** The version of the record */
  version?: Maybe<Scalars['BigInt']>;
};

/**
 * A condition to be used against `InboundOutboundLoad` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type InboundOutboundLoadCondition = {
  /** Checks for equality with the object’s `appointmentTime` field. */
  appointmentTime?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `confirmationId` field. */
  confirmationId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deleteId` field. */
  deleteId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `direction` field. */
  direction?: InputMaybe<WmsLoadDirectionType>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `loadType` field. */
  loadType?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `sourceId` field. */
  sourceId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `version` field. */
  version?: InputMaybe<Scalars['BigInt']>;
};

/** A filter to be used against `InboundOutboundLoad` object types. All fields are combined with a logical ‘and.’ */
export type InboundOutboundLoadFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<InboundOutboundLoadFilter>>;
  /** Filter by the object’s `appointmentTime` field. */
  appointmentTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `confirmationId` field. */
  confirmationId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deleteId` field. */
  deleteId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `direction` field. */
  direction?: InputMaybe<WmsLoadDirectionTypeFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `loadType` field. */
  loadType?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<InboundOutboundLoadFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<InboundOutboundLoadFilter>>;
  /** Filter by the object’s `sourceId` field. */
  sourceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `version` field. */
  version?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `InboundOutboundLoad` */
export type InboundOutboundLoadInput = {
  /** The time when the order occurred */
  appointmentTime?: InputMaybe<Scalars['Datetime']>;
  /** The unique reference number for the load */
  confirmationId?: InputMaybe<Scalars['String']>;
  /** The direction of load */
  direction: WmsLoadDirectionType;
  /** The facility where the order occurred */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** The type of load */
  loadType?: InputMaybe<Scalars['String']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String'];
};

/** Represents an update to a `InboundOutboundLoad`. Fields that are set will be updated. */
export type InboundOutboundLoadPatch = {
  /** The time when the order occurred */
  appointmentTime?: InputMaybe<Scalars['Datetime']>;
  /** The unique reference number for the load */
  confirmationId?: InputMaybe<Scalars['String']>;
  /** The direction of load */
  direction?: InputMaybe<WmsLoadDirectionType>;
  /** The facility where the order occurred */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** The type of load */
  loadType?: InputMaybe<Scalars['String']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `InboundOutboundLoad` values. */
export type InboundOutboundLoadsConnection = {
  __typename?: 'InboundOutboundLoadsConnection';
  /** A list of edges which contains the `InboundOutboundLoad` and cursor to aid in pagination. */
  edges: Array<InboundOutboundLoadsEdge>;
  /** A list of `InboundOutboundLoad` objects. */
  nodes: Array<InboundOutboundLoad>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InboundOutboundLoad` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `InboundOutboundLoad` edge in the connection. */
export type InboundOutboundLoadsEdge = {
  __typename?: 'InboundOutboundLoadsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `InboundOutboundLoad` at the end of the edge. */
  node: InboundOutboundLoad;
};

/** Methods to use when ordering `InboundOutboundLoad`. */
export enum InboundOutboundLoadsOrderBy {
  APPOINTMENT_TIME_ASC = 'APPOINTMENT_TIME_ASC',
  APPOINTMENT_TIME_DESC = 'APPOINTMENT_TIME_DESC',
  CONFIRMATION_ID_ASC = 'CONFIRMATION_ID_ASC',
  CONFIRMATION_ID_DESC = 'CONFIRMATION_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DELETED_AT_ASC = 'DELETED_AT_ASC',
  DELETED_AT_DESC = 'DELETED_AT_DESC',
  DELETE_ID_ASC = 'DELETE_ID_ASC',
  DELETE_ID_DESC = 'DELETE_ID_DESC',
  DIRECTION_ASC = 'DIRECTION_ASC',
  DIRECTION_DESC = 'DIRECTION_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LOAD_TYPE_ASC = 'LOAD_TYPE_ASC',
  LOAD_TYPE_DESC = 'LOAD_TYPE_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SOURCE_ID_ASC = 'SOURCE_ID_ASC',
  SOURCE_ID_DESC = 'SOURCE_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VERSION_ASC = 'VERSION_ASC',
  VERSION_DESC = 'VERSION_DESC'
}

export type InputFacilityMetricData = {
  data: Scalars['JSON'];
  facilityId: Scalars['Int'];
  label: Scalars['String'];
  metadata?: InputMaybe<Scalars['JSON']>;
  time: Scalars['Datetime'];
};

export type InputMetricData = {
  data: Scalars['JSON'];
  label: Scalars['String'];
  metadata?: InputMaybe<Scalars['JSON']>;
  sourceId: Scalars['String'];
  time: Scalars['Datetime'];
};

/** A filter to be used against Int fields. All fields are combined with a logical ‘and.’ */
export type IntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Int']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Int']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Int']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Int']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Int']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Int']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Int']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

/** An interval of time that has passed where the smallest distinct unit is a second. */
export type Interval = {
  __typename?: 'Interval';
  /** A quantity of days. */
  days?: Maybe<Scalars['Int']>;
  /** A quantity of hours. */
  hours?: Maybe<Scalars['Int']>;
  /** A quantity of minutes. */
  minutes?: Maybe<Scalars['Int']>;
  /** A quantity of months. */
  months?: Maybe<Scalars['Int']>;
  /**
   * A quantity of seconds. This is the only non-integer field, as all the other
   * fields will dump their overflow into a smaller unit of time. Intervals don’t
   * have a smaller unit than seconds.
   */
  seconds?: Maybe<Scalars['Float']>;
  /** A quantity of years. */
  years?: Maybe<Scalars['Int']>;
};

/** A filter to be used against Interval fields. All fields are combined with a logical ‘and.’ */
export type IntervalFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<IntervalInput>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<IntervalInput>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<IntervalInput>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<IntervalInput>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<IntervalInput>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<IntervalInput>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<IntervalInput>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<IntervalInput>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<IntervalInput>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<IntervalInput>>;
};

/** An interval of time that has passed where the smallest distinct unit is a second. */
export type IntervalInput = {
  /** A quantity of days. */
  days?: InputMaybe<Scalars['Int']>;
  /** A quantity of hours. */
  hours?: InputMaybe<Scalars['Int']>;
  /** A quantity of minutes. */
  minutes?: InputMaybe<Scalars['Int']>;
  /** A quantity of months. */
  months?: InputMaybe<Scalars['Int']>;
  /**
   * A quantity of seconds. This is the only non-integer field, as all the other
   * fields will dump their overflow into a smaller unit of time. Intervals don’t
   * have a smaller unit than seconds.
   */
  seconds?: InputMaybe<Scalars['Float']>;
  /** A quantity of years. */
  years?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against JSON fields. All fields are combined with a logical ‘and.’ */
export type JsonFilter = {
  /** Contained by the specified JSON. */
  containedBy?: InputMaybe<Scalars['JSON']>;
  /** Contains the specified JSON. */
  contains?: InputMaybe<Scalars['JSON']>;
  /** Contains all of the specified keys. */
  containsAllKeys?: InputMaybe<Array<Scalars['String']>>;
  /** Contains any of the specified keys. */
  containsAnyKeys?: InputMaybe<Array<Scalars['String']>>;
  /** Contains the specified key. */
  containsKey?: InputMaybe<Scalars['String']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['JSON']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['JSON']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['JSON']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['JSON']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['JSON']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['JSON']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['JSON']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['JSON']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['JSON']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['JSON']>>;
};

/** A filter to be used against JSON List fields. All fields are combined with a logical ‘and.’ */
export type JsonListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Scalars['JSON']>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<Scalars['JSON']>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars['JSON']>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<Scalars['JSON']>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<Scalars['JSON']>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Scalars['JSON']>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type MachineIdentity = Identity & {
  __typename?: 'MachineIdentity';
  authorizationType: Scalars['String'];
  id: Scalars['String'];
  machineUser: MachineUser;
  type: AccessTokenType;
};

/** Machine accounts that have their own set of access/permissions. */
export type MachineUser = Node & {
  __typename?: 'MachineUser';
  /** Returns the machine user`s access tokens. */
  accessTokens: PlatformAccessTokensConnection;
  capabilities: Array<PlatformCapabilityAccess>;
  /** Reads and enables pagination through a set of `Component`. */
  components: ComponentsConnection;
  /** The date the machine user was created at. */
  createdAt: Scalars['Datetime'];
  createdBy: Scalars['String'];
  creator?: Maybe<User>;
  description: Scalars['String'];
  /** The identifier of the machine user. */
  id: Scalars['BigInt'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Available permissions for the MachineUser. */
  permissions?: Maybe<MachineUserPermissions>;
  /** The date the machine user was updated at. */
  updatedAt: Scalars['Datetime'];
  vendorUser?: Maybe<VendorUser>;
  /** Reads and enables pagination through a set of `VendorUser`. */
  vendorUsers: VendorUsersConnection;
};

/** Machine accounts that have their own set of access/permissions. */
export type MachineUserAccessTokensArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<PlatformAccessTokenFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** Machine accounts that have their own set of access/permissions. */
export type MachineUserCapabilitiesArgs = {
  canRead?: InputMaybe<Scalars['Boolean']>;
  canWrite?: InputMaybe<Scalars['Boolean']>;
};

/** Machine accounts that have their own set of access/permissions. */
export type MachineUserComponentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ComponentCondition>;
  filter?: InputMaybe<ComponentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ComponentsOrderBy>>;
};

/** Machine accounts that have their own set of access/permissions. */
export type MachineUserVendorUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<VendorUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/**
 * A condition to be used against `MachineUser` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type MachineUserCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `MachineUser` object types. All fields are combined with a logical ‘and.’ */
export type MachineUserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MachineUserFilter>>;
  /** Filter by the permission can_write */
  canWrite?: InputMaybe<PermissionBooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MachineUserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MachineUserFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `MachineUser` */
export type MachineUserInput = {
  /** The date the machine user was created at. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  /** The date the machine user was updated at. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `MachineUser`. Fields that are set will be updated. */
export type MachineUserPatch = {
  /** The date the machine user was created at. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  /** The date the machine user was updated at. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Permissive capabilities on a MachineUser. */
export type MachineUserPermissions = {
  __typename?: 'MachineUserPermissions';
  /** Whether a user can edit a machine user */
  canWrite: Scalars['Boolean'];
};

/** A connection to a list of `MachineUser` values. */
export type MachineUsersConnection = {
  __typename?: 'MachineUsersConnection';
  /** A list of edges which contains the `MachineUser` and cursor to aid in pagination. */
  edges: Array<MachineUsersEdge>;
  /** A list of `MachineUser` objects. */
  nodes: Array<MachineUser>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MachineUser` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `MachineUser` edge in the connection. */
export type MachineUsersEdge = {
  __typename?: 'MachineUsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MachineUser` at the end of the edge. */
  node: MachineUser;
};

/** Methods to use when ordering `MachineUser`. */
export enum MachineUsersOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CREATED_BY_ASC = 'CREATED_BY_ASC',
  CREATED_BY_DESC = 'CREATED_BY_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** This represents one or more main meters at a facility */
export type MainService = Node & {
  __typename?: 'MainService';
  /** The time at which the main service was created */
  createdAt: Scalars['Datetime'];
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  demand?: Maybe<DataPoint>;
  /** The demand data point that represents this main service's contribution to/from the facility */
  demandDataPointId?: Maybe<Scalars['Int']>;
  /** Used to indicate whether this main service contributes to carbon reporting based on its location in the facility. */
  excludeCarbon?: Maybe<Scalars['Boolean']>;
  /** Reads a single `Facility` that is related to this `MainService`. */
  facility?: Maybe<Facility>;
  /** The facility this main service belongs to */
  facilityId: Scalars['Int'];
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  gridDemand?: Maybe<DataPoint>;
  /** The demand data point that represents this main service's contribution to/from the grid */
  gridDemandDataPointId?: Maybe<Scalars['Int']>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  gridUsage?: Maybe<DataPoint>;
  /** The usage data point that represents this main service's contribution to/from the grid */
  gridUsageDataPointId?: Maybe<Scalars['Int']>;
  /** The id of the main service */
  id: Scalars['Int'];
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  meterDemand?: Maybe<DataPoint>;
  /** The original meter demand datapoint for this main service */
  meterDemandDataPointId?: Maybe<Scalars['Int']>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  meterUsage?: Maybe<DataPoint>;
  /** The original meter usage datapoint for this main service */
  meterUsageDataPointId?: Maybe<Scalars['Int']>;
  /** The name for this main service */
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The specific type of this main service */
  type: MainServicesType;
  /** The time at which the main service was last updated */
  updatedAt: Scalars['Datetime'];
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  usage?: Maybe<DataPoint>;
  /** The usage data point that represents this main service's contribution to/from the facility */
  usageDataPointId?: Maybe<Scalars['Int']>;
};

/**
 * A condition to be used against `MainService` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type MainServiceCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `demandDataPointId` field. */
  demandDataPointId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `excludeCarbon` field. */
  excludeCarbon?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `gridDemandDataPointId` field. */
  gridDemandDataPointId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `gridUsageDataPointId` field. */
  gridUsageDataPointId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `meterDemandDataPointId` field. */
  meterDemandDataPointId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `meterUsageDataPointId` field. */
  meterUsageDataPointId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<MainServicesType>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `usageDataPointId` field. */
  usageDataPointId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `MainService` object types. All fields are combined with a logical ‘and.’ */
export type MainServiceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MainServiceFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `demandDataPointId` field. */
  demandDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `excludeCarbon` field. */
  excludeCarbon?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `gridDemandDataPointId` field. */
  gridDemandDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `gridUsageDataPointId` field. */
  gridUsageDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `meterDemandDataPointId` field. */
  meterDemandDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `meterUsageDataPointId` field. */
  meterUsageDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MainServiceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MainServiceFilter>>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<MainServicesTypeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `usageDataPointId` field. */
  usageDataPointId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `MainService` */
export type MainServiceInput = {
  /** Mutates a `DataPoint` as part of the payload */
  dataPoint?: InputMaybe<DataPointInput>;
  /** The demand data point that represents this main service's contribution to/from the facility */
  demandDataPointId?: InputMaybe<Scalars['Int']>;
  /** Used to indicate whether this main service contributes to carbon reporting based on its location in the facility. */
  excludeCarbon?: InputMaybe<Scalars['Boolean']>;
  /** The facility this main service belongs to */
  facilityId: Scalars['Int'];
  /** The demand data point that represents this main service's contribution to/from the grid */
  gridDemandDataPointId?: InputMaybe<Scalars['Int']>;
  /** The usage data point that represents this main service's contribution to/from the grid */
  gridUsageDataPointId?: InputMaybe<Scalars['Int']>;
  /** The original meter demand datapoint for this main service */
  meterDemandDataPointId?: InputMaybe<Scalars['Int']>;
  /** The original meter usage datapoint for this main service */
  meterUsageDataPointId?: InputMaybe<Scalars['Int']>;
  /** The name for this main service */
  name: Scalars['String'];
  /** The specific type of this main service */
  type: MainServicesType;
  /** The usage data point that represents this main service's contribution to/from the facility */
  usageDataPointId?: InputMaybe<Scalars['Int']>;
};

/** Represents an update to a `MainService`. Fields that are set will be updated. */
export type MainServicePatch = {
  /** The demand data point that represents this main service's contribution to/from the facility */
  demandDataPointId?: InputMaybe<Scalars['Int']>;
  /** Used to indicate whether this main service contributes to carbon reporting based on its location in the facility. */
  excludeCarbon?: InputMaybe<Scalars['Boolean']>;
  /** The facility this main service belongs to */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** The demand data point that represents this main service's contribution to/from the grid */
  gridDemandDataPointId?: InputMaybe<Scalars['Int']>;
  /** The usage data point that represents this main service's contribution to/from the grid */
  gridUsageDataPointId?: InputMaybe<Scalars['Int']>;
  /** The original meter demand datapoint for this main service */
  meterDemandDataPointId?: InputMaybe<Scalars['Int']>;
  /** The original meter usage datapoint for this main service */
  meterUsageDataPointId?: InputMaybe<Scalars['Int']>;
  /** The name for this main service */
  name?: InputMaybe<Scalars['String']>;
  /** The specific type of this main service */
  type?: InputMaybe<MainServicesType>;
  /** The usage data point that represents this main service's contribution to/from the facility */
  usageDataPointId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `MainService` values. */
export type MainServicesConnection = {
  __typename?: 'MainServicesConnection';
  /** Returns the aggregate demand timeseries data for the MainServicesConnection  */
  demand?: Maybe<MetricDataConnection>;
  /** A list of edges which contains the `MainService` and cursor to aid in pagination. */
  edges: Array<MainServicesEdge>;
  /** Returns the aggregate gridDemand timeseries data for the MainServicesConnection  */
  gridDemand?: Maybe<MetricDataConnection>;
  /** Returns the aggregate gridUsage timeseries data for the MainServicesConnection  */
  gridUsage?: Maybe<MetricDataConnection>;
  /** Returns the aggregate meterDemand timeseries data for the MainServicesConnection  */
  meterDemand?: Maybe<MetricDataConnection>;
  /** Returns the aggregate meterUsage timeseries data for the MainServicesConnection  */
  meterUsage?: Maybe<MetricDataConnection>;
  /** A list of `MainService` objects. */
  nodes: Array<MainService>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MainService` you could get from the connection. */
  totalCount: Scalars['Int'];
  /** Returns the aggregate usage timeseries data for the MainServicesConnection  */
  usage?: Maybe<MetricDataConnection>;
};

/** A connection to a list of `MainService` values. */
export type MainServicesConnectionDemandArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `MainService` values. */
export type MainServicesConnectionGridDemandArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `MainService` values. */
export type MainServicesConnectionGridUsageArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `MainService` values. */
export type MainServicesConnectionMeterDemandArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `MainService` values. */
export type MainServicesConnectionMeterUsageArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `MainService` values. */
export type MainServicesConnectionUsageArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A `MainService` edge in the connection. */
export type MainServicesEdge = {
  __typename?: 'MainServicesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MainService` at the end of the edge. */
  node: MainService;
};

/** Methods to use when ordering `MainService`. */
export enum MainServicesOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DEMAND_DATA_POINT_ID_ASC = 'DEMAND_DATA_POINT_ID_ASC',
  DEMAND_DATA_POINT_ID_DESC = 'DEMAND_DATA_POINT_ID_DESC',
  EXCLUDE_CARBON_ASC = 'EXCLUDE_CARBON_ASC',
  EXCLUDE_CARBON_DESC = 'EXCLUDE_CARBON_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  GRID_DEMAND_DATA_POINT_ID_ASC = 'GRID_DEMAND_DATA_POINT_ID_ASC',
  GRID_DEMAND_DATA_POINT_ID_DESC = 'GRID_DEMAND_DATA_POINT_ID_DESC',
  GRID_USAGE_DATA_POINT_ID_ASC = 'GRID_USAGE_DATA_POINT_ID_ASC',
  GRID_USAGE_DATA_POINT_ID_DESC = 'GRID_USAGE_DATA_POINT_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  METER_DEMAND_DATA_POINT_ID_ASC = 'METER_DEMAND_DATA_POINT_ID_ASC',
  METER_DEMAND_DATA_POINT_ID_DESC = 'METER_DEMAND_DATA_POINT_ID_DESC',
  METER_USAGE_DATA_POINT_ID_ASC = 'METER_USAGE_DATA_POINT_ID_ASC',
  METER_USAGE_DATA_POINT_ID_DESC = 'METER_USAGE_DATA_POINT_ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  USAGE_DATA_POINT_ID_ASC = 'USAGE_DATA_POINT_ID_ASC',
  USAGE_DATA_POINT_ID_DESC = 'USAGE_DATA_POINT_ID_DESC'
}

export enum MainServicesType {
  AIRFLOW_ELECTRIC_HIGH = 'AIRFLOW_ELECTRIC_HIGH',
  AIRFLOW_ELECTRIC_LOW = 'AIRFLOW_ELECTRIC_LOW',
  AIRFLOW_HIGH = 'AIRFLOW_HIGH',
  AIRFLOW_LOW = 'AIRFLOW_LOW',
  ELECTRIC = 'ELECTRIC',
  GAS = 'GAS',
  SOLAR = 'SOLAR',
  WATER = 'WATER'
}

/** A filter to be used against MainServicesType fields. All fields are combined with a logical ‘and.’ */
export type MainServicesTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<MainServicesType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<MainServicesType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<MainServicesType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<MainServicesType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<MainServicesType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<MainServicesType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<MainServicesType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<MainServicesType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<MainServicesType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<MainServicesType>>;
};

export type MeterCharge = Node & {
  __typename?: 'MeterCharge';
  /** The category of the charge. */
  category: UtilityMeterChargeCategory;
  /** The time this charge was created. */
  createdAt: Scalars['Datetime'];
  /** The time the charge was deleted. */
  deletedAt?: Maybe<Scalars['Datetime']>;
  id: Scalars['Int'];
  /** This is set by the extraction process. */
  label: Scalars['String'];
  /** This is used to further distinguish otherwise duplicate rows that need to be present. */
  lineNumber: Scalars['Int'];
  /** Reads a single `MeterStatement` that is related to this `MeterCharge`. */
  meterStatement?: Maybe<MeterStatement>;
  meterStatementId: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  overrideAt?: Maybe<Scalars['Datetime']>;
  /** The time this charge was updated. */
  updatedAt: Scalars['Datetime'];
  /** The value of the charge. */
  value: Scalars['Float'];
};

/**
 * A condition to be used against `MeterCharge` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type MeterChargeCondition = {
  /** Checks for equality with the object’s `category` field. */
  category?: InputMaybe<UtilityMeterChargeCategory>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `lineNumber` field. */
  lineNumber?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `meterStatementId` field. */
  meterStatementId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `normalizedValue` field. */
  normalizedValue?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `overrideAt` field. */
  overrideAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `MeterCharge` object types. All fields are combined with a logical ‘and.’ */
export type MeterChargeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MeterChargeFilter>>;
  /** Filter by the object’s `category` field. */
  category?: InputMaybe<UtilityMeterChargeCategoryFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object's `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lineNumber` field. */
  lineNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `meterStatementId` field. */
  meterStatementId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `normalizedValue` field. */
  normalizedValue?: InputMaybe<FloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MeterChargeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MeterChargeFilter>>;
  /** Filter by the object’s `overrideAt` field. */
  overrideAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object's `value` field. */
  value?: InputMaybe<FloatFilter>;
};

/** An input for mutations affecting `MeterCharge` */
export type MeterChargeInput = {
  /** The category of the charge. */
  category: UtilityMeterChargeCategory;
  id?: InputMaybe<Scalars['Int']>;
  /** This is set by the extraction process. */
  label: Scalars['String'];
  /** This is used to further distinguish otherwise duplicate rows that need to be present. */
  lineNumber?: InputMaybe<Scalars['Int']>;
  /** Mutates a `MeterStatement` as part of the payload */
  meterStatement?: InputMaybe<MeterStatementInput>;
  meterStatementId?: InputMaybe<Scalars['Int']>;
  /** The value of the charge. */
  value: Scalars['Float'];
};

/** Represents an update to a `MeterCharge`. Fields that are set will be updated. */
export type MeterChargePatch = {
  /** Overrides the label. */
  label?: InputMaybe<Scalars['String']>;
  /** Overrides the value. */
  value?: InputMaybe<Scalars['Float']>;
};

/** A connection to a list of `MeterCharge` values. */
export type MeterChargesConnection = {
  __typename?: 'MeterChargesConnection';
  /** A list of edges which contains the `MeterCharge` and cursor to aid in pagination. */
  edges: Array<MeterChargesEdge>;
  /** A list of `MeterCharge` objects. */
  nodes: Array<MeterCharge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MeterCharge` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `MeterCharge` edge in the connection. */
export type MeterChargesEdge = {
  __typename?: 'MeterChargesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MeterCharge` at the end of the edge. */
  node: MeterCharge;
};

/** Methods to use when ordering `MeterCharge`. */
export enum MeterChargesOrderBy {
  CATEGORY_ASC = 'CATEGORY_ASC',
  CATEGORY_DESC = 'CATEGORY_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DELETED_AT_ASC = 'DELETED_AT_ASC',
  DELETED_AT_DESC = 'DELETED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  LINE_NUMBER_ASC = 'LINE_NUMBER_ASC',
  LINE_NUMBER_DESC = 'LINE_NUMBER_DESC',
  METER_STATEMENT_ID_ASC = 'METER_STATEMENT_ID_ASC',
  METER_STATEMENT_ID_DESC = 'METER_STATEMENT_ID_DESC',
  NATURAL = 'NATURAL',
  NORMALIZED_VALUE_ASC = 'NORMALIZED_VALUE_ASC',
  NORMALIZED_VALUE_DESC = 'NORMALIZED_VALUE_DESC',
  OVERRIDE_AT_ASC = 'OVERRIDE_AT_ASC',
  OVERRIDE_AT_DESC = 'OVERRIDE_AT_DESC',
  OVERRIDE_LABEL_ASC = 'OVERRIDE_LABEL_ASC',
  OVERRIDE_LABEL_DESC = 'OVERRIDE_LABEL_DESC',
  OVERRIDE_VALUE_ASC = 'OVERRIDE_VALUE_ASC',
  OVERRIDE_VALUE_DESC = 'OVERRIDE_VALUE_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VALUE_ASC = 'VALUE_ASC',
  VALUE_DESC = 'VALUE_DESC'
}

export type MeterStatement = Node & {
  __typename?: 'MeterStatement';
  /** Reads a single `AccountStatement` that is related to this `MeterStatement`. */
  accountStatement?: Maybe<AccountStatement>;
  accountStatementId: Scalars['Int'];
  /** Reads a single `AccountStatementPdf` that is related to this `MeterStatement`. */
  accountStatementPdf?: Maybe<AccountStatementPdf>;
  /** The PDF for this meter statement */
  accountStatementPdfId?: Maybe<Scalars['Int']>;
  /** The charges for the meter statement */
  charges: MeterStatementsChargesConnection;
  /** The time this statement was created. */
  createdAt: Scalars['Datetime'];
  /** The original currency code. */
  currencyCode: Scalars['String'];
  /** Returns the deleted_at column of this record or its parent(s) */
  deletedAt?: Maybe<Scalars['Datetime']>;
  id: Scalars['Int'];
  integrationKey?: Maybe<Scalars['String']>;
  /** The end interval of the meter statement. */
  intervalEnd: Scalars['Date'];
  /** The start interval of the meter statement. */
  intervalStart: Scalars['Date'];
  isAdjustment: Scalars['Boolean'];
  isValidated: Scalars['Boolean'];
  manualUpload: Scalars['Boolean'];
  maxDemand?: Maybe<Scalars['Float']>;
  metadata: Scalars['JSON'];
  /** Reads and enables pagination through a set of `MeterCharge`. */
  meterCharges: MeterChargesConnection;
  /** Reads and enables pagination through a set of `MeterStatementHistory`. */
  meterStatementHistories: MeterStatementHistoriesConnection;
  /** Reads and enables pagination through a set of `MeterUsage`. */
  meterUsages: MeterUsagesConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The statements normalized charges. */
  normalizedCharges: MeterStatementsNormalizedChargesConnection;
  normalizedTotalCharges?: Maybe<Scalars['Float']>;
  overrideAt?: Maybe<Scalars['Datetime']>;
  /** Overrides the normalized month of the account_statement. */
  overrideStatementMonth?: Maybe<Scalars['Int']>;
  /** Overrides the normalized year of the account_statement. */
  overrideStatementYear?: Maybe<Scalars['Int']>;
  /**
   * Returns the PDF Link for the given meter statement.
   * @deprecated Use path property on the associated accountStatementPdf
   */
  pdfLink?: Maybe<Scalars['String']>;
  /**
   * Returns the PDF URI for the given meter statement.
   * @deprecated Use uri property on the associated accountStatementPdf
   */
  pdfUri?: Maybe<Scalars['String']>;
  /** This applies to max of meter_usages whose category is "demand" and units is this value. */
  primaryDemandUnits?: Maybe<Scalars['String']>;
  /** This applies to sums of meter_usages whose category is "usage" and units is this value. */
  primaryUsageUnits?: Maybe<Scalars['String']>;
  /** The date the statement was issued on. */
  statementDate: Scalars['Date'];
  statementMonth?: Maybe<Scalars['Int']>;
  statementYear?: Maybe<Scalars['Int']>;
  /** Returns the first day of the statement month and year as a date. */
  statementYearMonth?: Maybe<Scalars['Date']>;
  totalCharges?: Maybe<Scalars['Float']>;
  totalUsage?: Maybe<Scalars['Float']>;
  /** The time this statement was updated. */
  updatedAt: Scalars['Datetime'];
  /** Reads a single `UtilityMeter` that is related to this `MeterStatement`. */
  utilityMeter?: Maybe<UtilityMeter>;
  utilityMeterId: Scalars['Int'];
  /** Reads a single `UtilityMeterStatement` that is related to this `MeterStatement`. */
  utilityMeterStatement?: Maybe<UtilityMeterStatement>;
  /** Reads a single `UtilityMeterStatementRollup` that is related to this `MeterStatement`. */
  utilityMeterStatementRollup?: Maybe<UtilityMeterStatementRollup>;
};

export type MeterStatementChargesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<MeterStatementsChargesRecordFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type MeterStatementMeterChargesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MeterChargeCondition>;
  filter?: InputMaybe<MeterChargeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MeterChargesOrderBy>>;
};

export type MeterStatementMeterStatementHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MeterStatementHistoryCondition>;
  filter?: InputMaybe<MeterStatementHistoryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MeterStatementHistoriesOrderBy>>;
};

export type MeterStatementMeterUsagesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MeterUsageCondition>;
  filter?: InputMaybe<MeterUsageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MeterUsagesOrderBy>>;
};

export type MeterStatementNormalizedChargesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<MeterStatementsNormalizedChargesRecordFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/**
 * A condition to be used against `MeterStatement` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MeterStatementCondition = {
  /** Checks for equality with the object’s `accountStatementId` field. */
  accountStatementId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `accountStatementPdfId` field. */
  accountStatementPdfId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `integrationKey` field. */
  integrationKey?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `intervalEnd` field. */
  intervalEnd?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `intervalStart` field. */
  intervalStart?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `isAdjustment` field. */
  isAdjustment?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isValidated` field. */
  isValidated?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `manualUpload` field. */
  manualUpload?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `normalizedCurrencyCode` field. */
  normalizedCurrencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `overrideAt` field. */
  overrideAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `overrideStatementMonth` field. */
  overrideStatementMonth?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `overrideStatementYear` field. */
  overrideStatementYear?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `statementDate` field. */
  statementDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `utilityMeterId` field. */
  utilityMeterId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `MeterStatement` object types. All fields are combined with a logical ‘and.’ */
export type MeterStatementFilter = {
  /** Filter by the object’s `accountStatementId` field. */
  accountStatementId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `accountStatementPdfId` field. */
  accountStatementPdfId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MeterStatementFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object's `currencyCode` field. */
  currencyCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `integrationKey` field. */
  integrationKey?: InputMaybe<StringFilter>;
  /** Filter by the object’s `intervalEnd` field. */
  intervalEnd?: InputMaybe<DateFilter>;
  /** Filter by the object’s `intervalStart` field. */
  intervalStart?: InputMaybe<DateFilter>;
  /** Filter by the object’s `isAdjustment` field. */
  isAdjustment?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isValidated` field. */
  isValidated?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `manualUpload` field. */
  manualUpload?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `maxDemand` field. */
  maxDemand?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `normalizedCurrencyCode` field. */
  normalizedCurrencyCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `normalizedTotalCharges` field. */
  normalizedTotalCharges?: InputMaybe<FloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MeterStatementFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MeterStatementFilter>>;
  /** Filter by the object’s `overrideAt` field. */
  overrideAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `overrideStatementMonth` field. */
  overrideStatementMonth?: InputMaybe<IntFilter>;
  /** Filter by the object’s `overrideStatementYear` field. */
  overrideStatementYear?: InputMaybe<IntFilter>;
  /** Filter by the object's `primaryDemandUnits` field. */
  primaryDemandUnits?: InputMaybe<StringFilter>;
  /** Filter by the object's `primaryUsageUnits` field. */
  primaryUsageUnits?: InputMaybe<StringFilter>;
  /** Filter by the object’s `statementDate` field. */
  statementDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `statementMonth` field. */
  statementMonth?: InputMaybe<IntFilter>;
  /** Filter by the object’s `statementYear` field. */
  statementYear?: InputMaybe<IntFilter>;
  /** Filter by the object’s `statementYearMonth` field. */
  statementYearMonth?: InputMaybe<DateFilter>;
  /** Filter by the object’s `totalCharges` field. */
  totalCharges?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `totalUsage` field. */
  totalUsage?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `utilityMeterId` field. */
  utilityMeterId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `MeterStatementHistory` values. */
export type MeterStatementHistoriesConnection = {
  __typename?: 'MeterStatementHistoriesConnection';
  /** A list of edges which contains the `MeterStatementHistory` and cursor to aid in pagination. */
  edges: Array<MeterStatementHistoriesEdge>;
  /** A list of `MeterStatementHistory` objects. */
  nodes: Array<MeterStatementHistory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MeterStatementHistory` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `MeterStatementHistory` edge in the connection. */
export type MeterStatementHistoriesEdge = {
  __typename?: 'MeterStatementHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MeterStatementHistory` at the end of the edge. */
  node: MeterStatementHistory;
};

/** Methods to use when ordering `MeterStatementHistory`. */
export enum MeterStatementHistoriesOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  METER_STATEMENT_ID_ASC = 'METER_STATEMENT_ID_ASC',
  METER_STATEMENT_ID_DESC = 'METER_STATEMENT_ID_DESC',
  NATURAL = 'NATURAL'
}

export type MeterStatementHistory = {
  __typename?: 'MeterStatementHistory';
  /** The time this statement was created. */
  createdAt: Scalars['Datetime'];
  description: Scalars['String'];
  /** Reads a single `MeterStatement` that is related to this `MeterStatementHistory`. */
  meterStatement?: Maybe<MeterStatement>;
  meterStatementId: Scalars['Int'];
};

/**
 * A condition to be used against `MeterStatementHistory` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type MeterStatementHistoryCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `meterStatementId` field. */
  meterStatementId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `MeterStatementHistory` object types. All fields are combined with a logical ‘and.’ */
export type MeterStatementHistoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MeterStatementHistoryFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `meterStatementId` field. */
  meterStatementId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MeterStatementHistoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MeterStatementHistoryFilter>>;
};

/** An input for mutations affecting `MeterStatementHistory` */
export type MeterStatementHistoryInput = {
  description: Scalars['String'];
  /** Mutates a `MeterStatement` as part of the payload */
  meterStatement?: InputMaybe<MeterStatementInput>;
  meterStatementId?: InputMaybe<Scalars['Int']>;
};

/** An input for mutations affecting `MeterStatement` */
export type MeterStatementInput = {
  /** Mutates a `AccountStatement` as part of the payload */
  accountStatement?: InputMaybe<AccountStatementInput>;
  accountStatementId?: InputMaybe<Scalars['Int']>;
  /** Mutates a `AccountStatementPdf` as part of the payload */
  accountStatementPdf?: InputMaybe<AccountStatementPdfInput>;
  /** The PDF for this meter statement */
  accountStatementPdfId?: InputMaybe<Scalars['Int']>;
  /** The original currency code. */
  currencyCode: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  integrationKey?: InputMaybe<Scalars['String']>;
  /** The end interval of the meter statement. */
  intervalEnd: Scalars['Date'];
  /** The start interval of the meter statement. */
  intervalStart: Scalars['Date'];
  isAdjustment?: InputMaybe<Scalars['Boolean']>;
  isValidated?: InputMaybe<Scalars['Boolean']>;
  manualUpload?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  /** This applies to max of meter_usages whose category is "demand" and units is this value. */
  primaryDemandUnits?: InputMaybe<Scalars['String']>;
  /** This applies to sums of meter_usages whose category is "usage" and units is this value. */
  primaryUsageUnits?: InputMaybe<Scalars['String']>;
  /** The date the statement was issued on. */
  statementDate: Scalars['Date'];
  /** Mutates a `UtilityMeter` as part of the payload */
  utilityMeter?: InputMaybe<UtilityMeterInput>;
  utilityMeterId?: InputMaybe<Scalars['Int']>;
};

/** Represents an update to a `MeterStatement`. Fields that are set will be updated. */
export type MeterStatementPatch = {
  /** The PDF for this meter statement */
  accountStatementPdfId?: InputMaybe<Scalars['Int']>;
  /** Overrides the original currency code. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** The end interval of the meter statement. */
  intervalEnd?: InputMaybe<Scalars['Date']>;
  /** The start interval of the meter statement. */
  intervalStart?: InputMaybe<Scalars['Date']>;
  isAdjustment?: InputMaybe<Scalars['Boolean']>;
  isValidated?: InputMaybe<Scalars['Boolean']>;
  manualUpload?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Overrides the normalized month of the account_statement. */
  overrideStatementMonth?: InputMaybe<Scalars['Int']>;
  /** Overrides the normalized year of the account_statement. */
  overrideStatementYear?: InputMaybe<Scalars['Int']>;
  /** This overrides the primary demand units. */
  primaryDemandUnits?: InputMaybe<Scalars['String']>;
  /** This overrides the primary usage units. */
  primaryUsageUnits?: InputMaybe<Scalars['String']>;
  utilityMeterId?: InputMaybe<Scalars['Int']>;
};

/** A `MeterStatementsChargesRecord` edge in the connection. */
export type MeterStatementsChargeEdge = {
  __typename?: 'MeterStatementsChargeEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MeterStatementsChargesRecord` at the end of the edge. */
  node: MeterStatementsChargesRecord;
};

/** A connection to a list of `MeterStatementsChargesRecord` values. */
export type MeterStatementsChargesConnection = {
  __typename?: 'MeterStatementsChargesConnection';
  /** A list of edges which contains the `MeterStatementsChargesRecord` and cursor to aid in pagination. */
  edges: Array<MeterStatementsChargeEdge>;
  /** A list of `MeterStatementsChargesRecord` objects. */
  nodes: Array<MeterStatementsChargesRecord>;
  /** The count of *all* `MeterStatementsChargesRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** The return type of our `charges` query. */
export type MeterStatementsChargesRecord = {
  __typename?: 'MeterStatementsChargesRecord';
  category?: Maybe<UtilityMeterChargeCategory>;
  value?: Maybe<Scalars['Float']>;
};

/** A filter to be used against `MeterStatementsChargesRecord` object types. All fields are combined with a logical ‘and.’ */
export type MeterStatementsChargesRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MeterStatementsChargesRecordFilter>>;
  /** Filter by the object’s `category` field. */
  category?: InputMaybe<UtilityMeterChargeCategoryFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MeterStatementsChargesRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MeterStatementsChargesRecordFilter>>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<FloatFilter>;
};

/** A connection to a list of `MeterStatement` values. */
export type MeterStatementsConnection = {
  __typename?: 'MeterStatementsConnection';
  /** A list of edges which contains the `MeterStatement` and cursor to aid in pagination. */
  edges: Array<MeterStatementsEdge>;
  /** A list of `MeterStatement` objects. */
  nodes: Array<MeterStatement>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MeterStatement` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `MeterStatement` edge in the connection. */
export type MeterStatementsEdge = {
  __typename?: 'MeterStatementsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MeterStatement` at the end of the edge. */
  node: MeterStatement;
};

/** A `MeterStatementsNormalizedChargesRecord` edge in the connection. */
export type MeterStatementsNormalizedChargeEdge = {
  __typename?: 'MeterStatementsNormalizedChargeEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MeterStatementsNormalizedChargesRecord` at the end of the edge. */
  node: MeterStatementsNormalizedChargesRecord;
};

/** A connection to a list of `MeterStatementsNormalizedChargesRecord` values. */
export type MeterStatementsNormalizedChargesConnection = {
  __typename?: 'MeterStatementsNormalizedChargesConnection';
  /** A list of edges which contains the `MeterStatementsNormalizedChargesRecord` and cursor to aid in pagination. */
  edges: Array<MeterStatementsNormalizedChargeEdge>;
  /** A list of `MeterStatementsNormalizedChargesRecord` objects. */
  nodes: Array<MeterStatementsNormalizedChargesRecord>;
  /** The count of *all* `MeterStatementsNormalizedChargesRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** The return type of our `normalizedCharges` query. */
export type MeterStatementsNormalizedChargesRecord = {
  __typename?: 'MeterStatementsNormalizedChargesRecord';
  category?: Maybe<UtilityMeterChargeCategory>;
  value?: Maybe<Scalars['Float']>;
};

/** A filter to be used against `MeterStatementsNormalizedChargesRecord` object types. All fields are combined with a logical ‘and.’ */
export type MeterStatementsNormalizedChargesRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MeterStatementsNormalizedChargesRecordFilter>>;
  /** Filter by the object’s `category` field. */
  category?: InputMaybe<UtilityMeterChargeCategoryFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MeterStatementsNormalizedChargesRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MeterStatementsNormalizedChargesRecordFilter>>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<FloatFilter>;
};

/** Methods to use when ordering `MeterStatement`. */
export enum MeterStatementsOrderBy {
  ACCOUNT_STATEMENT_ID_ASC = 'ACCOUNT_STATEMENT_ID_ASC',
  ACCOUNT_STATEMENT_ID_DESC = 'ACCOUNT_STATEMENT_ID_DESC',
  ACCOUNT_STATEMENT_PDF_ID_ASC = 'ACCOUNT_STATEMENT_PDF_ID_ASC',
  ACCOUNT_STATEMENT_PDF_ID_DESC = 'ACCOUNT_STATEMENT_PDF_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CURRENCY_CODE_ASC = 'CURRENCY_CODE_ASC',
  CURRENCY_CODE_DESC = 'CURRENCY_CODE_DESC',
  DELETED_AT_ASC = 'DELETED_AT_ASC',
  DELETED_AT_DESC = 'DELETED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  INTEGRATION_KEY_ASC = 'INTEGRATION_KEY_ASC',
  INTEGRATION_KEY_DESC = 'INTEGRATION_KEY_DESC',
  INTERVAL_END_ASC = 'INTERVAL_END_ASC',
  INTERVAL_END_DESC = 'INTERVAL_END_DESC',
  INTERVAL_START_ASC = 'INTERVAL_START_ASC',
  INTERVAL_START_DESC = 'INTERVAL_START_DESC',
  IS_ADJUSTMENT_ASC = 'IS_ADJUSTMENT_ASC',
  IS_ADJUSTMENT_DESC = 'IS_ADJUSTMENT_DESC',
  IS_VALIDATED_ASC = 'IS_VALIDATED_ASC',
  IS_VALIDATED_DESC = 'IS_VALIDATED_DESC',
  MANUAL_UPLOAD_ASC = 'MANUAL_UPLOAD_ASC',
  MANUAL_UPLOAD_DESC = 'MANUAL_UPLOAD_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  NATURAL = 'NATURAL',
  NORMALIZED_CURRENCY_CODE_ASC = 'NORMALIZED_CURRENCY_CODE_ASC',
  NORMALIZED_CURRENCY_CODE_DESC = 'NORMALIZED_CURRENCY_CODE_DESC',
  OVERRIDE_AT_ASC = 'OVERRIDE_AT_ASC',
  OVERRIDE_AT_DESC = 'OVERRIDE_AT_DESC',
  OVERRIDE_CURRENCY_CODE_ASC = 'OVERRIDE_CURRENCY_CODE_ASC',
  OVERRIDE_CURRENCY_CODE_DESC = 'OVERRIDE_CURRENCY_CODE_DESC',
  OVERRIDE_PRIMARY_DEMAND_UNITS_ASC = 'OVERRIDE_PRIMARY_DEMAND_UNITS_ASC',
  OVERRIDE_PRIMARY_DEMAND_UNITS_DESC = 'OVERRIDE_PRIMARY_DEMAND_UNITS_DESC',
  OVERRIDE_PRIMARY_USAGE_UNITS_ASC = 'OVERRIDE_PRIMARY_USAGE_UNITS_ASC',
  OVERRIDE_PRIMARY_USAGE_UNITS_DESC = 'OVERRIDE_PRIMARY_USAGE_UNITS_DESC',
  OVERRIDE_STATEMENT_MONTH_ASC = 'OVERRIDE_STATEMENT_MONTH_ASC',
  OVERRIDE_STATEMENT_MONTH_DESC = 'OVERRIDE_STATEMENT_MONTH_DESC',
  OVERRIDE_STATEMENT_YEAR_ASC = 'OVERRIDE_STATEMENT_YEAR_ASC',
  OVERRIDE_STATEMENT_YEAR_DESC = 'OVERRIDE_STATEMENT_YEAR_DESC',
  PRIMARY_DEMAND_UNITS_ASC = 'PRIMARY_DEMAND_UNITS_ASC',
  PRIMARY_DEMAND_UNITS_DESC = 'PRIMARY_DEMAND_UNITS_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PRIMARY_USAGE_UNITS_ASC = 'PRIMARY_USAGE_UNITS_ASC',
  PRIMARY_USAGE_UNITS_DESC = 'PRIMARY_USAGE_UNITS_DESC',
  STATEMENT_DATE_ASC = 'STATEMENT_DATE_ASC',
  STATEMENT_DATE_DESC = 'STATEMENT_DATE_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  UTILITY_METER_ID_ASC = 'UTILITY_METER_ID_ASC',
  UTILITY_METER_ID_DESC = 'UTILITY_METER_ID_DESC'
}

export type MeterUsage = Node & {
  __typename?: 'MeterUsage';
  /** The category of the usage. */
  category: UtilityMeterUsageCategory;
  /** The time this usage was created. */
  createdAt: Scalars['Datetime'];
  /** The time the usage was deleted. */
  deletedAt?: Maybe<Scalars['Datetime']>;
  id: Scalars['Int'];
  /** This is set by the extraction process. */
  label: Scalars['String'];
  /** This is used to further distinguish otherwise duplicate rows that need to be present. */
  lineNumber: Scalars['Int'];
  /** This is set by the extraction process */
  metadata: Scalars['JSON'];
  /** Reads a single `MeterStatement` that is related to this `MeterUsage`. */
  meterStatement?: Maybe<MeterStatement>;
  meterStatementId: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  overrideAt?: Maybe<Scalars['Datetime']>;
  /** This is set by the extraction process. */
  units: Scalars['String'];
  /** The time this usage was updated. */
  updatedAt: Scalars['Datetime'];
  /** This is set by the extraction process. */
  value: Scalars['Float'];
};

/**
 * A condition to be used against `MeterUsage` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type MeterUsageCondition = {
  /** Checks for equality with the object’s `category` field. */
  category?: InputMaybe<UtilityMeterUsageCategory>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `lineNumber` field. */
  lineNumber?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `meterStatementId` field. */
  meterStatementId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `overrideAt` field. */
  overrideAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `MeterUsage` object types. All fields are combined with a logical ‘and.’ */
export type MeterUsageFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MeterUsageFilter>>;
  /** Filter by the object’s `category` field. */
  category?: InputMaybe<UtilityMeterUsageCategoryFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object's `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lineNumber` field. */
  lineNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `meterStatementId` field. */
  meterStatementId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MeterUsageFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MeterUsageFilter>>;
  /** Filter by the object’s `overrideAt` field. */
  overrideAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object's `units` field. */
  units?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object's `value` field. */
  value?: InputMaybe<FloatFilter>;
};

/** An input for mutations affecting `MeterUsage` */
export type MeterUsageInput = {
  /** The category of the usage. */
  category: UtilityMeterUsageCategory;
  id?: InputMaybe<Scalars['Int']>;
  /** This is set by the extraction process. */
  label: Scalars['String'];
  /** This is used to further distinguish otherwise duplicate rows that need to be present. */
  lineNumber: Scalars['Int'];
  /** This is set by the extraction process */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Mutates a `MeterStatement` as part of the payload */
  meterStatement?: InputMaybe<MeterStatementInput>;
  meterStatementId?: InputMaybe<Scalars['Int']>;
  /** This is set by the extraction process. */
  units: Scalars['String'];
  /** This is set by the extraction process. */
  value: Scalars['Float'];
};

/** Represents an update to a `MeterUsage`. Fields that are set will be updated. */
export type MeterUsagePatch = {
  /** This overrides the label. */
  label?: InputMaybe<Scalars['String']>;
  /** This is set by the extraction process */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** This overrides the units. */
  units?: InputMaybe<Scalars['String']>;
  /** This overrides the value. */
  value?: InputMaybe<Scalars['Float']>;
};

/** A connection to a list of `MeterUsage` values. */
export type MeterUsagesConnection = {
  __typename?: 'MeterUsagesConnection';
  /** A list of edges which contains the `MeterUsage` and cursor to aid in pagination. */
  edges: Array<MeterUsagesEdge>;
  /** A list of `MeterUsage` objects. */
  nodes: Array<MeterUsage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MeterUsage` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `MeterUsage` edge in the connection. */
export type MeterUsagesEdge = {
  __typename?: 'MeterUsagesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MeterUsage` at the end of the edge. */
  node: MeterUsage;
};

/** Methods to use when ordering `MeterUsage`. */
export enum MeterUsagesOrderBy {
  CATEGORY_ASC = 'CATEGORY_ASC',
  CATEGORY_DESC = 'CATEGORY_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DELETED_AT_ASC = 'DELETED_AT_ASC',
  DELETED_AT_DESC = 'DELETED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  LINE_NUMBER_ASC = 'LINE_NUMBER_ASC',
  LINE_NUMBER_DESC = 'LINE_NUMBER_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  METER_STATEMENT_ID_ASC = 'METER_STATEMENT_ID_ASC',
  METER_STATEMENT_ID_DESC = 'METER_STATEMENT_ID_DESC',
  NATURAL = 'NATURAL',
  OVERRIDE_AT_ASC = 'OVERRIDE_AT_ASC',
  OVERRIDE_AT_DESC = 'OVERRIDE_AT_DESC',
  OVERRIDE_LABEL_ASC = 'OVERRIDE_LABEL_ASC',
  OVERRIDE_LABEL_DESC = 'OVERRIDE_LABEL_DESC',
  OVERRIDE_UNITS_ASC = 'OVERRIDE_UNITS_ASC',
  OVERRIDE_UNITS_DESC = 'OVERRIDE_UNITS_DESC',
  OVERRIDE_VALUE_ASC = 'OVERRIDE_VALUE_ASC',
  OVERRIDE_VALUE_DESC = 'OVERRIDE_VALUE_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UNITS_ASC = 'UNITS_ASC',
  UNITS_DESC = 'UNITS_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VALUE_ASC = 'VALUE_ASC',
  VALUE_DESC = 'VALUE_DESC'
}

export type MetricAggregate = {
  __typename?: 'MetricAggregate';
  AVG?: Maybe<Scalars['JSON']>;
  COUNT?: Maybe<Scalars['JSON']>;
  FIRST?: Maybe<Scalars['JSON']>;
  LAST?: Maybe<Scalars['JSON']>;
  MAX?: Maybe<Scalars['JSON']>;
  MEDIAN?: Maybe<Scalars['JSON']>;
  MIN?: Maybe<Scalars['JSON']>;
  SUM?: Maybe<Scalars['JSON']>;
};

export type MetricData = Node & {
  __typename?: 'MetricData';
  data: Scalars['JSON'];
  label: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  nodeId: Scalars['ID'];
  sourceId: Scalars['String'];
  time: Scalars['String'];
};

export type MetricDataMetadataArgs = {
  drillIn?: InputMaybe<Scalars['Boolean']>;
};

export enum MetricDataAggregationMethod {
  AVG = 'AVG',
  COUNT = 'COUNT',
  FIRST = 'FIRST',
  LAST = 'LAST',
  MAX = 'MAX',
  MEDIAN = 'MEDIAN',
  MIN = 'MIN',
  SUM = 'SUM'
}

export type MetricDataConnection = {
  __typename?: 'MetricDataConnection';
  aggregates?: Maybe<MetricAggregate>;
  edges: Array<MetricDataEdge>;
  explain?: Maybe<MetricDataExplain>;
  nodes: Array<MetricData>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type MetricDataEdge = {
  __typename?: 'MetricDataEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node: MetricData;
};

export type MetricDataExplain = {
  __typename?: 'MetricDataExplain';
  timezone?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
};

export enum MetricDataOrderBy {
  TIME_ASC = 'TIME_ASC',
  TIME_DESC = 'TIME_DESC'
}

export enum MetricDatatype {
  BOOLEAN = 'BOOLEAN',
  FLOAT = 'FLOAT',
  INT = 'INT',
  LONG = 'LONG',
  NUMERIC = 'NUMERIC',
  TEXT = 'TEXT'
}

/** A filter to be used against MetricDatatype fields. All fields are combined with a logical ‘and.’ */
export type MetricDatatypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<MetricDatatype>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<MetricDatatype>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<MetricDatatype>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<MetricDatatype>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<MetricDatatype>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<MetricDatatype>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<MetricDatatype>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<MetricDatatype>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<MetricDatatype>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<MetricDatatype>>;
};

export type MetricLabel = Node & {
  __typename?: 'MetricLabel';
  label: Scalars['String'];
  nodeId: Scalars['ID'];
  sourceId: Scalars['String'];
};

/** A connection to a list of `MetricMetadatum` values. */
export type MetricMetadataConnection = {
  __typename?: 'MetricMetadataConnection';
  /** A list of edges which contains the `MetricMetadatum` and cursor to aid in pagination. */
  edges: Array<MetricMetadataEdge>;
  /** A list of `MetricMetadatum` objects. */
  nodes: Array<MetricMetadatum>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MetricMetadatum` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `MetricMetadatum` edge in the connection. */
export type MetricMetadataEdge = {
  __typename?: 'MetricMetadataEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MetricMetadatum` at the end of the edge. */
  node: MetricMetadatum;
};

/** Methods to use when ordering `MetricMetadatum`. */
export enum MetricMetadataOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DATA_TYPE_ASC = 'DATA_TYPE_ASC',
  DATA_TYPE_DESC = 'DATA_TYPE_DESC',
  EXPRESSION_ASC = 'EXPRESSION_ASC',
  EXPRESSION_DESC = 'EXPRESSION_DESC',
  HUMAN_LABEL_ASC = 'HUMAN_LABEL_ASC',
  HUMAN_LABEL_DESC = 'HUMAN_LABEL_DESC',
  IS_COMPOSITE_ASC = 'IS_COMPOSITE_ASC',
  IS_COMPOSITE_DESC = 'IS_COMPOSITE_DESC',
  IS_INTERNAL_ASC = 'IS_INTERNAL_ASC',
  IS_INTERNAL_DESC = 'IS_INTERNAL_DESC',
  IS_SPARSE_ASC = 'IS_SPARSE_ASC',
  IS_SPARSE_DESC = 'IS_SPARSE_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  TABLE_ASC = 'TABLE_ASC',
  TABLE_DESC = 'TABLE_DESC',
  UNIT_ASC = 'UNIT_ASC',
  UNIT_DESC = 'UNIT_DESC',
  UNIT_DIMENSION_ASC = 'UNIT_DIMENSION_ASC',
  UNIT_DIMENSION_DESC = 'UNIT_DIMENSION_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** Metadata describing a given metric by label. */
export type MetricMetadatum = Node & {
  __typename?: 'MetricMetadatum';
  /** Returns a list of all downstream dependencies for a metric. */
  allDependencies: MetricMetadataConnection;
  /** Returns a list of all upstream dependents for a metric. */
  allDependents: MetricMetadataConnection;
  /** The time the metric metadata was created. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** The data type of the metric. */
  dataType?: Maybe<MetricDatatype>;
  /** Returns a list of direct dependencies for a metric. */
  dependencies: MetricMetadataConnection;
  /** Returns a flattened list of direct dependencies for a metric. */
  dependencyList?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Returns a list of direct dependents for a metric. */
  dependents: MetricMetadataConnection;
  /** Returns a flattened list of direct dependents for a metric. */
  dependentsList?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The query expression used to derive the metric. */
  expression?: Maybe<Scalars['String']>;
  /** The human-readable label of the metric. */
  humanLabel: Scalars['String'];
  /** A flag that indicates the metric will be computed using other metrics. */
  isComposite?: Maybe<Scalars['Boolean']>;
  /** A flag that indicates  the metric is precalculated internally. */
  isInternal?: Maybe<Scalars['Boolean']>;
  /** A flag that indicates the metric should be interpolated when used. */
  isSparse?: Maybe<Scalars['Boolean']>;
  /** The label of the metric. */
  label: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The underlining table that stores the data stream of the metric. */
  table: Scalars['String'];
  /** The default unit that describes the raw data stream of the metric. */
  unit: Scalars['String'];
  /** The unit dimension of the metric. */
  unitDimension: Scalars['String'];
  /** The time the metric metadata was updated. */
  updatedAt?: Maybe<Scalars['Datetime']>;
};

/** Metadata describing a given metric by label. */
export type MetricMetadatumAllDependenciesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<MetricMetadatumFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** Metadata describing a given metric by label. */
export type MetricMetadatumAllDependentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<MetricMetadatumFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** Metadata describing a given metric by label. */
export type MetricMetadatumDependenciesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<MetricMetadatumFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** Metadata describing a given metric by label. */
export type MetricMetadatumDependentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<MetricMetadatumFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/**
 * A condition to be used against `MetricMetadatum` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MetricMetadatumCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `dataType` field. */
  dataType?: InputMaybe<MetricDatatype>;
  /** Checks for equality with the object’s `expression` field. */
  expression?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `humanLabel` field. */
  humanLabel?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `isComposite` field. */
  isComposite?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isInternal` field. */
  isInternal?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isSparse` field. */
  isSparse?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `table` field. */
  table?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `unit` field. */
  unit?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `unitDimension` field. */
  unitDimension?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `MetricMetadatum` object types. All fields are combined with a logical ‘and.’ */
export type MetricMetadatumFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MetricMetadatumFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dataType` field. */
  dataType?: InputMaybe<MetricDatatypeFilter>;
  /** Filter by the object’s `dependencyList` field. */
  dependencyList?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `dependentsList` field. */
  dependentsList?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `expression` field. */
  expression?: InputMaybe<StringFilter>;
  /** Filter by the object’s `humanLabel` field. */
  humanLabel?: InputMaybe<StringFilter>;
  /** Filter by the object’s `isComposite` field. */
  isComposite?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isInternal` field. */
  isInternal?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isSparse` field. */
  isSparse?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MetricMetadatumFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MetricMetadatumFilter>>;
  /** Filter by the object’s `table` field. */
  table?: InputMaybe<StringFilter>;
  /** Filter by the object’s `unit` field. */
  unit?: InputMaybe<StringFilter>;
  /** Filter by the object’s `unitDimension` field. */
  unitDimension?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Module Extension that can be enabled for each tenant environment */
export enum ModuleExtension {
  fleet = 'fleet',
  refrigeration = 'refrigeration',
  warehousing = 'warehousing'
}

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename?: 'Mutation';
  acknowledgeControlEvent?: Maybe<ControlEvent>;
  acknowledgeSuggestion?: Maybe<Suggestion>;
  /** Adds the facility as a favorite for the user. */
  addFavoriteFacility?: Maybe<AddFavoriteFacilityPayload>;
  /** Adds a child dependency to the specific metric */
  addMetricMetadataDependency?: Maybe<AddMetricMetadataDependencyPayload>;
  addProjectController?: Maybe<AddProjectControllerPayload>;
  addReportManager?: Maybe<AddReportManagerPayload>;
  /** Clears the facility communication. */
  clearFacilityCommunication?: Maybe<ClearFacilityCommunicationPayload>;
  /** Creates a single `AccountCharge`. */
  createAccountCharge?: Maybe<CreateAccountChargePayload>;
  /** Creates a single `AccountStatement`. */
  createAccountStatement?: Maybe<CreateAccountStatementPayload>;
  /** Creates a single `AccountStatementHistory`. */
  createAccountStatementHistory?: Maybe<CreateAccountStatementHistoryPayload>;
  /** Creates a single `AccountStatementPdf`. */
  createAccountStatementPdf?: Maybe<CreateAccountStatementPdfPayload>;
  /** Creates a single `BalancingAuthority`. */
  createBalancingAuthority?: Maybe<CreateBalancingAuthorityPayload>;
  /** Creates a single `Blast`. */
  createBlast?: Maybe<CreateBlastPayload>;
  /** Creates a single `BlastEvaporator`. */
  createBlastEvaporator?: Maybe<CreateBlastEvaporatorPayload>;
  /** Creates a single `BlastPallet`. */
  createBlastPallet?: Maybe<CreateBlastPalletPayload>;
  /** Creates a single `BlastPalletLocation`. */
  createBlastPalletLocation?: Maybe<CreateBlastPalletLocationPayload>;
  /** Creates a single `BlastRotation`. */
  createBlastRotation?: Maybe<CreateBlastRotationPayload>;
  /** Creates a single `BlastRotationAlert`. */
  createBlastRotationAlert?: Maybe<CreateBlastRotationAlertPayload>;
  /** Creates a single `BlastRotationEventLog`. */
  createBlastRotationEventLog?: Maybe<CreateBlastRotationEventLogPayload>;
  /** Creates a single `BlastRotationEventType`. */
  createBlastRotationEventType?: Maybe<CreateBlastRotationEventTypePayload>;
  /** Creates a single `BlastRotationPallet`. */
  createBlastRotationPallet?: Maybe<CreateBlastRotationPalletPayload>;
  /** Creates a single `BlastType`. */
  createBlastType?: Maybe<CreateBlastTypePayload>;
  /** Creates a single `BuildingArea`. */
  createBuildingArea?: Maybe<CreateBuildingAreaPayload>;
  /** Creates a single `BuildingAreaComplianceGroup`. */
  createBuildingAreaComplianceGroup?: Maybe<CreateBuildingAreaComplianceGroupPayload>;
  /** Creates a single `BuildingAreaType`. */
  createBuildingAreaType?: Maybe<CreateBuildingAreaTypePayload>;
  /** Creates a single `Chart`. */
  createChart?: Maybe<CreateChartPayload>;
  /** Creates a single `ComplianceGroup`. */
  createComplianceGroup?: Maybe<CreateComplianceGroupPayload>;
  /** Creates a single `ComplianceRange`. */
  createComplianceRange?: Maybe<CreateComplianceRangePayload>;
  /** Creates a single `Component`. */
  createComponent?: Maybe<CreateComponentPayload>;
  /** Creates a single `Compressor`. */
  createCompressor?: Maybe<CreateCompressorPayload>;
  /** Creates a single `ControlEvent`. */
  createControlEvent?: Maybe<CreateControlEventPayload>;
  /** Creates a single `ControlEventLog`. */
  createControlEventLog?: Maybe<CreateControlEventLogPayload>;
  /** Creates a single `Customer`. */
  createCustomer?: Maybe<CreateCustomerPayload>;
  /** Creates a single `Dashboard`. */
  createDashboard?: Maybe<CreateDashboardPayload>;
  /** Creates a single `DataPoint`. */
  createDataPoint?: Maybe<CreateDataPointPayload>;
  /** Creates a single `DataPointTag`. */
  createDataPointTag?: Maybe<CreateDataPointTagPayload>;
  /** Creates a single `DataSource`. */
  createDataSource?: Maybe<CreateDataSourcePayload>;
  /** Creates a single `Dependency`. */
  createDependency?: Maybe<CreateDependencyPayload>;
  /** Creates a single `Door`. */
  createDoor?: Maybe<CreateDoorPayload>;
  /** Creates a single `Evaporator`. */
  createEvaporator?: Maybe<CreateEvaporatorPayload>;
  /** Creates a single `Facility`. */
  createFacility?: Maybe<CreateFacilityPayload>;
  /** Creates a single `FacilityCommunication`. */
  createFacilityCommunication?: Maybe<CreateFacilityCommunicationPayload>;
  /** Creates a single `FacilityDataSource`. */
  createFacilityDataSource?: Maybe<CreateFacilityDataSourcePayload>;
  /** Creates a single `FacilityGroup`. */
  createFacilityGroup?: Maybe<CreateFacilityGroupPayload>;
  /** Creates a single `FacilityGroupsLinker`. */
  createFacilityGroupsLinker?: Maybe<CreateFacilityGroupsLinkerPayload>;
  /** Creates a single `FacilityTaggedDataPoint`. */
  createFacilityTaggedDataPoint?: Maybe<CreateFacilityTaggedDataPointPayload>;
  /** Creates a single `InboundOutboundLoad`. */
  createInboundOutboundLoad?: Maybe<CreateInboundOutboundLoadPayload>;
  createMachineAccessToken?: Maybe<CreateMachineAccessTokenPayload>;
  /** Creates a single `MachineUser`. */
  createMachineUser?: Maybe<CreateMachineUserPayload>;
  /** Creates a single `MainService`. */
  createMainService?: Maybe<CreateMainServicePayload>;
  /** Creates a single `MeterCharge`. */
  createMeterCharge?: Maybe<CreateMeterChargePayload>;
  /** Creates a single `MeterStatement`. */
  createMeterStatement?: Maybe<CreateMeterStatementPayload>;
  /** Creates a single `MeterStatementHistory`. */
  createMeterStatementHistory?: Maybe<CreateMeterStatementHistoryPayload>;
  /** Creates a single `MeterUsage`. */
  createMeterUsage?: Maybe<CreateMeterUsagePayload>;
  /** Creates a single `Pallet`. */
  createPallet?: Maybe<CreatePalletPayload>;
  /** Creates a single `PalletHistory`. */
  createPalletHistory?: Maybe<CreatePalletHistoryPayload>;
  /** Creates a single `PalletLocation`. */
  createPalletLocation?: Maybe<CreatePalletLocationPayload>;
  /** Creates a single `PricingNode`. */
  createPricingNode?: Maybe<CreatePricingNodePayload>;
  /** Creates a single `Product`. */
  createProduct?: Maybe<CreateProductPayload>;
  /** Creates a single `Program`. */
  createProgram?: Maybe<CreateProgramPayload>;
  /** Creates a single `ProgramEnrollment`. */
  createProgramEnrollment?: Maybe<CreateProgramEnrollmentPayload>;
  /** Creates a single `Project`. */
  createProject?: Maybe<CreateProjectPayload>;
  /** Creates a single `ProjectComponent`. */
  createProjectComponent?: Maybe<CreateProjectComponentPayload>;
  /** Creates a single `ProjectEnrollment`. */
  createProjectEnrollment?: Maybe<CreateProjectEnrollmentPayload>;
  /** Creates a single `ProjectEnrollmentDataPoint`. */
  createProjectEnrollmentDataPoint?: Maybe<CreateProjectEnrollmentDataPointPayload>;
  /** Creates a single `ProjectEnrollmentDataPointGroup`. */
  createProjectEnrollmentDataPointGroup?: Maybe<CreateProjectEnrollmentDataPointGroupPayload>;
  /** Creates a single `ProjectWatcher`. */
  createProjectWatcher?: Maybe<CreateProjectWatcherPayload>;
  /** Creates a single `ReportExecution`. */
  createReportExecution?: Maybe<CreateReportExecutionPayload>;
  /** Creates a single `SavingsEvent`. */
  createSavingsEvent?: Maybe<CreateSavingsEventPayload>;
  /** Creates a single `Suggestion`. */
  createSuggestion?: Maybe<CreateSuggestionPayload>;
  /** Creates a single `SuggestionActivityLog`. */
  createSuggestionActivityLog?: Maybe<CreateSuggestionActivityLogPayload>;
  /** Creates a single `SuggestionControlEvent`. */
  createSuggestionControlEvent?: Maybe<CreateSuggestionControlEventPayload>;
  /** Creates a single `TemperatureSensor`. */
  createTemperatureSensor?: Maybe<CreateTemperatureSensorPayload>;
  /** Creates a single `TrailerPosition`. */
  createTrailerPosition?: Maybe<CreateTrailerPositionPayload>;
  createUserAccessToken?: Maybe<CreateUserAccessTokenPayload>;
  /** Creates a single `UtilityAccount`. */
  createUtilityAccount?: Maybe<CreateUtilityAccountPayload>;
  /** Creates a single `UtilityMeter`. */
  createUtilityMeter?: Maybe<CreateUtilityMeterPayload>;
  /** Creates a single `UtilityProvider`. */
  createUtilityProvider?: Maybe<CreateUtilityProviderPayload>;
  /** Creates a single `VendorUser`. */
  createVendorUser?: Maybe<CreateVendorUserPayload>;
  /** Creates a single `VendorUserMachineUser`. */
  createVendorUserMachineUser?: Maybe<CreateVendorUserMachineUserPayload>;
  /** Creates a single `VirtualPointInterval`. */
  createVirtualPointInterval?: Maybe<CreateVirtualPointIntervalPayload>;
  /** Paranoid deletes a account charge. */
  deleteAccountCharge?: Maybe<DeleteAccountChargePayload>;
  /** Paranoid deletes a account statement. */
  deleteAccountStatement?: Maybe<DeleteAccountStatementPayload>;
  /** Deletes a single `BalancingAuthority` using a unique key. */
  deleteBalancingAuthority?: Maybe<DeleteBalancingAuthorityPayload>;
  /** Deletes a single `BalancingAuthority` using its globally unique id. */
  deleteBalancingAuthorityByNodeId?: Maybe<DeleteBalancingAuthorityPayload>;
  /** Deletes a single `BalancingAuthority` using a unique key. */
  deleteBalancingAuthorityBySlug?: Maybe<DeleteBalancingAuthorityPayload>;
  /** Deletes a single `Blast` using a unique key. */
  deleteBlast?: Maybe<DeleteBlastPayload>;
  /** Deletes a single `Blast` using a unique key. */
  deleteBlastByLabelAndFacilityId?: Maybe<DeleteBlastPayload>;
  /** Deletes a single `Blast` using its globally unique id. */
  deleteBlastByNodeId?: Maybe<DeleteBlastPayload>;
  /** Deletes a single `BlastEvaporator` using a unique key. */
  deleteBlastEvaporator?: Maybe<DeleteBlastEvaporatorPayload>;
  /** Deletes a single `BlastEvaporator` using its globally unique id. */
  deleteBlastEvaporatorByNodeId?: Maybe<DeleteBlastEvaporatorPayload>;
  /** Deletes a single `BlastPallet` using a unique key. */
  deleteBlastPallet?: Maybe<DeleteBlastPalletPayload>;
  /** Deletes a single `BlastPallet` using its globally unique id. */
  deleteBlastPalletByNodeId?: Maybe<DeleteBlastPalletPayload>;
  /** Deletes a single `BlastPalletLocation` using a unique key. */
  deleteBlastPalletLocation?: Maybe<DeleteBlastPalletLocationPayload>;
  /** Deletes a single `BlastPalletLocation` using its globally unique id. */
  deleteBlastPalletLocationByNodeId?: Maybe<DeleteBlastPalletLocationPayload>;
  /** Deletes a single `BlastRotation` using a unique key. */
  deleteBlastRotation?: Maybe<DeleteBlastRotationPayload>;
  /** Deletes a single `BlastRotationAlert` using a unique key. */
  deleteBlastRotationAlert?: Maybe<DeleteBlastRotationAlertPayload>;
  /** Deletes a single `BlastRotationAlert` using its globally unique id. */
  deleteBlastRotationAlertByNodeId?: Maybe<DeleteBlastRotationAlertPayload>;
  /** Deletes a single `BlastRotation` using its globally unique id. */
  deleteBlastRotationByNodeId?: Maybe<DeleteBlastRotationPayload>;
  /** Deletes a single `BlastRotationEventLog` using a unique key. */
  deleteBlastRotationEventLog?: Maybe<DeleteBlastRotationEventLogPayload>;
  /** Deletes a single `BlastRotationEventLog` using a unique key. */
  deleteBlastRotationEventLogByBlastRotationIdAndDescriptionAndBlastRotationEventTypeId?: Maybe<DeleteBlastRotationEventLogPayload>;
  /** Deletes a single `BlastRotationEventLog` using its globally unique id. */
  deleteBlastRotationEventLogByNodeId?: Maybe<DeleteBlastRotationEventLogPayload>;
  /** Deletes a single `BlastRotationEventType` using a unique key. */
  deleteBlastRotationEventType?: Maybe<DeleteBlastRotationEventTypePayload>;
  /** Deletes a single `BlastRotationEventType` using its globally unique id. */
  deleteBlastRotationEventTypeByNodeId?: Maybe<DeleteBlastRotationEventTypePayload>;
  /** Deletes a single `BlastRotationPallet` using a unique key. */
  deleteBlastRotationPallet?: Maybe<DeleteBlastRotationPalletPayload>;
  /** Deletes a single `BlastRotationPallet` using a unique key. */
  deleteBlastRotationPalletByBlastRotationIdAndPalletId?: Maybe<DeleteBlastRotationPalletPayload>;
  /** Deletes a single `BlastRotationPallet` using its globally unique id. */
  deleteBlastRotationPalletByNodeId?: Maybe<DeleteBlastRotationPalletPayload>;
  /** Deletes a single `BlastType` using a unique key. */
  deleteBlastType?: Maybe<DeleteBlastTypePayload>;
  /** Deletes a single `BlastType` using its globally unique id. */
  deleteBlastTypeByNodeId?: Maybe<DeleteBlastTypePayload>;
  /** Deletes a single `BuildingArea` using a unique key. */
  deleteBuildingArea?: Maybe<DeleteBuildingAreaPayload>;
  /** Deletes a single `BuildingArea` using a unique key. */
  deleteBuildingAreaByFacilityIdAndLabel?: Maybe<DeleteBuildingAreaPayload>;
  /** Deletes a single `BuildingArea` using its globally unique id. */
  deleteBuildingAreaByNodeId?: Maybe<DeleteBuildingAreaPayload>;
  /** Deletes a single `BuildingAreaComplianceGroup` using a unique key. */
  deleteBuildingAreaComplianceGroup?: Maybe<DeleteBuildingAreaComplianceGroupPayload>;
  /** Deletes a single `BuildingAreaComplianceGroup` using a unique key. */
  deleteBuildingAreaComplianceGroupByBuildingAreaIdAndComplianceType?: Maybe<DeleteBuildingAreaComplianceGroupPayload>;
  /** Deletes a single `BuildingAreaComplianceGroup` using its globally unique id. */
  deleteBuildingAreaComplianceGroupByNodeId?: Maybe<DeleteBuildingAreaComplianceGroupPayload>;
  /** Deletes a single `BuildingAreaType` using a unique key. */
  deleteBuildingAreaType?: Maybe<DeleteBuildingAreaTypePayload>;
  /** Deletes a single `BuildingAreaType` using its globally unique id. */
  deleteBuildingAreaTypeByNodeId?: Maybe<DeleteBuildingAreaTypePayload>;
  /** Deletes a single `Chart` using a unique key. */
  deleteChart?: Maybe<DeleteChartPayload>;
  /** Deletes a single `Chart` using its globally unique id. */
  deleteChartByNodeId?: Maybe<DeleteChartPayload>;
  /** Deletes a single `ComplianceGroup` using a unique key. */
  deleteComplianceGroup?: Maybe<DeleteComplianceGroupPayload>;
  /** Deletes a single `ComplianceGroup` using a unique key. */
  deleteComplianceGroupByLabel?: Maybe<DeleteComplianceGroupPayload>;
  /** Deletes a single `ComplianceGroup` using its globally unique id. */
  deleteComplianceGroupByNodeId?: Maybe<DeleteComplianceGroupPayload>;
  /** Deletes a single `ComplianceRange` using a unique key. */
  deleteComplianceRange?: Maybe<DeleteComplianceRangePayload>;
  /** Deletes a single `ComplianceRange` using a unique key. */
  deleteComplianceRangeByComplianceGroupIdAndLabel?: Maybe<DeleteComplianceRangePayload>;
  /** Deletes a single `ComplianceRange` using its globally unique id. */
  deleteComplianceRangeByNodeId?: Maybe<DeleteComplianceRangePayload>;
  /** Deletes a single `Component` using a unique key. */
  deleteComponent?: Maybe<DeleteComponentPayload>;
  /** Deletes a single `Component` using its globally unique id. */
  deleteComponentByNodeId?: Maybe<DeleteComponentPayload>;
  /** Deletes a single `Compressor` using a unique key. */
  deleteCompressor?: Maybe<DeleteCompressorPayload>;
  /** Deletes a single `Compressor` using a unique key. */
  deleteCompressorByFacilityIdAndLabel?: Maybe<DeleteCompressorPayload>;
  /** Deletes a single `Compressor` using its globally unique id. */
  deleteCompressorByNodeId?: Maybe<DeleteCompressorPayload>;
  /** Deletes a single `ControlEvent` using a unique key. */
  deleteControlEvent?: Maybe<DeleteControlEventPayload>;
  /** Deletes a single `ControlEvent` using its globally unique id. */
  deleteControlEventByNodeId?: Maybe<DeleteControlEventPayload>;
  /** Deletes a single `ControlEventLog` using a unique key. */
  deleteControlEventLog?: Maybe<DeleteControlEventLogPayload>;
  /** Deletes a single `ControlEventLog` using its globally unique id. */
  deleteControlEventLogByNodeId?: Maybe<DeleteControlEventLogPayload>;
  /** Deletes a single `Customer` using a unique key. */
  deleteCustomer?: Maybe<DeleteCustomerPayload>;
  /** Deletes a single `Customer` using its globally unique id. */
  deleteCustomerByNodeId?: Maybe<DeleteCustomerPayload>;
  /** Deletes a single `Customer` using a unique key. */
  deleteCustomerBySourceId?: Maybe<DeleteCustomerPayload>;
  /** Deletes a single `Dashboard` using a unique key. */
  deleteDashboard?: Maybe<DeleteDashboardPayload>;
  /** Deletes a single `Dashboard` using its globally unique id. */
  deleteDashboardByNodeId?: Maybe<DeleteDashboardPayload>;
  /** Deletes a single `DataPoint` using a unique key. */
  deleteDataPoint?: Maybe<DeleteDataPointPayload>;
  /** Deletes a single `DataPoint` using a unique key. */
  deleteDataPointByDataSourceNameAndName?: Maybe<DeleteDataPointPayload>;
  /** Deletes a single `DataPoint` using its globally unique id. */
  deleteDataPointByNodeId?: Maybe<DeleteDataPointPayload>;
  /** Deletes a single `DataSource` using a unique key. */
  deleteDataSource?: Maybe<DeleteDataSourcePayload>;
  /** Deletes a single `DataSource` using its globally unique id. */
  deleteDataSourceByNodeId?: Maybe<DeleteDataSourcePayload>;
  /** Deletes a single `Dependency` using a unique key. */
  deleteDependency?: Maybe<DeleteDependencyPayload>;
  /** Deletes a single `Dependency` using its globally unique id. */
  deleteDependencyByNodeId?: Maybe<DeleteDependencyPayload>;
  /** Deletes a single `Dependency` using a unique key. */
  deleteDependencyByPath?: Maybe<DeleteDependencyPayload>;
  /** Deletes a single `Door` using a unique key. */
  deleteDoor?: Maybe<DeleteDoorPayload>;
  /** Deletes a single `Door` using a unique key. */
  deleteDoorByFacilityIdAndLabel?: Maybe<DeleteDoorPayload>;
  /** Deletes a single `Door` using its globally unique id. */
  deleteDoorByNodeId?: Maybe<DeleteDoorPayload>;
  /** Deletes a single `Evaporator` using a unique key. */
  deleteEvaporator?: Maybe<DeleteEvaporatorPayload>;
  /** Deletes a single `Evaporator` using a unique key. */
  deleteEvaporatorByFacilityIdAndLabel?: Maybe<DeleteEvaporatorPayload>;
  /** Deletes a single `Evaporator` using its globally unique id. */
  deleteEvaporatorByNodeId?: Maybe<DeleteEvaporatorPayload>;
  /** Deletes a single `Facility` using a unique key. */
  deleteFacility?: Maybe<DeleteFacilityPayload>;
  /** Deletes a single `Facility` using its globally unique id. */
  deleteFacilityByNodeId?: Maybe<DeleteFacilityPayload>;
  /** Deletes a single `Facility` using a unique key. */
  deleteFacilityBySlug?: Maybe<DeleteFacilityPayload>;
  /** Removes a config from the specified facility */
  deleteFacilityConfig?: Maybe<DeleteFacilityConfigPayload>;
  /** Deletes a single `FacilityDataSource` using a unique key. */
  deleteFacilityDataSource?: Maybe<DeleteFacilityDataSourcePayload>;
  /** Deletes a single `FacilityDataSource` using its globally unique id. */
  deleteFacilityDataSourceByNodeId?: Maybe<DeleteFacilityDataSourcePayload>;
  /** Deletes a single `FacilityGroup` using a unique key. */
  deleteFacilityGroup?: Maybe<DeleteFacilityGroupPayload>;
  /** Deletes a single `FacilityGroup` using its globally unique id. */
  deleteFacilityGroupByNodeId?: Maybe<DeleteFacilityGroupPayload>;
  /** Deletes a single `FacilityGroupsLinker` using a unique key. */
  deleteFacilityGroupsLinker?: Maybe<DeleteFacilityGroupsLinkerPayload>;
  /** Deletes a single `FacilityGroupsLinker` using its globally unique id. */
  deleteFacilityGroupsLinkerByNodeId?: Maybe<DeleteFacilityGroupsLinkerPayload>;
  deleteFacilityMutableMetricData?: Maybe<Scalars['Int']>;
  /** Deletes a single `FacilityTaggedDataPoint` using a unique key. */
  deleteFacilityTaggedDataPoint?: Maybe<DeleteFacilityTaggedDataPointPayload>;
  /** Deletes a single `FacilityTaggedDataPoint` using its globally unique id. */
  deleteFacilityTaggedDataPointByNodeId?: Maybe<DeleteFacilityTaggedDataPointPayload>;
  /** Deletes a single `InboundOutboundLoad` using a unique key. */
  deleteInboundOutboundLoad?: Maybe<DeleteInboundOutboundLoadPayload>;
  /** Deletes a single `InboundOutboundLoad` using a unique key. */
  deleteInboundOutboundLoadByFacilityIdAndDirectionAndSourceId?: Maybe<DeleteInboundOutboundLoadPayload>;
  /** Deletes a single `InboundOutboundLoad` using its globally unique id. */
  deleteInboundOutboundLoadByNodeId?: Maybe<DeleteInboundOutboundLoadPayload>;
  /** Deletes a single `MachineUser` using a unique key. */
  deleteMachineUser?: Maybe<DeleteMachineUserPayload>;
  /** Deletes a single `MachineUser` using its globally unique id. */
  deleteMachineUserByNodeId?: Maybe<DeleteMachineUserPayload>;
  /** Deletes a single `MainService` using a unique key. */
  deleteMainService?: Maybe<DeleteMainServicePayload>;
  /** Deletes a single `MainService` using a unique key. */
  deleteMainServiceByFacilityIdAndName?: Maybe<DeleteMainServicePayload>;
  /** Deletes a single `MainService` using a unique key. */
  deleteMainServiceByFacilityIdAndUsageDataPointIdAndDemandDataPointId?: Maybe<DeleteMainServicePayload>;
  /** Deletes a single `MainService` using its globally unique id. */
  deleteMainServiceByNodeId?: Maybe<DeleteMainServicePayload>;
  /** Paranoid deletes a meter charge. */
  deleteMeterCharge?: Maybe<DeleteMeterChargePayload>;
  /** Paranoid deletes a meter statement. */
  deleteMeterStatement?: Maybe<DeleteMeterStatementPayload>;
  /** Paranoid deletes a utility meter usage. */
  deleteMeterUsage?: Maybe<DeleteMeterUsagePayload>;
  deleteMutableMetricData?: Maybe<Scalars['Int']>;
  /** Deletes a single `Pallet` using a unique key. */
  deletePallet?: Maybe<DeletePalletPayload>;
  /** Deletes a single `Pallet` using its globally unique id. */
  deletePalletByNodeId?: Maybe<DeletePalletPayload>;
  /** Deletes a single `Pallet` using a unique key. */
  deletePalletBySourceId?: Maybe<DeletePalletPayload>;
  /** Deletes a single `PalletHistory` using a unique key. */
  deletePalletHistory?: Maybe<DeletePalletHistoryPayload>;
  /** Deletes a single `PalletHistory` using its globally unique id. */
  deletePalletHistoryByNodeId?: Maybe<DeletePalletHistoryPayload>;
  /** Deletes a single `PalletHistory` using a unique key. */
  deletePalletHistoryBySourceId?: Maybe<DeletePalletHistoryPayload>;
  /** Deletes a single `PalletLocation` using a unique key. */
  deletePalletLocation?: Maybe<DeletePalletLocationPayload>;
  /** Deletes a single `PalletLocation` using its globally unique id. */
  deletePalletLocationByNodeId?: Maybe<DeletePalletLocationPayload>;
  /** Deletes a single `PalletLocation` using a unique key. */
  deletePalletLocationBySourceId?: Maybe<DeletePalletLocationPayload>;
  deletePhoneNumber: DeletePhoneNumberResponse;
  /** Deletes a single `PricingNode` using a unique key. */
  deletePricingNode?: Maybe<DeletePricingNodePayload>;
  /** Deletes a single `PricingNode` using its globally unique id. */
  deletePricingNodeByNodeId?: Maybe<DeletePricingNodePayload>;
  /** Deletes a single `Product` using a unique key. */
  deleteProduct?: Maybe<DeleteProductPayload>;
  /** Deletes a single `Product` using its globally unique id. */
  deleteProductByNodeId?: Maybe<DeleteProductPayload>;
  /** Deletes a single `Product` using a unique key. */
  deleteProductBySourceId?: Maybe<DeleteProductPayload>;
  /** Deletes a single `Program` using a unique key. */
  deleteProgram?: Maybe<DeleteProgramPayload>;
  /** Deletes a single `Program` using its globally unique id. */
  deleteProgramByNodeId?: Maybe<DeleteProgramPayload>;
  /** Deletes a single `Program` using a unique key. */
  deleteProgramByProjectTypeIdAndName?: Maybe<DeleteProgramPayload>;
  /** Deletes a single `ProgramEnrollment` using a unique key. */
  deleteProgramEnrollment?: Maybe<DeleteProgramEnrollmentPayload>;
  /** Deletes a single `ProgramEnrollment` using its globally unique id. */
  deleteProgramEnrollmentByNodeId?: Maybe<DeleteProgramEnrollmentPayload>;
  /** Deletes a single `ProgramEnrollment` using a unique key. */
  deleteProgramEnrollmentByProgramIdAndName?: Maybe<DeleteProgramEnrollmentPayload>;
  /** Deletes a single `Project` using a unique key. */
  deleteProject?: Maybe<DeleteProjectPayload>;
  /** Deletes a single `Project` using a unique key. */
  deleteProjectByFacilityIdAndProgramId?: Maybe<DeleteProjectPayload>;
  /** Deletes a single `Project` using its globally unique id. */
  deleteProjectByNodeId?: Maybe<DeleteProjectPayload>;
  /** Deletes a single `ProjectComponent` using a unique key. */
  deleteProjectComponent?: Maybe<DeleteProjectComponentPayload>;
  /** Deletes a single `ProjectComponent` using its globally unique id. */
  deleteProjectComponentByNodeId?: Maybe<DeleteProjectComponentPayload>;
  /** Removes a config from the specified project */
  deleteProjectConfig?: Maybe<DeleteProjectConfigPayload>;
  /** Deletes a single `ProjectEnrollment` using a unique key. */
  deleteProjectEnrollment?: Maybe<DeleteProjectEnrollmentPayload>;
  /** Deletes a single `ProjectEnrollment` using its globally unique id. */
  deleteProjectEnrollmentByNodeId?: Maybe<DeleteProjectEnrollmentPayload>;
  /** Deletes a single `ProjectEnrollment` using a unique key. */
  deleteProjectEnrollmentByProjectIdAndProgramEnrollmentId?: Maybe<DeleteProjectEnrollmentPayload>;
  /** Deletes a single `ProjectEnrollmentDataPoint` using a unique key. */
  deleteProjectEnrollmentDataPoint?: Maybe<DeleteProjectEnrollmentDataPointPayload>;
  /** Deletes a single `ProjectEnrollmentDataPoint` using its globally unique id. */
  deleteProjectEnrollmentDataPointByNodeId?: Maybe<DeleteProjectEnrollmentDataPointPayload>;
  /** Deletes a single `ProjectEnrollmentDataPoint` using a unique key. */
  deleteProjectEnrollmentDataPointByProjectEnrollmentIdAndDataPointId?: Maybe<DeleteProjectEnrollmentDataPointPayload>;
  /** Deletes a single `ProjectEnrollmentDataPointGroup` using a unique key. */
  deleteProjectEnrollmentDataPointGroup?: Maybe<DeleteProjectEnrollmentDataPointGroupPayload>;
  /** Deletes a single `ProjectEnrollmentDataPointGroup` using its globally unique id. */
  deleteProjectEnrollmentDataPointGroupByNodeId?: Maybe<DeleteProjectEnrollmentDataPointGroupPayload>;
  /** Deletes a single `ProjectWatcher` using a unique key. */
  deleteProjectWatcher?: Maybe<DeleteProjectWatcherPayload>;
  /** Deletes a single `ProjectWatcher` using its globally unique id. */
  deleteProjectWatcherByNodeId?: Maybe<DeleteProjectWatcherPayload>;
  /** Deletes a single `ReportExecution` using a unique key. */
  deleteReportExecution?: Maybe<DeleteReportExecutionPayload>;
  /** Deletes a single `ReportExecution` using its globally unique id. */
  deleteReportExecutionByNodeId?: Maybe<DeleteReportExecutionPayload>;
  /** Deletes a single `SavingsEvent` using a unique key. */
  deleteSavingsEvent?: Maybe<DeleteSavingsEventPayload>;
  /** Deletes a single `SavingsEvent` using its globally unique id. */
  deleteSavingsEventByNodeId?: Maybe<DeleteSavingsEventPayload>;
  /** Deletes a single `SavingsEvent` using a unique key. */
  deleteSavingsEventByProjectIdAndStartTimeAndEndTime?: Maybe<DeleteSavingsEventPayload>;
  /** Deletes a single `SuggestionControlEvent` using a unique key. */
  deleteSuggestionControlEvent?: Maybe<DeleteSuggestionControlEventPayload>;
  /** Deletes a single `SuggestionControlEvent` using a unique key. */
  deleteSuggestionControlEventByControlEventId?: Maybe<DeleteSuggestionControlEventPayload>;
  /** Deletes a single `SuggestionControlEvent` using its globally unique id. */
  deleteSuggestionControlEventByNodeId?: Maybe<DeleteSuggestionControlEventPayload>;
  /** Deletes a single `TemperatureSensor` using a unique key. */
  deleteTemperatureSensor?: Maybe<DeleteTemperatureSensorPayload>;
  /** Deletes a single `TemperatureSensor` using a unique key. */
  deleteTemperatureSensorByFacilityIdAndLabel?: Maybe<DeleteTemperatureSensorPayload>;
  /** Deletes a single `TemperatureSensor` using its globally unique id. */
  deleteTemperatureSensorByNodeId?: Maybe<DeleteTemperatureSensorPayload>;
  /** Deletes a single `TrailerPosition` using a unique key. */
  deleteTrailerPosition?: Maybe<DeleteTrailerPositionPayload>;
  /** Deletes a single `TrailerPosition` using a unique key. */
  deleteTrailerPositionByFacilityIdAndLabel?: Maybe<DeleteTrailerPositionPayload>;
  /** Deletes a single `TrailerPosition` using its globally unique id. */
  deleteTrailerPositionByNodeId?: Maybe<DeleteTrailerPositionPayload>;
  /** Deletes a single `User` using a unique key. */
  deleteUser?: Maybe<DeleteUserPayload>;
  /** Deletes a single `User` using its globally unique id. */
  deleteUserByNodeId?: Maybe<DeleteUserPayload>;
  /** Paranoid deletes a utility account. */
  deleteUtilityAccount?: Maybe<DeleteUtilityAccountPayload>;
  /** Paranoid deletes a utility meter. */
  deleteUtilityMeter?: Maybe<DeleteUtilityMeterPayload>;
  /** Deletes a single `UtilityProvider` using a unique key. */
  deleteUtilityProvider?: Maybe<DeleteUtilityProviderPayload>;
  /** Deletes a single `UtilityProvider` using a unique key. */
  deleteUtilityProviderByName?: Maybe<DeleteUtilityProviderPayload>;
  /** Deletes a single `UtilityProvider` using its globally unique id. */
  deleteUtilityProviderByNodeId?: Maybe<DeleteUtilityProviderPayload>;
  /** Deletes a single `VendorUser` using a unique key. */
  deleteVendorUser?: Maybe<DeleteVendorUserPayload>;
  /** Deletes a single `VendorUser` using a unique key. */
  deleteVendorUserByEmail?: Maybe<DeleteVendorUserPayload>;
  /** Deletes a single `VendorUser` using its globally unique id. */
  deleteVendorUserByNodeId?: Maybe<DeleteVendorUserPayload>;
  /** Deletes a single `VendorUserMachineUser` using a unique key. */
  deleteVendorUserMachineUser?: Maybe<DeleteVendorUserMachineUserPayload>;
  /** Deletes a single `VendorUserMachineUser` using a unique key. */
  deleteVendorUserMachineUserByMachineUserId?: Maybe<DeleteVendorUserMachineUserPayload>;
  /** Deletes a single `VendorUserMachineUser` using its globally unique id. */
  deleteVendorUserMachineUserByNodeId?: Maybe<DeleteVendorUserMachineUserPayload>;
  /** Deletes a single `VirtualPointInterval` using a unique key. */
  deleteVirtualPointInterval?: Maybe<DeleteVirtualPointIntervalPayload>;
  /** Deletes a single `VirtualPointInterval` using its globally unique id. */
  deleteVirtualPointIntervalByNodeId?: Maybe<DeleteVirtualPointIntervalPayload>;
  extend?: Maybe<Scalars['Boolean']>;
  patchControlEventRemoteMetadata?: Maybe<PatchControlEventRemoteMetadataPayload>;
  regenerateAccessToken?: Maybe<CreateAccessTokenPayload>;
  registerProjectUsers?: Maybe<RegisterProjectUsersPayload>;
  /** Removes the facility as a favorite for the user. */
  removeFavoriteFacility?: Maybe<RemoveFavoriteFacilityPayload>;
  /** Removes a child dependency from the specific metric */
  removeMetricMetadataDependency?: Maybe<RemoveMetricMetadataDependencyPayload>;
  removeProjectController?: Maybe<RemoveProjectControllerPayload>;
  removeReportManager?: Maybe<RemoveReportManagerPayload>;
  /** Custom mutation for assigning a meter_statement and its account_statement to a new meter and its account, respectively */
  reparentMeterStatement?: Maybe<ReparentMeterStatementPayload>;
  revokeAccessToken?: Maybe<Scalars['Boolean']>;
  runReport?: Maybe<ReportExecution>;
  /** Adds or updates a config on the specified facility */
  setFacilityConfig?: Maybe<SetFacilityConfigPayload>;
  setMachineUserCapability?: Maybe<SetMachineUserCapabilityPayload>;
  /** Adds or updates a config on the specified project */
  setProjectConfig?: Maybe<SetProjectConfigPayload>;
  transitionControlEvent?: Maybe<ControlEvent>;
  triggerPhoneNumberVerification: VerifyPhoneNumberResponse;
  /** Updates a single `AccountCharge` using a unique key and a patch. */
  updateAccountCharge?: Maybe<UpdateAccountChargePayload>;
  /** Updates a single `AccountCharge` using its globally unique id and a patch. */
  updateAccountChargeByNodeId?: Maybe<UpdateAccountChargePayload>;
  /** Updates a single `AccountStatement` using a unique key and a patch. */
  updateAccountStatement?: Maybe<UpdateAccountStatementPayload>;
  /** Updates a single `AccountStatement` using its globally unique id and a patch. */
  updateAccountStatementByNodeId?: Maybe<UpdateAccountStatementPayload>;
  /** Updates a single `BalancingAuthority` using a unique key and a patch. */
  updateBalancingAuthority?: Maybe<UpdateBalancingAuthorityPayload>;
  /** Updates a single `BalancingAuthority` using its globally unique id and a patch. */
  updateBalancingAuthorityByNodeId?: Maybe<UpdateBalancingAuthorityPayload>;
  /** Updates a single `BalancingAuthority` using a unique key and a patch. */
  updateBalancingAuthorityBySlug?: Maybe<UpdateBalancingAuthorityPayload>;
  /** Updates a single `Blast` using a unique key and a patch. */
  updateBlast?: Maybe<UpdateBlastPayload>;
  /** Updates a single `Blast` using a unique key and a patch. */
  updateBlastByLabelAndFacilityId?: Maybe<UpdateBlastPayload>;
  /** Updates a single `Blast` using its globally unique id and a patch. */
  updateBlastByNodeId?: Maybe<UpdateBlastPayload>;
  /** Updates a single `BlastEvaporator` using a unique key and a patch. */
  updateBlastEvaporator?: Maybe<UpdateBlastEvaporatorPayload>;
  /** Updates a single `BlastEvaporator` using its globally unique id and a patch. */
  updateBlastEvaporatorByNodeId?: Maybe<UpdateBlastEvaporatorPayload>;
  /** Updates a single `BlastPallet` using a unique key and a patch. */
  updateBlastPallet?: Maybe<UpdateBlastPalletPayload>;
  /** Updates a single `BlastPallet` using its globally unique id and a patch. */
  updateBlastPalletByNodeId?: Maybe<UpdateBlastPalletPayload>;
  /** Updates a single `BlastPalletLocation` using a unique key and a patch. */
  updateBlastPalletLocation?: Maybe<UpdateBlastPalletLocationPayload>;
  /** Updates a single `BlastPalletLocation` using its globally unique id and a patch. */
  updateBlastPalletLocationByNodeId?: Maybe<UpdateBlastPalletLocationPayload>;
  /** Updates a single `BlastRotation` using a unique key and a patch. */
  updateBlastRotation?: Maybe<UpdateBlastRotationPayload>;
  /** Updates a single `BlastRotationAlert` using a unique key and a patch. */
  updateBlastRotationAlert?: Maybe<UpdateBlastRotationAlertPayload>;
  /** Updates a single `BlastRotationAlert` using its globally unique id and a patch. */
  updateBlastRotationAlertByNodeId?: Maybe<UpdateBlastRotationAlertPayload>;
  /** Updates a single `BlastRotation` using its globally unique id and a patch. */
  updateBlastRotationByNodeId?: Maybe<UpdateBlastRotationPayload>;
  /** Updates a single `BlastRotationEventLog` using a unique key and a patch. */
  updateBlastRotationEventLog?: Maybe<UpdateBlastRotationEventLogPayload>;
  /** Updates a single `BlastRotationEventLog` using a unique key and a patch. */
  updateBlastRotationEventLogByBlastRotationIdAndDescriptionAndBlastRotationEventTypeId?: Maybe<UpdateBlastRotationEventLogPayload>;
  /** Updates a single `BlastRotationEventLog` using its globally unique id and a patch. */
  updateBlastRotationEventLogByNodeId?: Maybe<UpdateBlastRotationEventLogPayload>;
  /** Updates a single `BlastRotationEventType` using a unique key and a patch. */
  updateBlastRotationEventType?: Maybe<UpdateBlastRotationEventTypePayload>;
  /** Updates a single `BlastRotationEventType` using its globally unique id and a patch. */
  updateBlastRotationEventTypeByNodeId?: Maybe<UpdateBlastRotationEventTypePayload>;
  /** Updates a single `BlastRotationPallet` using a unique key and a patch. */
  updateBlastRotationPallet?: Maybe<UpdateBlastRotationPalletPayload>;
  /** Updates a single `BlastRotationPallet` using a unique key and a patch. */
  updateBlastRotationPalletByBlastRotationIdAndPalletId?: Maybe<UpdateBlastRotationPalletPayload>;
  /** Updates a single `BlastRotationPallet` using its globally unique id and a patch. */
  updateBlastRotationPalletByNodeId?: Maybe<UpdateBlastRotationPalletPayload>;
  /** Updates a single `BlastType` using a unique key and a patch. */
  updateBlastType?: Maybe<UpdateBlastTypePayload>;
  /** Updates a single `BlastType` using its globally unique id and a patch. */
  updateBlastTypeByNodeId?: Maybe<UpdateBlastTypePayload>;
  /** Updates a single `BuildingArea` using a unique key and a patch. */
  updateBuildingArea?: Maybe<UpdateBuildingAreaPayload>;
  /** Updates a single `BuildingArea` using a unique key and a patch. */
  updateBuildingAreaByFacilityIdAndLabel?: Maybe<UpdateBuildingAreaPayload>;
  /** Updates a single `BuildingArea` using its globally unique id and a patch. */
  updateBuildingAreaByNodeId?: Maybe<UpdateBuildingAreaPayload>;
  /** Updates a single `BuildingAreaComplianceGroup` using a unique key and a patch. */
  updateBuildingAreaComplianceGroup?: Maybe<UpdateBuildingAreaComplianceGroupPayload>;
  /** Updates a single `BuildingAreaComplianceGroup` using a unique key and a patch. */
  updateBuildingAreaComplianceGroupByBuildingAreaIdAndComplianceType?: Maybe<UpdateBuildingAreaComplianceGroupPayload>;
  /** Updates a single `BuildingAreaComplianceGroup` using its globally unique id and a patch. */
  updateBuildingAreaComplianceGroupByNodeId?: Maybe<UpdateBuildingAreaComplianceGroupPayload>;
  /** Updates a single `BuildingAreaType` using a unique key and a patch. */
  updateBuildingAreaType?: Maybe<UpdateBuildingAreaTypePayload>;
  /** Updates a single `BuildingAreaType` using its globally unique id and a patch. */
  updateBuildingAreaTypeByNodeId?: Maybe<UpdateBuildingAreaTypePayload>;
  /** Updates a single `Chart` using a unique key and a patch. */
  updateChart?: Maybe<UpdateChartPayload>;
  /** Updates a single `Chart` using its globally unique id and a patch. */
  updateChartByNodeId?: Maybe<UpdateChartPayload>;
  /** Updates a single `ComplianceGroup` using a unique key and a patch. */
  updateComplianceGroup?: Maybe<UpdateComplianceGroupPayload>;
  /** Updates a single `ComplianceGroup` using a unique key and a patch. */
  updateComplianceGroupByLabel?: Maybe<UpdateComplianceGroupPayload>;
  /** Updates a single `ComplianceGroup` using its globally unique id and a patch. */
  updateComplianceGroupByNodeId?: Maybe<UpdateComplianceGroupPayload>;
  /** Updates a single `ComplianceRange` using a unique key and a patch. */
  updateComplianceRange?: Maybe<UpdateComplianceRangePayload>;
  /** Updates a single `ComplianceRange` using a unique key and a patch. */
  updateComplianceRangeByComplianceGroupIdAndLabel?: Maybe<UpdateComplianceRangePayload>;
  /** Updates a single `ComplianceRange` using its globally unique id and a patch. */
  updateComplianceRangeByNodeId?: Maybe<UpdateComplianceRangePayload>;
  /** Updates a single `Component` using a unique key and a patch. */
  updateComponent?: Maybe<UpdateComponentPayload>;
  /** Updates a single `Component` using its globally unique id and a patch. */
  updateComponentByNodeId?: Maybe<UpdateComponentPayload>;
  /** Updates a single `Compressor` using a unique key and a patch. */
  updateCompressor?: Maybe<UpdateCompressorPayload>;
  /** Updates a single `Compressor` using a unique key and a patch. */
  updateCompressorByFacilityIdAndLabel?: Maybe<UpdateCompressorPayload>;
  /** Updates a single `Compressor` using its globally unique id and a patch. */
  updateCompressorByNodeId?: Maybe<UpdateCompressorPayload>;
  /** Updates a single `ControlEvent` using a unique key and a patch. */
  updateControlEvent?: Maybe<UpdateControlEventPayload>;
  /** Updates a single `ControlEvent` using its globally unique id and a patch. */
  updateControlEventByNodeId?: Maybe<UpdateControlEventPayload>;
  /** Updates a single `ControlEventLog` using a unique key and a patch. */
  updateControlEventLog?: Maybe<UpdateControlEventLogPayload>;
  /** Updates a single `ControlEventLog` using its globally unique id and a patch. */
  updateControlEventLogByNodeId?: Maybe<UpdateControlEventLogPayload>;
  /** Updates a single `Customer` using a unique key and a patch. */
  updateCustomer?: Maybe<UpdateCustomerPayload>;
  /** Updates a single `Customer` using its globally unique id and a patch. */
  updateCustomerByNodeId?: Maybe<UpdateCustomerPayload>;
  /** Updates a single `Customer` using a unique key and a patch. */
  updateCustomerBySourceId?: Maybe<UpdateCustomerPayload>;
  /** Updates a single `Dashboard` using a unique key and a patch. */
  updateDashboard?: Maybe<UpdateDashboardPayload>;
  /** Updates a single `Dashboard` using its globally unique id and a patch. */
  updateDashboardByNodeId?: Maybe<UpdateDashboardPayload>;
  /** Updates a single `DataPoint` using a unique key and a patch. */
  updateDataPoint?: Maybe<UpdateDataPointPayload>;
  /** Updates a single `DataPoint` using a unique key and a patch. */
  updateDataPointByDataSourceNameAndName?: Maybe<UpdateDataPointPayload>;
  /** Updates a single `DataPoint` using its globally unique id and a patch. */
  updateDataPointByNodeId?: Maybe<UpdateDataPointPayload>;
  /** Updates a single `Dependency` using a unique key and a patch. */
  updateDependency?: Maybe<UpdateDependencyPayload>;
  /** Updates a single `Dependency` using its globally unique id and a patch. */
  updateDependencyByNodeId?: Maybe<UpdateDependencyPayload>;
  /** Updates a single `Dependency` using a unique key and a patch. */
  updateDependencyByPath?: Maybe<UpdateDependencyPayload>;
  /** Updates a single `Door` using a unique key and a patch. */
  updateDoor?: Maybe<UpdateDoorPayload>;
  /** Updates a single `Door` using a unique key and a patch. */
  updateDoorByFacilityIdAndLabel?: Maybe<UpdateDoorPayload>;
  /** Updates a single `Door` using its globally unique id and a patch. */
  updateDoorByNodeId?: Maybe<UpdateDoorPayload>;
  /** Updates a single `Evaporator` using a unique key and a patch. */
  updateEvaporator?: Maybe<UpdateEvaporatorPayload>;
  /** Updates a single `Evaporator` using a unique key and a patch. */
  updateEvaporatorByFacilityIdAndLabel?: Maybe<UpdateEvaporatorPayload>;
  /** Updates a single `Evaporator` using its globally unique id and a patch. */
  updateEvaporatorByNodeId?: Maybe<UpdateEvaporatorPayload>;
  /** Updates a single `Facility` using a unique key and a patch. */
  updateFacility?: Maybe<UpdateFacilityPayload>;
  /** Updates a single `Facility` using its globally unique id and a patch. */
  updateFacilityByNodeId?: Maybe<UpdateFacilityPayload>;
  /** Updates a single `Facility` using a unique key and a patch. */
  updateFacilityBySlug?: Maybe<UpdateFacilityPayload>;
  /** Updates a single `FacilityGroup` using a unique key and a patch. */
  updateFacilityGroup?: Maybe<UpdateFacilityGroupPayload>;
  /** Updates a single `FacilityGroup` using its globally unique id and a patch. */
  updateFacilityGroupByNodeId?: Maybe<UpdateFacilityGroupPayload>;
  /** Updates a single `FacilityGroupsLinker` using a unique key and a patch. */
  updateFacilityGroupsLinker?: Maybe<UpdateFacilityGroupsLinkerPayload>;
  /** Updates a single `FacilityGroupsLinker` using its globally unique id and a patch. */
  updateFacilityGroupsLinkerByNodeId?: Maybe<UpdateFacilityGroupsLinkerPayload>;
  updateFacilityMutableMetricData?: Maybe<Scalars['Int']>;
  /** Updates a single `FacilityTaggedDataPoint` using a unique key and a patch. */
  updateFacilityTaggedDataPoint?: Maybe<UpdateFacilityTaggedDataPointPayload>;
  /** Updates a single `FacilityTaggedDataPoint` using its globally unique id and a patch. */
  updateFacilityTaggedDataPointByNodeId?: Maybe<UpdateFacilityTaggedDataPointPayload>;
  /** Updates a single `InboundOutboundLoad` using a unique key and a patch. */
  updateInboundOutboundLoad?: Maybe<UpdateInboundOutboundLoadPayload>;
  /** Updates a single `InboundOutboundLoad` using a unique key and a patch. */
  updateInboundOutboundLoadByFacilityIdAndDirectionAndSourceId?: Maybe<UpdateInboundOutboundLoadPayload>;
  /** Updates a single `InboundOutboundLoad` using its globally unique id and a patch. */
  updateInboundOutboundLoadByNodeId?: Maybe<UpdateInboundOutboundLoadPayload>;
  /** Updates a single `MachineUser` using a unique key and a patch. */
  updateMachineUser?: Maybe<UpdateMachineUserPayload>;
  /** Updates a single `MachineUser` using its globally unique id and a patch. */
  updateMachineUserByNodeId?: Maybe<UpdateMachineUserPayload>;
  /** Updates a single `MainService` using a unique key and a patch. */
  updateMainService?: Maybe<UpdateMainServicePayload>;
  /** Updates a single `MainService` using a unique key and a patch. */
  updateMainServiceByFacilityIdAndName?: Maybe<UpdateMainServicePayload>;
  /** Updates a single `MainService` using a unique key and a patch. */
  updateMainServiceByFacilityIdAndUsageDataPointIdAndDemandDataPointId?: Maybe<UpdateMainServicePayload>;
  /** Updates a single `MainService` using its globally unique id and a patch. */
  updateMainServiceByNodeId?: Maybe<UpdateMainServicePayload>;
  /** Updates a single `MeterCharge` using a unique key and a patch. */
  updateMeterCharge?: Maybe<UpdateMeterChargePayload>;
  /** Updates a single `MeterCharge` using its globally unique id and a patch. */
  updateMeterChargeByNodeId?: Maybe<UpdateMeterChargePayload>;
  /** Updates a single `MeterStatement` using a unique key and a patch. */
  updateMeterStatement?: Maybe<UpdateMeterStatementPayload>;
  /** Updates a single `MeterStatement` using its globally unique id and a patch. */
  updateMeterStatementByNodeId?: Maybe<UpdateMeterStatementPayload>;
  /** Updates a single `MeterUsage` using a unique key and a patch. */
  updateMeterUsage?: Maybe<UpdateMeterUsagePayload>;
  /** Updates a single `MeterUsage` using its globally unique id and a patch. */
  updateMeterUsageByNodeId?: Maybe<UpdateMeterUsagePayload>;
  updateMutableMetricData?: Maybe<Scalars['Int']>;
  /** Updates a single `Pallet` using a unique key and a patch. */
  updatePallet?: Maybe<UpdatePalletPayload>;
  /** Updates a single `Pallet` using its globally unique id and a patch. */
  updatePalletByNodeId?: Maybe<UpdatePalletPayload>;
  /** Updates a single `Pallet` using a unique key and a patch. */
  updatePalletBySourceId?: Maybe<UpdatePalletPayload>;
  /** Updates a single `PalletHistory` using a unique key and a patch. */
  updatePalletHistory?: Maybe<UpdatePalletHistoryPayload>;
  /** Updates a single `PalletHistory` using its globally unique id and a patch. */
  updatePalletHistoryByNodeId?: Maybe<UpdatePalletHistoryPayload>;
  /** Updates a single `PalletHistory` using a unique key and a patch. */
  updatePalletHistoryBySourceId?: Maybe<UpdatePalletHistoryPayload>;
  /** Updates a single `PalletLocation` using a unique key and a patch. */
  updatePalletLocation?: Maybe<UpdatePalletLocationPayload>;
  /** Updates a single `PalletLocation` using its globally unique id and a patch. */
  updatePalletLocationByNodeId?: Maybe<UpdatePalletLocationPayload>;
  /** Updates a single `PalletLocation` using a unique key and a patch. */
  updatePalletLocationBySourceId?: Maybe<UpdatePalletLocationPayload>;
  updatePhoneNumber: UpdatePhoneNumberResponse;
  /** Updates a single `PricingNode` using a unique key and a patch. */
  updatePricingNode?: Maybe<UpdatePricingNodePayload>;
  /** Updates a single `PricingNode` using its globally unique id and a patch. */
  updatePricingNodeByNodeId?: Maybe<UpdatePricingNodePayload>;
  /** Updates a single `Product` using a unique key and a patch. */
  updateProduct?: Maybe<UpdateProductPayload>;
  /** Updates a single `Product` using its globally unique id and a patch. */
  updateProductByNodeId?: Maybe<UpdateProductPayload>;
  /** Updates a single `Product` using a unique key and a patch. */
  updateProductBySourceId?: Maybe<UpdateProductPayload>;
  /** Updates a single `Program` using a unique key and a patch. */
  updateProgram?: Maybe<UpdateProgramPayload>;
  /** Updates a single `Program` using its globally unique id and a patch. */
  updateProgramByNodeId?: Maybe<UpdateProgramPayload>;
  /** Updates a single `Program` using a unique key and a patch. */
  updateProgramByProjectTypeIdAndName?: Maybe<UpdateProgramPayload>;
  /** Updates a single `ProgramEnrollment` using a unique key and a patch. */
  updateProgramEnrollment?: Maybe<UpdateProgramEnrollmentPayload>;
  /** Updates a single `ProgramEnrollment` using its globally unique id and a patch. */
  updateProgramEnrollmentByNodeId?: Maybe<UpdateProgramEnrollmentPayload>;
  /** Updates a single `ProgramEnrollment` using a unique key and a patch. */
  updateProgramEnrollmentByProgramIdAndName?: Maybe<UpdateProgramEnrollmentPayload>;
  /** Updates a single `Project` using a unique key and a patch. */
  updateProject?: Maybe<UpdateProjectPayload>;
  /** Updates a single `Project` using a unique key and a patch. */
  updateProjectByFacilityIdAndProgramId?: Maybe<UpdateProjectPayload>;
  /** Updates a single `Project` using its globally unique id and a patch. */
  updateProjectByNodeId?: Maybe<UpdateProjectPayload>;
  /** Updates a single `ProjectComponent` using a unique key and a patch. */
  updateProjectComponent?: Maybe<UpdateProjectComponentPayload>;
  /** Updates a single `ProjectComponent` using its globally unique id and a patch. */
  updateProjectComponentByNodeId?: Maybe<UpdateProjectComponentPayload>;
  /** Updates a single `ProjectEnrollmentDataPoint` using a unique key and a patch. */
  updateProjectEnrollmentDataPoint?: Maybe<UpdateProjectEnrollmentDataPointPayload>;
  /** Updates a single `ProjectEnrollmentDataPoint` using its globally unique id and a patch. */
  updateProjectEnrollmentDataPointByNodeId?: Maybe<UpdateProjectEnrollmentDataPointPayload>;
  /** Updates a single `ProjectEnrollmentDataPoint` using a unique key and a patch. */
  updateProjectEnrollmentDataPointByProjectEnrollmentIdAndDataPointId?: Maybe<UpdateProjectEnrollmentDataPointPayload>;
  /** Updates a single `ProjectEnrollmentDataPointGroup` using a unique key and a patch. */
  updateProjectEnrollmentDataPointGroup?: Maybe<UpdateProjectEnrollmentDataPointGroupPayload>;
  /** Updates a single `ProjectEnrollmentDataPointGroup` using its globally unique id and a patch. */
  updateProjectEnrollmentDataPointGroupByNodeId?: Maybe<UpdateProjectEnrollmentDataPointGroupPayload>;
  /** Updates a single `ProjectWatcher` using a unique key and a patch. */
  updateProjectWatcher?: Maybe<UpdateProjectWatcherPayload>;
  /** Updates a single `ProjectWatcher` using its globally unique id and a patch. */
  updateProjectWatcherByNodeId?: Maybe<UpdateProjectWatcherPayload>;
  /** Updates a single `ReportExecution` using a unique key and a patch. */
  updateReportExecution?: Maybe<UpdateReportExecutionPayload>;
  /** Updates a single `ReportExecution` using its globally unique id and a patch. */
  updateReportExecutionByNodeId?: Maybe<UpdateReportExecutionPayload>;
  /** Updates a single `SavingsEvent` using a unique key and a patch. */
  updateSavingsEvent?: Maybe<UpdateSavingsEventPayload>;
  /** Updates a single `SavingsEvent` using its globally unique id and a patch. */
  updateSavingsEventByNodeId?: Maybe<UpdateSavingsEventPayload>;
  /** Updates a single `SavingsEvent` using a unique key and a patch. */
  updateSavingsEventByProjectIdAndStartTimeAndEndTime?: Maybe<UpdateSavingsEventPayload>;
  /** Updates a single `Suggestion` using a unique key and a patch. */
  updateSuggestion?: Maybe<UpdateSuggestionPayload>;
  /** Updates a single `Suggestion` using its globally unique id and a patch. */
  updateSuggestionByNodeId?: Maybe<UpdateSuggestionPayload>;
  /** Updates a single `SuggestionControlEvent` using a unique key and a patch. */
  updateSuggestionControlEvent?: Maybe<UpdateSuggestionControlEventPayload>;
  /** Updates a single `SuggestionControlEvent` using a unique key and a patch. */
  updateSuggestionControlEventByControlEventId?: Maybe<UpdateSuggestionControlEventPayload>;
  /** Updates a single `SuggestionControlEvent` using its globally unique id and a patch. */
  updateSuggestionControlEventByNodeId?: Maybe<UpdateSuggestionControlEventPayload>;
  /** Updates a single `TemperatureSensor` using a unique key and a patch. */
  updateTemperatureSensor?: Maybe<UpdateTemperatureSensorPayload>;
  /** Updates a single `TemperatureSensor` using a unique key and a patch. */
  updateTemperatureSensorByFacilityIdAndLabel?: Maybe<UpdateTemperatureSensorPayload>;
  /** Updates a single `TemperatureSensor` using its globally unique id and a patch. */
  updateTemperatureSensorByNodeId?: Maybe<UpdateTemperatureSensorPayload>;
  /** Updates a single `TrailerPosition` using a unique key and a patch. */
  updateTrailerPosition?: Maybe<UpdateTrailerPositionPayload>;
  /** Updates a single `TrailerPosition` using a unique key and a patch. */
  updateTrailerPositionByFacilityIdAndLabel?: Maybe<UpdateTrailerPositionPayload>;
  /** Updates a single `TrailerPosition` using its globally unique id and a patch. */
  updateTrailerPositionByNodeId?: Maybe<UpdateTrailerPositionPayload>;
  /** Updates a single `User` using a unique key and a patch. */
  updateUser?: Maybe<UpdateUserPayload>;
  /** Updates a single `User` using its globally unique id and a patch. */
  updateUserByNodeId?: Maybe<UpdateUserPayload>;
  /** Updates a single `UtilityAccount` using a unique key and a patch. */
  updateUtilityAccount?: Maybe<UpdateUtilityAccountPayload>;
  /** Updates a single `UtilityAccount` using its globally unique id and a patch. */
  updateUtilityAccountByNodeId?: Maybe<UpdateUtilityAccountPayload>;
  /** Updates a single `UtilityMeter` using a unique key and a patch. */
  updateUtilityMeter?: Maybe<UpdateUtilityMeterPayload>;
  /** Updates a single `UtilityMeter` using its globally unique id and a patch. */
  updateUtilityMeterByNodeId?: Maybe<UpdateUtilityMeterPayload>;
  /** Updates a single `UtilityProvider` using a unique key and a patch. */
  updateUtilityProvider?: Maybe<UpdateUtilityProviderPayload>;
  /** Updates a single `UtilityProvider` using a unique key and a patch. */
  updateUtilityProviderByName?: Maybe<UpdateUtilityProviderPayload>;
  /** Updates a single `UtilityProvider` using its globally unique id and a patch. */
  updateUtilityProviderByNodeId?: Maybe<UpdateUtilityProviderPayload>;
  /** Updates a single `VendorUser` using a unique key and a patch. */
  updateVendorUser?: Maybe<UpdateVendorUserPayload>;
  /** Updates a single `VendorUser` using a unique key and a patch. */
  updateVendorUserByEmail?: Maybe<UpdateVendorUserPayload>;
  /** Updates a single `VendorUser` using its globally unique id and a patch. */
  updateVendorUserByNodeId?: Maybe<UpdateVendorUserPayload>;
  /** Updates a single `VendorUserMachineUser` using a unique key and a patch. */
  updateVendorUserMachineUser?: Maybe<UpdateVendorUserMachineUserPayload>;
  /** Updates a single `VendorUserMachineUser` using a unique key and a patch. */
  updateVendorUserMachineUserByMachineUserId?: Maybe<UpdateVendorUserMachineUserPayload>;
  /** Updates a single `VendorUserMachineUser` using its globally unique id and a patch. */
  updateVendorUserMachineUserByNodeId?: Maybe<UpdateVendorUserMachineUserPayload>;
  /** Updates a single `VirtualPointInterval` using a unique key and a patch. */
  updateVirtualPointInterval?: Maybe<UpdateVirtualPointIntervalPayload>;
  /** Updates a single `VirtualPointInterval` using its globally unique id and a patch. */
  updateVirtualPointIntervalByNodeId?: Maybe<UpdateVirtualPointIntervalPayload>;
  /** Upserts a single `AccountCharge`. */
  upsertAccountCharge?: Maybe<UpsertAccountChargePayload>;
  /** Upserts a single `AccountStatement`. */
  upsertAccountStatement?: Maybe<UpsertAccountStatementPayload>;
  /** Upserts a single `AccountStatementPdf`. */
  upsertAccountStatementPdf?: Maybe<UpsertAccountStatementPdfPayload>;
  /** Upserts a single `BalancingAuthority`. */
  upsertBalancingAuthority?: Maybe<UpsertBalancingAuthorityPayload>;
  /** Upserts a single `Blast`. */
  upsertBlast?: Maybe<UpsertBlastPayload>;
  /** Upserts a single `BlastEvaporator`. */
  upsertBlastEvaporator?: Maybe<UpsertBlastEvaporatorPayload>;
  /** Upserts a single `BlastPallet`. */
  upsertBlastPallet?: Maybe<UpsertBlastPalletPayload>;
  /** Upserts a single `BlastPalletLocation`. */
  upsertBlastPalletLocation?: Maybe<UpsertBlastPalletLocationPayload>;
  /** Upserts a single `BlastRotation`. */
  upsertBlastRotation?: Maybe<UpsertBlastRotationPayload>;
  /** Upserts a single `BlastRotationAlert`. */
  upsertBlastRotationAlert?: Maybe<UpsertBlastRotationAlertPayload>;
  /** Upserts a single `BlastRotationEventLog`. */
  upsertBlastRotationEventLog?: Maybe<UpsertBlastRotationEventLogPayload>;
  /** Upserts a single `BlastRotationEventType`. */
  upsertBlastRotationEventType?: Maybe<UpsertBlastRotationEventTypePayload>;
  /** Upserts a single `BlastRotationPallet`. */
  upsertBlastRotationPallet?: Maybe<UpsertBlastRotationPalletPayload>;
  /** Upserts a single `BlastType`. */
  upsertBlastType?: Maybe<UpsertBlastTypePayload>;
  /** Upserts a single `BuildingArea`. */
  upsertBuildingArea?: Maybe<UpsertBuildingAreaPayload>;
  /** Upserts a single `BuildingAreaComplianceGroup`. */
  upsertBuildingAreaComplianceGroup?: Maybe<UpsertBuildingAreaComplianceGroupPayload>;
  /** Upserts a single `BuildingAreaType`. */
  upsertBuildingAreaType?: Maybe<UpsertBuildingAreaTypePayload>;
  /** Upserts a single `Chart`. */
  upsertChart?: Maybe<UpsertChartPayload>;
  /** Upserts a single `ComplianceGroup`. */
  upsertComplianceGroup?: Maybe<UpsertComplianceGroupPayload>;
  /** Upserts a single `ComplianceRange`. */
  upsertComplianceRange?: Maybe<UpsertComplianceRangePayload>;
  /** Upserts a single `Compressor`. */
  upsertCompressor?: Maybe<UpsertCompressorPayload>;
  /** Upserts a single `Customer`. */
  upsertCustomer?: Maybe<UpsertCustomerPayload>;
  /** Upserts a single `Dashboard`. */
  upsertDashboard?: Maybe<UpsertDashboardPayload>;
  /** Upserts a single `DataPoint`. */
  upsertDataPoint?: Maybe<UpsertDataPointPayload>;
  /** Upserts a single `Dependency`. */
  upsertDependency?: Maybe<UpsertDependencyPayload>;
  /** Upserts a single `Door`. */
  upsertDoor?: Maybe<UpsertDoorPayload>;
  /** Upserts a single `Evaporator`. */
  upsertEvaporator?: Maybe<UpsertEvaporatorPayload>;
  /** Upserts a single `FacilityTaggedDataPoint`. */
  upsertFacilityTaggedDataPoint?: Maybe<UpsertFacilityTaggedDataPointPayload>;
  /** Upserts a single `InboundOutboundLoad`. */
  upsertInboundOutboundLoad?: Maybe<UpsertInboundOutboundLoadPayload>;
  /** Upserts a single `MachineUser`. */
  upsertMachineUser?: Maybe<UpsertMachineUserPayload>;
  /** Upserts a single `MainService`. */
  upsertMainService?: Maybe<UpsertMainServicePayload>;
  /** Upserts a single `MeterCharge`. */
  upsertMeterCharge?: Maybe<UpsertMeterChargePayload>;
  /** Upserts a single `MeterStatement`. */
  upsertMeterStatement?: Maybe<UpsertMeterStatementPayload>;
  /** Upserts a single `MeterUsage`. */
  upsertMeterUsage?: Maybe<UpsertMeterUsagePayload>;
  /** Upserts a single `Pallet`. */
  upsertPallet?: Maybe<UpsertPalletPayload>;
  /** Upserts a single `PalletHistory`. */
  upsertPalletHistory?: Maybe<UpsertPalletHistoryPayload>;
  /** Upserts a single `PalletLocation`. */
  upsertPalletLocation?: Maybe<UpsertPalletLocationPayload>;
  /** Upserts a single `PricingNode`. */
  upsertPricingNode?: Maybe<UpsertPricingNodePayload>;
  /** Upserts a single `Product`. */
  upsertProduct?: Maybe<UpsertProductPayload>;
  /** Upserts a single `Program`. */
  upsertProgram?: Maybe<UpsertProgramPayload>;
  /** Upserts a single `ProgramEnrollment`. */
  upsertProgramEnrollment?: Maybe<UpsertProgramEnrollmentPayload>;
  /** Upserts a single `ProjectComponent`. */
  upsertProjectComponent?: Maybe<UpsertProjectComponentPayload>;
  /** Upserts a single `ProjectEnrollment`. */
  upsertProjectEnrollment?: Maybe<UpsertProjectEnrollmentPayload>;
  /** Upserts a single `ProjectEnrollmentDataPoint`. */
  upsertProjectEnrollmentDataPoint?: Maybe<UpsertProjectEnrollmentDataPointPayload>;
  /** Upserts a single `ProjectEnrollmentDataPointGroup`. */
  upsertProjectEnrollmentDataPointGroup?: Maybe<UpsertProjectEnrollmentDataPointGroupPayload>;
  upsertProjectSubscription?: Maybe<UpsertProjectSubscriptionPayload>;
  /** Upserts a single `ProjectWatcher`. */
  upsertProjectWatcher?: Maybe<UpsertProjectWatcherPayload>;
  /** Upserts a single `ReportExecution`. */
  upsertReportExecution?: Maybe<UpsertReportExecutionPayload>;
  /** Upserts a single `ReportQuery`. */
  upsertReportQuery?: Maybe<UpsertReportQueryPayload>;
  /** Upserts a single `SavingsEvent`. */
  upsertSavingsEvent?: Maybe<UpsertSavingsEventPayload>;
  /** Upserts a single `SuggestionControlEvent`. */
  upsertSuggestionControlEvent?: Maybe<UpsertSuggestionControlEventPayload>;
  /** Upserts a single `TemperatureSensor`. */
  upsertTemperatureSensor?: Maybe<UpsertTemperatureSensorPayload>;
  /** Upserts a single `TrailerPosition`. */
  upsertTrailerPosition?: Maybe<UpsertTrailerPositionPayload>;
  upsertUrjanetUtilityProvider?: Maybe<UpsertUrjanetUtilityProviderPayload>;
  /** Upserts a single `UtilityAccount`. */
  upsertUtilityAccount?: Maybe<UpsertUtilityAccountPayload>;
  /** Upserts a single `UtilityMeter`. */
  upsertUtilityMeter?: Maybe<UpsertUtilityMeterPayload>;
  /** Upserts a single `UtilityProvider`. */
  upsertUtilityProvider?: Maybe<UpsertUtilityProviderPayload>;
  /** Upserts a single `VendorUserMachineUser`. */
  upsertVendorUserMachineUser?: Maybe<UpsertVendorUserMachineUserPayload>;
  /** Upserts a single `VirtualPointInterval`. */
  upsertVirtualPointInterval?: Maybe<UpsertVirtualPointIntervalPayload>;
  withdrawSuggestion?: Maybe<Suggestion>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationAcknowledgeControlEventArgs = {
  input: AcknowledgeControlEventInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationAcknowledgeSuggestionArgs = {
  input: AcknowledgeSuggestionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddFavoriteFacilityArgs = {
  input: AddFavoriteFacilityInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddMetricMetadataDependencyArgs = {
  input: AddMetricMetadataDependencyInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddProjectControllerArgs = {
  input: AddProjectControllerInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddReportManagerArgs = {
  input: AddReportManagerInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationClearFacilityCommunicationArgs = {
  input: ClearFacilityCommunicationInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAccountChargeArgs = {
  input: CreateAccountChargeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAccountStatementArgs = {
  input: CreateAccountStatementInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAccountStatementHistoryArgs = {
  input: CreateAccountStatementHistoryInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAccountStatementPdfArgs = {
  input: CreateAccountStatementPdfInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBalancingAuthorityArgs = {
  input: CreateBalancingAuthorityInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBlastArgs = {
  input: CreateBlastInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBlastEvaporatorArgs = {
  input: CreateBlastEvaporatorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBlastPalletArgs = {
  input: CreateBlastPalletInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBlastPalletLocationArgs = {
  input: CreateBlastPalletLocationInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBlastRotationArgs = {
  input: CreateBlastRotationInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBlastRotationAlertArgs = {
  input: CreateBlastRotationAlertInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBlastRotationEventLogArgs = {
  input: CreateBlastRotationEventLogInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBlastRotationEventTypeArgs = {
  input: CreateBlastRotationEventTypeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBlastRotationPalletArgs = {
  input: CreateBlastRotationPalletInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBlastTypeArgs = {
  input: CreateBlastTypeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBuildingAreaArgs = {
  input: CreateBuildingAreaInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBuildingAreaComplianceGroupArgs = {
  input: CreateBuildingAreaComplianceGroupInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBuildingAreaTypeArgs = {
  input: CreateBuildingAreaTypeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateChartArgs = {
  input: CreateChartInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateComplianceGroupArgs = {
  input: CreateComplianceGroupInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateComplianceRangeArgs = {
  input: CreateComplianceRangeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateComponentArgs = {
  input: CreateComponentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCompressorArgs = {
  input: CreateCompressorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateControlEventArgs = {
  input: CreateControlEventInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateControlEventLogArgs = {
  input: CreateControlEventLogInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCustomerArgs = {
  input: CreateCustomerInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDashboardArgs = {
  input: CreateDashboardInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDataPointArgs = {
  input: CreateDataPointInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDataPointTagArgs = {
  input: CreateDataPointTagInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDataSourceArgs = {
  input: CreateDataSourceInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDependencyArgs = {
  input: CreateDependencyInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDoorArgs = {
  input: CreateDoorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEvaporatorArgs = {
  input: CreateEvaporatorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFacilityArgs = {
  input: CreateFacilityInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFacilityCommunicationArgs = {
  input: CreateFacilityCommunicationInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFacilityDataSourceArgs = {
  input: CreateFacilityDataSourceInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFacilityGroupArgs = {
  input: CreateFacilityGroupInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFacilityGroupsLinkerArgs = {
  input: CreateFacilityGroupsLinkerInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFacilityTaggedDataPointArgs = {
  input: CreateFacilityTaggedDataPointInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateInboundOutboundLoadArgs = {
  input: CreateInboundOutboundLoadInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMachineAccessTokenArgs = {
  input: CreateMachineAccessTokenInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMachineUserArgs = {
  input: CreateMachineUserInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMainServiceArgs = {
  input: CreateMainServiceInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMeterChargeArgs = {
  input: CreateMeterChargeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMeterStatementArgs = {
  input: CreateMeterStatementInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMeterStatementHistoryArgs = {
  input: CreateMeterStatementHistoryInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMeterUsageArgs = {
  input: CreateMeterUsageInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePalletArgs = {
  input: CreatePalletInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePalletHistoryArgs = {
  input: CreatePalletHistoryInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePalletLocationArgs = {
  input: CreatePalletLocationInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePricingNodeArgs = {
  input: CreatePricingNodeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProductArgs = {
  input: CreateProductInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProgramArgs = {
  input: CreateProgramInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProgramEnrollmentArgs = {
  input: CreateProgramEnrollmentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProjectComponentArgs = {
  input: CreateProjectComponentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProjectEnrollmentArgs = {
  input: CreateProjectEnrollmentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProjectEnrollmentDataPointArgs = {
  input: CreateProjectEnrollmentDataPointInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProjectEnrollmentDataPointGroupArgs = {
  input: CreateProjectEnrollmentDataPointGroupInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProjectWatcherArgs = {
  input: CreateProjectWatcherInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateReportExecutionArgs = {
  input: CreateReportExecutionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSavingsEventArgs = {
  input: CreateSavingsEventInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSuggestionArgs = {
  input: CreateSuggestionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSuggestionActivityLogArgs = {
  input: CreateSuggestionActivityLogInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSuggestionControlEventArgs = {
  input: CreateSuggestionControlEventInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTemperatureSensorArgs = {
  input: CreateTemperatureSensorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTrailerPositionArgs = {
  input: CreateTrailerPositionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserAccessTokenArgs = {
  input: CreateUserAccessTokenInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUtilityAccountArgs = {
  input: CreateUtilityAccountInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUtilityMeterArgs = {
  input: CreateUtilityMeterInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUtilityProviderArgs = {
  input: CreateUtilityProviderInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateVendorUserArgs = {
  input: CreateVendorUserInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateVendorUserMachineUserArgs = {
  input: CreateVendorUserMachineUserInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateVirtualPointIntervalArgs = {
  input: CreateVirtualPointIntervalInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAccountChargeArgs = {
  input: DeleteAccountChargeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAccountStatementArgs = {
  input: DeleteAccountStatementInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBalancingAuthorityArgs = {
  input: DeleteBalancingAuthorityInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBalancingAuthorityByNodeIdArgs = {
  input: DeleteBalancingAuthorityByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBalancingAuthorityBySlugArgs = {
  input: DeleteBalancingAuthorityBySlugInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBlastArgs = {
  input: DeleteBlastInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBlastByLabelAndFacilityIdArgs = {
  input: DeleteBlastByLabelAndFacilityIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBlastByNodeIdArgs = {
  input: DeleteBlastByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBlastEvaporatorArgs = {
  input: DeleteBlastEvaporatorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBlastEvaporatorByNodeIdArgs = {
  input: DeleteBlastEvaporatorByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBlastPalletArgs = {
  input: DeleteBlastPalletInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBlastPalletByNodeIdArgs = {
  input: DeleteBlastPalletByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBlastPalletLocationArgs = {
  input: DeleteBlastPalletLocationInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBlastPalletLocationByNodeIdArgs = {
  input: DeleteBlastPalletLocationByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBlastRotationArgs = {
  input: DeleteBlastRotationInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBlastRotationAlertArgs = {
  input: DeleteBlastRotationAlertInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBlastRotationAlertByNodeIdArgs = {
  input: DeleteBlastRotationAlertByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBlastRotationByNodeIdArgs = {
  input: DeleteBlastRotationByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBlastRotationEventLogArgs = {
  input: DeleteBlastRotationEventLogInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBlastRotationEventLogByBlastRotationIdAndDescriptionAndBlastRotationEventTypeIdArgs =
  {
    input: DeleteBlastRotationEventLogByBlastRotationIdAndDescriptionAndBlastRotationEventTypeIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBlastRotationEventLogByNodeIdArgs = {
  input: DeleteBlastRotationEventLogByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBlastRotationEventTypeArgs = {
  input: DeleteBlastRotationEventTypeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBlastRotationEventTypeByNodeIdArgs = {
  input: DeleteBlastRotationEventTypeByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBlastRotationPalletArgs = {
  input: DeleteBlastRotationPalletInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBlastRotationPalletByBlastRotationIdAndPalletIdArgs =
  {
    input: DeleteBlastRotationPalletByBlastRotationIdAndPalletIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBlastRotationPalletByNodeIdArgs = {
  input: DeleteBlastRotationPalletByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBlastTypeArgs = {
  input: DeleteBlastTypeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBlastTypeByNodeIdArgs = {
  input: DeleteBlastTypeByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBuildingAreaArgs = {
  input: DeleteBuildingAreaInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBuildingAreaByFacilityIdAndLabelArgs = {
  input: DeleteBuildingAreaByFacilityIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBuildingAreaByNodeIdArgs = {
  input: DeleteBuildingAreaByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBuildingAreaComplianceGroupArgs = {
  input: DeleteBuildingAreaComplianceGroupInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBuildingAreaComplianceGroupByBuildingAreaIdAndComplianceTypeArgs =
  {
    input: DeleteBuildingAreaComplianceGroupByBuildingAreaIdAndComplianceTypeInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBuildingAreaComplianceGroupByNodeIdArgs = {
  input: DeleteBuildingAreaComplianceGroupByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBuildingAreaTypeArgs = {
  input: DeleteBuildingAreaTypeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBuildingAreaTypeByNodeIdArgs = {
  input: DeleteBuildingAreaTypeByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteChartArgs = {
  input: DeleteChartInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteChartByNodeIdArgs = {
  input: DeleteChartByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteComplianceGroupArgs = {
  input: DeleteComplianceGroupInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteComplianceGroupByLabelArgs = {
  input: DeleteComplianceGroupByLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteComplianceGroupByNodeIdArgs = {
  input: DeleteComplianceGroupByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteComplianceRangeArgs = {
  input: DeleteComplianceRangeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteComplianceRangeByComplianceGroupIdAndLabelArgs = {
  input: DeleteComplianceRangeByComplianceGroupIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteComplianceRangeByNodeIdArgs = {
  input: DeleteComplianceRangeByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteComponentArgs = {
  input: DeleteComponentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteComponentByNodeIdArgs = {
  input: DeleteComponentByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCompressorArgs = {
  input: DeleteCompressorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCompressorByFacilityIdAndLabelArgs = {
  input: DeleteCompressorByFacilityIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCompressorByNodeIdArgs = {
  input: DeleteCompressorByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteControlEventArgs = {
  input: DeleteControlEventInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteControlEventByNodeIdArgs = {
  input: DeleteControlEventByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteControlEventLogArgs = {
  input: DeleteControlEventLogInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteControlEventLogByNodeIdArgs = {
  input: DeleteControlEventLogByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCustomerArgs = {
  input: DeleteCustomerInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCustomerByNodeIdArgs = {
  input: DeleteCustomerByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCustomerBySourceIdArgs = {
  input: DeleteCustomerBySourceIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDashboardArgs = {
  input: DeleteDashboardInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDashboardByNodeIdArgs = {
  input: DeleteDashboardByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDataPointArgs = {
  input: DeleteDataPointInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDataPointByDataSourceNameAndNameArgs = {
  input: DeleteDataPointByDataSourceNameAndNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDataPointByNodeIdArgs = {
  input: DeleteDataPointByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDataSourceArgs = {
  input: DeleteDataSourceInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDataSourceByNodeIdArgs = {
  input: DeleteDataSourceByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDependencyArgs = {
  input: DeleteDependencyInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDependencyByNodeIdArgs = {
  input: DeleteDependencyByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDependencyByPathArgs = {
  input: DeleteDependencyByPathInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDoorArgs = {
  input: DeleteDoorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDoorByFacilityIdAndLabelArgs = {
  input: DeleteDoorByFacilityIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDoorByNodeIdArgs = {
  input: DeleteDoorByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEvaporatorArgs = {
  input: DeleteEvaporatorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEvaporatorByFacilityIdAndLabelArgs = {
  input: DeleteEvaporatorByFacilityIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEvaporatorByNodeIdArgs = {
  input: DeleteEvaporatorByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFacilityArgs = {
  input: DeleteFacilityInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFacilityByNodeIdArgs = {
  input: DeleteFacilityByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFacilityBySlugArgs = {
  input: DeleteFacilityBySlugInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFacilityConfigArgs = {
  input: DeleteFacilityConfigInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFacilityDataSourceArgs = {
  input: DeleteFacilityDataSourceInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFacilityDataSourceByNodeIdArgs = {
  input: DeleteFacilityDataSourceByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFacilityGroupArgs = {
  input: DeleteFacilityGroupInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFacilityGroupByNodeIdArgs = {
  input: DeleteFacilityGroupByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFacilityGroupsLinkerArgs = {
  input: DeleteFacilityGroupsLinkerInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFacilityGroupsLinkerByNodeIdArgs = {
  input: DeleteFacilityGroupsLinkerByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFacilityMutableMetricDataArgs = {
  facilityId: Scalars['Int'];
  from?: InputMaybe<Scalars['Datetime']>;
  label: Scalars['String'];
  to?: InputMaybe<Scalars['Datetime']>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFacilityTaggedDataPointArgs = {
  input: DeleteFacilityTaggedDataPointInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFacilityTaggedDataPointByNodeIdArgs = {
  input: DeleteFacilityTaggedDataPointByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInboundOutboundLoadArgs = {
  input: DeleteInboundOutboundLoadInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInboundOutboundLoadByFacilityIdAndDirectionAndSourceIdArgs =
  {
    input: DeleteInboundOutboundLoadByFacilityIdAndDirectionAndSourceIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInboundOutboundLoadByNodeIdArgs = {
  input: DeleteInboundOutboundLoadByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMachineUserArgs = {
  input: DeleteMachineUserInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMachineUserByNodeIdArgs = {
  input: DeleteMachineUserByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMainServiceArgs = {
  input: DeleteMainServiceInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMainServiceByFacilityIdAndNameArgs = {
  input: DeleteMainServiceByFacilityIdAndNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMainServiceByFacilityIdAndUsageDataPointIdAndDemandDataPointIdArgs =
  {
    input: DeleteMainServiceByFacilityIdAndUsageDataPointIdAndDemandDataPointIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMainServiceByNodeIdArgs = {
  input: DeleteMainServiceByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMeterChargeArgs = {
  input: DeleteMeterChargeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMeterStatementArgs = {
  input: DeleteMeterStatementInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMeterUsageArgs = {
  input: DeleteMeterUsageInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMutableMetricDataArgs = {
  from?: InputMaybe<Scalars['Datetime']>;
  label: Scalars['String'];
  sourceId?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['Datetime']>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePalletArgs = {
  input: DeletePalletInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePalletByNodeIdArgs = {
  input: DeletePalletByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePalletBySourceIdArgs = {
  input: DeletePalletBySourceIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePalletHistoryArgs = {
  input: DeletePalletHistoryInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePalletHistoryByNodeIdArgs = {
  input: DeletePalletHistoryByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePalletHistoryBySourceIdArgs = {
  input: DeletePalletHistoryBySourceIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePalletLocationArgs = {
  input: DeletePalletLocationInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePalletLocationByNodeIdArgs = {
  input: DeletePalletLocationByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePalletLocationBySourceIdArgs = {
  input: DeletePalletLocationBySourceIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePhoneNumberArgs = {
  input?: InputMaybe<DeletePhoneNumberInput>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePricingNodeArgs = {
  input: DeletePricingNodeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePricingNodeByNodeIdArgs = {
  input: DeletePricingNodeByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProductArgs = {
  input: DeleteProductInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProductByNodeIdArgs = {
  input: DeleteProductByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProductBySourceIdArgs = {
  input: DeleteProductBySourceIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProgramArgs = {
  input: DeleteProgramInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProgramByNodeIdArgs = {
  input: DeleteProgramByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProgramByProjectTypeIdAndNameArgs = {
  input: DeleteProgramByProjectTypeIdAndNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProgramEnrollmentArgs = {
  input: DeleteProgramEnrollmentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProgramEnrollmentByNodeIdArgs = {
  input: DeleteProgramEnrollmentByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProgramEnrollmentByProgramIdAndNameArgs = {
  input: DeleteProgramEnrollmentByProgramIdAndNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectArgs = {
  input: DeleteProjectInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectByFacilityIdAndProgramIdArgs = {
  input: DeleteProjectByFacilityIdAndProgramIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectByNodeIdArgs = {
  input: DeleteProjectByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectComponentArgs = {
  input: DeleteProjectComponentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectComponentByNodeIdArgs = {
  input: DeleteProjectComponentByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectConfigArgs = {
  input: DeleteProjectConfigInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectEnrollmentArgs = {
  input: DeleteProjectEnrollmentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectEnrollmentByNodeIdArgs = {
  input: DeleteProjectEnrollmentByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectEnrollmentByProjectIdAndProgramEnrollmentIdArgs =
  {
    input: DeleteProjectEnrollmentByProjectIdAndProgramEnrollmentIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectEnrollmentDataPointArgs = {
  input: DeleteProjectEnrollmentDataPointInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectEnrollmentDataPointByNodeIdArgs = {
  input: DeleteProjectEnrollmentDataPointByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectEnrollmentDataPointByProjectEnrollmentIdAndDataPointIdArgs =
  {
    input: DeleteProjectEnrollmentDataPointByProjectEnrollmentIdAndDataPointIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectEnrollmentDataPointGroupArgs = {
  input: DeleteProjectEnrollmentDataPointGroupInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectEnrollmentDataPointGroupByNodeIdArgs = {
  input: DeleteProjectEnrollmentDataPointGroupByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectWatcherArgs = {
  input: DeleteProjectWatcherInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectWatcherByNodeIdArgs = {
  input: DeleteProjectWatcherByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteReportExecutionArgs = {
  input: DeleteReportExecutionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteReportExecutionByNodeIdArgs = {
  input: DeleteReportExecutionByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSavingsEventArgs = {
  input: DeleteSavingsEventInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSavingsEventByNodeIdArgs = {
  input: DeleteSavingsEventByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSavingsEventByProjectIdAndStartTimeAndEndTimeArgs = {
  input: DeleteSavingsEventByProjectIdAndStartTimeAndEndTimeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSuggestionControlEventArgs = {
  input: DeleteSuggestionControlEventInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSuggestionControlEventByControlEventIdArgs = {
  input: DeleteSuggestionControlEventByControlEventIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSuggestionControlEventByNodeIdArgs = {
  input: DeleteSuggestionControlEventByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTemperatureSensorArgs = {
  input: DeleteTemperatureSensorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTemperatureSensorByFacilityIdAndLabelArgs = {
  input: DeleteTemperatureSensorByFacilityIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTemperatureSensorByNodeIdArgs = {
  input: DeleteTemperatureSensorByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTrailerPositionArgs = {
  input: DeleteTrailerPositionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTrailerPositionByFacilityIdAndLabelArgs = {
  input: DeleteTrailerPositionByFacilityIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTrailerPositionByNodeIdArgs = {
  input: DeleteTrailerPositionByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserByNodeIdArgs = {
  input: DeleteUserByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUtilityAccountArgs = {
  input: DeleteUtilityAccountInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUtilityMeterArgs = {
  input: DeleteUtilityMeterInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUtilityProviderArgs = {
  input: DeleteUtilityProviderInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUtilityProviderByNameArgs = {
  input: DeleteUtilityProviderByNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUtilityProviderByNodeIdArgs = {
  input: DeleteUtilityProviderByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVendorUserArgs = {
  input: DeleteVendorUserInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVendorUserByEmailArgs = {
  input: DeleteVendorUserByEmailInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVendorUserByNodeIdArgs = {
  input: DeleteVendorUserByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVendorUserMachineUserArgs = {
  input: DeleteVendorUserMachineUserInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVendorUserMachineUserByMachineUserIdArgs = {
  input: DeleteVendorUserMachineUserByMachineUserIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVendorUserMachineUserByNodeIdArgs = {
  input: DeleteVendorUserMachineUserByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVirtualPointIntervalArgs = {
  input: DeleteVirtualPointIntervalInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVirtualPointIntervalByNodeIdArgs = {
  input: DeleteVirtualPointIntervalByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationExtendArgs = {
  failOnExists?: InputMaybe<Scalars['Boolean']>;
  payload: Scalars['String'];
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationPatchControlEventRemoteMetadataArgs = {
  input: PatchControlEventRemoteMetadataInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationRegenerateAccessTokenArgs = {
  input: RegenerateAccessTokenInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationRegisterProjectUsersArgs = {
  input: RegisterProjectUsersInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationRemoveFavoriteFacilityArgs = {
  input: RemoveFavoriteFacilityInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationRemoveMetricMetadataDependencyArgs = {
  input: RemoveMetricMetadataDependencyInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationRemoveProjectControllerArgs = {
  input: RemoveProjectControllerInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationRemoveReportManagerArgs = {
  input: RemoveReportManagerInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationReparentMeterStatementArgs = {
  input: ReparentMeterStatementInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationRevokeAccessTokenArgs = {
  input: RevokeAccessTokenInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationRunReportArgs = {
  parameters?: InputMaybe<Scalars['JSON']>;
  reportId: Scalars['Int'];
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetFacilityConfigArgs = {
  input: SetFacilityConfigInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetMachineUserCapabilityArgs = {
  input: SetMachineUserCapabilityInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetProjectConfigArgs = {
  input: SetProjectConfigInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationTransitionControlEventArgs = {
  input: TransitionControlEventInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationTriggerPhoneNumberVerificationArgs = {
  input: VerifyPhoneNumberInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAccountChargeArgs = {
  input: UpdateAccountChargeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAccountChargeByNodeIdArgs = {
  input: UpdateAccountChargeByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAccountStatementArgs = {
  input: UpdateAccountStatementInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAccountStatementByNodeIdArgs = {
  input: UpdateAccountStatementByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBalancingAuthorityArgs = {
  input: UpdateBalancingAuthorityInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBalancingAuthorityByNodeIdArgs = {
  input: UpdateBalancingAuthorityByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBalancingAuthorityBySlugArgs = {
  input: UpdateBalancingAuthorityBySlugInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBlastArgs = {
  input: UpdateBlastInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBlastByLabelAndFacilityIdArgs = {
  input: UpdateBlastByLabelAndFacilityIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBlastByNodeIdArgs = {
  input: UpdateBlastByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBlastEvaporatorArgs = {
  input: UpdateBlastEvaporatorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBlastEvaporatorByNodeIdArgs = {
  input: UpdateBlastEvaporatorByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBlastPalletArgs = {
  input: UpdateBlastPalletInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBlastPalletByNodeIdArgs = {
  input: UpdateBlastPalletByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBlastPalletLocationArgs = {
  input: UpdateBlastPalletLocationInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBlastPalletLocationByNodeIdArgs = {
  input: UpdateBlastPalletLocationByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBlastRotationArgs = {
  input: UpdateBlastRotationInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBlastRotationAlertArgs = {
  input: UpdateBlastRotationAlertInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBlastRotationAlertByNodeIdArgs = {
  input: UpdateBlastRotationAlertByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBlastRotationByNodeIdArgs = {
  input: UpdateBlastRotationByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBlastRotationEventLogArgs = {
  input: UpdateBlastRotationEventLogInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBlastRotationEventLogByBlastRotationIdAndDescriptionAndBlastRotationEventTypeIdArgs =
  {
    input: UpdateBlastRotationEventLogByBlastRotationIdAndDescriptionAndBlastRotationEventTypeIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBlastRotationEventLogByNodeIdArgs = {
  input: UpdateBlastRotationEventLogByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBlastRotationEventTypeArgs = {
  input: UpdateBlastRotationEventTypeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBlastRotationEventTypeByNodeIdArgs = {
  input: UpdateBlastRotationEventTypeByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBlastRotationPalletArgs = {
  input: UpdateBlastRotationPalletInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBlastRotationPalletByBlastRotationIdAndPalletIdArgs =
  {
    input: UpdateBlastRotationPalletByBlastRotationIdAndPalletIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBlastRotationPalletByNodeIdArgs = {
  input: UpdateBlastRotationPalletByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBlastTypeArgs = {
  input: UpdateBlastTypeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBlastTypeByNodeIdArgs = {
  input: UpdateBlastTypeByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBuildingAreaArgs = {
  input: UpdateBuildingAreaInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBuildingAreaByFacilityIdAndLabelArgs = {
  input: UpdateBuildingAreaByFacilityIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBuildingAreaByNodeIdArgs = {
  input: UpdateBuildingAreaByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBuildingAreaComplianceGroupArgs = {
  input: UpdateBuildingAreaComplianceGroupInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBuildingAreaComplianceGroupByBuildingAreaIdAndComplianceTypeArgs =
  {
    input: UpdateBuildingAreaComplianceGroupByBuildingAreaIdAndComplianceTypeInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBuildingAreaComplianceGroupByNodeIdArgs = {
  input: UpdateBuildingAreaComplianceGroupByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBuildingAreaTypeArgs = {
  input: UpdateBuildingAreaTypeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBuildingAreaTypeByNodeIdArgs = {
  input: UpdateBuildingAreaTypeByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateChartArgs = {
  input: UpdateChartInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateChartByNodeIdArgs = {
  input: UpdateChartByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateComplianceGroupArgs = {
  input: UpdateComplianceGroupInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateComplianceGroupByLabelArgs = {
  input: UpdateComplianceGroupByLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateComplianceGroupByNodeIdArgs = {
  input: UpdateComplianceGroupByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateComplianceRangeArgs = {
  input: UpdateComplianceRangeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateComplianceRangeByComplianceGroupIdAndLabelArgs = {
  input: UpdateComplianceRangeByComplianceGroupIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateComplianceRangeByNodeIdArgs = {
  input: UpdateComplianceRangeByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateComponentArgs = {
  input: UpdateComponentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateComponentByNodeIdArgs = {
  input: UpdateComponentByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCompressorArgs = {
  input: UpdateCompressorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCompressorByFacilityIdAndLabelArgs = {
  input: UpdateCompressorByFacilityIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCompressorByNodeIdArgs = {
  input: UpdateCompressorByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateControlEventArgs = {
  input: UpdateControlEventInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateControlEventByNodeIdArgs = {
  input: UpdateControlEventByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateControlEventLogArgs = {
  input: UpdateControlEventLogInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateControlEventLogByNodeIdArgs = {
  input: UpdateControlEventLogByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCustomerArgs = {
  input: UpdateCustomerInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCustomerByNodeIdArgs = {
  input: UpdateCustomerByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCustomerBySourceIdArgs = {
  input: UpdateCustomerBySourceIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDashboardArgs = {
  input: UpdateDashboardInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDashboardByNodeIdArgs = {
  input: UpdateDashboardByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDataPointArgs = {
  input: UpdateDataPointInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDataPointByDataSourceNameAndNameArgs = {
  input: UpdateDataPointByDataSourceNameAndNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDataPointByNodeIdArgs = {
  input: UpdateDataPointByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDependencyArgs = {
  input: UpdateDependencyInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDependencyByNodeIdArgs = {
  input: UpdateDependencyByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDependencyByPathArgs = {
  input: UpdateDependencyByPathInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDoorArgs = {
  input: UpdateDoorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDoorByFacilityIdAndLabelArgs = {
  input: UpdateDoorByFacilityIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDoorByNodeIdArgs = {
  input: UpdateDoorByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEvaporatorArgs = {
  input: UpdateEvaporatorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEvaporatorByFacilityIdAndLabelArgs = {
  input: UpdateEvaporatorByFacilityIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEvaporatorByNodeIdArgs = {
  input: UpdateEvaporatorByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFacilityArgs = {
  input: UpdateFacilityInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFacilityByNodeIdArgs = {
  input: UpdateFacilityByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFacilityBySlugArgs = {
  input: UpdateFacilityBySlugInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFacilityGroupArgs = {
  input: UpdateFacilityGroupInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFacilityGroupByNodeIdArgs = {
  input: UpdateFacilityGroupByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFacilityGroupsLinkerArgs = {
  input: UpdateFacilityGroupsLinkerInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFacilityGroupsLinkerByNodeIdArgs = {
  input: UpdateFacilityGroupsLinkerByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFacilityMutableMetricDataArgs = {
  deleteExisting?: InputMaybe<Scalars['Boolean']>;
  metricData: Array<InputFacilityMetricData>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFacilityTaggedDataPointArgs = {
  input: UpdateFacilityTaggedDataPointInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFacilityTaggedDataPointByNodeIdArgs = {
  input: UpdateFacilityTaggedDataPointByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInboundOutboundLoadArgs = {
  input: UpdateInboundOutboundLoadInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInboundOutboundLoadByFacilityIdAndDirectionAndSourceIdArgs =
  {
    input: UpdateInboundOutboundLoadByFacilityIdAndDirectionAndSourceIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInboundOutboundLoadByNodeIdArgs = {
  input: UpdateInboundOutboundLoadByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMachineUserArgs = {
  input: UpdateMachineUserInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMachineUserByNodeIdArgs = {
  input: UpdateMachineUserByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMainServiceArgs = {
  input: UpdateMainServiceInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMainServiceByFacilityIdAndNameArgs = {
  input: UpdateMainServiceByFacilityIdAndNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMainServiceByFacilityIdAndUsageDataPointIdAndDemandDataPointIdArgs =
  {
    input: UpdateMainServiceByFacilityIdAndUsageDataPointIdAndDemandDataPointIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMainServiceByNodeIdArgs = {
  input: UpdateMainServiceByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMeterChargeArgs = {
  input: UpdateMeterChargeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMeterChargeByNodeIdArgs = {
  input: UpdateMeterChargeByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMeterStatementArgs = {
  input: UpdateMeterStatementInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMeterStatementByNodeIdArgs = {
  input: UpdateMeterStatementByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMeterUsageArgs = {
  input: UpdateMeterUsageInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMeterUsageByNodeIdArgs = {
  input: UpdateMeterUsageByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMutableMetricDataArgs = {
  deleteExisting?: InputMaybe<Scalars['Boolean']>;
  metricData: Array<InputMetricData>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePalletArgs = {
  input: UpdatePalletInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePalletByNodeIdArgs = {
  input: UpdatePalletByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePalletBySourceIdArgs = {
  input: UpdatePalletBySourceIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePalletHistoryArgs = {
  input: UpdatePalletHistoryInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePalletHistoryByNodeIdArgs = {
  input: UpdatePalletHistoryByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePalletHistoryBySourceIdArgs = {
  input: UpdatePalletHistoryBySourceIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePalletLocationArgs = {
  input: UpdatePalletLocationInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePalletLocationByNodeIdArgs = {
  input: UpdatePalletLocationByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePalletLocationBySourceIdArgs = {
  input: UpdatePalletLocationBySourceIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePhoneNumberArgs = {
  input: UpdatePhoneNumberInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePricingNodeArgs = {
  input: UpdatePricingNodeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePricingNodeByNodeIdArgs = {
  input: UpdatePricingNodeByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProductArgs = {
  input: UpdateProductInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProductByNodeIdArgs = {
  input: UpdateProductByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProductBySourceIdArgs = {
  input: UpdateProductBySourceIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProgramArgs = {
  input: UpdateProgramInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProgramByNodeIdArgs = {
  input: UpdateProgramByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProgramByProjectTypeIdAndNameArgs = {
  input: UpdateProgramByProjectTypeIdAndNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProgramEnrollmentArgs = {
  input: UpdateProgramEnrollmentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProgramEnrollmentByNodeIdArgs = {
  input: UpdateProgramEnrollmentByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProgramEnrollmentByProgramIdAndNameArgs = {
  input: UpdateProgramEnrollmentByProgramIdAndNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectArgs = {
  input: UpdateProjectInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectByFacilityIdAndProgramIdArgs = {
  input: UpdateProjectByFacilityIdAndProgramIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectByNodeIdArgs = {
  input: UpdateProjectByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectComponentArgs = {
  input: UpdateProjectComponentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectComponentByNodeIdArgs = {
  input: UpdateProjectComponentByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectEnrollmentDataPointArgs = {
  input: UpdateProjectEnrollmentDataPointInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectEnrollmentDataPointByNodeIdArgs = {
  input: UpdateProjectEnrollmentDataPointByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectEnrollmentDataPointByProjectEnrollmentIdAndDataPointIdArgs =
  {
    input: UpdateProjectEnrollmentDataPointByProjectEnrollmentIdAndDataPointIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectEnrollmentDataPointGroupArgs = {
  input: UpdateProjectEnrollmentDataPointGroupInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectEnrollmentDataPointGroupByNodeIdArgs = {
  input: UpdateProjectEnrollmentDataPointGroupByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectWatcherArgs = {
  input: UpdateProjectWatcherInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectWatcherByNodeIdArgs = {
  input: UpdateProjectWatcherByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateReportExecutionArgs = {
  input: UpdateReportExecutionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateReportExecutionByNodeIdArgs = {
  input: UpdateReportExecutionByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSavingsEventArgs = {
  input: UpdateSavingsEventInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSavingsEventByNodeIdArgs = {
  input: UpdateSavingsEventByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSavingsEventByProjectIdAndStartTimeAndEndTimeArgs = {
  input: UpdateSavingsEventByProjectIdAndStartTimeAndEndTimeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSuggestionArgs = {
  input: UpdateSuggestionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSuggestionByNodeIdArgs = {
  input: UpdateSuggestionByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSuggestionControlEventArgs = {
  input: UpdateSuggestionControlEventInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSuggestionControlEventByControlEventIdArgs = {
  input: UpdateSuggestionControlEventByControlEventIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSuggestionControlEventByNodeIdArgs = {
  input: UpdateSuggestionControlEventByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTemperatureSensorArgs = {
  input: UpdateTemperatureSensorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTemperatureSensorByFacilityIdAndLabelArgs = {
  input: UpdateTemperatureSensorByFacilityIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTemperatureSensorByNodeIdArgs = {
  input: UpdateTemperatureSensorByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTrailerPositionArgs = {
  input: UpdateTrailerPositionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTrailerPositionByFacilityIdAndLabelArgs = {
  input: UpdateTrailerPositionByFacilityIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTrailerPositionByNodeIdArgs = {
  input: UpdateTrailerPositionByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserByNodeIdArgs = {
  input: UpdateUserByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUtilityAccountArgs = {
  input: UpdateUtilityAccountInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUtilityAccountByNodeIdArgs = {
  input: UpdateUtilityAccountByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUtilityMeterArgs = {
  input: UpdateUtilityMeterInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUtilityMeterByNodeIdArgs = {
  input: UpdateUtilityMeterByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUtilityProviderArgs = {
  input: UpdateUtilityProviderInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUtilityProviderByNameArgs = {
  input: UpdateUtilityProviderByNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUtilityProviderByNodeIdArgs = {
  input: UpdateUtilityProviderByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVendorUserArgs = {
  input: UpdateVendorUserInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVendorUserByEmailArgs = {
  input: UpdateVendorUserByEmailInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVendorUserByNodeIdArgs = {
  input: UpdateVendorUserByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVendorUserMachineUserArgs = {
  input: UpdateVendorUserMachineUserInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVendorUserMachineUserByMachineUserIdArgs = {
  input: UpdateVendorUserMachineUserByMachineUserIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVendorUserMachineUserByNodeIdArgs = {
  input: UpdateVendorUserMachineUserByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVirtualPointIntervalArgs = {
  input: UpdateVirtualPointIntervalInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVirtualPointIntervalByNodeIdArgs = {
  input: UpdateVirtualPointIntervalByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertAccountChargeArgs = {
  input: UpsertAccountChargeInput;
  where?: InputMaybe<UpsertAccountChargeWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertAccountStatementArgs = {
  input: UpsertAccountStatementInput;
  where?: InputMaybe<UpsertAccountStatementWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertAccountStatementPdfArgs = {
  input: UpsertAccountStatementPdfInput;
  where?: InputMaybe<UpsertAccountStatementPdfWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertBalancingAuthorityArgs = {
  input: UpsertBalancingAuthorityInput;
  where?: InputMaybe<UpsertBalancingAuthorityWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertBlastArgs = {
  input: UpsertBlastInput;
  where?: InputMaybe<UpsertBlastWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertBlastEvaporatorArgs = {
  input: UpsertBlastEvaporatorInput;
  where?: InputMaybe<UpsertBlastEvaporatorWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertBlastPalletArgs = {
  input: UpsertBlastPalletInput;
  where?: InputMaybe<UpsertBlastPalletWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertBlastPalletLocationArgs = {
  input: UpsertBlastPalletLocationInput;
  where?: InputMaybe<UpsertBlastPalletLocationWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertBlastRotationArgs = {
  input: UpsertBlastRotationInput;
  where?: InputMaybe<UpsertBlastRotationWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertBlastRotationAlertArgs = {
  input: UpsertBlastRotationAlertInput;
  where?: InputMaybe<UpsertBlastRotationAlertWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertBlastRotationEventLogArgs = {
  input: UpsertBlastRotationEventLogInput;
  where?: InputMaybe<UpsertBlastRotationEventLogWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertBlastRotationEventTypeArgs = {
  input: UpsertBlastRotationEventTypeInput;
  where?: InputMaybe<UpsertBlastRotationEventTypeWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertBlastRotationPalletArgs = {
  input: UpsertBlastRotationPalletInput;
  where?: InputMaybe<UpsertBlastRotationPalletWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertBlastTypeArgs = {
  input: UpsertBlastTypeInput;
  where?: InputMaybe<UpsertBlastTypeWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertBuildingAreaArgs = {
  input: UpsertBuildingAreaInput;
  where?: InputMaybe<UpsertBuildingAreaWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertBuildingAreaComplianceGroupArgs = {
  input: UpsertBuildingAreaComplianceGroupInput;
  where?: InputMaybe<UpsertBuildingAreaComplianceGroupWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertBuildingAreaTypeArgs = {
  input: UpsertBuildingAreaTypeInput;
  where?: InputMaybe<UpsertBuildingAreaTypeWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertChartArgs = {
  input: UpsertChartInput;
  where?: InputMaybe<UpsertChartWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertComplianceGroupArgs = {
  input: UpsertComplianceGroupInput;
  where?: InputMaybe<UpsertComplianceGroupWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertComplianceRangeArgs = {
  input: UpsertComplianceRangeInput;
  where?: InputMaybe<UpsertComplianceRangeWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertCompressorArgs = {
  input: UpsertCompressorInput;
  where?: InputMaybe<UpsertCompressorWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertCustomerArgs = {
  input: UpsertCustomerInput;
  where?: InputMaybe<UpsertCustomerWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertDashboardArgs = {
  input: UpsertDashboardInput;
  where?: InputMaybe<UpsertDashboardWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertDataPointArgs = {
  input: UpsertDataPointInput;
  where?: InputMaybe<UpsertDataPointWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertDependencyArgs = {
  input: UpsertDependencyInput;
  where?: InputMaybe<UpsertDependencyWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertDoorArgs = {
  input: UpsertDoorInput;
  where?: InputMaybe<UpsertDoorWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertEvaporatorArgs = {
  input: UpsertEvaporatorInput;
  where?: InputMaybe<UpsertEvaporatorWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertFacilityTaggedDataPointArgs = {
  input: UpsertFacilityTaggedDataPointInput;
  where?: InputMaybe<UpsertFacilityTaggedDataPointWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertInboundOutboundLoadArgs = {
  input: UpsertInboundOutboundLoadInput;
  where?: InputMaybe<UpsertInboundOutboundLoadWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertMachineUserArgs = {
  input: UpsertMachineUserInput;
  where?: InputMaybe<UpsertMachineUserWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertMainServiceArgs = {
  input: UpsertMainServiceInput;
  where?: InputMaybe<UpsertMainServiceWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertMeterChargeArgs = {
  input: UpsertMeterChargeInput;
  where?: InputMaybe<UpsertMeterChargeWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertMeterStatementArgs = {
  input: UpsertMeterStatementInput;
  where?: InputMaybe<UpsertMeterStatementWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertMeterUsageArgs = {
  input: UpsertMeterUsageInput;
  where?: InputMaybe<UpsertMeterUsageWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertPalletArgs = {
  input: UpsertPalletInput;
  where?: InputMaybe<UpsertPalletWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertPalletHistoryArgs = {
  input: UpsertPalletHistoryInput;
  where?: InputMaybe<UpsertPalletHistoryWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertPalletLocationArgs = {
  input: UpsertPalletLocationInput;
  where?: InputMaybe<UpsertPalletLocationWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertPricingNodeArgs = {
  input: UpsertPricingNodeInput;
  where?: InputMaybe<UpsertPricingNodeWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertProductArgs = {
  input: UpsertProductInput;
  where?: InputMaybe<UpsertProductWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertProgramArgs = {
  input: UpsertProgramInput;
  where?: InputMaybe<UpsertProgramWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertProgramEnrollmentArgs = {
  input: UpsertProgramEnrollmentInput;
  where?: InputMaybe<UpsertProgramEnrollmentWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertProjectComponentArgs = {
  input: UpsertProjectComponentInput;
  where?: InputMaybe<UpsertProjectComponentWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertProjectEnrollmentArgs = {
  input: UpsertProjectEnrollmentInput;
  where?: InputMaybe<UpsertProjectEnrollmentWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertProjectEnrollmentDataPointArgs = {
  input: UpsertProjectEnrollmentDataPointInput;
  where?: InputMaybe<UpsertProjectEnrollmentDataPointWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertProjectEnrollmentDataPointGroupArgs = {
  input: UpsertProjectEnrollmentDataPointGroupInput;
  where?: InputMaybe<UpsertProjectEnrollmentDataPointGroupWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertProjectSubscriptionArgs = {
  input: UpsertProjectSubscriptionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertProjectWatcherArgs = {
  input: UpsertProjectWatcherInput;
  where?: InputMaybe<UpsertProjectWatcherWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertReportExecutionArgs = {
  input: UpsertReportExecutionInput;
  where?: InputMaybe<UpsertReportExecutionWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertReportQueryArgs = {
  input: UpsertReportQueryInput;
  where?: InputMaybe<UpsertReportQueryWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertSavingsEventArgs = {
  input: UpsertSavingsEventInput;
  where?: InputMaybe<UpsertSavingsEventWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertSuggestionControlEventArgs = {
  input: UpsertSuggestionControlEventInput;
  where?: InputMaybe<UpsertSuggestionControlEventWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertTemperatureSensorArgs = {
  input: UpsertTemperatureSensorInput;
  where?: InputMaybe<UpsertTemperatureSensorWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertTrailerPositionArgs = {
  input: UpsertTrailerPositionInput;
  where?: InputMaybe<UpsertTrailerPositionWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertUrjanetUtilityProviderArgs = {
  input: UpsertUrjanetUtilityProviderInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertUtilityAccountArgs = {
  input: UpsertUtilityAccountInput;
  where?: InputMaybe<UpsertUtilityAccountWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertUtilityMeterArgs = {
  input: UpsertUtilityMeterInput;
  where?: InputMaybe<UpsertUtilityMeterWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertUtilityProviderArgs = {
  input: UpsertUtilityProviderInput;
  where?: InputMaybe<UpsertUtilityProviderWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertVendorUserMachineUserArgs = {
  input: UpsertVendorUserMachineUserInput;
  where?: InputMaybe<UpsertVendorUserMachineUserWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertVirtualPointIntervalArgs = {
  input: UpsertVirtualPointIntervalInput;
  where?: InputMaybe<UpsertVirtualPointIntervalWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationWithdrawSuggestionArgs = {
  input: WithdrawSuggestionInput;
};

/** An object with a globally unique `ID`. */
export type Node = {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']>;
};

export type Pallet = Node & {
  __typename?: 'Pallet';
  /** An alternate pallet code that could be sourced from other codes */
  alternatePalletCode?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `BlastPallet`. */
  blastPallets: BlastPalletsConnection;
  /** Reads and enables pagination through a set of `BlastRotationPallet`. */
  blastRotationPallets: BlastRotationPalletsConnection;
  /** The time at which the record was created */
  createdAt: Scalars['Datetime'];
  /** The current number of product cases on a pallet */
  currentProductQuantity?: Maybe<Scalars['Int']>;
  /** The globally unique external deletion identifier of the record. Sometimes this is different from sourceId due to change tracking semantics */
  deleteId?: Maybe<Scalars['String']>;
  /** The time at which the record was deleted */
  deletedAt?: Maybe<Scalars['Datetime']>;
  /** The date the pallet was emptied or left the warehouse */
  depletedDate?: Maybe<Scalars['Datetime']>;
  /** The originating facility of the pallet record */
  facilityId?: Maybe<Scalars['Int']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['BigInt'];
  /** The inventory status of a pallet -- expected, in the warehouse, etc. */
  inventoryStatus?: Maybe<Scalars['String']>;
  /** Boolean value indicated if the pallet is empty or left the facility */
  isDepleted?: Maybe<Scalars['Boolean']>;
  location?: Maybe<PalletLocation>;
  /** Metadata information for a pallet */
  metadata: Scalars['JSON'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The original number of product cases (or other UOM) that were on a pallet when brought into the facility */
  originalProductQuantity?: Maybe<Scalars['Int']>;
  /** The primary pallet code (not globally unique) of the pallet. Also known as the pallet license plate number */
  palletCode?: Maybe<Scalars['String']>;
  /** The number of pallets a record corresponds to. In some cases, a single pallet record is used for multiple pallets */
  palletCount?: Maybe<Scalars['Int']>;
  /** The location of a pallet within the facility */
  palletLocationSourceId?: Maybe<Scalars['String']>;
  /** The date the pallet was received by the warehouse */
  palletReceivedDate?: Maybe<Scalars['Datetime']>;
  product?: Maybe<Product>;
  /** The product a pallet has on it */
  productSourceId?: Maybe<Scalars['String']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String'];
  /** The time at which the record was updated */
  updatedAt: Scalars['Datetime'];
  /** The version of the record */
  version?: Maybe<Scalars['BigInt']>;
};

export type PalletBlastPalletsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BlastPalletCondition>;
  filter?: InputMaybe<BlastPalletFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BlastPalletsOrderBy>>;
};

export type PalletBlastRotationPalletsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BlastRotationPalletCondition>;
  filter?: InputMaybe<BlastRotationPalletFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BlastRotationPalletsOrderBy>>;
};

/** A condition to be used against `Pallet` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type PalletCondition = {
  /** Checks for equality with the object’s `alternatePalletCode` field. */
  alternatePalletCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `currentProductQuantity` field. */
  currentProductQuantity?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `deleteId` field. */
  deleteId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `depletedDate` field. */
  depletedDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `inventoryStatus` field. */
  inventoryStatus?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `isDepleted` field. */
  isDepleted?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `originalProductQuantity` field. */
  originalProductQuantity?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `palletCode` field. */
  palletCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `palletCount` field. */
  palletCount?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `palletLocationSourceId` field. */
  palletLocationSourceId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `palletReceivedDate` field. */
  palletReceivedDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `productSourceId` field. */
  productSourceId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `sourceId` field. */
  sourceId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `version` field. */
  version?: InputMaybe<Scalars['BigInt']>;
};

/** A filter to be used against `Pallet` object types. All fields are combined with a logical ‘and.’ */
export type PalletFilter = {
  /** Filter by the object’s `alternatePalletCode` field. */
  alternatePalletCode?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PalletFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `currentProductQuantity` field. */
  currentProductQuantity?: InputMaybe<IntFilter>;
  /** Filter by the object’s `deleteId` field. */
  deleteId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `depletedDate` field. */
  depletedDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `inventoryStatus` field. */
  inventoryStatus?: InputMaybe<StringFilter>;
  /** Filter by the object’s `isDepleted` field. */
  isDepleted?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PalletFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PalletFilter>>;
  /** Filter by the object’s `originalProductQuantity` field. */
  originalProductQuantity?: InputMaybe<IntFilter>;
  /** Filter by the object’s `palletCode` field. */
  palletCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `palletCount` field. */
  palletCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `palletLocationSourceId` field. */
  palletLocationSourceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `palletReceivedDate` field. */
  palletReceivedDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `productSourceId` field. */
  productSourceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `sourceId` field. */
  sourceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `version` field. */
  version?: InputMaybe<BigIntFilter>;
};

/** A connection to a list of `PalletHistory` values. */
export type PalletHistoriesConnection = {
  __typename?: 'PalletHistoriesConnection';
  /** A list of edges which contains the `PalletHistory` and cursor to aid in pagination. */
  edges: Array<PalletHistoriesEdge>;
  /** A list of `PalletHistory` objects. */
  nodes: Array<PalletHistory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PalletHistory` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PalletHistory` edge in the connection. */
export type PalletHistoriesEdge = {
  __typename?: 'PalletHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PalletHistory` at the end of the edge. */
  node: PalletHistory;
};

/** Methods to use when ordering `PalletHistory`. */
export enum PalletHistoriesOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DELETED_AT_ASC = 'DELETED_AT_ASC',
  DELETED_AT_DESC = 'DELETED_AT_DESC',
  DELETE_ID_ASC = 'DELETE_ID_ASC',
  DELETE_ID_DESC = 'DELETE_ID_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  FROM_PALLET_LOCATION_CODE_ASC = 'FROM_PALLET_LOCATION_CODE_ASC',
  FROM_PALLET_LOCATION_CODE_DESC = 'FROM_PALLET_LOCATION_CODE_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PALLET_CODE_ASC = 'PALLET_CODE_ASC',
  PALLET_CODE_DESC = 'PALLET_CODE_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  QUANTITY_ASC = 'QUANTITY_ASC',
  QUANTITY_DESC = 'QUANTITY_DESC',
  SOURCE_ID_ASC = 'SOURCE_ID_ASC',
  SOURCE_ID_DESC = 'SOURCE_ID_DESC',
  TO_PALLET_LOCATION_CODE_ASC = 'TO_PALLET_LOCATION_CODE_ASC',
  TO_PALLET_LOCATION_CODE_DESC = 'TO_PALLET_LOCATION_CODE_DESC',
  TRANSACTION_DATE_ASC = 'TRANSACTION_DATE_ASC',
  TRANSACTION_DATE_DESC = 'TRANSACTION_DATE_DESC',
  TRANSACTION_TYPE_ASC = 'TRANSACTION_TYPE_ASC',
  TRANSACTION_TYPE_DESC = 'TRANSACTION_TYPE_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VERSION_ASC = 'VERSION_ASC',
  VERSION_DESC = 'VERSION_DESC'
}

export type PalletHistory = Node & {
  __typename?: 'PalletHistory';
  /** The time at which the record was created */
  createdAt: Scalars['Datetime'];
  /** The globally unique external deletion identifier of the record. Sometimes this is different from sourceId due to change tracking semantics */
  deleteId?: Maybe<Scalars['String']>;
  /** The time at which the record was deleted */
  deletedAt?: Maybe<Scalars['Datetime']>;
  /** The originating facility of the history record */
  facilityId?: Maybe<Scalars['Int']>;
  /** If moving locations, this is the location it is being moved from */
  fromPalletLocationCode?: Maybe<Scalars['String']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['BigInt'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The unique local (facility-level) identifier of the pallet. Note this is not the pallet_source_id */
  palletCode?: Maybe<Scalars['String']>;
  /** The quantity of the product UOM this transaction applies to */
  quantity?: Maybe<Scalars['Int']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String'];
  /** If moving locations, this is the location it is being moved to */
  toPalletLocationCode?: Maybe<Scalars['String']>;
  /** The timestamp of the pallet event */
  transactionDate?: Maybe<Scalars['Datetime']>;
  /** The type of pallet event / transaction for this record */
  transactionType?: Maybe<Scalars['String']>;
  /** The time at which the record was updated */
  updatedAt: Scalars['Datetime'];
  /** The version of the record */
  version?: Maybe<Scalars['BigInt']>;
};

/**
 * A condition to be used against `PalletHistory` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PalletHistoryCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deleteId` field. */
  deleteId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `fromPalletLocationCode` field. */
  fromPalletLocationCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `palletCode` field. */
  palletCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `quantity` field. */
  quantity?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `sourceId` field. */
  sourceId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `toPalletLocationCode` field. */
  toPalletLocationCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `transactionDate` field. */
  transactionDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `transactionType` field. */
  transactionType?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `version` field. */
  version?: InputMaybe<Scalars['BigInt']>;
};

/** A filter to be used against `PalletHistory` object types. All fields are combined with a logical ‘and.’ */
export type PalletHistoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PalletHistoryFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deleteId` field. */
  deleteId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `fromPalletLocationCode` field. */
  fromPalletLocationCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PalletHistoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PalletHistoryFilter>>;
  /** Filter by the object’s `palletCode` field. */
  palletCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `quantity` field. */
  quantity?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sourceId` field. */
  sourceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `toPalletLocationCode` field. */
  toPalletLocationCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `transactionDate` field. */
  transactionDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `transactionType` field. */
  transactionType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `version` field. */
  version?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `PalletHistory` */
export type PalletHistoryInput = {
  /** The originating facility of the history record */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** If moving locations, this is the location it is being moved from */
  fromPalletLocationCode?: InputMaybe<Scalars['String']>;
  /** The unique local (facility-level) identifier of the pallet. Note this is not the pallet_source_id */
  palletCode?: InputMaybe<Scalars['String']>;
  /** The quantity of the product UOM this transaction applies to */
  quantity?: InputMaybe<Scalars['Int']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String'];
  /** If moving locations, this is the location it is being moved to */
  toPalletLocationCode?: InputMaybe<Scalars['String']>;
  /** The timestamp of the pallet event */
  transactionDate?: InputMaybe<Scalars['Datetime']>;
  /** The type of pallet event / transaction for this record */
  transactionType?: InputMaybe<Scalars['String']>;
};

/** Represents an update to a `PalletHistory`. Fields that are set will be updated. */
export type PalletHistoryPatch = {
  /** The originating facility of the history record */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** If moving locations, this is the location it is being moved from */
  fromPalletLocationCode?: InputMaybe<Scalars['String']>;
  /** The unique local (facility-level) identifier of the pallet. Note this is not the pallet_source_id */
  palletCode?: InputMaybe<Scalars['String']>;
  /** The quantity of the product UOM this transaction applies to */
  quantity?: InputMaybe<Scalars['Int']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId?: InputMaybe<Scalars['String']>;
  /** If moving locations, this is the location it is being moved to */
  toPalletLocationCode?: InputMaybe<Scalars['String']>;
  /** The timestamp of the pallet event */
  transactionDate?: InputMaybe<Scalars['Datetime']>;
  /** The type of pallet event / transaction for this record */
  transactionType?: InputMaybe<Scalars['String']>;
};

/** An input for mutations affecting `Pallet` */
export type PalletInput = {
  /** An alternate pallet code that could be sourced from other codes */
  alternatePalletCode?: InputMaybe<Scalars['String']>;
  /** The current number of product cases on a pallet */
  currentProductQuantity?: InputMaybe<Scalars['Int']>;
  /** The date the pallet was emptied or left the warehouse */
  depletedDate?: InputMaybe<Scalars['Datetime']>;
  /** The originating facility of the pallet record */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** The inventory status of a pallet -- expected, in the warehouse, etc. */
  inventoryStatus?: InputMaybe<Scalars['String']>;
  /** Boolean value indicated if the pallet is empty or left the facility */
  isDepleted?: InputMaybe<Scalars['Boolean']>;
  /** Metadata information for a pallet */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** The original number of product cases (or other UOM) that were on a pallet when brought into the facility */
  originalProductQuantity?: InputMaybe<Scalars['Int']>;
  /** The primary pallet code (not globally unique) of the pallet. Also known as the pallet license plate number */
  palletCode?: InputMaybe<Scalars['String']>;
  /** The number of pallets a record corresponds to. In some cases, a single pallet record is used for multiple pallets */
  palletCount?: InputMaybe<Scalars['Int']>;
  /** The location of a pallet within the facility */
  palletLocationSourceId?: InputMaybe<Scalars['String']>;
  /** The date the pallet was received by the warehouse */
  palletReceivedDate?: InputMaybe<Scalars['Datetime']>;
  /** The product a pallet has on it */
  productSourceId?: InputMaybe<Scalars['String']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String'];
};

export type PalletLocation = Node & {
  __typename?: 'PalletLocation';
  /** The aisle the location is located on */
  aisle?: Maybe<Scalars['String']>;
  /** The bay the location is located within */
  bay?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `BlastPalletLocation`. */
  blastPalletLocations: BlastPalletLocationsConnection;
  /** Reads a single `BuildingArea` that is related to this `PalletLocation`. */
  buildingArea?: Maybe<BuildingArea>;
  /** The associated building area */
  buildingAreaId?: Maybe<Scalars['Int']>;
  /** The time at which the record was created */
  createdAt: Scalars['Datetime'];
  /** The globally unique external deletion identifier of the record. Sometimes this is different from sourceId due to change tracking semantics */
  deleteId?: Maybe<Scalars['String']>;
  /** The time at which the record was deleted */
  deletedAt?: Maybe<Scalars['Datetime']>;
  /** Reads a single `Facility` that is related to this `PalletLocation`. */
  facility?: Maybe<Facility>;
  /** The facility of the location record */
  facilityId?: Maybe<Scalars['Int']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['BigInt'];
  /** The maximum number of pallets that can be stored at this location */
  maxPallets?: Maybe<Scalars['Int']>;
  /** The name / descriptor of the location */
  name?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The type of the room the location is within */
  roomType?: Maybe<Scalars['String']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String'];
  /** The time at which the record was updated */
  updatedAt: Scalars['Datetime'];
  /** The version of the record */
  version?: Maybe<Scalars['BigInt']>;
};

export type PalletLocationBlastPalletLocationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BlastPalletLocationCondition>;
  filter?: InputMaybe<BlastPalletLocationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BlastPalletLocationsOrderBy>>;
};

/**
 * A condition to be used against `PalletLocation` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PalletLocationCondition = {
  /** Checks for equality with the object’s `aisle` field. */
  aisle?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `bay` field. */
  bay?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `buildingAreaId` field. */
  buildingAreaId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deleteId` field. */
  deleteId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `maxPallets` field. */
  maxPallets?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `roomType` field. */
  roomType?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `sourceId` field. */
  sourceId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `version` field. */
  version?: InputMaybe<Scalars['BigInt']>;
};

/** A filter to be used against `PalletLocation` object types. All fields are combined with a logical ‘and.’ */
export type PalletLocationFilter = {
  /** Filter by the object’s `aisle` field. */
  aisle?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PalletLocationFilter>>;
  /** Filter by the object’s `bay` field. */
  bay?: InputMaybe<StringFilter>;
  /** Filter by the object’s `buildingAreaId` field. */
  buildingAreaId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deleteId` field. */
  deleteId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `maxPallets` field. */
  maxPallets?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PalletLocationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PalletLocationFilter>>;
  /** Filter by the object’s `roomType` field. */
  roomType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `sourceId` field. */
  sourceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `version` field. */
  version?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `PalletLocation` */
export type PalletLocationInput = {
  /** The aisle the location is located on */
  aisle?: InputMaybe<Scalars['String']>;
  /** The bay the location is located within */
  bay?: InputMaybe<Scalars['String']>;
  /** Mutates a `BuildingArea` as part of the payload */
  buildingArea?: InputMaybe<BuildingAreaInput>;
  /** The associated building area */
  buildingAreaId?: InputMaybe<Scalars['Int']>;
  /** The facility of the location record */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** The maximum number of pallets that can be stored at this location */
  maxPallets?: InputMaybe<Scalars['Int']>;
  /** The name / descriptor of the location */
  name?: InputMaybe<Scalars['String']>;
  /** The type of the room the location is within */
  roomType?: InputMaybe<Scalars['String']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String'];
};

/** Represents an update to a `PalletLocation`. Fields that are set will be updated. */
export type PalletLocationPatch = {
  /** The aisle the location is located on */
  aisle?: InputMaybe<Scalars['String']>;
  /** The bay the location is located within */
  bay?: InputMaybe<Scalars['String']>;
  /** The associated building area */
  buildingAreaId?: InputMaybe<Scalars['Int']>;
  /** The facility of the location record */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** The maximum number of pallets that can be stored at this location */
  maxPallets?: InputMaybe<Scalars['Int']>;
  /** The name / descriptor of the location */
  name?: InputMaybe<Scalars['String']>;
  /** The type of the room the location is within */
  roomType?: InputMaybe<Scalars['String']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `PalletLocation` values. */
export type PalletLocationsConnection = {
  __typename?: 'PalletLocationsConnection';
  /** A list of edges which contains the `PalletLocation` and cursor to aid in pagination. */
  edges: Array<PalletLocationsEdge>;
  /** A list of `PalletLocation` objects. */
  nodes: Array<PalletLocation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PalletLocation` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PalletLocation` edge in the connection. */
export type PalletLocationsEdge = {
  __typename?: 'PalletLocationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PalletLocation` at the end of the edge. */
  node: PalletLocation;
};

/** Methods to use when ordering `PalletLocation`. */
export enum PalletLocationsOrderBy {
  AISLE_ASC = 'AISLE_ASC',
  AISLE_DESC = 'AISLE_DESC',
  BAY_ASC = 'BAY_ASC',
  BAY_DESC = 'BAY_DESC',
  BUILDING_AREA_ID_ASC = 'BUILDING_AREA_ID_ASC',
  BUILDING_AREA_ID_DESC = 'BUILDING_AREA_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DELETED_AT_ASC = 'DELETED_AT_ASC',
  DELETED_AT_DESC = 'DELETED_AT_DESC',
  DELETE_ID_ASC = 'DELETE_ID_ASC',
  DELETE_ID_DESC = 'DELETE_ID_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  MAX_PALLETS_ASC = 'MAX_PALLETS_ASC',
  MAX_PALLETS_DESC = 'MAX_PALLETS_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOM_TYPE_ASC = 'ROOM_TYPE_ASC',
  ROOM_TYPE_DESC = 'ROOM_TYPE_DESC',
  SOURCE_ID_ASC = 'SOURCE_ID_ASC',
  SOURCE_ID_DESC = 'SOURCE_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VERSION_ASC = 'VERSION_ASC',
  VERSION_DESC = 'VERSION_DESC'
}

/** Represents an update to a `Pallet`. Fields that are set will be updated. */
export type PalletPatch = {
  /** An alternate pallet code that could be sourced from other codes */
  alternatePalletCode?: InputMaybe<Scalars['String']>;
  /** The current number of product cases on a pallet */
  currentProductQuantity?: InputMaybe<Scalars['Int']>;
  /** The date the pallet was emptied or left the warehouse */
  depletedDate?: InputMaybe<Scalars['Datetime']>;
  /** The originating facility of the pallet record */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** The inventory status of a pallet -- expected, in the warehouse, etc. */
  inventoryStatus?: InputMaybe<Scalars['String']>;
  /** Boolean value indicated if the pallet is empty or left the facility */
  isDepleted?: InputMaybe<Scalars['Boolean']>;
  /** Metadata information for a pallet */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** The original number of product cases (or other UOM) that were on a pallet when brought into the facility */
  originalProductQuantity?: InputMaybe<Scalars['Int']>;
  /** The primary pallet code (not globally unique) of the pallet. Also known as the pallet license plate number */
  palletCode?: InputMaybe<Scalars['String']>;
  /** The number of pallets a record corresponds to. In some cases, a single pallet record is used for multiple pallets */
  palletCount?: InputMaybe<Scalars['Int']>;
  /** The location of a pallet within the facility */
  palletLocationSourceId?: InputMaybe<Scalars['String']>;
  /** The date the pallet was received by the warehouse */
  palletReceivedDate?: InputMaybe<Scalars['Datetime']>;
  /** The product a pallet has on it */
  productSourceId?: InputMaybe<Scalars['String']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `Pallet` values. */
export type PalletsConnection = {
  __typename?: 'PalletsConnection';
  /** A list of edges which contains the `Pallet` and cursor to aid in pagination. */
  edges: Array<PalletsEdge>;
  /** A list of `Pallet` objects. */
  nodes: Array<Pallet>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Pallet` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Pallet` edge in the connection. */
export type PalletsEdge = {
  __typename?: 'PalletsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Pallet` at the end of the edge. */
  node: Pallet;
};

/** Methods to use when ordering `Pallet`. */
export enum PalletsOrderBy {
  ALTERNATE_PALLET_CODE_ASC = 'ALTERNATE_PALLET_CODE_ASC',
  ALTERNATE_PALLET_CODE_DESC = 'ALTERNATE_PALLET_CODE_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CURRENT_PRODUCT_QUANTITY_ASC = 'CURRENT_PRODUCT_QUANTITY_ASC',
  CURRENT_PRODUCT_QUANTITY_DESC = 'CURRENT_PRODUCT_QUANTITY_DESC',
  DELETED_AT_ASC = 'DELETED_AT_ASC',
  DELETED_AT_DESC = 'DELETED_AT_DESC',
  DELETE_ID_ASC = 'DELETE_ID_ASC',
  DELETE_ID_DESC = 'DELETE_ID_DESC',
  DEPLETED_DATE_ASC = 'DEPLETED_DATE_ASC',
  DEPLETED_DATE_DESC = 'DEPLETED_DATE_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  INVENTORY_STATUS_ASC = 'INVENTORY_STATUS_ASC',
  INVENTORY_STATUS_DESC = 'INVENTORY_STATUS_DESC',
  IS_DEPLETED_ASC = 'IS_DEPLETED_ASC',
  IS_DEPLETED_DESC = 'IS_DEPLETED_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  NATURAL = 'NATURAL',
  ORIGINAL_PRODUCT_QUANTITY_ASC = 'ORIGINAL_PRODUCT_QUANTITY_ASC',
  ORIGINAL_PRODUCT_QUANTITY_DESC = 'ORIGINAL_PRODUCT_QUANTITY_DESC',
  PALLET_CODE_ASC = 'PALLET_CODE_ASC',
  PALLET_CODE_DESC = 'PALLET_CODE_DESC',
  PALLET_COUNT_ASC = 'PALLET_COUNT_ASC',
  PALLET_COUNT_DESC = 'PALLET_COUNT_DESC',
  PALLET_LOCATION_SOURCE_ID_ASC = 'PALLET_LOCATION_SOURCE_ID_ASC',
  PALLET_LOCATION_SOURCE_ID_DESC = 'PALLET_LOCATION_SOURCE_ID_DESC',
  PALLET_RECEIVED_DATE_ASC = 'PALLET_RECEIVED_DATE_ASC',
  PALLET_RECEIVED_DATE_DESC = 'PALLET_RECEIVED_DATE_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PRODUCT_SOURCE_ID_ASC = 'PRODUCT_SOURCE_ID_ASC',
  PRODUCT_SOURCE_ID_DESC = 'PRODUCT_SOURCE_ID_DESC',
  SOURCE_ID_ASC = 'SOURCE_ID_ASC',
  SOURCE_ID_DESC = 'SOURCE_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VERSION_ASC = 'VERSION_ASC',
  VERSION_DESC = 'VERSION_DESC'
}

/** All input for the `patchControlEventRemoteMetadata` mutation. */
export type PatchControlEventRemoteMetadataInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  controlEventId: Scalars['Int'];
  patchedMetadata: Scalars['JSON'];
};

/** The output of our `patchControlEventRemoteMetadata` mutation. */
export type PatchControlEventRemoteMetadataPayload = {
  __typename?: 'PatchControlEventRemoteMetadataPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Component` that is related to this `ControlEvent`. */
  component?: Maybe<Component>;
  controlEvent?: Maybe<ControlEvent>;
  /** An edge for our `ControlEvent`. May be used by Relay 1. */
  controlEventEdge?: Maybe<ControlEventsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our `patchControlEventRemoteMetadata` mutation. */
export type PatchControlEventRemoteMetadataPayloadControlEventEdgeArgs = {
  orderBy?: InputMaybe<Array<ControlEventsOrderBy>>;
};

/** A filter to be used against boolean permission fields. */
export type PermissionBooleanFilter = {
  equalTo?: InputMaybe<Scalars['Boolean']>;
};

/** Represents an access token for a given type. */
export type PlatformAccessToken = {
  __typename?: 'PlatformAccessToken';
  createdAt?: Maybe<Scalars['Datetime']>;
  description?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['Datetime']>;
  id?: Maybe<Scalars['BigInt']>;
  /** Returns the associated machine user if this is a machine user access token. */
  machineUser?: Maybe<MachineUser>;
  ownerId?: Maybe<Scalars['String']>;
  type?: Maybe<AccessTokenType>;
  /** Returns the associated user if this is a user access token. */
  user?: Maybe<User>;
};

/**
 * A condition to be used against `PlatformAccessToken` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type PlatformAccessTokenCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `expiresAt` field. */
  expiresAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `ownerId` field. */
  ownerId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<AccessTokenType>;
};

/** A filter to be used against `PlatformAccessToken` object types. All fields are combined with a logical ‘and.’ */
export type PlatformAccessTokenFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PlatformAccessTokenFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `expiresAt` field. */
  expiresAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PlatformAccessTokenFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PlatformAccessTokenFilter>>;
  /** Filter by the object’s `ownerId` field. */
  ownerId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<AccessTokenTypeFilter>;
};

/** A connection to a list of `PlatformAccessToken` values. */
export type PlatformAccessTokensConnection = {
  __typename?: 'PlatformAccessTokensConnection';
  /** A list of edges which contains the `PlatformAccessToken` and cursor to aid in pagination. */
  edges: Array<PlatformAccessTokensEdge>;
  /** A list of `PlatformAccessToken` objects. */
  nodes: Array<PlatformAccessToken>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PlatformAccessToken` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PlatformAccessToken` edge in the connection. */
export type PlatformAccessTokensEdge = {
  __typename?: 'PlatformAccessTokensEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PlatformAccessToken` at the end of the edge. */
  node: PlatformAccessToken;
};

/** Methods to use when ordering `PlatformAccessToken`. */
export enum PlatformAccessTokensOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  EXPIRES_AT_ASC = 'EXPIRES_AT_ASC',
  EXPIRES_AT_DESC = 'EXPIRES_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  OWNER_ID_ASC = 'OWNER_ID_ASC',
  OWNER_ID_DESC = 'OWNER_ID_DESC',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC'
}

export enum PlatformCapability {
  BASE = 'BASE',
  FLEET = 'FLEET',
  IOT = 'IOT',
  METRIC = 'METRIC',
  SUGGESTION = 'SUGGESTION',
  UTILITY = 'UTILITY',
  WMS = 'WMS'
}

export type PlatformCapabilityAccess = {
  __typename?: 'PlatformCapabilityAccess';
  canRead: Scalars['Boolean'];
  canWrite: Scalars['Boolean'];
  capability: PlatformCapability;
};

export type PlatformCapabilityAccessDefinition = {
  capability: PlatformCapability;
  enableRead: Scalars['Boolean'];
  enableWrite: Scalars['Boolean'];
};

/** Platform errors that can be received as part of query/mutation responses */
export enum PlatformError {
  /** An error occurred while handling the data request. */
  BAD_DATA_ERROR = 'BAD_DATA_ERROR',
  /** The GraphQL request contains a format error. */
  BAD_REQUEST_ERROR = 'BAD_REQUEST_ERROR',
  /** An entity already exists for the given parameters. */
  DUPLICATE_ENTRY_ERROR = 'DUPLICATE_ENTRY_ERROR',
  /** An fleet messaging error has occured. */
  FLEET_SMS_ERROR = 'FLEET_SMS_ERROR',
  /** The request cannot be completed due to incompatible data. */
  INCOMPATIBLE_DATA_ERROR = 'INCOMPATIBLE_DATA_ERROR',
  /** An internal server error has occurred. */
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  /** One or more input values are invalid. */
  INVALID_INPUT_ERROR = 'INVALID_INPUT_ERROR',
  /** One or more report parameters were not valid. */
  INVALID_REPORT_PARAMETERS = 'INVALID_REPORT_PARAMETERS',
  /** Entity not found. */
  NOT_FOUND_ERROR = 'NOT_FOUND_ERROR',
  /** Amount of data requested supercedes allowed amount - try again with pagination. */
  REQUEST_LIMIT_ERROR = 'REQUEST_LIMIT_ERROR',
  /** An error occured while validating phone number. */
  SMS_VALIDATION_ERROR = 'SMS_VALIDATION_ERROR',
  /** Unauthorized */
  UNAUTHORIZED_ERROR = 'UNAUTHORIZED_ERROR',
  /** An unknown server error has occurred. */
  UNKNOWN_ERROR = 'UNKNOWN_ERROR'
}

/** A pricing node in a balancing authority. */
export type PricingNode = Node & {
  __typename?: 'PricingNode';
  /** Reads a single `BalancingAuthority` that is related to this `PricingNode`. */
  balancingAuthority?: Maybe<BalancingAuthority>;
  /** The id of the balancing authority the pricing node is associated with. */
  balancingAuthorityId: Scalars['Int'];
  /** The time the pricing node was created. */
  createdAt: Scalars['Datetime'];
  /** The dayahead rate for the associated pricing node. */
  dayaheadRate?: Maybe<MetricDataConnection>;
  /** Reads and enables pagination through a set of `Facility`. */
  facilities: FacilitiesConnection;
  /** The geometry information of the pricing node. */
  geometry?: Maybe<GeometryInterface>;
  /** The grid demand value for the associated balancing authority. */
  gridDemand?: Maybe<MetricDataConnection>;
  /** The identifer of the pricing node. */
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The realtime rate for the associated pricing node. */
  realtimeRate?: Maybe<MetricDataConnection>;
  /** The name of the pricing node. */
  slug: Scalars['String'];
  /** The time the pricing node was updated. */
  updatedAt: Scalars['Datetime'];
};

/** A pricing node in a balancing authority. */
export type PricingNodeDayaheadRateArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A pricing node in a balancing authority. */
export type PricingNodeFacilitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FacilityCondition>;
  filter?: InputMaybe<FacilityFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FacilitiesOrderBy>>;
};

/** A pricing node in a balancing authority. */
export type PricingNodeGridDemandArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A pricing node in a balancing authority. */
export type PricingNodeRealtimeRateArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/**
 * A condition to be used against `PricingNode` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type PricingNodeCondition = {
  /** Checks for equality with the object’s `balancingAuthorityId` field. */
  balancingAuthorityId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `geometry` field. */
  geometry?: InputMaybe<Scalars['GeoJSON']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `PricingNode` object types. All fields are combined with a logical ‘and.’ */
export type PricingNodeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PricingNodeFilter>>;
  /** Filter by the object’s `balancingAuthorityId` field. */
  balancingAuthorityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PricingNodeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PricingNodeFilter>>;
  /** Filter by the object’s `slug` field. */
  slug?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `PricingNode` */
export type PricingNodeInput = {
  /** Mutates a `BalancingAuthority` as part of the payload */
  balancingAuthority?: InputMaybe<BalancingAuthorityInput>;
  /** The id of the balancing authority the pricing node is associated with. */
  balancingAuthorityId?: InputMaybe<Scalars['Int']>;
  /** The geometry information of the pricing node. */
  geometry?: InputMaybe<Scalars['GeoJSON']>;
  name?: InputMaybe<Scalars['String']>;
  /** The name of the pricing node. */
  slug: Scalars['String'];
};

/** Represents an update to a `PricingNode`. Fields that are set will be updated. */
export type PricingNodePatch = {
  /** The id of the balancing authority the pricing node is associated with. */
  balancingAuthorityId?: InputMaybe<Scalars['Int']>;
  /** The geometry information of the pricing node. */
  geometry?: InputMaybe<Scalars['GeoJSON']>;
  name?: InputMaybe<Scalars['String']>;
  /** The name of the pricing node. */
  slug?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `PricingNode` values. */
export type PricingNodesConnection = {
  __typename?: 'PricingNodesConnection';
  /** The dayahead rate for the associated pricing node. */
  dayaheadRate?: Maybe<MetricDataConnection>;
  /** A list of edges which contains the `PricingNode` and cursor to aid in pagination. */
  edges: Array<PricingNodesEdge>;
  /** The grid demand value for the associated balancing authority. */
  gridDemand?: Maybe<MetricDataConnection>;
  /** A list of `PricingNode` objects. */
  nodes: Array<PricingNode>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The realtime rate for the associated pricing node. */
  realtimeRate?: Maybe<MetricDataConnection>;
  /** The count of *all* `PricingNode` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A connection to a list of `PricingNode` values. */
export type PricingNodesConnectionDayaheadRateArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `PricingNode` values. */
export type PricingNodesConnectionGridDemandArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `PricingNode` values. */
export type PricingNodesConnectionRealtimeRateArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A `PricingNode` edge in the connection. */
export type PricingNodesEdge = {
  __typename?: 'PricingNodesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PricingNode` at the end of the edge. */
  node: PricingNode;
};

/** Methods to use when ordering `PricingNode`. */
export enum PricingNodesOrderBy {
  BALANCING_AUTHORITY_ID_ASC = 'BALANCING_AUTHORITY_ID_ASC',
  BALANCING_AUTHORITY_ID_DESC = 'BALANCING_AUTHORITY_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  FACILITIES_AVERAGE_ADDRESS_ASC = 'FACILITIES_AVERAGE_ADDRESS_ASC',
  FACILITIES_AVERAGE_ADDRESS_DESC = 'FACILITIES_AVERAGE_ADDRESS_DESC',
  FACILITIES_AVERAGE_BONUS_LTR_ASC = 'FACILITIES_AVERAGE_BONUS_LTR_ASC',
  FACILITIES_AVERAGE_BONUS_LTR_DESC = 'FACILITIES_AVERAGE_BONUS_LTR_DESC',
  FACILITIES_AVERAGE_CITY_ASC = 'FACILITIES_AVERAGE_CITY_ASC',
  FACILITIES_AVERAGE_CITY_DESC = 'FACILITIES_AVERAGE_CITY_DESC',
  FACILITIES_AVERAGE_CONTXT_9249_ASC = 'FACILITIES_AVERAGE_CONTXT_9249_ASC',
  FACILITIES_AVERAGE_CONTXT_9249_DESC = 'FACILITIES_AVERAGE_CONTXT_9249_DESC',
  FACILITIES_AVERAGE_COUNTRY_ASC = 'FACILITIES_AVERAGE_COUNTRY_ASC',
  FACILITIES_AVERAGE_COUNTRY_DESC = 'FACILITIES_AVERAGE_COUNTRY_DESC',
  FACILITIES_AVERAGE_CREATED_AT_ASC = 'FACILITIES_AVERAGE_CREATED_AT_ASC',
  FACILITIES_AVERAGE_CREATED_AT_DESC = 'FACILITIES_AVERAGE_CREATED_AT_DESC',
  FACILITIES_AVERAGE_DATATYPE_1_TEST_ASC = 'FACILITIES_AVERAGE_DATATYPE_1_TEST_ASC',
  FACILITIES_AVERAGE_DATATYPE_1_TEST_DESC = 'FACILITIES_AVERAGE_DATATYPE_1_TEST_DESC',
  FACILITIES_AVERAGE_DATA_TYPE_2_TEST_ASC = 'FACILITIES_AVERAGE_DATA_TYPE_2_TEST_ASC',
  FACILITIES_AVERAGE_DATA_TYPE_2_TEST_DESC = 'FACILITIES_AVERAGE_DATA_TYPE_2_TEST_DESC',
  FACILITIES_AVERAGE_DATA_TYPE_3_TEST_ASC = 'FACILITIES_AVERAGE_DATA_TYPE_3_TEST_ASC',
  FACILITIES_AVERAGE_DATA_TYPE_3_TEST_DESC = 'FACILITIES_AVERAGE_DATA_TYPE_3_TEST_DESC',
  FACILITIES_AVERAGE_FACILITY_CONTACTS_ASC = 'FACILITIES_AVERAGE_FACILITY_CONTACTS_ASC',
  FACILITIES_AVERAGE_FACILITY_CONTACTS_DESC = 'FACILITIES_AVERAGE_FACILITY_CONTACTS_DESC',
  FACILITIES_AVERAGE_GEOMETRY_ASC = 'FACILITIES_AVERAGE_GEOMETRY_ASC',
  FACILITIES_AVERAGE_GEOMETRY_DESC = 'FACILITIES_AVERAGE_GEOMETRY_DESC',
  FACILITIES_AVERAGE_ID_ASC = 'FACILITIES_AVERAGE_ID_ASC',
  FACILITIES_AVERAGE_ID_DESC = 'FACILITIES_AVERAGE_ID_DESC',
  FACILITIES_AVERAGE_LATITUDE_ASC = 'FACILITIES_AVERAGE_LATITUDE_ASC',
  FACILITIES_AVERAGE_LATITUDE_DESC = 'FACILITIES_AVERAGE_LATITUDE_DESC',
  FACILITIES_AVERAGE_LINK_ACTIVE_ASC = 'FACILITIES_AVERAGE_LINK_ACTIVE_ASC',
  FACILITIES_AVERAGE_LINK_ACTIVE_DESC = 'FACILITIES_AVERAGE_LINK_ACTIVE_DESC',
  FACILITIES_AVERAGE_LONGITUDE_ASC = 'FACILITIES_AVERAGE_LONGITUDE_ASC',
  FACILITIES_AVERAGE_LONGITUDE_DESC = 'FACILITIES_AVERAGE_LONGITUDE_DESC',
  FACILITIES_AVERAGE_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_AVERAGE_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_AVERAGE_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_AVERAGE_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_AVERAGE_NAME_ASC = 'FACILITIES_AVERAGE_NAME_ASC',
  FACILITIES_AVERAGE_NAME_DESC = 'FACILITIES_AVERAGE_NAME_DESC',
  FACILITIES_AVERAGE_NOTE_ASC = 'FACILITIES_AVERAGE_NOTE_ASC',
  FACILITIES_AVERAGE_NOTE_DESC = 'FACILITIES_AVERAGE_NOTE_DESC',
  FACILITIES_AVERAGE_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_AVERAGE_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_AVERAGE_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_AVERAGE_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_AVERAGE_N_SIGHT_ACTIVE_ASC = 'FACILITIES_AVERAGE_N_SIGHT_ACTIVE_ASC',
  FACILITIES_AVERAGE_N_SIGHT_ACTIVE_DESC = 'FACILITIES_AVERAGE_N_SIGHT_ACTIVE_DESC',
  FACILITIES_AVERAGE_PRE_BONUS_EBITDA_ASC = 'FACILITIES_AVERAGE_PRE_BONUS_EBITDA_ASC',
  FACILITIES_AVERAGE_PRE_BONUS_EBITDA_DESC = 'FACILITIES_AVERAGE_PRE_BONUS_EBITDA_DESC',
  FACILITIES_AVERAGE_PRICING_NODE_ID_ASC = 'FACILITIES_AVERAGE_PRICING_NODE_ID_ASC',
  FACILITIES_AVERAGE_PRICING_NODE_ID_DESC = 'FACILITIES_AVERAGE_PRICING_NODE_ID_DESC',
  FACILITIES_AVERAGE_REAL_TIME_ENABLED_ASC = 'FACILITIES_AVERAGE_REAL_TIME_ENABLED_ASC',
  FACILITIES_AVERAGE_REAL_TIME_ENABLED_DESC = 'FACILITIES_AVERAGE_REAL_TIME_ENABLED_DESC',
  FACILITIES_AVERAGE_REFRIGERATIONVENDOR_ASC = 'FACILITIES_AVERAGE_REFRIGERATIONVENDOR_ASC',
  FACILITIES_AVERAGE_REFRIGERATIONVENDOR_DESC = 'FACILITIES_AVERAGE_REFRIGERATIONVENDOR_DESC',
  FACILITIES_AVERAGE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_AVERAGE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_AVERAGE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_AVERAGE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_AVERAGE_RETIRED_AT_ASC = 'FACILITIES_AVERAGE_RETIRED_AT_ASC',
  FACILITIES_AVERAGE_RETIRED_AT_DESC = 'FACILITIES_AVERAGE_RETIRED_AT_DESC',
  FACILITIES_AVERAGE_SLUG_ASC = 'FACILITIES_AVERAGE_SLUG_ASC',
  FACILITIES_AVERAGE_SLUG_DESC = 'FACILITIES_AVERAGE_SLUG_DESC',
  FACILITIES_AVERAGE_STATE_ASC = 'FACILITIES_AVERAGE_STATE_ASC',
  FACILITIES_AVERAGE_STATE_DESC = 'FACILITIES_AVERAGE_STATE_DESC',
  FACILITIES_AVERAGE_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_AVERAGE_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_AVERAGE_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_AVERAGE_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_AVERAGE_TIMEZONE_NAME_ASC = 'FACILITIES_AVERAGE_TIMEZONE_NAME_ASC',
  FACILITIES_AVERAGE_TIMEZONE_NAME_DESC = 'FACILITIES_AVERAGE_TIMEZONE_NAME_DESC',
  FACILITIES_AVERAGE_UNIT_GROUP_ASC = 'FACILITIES_AVERAGE_UNIT_GROUP_ASC',
  FACILITIES_AVERAGE_UNIT_GROUP_DESC = 'FACILITIES_AVERAGE_UNIT_GROUP_DESC',
  FACILITIES_AVERAGE_UPDATED_AT_ASC = 'FACILITIES_AVERAGE_UPDATED_AT_ASC',
  FACILITIES_AVERAGE_UPDATED_AT_DESC = 'FACILITIES_AVERAGE_UPDATED_AT_DESC',
  FACILITIES_AVERAGE_ZIP_ASC = 'FACILITIES_AVERAGE_ZIP_ASC',
  FACILITIES_AVERAGE_ZIP_DESC = 'FACILITIES_AVERAGE_ZIP_DESC',
  FACILITIES_COUNT_ASC = 'FACILITIES_COUNT_ASC',
  FACILITIES_COUNT_DESC = 'FACILITIES_COUNT_DESC',
  FACILITIES_DISTINCT_ADDRESS_ASC = 'FACILITIES_DISTINCT_ADDRESS_ASC',
  FACILITIES_DISTINCT_ADDRESS_DESC = 'FACILITIES_DISTINCT_ADDRESS_DESC',
  FACILITIES_DISTINCT_BONUS_LTR_ASC = 'FACILITIES_DISTINCT_BONUS_LTR_ASC',
  FACILITIES_DISTINCT_BONUS_LTR_DESC = 'FACILITIES_DISTINCT_BONUS_LTR_DESC',
  FACILITIES_DISTINCT_CITY_ASC = 'FACILITIES_DISTINCT_CITY_ASC',
  FACILITIES_DISTINCT_CITY_DESC = 'FACILITIES_DISTINCT_CITY_DESC',
  FACILITIES_DISTINCT_CONTXT_9249_ASC = 'FACILITIES_DISTINCT_CONTXT_9249_ASC',
  FACILITIES_DISTINCT_CONTXT_9249_DESC = 'FACILITIES_DISTINCT_CONTXT_9249_DESC',
  FACILITIES_DISTINCT_COUNTRY_ASC = 'FACILITIES_DISTINCT_COUNTRY_ASC',
  FACILITIES_DISTINCT_COUNTRY_DESC = 'FACILITIES_DISTINCT_COUNTRY_DESC',
  FACILITIES_DISTINCT_COUNT_ADDRESS_ASC = 'FACILITIES_DISTINCT_COUNT_ADDRESS_ASC',
  FACILITIES_DISTINCT_COUNT_ADDRESS_DESC = 'FACILITIES_DISTINCT_COUNT_ADDRESS_DESC',
  FACILITIES_DISTINCT_COUNT_BONUS_LTR_ASC = 'FACILITIES_DISTINCT_COUNT_BONUS_LTR_ASC',
  FACILITIES_DISTINCT_COUNT_BONUS_LTR_DESC = 'FACILITIES_DISTINCT_COUNT_BONUS_LTR_DESC',
  FACILITIES_DISTINCT_COUNT_CITY_ASC = 'FACILITIES_DISTINCT_COUNT_CITY_ASC',
  FACILITIES_DISTINCT_COUNT_CITY_DESC = 'FACILITIES_DISTINCT_COUNT_CITY_DESC',
  FACILITIES_DISTINCT_COUNT_CONTXT_9249_ASC = 'FACILITIES_DISTINCT_COUNT_CONTXT_9249_ASC',
  FACILITIES_DISTINCT_COUNT_CONTXT_9249_DESC = 'FACILITIES_DISTINCT_COUNT_CONTXT_9249_DESC',
  FACILITIES_DISTINCT_COUNT_COUNTRY_ASC = 'FACILITIES_DISTINCT_COUNT_COUNTRY_ASC',
  FACILITIES_DISTINCT_COUNT_COUNTRY_DESC = 'FACILITIES_DISTINCT_COUNT_COUNTRY_DESC',
  FACILITIES_DISTINCT_COUNT_CREATED_AT_ASC = 'FACILITIES_DISTINCT_COUNT_CREATED_AT_ASC',
  FACILITIES_DISTINCT_COUNT_CREATED_AT_DESC = 'FACILITIES_DISTINCT_COUNT_CREATED_AT_DESC',
  FACILITIES_DISTINCT_COUNT_DATATYPE_1_TEST_ASC = 'FACILITIES_DISTINCT_COUNT_DATATYPE_1_TEST_ASC',
  FACILITIES_DISTINCT_COUNT_DATATYPE_1_TEST_DESC = 'FACILITIES_DISTINCT_COUNT_DATATYPE_1_TEST_DESC',
  FACILITIES_DISTINCT_COUNT_DATA_TYPE_2_TEST_ASC = 'FACILITIES_DISTINCT_COUNT_DATA_TYPE_2_TEST_ASC',
  FACILITIES_DISTINCT_COUNT_DATA_TYPE_2_TEST_DESC = 'FACILITIES_DISTINCT_COUNT_DATA_TYPE_2_TEST_DESC',
  FACILITIES_DISTINCT_COUNT_DATA_TYPE_3_TEST_ASC = 'FACILITIES_DISTINCT_COUNT_DATA_TYPE_3_TEST_ASC',
  FACILITIES_DISTINCT_COUNT_DATA_TYPE_3_TEST_DESC = 'FACILITIES_DISTINCT_COUNT_DATA_TYPE_3_TEST_DESC',
  FACILITIES_DISTINCT_COUNT_FACILITY_CONTACTS_ASC = 'FACILITIES_DISTINCT_COUNT_FACILITY_CONTACTS_ASC',
  FACILITIES_DISTINCT_COUNT_FACILITY_CONTACTS_DESC = 'FACILITIES_DISTINCT_COUNT_FACILITY_CONTACTS_DESC',
  FACILITIES_DISTINCT_COUNT_GEOMETRY_ASC = 'FACILITIES_DISTINCT_COUNT_GEOMETRY_ASC',
  FACILITIES_DISTINCT_COUNT_GEOMETRY_DESC = 'FACILITIES_DISTINCT_COUNT_GEOMETRY_DESC',
  FACILITIES_DISTINCT_COUNT_ID_ASC = 'FACILITIES_DISTINCT_COUNT_ID_ASC',
  FACILITIES_DISTINCT_COUNT_ID_DESC = 'FACILITIES_DISTINCT_COUNT_ID_DESC',
  FACILITIES_DISTINCT_COUNT_LATITUDE_ASC = 'FACILITIES_DISTINCT_COUNT_LATITUDE_ASC',
  FACILITIES_DISTINCT_COUNT_LATITUDE_DESC = 'FACILITIES_DISTINCT_COUNT_LATITUDE_DESC',
  FACILITIES_DISTINCT_COUNT_LINK_ACTIVE_ASC = 'FACILITIES_DISTINCT_COUNT_LINK_ACTIVE_ASC',
  FACILITIES_DISTINCT_COUNT_LINK_ACTIVE_DESC = 'FACILITIES_DISTINCT_COUNT_LINK_ACTIVE_DESC',
  FACILITIES_DISTINCT_COUNT_LONGITUDE_ASC = 'FACILITIES_DISTINCT_COUNT_LONGITUDE_ASC',
  FACILITIES_DISTINCT_COUNT_LONGITUDE_DESC = 'FACILITIES_DISTINCT_COUNT_LONGITUDE_DESC',
  FACILITIES_DISTINCT_COUNT_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_DISTINCT_COUNT_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_DISTINCT_COUNT_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_DISTINCT_COUNT_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_DISTINCT_COUNT_NAME_ASC = 'FACILITIES_DISTINCT_COUNT_NAME_ASC',
  FACILITIES_DISTINCT_COUNT_NAME_DESC = 'FACILITIES_DISTINCT_COUNT_NAME_DESC',
  FACILITIES_DISTINCT_COUNT_NOTE_ASC = 'FACILITIES_DISTINCT_COUNT_NOTE_ASC',
  FACILITIES_DISTINCT_COUNT_NOTE_DESC = 'FACILITIES_DISTINCT_COUNT_NOTE_DESC',
  FACILITIES_DISTINCT_COUNT_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_DISTINCT_COUNT_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_DISTINCT_COUNT_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_DISTINCT_COUNT_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_DISTINCT_COUNT_N_SIGHT_ACTIVE_ASC = 'FACILITIES_DISTINCT_COUNT_N_SIGHT_ACTIVE_ASC',
  FACILITIES_DISTINCT_COUNT_N_SIGHT_ACTIVE_DESC = 'FACILITIES_DISTINCT_COUNT_N_SIGHT_ACTIVE_DESC',
  FACILITIES_DISTINCT_COUNT_PRE_BONUS_EBITDA_ASC = 'FACILITIES_DISTINCT_COUNT_PRE_BONUS_EBITDA_ASC',
  FACILITIES_DISTINCT_COUNT_PRE_BONUS_EBITDA_DESC = 'FACILITIES_DISTINCT_COUNT_PRE_BONUS_EBITDA_DESC',
  FACILITIES_DISTINCT_COUNT_PRICING_NODE_ID_ASC = 'FACILITIES_DISTINCT_COUNT_PRICING_NODE_ID_ASC',
  FACILITIES_DISTINCT_COUNT_PRICING_NODE_ID_DESC = 'FACILITIES_DISTINCT_COUNT_PRICING_NODE_ID_DESC',
  FACILITIES_DISTINCT_COUNT_REAL_TIME_ENABLED_ASC = 'FACILITIES_DISTINCT_COUNT_REAL_TIME_ENABLED_ASC',
  FACILITIES_DISTINCT_COUNT_REAL_TIME_ENABLED_DESC = 'FACILITIES_DISTINCT_COUNT_REAL_TIME_ENABLED_DESC',
  FACILITIES_DISTINCT_COUNT_REFRIGERATIONVENDOR_ASC = 'FACILITIES_DISTINCT_COUNT_REFRIGERATIONVENDOR_ASC',
  FACILITIES_DISTINCT_COUNT_REFRIGERATIONVENDOR_DESC = 'FACILITIES_DISTINCT_COUNT_REFRIGERATIONVENDOR_DESC',
  FACILITIES_DISTINCT_COUNT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_DISTINCT_COUNT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_DISTINCT_COUNT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_DISTINCT_COUNT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_DISTINCT_COUNT_RETIRED_AT_ASC = 'FACILITIES_DISTINCT_COUNT_RETIRED_AT_ASC',
  FACILITIES_DISTINCT_COUNT_RETIRED_AT_DESC = 'FACILITIES_DISTINCT_COUNT_RETIRED_AT_DESC',
  FACILITIES_DISTINCT_COUNT_SLUG_ASC = 'FACILITIES_DISTINCT_COUNT_SLUG_ASC',
  FACILITIES_DISTINCT_COUNT_SLUG_DESC = 'FACILITIES_DISTINCT_COUNT_SLUG_DESC',
  FACILITIES_DISTINCT_COUNT_STATE_ASC = 'FACILITIES_DISTINCT_COUNT_STATE_ASC',
  FACILITIES_DISTINCT_COUNT_STATE_DESC = 'FACILITIES_DISTINCT_COUNT_STATE_DESC',
  FACILITIES_DISTINCT_COUNT_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_DISTINCT_COUNT_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_DISTINCT_COUNT_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_DISTINCT_COUNT_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_DISTINCT_COUNT_TIMEZONE_NAME_ASC = 'FACILITIES_DISTINCT_COUNT_TIMEZONE_NAME_ASC',
  FACILITIES_DISTINCT_COUNT_TIMEZONE_NAME_DESC = 'FACILITIES_DISTINCT_COUNT_TIMEZONE_NAME_DESC',
  FACILITIES_DISTINCT_COUNT_UNIT_GROUP_ASC = 'FACILITIES_DISTINCT_COUNT_UNIT_GROUP_ASC',
  FACILITIES_DISTINCT_COUNT_UNIT_GROUP_DESC = 'FACILITIES_DISTINCT_COUNT_UNIT_GROUP_DESC',
  FACILITIES_DISTINCT_COUNT_UPDATED_AT_ASC = 'FACILITIES_DISTINCT_COUNT_UPDATED_AT_ASC',
  FACILITIES_DISTINCT_COUNT_UPDATED_AT_DESC = 'FACILITIES_DISTINCT_COUNT_UPDATED_AT_DESC',
  FACILITIES_DISTINCT_COUNT_ZIP_ASC = 'FACILITIES_DISTINCT_COUNT_ZIP_ASC',
  FACILITIES_DISTINCT_COUNT_ZIP_DESC = 'FACILITIES_DISTINCT_COUNT_ZIP_DESC',
  FACILITIES_DISTINCT_CREATED_AT_ASC = 'FACILITIES_DISTINCT_CREATED_AT_ASC',
  FACILITIES_DISTINCT_CREATED_AT_DESC = 'FACILITIES_DISTINCT_CREATED_AT_DESC',
  FACILITIES_DISTINCT_DATATYPE_1_TEST_ASC = 'FACILITIES_DISTINCT_DATATYPE_1_TEST_ASC',
  FACILITIES_DISTINCT_DATATYPE_1_TEST_DESC = 'FACILITIES_DISTINCT_DATATYPE_1_TEST_DESC',
  FACILITIES_DISTINCT_DATA_TYPE_2_TEST_ASC = 'FACILITIES_DISTINCT_DATA_TYPE_2_TEST_ASC',
  FACILITIES_DISTINCT_DATA_TYPE_2_TEST_DESC = 'FACILITIES_DISTINCT_DATA_TYPE_2_TEST_DESC',
  FACILITIES_DISTINCT_DATA_TYPE_3_TEST_ASC = 'FACILITIES_DISTINCT_DATA_TYPE_3_TEST_ASC',
  FACILITIES_DISTINCT_DATA_TYPE_3_TEST_DESC = 'FACILITIES_DISTINCT_DATA_TYPE_3_TEST_DESC',
  FACILITIES_DISTINCT_FACILITY_CONTACTS_ASC = 'FACILITIES_DISTINCT_FACILITY_CONTACTS_ASC',
  FACILITIES_DISTINCT_FACILITY_CONTACTS_DESC = 'FACILITIES_DISTINCT_FACILITY_CONTACTS_DESC',
  FACILITIES_DISTINCT_GEOMETRY_ASC = 'FACILITIES_DISTINCT_GEOMETRY_ASC',
  FACILITIES_DISTINCT_GEOMETRY_DESC = 'FACILITIES_DISTINCT_GEOMETRY_DESC',
  FACILITIES_DISTINCT_ID_ASC = 'FACILITIES_DISTINCT_ID_ASC',
  FACILITIES_DISTINCT_ID_DESC = 'FACILITIES_DISTINCT_ID_DESC',
  FACILITIES_DISTINCT_LATITUDE_ASC = 'FACILITIES_DISTINCT_LATITUDE_ASC',
  FACILITIES_DISTINCT_LATITUDE_DESC = 'FACILITIES_DISTINCT_LATITUDE_DESC',
  FACILITIES_DISTINCT_LINK_ACTIVE_ASC = 'FACILITIES_DISTINCT_LINK_ACTIVE_ASC',
  FACILITIES_DISTINCT_LINK_ACTIVE_DESC = 'FACILITIES_DISTINCT_LINK_ACTIVE_DESC',
  FACILITIES_DISTINCT_LONGITUDE_ASC = 'FACILITIES_DISTINCT_LONGITUDE_ASC',
  FACILITIES_DISTINCT_LONGITUDE_DESC = 'FACILITIES_DISTINCT_LONGITUDE_DESC',
  FACILITIES_DISTINCT_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_DISTINCT_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_DISTINCT_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_DISTINCT_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_DISTINCT_NAME_ASC = 'FACILITIES_DISTINCT_NAME_ASC',
  FACILITIES_DISTINCT_NAME_DESC = 'FACILITIES_DISTINCT_NAME_DESC',
  FACILITIES_DISTINCT_NOTE_ASC = 'FACILITIES_DISTINCT_NOTE_ASC',
  FACILITIES_DISTINCT_NOTE_DESC = 'FACILITIES_DISTINCT_NOTE_DESC',
  FACILITIES_DISTINCT_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_DISTINCT_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_DISTINCT_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_DISTINCT_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_DISTINCT_N_SIGHT_ACTIVE_ASC = 'FACILITIES_DISTINCT_N_SIGHT_ACTIVE_ASC',
  FACILITIES_DISTINCT_N_SIGHT_ACTIVE_DESC = 'FACILITIES_DISTINCT_N_SIGHT_ACTIVE_DESC',
  FACILITIES_DISTINCT_PRE_BONUS_EBITDA_ASC = 'FACILITIES_DISTINCT_PRE_BONUS_EBITDA_ASC',
  FACILITIES_DISTINCT_PRE_BONUS_EBITDA_DESC = 'FACILITIES_DISTINCT_PRE_BONUS_EBITDA_DESC',
  FACILITIES_DISTINCT_PRICING_NODE_ID_ASC = 'FACILITIES_DISTINCT_PRICING_NODE_ID_ASC',
  FACILITIES_DISTINCT_PRICING_NODE_ID_DESC = 'FACILITIES_DISTINCT_PRICING_NODE_ID_DESC',
  FACILITIES_DISTINCT_REAL_TIME_ENABLED_ASC = 'FACILITIES_DISTINCT_REAL_TIME_ENABLED_ASC',
  FACILITIES_DISTINCT_REAL_TIME_ENABLED_DESC = 'FACILITIES_DISTINCT_REAL_TIME_ENABLED_DESC',
  FACILITIES_DISTINCT_REFRIGERATIONVENDOR_ASC = 'FACILITIES_DISTINCT_REFRIGERATIONVENDOR_ASC',
  FACILITIES_DISTINCT_REFRIGERATIONVENDOR_DESC = 'FACILITIES_DISTINCT_REFRIGERATIONVENDOR_DESC',
  FACILITIES_DISTINCT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_DISTINCT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_DISTINCT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_DISTINCT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_DISTINCT_RETIRED_AT_ASC = 'FACILITIES_DISTINCT_RETIRED_AT_ASC',
  FACILITIES_DISTINCT_RETIRED_AT_DESC = 'FACILITIES_DISTINCT_RETIRED_AT_DESC',
  FACILITIES_DISTINCT_SLUG_ASC = 'FACILITIES_DISTINCT_SLUG_ASC',
  FACILITIES_DISTINCT_SLUG_DESC = 'FACILITIES_DISTINCT_SLUG_DESC',
  FACILITIES_DISTINCT_STATE_ASC = 'FACILITIES_DISTINCT_STATE_ASC',
  FACILITIES_DISTINCT_STATE_DESC = 'FACILITIES_DISTINCT_STATE_DESC',
  FACILITIES_DISTINCT_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_DISTINCT_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_DISTINCT_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_DISTINCT_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_DISTINCT_TIMEZONE_NAME_ASC = 'FACILITIES_DISTINCT_TIMEZONE_NAME_ASC',
  FACILITIES_DISTINCT_TIMEZONE_NAME_DESC = 'FACILITIES_DISTINCT_TIMEZONE_NAME_DESC',
  FACILITIES_DISTINCT_UNIT_GROUP_ASC = 'FACILITIES_DISTINCT_UNIT_GROUP_ASC',
  FACILITIES_DISTINCT_UNIT_GROUP_DESC = 'FACILITIES_DISTINCT_UNIT_GROUP_DESC',
  FACILITIES_DISTINCT_UPDATED_AT_ASC = 'FACILITIES_DISTINCT_UPDATED_AT_ASC',
  FACILITIES_DISTINCT_UPDATED_AT_DESC = 'FACILITIES_DISTINCT_UPDATED_AT_DESC',
  FACILITIES_DISTINCT_ZIP_ASC = 'FACILITIES_DISTINCT_ZIP_ASC',
  FACILITIES_DISTINCT_ZIP_DESC = 'FACILITIES_DISTINCT_ZIP_DESC',
  FACILITIES_MAX_ADDRESS_ASC = 'FACILITIES_MAX_ADDRESS_ASC',
  FACILITIES_MAX_ADDRESS_DESC = 'FACILITIES_MAX_ADDRESS_DESC',
  FACILITIES_MAX_BONUS_LTR_ASC = 'FACILITIES_MAX_BONUS_LTR_ASC',
  FACILITIES_MAX_BONUS_LTR_DESC = 'FACILITIES_MAX_BONUS_LTR_DESC',
  FACILITIES_MAX_CITY_ASC = 'FACILITIES_MAX_CITY_ASC',
  FACILITIES_MAX_CITY_DESC = 'FACILITIES_MAX_CITY_DESC',
  FACILITIES_MAX_CONTXT_9249_ASC = 'FACILITIES_MAX_CONTXT_9249_ASC',
  FACILITIES_MAX_CONTXT_9249_DESC = 'FACILITIES_MAX_CONTXT_9249_DESC',
  FACILITIES_MAX_COUNTRY_ASC = 'FACILITIES_MAX_COUNTRY_ASC',
  FACILITIES_MAX_COUNTRY_DESC = 'FACILITIES_MAX_COUNTRY_DESC',
  FACILITIES_MAX_CREATED_AT_ASC = 'FACILITIES_MAX_CREATED_AT_ASC',
  FACILITIES_MAX_CREATED_AT_DESC = 'FACILITIES_MAX_CREATED_AT_DESC',
  FACILITIES_MAX_DATATYPE_1_TEST_ASC = 'FACILITIES_MAX_DATATYPE_1_TEST_ASC',
  FACILITIES_MAX_DATATYPE_1_TEST_DESC = 'FACILITIES_MAX_DATATYPE_1_TEST_DESC',
  FACILITIES_MAX_DATA_TYPE_2_TEST_ASC = 'FACILITIES_MAX_DATA_TYPE_2_TEST_ASC',
  FACILITIES_MAX_DATA_TYPE_2_TEST_DESC = 'FACILITIES_MAX_DATA_TYPE_2_TEST_DESC',
  FACILITIES_MAX_DATA_TYPE_3_TEST_ASC = 'FACILITIES_MAX_DATA_TYPE_3_TEST_ASC',
  FACILITIES_MAX_DATA_TYPE_3_TEST_DESC = 'FACILITIES_MAX_DATA_TYPE_3_TEST_DESC',
  FACILITIES_MAX_FACILITY_CONTACTS_ASC = 'FACILITIES_MAX_FACILITY_CONTACTS_ASC',
  FACILITIES_MAX_FACILITY_CONTACTS_DESC = 'FACILITIES_MAX_FACILITY_CONTACTS_DESC',
  FACILITIES_MAX_GEOMETRY_ASC = 'FACILITIES_MAX_GEOMETRY_ASC',
  FACILITIES_MAX_GEOMETRY_DESC = 'FACILITIES_MAX_GEOMETRY_DESC',
  FACILITIES_MAX_ID_ASC = 'FACILITIES_MAX_ID_ASC',
  FACILITIES_MAX_ID_DESC = 'FACILITIES_MAX_ID_DESC',
  FACILITIES_MAX_LATITUDE_ASC = 'FACILITIES_MAX_LATITUDE_ASC',
  FACILITIES_MAX_LATITUDE_DESC = 'FACILITIES_MAX_LATITUDE_DESC',
  FACILITIES_MAX_LINK_ACTIVE_ASC = 'FACILITIES_MAX_LINK_ACTIVE_ASC',
  FACILITIES_MAX_LINK_ACTIVE_DESC = 'FACILITIES_MAX_LINK_ACTIVE_DESC',
  FACILITIES_MAX_LONGITUDE_ASC = 'FACILITIES_MAX_LONGITUDE_ASC',
  FACILITIES_MAX_LONGITUDE_DESC = 'FACILITIES_MAX_LONGITUDE_DESC',
  FACILITIES_MAX_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_MAX_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_MAX_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_MAX_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_MAX_NAME_ASC = 'FACILITIES_MAX_NAME_ASC',
  FACILITIES_MAX_NAME_DESC = 'FACILITIES_MAX_NAME_DESC',
  FACILITIES_MAX_NOTE_ASC = 'FACILITIES_MAX_NOTE_ASC',
  FACILITIES_MAX_NOTE_DESC = 'FACILITIES_MAX_NOTE_DESC',
  FACILITIES_MAX_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_MAX_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_MAX_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_MAX_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_MAX_N_SIGHT_ACTIVE_ASC = 'FACILITIES_MAX_N_SIGHT_ACTIVE_ASC',
  FACILITIES_MAX_N_SIGHT_ACTIVE_DESC = 'FACILITIES_MAX_N_SIGHT_ACTIVE_DESC',
  FACILITIES_MAX_PRE_BONUS_EBITDA_ASC = 'FACILITIES_MAX_PRE_BONUS_EBITDA_ASC',
  FACILITIES_MAX_PRE_BONUS_EBITDA_DESC = 'FACILITIES_MAX_PRE_BONUS_EBITDA_DESC',
  FACILITIES_MAX_PRICING_NODE_ID_ASC = 'FACILITIES_MAX_PRICING_NODE_ID_ASC',
  FACILITIES_MAX_PRICING_NODE_ID_DESC = 'FACILITIES_MAX_PRICING_NODE_ID_DESC',
  FACILITIES_MAX_REAL_TIME_ENABLED_ASC = 'FACILITIES_MAX_REAL_TIME_ENABLED_ASC',
  FACILITIES_MAX_REAL_TIME_ENABLED_DESC = 'FACILITIES_MAX_REAL_TIME_ENABLED_DESC',
  FACILITIES_MAX_REFRIGERATIONVENDOR_ASC = 'FACILITIES_MAX_REFRIGERATIONVENDOR_ASC',
  FACILITIES_MAX_REFRIGERATIONVENDOR_DESC = 'FACILITIES_MAX_REFRIGERATIONVENDOR_DESC',
  FACILITIES_MAX_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_MAX_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_MAX_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_MAX_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_MAX_RETIRED_AT_ASC = 'FACILITIES_MAX_RETIRED_AT_ASC',
  FACILITIES_MAX_RETIRED_AT_DESC = 'FACILITIES_MAX_RETIRED_AT_DESC',
  FACILITIES_MAX_SLUG_ASC = 'FACILITIES_MAX_SLUG_ASC',
  FACILITIES_MAX_SLUG_DESC = 'FACILITIES_MAX_SLUG_DESC',
  FACILITIES_MAX_STATE_ASC = 'FACILITIES_MAX_STATE_ASC',
  FACILITIES_MAX_STATE_DESC = 'FACILITIES_MAX_STATE_DESC',
  FACILITIES_MAX_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_MAX_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_MAX_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_MAX_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_MAX_TIMEZONE_NAME_ASC = 'FACILITIES_MAX_TIMEZONE_NAME_ASC',
  FACILITIES_MAX_TIMEZONE_NAME_DESC = 'FACILITIES_MAX_TIMEZONE_NAME_DESC',
  FACILITIES_MAX_UNIT_GROUP_ASC = 'FACILITIES_MAX_UNIT_GROUP_ASC',
  FACILITIES_MAX_UNIT_GROUP_DESC = 'FACILITIES_MAX_UNIT_GROUP_DESC',
  FACILITIES_MAX_UPDATED_AT_ASC = 'FACILITIES_MAX_UPDATED_AT_ASC',
  FACILITIES_MAX_UPDATED_AT_DESC = 'FACILITIES_MAX_UPDATED_AT_DESC',
  FACILITIES_MAX_ZIP_ASC = 'FACILITIES_MAX_ZIP_ASC',
  FACILITIES_MAX_ZIP_DESC = 'FACILITIES_MAX_ZIP_DESC',
  FACILITIES_MIN_ADDRESS_ASC = 'FACILITIES_MIN_ADDRESS_ASC',
  FACILITIES_MIN_ADDRESS_DESC = 'FACILITIES_MIN_ADDRESS_DESC',
  FACILITIES_MIN_BONUS_LTR_ASC = 'FACILITIES_MIN_BONUS_LTR_ASC',
  FACILITIES_MIN_BONUS_LTR_DESC = 'FACILITIES_MIN_BONUS_LTR_DESC',
  FACILITIES_MIN_CITY_ASC = 'FACILITIES_MIN_CITY_ASC',
  FACILITIES_MIN_CITY_DESC = 'FACILITIES_MIN_CITY_DESC',
  FACILITIES_MIN_CONTXT_9249_ASC = 'FACILITIES_MIN_CONTXT_9249_ASC',
  FACILITIES_MIN_CONTXT_9249_DESC = 'FACILITIES_MIN_CONTXT_9249_DESC',
  FACILITIES_MIN_COUNTRY_ASC = 'FACILITIES_MIN_COUNTRY_ASC',
  FACILITIES_MIN_COUNTRY_DESC = 'FACILITIES_MIN_COUNTRY_DESC',
  FACILITIES_MIN_CREATED_AT_ASC = 'FACILITIES_MIN_CREATED_AT_ASC',
  FACILITIES_MIN_CREATED_AT_DESC = 'FACILITIES_MIN_CREATED_AT_DESC',
  FACILITIES_MIN_DATATYPE_1_TEST_ASC = 'FACILITIES_MIN_DATATYPE_1_TEST_ASC',
  FACILITIES_MIN_DATATYPE_1_TEST_DESC = 'FACILITIES_MIN_DATATYPE_1_TEST_DESC',
  FACILITIES_MIN_DATA_TYPE_2_TEST_ASC = 'FACILITIES_MIN_DATA_TYPE_2_TEST_ASC',
  FACILITIES_MIN_DATA_TYPE_2_TEST_DESC = 'FACILITIES_MIN_DATA_TYPE_2_TEST_DESC',
  FACILITIES_MIN_DATA_TYPE_3_TEST_ASC = 'FACILITIES_MIN_DATA_TYPE_3_TEST_ASC',
  FACILITIES_MIN_DATA_TYPE_3_TEST_DESC = 'FACILITIES_MIN_DATA_TYPE_3_TEST_DESC',
  FACILITIES_MIN_FACILITY_CONTACTS_ASC = 'FACILITIES_MIN_FACILITY_CONTACTS_ASC',
  FACILITIES_MIN_FACILITY_CONTACTS_DESC = 'FACILITIES_MIN_FACILITY_CONTACTS_DESC',
  FACILITIES_MIN_GEOMETRY_ASC = 'FACILITIES_MIN_GEOMETRY_ASC',
  FACILITIES_MIN_GEOMETRY_DESC = 'FACILITIES_MIN_GEOMETRY_DESC',
  FACILITIES_MIN_ID_ASC = 'FACILITIES_MIN_ID_ASC',
  FACILITIES_MIN_ID_DESC = 'FACILITIES_MIN_ID_DESC',
  FACILITIES_MIN_LATITUDE_ASC = 'FACILITIES_MIN_LATITUDE_ASC',
  FACILITIES_MIN_LATITUDE_DESC = 'FACILITIES_MIN_LATITUDE_DESC',
  FACILITIES_MIN_LINK_ACTIVE_ASC = 'FACILITIES_MIN_LINK_ACTIVE_ASC',
  FACILITIES_MIN_LINK_ACTIVE_DESC = 'FACILITIES_MIN_LINK_ACTIVE_DESC',
  FACILITIES_MIN_LONGITUDE_ASC = 'FACILITIES_MIN_LONGITUDE_ASC',
  FACILITIES_MIN_LONGITUDE_DESC = 'FACILITIES_MIN_LONGITUDE_DESC',
  FACILITIES_MIN_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_MIN_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_MIN_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_MIN_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_MIN_NAME_ASC = 'FACILITIES_MIN_NAME_ASC',
  FACILITIES_MIN_NAME_DESC = 'FACILITIES_MIN_NAME_DESC',
  FACILITIES_MIN_NOTE_ASC = 'FACILITIES_MIN_NOTE_ASC',
  FACILITIES_MIN_NOTE_DESC = 'FACILITIES_MIN_NOTE_DESC',
  FACILITIES_MIN_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_MIN_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_MIN_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_MIN_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_MIN_N_SIGHT_ACTIVE_ASC = 'FACILITIES_MIN_N_SIGHT_ACTIVE_ASC',
  FACILITIES_MIN_N_SIGHT_ACTIVE_DESC = 'FACILITIES_MIN_N_SIGHT_ACTIVE_DESC',
  FACILITIES_MIN_PRE_BONUS_EBITDA_ASC = 'FACILITIES_MIN_PRE_BONUS_EBITDA_ASC',
  FACILITIES_MIN_PRE_BONUS_EBITDA_DESC = 'FACILITIES_MIN_PRE_BONUS_EBITDA_DESC',
  FACILITIES_MIN_PRICING_NODE_ID_ASC = 'FACILITIES_MIN_PRICING_NODE_ID_ASC',
  FACILITIES_MIN_PRICING_NODE_ID_DESC = 'FACILITIES_MIN_PRICING_NODE_ID_DESC',
  FACILITIES_MIN_REAL_TIME_ENABLED_ASC = 'FACILITIES_MIN_REAL_TIME_ENABLED_ASC',
  FACILITIES_MIN_REAL_TIME_ENABLED_DESC = 'FACILITIES_MIN_REAL_TIME_ENABLED_DESC',
  FACILITIES_MIN_REFRIGERATIONVENDOR_ASC = 'FACILITIES_MIN_REFRIGERATIONVENDOR_ASC',
  FACILITIES_MIN_REFRIGERATIONVENDOR_DESC = 'FACILITIES_MIN_REFRIGERATIONVENDOR_DESC',
  FACILITIES_MIN_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_MIN_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_MIN_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_MIN_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_MIN_RETIRED_AT_ASC = 'FACILITIES_MIN_RETIRED_AT_ASC',
  FACILITIES_MIN_RETIRED_AT_DESC = 'FACILITIES_MIN_RETIRED_AT_DESC',
  FACILITIES_MIN_SLUG_ASC = 'FACILITIES_MIN_SLUG_ASC',
  FACILITIES_MIN_SLUG_DESC = 'FACILITIES_MIN_SLUG_DESC',
  FACILITIES_MIN_STATE_ASC = 'FACILITIES_MIN_STATE_ASC',
  FACILITIES_MIN_STATE_DESC = 'FACILITIES_MIN_STATE_DESC',
  FACILITIES_MIN_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_MIN_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_MIN_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_MIN_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_MIN_TIMEZONE_NAME_ASC = 'FACILITIES_MIN_TIMEZONE_NAME_ASC',
  FACILITIES_MIN_TIMEZONE_NAME_DESC = 'FACILITIES_MIN_TIMEZONE_NAME_DESC',
  FACILITIES_MIN_UNIT_GROUP_ASC = 'FACILITIES_MIN_UNIT_GROUP_ASC',
  FACILITIES_MIN_UNIT_GROUP_DESC = 'FACILITIES_MIN_UNIT_GROUP_DESC',
  FACILITIES_MIN_UPDATED_AT_ASC = 'FACILITIES_MIN_UPDATED_AT_ASC',
  FACILITIES_MIN_UPDATED_AT_DESC = 'FACILITIES_MIN_UPDATED_AT_DESC',
  FACILITIES_MIN_ZIP_ASC = 'FACILITIES_MIN_ZIP_ASC',
  FACILITIES_MIN_ZIP_DESC = 'FACILITIES_MIN_ZIP_DESC',
  FACILITIES_STDDEV_POPULATION_ADDRESS_ASC = 'FACILITIES_STDDEV_POPULATION_ADDRESS_ASC',
  FACILITIES_STDDEV_POPULATION_ADDRESS_DESC = 'FACILITIES_STDDEV_POPULATION_ADDRESS_DESC',
  FACILITIES_STDDEV_POPULATION_BONUS_LTR_ASC = 'FACILITIES_STDDEV_POPULATION_BONUS_LTR_ASC',
  FACILITIES_STDDEV_POPULATION_BONUS_LTR_DESC = 'FACILITIES_STDDEV_POPULATION_BONUS_LTR_DESC',
  FACILITIES_STDDEV_POPULATION_CITY_ASC = 'FACILITIES_STDDEV_POPULATION_CITY_ASC',
  FACILITIES_STDDEV_POPULATION_CITY_DESC = 'FACILITIES_STDDEV_POPULATION_CITY_DESC',
  FACILITIES_STDDEV_POPULATION_CONTXT_9249_ASC = 'FACILITIES_STDDEV_POPULATION_CONTXT_9249_ASC',
  FACILITIES_STDDEV_POPULATION_CONTXT_9249_DESC = 'FACILITIES_STDDEV_POPULATION_CONTXT_9249_DESC',
  FACILITIES_STDDEV_POPULATION_COUNTRY_ASC = 'FACILITIES_STDDEV_POPULATION_COUNTRY_ASC',
  FACILITIES_STDDEV_POPULATION_COUNTRY_DESC = 'FACILITIES_STDDEV_POPULATION_COUNTRY_DESC',
  FACILITIES_STDDEV_POPULATION_CREATED_AT_ASC = 'FACILITIES_STDDEV_POPULATION_CREATED_AT_ASC',
  FACILITIES_STDDEV_POPULATION_CREATED_AT_DESC = 'FACILITIES_STDDEV_POPULATION_CREATED_AT_DESC',
  FACILITIES_STDDEV_POPULATION_DATATYPE_1_TEST_ASC = 'FACILITIES_STDDEV_POPULATION_DATATYPE_1_TEST_ASC',
  FACILITIES_STDDEV_POPULATION_DATATYPE_1_TEST_DESC = 'FACILITIES_STDDEV_POPULATION_DATATYPE_1_TEST_DESC',
  FACILITIES_STDDEV_POPULATION_DATA_TYPE_2_TEST_ASC = 'FACILITIES_STDDEV_POPULATION_DATA_TYPE_2_TEST_ASC',
  FACILITIES_STDDEV_POPULATION_DATA_TYPE_2_TEST_DESC = 'FACILITIES_STDDEV_POPULATION_DATA_TYPE_2_TEST_DESC',
  FACILITIES_STDDEV_POPULATION_DATA_TYPE_3_TEST_ASC = 'FACILITIES_STDDEV_POPULATION_DATA_TYPE_3_TEST_ASC',
  FACILITIES_STDDEV_POPULATION_DATA_TYPE_3_TEST_DESC = 'FACILITIES_STDDEV_POPULATION_DATA_TYPE_3_TEST_DESC',
  FACILITIES_STDDEV_POPULATION_FACILITY_CONTACTS_ASC = 'FACILITIES_STDDEV_POPULATION_FACILITY_CONTACTS_ASC',
  FACILITIES_STDDEV_POPULATION_FACILITY_CONTACTS_DESC = 'FACILITIES_STDDEV_POPULATION_FACILITY_CONTACTS_DESC',
  FACILITIES_STDDEV_POPULATION_GEOMETRY_ASC = 'FACILITIES_STDDEV_POPULATION_GEOMETRY_ASC',
  FACILITIES_STDDEV_POPULATION_GEOMETRY_DESC = 'FACILITIES_STDDEV_POPULATION_GEOMETRY_DESC',
  FACILITIES_STDDEV_POPULATION_ID_ASC = 'FACILITIES_STDDEV_POPULATION_ID_ASC',
  FACILITIES_STDDEV_POPULATION_ID_DESC = 'FACILITIES_STDDEV_POPULATION_ID_DESC',
  FACILITIES_STDDEV_POPULATION_LATITUDE_ASC = 'FACILITIES_STDDEV_POPULATION_LATITUDE_ASC',
  FACILITIES_STDDEV_POPULATION_LATITUDE_DESC = 'FACILITIES_STDDEV_POPULATION_LATITUDE_DESC',
  FACILITIES_STDDEV_POPULATION_LINK_ACTIVE_ASC = 'FACILITIES_STDDEV_POPULATION_LINK_ACTIVE_ASC',
  FACILITIES_STDDEV_POPULATION_LINK_ACTIVE_DESC = 'FACILITIES_STDDEV_POPULATION_LINK_ACTIVE_DESC',
  FACILITIES_STDDEV_POPULATION_LONGITUDE_ASC = 'FACILITIES_STDDEV_POPULATION_LONGITUDE_ASC',
  FACILITIES_STDDEV_POPULATION_LONGITUDE_DESC = 'FACILITIES_STDDEV_POPULATION_LONGITUDE_DESC',
  FACILITIES_STDDEV_POPULATION_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_STDDEV_POPULATION_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_STDDEV_POPULATION_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_STDDEV_POPULATION_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_STDDEV_POPULATION_NAME_ASC = 'FACILITIES_STDDEV_POPULATION_NAME_ASC',
  FACILITIES_STDDEV_POPULATION_NAME_DESC = 'FACILITIES_STDDEV_POPULATION_NAME_DESC',
  FACILITIES_STDDEV_POPULATION_NOTE_ASC = 'FACILITIES_STDDEV_POPULATION_NOTE_ASC',
  FACILITIES_STDDEV_POPULATION_NOTE_DESC = 'FACILITIES_STDDEV_POPULATION_NOTE_DESC',
  FACILITIES_STDDEV_POPULATION_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_STDDEV_POPULATION_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_STDDEV_POPULATION_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_STDDEV_POPULATION_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_STDDEV_POPULATION_N_SIGHT_ACTIVE_ASC = 'FACILITIES_STDDEV_POPULATION_N_SIGHT_ACTIVE_ASC',
  FACILITIES_STDDEV_POPULATION_N_SIGHT_ACTIVE_DESC = 'FACILITIES_STDDEV_POPULATION_N_SIGHT_ACTIVE_DESC',
  FACILITIES_STDDEV_POPULATION_PRE_BONUS_EBITDA_ASC = 'FACILITIES_STDDEV_POPULATION_PRE_BONUS_EBITDA_ASC',
  FACILITIES_STDDEV_POPULATION_PRE_BONUS_EBITDA_DESC = 'FACILITIES_STDDEV_POPULATION_PRE_BONUS_EBITDA_DESC',
  FACILITIES_STDDEV_POPULATION_PRICING_NODE_ID_ASC = 'FACILITIES_STDDEV_POPULATION_PRICING_NODE_ID_ASC',
  FACILITIES_STDDEV_POPULATION_PRICING_NODE_ID_DESC = 'FACILITIES_STDDEV_POPULATION_PRICING_NODE_ID_DESC',
  FACILITIES_STDDEV_POPULATION_REAL_TIME_ENABLED_ASC = 'FACILITIES_STDDEV_POPULATION_REAL_TIME_ENABLED_ASC',
  FACILITIES_STDDEV_POPULATION_REAL_TIME_ENABLED_DESC = 'FACILITIES_STDDEV_POPULATION_REAL_TIME_ENABLED_DESC',
  FACILITIES_STDDEV_POPULATION_REFRIGERATIONVENDOR_ASC = 'FACILITIES_STDDEV_POPULATION_REFRIGERATIONVENDOR_ASC',
  FACILITIES_STDDEV_POPULATION_REFRIGERATIONVENDOR_DESC = 'FACILITIES_STDDEV_POPULATION_REFRIGERATIONVENDOR_DESC',
  FACILITIES_STDDEV_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_STDDEV_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_STDDEV_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_STDDEV_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_STDDEV_POPULATION_RETIRED_AT_ASC = 'FACILITIES_STDDEV_POPULATION_RETIRED_AT_ASC',
  FACILITIES_STDDEV_POPULATION_RETIRED_AT_DESC = 'FACILITIES_STDDEV_POPULATION_RETIRED_AT_DESC',
  FACILITIES_STDDEV_POPULATION_SLUG_ASC = 'FACILITIES_STDDEV_POPULATION_SLUG_ASC',
  FACILITIES_STDDEV_POPULATION_SLUG_DESC = 'FACILITIES_STDDEV_POPULATION_SLUG_DESC',
  FACILITIES_STDDEV_POPULATION_STATE_ASC = 'FACILITIES_STDDEV_POPULATION_STATE_ASC',
  FACILITIES_STDDEV_POPULATION_STATE_DESC = 'FACILITIES_STDDEV_POPULATION_STATE_DESC',
  FACILITIES_STDDEV_POPULATION_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_STDDEV_POPULATION_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_STDDEV_POPULATION_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_STDDEV_POPULATION_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_STDDEV_POPULATION_TIMEZONE_NAME_ASC = 'FACILITIES_STDDEV_POPULATION_TIMEZONE_NAME_ASC',
  FACILITIES_STDDEV_POPULATION_TIMEZONE_NAME_DESC = 'FACILITIES_STDDEV_POPULATION_TIMEZONE_NAME_DESC',
  FACILITIES_STDDEV_POPULATION_UNIT_GROUP_ASC = 'FACILITIES_STDDEV_POPULATION_UNIT_GROUP_ASC',
  FACILITIES_STDDEV_POPULATION_UNIT_GROUP_DESC = 'FACILITIES_STDDEV_POPULATION_UNIT_GROUP_DESC',
  FACILITIES_STDDEV_POPULATION_UPDATED_AT_ASC = 'FACILITIES_STDDEV_POPULATION_UPDATED_AT_ASC',
  FACILITIES_STDDEV_POPULATION_UPDATED_AT_DESC = 'FACILITIES_STDDEV_POPULATION_UPDATED_AT_DESC',
  FACILITIES_STDDEV_POPULATION_ZIP_ASC = 'FACILITIES_STDDEV_POPULATION_ZIP_ASC',
  FACILITIES_STDDEV_POPULATION_ZIP_DESC = 'FACILITIES_STDDEV_POPULATION_ZIP_DESC',
  FACILITIES_STDDEV_SAMPLE_ADDRESS_ASC = 'FACILITIES_STDDEV_SAMPLE_ADDRESS_ASC',
  FACILITIES_STDDEV_SAMPLE_ADDRESS_DESC = 'FACILITIES_STDDEV_SAMPLE_ADDRESS_DESC',
  FACILITIES_STDDEV_SAMPLE_BONUS_LTR_ASC = 'FACILITIES_STDDEV_SAMPLE_BONUS_LTR_ASC',
  FACILITIES_STDDEV_SAMPLE_BONUS_LTR_DESC = 'FACILITIES_STDDEV_SAMPLE_BONUS_LTR_DESC',
  FACILITIES_STDDEV_SAMPLE_CITY_ASC = 'FACILITIES_STDDEV_SAMPLE_CITY_ASC',
  FACILITIES_STDDEV_SAMPLE_CITY_DESC = 'FACILITIES_STDDEV_SAMPLE_CITY_DESC',
  FACILITIES_STDDEV_SAMPLE_CONTXT_9249_ASC = 'FACILITIES_STDDEV_SAMPLE_CONTXT_9249_ASC',
  FACILITIES_STDDEV_SAMPLE_CONTXT_9249_DESC = 'FACILITIES_STDDEV_SAMPLE_CONTXT_9249_DESC',
  FACILITIES_STDDEV_SAMPLE_COUNTRY_ASC = 'FACILITIES_STDDEV_SAMPLE_COUNTRY_ASC',
  FACILITIES_STDDEV_SAMPLE_COUNTRY_DESC = 'FACILITIES_STDDEV_SAMPLE_COUNTRY_DESC',
  FACILITIES_STDDEV_SAMPLE_CREATED_AT_ASC = 'FACILITIES_STDDEV_SAMPLE_CREATED_AT_ASC',
  FACILITIES_STDDEV_SAMPLE_CREATED_AT_DESC = 'FACILITIES_STDDEV_SAMPLE_CREATED_AT_DESC',
  FACILITIES_STDDEV_SAMPLE_DATATYPE_1_TEST_ASC = 'FACILITIES_STDDEV_SAMPLE_DATATYPE_1_TEST_ASC',
  FACILITIES_STDDEV_SAMPLE_DATATYPE_1_TEST_DESC = 'FACILITIES_STDDEV_SAMPLE_DATATYPE_1_TEST_DESC',
  FACILITIES_STDDEV_SAMPLE_DATA_TYPE_2_TEST_ASC = 'FACILITIES_STDDEV_SAMPLE_DATA_TYPE_2_TEST_ASC',
  FACILITIES_STDDEV_SAMPLE_DATA_TYPE_2_TEST_DESC = 'FACILITIES_STDDEV_SAMPLE_DATA_TYPE_2_TEST_DESC',
  FACILITIES_STDDEV_SAMPLE_DATA_TYPE_3_TEST_ASC = 'FACILITIES_STDDEV_SAMPLE_DATA_TYPE_3_TEST_ASC',
  FACILITIES_STDDEV_SAMPLE_DATA_TYPE_3_TEST_DESC = 'FACILITIES_STDDEV_SAMPLE_DATA_TYPE_3_TEST_DESC',
  FACILITIES_STDDEV_SAMPLE_FACILITY_CONTACTS_ASC = 'FACILITIES_STDDEV_SAMPLE_FACILITY_CONTACTS_ASC',
  FACILITIES_STDDEV_SAMPLE_FACILITY_CONTACTS_DESC = 'FACILITIES_STDDEV_SAMPLE_FACILITY_CONTACTS_DESC',
  FACILITIES_STDDEV_SAMPLE_GEOMETRY_ASC = 'FACILITIES_STDDEV_SAMPLE_GEOMETRY_ASC',
  FACILITIES_STDDEV_SAMPLE_GEOMETRY_DESC = 'FACILITIES_STDDEV_SAMPLE_GEOMETRY_DESC',
  FACILITIES_STDDEV_SAMPLE_ID_ASC = 'FACILITIES_STDDEV_SAMPLE_ID_ASC',
  FACILITIES_STDDEV_SAMPLE_ID_DESC = 'FACILITIES_STDDEV_SAMPLE_ID_DESC',
  FACILITIES_STDDEV_SAMPLE_LATITUDE_ASC = 'FACILITIES_STDDEV_SAMPLE_LATITUDE_ASC',
  FACILITIES_STDDEV_SAMPLE_LATITUDE_DESC = 'FACILITIES_STDDEV_SAMPLE_LATITUDE_DESC',
  FACILITIES_STDDEV_SAMPLE_LINK_ACTIVE_ASC = 'FACILITIES_STDDEV_SAMPLE_LINK_ACTIVE_ASC',
  FACILITIES_STDDEV_SAMPLE_LINK_ACTIVE_DESC = 'FACILITIES_STDDEV_SAMPLE_LINK_ACTIVE_DESC',
  FACILITIES_STDDEV_SAMPLE_LONGITUDE_ASC = 'FACILITIES_STDDEV_SAMPLE_LONGITUDE_ASC',
  FACILITIES_STDDEV_SAMPLE_LONGITUDE_DESC = 'FACILITIES_STDDEV_SAMPLE_LONGITUDE_DESC',
  FACILITIES_STDDEV_SAMPLE_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_STDDEV_SAMPLE_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_STDDEV_SAMPLE_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_STDDEV_SAMPLE_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_STDDEV_SAMPLE_NAME_ASC = 'FACILITIES_STDDEV_SAMPLE_NAME_ASC',
  FACILITIES_STDDEV_SAMPLE_NAME_DESC = 'FACILITIES_STDDEV_SAMPLE_NAME_DESC',
  FACILITIES_STDDEV_SAMPLE_NOTE_ASC = 'FACILITIES_STDDEV_SAMPLE_NOTE_ASC',
  FACILITIES_STDDEV_SAMPLE_NOTE_DESC = 'FACILITIES_STDDEV_SAMPLE_NOTE_DESC',
  FACILITIES_STDDEV_SAMPLE_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_STDDEV_SAMPLE_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_STDDEV_SAMPLE_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_STDDEV_SAMPLE_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_STDDEV_SAMPLE_N_SIGHT_ACTIVE_ASC = 'FACILITIES_STDDEV_SAMPLE_N_SIGHT_ACTIVE_ASC',
  FACILITIES_STDDEV_SAMPLE_N_SIGHT_ACTIVE_DESC = 'FACILITIES_STDDEV_SAMPLE_N_SIGHT_ACTIVE_DESC',
  FACILITIES_STDDEV_SAMPLE_PRE_BONUS_EBITDA_ASC = 'FACILITIES_STDDEV_SAMPLE_PRE_BONUS_EBITDA_ASC',
  FACILITIES_STDDEV_SAMPLE_PRE_BONUS_EBITDA_DESC = 'FACILITIES_STDDEV_SAMPLE_PRE_BONUS_EBITDA_DESC',
  FACILITIES_STDDEV_SAMPLE_PRICING_NODE_ID_ASC = 'FACILITIES_STDDEV_SAMPLE_PRICING_NODE_ID_ASC',
  FACILITIES_STDDEV_SAMPLE_PRICING_NODE_ID_DESC = 'FACILITIES_STDDEV_SAMPLE_PRICING_NODE_ID_DESC',
  FACILITIES_STDDEV_SAMPLE_REAL_TIME_ENABLED_ASC = 'FACILITIES_STDDEV_SAMPLE_REAL_TIME_ENABLED_ASC',
  FACILITIES_STDDEV_SAMPLE_REAL_TIME_ENABLED_DESC = 'FACILITIES_STDDEV_SAMPLE_REAL_TIME_ENABLED_DESC',
  FACILITIES_STDDEV_SAMPLE_REFRIGERATIONVENDOR_ASC = 'FACILITIES_STDDEV_SAMPLE_REFRIGERATIONVENDOR_ASC',
  FACILITIES_STDDEV_SAMPLE_REFRIGERATIONVENDOR_DESC = 'FACILITIES_STDDEV_SAMPLE_REFRIGERATIONVENDOR_DESC',
  FACILITIES_STDDEV_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_STDDEV_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_STDDEV_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_STDDEV_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_STDDEV_SAMPLE_RETIRED_AT_ASC = 'FACILITIES_STDDEV_SAMPLE_RETIRED_AT_ASC',
  FACILITIES_STDDEV_SAMPLE_RETIRED_AT_DESC = 'FACILITIES_STDDEV_SAMPLE_RETIRED_AT_DESC',
  FACILITIES_STDDEV_SAMPLE_SLUG_ASC = 'FACILITIES_STDDEV_SAMPLE_SLUG_ASC',
  FACILITIES_STDDEV_SAMPLE_SLUG_DESC = 'FACILITIES_STDDEV_SAMPLE_SLUG_DESC',
  FACILITIES_STDDEV_SAMPLE_STATE_ASC = 'FACILITIES_STDDEV_SAMPLE_STATE_ASC',
  FACILITIES_STDDEV_SAMPLE_STATE_DESC = 'FACILITIES_STDDEV_SAMPLE_STATE_DESC',
  FACILITIES_STDDEV_SAMPLE_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_STDDEV_SAMPLE_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_STDDEV_SAMPLE_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_STDDEV_SAMPLE_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_STDDEV_SAMPLE_TIMEZONE_NAME_ASC = 'FACILITIES_STDDEV_SAMPLE_TIMEZONE_NAME_ASC',
  FACILITIES_STDDEV_SAMPLE_TIMEZONE_NAME_DESC = 'FACILITIES_STDDEV_SAMPLE_TIMEZONE_NAME_DESC',
  FACILITIES_STDDEV_SAMPLE_UNIT_GROUP_ASC = 'FACILITIES_STDDEV_SAMPLE_UNIT_GROUP_ASC',
  FACILITIES_STDDEV_SAMPLE_UNIT_GROUP_DESC = 'FACILITIES_STDDEV_SAMPLE_UNIT_GROUP_DESC',
  FACILITIES_STDDEV_SAMPLE_UPDATED_AT_ASC = 'FACILITIES_STDDEV_SAMPLE_UPDATED_AT_ASC',
  FACILITIES_STDDEV_SAMPLE_UPDATED_AT_DESC = 'FACILITIES_STDDEV_SAMPLE_UPDATED_AT_DESC',
  FACILITIES_STDDEV_SAMPLE_ZIP_ASC = 'FACILITIES_STDDEV_SAMPLE_ZIP_ASC',
  FACILITIES_STDDEV_SAMPLE_ZIP_DESC = 'FACILITIES_STDDEV_SAMPLE_ZIP_DESC',
  FACILITIES_SUM_ADDRESS_ASC = 'FACILITIES_SUM_ADDRESS_ASC',
  FACILITIES_SUM_ADDRESS_DESC = 'FACILITIES_SUM_ADDRESS_DESC',
  FACILITIES_SUM_BONUS_LTR_ASC = 'FACILITIES_SUM_BONUS_LTR_ASC',
  FACILITIES_SUM_BONUS_LTR_DESC = 'FACILITIES_SUM_BONUS_LTR_DESC',
  FACILITIES_SUM_CITY_ASC = 'FACILITIES_SUM_CITY_ASC',
  FACILITIES_SUM_CITY_DESC = 'FACILITIES_SUM_CITY_DESC',
  FACILITIES_SUM_CONTXT_9249_ASC = 'FACILITIES_SUM_CONTXT_9249_ASC',
  FACILITIES_SUM_CONTXT_9249_DESC = 'FACILITIES_SUM_CONTXT_9249_DESC',
  FACILITIES_SUM_COUNTRY_ASC = 'FACILITIES_SUM_COUNTRY_ASC',
  FACILITIES_SUM_COUNTRY_DESC = 'FACILITIES_SUM_COUNTRY_DESC',
  FACILITIES_SUM_CREATED_AT_ASC = 'FACILITIES_SUM_CREATED_AT_ASC',
  FACILITIES_SUM_CREATED_AT_DESC = 'FACILITIES_SUM_CREATED_AT_DESC',
  FACILITIES_SUM_DATATYPE_1_TEST_ASC = 'FACILITIES_SUM_DATATYPE_1_TEST_ASC',
  FACILITIES_SUM_DATATYPE_1_TEST_DESC = 'FACILITIES_SUM_DATATYPE_1_TEST_DESC',
  FACILITIES_SUM_DATA_TYPE_2_TEST_ASC = 'FACILITIES_SUM_DATA_TYPE_2_TEST_ASC',
  FACILITIES_SUM_DATA_TYPE_2_TEST_DESC = 'FACILITIES_SUM_DATA_TYPE_2_TEST_DESC',
  FACILITIES_SUM_DATA_TYPE_3_TEST_ASC = 'FACILITIES_SUM_DATA_TYPE_3_TEST_ASC',
  FACILITIES_SUM_DATA_TYPE_3_TEST_DESC = 'FACILITIES_SUM_DATA_TYPE_3_TEST_DESC',
  FACILITIES_SUM_FACILITY_CONTACTS_ASC = 'FACILITIES_SUM_FACILITY_CONTACTS_ASC',
  FACILITIES_SUM_FACILITY_CONTACTS_DESC = 'FACILITIES_SUM_FACILITY_CONTACTS_DESC',
  FACILITIES_SUM_GEOMETRY_ASC = 'FACILITIES_SUM_GEOMETRY_ASC',
  FACILITIES_SUM_GEOMETRY_DESC = 'FACILITIES_SUM_GEOMETRY_DESC',
  FACILITIES_SUM_ID_ASC = 'FACILITIES_SUM_ID_ASC',
  FACILITIES_SUM_ID_DESC = 'FACILITIES_SUM_ID_DESC',
  FACILITIES_SUM_LATITUDE_ASC = 'FACILITIES_SUM_LATITUDE_ASC',
  FACILITIES_SUM_LATITUDE_DESC = 'FACILITIES_SUM_LATITUDE_DESC',
  FACILITIES_SUM_LINK_ACTIVE_ASC = 'FACILITIES_SUM_LINK_ACTIVE_ASC',
  FACILITIES_SUM_LINK_ACTIVE_DESC = 'FACILITIES_SUM_LINK_ACTIVE_DESC',
  FACILITIES_SUM_LONGITUDE_ASC = 'FACILITIES_SUM_LONGITUDE_ASC',
  FACILITIES_SUM_LONGITUDE_DESC = 'FACILITIES_SUM_LONGITUDE_DESC',
  FACILITIES_SUM_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_SUM_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_SUM_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_SUM_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_SUM_NAME_ASC = 'FACILITIES_SUM_NAME_ASC',
  FACILITIES_SUM_NAME_DESC = 'FACILITIES_SUM_NAME_DESC',
  FACILITIES_SUM_NOTE_ASC = 'FACILITIES_SUM_NOTE_ASC',
  FACILITIES_SUM_NOTE_DESC = 'FACILITIES_SUM_NOTE_DESC',
  FACILITIES_SUM_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_SUM_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_SUM_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_SUM_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_SUM_N_SIGHT_ACTIVE_ASC = 'FACILITIES_SUM_N_SIGHT_ACTIVE_ASC',
  FACILITIES_SUM_N_SIGHT_ACTIVE_DESC = 'FACILITIES_SUM_N_SIGHT_ACTIVE_DESC',
  FACILITIES_SUM_PRE_BONUS_EBITDA_ASC = 'FACILITIES_SUM_PRE_BONUS_EBITDA_ASC',
  FACILITIES_SUM_PRE_BONUS_EBITDA_DESC = 'FACILITIES_SUM_PRE_BONUS_EBITDA_DESC',
  FACILITIES_SUM_PRICING_NODE_ID_ASC = 'FACILITIES_SUM_PRICING_NODE_ID_ASC',
  FACILITIES_SUM_PRICING_NODE_ID_DESC = 'FACILITIES_SUM_PRICING_NODE_ID_DESC',
  FACILITIES_SUM_REAL_TIME_ENABLED_ASC = 'FACILITIES_SUM_REAL_TIME_ENABLED_ASC',
  FACILITIES_SUM_REAL_TIME_ENABLED_DESC = 'FACILITIES_SUM_REAL_TIME_ENABLED_DESC',
  FACILITIES_SUM_REFRIGERATIONVENDOR_ASC = 'FACILITIES_SUM_REFRIGERATIONVENDOR_ASC',
  FACILITIES_SUM_REFRIGERATIONVENDOR_DESC = 'FACILITIES_SUM_REFRIGERATIONVENDOR_DESC',
  FACILITIES_SUM_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_SUM_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_SUM_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_SUM_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_SUM_RETIRED_AT_ASC = 'FACILITIES_SUM_RETIRED_AT_ASC',
  FACILITIES_SUM_RETIRED_AT_DESC = 'FACILITIES_SUM_RETIRED_AT_DESC',
  FACILITIES_SUM_SLUG_ASC = 'FACILITIES_SUM_SLUG_ASC',
  FACILITIES_SUM_SLUG_DESC = 'FACILITIES_SUM_SLUG_DESC',
  FACILITIES_SUM_STATE_ASC = 'FACILITIES_SUM_STATE_ASC',
  FACILITIES_SUM_STATE_DESC = 'FACILITIES_SUM_STATE_DESC',
  FACILITIES_SUM_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_SUM_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_SUM_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_SUM_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_SUM_TIMEZONE_NAME_ASC = 'FACILITIES_SUM_TIMEZONE_NAME_ASC',
  FACILITIES_SUM_TIMEZONE_NAME_DESC = 'FACILITIES_SUM_TIMEZONE_NAME_DESC',
  FACILITIES_SUM_UNIT_GROUP_ASC = 'FACILITIES_SUM_UNIT_GROUP_ASC',
  FACILITIES_SUM_UNIT_GROUP_DESC = 'FACILITIES_SUM_UNIT_GROUP_DESC',
  FACILITIES_SUM_UPDATED_AT_ASC = 'FACILITIES_SUM_UPDATED_AT_ASC',
  FACILITIES_SUM_UPDATED_AT_DESC = 'FACILITIES_SUM_UPDATED_AT_DESC',
  FACILITIES_SUM_ZIP_ASC = 'FACILITIES_SUM_ZIP_ASC',
  FACILITIES_SUM_ZIP_DESC = 'FACILITIES_SUM_ZIP_DESC',
  FACILITIES_VARIANCE_POPULATION_ADDRESS_ASC = 'FACILITIES_VARIANCE_POPULATION_ADDRESS_ASC',
  FACILITIES_VARIANCE_POPULATION_ADDRESS_DESC = 'FACILITIES_VARIANCE_POPULATION_ADDRESS_DESC',
  FACILITIES_VARIANCE_POPULATION_BONUS_LTR_ASC = 'FACILITIES_VARIANCE_POPULATION_BONUS_LTR_ASC',
  FACILITIES_VARIANCE_POPULATION_BONUS_LTR_DESC = 'FACILITIES_VARIANCE_POPULATION_BONUS_LTR_DESC',
  FACILITIES_VARIANCE_POPULATION_CITY_ASC = 'FACILITIES_VARIANCE_POPULATION_CITY_ASC',
  FACILITIES_VARIANCE_POPULATION_CITY_DESC = 'FACILITIES_VARIANCE_POPULATION_CITY_DESC',
  FACILITIES_VARIANCE_POPULATION_CONTXT_9249_ASC = 'FACILITIES_VARIANCE_POPULATION_CONTXT_9249_ASC',
  FACILITIES_VARIANCE_POPULATION_CONTXT_9249_DESC = 'FACILITIES_VARIANCE_POPULATION_CONTXT_9249_DESC',
  FACILITIES_VARIANCE_POPULATION_COUNTRY_ASC = 'FACILITIES_VARIANCE_POPULATION_COUNTRY_ASC',
  FACILITIES_VARIANCE_POPULATION_COUNTRY_DESC = 'FACILITIES_VARIANCE_POPULATION_COUNTRY_DESC',
  FACILITIES_VARIANCE_POPULATION_CREATED_AT_ASC = 'FACILITIES_VARIANCE_POPULATION_CREATED_AT_ASC',
  FACILITIES_VARIANCE_POPULATION_CREATED_AT_DESC = 'FACILITIES_VARIANCE_POPULATION_CREATED_AT_DESC',
  FACILITIES_VARIANCE_POPULATION_DATATYPE_1_TEST_ASC = 'FACILITIES_VARIANCE_POPULATION_DATATYPE_1_TEST_ASC',
  FACILITIES_VARIANCE_POPULATION_DATATYPE_1_TEST_DESC = 'FACILITIES_VARIANCE_POPULATION_DATATYPE_1_TEST_DESC',
  FACILITIES_VARIANCE_POPULATION_DATA_TYPE_2_TEST_ASC = 'FACILITIES_VARIANCE_POPULATION_DATA_TYPE_2_TEST_ASC',
  FACILITIES_VARIANCE_POPULATION_DATA_TYPE_2_TEST_DESC = 'FACILITIES_VARIANCE_POPULATION_DATA_TYPE_2_TEST_DESC',
  FACILITIES_VARIANCE_POPULATION_DATA_TYPE_3_TEST_ASC = 'FACILITIES_VARIANCE_POPULATION_DATA_TYPE_3_TEST_ASC',
  FACILITIES_VARIANCE_POPULATION_DATA_TYPE_3_TEST_DESC = 'FACILITIES_VARIANCE_POPULATION_DATA_TYPE_3_TEST_DESC',
  FACILITIES_VARIANCE_POPULATION_FACILITY_CONTACTS_ASC = 'FACILITIES_VARIANCE_POPULATION_FACILITY_CONTACTS_ASC',
  FACILITIES_VARIANCE_POPULATION_FACILITY_CONTACTS_DESC = 'FACILITIES_VARIANCE_POPULATION_FACILITY_CONTACTS_DESC',
  FACILITIES_VARIANCE_POPULATION_GEOMETRY_ASC = 'FACILITIES_VARIANCE_POPULATION_GEOMETRY_ASC',
  FACILITIES_VARIANCE_POPULATION_GEOMETRY_DESC = 'FACILITIES_VARIANCE_POPULATION_GEOMETRY_DESC',
  FACILITIES_VARIANCE_POPULATION_ID_ASC = 'FACILITIES_VARIANCE_POPULATION_ID_ASC',
  FACILITIES_VARIANCE_POPULATION_ID_DESC = 'FACILITIES_VARIANCE_POPULATION_ID_DESC',
  FACILITIES_VARIANCE_POPULATION_LATITUDE_ASC = 'FACILITIES_VARIANCE_POPULATION_LATITUDE_ASC',
  FACILITIES_VARIANCE_POPULATION_LATITUDE_DESC = 'FACILITIES_VARIANCE_POPULATION_LATITUDE_DESC',
  FACILITIES_VARIANCE_POPULATION_LINK_ACTIVE_ASC = 'FACILITIES_VARIANCE_POPULATION_LINK_ACTIVE_ASC',
  FACILITIES_VARIANCE_POPULATION_LINK_ACTIVE_DESC = 'FACILITIES_VARIANCE_POPULATION_LINK_ACTIVE_DESC',
  FACILITIES_VARIANCE_POPULATION_LONGITUDE_ASC = 'FACILITIES_VARIANCE_POPULATION_LONGITUDE_ASC',
  FACILITIES_VARIANCE_POPULATION_LONGITUDE_DESC = 'FACILITIES_VARIANCE_POPULATION_LONGITUDE_DESC',
  FACILITIES_VARIANCE_POPULATION_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_VARIANCE_POPULATION_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_VARIANCE_POPULATION_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_VARIANCE_POPULATION_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_VARIANCE_POPULATION_NAME_ASC = 'FACILITIES_VARIANCE_POPULATION_NAME_ASC',
  FACILITIES_VARIANCE_POPULATION_NAME_DESC = 'FACILITIES_VARIANCE_POPULATION_NAME_DESC',
  FACILITIES_VARIANCE_POPULATION_NOTE_ASC = 'FACILITIES_VARIANCE_POPULATION_NOTE_ASC',
  FACILITIES_VARIANCE_POPULATION_NOTE_DESC = 'FACILITIES_VARIANCE_POPULATION_NOTE_DESC',
  FACILITIES_VARIANCE_POPULATION_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_VARIANCE_POPULATION_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_VARIANCE_POPULATION_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_VARIANCE_POPULATION_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_VARIANCE_POPULATION_N_SIGHT_ACTIVE_ASC = 'FACILITIES_VARIANCE_POPULATION_N_SIGHT_ACTIVE_ASC',
  FACILITIES_VARIANCE_POPULATION_N_SIGHT_ACTIVE_DESC = 'FACILITIES_VARIANCE_POPULATION_N_SIGHT_ACTIVE_DESC',
  FACILITIES_VARIANCE_POPULATION_PRE_BONUS_EBITDA_ASC = 'FACILITIES_VARIANCE_POPULATION_PRE_BONUS_EBITDA_ASC',
  FACILITIES_VARIANCE_POPULATION_PRE_BONUS_EBITDA_DESC = 'FACILITIES_VARIANCE_POPULATION_PRE_BONUS_EBITDA_DESC',
  FACILITIES_VARIANCE_POPULATION_PRICING_NODE_ID_ASC = 'FACILITIES_VARIANCE_POPULATION_PRICING_NODE_ID_ASC',
  FACILITIES_VARIANCE_POPULATION_PRICING_NODE_ID_DESC = 'FACILITIES_VARIANCE_POPULATION_PRICING_NODE_ID_DESC',
  FACILITIES_VARIANCE_POPULATION_REAL_TIME_ENABLED_ASC = 'FACILITIES_VARIANCE_POPULATION_REAL_TIME_ENABLED_ASC',
  FACILITIES_VARIANCE_POPULATION_REAL_TIME_ENABLED_DESC = 'FACILITIES_VARIANCE_POPULATION_REAL_TIME_ENABLED_DESC',
  FACILITIES_VARIANCE_POPULATION_REFRIGERATIONVENDOR_ASC = 'FACILITIES_VARIANCE_POPULATION_REFRIGERATIONVENDOR_ASC',
  FACILITIES_VARIANCE_POPULATION_REFRIGERATIONVENDOR_DESC = 'FACILITIES_VARIANCE_POPULATION_REFRIGERATIONVENDOR_DESC',
  FACILITIES_VARIANCE_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_VARIANCE_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_VARIANCE_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_VARIANCE_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_VARIANCE_POPULATION_RETIRED_AT_ASC = 'FACILITIES_VARIANCE_POPULATION_RETIRED_AT_ASC',
  FACILITIES_VARIANCE_POPULATION_RETIRED_AT_DESC = 'FACILITIES_VARIANCE_POPULATION_RETIRED_AT_DESC',
  FACILITIES_VARIANCE_POPULATION_SLUG_ASC = 'FACILITIES_VARIANCE_POPULATION_SLUG_ASC',
  FACILITIES_VARIANCE_POPULATION_SLUG_DESC = 'FACILITIES_VARIANCE_POPULATION_SLUG_DESC',
  FACILITIES_VARIANCE_POPULATION_STATE_ASC = 'FACILITIES_VARIANCE_POPULATION_STATE_ASC',
  FACILITIES_VARIANCE_POPULATION_STATE_DESC = 'FACILITIES_VARIANCE_POPULATION_STATE_DESC',
  FACILITIES_VARIANCE_POPULATION_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_VARIANCE_POPULATION_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_VARIANCE_POPULATION_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_VARIANCE_POPULATION_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_VARIANCE_POPULATION_TIMEZONE_NAME_ASC = 'FACILITIES_VARIANCE_POPULATION_TIMEZONE_NAME_ASC',
  FACILITIES_VARIANCE_POPULATION_TIMEZONE_NAME_DESC = 'FACILITIES_VARIANCE_POPULATION_TIMEZONE_NAME_DESC',
  FACILITIES_VARIANCE_POPULATION_UNIT_GROUP_ASC = 'FACILITIES_VARIANCE_POPULATION_UNIT_GROUP_ASC',
  FACILITIES_VARIANCE_POPULATION_UNIT_GROUP_DESC = 'FACILITIES_VARIANCE_POPULATION_UNIT_GROUP_DESC',
  FACILITIES_VARIANCE_POPULATION_UPDATED_AT_ASC = 'FACILITIES_VARIANCE_POPULATION_UPDATED_AT_ASC',
  FACILITIES_VARIANCE_POPULATION_UPDATED_AT_DESC = 'FACILITIES_VARIANCE_POPULATION_UPDATED_AT_DESC',
  FACILITIES_VARIANCE_POPULATION_ZIP_ASC = 'FACILITIES_VARIANCE_POPULATION_ZIP_ASC',
  FACILITIES_VARIANCE_POPULATION_ZIP_DESC = 'FACILITIES_VARIANCE_POPULATION_ZIP_DESC',
  FACILITIES_VARIANCE_SAMPLE_ADDRESS_ASC = 'FACILITIES_VARIANCE_SAMPLE_ADDRESS_ASC',
  FACILITIES_VARIANCE_SAMPLE_ADDRESS_DESC = 'FACILITIES_VARIANCE_SAMPLE_ADDRESS_DESC',
  FACILITIES_VARIANCE_SAMPLE_BONUS_LTR_ASC = 'FACILITIES_VARIANCE_SAMPLE_BONUS_LTR_ASC',
  FACILITIES_VARIANCE_SAMPLE_BONUS_LTR_DESC = 'FACILITIES_VARIANCE_SAMPLE_BONUS_LTR_DESC',
  FACILITIES_VARIANCE_SAMPLE_CITY_ASC = 'FACILITIES_VARIANCE_SAMPLE_CITY_ASC',
  FACILITIES_VARIANCE_SAMPLE_CITY_DESC = 'FACILITIES_VARIANCE_SAMPLE_CITY_DESC',
  FACILITIES_VARIANCE_SAMPLE_CONTXT_9249_ASC = 'FACILITIES_VARIANCE_SAMPLE_CONTXT_9249_ASC',
  FACILITIES_VARIANCE_SAMPLE_CONTXT_9249_DESC = 'FACILITIES_VARIANCE_SAMPLE_CONTXT_9249_DESC',
  FACILITIES_VARIANCE_SAMPLE_COUNTRY_ASC = 'FACILITIES_VARIANCE_SAMPLE_COUNTRY_ASC',
  FACILITIES_VARIANCE_SAMPLE_COUNTRY_DESC = 'FACILITIES_VARIANCE_SAMPLE_COUNTRY_DESC',
  FACILITIES_VARIANCE_SAMPLE_CREATED_AT_ASC = 'FACILITIES_VARIANCE_SAMPLE_CREATED_AT_ASC',
  FACILITIES_VARIANCE_SAMPLE_CREATED_AT_DESC = 'FACILITIES_VARIANCE_SAMPLE_CREATED_AT_DESC',
  FACILITIES_VARIANCE_SAMPLE_DATATYPE_1_TEST_ASC = 'FACILITIES_VARIANCE_SAMPLE_DATATYPE_1_TEST_ASC',
  FACILITIES_VARIANCE_SAMPLE_DATATYPE_1_TEST_DESC = 'FACILITIES_VARIANCE_SAMPLE_DATATYPE_1_TEST_DESC',
  FACILITIES_VARIANCE_SAMPLE_DATA_TYPE_2_TEST_ASC = 'FACILITIES_VARIANCE_SAMPLE_DATA_TYPE_2_TEST_ASC',
  FACILITIES_VARIANCE_SAMPLE_DATA_TYPE_2_TEST_DESC = 'FACILITIES_VARIANCE_SAMPLE_DATA_TYPE_2_TEST_DESC',
  FACILITIES_VARIANCE_SAMPLE_DATA_TYPE_3_TEST_ASC = 'FACILITIES_VARIANCE_SAMPLE_DATA_TYPE_3_TEST_ASC',
  FACILITIES_VARIANCE_SAMPLE_DATA_TYPE_3_TEST_DESC = 'FACILITIES_VARIANCE_SAMPLE_DATA_TYPE_3_TEST_DESC',
  FACILITIES_VARIANCE_SAMPLE_FACILITY_CONTACTS_ASC = 'FACILITIES_VARIANCE_SAMPLE_FACILITY_CONTACTS_ASC',
  FACILITIES_VARIANCE_SAMPLE_FACILITY_CONTACTS_DESC = 'FACILITIES_VARIANCE_SAMPLE_FACILITY_CONTACTS_DESC',
  FACILITIES_VARIANCE_SAMPLE_GEOMETRY_ASC = 'FACILITIES_VARIANCE_SAMPLE_GEOMETRY_ASC',
  FACILITIES_VARIANCE_SAMPLE_GEOMETRY_DESC = 'FACILITIES_VARIANCE_SAMPLE_GEOMETRY_DESC',
  FACILITIES_VARIANCE_SAMPLE_ID_ASC = 'FACILITIES_VARIANCE_SAMPLE_ID_ASC',
  FACILITIES_VARIANCE_SAMPLE_ID_DESC = 'FACILITIES_VARIANCE_SAMPLE_ID_DESC',
  FACILITIES_VARIANCE_SAMPLE_LATITUDE_ASC = 'FACILITIES_VARIANCE_SAMPLE_LATITUDE_ASC',
  FACILITIES_VARIANCE_SAMPLE_LATITUDE_DESC = 'FACILITIES_VARIANCE_SAMPLE_LATITUDE_DESC',
  FACILITIES_VARIANCE_SAMPLE_LINK_ACTIVE_ASC = 'FACILITIES_VARIANCE_SAMPLE_LINK_ACTIVE_ASC',
  FACILITIES_VARIANCE_SAMPLE_LINK_ACTIVE_DESC = 'FACILITIES_VARIANCE_SAMPLE_LINK_ACTIVE_DESC',
  FACILITIES_VARIANCE_SAMPLE_LONGITUDE_ASC = 'FACILITIES_VARIANCE_SAMPLE_LONGITUDE_ASC',
  FACILITIES_VARIANCE_SAMPLE_LONGITUDE_DESC = 'FACILITIES_VARIANCE_SAMPLE_LONGITUDE_DESC',
  FACILITIES_VARIANCE_SAMPLE_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_VARIANCE_SAMPLE_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_VARIANCE_SAMPLE_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_VARIANCE_SAMPLE_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_VARIANCE_SAMPLE_NAME_ASC = 'FACILITIES_VARIANCE_SAMPLE_NAME_ASC',
  FACILITIES_VARIANCE_SAMPLE_NAME_DESC = 'FACILITIES_VARIANCE_SAMPLE_NAME_DESC',
  FACILITIES_VARIANCE_SAMPLE_NOTE_ASC = 'FACILITIES_VARIANCE_SAMPLE_NOTE_ASC',
  FACILITIES_VARIANCE_SAMPLE_NOTE_DESC = 'FACILITIES_VARIANCE_SAMPLE_NOTE_DESC',
  FACILITIES_VARIANCE_SAMPLE_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_VARIANCE_SAMPLE_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_VARIANCE_SAMPLE_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_VARIANCE_SAMPLE_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_VARIANCE_SAMPLE_N_SIGHT_ACTIVE_ASC = 'FACILITIES_VARIANCE_SAMPLE_N_SIGHT_ACTIVE_ASC',
  FACILITIES_VARIANCE_SAMPLE_N_SIGHT_ACTIVE_DESC = 'FACILITIES_VARIANCE_SAMPLE_N_SIGHT_ACTIVE_DESC',
  FACILITIES_VARIANCE_SAMPLE_PRE_BONUS_EBITDA_ASC = 'FACILITIES_VARIANCE_SAMPLE_PRE_BONUS_EBITDA_ASC',
  FACILITIES_VARIANCE_SAMPLE_PRE_BONUS_EBITDA_DESC = 'FACILITIES_VARIANCE_SAMPLE_PRE_BONUS_EBITDA_DESC',
  FACILITIES_VARIANCE_SAMPLE_PRICING_NODE_ID_ASC = 'FACILITIES_VARIANCE_SAMPLE_PRICING_NODE_ID_ASC',
  FACILITIES_VARIANCE_SAMPLE_PRICING_NODE_ID_DESC = 'FACILITIES_VARIANCE_SAMPLE_PRICING_NODE_ID_DESC',
  FACILITIES_VARIANCE_SAMPLE_REAL_TIME_ENABLED_ASC = 'FACILITIES_VARIANCE_SAMPLE_REAL_TIME_ENABLED_ASC',
  FACILITIES_VARIANCE_SAMPLE_REAL_TIME_ENABLED_DESC = 'FACILITIES_VARIANCE_SAMPLE_REAL_TIME_ENABLED_DESC',
  FACILITIES_VARIANCE_SAMPLE_REFRIGERATIONVENDOR_ASC = 'FACILITIES_VARIANCE_SAMPLE_REFRIGERATIONVENDOR_ASC',
  FACILITIES_VARIANCE_SAMPLE_REFRIGERATIONVENDOR_DESC = 'FACILITIES_VARIANCE_SAMPLE_REFRIGERATIONVENDOR_DESC',
  FACILITIES_VARIANCE_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_VARIANCE_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_VARIANCE_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_VARIANCE_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_VARIANCE_SAMPLE_RETIRED_AT_ASC = 'FACILITIES_VARIANCE_SAMPLE_RETIRED_AT_ASC',
  FACILITIES_VARIANCE_SAMPLE_RETIRED_AT_DESC = 'FACILITIES_VARIANCE_SAMPLE_RETIRED_AT_DESC',
  FACILITIES_VARIANCE_SAMPLE_SLUG_ASC = 'FACILITIES_VARIANCE_SAMPLE_SLUG_ASC',
  FACILITIES_VARIANCE_SAMPLE_SLUG_DESC = 'FACILITIES_VARIANCE_SAMPLE_SLUG_DESC',
  FACILITIES_VARIANCE_SAMPLE_STATE_ASC = 'FACILITIES_VARIANCE_SAMPLE_STATE_ASC',
  FACILITIES_VARIANCE_SAMPLE_STATE_DESC = 'FACILITIES_VARIANCE_SAMPLE_STATE_DESC',
  FACILITIES_VARIANCE_SAMPLE_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_VARIANCE_SAMPLE_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_VARIANCE_SAMPLE_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_VARIANCE_SAMPLE_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_VARIANCE_SAMPLE_TIMEZONE_NAME_ASC = 'FACILITIES_VARIANCE_SAMPLE_TIMEZONE_NAME_ASC',
  FACILITIES_VARIANCE_SAMPLE_TIMEZONE_NAME_DESC = 'FACILITIES_VARIANCE_SAMPLE_TIMEZONE_NAME_DESC',
  FACILITIES_VARIANCE_SAMPLE_UNIT_GROUP_ASC = 'FACILITIES_VARIANCE_SAMPLE_UNIT_GROUP_ASC',
  FACILITIES_VARIANCE_SAMPLE_UNIT_GROUP_DESC = 'FACILITIES_VARIANCE_SAMPLE_UNIT_GROUP_DESC',
  FACILITIES_VARIANCE_SAMPLE_UPDATED_AT_ASC = 'FACILITIES_VARIANCE_SAMPLE_UPDATED_AT_ASC',
  FACILITIES_VARIANCE_SAMPLE_UPDATED_AT_DESC = 'FACILITIES_VARIANCE_SAMPLE_UPDATED_AT_DESC',
  FACILITIES_VARIANCE_SAMPLE_ZIP_ASC = 'FACILITIES_VARIANCE_SAMPLE_ZIP_ASC',
  FACILITIES_VARIANCE_SAMPLE_ZIP_DESC = 'FACILITIES_VARIANCE_SAMPLE_ZIP_DESC',
  GEOMETRY_ASC = 'GEOMETRY_ASC',
  GEOMETRY_DESC = 'GEOMETRY_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SLUG_ASC = 'SLUG_ASC',
  SLUG_DESC = 'SLUG_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

export type Product = Node & {
  __typename?: 'Product';
  /** Reads and enables pagination through a set of `Pallet`. */
  availablePallets: PalletsConnection;
  /** A readable category of the product */
  category?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  customer?: Maybe<Customer>;
  /** The source ID of the customer this product belongs to */
  customerSourceId?: Maybe<Scalars['String']>;
  /** The globally unique external deletion identifier of the record. Sometimes this is different from sourceId due to change tracking semantics */
  deleteId?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  /** The product description */
  description?: Maybe<Scalars['String']>;
  /** Reads a single `Facility` that is related to this `Product`. */
  facility?: Maybe<Facility>;
  /** The originating facility of the product record */
  facilityId?: Maybe<Scalars['Int']>;
  /** The total weight of each case, including the tare weight */
  grossWeight?: Maybe<Scalars['Float']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['BigInt'];
  /** The ideal blast-freezing hours for the referenced product */
  idealBlastHours?: Maybe<Scalars['Float']>;
  /** The total weight of each case minus the tare weight */
  netWeight?: Maybe<Scalars['Float']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The unique local (facility-level) identifier of the product */
  productCode?: Maybe<Scalars['String']>;
  /** Unit of measure for the product (cases, barrels, etc.) */
  productUom?: Maybe<Scalars['String']>;
  /** The number of cases (or other product unit of measure) on a single pallet */
  quantity?: Maybe<Scalars['Int']>;
  /** The type of room this product should be stored within */
  roomType?: Maybe<Scalars['String']>;
  /** A readable, short description of the product */
  shortName?: Maybe<Scalars['String']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String'];
  updatedAt: Scalars['Datetime'];
  /** The version of the record */
  version?: Maybe<Scalars['BigInt']>;
  /** Unit of measure for weight (lbs, kg) */
  weightUom?: Maybe<Scalars['String']>;
};

export type ProductAvailablePalletsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<PalletFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** A condition to be used against `Product` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ProductCondition = {
  /** Checks for equality with the object’s `category` field. */
  category?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `customerSourceId` field. */
  customerSourceId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `deleteId` field. */
  deleteId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `grossWeight` field. */
  grossWeight?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `idealBlastHours` field. */
  idealBlastHours?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `netWeight` field. */
  netWeight?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `productCode` field. */
  productCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `productUom` field. */
  productUom?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `quantity` field. */
  quantity?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `roomType` field. */
  roomType?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `shortName` field. */
  shortName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `sourceId` field. */
  sourceId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `version` field. */
  version?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `weightUom` field. */
  weightUom?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `Product` object types. All fields are combined with a logical ‘and.’ */
export type ProductFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProductFilter>>;
  /** Filter by the object’s `category` field. */
  category?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `customerSourceId` field. */
  customerSourceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `deleteId` field. */
  deleteId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `grossWeight` field. */
  grossWeight?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `idealBlastHours` field. */
  idealBlastHours?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `netWeight` field. */
  netWeight?: InputMaybe<FloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProductFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProductFilter>>;
  /** Filter by the object’s `productCode` field. */
  productCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `productUom` field. */
  productUom?: InputMaybe<StringFilter>;
  /** Filter by the object’s `quantity` field. */
  quantity?: InputMaybe<IntFilter>;
  /** Filter by the object’s `roomType` field. */
  roomType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `shortName` field. */
  shortName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `sourceId` field. */
  sourceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `version` field. */
  version?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `weightUom` field. */
  weightUom?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `Product` */
export type ProductInput = {
  /** A readable category of the product */
  category?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** The source ID of the customer this product belongs to */
  customerSourceId?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  /** The product description */
  description?: InputMaybe<Scalars['String']>;
  /** The originating facility of the product record */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** The total weight of each case, including the tare weight */
  grossWeight?: InputMaybe<Scalars['Float']>;
  /** The ideal blast-freezing hours for the referenced product */
  idealBlastHours?: InputMaybe<Scalars['Float']>;
  /** The total weight of each case minus the tare weight */
  netWeight?: InputMaybe<Scalars['Float']>;
  /** The unique local (facility-level) identifier of the product */
  productCode?: InputMaybe<Scalars['String']>;
  /** Unit of measure for the product (cases, barrels, etc.) */
  productUom?: InputMaybe<Scalars['String']>;
  /** The number of cases (or other product unit of measure) on a single pallet */
  quantity?: InputMaybe<Scalars['Int']>;
  /** The type of room this product should be stored within */
  roomType?: InputMaybe<Scalars['String']>;
  /** A readable, short description of the product */
  shortName?: InputMaybe<Scalars['String']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Unit of measure for weight (lbs, kg) */
  weightUom?: InputMaybe<Scalars['String']>;
};

/** Represents an update to a `Product`. Fields that are set will be updated. */
export type ProductPatch = {
  /** A readable category of the product */
  category?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** The source ID of the customer this product belongs to */
  customerSourceId?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  /** The product description */
  description?: InputMaybe<Scalars['String']>;
  /** The originating facility of the product record */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** The total weight of each case, including the tare weight */
  grossWeight?: InputMaybe<Scalars['Float']>;
  /** The ideal blast-freezing hours for the referenced product */
  idealBlastHours?: InputMaybe<Scalars['Float']>;
  /** The total weight of each case minus the tare weight */
  netWeight?: InputMaybe<Scalars['Float']>;
  /** The unique local (facility-level) identifier of the product */
  productCode?: InputMaybe<Scalars['String']>;
  /** Unit of measure for the product (cases, barrels, etc.) */
  productUom?: InputMaybe<Scalars['String']>;
  /** The number of cases (or other product unit of measure) on a single pallet */
  quantity?: InputMaybe<Scalars['Int']>;
  /** The type of room this product should be stored within */
  roomType?: InputMaybe<Scalars['String']>;
  /** A readable, short description of the product */
  shortName?: InputMaybe<Scalars['String']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Unit of measure for weight (lbs, kg) */
  weightUom?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `Product` values. */
export type ProductsConnection = {
  __typename?: 'ProductsConnection';
  /** A list of edges which contains the `Product` and cursor to aid in pagination. */
  edges: Array<ProductsEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Product>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection. */
export type ProductsEdge = {
  __typename?: 'ProductsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Product` at the end of the edge. */
  node: Product;
};

/** Methods to use when ordering `Product`. */
export enum ProductsOrderBy {
  CATEGORY_ASC = 'CATEGORY_ASC',
  CATEGORY_DESC = 'CATEGORY_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CUSTOMER_SOURCE_ID_ASC = 'CUSTOMER_SOURCE_ID_ASC',
  CUSTOMER_SOURCE_ID_DESC = 'CUSTOMER_SOURCE_ID_DESC',
  DELETED_AT_ASC = 'DELETED_AT_ASC',
  DELETED_AT_DESC = 'DELETED_AT_DESC',
  DELETE_ID_ASC = 'DELETE_ID_ASC',
  DELETE_ID_DESC = 'DELETE_ID_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  GROSS_WEIGHT_ASC = 'GROSS_WEIGHT_ASC',
  GROSS_WEIGHT_DESC = 'GROSS_WEIGHT_DESC',
  IDEAL_BLAST_HOURS_ASC = 'IDEAL_BLAST_HOURS_ASC',
  IDEAL_BLAST_HOURS_DESC = 'IDEAL_BLAST_HOURS_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  NET_WEIGHT_ASC = 'NET_WEIGHT_ASC',
  NET_WEIGHT_DESC = 'NET_WEIGHT_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PRODUCT_CODE_ASC = 'PRODUCT_CODE_ASC',
  PRODUCT_CODE_DESC = 'PRODUCT_CODE_DESC',
  PRODUCT_UOM_ASC = 'PRODUCT_UOM_ASC',
  PRODUCT_UOM_DESC = 'PRODUCT_UOM_DESC',
  QUANTITY_ASC = 'QUANTITY_ASC',
  QUANTITY_DESC = 'QUANTITY_DESC',
  ROOM_TYPE_ASC = 'ROOM_TYPE_ASC',
  ROOM_TYPE_DESC = 'ROOM_TYPE_DESC',
  SHORT_NAME_ASC = 'SHORT_NAME_ASC',
  SHORT_NAME_DESC = 'SHORT_NAME_DESC',
  SOURCE_ID_ASC = 'SOURCE_ID_ASC',
  SOURCE_ID_DESC = 'SOURCE_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VERSION_ASC = 'VERSION_ASC',
  VERSION_DESC = 'VERSION_DESC',
  WEIGHT_UOM_ASC = 'WEIGHT_UOM_ASC',
  WEIGHT_UOM_DESC = 'WEIGHT_UOM_DESC'
}

/** A program describes sub types of project types. */
export type Program = Node & {
  __typename?: 'Program';
  /** The time the program was created. */
  createdAt: Scalars['Datetime'];
  /** The description of the program. */
  description?: Maybe<Scalars['String']>;
  /** The identifer of the program. */
  id: Scalars['Int'];
  /** The name of the program. */
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `ProgramEnrollment`. */
  programEnrollments: ProgramEnrollmentsConnection;
  /** Reads a single `ProjectType` that is related to this `Program`. */
  projectType?: Maybe<ProjectType>;
  /** The id of the project type the program is associated with. */
  projectTypeId: Scalars['Int'];
  /** Reads and enables pagination through a set of `Project`. */
  projects: ProjectsConnection;
  /** The time the program was updated. */
  updatedAt: Scalars['Datetime'];
};

/** A program describes sub types of project types. */
export type ProgramProgramEnrollmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProgramEnrollmentCondition>;
  filter?: InputMaybe<ProgramEnrollmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProgramEnrollmentsOrderBy>>;
};

/** A program describes sub types of project types. */
export type ProgramProjectsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectCondition>;
  filter?: InputMaybe<ProjectFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};

/** A condition to be used against `Program` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ProgramCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `projectTypeId` field. */
  projectTypeId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Tracks enrollment periods for a program. */
export type ProgramEnrollment = Node & {
  __typename?: 'ProgramEnrollment';
  createdAt: Scalars['Datetime'];
  /** The end date of the enrollment period. */
  endDate: Scalars['Datetime'];
  /** The identifer of the program enrollment. */
  id: Scalars['Int'];
  /** The name of this program enrollment. */
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Program` that is related to this `ProgramEnrollment`. */
  program?: Maybe<Program>;
  /** The program this program enrollment belongs to. */
  programId: Scalars['Int'];
  /** Reads and enables pagination through a set of `ProjectEnrollment`. */
  projectEnrollments: ProjectEnrollmentsConnection;
  /** The start date of the enrollment period. */
  startDate: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
};

/** Tracks enrollment periods for a program. */
export type ProgramEnrollmentProjectEnrollmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectEnrollmentCondition>;
  filter?: InputMaybe<ProjectEnrollmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectEnrollmentsOrderBy>>;
};

/**
 * A condition to be used against `ProgramEnrollment` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ProgramEnrollmentCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `endDate` field. */
  endDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `programId` field. */
  programId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `ProgramEnrollment` object types. All fields are combined with a logical ‘and.’ */
export type ProgramEnrollmentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProgramEnrollmentFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `endDate` field. */
  endDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProgramEnrollmentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProgramEnrollmentFilter>>;
  /** Filter by the object’s `programId` field. */
  programId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `startDate` field. */
  startDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ProgramEnrollment` */
export type ProgramEnrollmentInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** The end date of the enrollment period. */
  endDate: Scalars['Datetime'];
  /** The name of this program enrollment. */
  name: Scalars['String'];
  /** Mutates a `Program` as part of the payload */
  program?: InputMaybe<ProgramInput>;
  /** The program this program enrollment belongs to. */
  programId?: InputMaybe<Scalars['Int']>;
  /** The start date of the enrollment period. */
  startDate: Scalars['Datetime'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `ProgramEnrollment`. Fields that are set will be updated. */
export type ProgramEnrollmentPatch = {
  /** The end date of the enrollment period. */
  endDate?: InputMaybe<Scalars['Datetime']>;
  /** The name of this program enrollment. */
  name?: InputMaybe<Scalars['String']>;
  /** The start date of the enrollment period. */
  startDate?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `ProgramEnrollment` values. */
export type ProgramEnrollmentsConnection = {
  __typename?: 'ProgramEnrollmentsConnection';
  /** A list of edges which contains the `ProgramEnrollment` and cursor to aid in pagination. */
  edges: Array<ProgramEnrollmentsEdge>;
  /** A list of `ProgramEnrollment` objects. */
  nodes: Array<ProgramEnrollment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProgramEnrollment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProgramEnrollment` edge in the connection. */
export type ProgramEnrollmentsEdge = {
  __typename?: 'ProgramEnrollmentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProgramEnrollment` at the end of the edge. */
  node: ProgramEnrollment;
};

/** Methods to use when ordering `ProgramEnrollment`. */
export enum ProgramEnrollmentsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  END_DATE_ASC = 'END_DATE_ASC',
  END_DATE_DESC = 'END_DATE_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROGRAM_ID_ASC = 'PROGRAM_ID_ASC',
  PROGRAM_ID_DESC = 'PROGRAM_ID_DESC',
  START_DATE_ASC = 'START_DATE_ASC',
  START_DATE_DESC = 'START_DATE_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A filter to be used against `Program` object types. All fields are combined with a logical ‘and.’ */
export type ProgramFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProgramFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProgramFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProgramFilter>>;
  /** Filter by the object’s `projectTypeId` field. */
  projectTypeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Program` */
export type ProgramInput = {
  /** The description of the program. */
  description?: InputMaybe<Scalars['String']>;
  /** The name of the program. */
  name: Scalars['String'];
  /** The id of the project type the program is associated with. */
  projectTypeId: Scalars['Int'];
};

/** Represents an update to a `Program`. Fields that are set will be updated. */
export type ProgramPatch = {
  /** The description of the program. */
  description?: InputMaybe<Scalars['String']>;
  /** The name of the program. */
  name?: InputMaybe<Scalars['String']>;
  /** The id of the project type the program is associated with. */
  projectTypeId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `Program` values. */
export type ProgramsConnection = {
  __typename?: 'ProgramsConnection';
  /** A list of edges which contains the `Program` and cursor to aid in pagination. */
  edges: Array<ProgramsEdge>;
  /** A list of `Program` objects. */
  nodes: Array<Program>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Program` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Program` edge in the connection. */
export type ProgramsEdge = {
  __typename?: 'ProgramsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Program` at the end of the edge. */
  node: Program;
};

/** Methods to use when ordering `Program`. */
export enum ProgramsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROJECT_TYPE_ID_ASC = 'PROJECT_TYPE_ID_ASC',
  PROJECT_TYPE_ID_DESC = 'PROJECT_TYPE_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

export type Project = Node & {
  __typename?: 'Project';
  /** The threshold in minutes that will be applied to a suggestion start time to restrict acknowledgements. */
  acknowledgementWindowThreshold: Scalars['Int'];
  /** Whether suggestions for this project will be auto-acknowledged. */
  autoAcknowledge: Scalars['Boolean'];
  /** Reads and enables pagination through a set of `Component`. */
  components: ComponentsConnection;
  /** Serialized configuration for the project */
  config?: Maybe<Scalars['JSON']>;
  /** Reads and enables pagination through a set of `ProjectConfig`. */
  configs: ProjectConfigsConnection;
  /** Returns the control type of a project. */
  controlType?: Maybe<ControlType>;
  controllers: UsersConnection;
  /** The time the project was created. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** The current Project Enrollment associated with the project. */
  currentEnrollment?: Maybe<ProjectEnrollment>;
  /** The description of optimization project. */
  description?: Maybe<Scalars['String']>;
  /** The date in which the optimization project ends. */
  endDate?: Maybe<Scalars['Date']>;
  /** The timeout in seconds before which a control event will need to complete. */
  endTimeout: Scalars['Int'];
  /** Reads a single `Facility` that is related to this `Project`. */
  facility?: Maybe<Facility>;
  /** The identifier of the facility. */
  facilityId: Scalars['Int'];
  /** Facility Name */
  facilityName?: Maybe<Scalars['String']>;
  /** The identifier of the optimization project. */
  id: Scalars['Int'];
  /** Is current user is watching project. */
  isWatching?: Maybe<Scalars['Boolean']>;
  /** The name of optimization project. */
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Available permissions for the Project. */
  permissions?: Maybe<ProjectPermissions>;
  /** Reads a single `Program` that is related to this `Project`. */
  program?: Maybe<Program>;
  /** The id of the program the project is associated with */
  programId: Scalars['Int'];
  /** The name of the program */
  programName?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `ProjectComponent`. */
  projectComponents: ProjectComponentsConnection;
  /** Reads and enables pagination through a set of `ProjectEnrollment`. */
  projectEnrollments: ProjectEnrollmentsConnection;
  /** Reads a single `ProjectType` that is related to this `Project`. */
  projectType?: Maybe<ProjectType>;
  /** The type of optimization project. */
  projectTypeId: Scalars['Int'];
  /** The name of the project type */
  projectTypeName?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `ProjectWatcher`. */
  projectWatchers: ProjectWatchersConnection;
  /** Aggregates a metric by label for the specified filter expression. */
  savingsEventData?: Maybe<MetricDataConnection>;
  /** Reads and enables pagination through a set of `SavingsEvent`. */
  savingsEvents: SavingsEventsConnection;
  /** The date in which the optimization project starts. */
  startDate?: Maybe<Scalars['Date']>;
  /** The timeout in seconds before which a control event will need to start. */
  startTimeout: Scalars['Int'];
  /** Returns a distinct list of enabled subscription channels for the current user scoped to the project. */
  subscribedChannels?: Maybe<Array<Maybe<UserSubscriptionChannel>>>;
  /** Returns the current user subscriptions scoped to the project. */
  subscriptions: UserSubscriptionsConnection;
  /** Reads and enables pagination through a set of `Suggestion`. */
  suggestions: SuggestionsConnection;
  /** The time the project was updated . */
  updatedAt?: Maybe<Scalars['Datetime']>;
  /** Returns all user subscriptions scoped to the project. */
  userSubscriptions: UserSubscriptionsConnection;
  /** Reads and enables pagination through a set of `User`. */
  watchers: UsersConnection;
};

export type ProjectComponentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<ComponentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type ProjectConfigsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectConfigCondition>;
  filter?: InputMaybe<ProjectConfigFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectConfigsOrderBy>>;
};

export type ProjectControllersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

export type ProjectProjectComponentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectComponentCondition>;
  filter?: InputMaybe<ProjectComponentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectComponentsOrderBy>>;
};

export type ProjectProjectEnrollmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectEnrollmentCondition>;
  filter?: InputMaybe<ProjectEnrollmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectEnrollmentsOrderBy>>;
};

export type ProjectProjectWatchersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectWatcherCondition>;
  filter?: InputMaybe<ProjectWatcherFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectWatchersOrderBy>>;
};

export type ProjectSavingsEventDataArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: InputMaybe<MetricDataAggregationMethod>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['String']>;
  inheritTimezone?: InputMaybe<Scalars['Boolean']>;
  label: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

export type ProjectSavingsEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SavingsEventCondition>;
  filter?: InputMaybe<SavingsEventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SavingsEventsOrderBy>>;
};

export type ProjectSubscriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<UserSubscriptionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type ProjectSuggestionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SuggestionCondition>;
  filter?: InputMaybe<SuggestionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SuggestionsOrderBy>>;
};

export type ProjectUserSubscriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<UserSubscriptionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type ProjectWatchersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type ProjectComponent = Node & {
  __typename?: 'ProjectComponent';
  /** Reads a single `Component` that is related to this `ProjectComponent`. */
  component?: Maybe<Component>;
  componentId: Scalars['Int'];
  /** A scheme name to be associated with the control for this project component. */
  controlScheme?: Maybe<Scalars['String']>;
  /** The maximum duration, in seconds, that a control event can be scheduled. This value will also be the default when related suggestions have no end time. */
  maximumControlDuration?: Maybe<Scalars['Int']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Project` that is related to this `ProjectComponent`. */
  project?: Maybe<Project>;
  projectId: Scalars['Int'];
  /** The duration in seconds before an event start time that the component will start. */
  startupOffset: Scalars['Int'];
};

/**
 * A condition to be used against `ProjectComponent` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ProjectComponentCondition = {
  /** Checks for equality with the object’s `componentId` field. */
  componentId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `controlScheme` field. */
  controlScheme?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `maximumControlDuration` field. */
  maximumControlDuration?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `startupOffset` field. */
  startupOffset?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `ProjectComponent` object types. All fields are combined with a logical ‘and.’ */
export type ProjectComponentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectComponentFilter>>;
  /** Filter by the object’s `componentId` field. */
  componentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `controlScheme` field. */
  controlScheme?: InputMaybe<StringFilter>;
  /** Filter by the object’s `maximumControlDuration` field. */
  maximumControlDuration?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectComponentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectComponentFilter>>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `startupOffset` field. */
  startupOffset?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `ProjectComponent` */
export type ProjectComponentInput = {
  componentId: Scalars['Int'];
  /** A scheme name to be associated with the control for this project component. */
  controlScheme?: InputMaybe<Scalars['String']>;
  /** The maximum duration, in seconds, that a control event can be scheduled. This value will also be the default when related suggestions have no end time. */
  maximumControlDuration?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['Int'];
  /** The duration in seconds before an event start time that the component will start. */
  startupOffset?: InputMaybe<Scalars['Int']>;
};

/** Represents an update to a `ProjectComponent`. Fields that are set will be updated. */
export type ProjectComponentPatch = {
  componentId?: InputMaybe<Scalars['Int']>;
  /** A scheme name to be associated with the control for this project component. */
  controlScheme?: InputMaybe<Scalars['String']>;
  /** The maximum duration, in seconds, that a control event can be scheduled. This value will also be the default when related suggestions have no end time. */
  maximumControlDuration?: InputMaybe<Scalars['Int']>;
  projectId?: InputMaybe<Scalars['Int']>;
  /** The duration in seconds before an event start time that the component will start. */
  startupOffset?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `ProjectComponent` values. */
export type ProjectComponentsConnection = {
  __typename?: 'ProjectComponentsConnection';
  /** A list of edges which contains the `ProjectComponent` and cursor to aid in pagination. */
  edges: Array<ProjectComponentsEdge>;
  /** A list of `ProjectComponent` objects. */
  nodes: Array<ProjectComponent>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectComponent` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProjectComponent` edge in the connection. */
export type ProjectComponentsEdge = {
  __typename?: 'ProjectComponentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProjectComponent` at the end of the edge. */
  node: ProjectComponent;
};

/** Methods to use when ordering `ProjectComponent`. */
export enum ProjectComponentsOrderBy {
  COMPONENT_ID_ASC = 'COMPONENT_ID_ASC',
  COMPONENT_ID_DESC = 'COMPONENT_ID_DESC',
  CONTROL_SCHEME_ASC = 'CONTROL_SCHEME_ASC',
  CONTROL_SCHEME_DESC = 'CONTROL_SCHEME_DESC',
  MAXIMUM_CONTROL_DURATION_ASC = 'MAXIMUM_CONTROL_DURATION_ASC',
  MAXIMUM_CONTROL_DURATION_DESC = 'MAXIMUM_CONTROL_DURATION_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROJECT_ID_ASC = 'PROJECT_ID_ASC',
  PROJECT_ID_DESC = 'PROJECT_ID_DESC',
  STARTUP_OFFSET_ASC = 'STARTUP_OFFSET_ASC',
  STARTUP_OFFSET_DESC = 'STARTUP_OFFSET_DESC'
}

/** A condition to be used against `Project` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ProjectCondition = {
  /** Checks for equality with the object’s `acknowledgementWindowThreshold` field. */
  acknowledgementWindowThreshold?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `autoAcknowledge` field. */
  autoAcknowledge?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `config` field. */
  config?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `endDate` field. */
  endDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `endTimeout` field. */
  endTimeout?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `programId` field. */
  programId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `projectTypeId` field. */
  projectTypeId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `startTimeout` field. */
  startTimeout?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type ProjectConfig = Node & {
  __typename?: 'ProjectConfig';
  createdAt?: Maybe<Scalars['Datetime']>;
  id: Scalars['Int'];
  key?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Project` that is related to this `ProjectConfig`. */
  project?: Maybe<Project>;
  projectId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  value?: Maybe<Scalars['JSON']>;
};

/**
 * A condition to be used against `ProjectConfig` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ProjectConfigCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['JSON']>;
};

/** A filter to be used against `ProjectConfig` object types. All fields are combined with a logical ‘and.’ */
export type ProjectConfigFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectConfigFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectConfigFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectConfigFilter>>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<JsonFilter>;
};

/** A connection to a list of `ProjectConfig` values. */
export type ProjectConfigsConnection = {
  __typename?: 'ProjectConfigsConnection';
  /** A list of edges which contains the `ProjectConfig` and cursor to aid in pagination. */
  edges: Array<ProjectConfigsEdge>;
  /** A list of `ProjectConfig` objects. */
  nodes: Array<ProjectConfig>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectConfig` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProjectConfig` edge in the connection. */
export type ProjectConfigsEdge = {
  __typename?: 'ProjectConfigsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProjectConfig` at the end of the edge. */
  node: ProjectConfig;
};

/** Methods to use when ordering `ProjectConfig`. */
export enum ProjectConfigsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  KEY_ASC = 'KEY_ASC',
  KEY_DESC = 'KEY_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROJECT_ID_ASC = 'PROJECT_ID_ASC',
  PROJECT_ID_DESC = 'PROJECT_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VALUE_ASC = 'VALUE_ASC',
  VALUE_DESC = 'VALUE_DESC'
}

/** Tracks enrollment periods for a project. */
export type ProjectEnrollment = Node & {
  __typename?: 'ProjectEnrollment';
  createdAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `ProjectEnrollmentDataPoint`. */
  dataPoints: ProjectEnrollmentDataPointsConnection;
  /** The end date of the program enrollment associated with the project enrollment. */
  endDate?: Maybe<Scalars['Datetime']>;
  /** The identifer of the project enrollment. */
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `ProgramEnrollment` that is related to this `ProjectEnrollment`. */
  programEnrollment?: Maybe<ProgramEnrollment>;
  /** The program enrollment this project enrollment belongs to. */
  programEnrollmentId: Scalars['Int'];
  /** Reads a single `Project` that is related to this `ProjectEnrollment`. */
  project?: Maybe<Project>;
  /** The project this project enrollment belongs to. */
  projectId: Scalars['Int'];
  /** The start date of the program enrollment associated with the project enrollment. */
  startDate?: Maybe<Scalars['Datetime']>;
  updatedAt: Scalars['Datetime'];
};

/** Tracks enrollment periods for a project. */
export type ProjectEnrollmentDataPointsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectEnrollmentDataPointCondition>;
  filter?: InputMaybe<ProjectEnrollmentDataPointFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectEnrollmentDataPointsOrderBy>>;
};

/**
 * A condition to be used against `ProjectEnrollment` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ProjectEnrollmentCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `programEnrollmentId` field. */
  programEnrollmentId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Tracks data points associated with enrollments. */
export type ProjectEnrollmentDataPoint = Node & {
  __typename?: 'ProjectEnrollmentDataPoint';
  /** This allows data point names to be overwritten. */
  alias?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  /** Reads a single `DataPoint` that is related to this `ProjectEnrollmentDataPoint`. */
  dataPoint?: Maybe<DataPoint>;
  /** The data point being referenced. */
  dataPointId: Scalars['Int'];
  /** Reads a single `ProjectEnrollmentDataPointGroup` that is related to this `ProjectEnrollmentDataPoint`. */
  group?: Maybe<ProjectEnrollmentDataPointGroup>;
  /** The identifer of the project enrollment data point. */
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `ProjectEnrollment` that is related to this `ProjectEnrollmentDataPoint`. */
  projectEnrollment?: Maybe<ProjectEnrollment>;
  /** The group this data point belongs to. */
  projectEnrollmentDataPointGroupId?: Maybe<Scalars['Int']>;
  /** The project enrollment this data point belongs to. */
  projectEnrollmentId: Scalars['Int'];
  /** The rate(s) associated with the data point. */
  rate: Scalars['JSON'];
  /** The target value for the data point during a savings event. */
  target?: Maybe<Scalars['BigFloat']>;
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `ProjectEnrollmentDataPoint` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ProjectEnrollmentDataPointCondition = {
  /** Checks for equality with the object’s `alias` field. */
  alias?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `dataPointId` field. */
  dataPointId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `projectEnrollmentDataPointGroupId` field. */
  projectEnrollmentDataPointGroupId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `projectEnrollmentId` field. */
  projectEnrollmentId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `rate` field. */
  rate?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `target` field. */
  target?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `ProjectEnrollmentDataPoint` object types. All fields are combined with a logical ‘and.’ */
export type ProjectEnrollmentDataPointFilter = {
  /** Filter by the object’s `alias` field. */
  alias?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectEnrollmentDataPointFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dataPointId` field. */
  dataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectEnrollmentDataPointFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectEnrollmentDataPointFilter>>;
  /** Filter by the object’s `projectEnrollmentDataPointGroupId` field. */
  projectEnrollmentDataPointGroupId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `projectEnrollmentId` field. */
  projectEnrollmentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rate` field. */
  rate?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `target` field. */
  target?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Allows grouping enrollment data points. */
export type ProjectEnrollmentDataPointGroup = Node & {
  __typename?: 'ProjectEnrollmentDataPointGroup';
  createdAt: Scalars['Datetime'];
  /** The description of the data point group. */
  description?: Maybe<Scalars['String']>;
  /** The identifer of the project enrollment. */
  id: Scalars['Int'];
  /** The label of the data point group. */
  label: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `ProjectEnrollmentDataPoint`. */
  projectEnrollmentDataPoints: ProjectEnrollmentDataPointsConnection;
  updatedAt: Scalars['Datetime'];
};

/** Allows grouping enrollment data points. */
export type ProjectEnrollmentDataPointGroupProjectEnrollmentDataPointsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectEnrollmentDataPointCondition>;
  filter?: InputMaybe<ProjectEnrollmentDataPointFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectEnrollmentDataPointsOrderBy>>;
};

/**
 * A condition to be used against `ProjectEnrollmentDataPointGroup` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type ProjectEnrollmentDataPointGroupCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `ProjectEnrollmentDataPointGroup` object types. All fields are combined with a logical ‘and.’ */
export type ProjectEnrollmentDataPointGroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectEnrollmentDataPointGroupFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectEnrollmentDataPointGroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectEnrollmentDataPointGroupFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ProjectEnrollmentDataPointGroup` */
export type ProjectEnrollmentDataPointGroupInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** The description of the data point group. */
  description?: InputMaybe<Scalars['String']>;
  /** The label of the data point group. */
  label: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `ProjectEnrollmentDataPointGroup`. Fields that are set will be updated. */
export type ProjectEnrollmentDataPointGroupPatch = {
  /** The description of the data point group. */
  description?: InputMaybe<Scalars['String']>;
  /** The label of the data point group. */
  label?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `ProjectEnrollmentDataPointGroup` values. */
export type ProjectEnrollmentDataPointGroupsConnection = {
  __typename?: 'ProjectEnrollmentDataPointGroupsConnection';
  /** A list of edges which contains the `ProjectEnrollmentDataPointGroup` and cursor to aid in pagination. */
  edges: Array<ProjectEnrollmentDataPointGroupsEdge>;
  /** A list of `ProjectEnrollmentDataPointGroup` objects. */
  nodes: Array<ProjectEnrollmentDataPointGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectEnrollmentDataPointGroup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProjectEnrollmentDataPointGroup` edge in the connection. */
export type ProjectEnrollmentDataPointGroupsEdge = {
  __typename?: 'ProjectEnrollmentDataPointGroupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProjectEnrollmentDataPointGroup` at the end of the edge. */
  node: ProjectEnrollmentDataPointGroup;
};

/** Methods to use when ordering `ProjectEnrollmentDataPointGroup`. */
export enum ProjectEnrollmentDataPointGroupsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** An input for mutations affecting `ProjectEnrollmentDataPoint` */
export type ProjectEnrollmentDataPointInput = {
  /** This allows data point names to be overwritten. */
  alias?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Mutates a `DataPoint` as part of the payload */
  dataPoint?: InputMaybe<DataPointInput>;
  /** The data point being referenced. */
  dataPointId?: InputMaybe<Scalars['Int']>;
  /** Mutates a `ProjectEnrollment` as part of the payload */
  projectEnrollment?: InputMaybe<ProjectEnrollmentInput>;
  /** Mutates a `ProjectEnrollmentDataPointGroup` as part of the payload */
  projectEnrollmentDataPointGroup?: InputMaybe<ProjectEnrollmentDataPointGroupInput>;
  /** The group this data point belongs to. */
  projectEnrollmentDataPointGroupId?: InputMaybe<Scalars['Int']>;
  /** The project enrollment this data point belongs to. */
  projectEnrollmentId?: InputMaybe<Scalars['Int']>;
  /** The rate(s) associated with the data point. */
  rate?: InputMaybe<Scalars['JSON']>;
  /** The target value for the data point during a savings event. */
  target?: InputMaybe<Scalars['BigFloat']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `ProjectEnrollmentDataPoint`. Fields that are set will be updated. */
export type ProjectEnrollmentDataPointPatch = {
  /** This allows data point names to be overwritten. */
  alias?: InputMaybe<Scalars['String']>;
  /** The rate(s) associated with the data point. */
  rate?: InputMaybe<Scalars['JSON']>;
  /** The target value for the data point during a savings event. */
  target?: InputMaybe<Scalars['BigFloat']>;
};

/** A connection to a list of `ProjectEnrollmentDataPoint` values. */
export type ProjectEnrollmentDataPointsConnection = {
  __typename?: 'ProjectEnrollmentDataPointsConnection';
  /** Returns the aggregate data timeseries data for the ProjectEnrollmentDataPointsConnection  */
  data?: Maybe<MetricDataConnection>;
  /** A list of edges which contains the `ProjectEnrollmentDataPoint` and cursor to aid in pagination. */
  edges: Array<ProjectEnrollmentDataPointsEdge>;
  /** A list of `ProjectEnrollmentDataPoint` objects. */
  nodes: Array<ProjectEnrollmentDataPoint>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectEnrollmentDataPoint` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A connection to a list of `ProjectEnrollmentDataPoint` values. */
export type ProjectEnrollmentDataPointsConnectionDataArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A `ProjectEnrollmentDataPoint` edge in the connection. */
export type ProjectEnrollmentDataPointsEdge = {
  __typename?: 'ProjectEnrollmentDataPointsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProjectEnrollmentDataPoint` at the end of the edge. */
  node: ProjectEnrollmentDataPoint;
};

/** Methods to use when ordering `ProjectEnrollmentDataPoint`. */
export enum ProjectEnrollmentDataPointsOrderBy {
  ALIAS_ASC = 'ALIAS_ASC',
  ALIAS_DESC = 'ALIAS_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DATA_POINT_ID_ASC = 'DATA_POINT_ID_ASC',
  DATA_POINT_ID_DESC = 'DATA_POINT_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROJECT_ENROLLMENT_DATA_POINT_GROUP_ID_ASC = 'PROJECT_ENROLLMENT_DATA_POINT_GROUP_ID_ASC',
  PROJECT_ENROLLMENT_DATA_POINT_GROUP_ID_DESC = 'PROJECT_ENROLLMENT_DATA_POINT_GROUP_ID_DESC',
  PROJECT_ENROLLMENT_ID_ASC = 'PROJECT_ENROLLMENT_ID_ASC',
  PROJECT_ENROLLMENT_ID_DESC = 'PROJECT_ENROLLMENT_ID_DESC',
  RATE_ASC = 'RATE_ASC',
  RATE_DESC = 'RATE_DESC',
  TARGET_ASC = 'TARGET_ASC',
  TARGET_DESC = 'TARGET_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A filter to be used against `ProjectEnrollment` object types. All fields are combined with a logical ‘and.’ */
export type ProjectEnrollmentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectEnrollmentFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `endDate` field. */
  endDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectEnrollmentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectEnrollmentFilter>>;
  /** Filter by the object’s `programEnrollmentId` field. */
  programEnrollmentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `startDate` field. */
  startDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ProjectEnrollment` */
export type ProjectEnrollmentInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Mutates a `ProgramEnrollment` as part of the payload */
  programEnrollment?: InputMaybe<ProgramEnrollmentInput>;
  /** The program enrollment this project enrollment belongs to. */
  programEnrollmentId?: InputMaybe<Scalars['Int']>;
  /** The project this project enrollment belongs to. */
  projectId: Scalars['Int'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `ProjectEnrollment` values. */
export type ProjectEnrollmentsConnection = {
  __typename?: 'ProjectEnrollmentsConnection';
  /** A list of edges which contains the `ProjectEnrollment` and cursor to aid in pagination. */
  edges: Array<ProjectEnrollmentsEdge>;
  /** A list of `ProjectEnrollment` objects. */
  nodes: Array<ProjectEnrollment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectEnrollment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProjectEnrollment` edge in the connection. */
export type ProjectEnrollmentsEdge = {
  __typename?: 'ProjectEnrollmentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProjectEnrollment` at the end of the edge. */
  node: ProjectEnrollment;
};

/** Methods to use when ordering `ProjectEnrollment`. */
export enum ProjectEnrollmentsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  END_DATE_ASC = 'END_DATE_ASC',
  END_DATE_DESC = 'END_DATE_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROGRAM_ENROLLMENT_ID_ASC = 'PROGRAM_ENROLLMENT_ID_ASC',
  PROGRAM_ENROLLMENT_ID_DESC = 'PROGRAM_ENROLLMENT_ID_DESC',
  PROJECT_ID_ASC = 'PROJECT_ID_ASC',
  PROJECT_ID_DESC = 'PROJECT_ID_DESC',
  START_DATE_ASC = 'START_DATE_ASC',
  START_DATE_DESC = 'START_DATE_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A filter to be used against `Project` object types. All fields are combined with a logical ‘and.’ */
export type ProjectFilter = {
  /** Filter by the object’s `acknowledgementWindowThreshold` field. */
  acknowledgementWindowThreshold?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectFilter>>;
  /** Filter by the object’s `autoAcknowledge` field. */
  autoAcknowledge?: InputMaybe<BooleanFilter>;
  /** Filter by the permission can_control */
  canControl?: InputMaybe<PermissionBooleanFilter>;
  /** Filter by the object’s `config` field. */
  config?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `controlType` field. */
  controlType?: InputMaybe<ControlTypeFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `endDate` field. */
  endDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `endTimeout` field. */
  endTimeout?: InputMaybe<IntFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `facilityName` field. */
  facilityName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isWatching` field. */
  isWatching?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectFilter>>;
  /** Filter by the object’s `programId` field. */
  programId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `programName` field. */
  programName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `projectTypeId` field. */
  projectTypeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `projectTypeName` field. */
  projectTypeName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `startDate` field. */
  startDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `startTimeout` field. */
  startTimeout?: InputMaybe<IntFilter>;
  /** Filter by the object’s `subscribedChannels` field. */
  subscribedChannels?: InputMaybe<UserSubscriptionChannelListFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Project` */
export type ProjectInput = {
  /** The threshold in minutes that will be applied to a suggestion start time to restrict acknowledgements. */
  acknowledgementWindowThreshold?: InputMaybe<Scalars['Int']>;
  /** Whether suggestions for this project will be auto-acknowledged. */
  autoAcknowledge?: InputMaybe<Scalars['Boolean']>;
  /** The description of optimization project. */
  description?: InputMaybe<Scalars['String']>;
  /** The date in which the optimization project ends. */
  endDate?: InputMaybe<Scalars['Date']>;
  /** The timeout in seconds before which a control event will need to complete. */
  endTimeout?: InputMaybe<Scalars['Int']>;
  /** The identifier of the facility. */
  facilityId: Scalars['Int'];
  /** The name of optimization project. */
  name: Scalars['String'];
  /** Mutates a `Program` as part of the payload */
  program?: InputMaybe<ProgramInput>;
  /** The id of the program the project is associated with */
  programId?: InputMaybe<Scalars['Int']>;
  /** The type of optimization project. */
  projectTypeId: Scalars['Int'];
  /** The date in which the optimization project starts. */
  startDate?: InputMaybe<Scalars['Date']>;
  /** The timeout in seconds before which a control event will need to start. */
  startTimeout?: InputMaybe<Scalars['Int']>;
};

/** Represents an update to a `Project`. Fields that are set will be updated. */
export type ProjectPatch = {
  /** The threshold in minutes that will be applied to a suggestion start time to restrict acknowledgements. */
  acknowledgementWindowThreshold?: InputMaybe<Scalars['Int']>;
  /** Whether suggestions for this project will be auto-acknowledged. */
  autoAcknowledge?: InputMaybe<Scalars['Boolean']>;
  /** The description of optimization project. */
  description?: InputMaybe<Scalars['String']>;
  /** The date in which the optimization project ends. */
  endDate?: InputMaybe<Scalars['Date']>;
  /** The timeout in seconds before which a control event will need to complete. */
  endTimeout?: InputMaybe<Scalars['Int']>;
  /** The identifier of the facility. */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** The name of optimization project. */
  name?: InputMaybe<Scalars['String']>;
  /** The id of the program the project is associated with */
  programId?: InputMaybe<Scalars['Int']>;
  /** The type of optimization project. */
  projectTypeId?: InputMaybe<Scalars['Int']>;
  /** The date in which the optimization project starts. */
  startDate?: InputMaybe<Scalars['Date']>;
  /** The timeout in seconds before which a control event will need to start. */
  startTimeout?: InputMaybe<Scalars['Int']>;
};

/** Permissive capabilities on a Project. */
export type ProjectPermissions = {
  __typename?: 'ProjectPermissions';
  /** Whether a user can approve and/or transition suggestions in the project. */
  canControl: Scalars['Boolean'];
};

/** Type of optimization project that can be associated to a facility. */
export type ProjectType = Node & {
  __typename?: 'ProjectType';
  /** The description of the project type */
  description?: Maybe<Scalars['String']>;
  /** The identifier of the project type */
  id: Scalars['Int'];
  /** The name of the project type */
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `Program`. */
  programs: ProgramsConnection;
  /** Reads and enables pagination through a set of `Project`. */
  projects: ProjectsConnection;
};

/** Type of optimization project that can be associated to a facility. */
export type ProjectTypeProgramsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProgramCondition>;
  filter?: InputMaybe<ProgramFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProgramsOrderBy>>;
};

/** Type of optimization project that can be associated to a facility. */
export type ProjectTypeProjectsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectCondition>;
  filter?: InputMaybe<ProjectFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};

/**
 * A condition to be used against `ProjectType` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ProjectTypeCondition = {
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `ProjectType` object types. All fields are combined with a logical ‘and.’ */
export type ProjectTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectTypeFilter>>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectTypeFilter>>;
};

/** A connection to a list of `ProjectType` values. */
export type ProjectTypesConnection = {
  __typename?: 'ProjectTypesConnection';
  /** A list of edges which contains the `ProjectType` and cursor to aid in pagination. */
  edges: Array<ProjectTypesEdge>;
  /** A list of `ProjectType` objects. */
  nodes: Array<ProjectType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectType` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProjectType` edge in the connection. */
export type ProjectTypesEdge = {
  __typename?: 'ProjectTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProjectType` at the end of the edge. */
  node: ProjectType;
};

/** Methods to use when ordering `ProjectType`. */
export enum ProjectTypesOrderBy {
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

export type ProjectWatcher = Node & {
  __typename?: 'ProjectWatcher';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Project` that is related to this `ProjectWatcher`. */
  project?: Maybe<Project>;
  projectId: Scalars['Int'];
  subscribedChannels?: Maybe<Array<Maybe<UserSubscriptionChannel>>>;
  /** Reads a single `User` that is related to this `ProjectWatcher`. */
  user?: Maybe<User>;
  userId: Scalars['String'];
};

/**
 * A condition to be used against `ProjectWatcher` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ProjectWatcherCondition = {
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `ProjectWatcher` object types. All fields are combined with a logical ‘and.’ */
export type ProjectWatcherFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectWatcherFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectWatcherFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectWatcherFilter>>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `subscribedChannels` field. */
  subscribedChannels?: InputMaybe<UserSubscriptionChannelListFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `ProjectWatcher` */
export type ProjectWatcherInput = {
  projectId: Scalars['Int'];
  userId: Scalars['String'];
};

/** Represents an update to a `ProjectWatcher`. Fields that are set will be updated. */
export type ProjectWatcherPatch = {
  projectId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `ProjectWatcher` values. */
export type ProjectWatchersConnection = {
  __typename?: 'ProjectWatchersConnection';
  /** A list of edges which contains the `ProjectWatcher` and cursor to aid in pagination. */
  edges: Array<ProjectWatchersEdge>;
  /** A list of `ProjectWatcher` objects. */
  nodes: Array<ProjectWatcher>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectWatcher` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProjectWatcher` edge in the connection. */
export type ProjectWatchersEdge = {
  __typename?: 'ProjectWatchersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProjectWatcher` at the end of the edge. */
  node: ProjectWatcher;
};

/** Methods to use when ordering `ProjectWatcher`. */
export enum ProjectWatchersOrderBy {
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROJECT_ID_ASC = 'PROJECT_ID_ASC',
  PROJECT_ID_DESC = 'PROJECT_ID_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC'
}

/** A connection to a list of `Project` values. */
export type ProjectsConnection = {
  __typename?: 'ProjectsConnection';
  /** A list of edges which contains the `Project` and cursor to aid in pagination. */
  edges: Array<ProjectsEdge>;
  /** A list of `Project` objects. */
  nodes: Array<Project>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Aggregates a metric by label for the specified filter expression. */
  savingsEventData?: Maybe<MetricDataConnection>;
  /** The count of *all* `Project` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A connection to a list of `Project` values. */
export type ProjectsConnectionSavingsEventDataArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A `Project` edge in the connection. */
export type ProjectsEdge = {
  __typename?: 'ProjectsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Project` at the end of the edge. */
  node: Project;
};

/** Methods to use when ordering `Project`. */
export enum ProjectsOrderBy {
  ACKNOWLEDGEMENT_WINDOW_THRESHOLD_ASC = 'ACKNOWLEDGEMENT_WINDOW_THRESHOLD_ASC',
  ACKNOWLEDGEMENT_WINDOW_THRESHOLD_DESC = 'ACKNOWLEDGEMENT_WINDOW_THRESHOLD_DESC',
  AUTO_ACKNOWLEDGE_ASC = 'AUTO_ACKNOWLEDGE_ASC',
  AUTO_ACKNOWLEDGE_DESC = 'AUTO_ACKNOWLEDGE_DESC',
  CONTROL_TYPE_ASC = 'CONTROL_TYPE_ASC',
  CONTROL_TYPE_DESC = 'CONTROL_TYPE_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  END_DATE_ASC = 'END_DATE_ASC',
  END_DATE_DESC = 'END_DATE_DESC',
  END_TIMEOUT_ASC = 'END_TIMEOUT_ASC',
  END_TIMEOUT_DESC = 'END_TIMEOUT_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  FACILITY_NAME_ASC = 'FACILITY_NAME_ASC',
  FACILITY_NAME_DESC = 'FACILITY_NAME_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IS_WATCHING_ASC = 'IS_WATCHING_ASC',
  IS_WATCHING_DESC = 'IS_WATCHING_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROGRAM_ID_ASC = 'PROGRAM_ID_ASC',
  PROGRAM_ID_DESC = 'PROGRAM_ID_DESC',
  PROGRAM_NAME_ASC = 'PROGRAM_NAME_ASC',
  PROGRAM_NAME_DESC = 'PROGRAM_NAME_DESC',
  PROJECT_TYPE_ID_ASC = 'PROJECT_TYPE_ID_ASC',
  PROJECT_TYPE_ID_DESC = 'PROJECT_TYPE_ID_DESC',
  PROJECT_TYPE_NAME_ASC = 'PROJECT_TYPE_NAME_ASC',
  PROJECT_TYPE_NAME_DESC = 'PROJECT_TYPE_NAME_DESC',
  START_DATE_ASC = 'START_DATE_ASC',
  START_DATE_DESC = 'START_DATE_DESC',
  START_TIMEOUT_ASC = 'START_TIMEOUT_ASC',
  START_TIMEOUT_DESC = 'START_TIMEOUT_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** The root query type which gives access points into the data universe. */
export type Query = Node & {
  __typename?: 'Query';
  accountCharge?: Maybe<AccountCharge>;
  /** Reads a single `AccountCharge` using its globally unique `ID`. */
  accountChargeByNodeId?: Maybe<AccountCharge>;
  /** Reads and enables pagination through a set of `AccountCharge`. */
  accountCharges?: Maybe<AccountChargesConnection>;
  accountStatement?: Maybe<AccountStatement>;
  /** Reads a single `AccountStatement` using its globally unique `ID`. */
  accountStatementByNodeId?: Maybe<AccountStatement>;
  /** Reads and enables pagination through a set of `AccountStatementHistory`. */
  accountStatementHistories?: Maybe<AccountStatementHistoriesConnection>;
  accountStatementPdf?: Maybe<AccountStatementPdf>;
  accountStatementPdfByAccountStatementIdAndFileKey?: Maybe<AccountStatementPdf>;
  /** Reads a single `AccountStatementPdf` using its globally unique `ID`. */
  accountStatementPdfByNodeId?: Maybe<AccountStatementPdf>;
  /** Reads and enables pagination through a set of `AccountStatementPdf`. */
  accountStatementPdfs?: Maybe<AccountStatementPdfsConnection>;
  /** Reads and enables pagination through a set of `AccountStatement`. */
  accountStatements?: Maybe<AccountStatementsConnection>;
  /** Reads and enables pagination through a set of `BalancingAuthority`. */
  balancingAuthorities?: Maybe<BalancingAuthoritiesConnection>;
  balancingAuthority?: Maybe<BalancingAuthority>;
  /** Reads a single `BalancingAuthority` using its globally unique `ID`. */
  balancingAuthorityByNodeId?: Maybe<BalancingAuthority>;
  balancingAuthorityBySlug?: Maybe<BalancingAuthority>;
  blast?: Maybe<Blast>;
  blastByLabelAndFacilityId?: Maybe<Blast>;
  /** Reads a single `Blast` using its globally unique `ID`. */
  blastByNodeId?: Maybe<Blast>;
  blastEvaporator?: Maybe<BlastEvaporator>;
  /** Reads a single `BlastEvaporator` using its globally unique `ID`. */
  blastEvaporatorByNodeId?: Maybe<BlastEvaporator>;
  /** Reads and enables pagination through a set of `BlastEvaporator`. */
  blastEvaporators?: Maybe<BlastEvaporatorsConnection>;
  blastPallet?: Maybe<BlastPallet>;
  /** Reads a single `BlastPallet` using its globally unique `ID`. */
  blastPalletByNodeId?: Maybe<BlastPallet>;
  blastPalletLocation?: Maybe<BlastPalletLocation>;
  /** Reads a single `BlastPalletLocation` using its globally unique `ID`. */
  blastPalletLocationByNodeId?: Maybe<BlastPalletLocation>;
  /** Reads and enables pagination through a set of `BlastPalletLocation`. */
  blastPalletLocations?: Maybe<BlastPalletLocationsConnection>;
  /** Reads and enables pagination through a set of `BlastPallet`. */
  blastPallets?: Maybe<BlastPalletsConnection>;
  blastRotation?: Maybe<BlastRotation>;
  blastRotationAlert?: Maybe<BlastRotationAlert>;
  /** Reads a single `BlastRotationAlert` using its globally unique `ID`. */
  blastRotationAlertByNodeId?: Maybe<BlastRotationAlert>;
  /** Reads and enables pagination through a set of `BlastRotationAlert`. */
  blastRotationAlerts?: Maybe<BlastRotationAlertsConnection>;
  /** Reads a single `BlastRotation` using its globally unique `ID`. */
  blastRotationByNodeId?: Maybe<BlastRotation>;
  blastRotationEventLog?: Maybe<BlastRotationEventLog>;
  blastRotationEventLogByBlastRotationIdAndDescriptionAndBlastRotationEventTypeId?: Maybe<BlastRotationEventLog>;
  /** Reads a single `BlastRotationEventLog` using its globally unique `ID`. */
  blastRotationEventLogByNodeId?: Maybe<BlastRotationEventLog>;
  /** Reads and enables pagination through a set of `BlastRotationEventLog`. */
  blastRotationEventLogs?: Maybe<BlastRotationEventLogsConnection>;
  blastRotationEventType?: Maybe<BlastRotationEventType>;
  /** Reads a single `BlastRotationEventType` using its globally unique `ID`. */
  blastRotationEventTypeByNodeId?: Maybe<BlastRotationEventType>;
  /** Reads and enables pagination through a set of `BlastRotationEventType`. */
  blastRotationEventTypes?: Maybe<BlastRotationEventTypesConnection>;
  blastRotationPallet?: Maybe<BlastRotationPallet>;
  blastRotationPalletByBlastRotationIdAndPalletId?: Maybe<BlastRotationPallet>;
  /** Reads a single `BlastRotationPallet` using its globally unique `ID`. */
  blastRotationPalletByNodeId?: Maybe<BlastRotationPallet>;
  /** Reads and enables pagination through a set of `BlastRotationPallet`. */
  blastRotationPallets?: Maybe<BlastRotationPalletsConnection>;
  /** Reads and enables pagination through a set of `BlastRotation`. */
  blastRotations?: Maybe<BlastRotationsConnection>;
  blastType?: Maybe<BlastType>;
  /** Reads a single `BlastType` using its globally unique `ID`. */
  blastTypeByNodeId?: Maybe<BlastType>;
  /** Reads and enables pagination through a set of `BlastType`. */
  blastTypes?: Maybe<BlastTypesConnection>;
  /** Reads and enables pagination through a set of `Blast`. */
  blasts?: Maybe<BlastsConnection>;
  buildingArea?: Maybe<BuildingArea>;
  buildingAreaByFacilityIdAndLabel?: Maybe<BuildingArea>;
  /** Reads a single `BuildingArea` using its globally unique `ID`. */
  buildingAreaByNodeId?: Maybe<BuildingArea>;
  buildingAreaComplianceGroup?: Maybe<BuildingAreaComplianceGroup>;
  buildingAreaComplianceGroupByBuildingAreaIdAndComplianceType?: Maybe<BuildingAreaComplianceGroup>;
  /** Reads a single `BuildingAreaComplianceGroup` using its globally unique `ID`. */
  buildingAreaComplianceGroupByNodeId?: Maybe<BuildingAreaComplianceGroup>;
  /** Reads and enables pagination through a set of `BuildingAreaComplianceGroup`. */
  buildingAreaComplianceGroups?: Maybe<BuildingAreaComplianceGroupsConnection>;
  buildingAreaType?: Maybe<BuildingAreaType>;
  /** Reads a single `BuildingAreaType` using its globally unique `ID`. */
  buildingAreaTypeByNodeId?: Maybe<BuildingAreaType>;
  /** Reads and enables pagination through a set of `BuildingAreaType`. */
  buildingAreaTypes?: Maybe<BuildingAreaTypesConnection>;
  /** Reads and enables pagination through a set of `BuildingArea`. */
  buildingAreas?: Maybe<BuildingAreasConnection>;
  chart?: Maybe<Chart>;
  /** Reads a single `Chart` using its globally unique `ID`. */
  chartByNodeId?: Maybe<Chart>;
  /** Reads and enables pagination through a set of `Chart`. */
  charts?: Maybe<ChartsConnection>;
  complianceGroup?: Maybe<ComplianceGroup>;
  complianceGroupByLabel?: Maybe<ComplianceGroup>;
  /** Reads a single `ComplianceGroup` using its globally unique `ID`. */
  complianceGroupByNodeId?: Maybe<ComplianceGroup>;
  /** Reads and enables pagination through a set of `ComplianceGroup`. */
  complianceGroups?: Maybe<ComplianceGroupsConnection>;
  complianceRange?: Maybe<ComplianceRange>;
  complianceRangeByComplianceGroupIdAndLabel?: Maybe<ComplianceRange>;
  /** Reads a single `ComplianceRange` using its globally unique `ID`. */
  complianceRangeByNodeId?: Maybe<ComplianceRange>;
  /** Reads and enables pagination through a set of `ComplianceRange`. */
  complianceRanges?: Maybe<ComplianceRangesConnection>;
  component?: Maybe<Component>;
  /** Reads a single `Component` using its globally unique `ID`. */
  componentByNodeId?: Maybe<Component>;
  /** Reads and enables pagination through a set of `Component`. */
  components?: Maybe<ComponentsConnection>;
  compressor?: Maybe<Compressor>;
  compressorByFacilityIdAndLabel?: Maybe<Compressor>;
  /** Reads a single `Compressor` using its globally unique `ID`. */
  compressorByNodeId?: Maybe<Compressor>;
  /** Reads and enables pagination through a set of `Compressor`. */
  compressors?: Maybe<CompressorsConnection>;
  controlEvent?: Maybe<ControlEvent>;
  /** Reads a single `ControlEvent` using its globally unique `ID`. */
  controlEventByNodeId?: Maybe<ControlEvent>;
  controlEventLog?: Maybe<ControlEventLog>;
  /** Reads a single `ControlEventLog` using its globally unique `ID`. */
  controlEventLogByNodeId?: Maybe<ControlEventLog>;
  /** Reads a single `ControlEventStateTransition` using its globally unique `ID`. */
  controlEventStateTransitionByNodeId?: Maybe<ControlEventStateTransition>;
  /** Reads and enables pagination through a set of `ControlEvent`. */
  controlEvents?: Maybe<ControlEventsConnection>;
  currentIdentity?: Maybe<Identity>;
  customer?: Maybe<Customer>;
  /** Reads a single `Customer` using its globally unique `ID`. */
  customerByNodeId?: Maybe<Customer>;
  customerBySourceId?: Maybe<Customer>;
  /** Reads and enables pagination through a set of `Customer`. */
  customers?: Maybe<CustomersConnection>;
  dashboard?: Maybe<Dashboard>;
  /** Reads a single `Dashboard` using its globally unique `ID`. */
  dashboardByNodeId?: Maybe<Dashboard>;
  /** Reads and enables pagination through a set of `Dashboard`. */
  dashboards?: Maybe<DashboardsConnection>;
  dataPoint?: Maybe<DataPoint>;
  dataPointById?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` using its globally unique `ID`. */
  dataPointByNodeId?: Maybe<DataPoint>;
  dataPointTag?: Maybe<DataPointTag>;
  /** Reads a single `DataPointTag` using its globally unique `ID`. */
  dataPointTagByNodeId?: Maybe<DataPointTag>;
  /** Reads and enables pagination through a set of `DataPointTag`. */
  dataPointTags?: Maybe<DataPointTagsConnection>;
  /** Reads and enables pagination through a set of `DataPoint`. */
  dataPoints?: Maybe<DataPointsConnection>;
  dataSource?: Maybe<DataSource>;
  /** Reads a single `DataSource` using its globally unique `ID`. */
  dataSourceByNodeId?: Maybe<DataSource>;
  /** Reads and enables pagination through a set of `DataSource`. */
  dataSources?: Maybe<DataSourcesConnection>;
  /** Reads and enables pagination through a set of `Dependency`. */
  dependencies?: Maybe<DependenciesConnection>;
  dependency?: Maybe<Dependency>;
  /** Reads a single `Dependency` using its globally unique `ID`. */
  dependencyByNodeId?: Maybe<Dependency>;
  dependencyByPath?: Maybe<Dependency>;
  /** Returns the derived statement date for the interval */
  deriveStatementDate?: Maybe<DerivedStatementDate>;
  door?: Maybe<Door>;
  doorByFacilityIdAndLabel?: Maybe<Door>;
  /** Reads a single `Door` using its globally unique `ID`. */
  doorByNodeId?: Maybe<Door>;
  /** Reads and enables pagination through a set of `Door`. */
  doors?: Maybe<DoorsConnection>;
  /** Returns a list enabled module extensions */
  enabledModuleExtensions?: Maybe<Array<Maybe<ModuleExtension>>>;
  evaporator?: Maybe<Evaporator>;
  evaporatorByFacilityIdAndLabel?: Maybe<Evaporator>;
  /** Reads a single `Evaporator` using its globally unique `ID`. */
  evaporatorByNodeId?: Maybe<Evaporator>;
  /** Reads and enables pagination through a set of `Evaporator`. */
  evaporators?: Maybe<EvaporatorsConnection>;
  event?: Maybe<Event>;
  /** Reads a single `Event` using its globally unique `ID`. */
  eventByNodeId?: Maybe<Event>;
  eventHandler?: Maybe<EventHandler>;
  /** Reads a single `EventHandler` using its globally unique `ID`. */
  eventHandlerByNodeId?: Maybe<EventHandler>;
  eventHandlerMetadatum?: Maybe<EventHandlerMetadatum>;
  /** Reads a single `EventHandlerMetadatum` using its globally unique `ID`. */
  eventHandlerMetadatumByNodeId?: Maybe<EventHandlerMetadatum>;
  eventType?: Maybe<EventType>;
  /** Reads a single `EventType` using its globally unique `ID`. */
  eventTypeByNodeId?: Maybe<EventType>;
  /** Reads and enables pagination through a set of `Facility`. */
  facilities?: Maybe<FacilitiesConnection>;
  facility?: Maybe<Facility>;
  /** Reads a single `Facility` using its globally unique `ID`. */
  facilityByNodeId?: Maybe<Facility>;
  facilityBySlug?: Maybe<Facility>;
  facilityCommunication?: Maybe<FacilityCommunication>;
  /** Reads a single `FacilityCommunication` using its globally unique `ID`. */
  facilityCommunicationByNodeId?: Maybe<FacilityCommunication>;
  /** Reads and enables pagination through a set of `FacilityCommunication`. */
  facilityCommunications?: Maybe<FacilityCommunicationsConnection>;
  facilityConfig?: Maybe<FacilityConfig>;
  /** Reads a single `FacilityConfig` using its globally unique `ID`. */
  facilityConfigByNodeId?: Maybe<FacilityConfig>;
  /** Reads and enables pagination through a set of `FacilityConfig`. */
  facilityConfigs?: Maybe<FacilityConfigsConnection>;
  facilityDataSource?: Maybe<FacilityDataSource>;
  /** Reads a single `FacilityDataSource` using its globally unique `ID`. */
  facilityDataSourceByNodeId?: Maybe<FacilityDataSource>;
  /** Reads and enables pagination through a set of `FacilityDataSource`. */
  facilityDataSources?: Maybe<FacilityDataSourcesConnection>;
  facilityGroup?: Maybe<FacilityGroup>;
  /** Reads a single `FacilityGroup` using its globally unique `ID`. */
  facilityGroupByNodeId?: Maybe<FacilityGroup>;
  /** Reads and enables pagination through a set of `FacilityGroup`. */
  facilityGroups?: Maybe<FacilityGroupsConnection>;
  facilityGroupsLinker?: Maybe<FacilityGroupsLinker>;
  /** Reads a single `FacilityGroupsLinker` using its globally unique `ID`. */
  facilityGroupsLinkerByNodeId?: Maybe<FacilityGroupsLinker>;
  /** Reads and enables pagination through a set of `FacilityGroupsLinker`. */
  facilityGroupsLinkers?: Maybe<FacilityGroupsLinkersConnection>;
  facilityTaggedDataPoint?: Maybe<FacilityTaggedDataPoint>;
  /** Reads a single `FacilityTaggedDataPoint` using its globally unique `ID`. */
  facilityTaggedDataPointByNodeId?: Maybe<FacilityTaggedDataPoint>;
  /** Reads and enables pagination through a set of `FacilityTaggedDataPoint`. */
  facilityTaggedDataPoints?: Maybe<FacilityTaggedDataPointsConnection>;
  /** A json object of all facility groups built from the root. */
  groupings?: Maybe<GroupingsConnection>;
  /** A json object of all facility groups with their facilities built from the root and all ungrouped facilities */
  groupingsWithFacilities?: Maybe<GroupingsWithFacilitiesConnection>;
  inboundOutboundLoad?: Maybe<InboundOutboundLoad>;
  inboundOutboundLoadByFacilityIdAndDirectionAndSourceId?: Maybe<InboundOutboundLoad>;
  /** Reads a single `InboundOutboundLoad` using its globally unique `ID`. */
  inboundOutboundLoadByNodeId?: Maybe<InboundOutboundLoad>;
  /** Reads and enables pagination through a set of `InboundOutboundLoad`. */
  inboundOutboundLoads?: Maybe<InboundOutboundLoadsConnection>;
  machineUser?: Maybe<MachineUser>;
  /** Reads a single `MachineUser` using its globally unique `ID`. */
  machineUserByNodeId?: Maybe<MachineUser>;
  /** Reads and enables pagination through a set of `MachineUser`. */
  machineUsers?: Maybe<MachineUsersConnection>;
  mainService?: Maybe<MainService>;
  mainServiceByFacilityIdAndName?: Maybe<MainService>;
  mainServiceByFacilityIdAndUsageDataPointIdAndDemandDataPointId?: Maybe<MainService>;
  /** Reads a single `MainService` using its globally unique `ID`. */
  mainServiceByNodeId?: Maybe<MainService>;
  /** Reads and enables pagination through a set of `MainService`. */
  mainServices?: Maybe<MainServicesConnection>;
  meterCharge?: Maybe<MeterCharge>;
  /** Reads a single `MeterCharge` using its globally unique `ID`. */
  meterChargeByNodeId?: Maybe<MeterCharge>;
  /** Reads and enables pagination through a set of `MeterCharge`. */
  meterCharges?: Maybe<MeterChargesConnection>;
  meterStatement?: Maybe<MeterStatement>;
  /** Reads a single `MeterStatement` using its globally unique `ID`. */
  meterStatementByNodeId?: Maybe<MeterStatement>;
  /** Reads and enables pagination through a set of `MeterStatementHistory`. */
  meterStatementHistories?: Maybe<MeterStatementHistoriesConnection>;
  /** @deprecated Use pdfUri property on the statement */
  meterStatementPdf?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `MeterStatement`. */
  meterStatements?: Maybe<MeterStatementsConnection>;
  meterUsage?: Maybe<MeterUsage>;
  /** Reads a single `MeterUsage` using its globally unique `ID`. */
  meterUsageByNodeId?: Maybe<MeterUsage>;
  /** Reads and enables pagination through a set of `MeterUsage`. */
  meterUsages?: Maybe<MeterUsagesConnection>;
  /** @deprecated Use `sourceData` for IoT time series data. */
  metricData?: Maybe<MetricDataConnection>;
  /** @deprecated Use `sourceLabels` for IoT device name and field discovery. */
  metricLabels: Array<MetricLabel>;
  /** Reads and enables pagination through a set of `MetricMetadatum`. */
  metricMetadata?: Maybe<MetricMetadataConnection>;
  metricMetadatum?: Maybe<MetricMetadatum>;
  /** Reads a single `MetricMetadatum` using its globally unique `ID`. */
  metricMetadatumByNodeId?: Maybe<MetricMetadatum>;
  /** Returns a list of known module extensions */
  moduleExtensions?: Maybe<Array<ModuleExtension>>;
  /** Fetches an object given its globally unique `ID`. */
  node?: Maybe<Node>;
  /** The root query type must be a `Node` to work well with Relay 1 mutations. This just resolves to `query`. */
  nodeId: Scalars['ID'];
  pallet?: Maybe<Pallet>;
  /** Reads a single `Pallet` using its globally unique `ID`. */
  palletByNodeId?: Maybe<Pallet>;
  palletBySourceId?: Maybe<Pallet>;
  /** Reads and enables pagination through a set of `PalletHistory`. */
  palletHistories?: Maybe<PalletHistoriesConnection>;
  palletHistory?: Maybe<PalletHistory>;
  /** Reads a single `PalletHistory` using its globally unique `ID`. */
  palletHistoryByNodeId?: Maybe<PalletHistory>;
  palletHistoryBySourceId?: Maybe<PalletHistory>;
  palletLocation?: Maybe<PalletLocation>;
  /** Reads a single `PalletLocation` using its globally unique `ID`. */
  palletLocationByNodeId?: Maybe<PalletLocation>;
  palletLocationBySourceId?: Maybe<PalletLocation>;
  /** Reads and enables pagination through a set of `PalletLocation`. */
  palletLocations?: Maybe<PalletLocationsConnection>;
  /** Reads and enables pagination through a set of `Pallet`. */
  pallets?: Maybe<PalletsConnection>;
  /** Reads and enables pagination through a set of `PlatformAccessToken`. */
  platformAccessTokens?: Maybe<PlatformAccessTokensConnection>;
  /** Returns a list of known platform errors */
  platformErrors: Array<PlatformError>;
  pricingNode?: Maybe<PricingNode>;
  /** Reads a single `PricingNode` using its globally unique `ID`. */
  pricingNodeByNodeId?: Maybe<PricingNode>;
  /** Reads and enables pagination through a set of `PricingNode`. */
  pricingNodes?: Maybe<PricingNodesConnection>;
  product?: Maybe<Product>;
  /** Reads a single `Product` using its globally unique `ID`. */
  productByNodeId?: Maybe<Product>;
  productBySourceId?: Maybe<Product>;
  /** Reads and enables pagination through a set of `Product`. */
  products?: Maybe<ProductsConnection>;
  /** Returns the current user`s profile. */
  profile?: Maybe<User>;
  program?: Maybe<Program>;
  /** Reads a single `Program` using its globally unique `ID`. */
  programByNodeId?: Maybe<Program>;
  programByProjectTypeIdAndName?: Maybe<Program>;
  programEnrollment?: Maybe<ProgramEnrollment>;
  /** Reads a single `ProgramEnrollment` using its globally unique `ID`. */
  programEnrollmentByNodeId?: Maybe<ProgramEnrollment>;
  programEnrollmentByProgramIdAndName?: Maybe<ProgramEnrollment>;
  /** Reads and enables pagination through a set of `ProgramEnrollment`. */
  programEnrollments?: Maybe<ProgramEnrollmentsConnection>;
  /** Reads and enables pagination through a set of `Program`. */
  programs?: Maybe<ProgramsConnection>;
  project?: Maybe<Project>;
  projectByFacilityIdAndProgramId?: Maybe<Project>;
  /** Reads a single `Project` using its globally unique `ID`. */
  projectByNodeId?: Maybe<Project>;
  projectComponent?: Maybe<ProjectComponent>;
  /** Reads a single `ProjectComponent` using its globally unique `ID`. */
  projectComponentByNodeId?: Maybe<ProjectComponent>;
  projectConfig?: Maybe<ProjectConfig>;
  /** Reads a single `ProjectConfig` using its globally unique `ID`. */
  projectConfigByNodeId?: Maybe<ProjectConfig>;
  /** Reads and enables pagination through a set of `ProjectConfig`. */
  projectConfigs?: Maybe<ProjectConfigsConnection>;
  projectEnrollment?: Maybe<ProjectEnrollment>;
  /** Reads a single `ProjectEnrollment` using its globally unique `ID`. */
  projectEnrollmentByNodeId?: Maybe<ProjectEnrollment>;
  projectEnrollmentByProjectIdAndProgramEnrollmentId?: Maybe<ProjectEnrollment>;
  projectEnrollmentDataPoint?: Maybe<ProjectEnrollmentDataPoint>;
  /** Reads a single `ProjectEnrollmentDataPoint` using its globally unique `ID`. */
  projectEnrollmentDataPointByNodeId?: Maybe<ProjectEnrollmentDataPoint>;
  projectEnrollmentDataPointByProjectEnrollmentIdAndDataPointId?: Maybe<ProjectEnrollmentDataPoint>;
  projectEnrollmentDataPointGroup?: Maybe<ProjectEnrollmentDataPointGroup>;
  /** Reads a single `ProjectEnrollmentDataPointGroup` using its globally unique `ID`. */
  projectEnrollmentDataPointGroupByNodeId?: Maybe<ProjectEnrollmentDataPointGroup>;
  /** Reads and enables pagination through a set of `ProjectEnrollmentDataPointGroup`. */
  projectEnrollmentDataPointGroups?: Maybe<ProjectEnrollmentDataPointGroupsConnection>;
  /** Reads and enables pagination through a set of `ProjectEnrollmentDataPoint`. */
  projectEnrollmentDataPoints?: Maybe<ProjectEnrollmentDataPointsConnection>;
  /** Reads and enables pagination through a set of `ProjectEnrollment`. */
  projectEnrollments?: Maybe<ProjectEnrollmentsConnection>;
  projectType?: Maybe<ProjectType>;
  projectTypeByName?: Maybe<ProjectType>;
  /** Reads a single `ProjectType` using its globally unique `ID`. */
  projectTypeByNodeId?: Maybe<ProjectType>;
  /** Reads and enables pagination through a set of `ProjectType`. */
  projectTypes?: Maybe<ProjectTypesConnection>;
  projectWatcher?: Maybe<ProjectWatcher>;
  /** Reads a single `ProjectWatcher` using its globally unique `ID`. */
  projectWatcherByNodeId?: Maybe<ProjectWatcher>;
  /** Reads and enables pagination through a set of `ProjectWatcher`. */
  projectWatchers?: Maybe<ProjectWatchersConnection>;
  /** Reads and enables pagination through a set of `Project`. */
  projects?: Maybe<ProjectsConnection>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  report?: Maybe<Report>;
  reportByLabel?: Maybe<Report>;
  /** Reads a single `Report` using its globally unique `ID`. */
  reportByNodeId?: Maybe<Report>;
  reportExecution?: Maybe<ReportExecution>;
  /** Reads a single `ReportExecution` using its globally unique `ID`. */
  reportExecutionByNodeId?: Maybe<ReportExecution>;
  /** Reads and enables pagination through a set of `ReportExecution`. */
  reportExecutions?: Maybe<ReportExecutionsConnection>;
  /** Reads and enables pagination through a set of `ReportQuery`. */
  reportQueries?: Maybe<ReportQueriesConnection>;
  reportQuery?: Maybe<ReportQuery>;
  /** Reads a single `ReportQuery` using its globally unique `ID`. */
  reportQueryByNodeId?: Maybe<ReportQuery>;
  reportQueryByReportIdAndLabel?: Maybe<ReportQuery>;
  /** Reads and enables pagination through a set of `Report`. */
  reports?: Maybe<ReportsConnection>;
  savingsEvent?: Maybe<SavingsEvent>;
  /** Reads a single `SavingsEvent` using its globally unique `ID`. */
  savingsEventByNodeId?: Maybe<SavingsEvent>;
  savingsEventByProjectIdAndStartTimeAndEndTime?: Maybe<SavingsEvent>;
  /** Reads and enables pagination through a set of `SavingsEvent`. */
  savingsEvents?: Maybe<SavingsEventsConnection>;
  sourceData?: Maybe<MetricDataConnection>;
  sourceLabels: Array<SourceLabel>;
  suggestion?: Maybe<Suggestion>;
  /** Reads and enables pagination through a set of `SuggestionActivityLog`. */
  suggestionActivityLogs?: Maybe<SuggestionActivityLogsConnection>;
  /** Reads a single `Suggestion` using its globally unique `ID`. */
  suggestionByNodeId?: Maybe<Suggestion>;
  suggestionControlEvent?: Maybe<SuggestionControlEvent>;
  suggestionControlEventByControlEventId?: Maybe<SuggestionControlEvent>;
  /** Reads a single `SuggestionControlEvent` using its globally unique `ID`. */
  suggestionControlEventByNodeId?: Maybe<SuggestionControlEvent>;
  /** Reads and enables pagination through a set of `Suggestion`. */
  suggestions?: Maybe<SuggestionsConnection>;
  temperatureSensor?: Maybe<TemperatureSensor>;
  temperatureSensorByFacilityIdAndLabel?: Maybe<TemperatureSensor>;
  /** Reads a single `TemperatureSensor` using its globally unique `ID`. */
  temperatureSensorByNodeId?: Maybe<TemperatureSensor>;
  /** Reads and enables pagination through a set of `TemperatureSensor`. */
  temperatureSensors?: Maybe<TemperatureSensorsConnection>;
  timezone?: Maybe<Timezone>;
  /** Reads a single `Timezone` using its globally unique `ID`. */
  timezoneByNodeId?: Maybe<Timezone>;
  /** Reads and enables pagination through a set of `Timezone`. */
  timezones?: Maybe<TimezonesConnection>;
  trailerPosition?: Maybe<TrailerPosition>;
  trailerPositionByFacilityIdAndLabel?: Maybe<TrailerPosition>;
  /** Reads a single `TrailerPosition` using its globally unique `ID`. */
  trailerPositionByNodeId?: Maybe<TrailerPosition>;
  /** Reads and enables pagination through a set of `TrailerPosition`. */
  trailerPositions?: Maybe<TrailerPositionsConnection>;
  unitDimension?: Maybe<UnitDimension>;
  /** Reads a single `UnitDimension` using its globally unique `ID`. */
  unitDimensionByNodeId?: Maybe<UnitDimension>;
  /** Reads and enables pagination through a set of `UnitDimension`. */
  unitDimensions?: Maybe<UnitDimensionsConnection>;
  unitGroup?: Maybe<UnitGroup>;
  /** Reads a single `UnitGroup` using its globally unique `ID`. */
  unitGroupByNodeId?: Maybe<UnitGroup>;
  unitGroupDimension?: Maybe<UnitGroupDimension>;
  /** Reads a single `UnitGroupDimension` using its globally unique `ID`. */
  unitGroupDimensionByNodeId?: Maybe<UnitGroupDimension>;
  /** Reads and enables pagination through a set of `UnitGroupDimension`. */
  unitGroupDimensions?: Maybe<UnitGroupDimensionsConnection>;
  /** Reads and enables pagination through a set of `UnitGroup`. */
  unitGroups?: Maybe<UnitGroupsConnection>;
  user?: Maybe<User>;
  /** Reads a single `User` using its globally unique `ID`. */
  userByNodeId?: Maybe<User>;
  /** Reads and enables pagination through a set of `User`. */
  users?: Maybe<UsersConnection>;
  utilityAccount?: Maybe<UtilityAccount>;
  /** Reads a single `UtilityAccount` using its globally unique `ID`. */
  utilityAccountByNodeId?: Maybe<UtilityAccount>;
  utilityAccountStatement?: Maybe<UtilityAccountStatement>;
  /** Reads a single `UtilityAccountStatement` using its globally unique `ID`. */
  utilityAccountStatementByNodeId?: Maybe<UtilityAccountStatement>;
  utilityAccountStatementRollup?: Maybe<UtilityAccountStatementRollup>;
  /** Reads a single `UtilityAccountStatementRollup` using its globally unique `ID`. */
  utilityAccountStatementRollupByNodeId?: Maybe<UtilityAccountStatementRollup>;
  /** Reads and enables pagination through a set of `UtilityAccountStatementRollup`. */
  utilityAccountStatementRollups?: Maybe<UtilityAccountStatementRollupsConnection>;
  /** Reads and enables pagination through a set of `UtilityAccountStatement`. */
  utilityAccountStatements?: Maybe<UtilityAccountStatementsConnection>;
  /** Reads and enables pagination through a set of `UtilityAccount`. */
  utilityAccounts?: Maybe<UtilityAccountsConnection>;
  utilityMeter?: Maybe<UtilityMeter>;
  /** Reads a single `UtilityMeter` using its globally unique `ID`. */
  utilityMeterByNodeId?: Maybe<UtilityMeter>;
  utilityMeterStatement?: Maybe<UtilityMeterStatement>;
  /** Reads a single `UtilityMeterStatement` using its globally unique `ID`. */
  utilityMeterStatementByNodeId?: Maybe<UtilityMeterStatement>;
  utilityMeterStatementRollup?: Maybe<UtilityMeterStatementRollup>;
  /** Reads a single `UtilityMeterStatementRollup` using its globally unique `ID`. */
  utilityMeterStatementRollupByNodeId?: Maybe<UtilityMeterStatementRollup>;
  /** Reads and enables pagination through a set of `UtilityMeterStatementRollup`. */
  utilityMeterStatementRollups?: Maybe<UtilityMeterStatementRollupsConnection>;
  /** Reads and enables pagination through a set of `UtilityMeterStatement`. */
  utilityMeterStatements?: Maybe<UtilityMeterStatementsConnection>;
  /** Reads and enables pagination through a set of `UtilityMeter`. */
  utilityMeters?: Maybe<UtilityMetersConnection>;
  utilityProvider?: Maybe<UtilityProvider>;
  utilityProviderByName?: Maybe<UtilityProvider>;
  /** Reads a single `UtilityProvider` using its globally unique `ID`. */
  utilityProviderByNodeId?: Maybe<UtilityProvider>;
  /** Reads and enables pagination through a set of `UtilityProvider`. */
  utilityProviders?: Maybe<UtilityProvidersConnection>;
  vendorUser?: Maybe<VendorUser>;
  vendorUserByEmail?: Maybe<VendorUser>;
  /** Reads a single `VendorUser` using its globally unique `ID`. */
  vendorUserByNodeId?: Maybe<VendorUser>;
  vendorUserMachineUser?: Maybe<VendorUserMachineUser>;
  vendorUserMachineUserByMachineUserId?: Maybe<VendorUserMachineUser>;
  /** Reads a single `VendorUserMachineUser` using its globally unique `ID`. */
  vendorUserMachineUserByNodeId?: Maybe<VendorUserMachineUser>;
  /** Reads and enables pagination through a set of `VendorUser`. */
  vendorUsers?: Maybe<VendorUsersConnection>;
  virtualPointInterval?: Maybe<VirtualPointInterval>;
  /** Reads a single `VirtualPointInterval` using its globally unique `ID`. */
  virtualPointIntervalByNodeId?: Maybe<VirtualPointInterval>;
  /** Reads and enables pagination through a set of `VirtualPointInterval`. */
  virtualPointIntervals?: Maybe<VirtualPointIntervalsConnection>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAccountChargeArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryAccountChargeByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryAccountChargesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountChargeCondition>;
  filter?: InputMaybe<AccountChargeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountChargesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAccountStatementArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryAccountStatementByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryAccountStatementHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountStatementHistoryCondition>;
  filter?: InputMaybe<AccountStatementHistoryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountStatementHistoriesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAccountStatementPdfArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryAccountStatementPdfByAccountStatementIdAndFileKeyArgs = {
  accountStatementId: Scalars['Int'];
  fileKey: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryAccountStatementPdfByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryAccountStatementPdfsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountStatementPdfCondition>;
  filter?: InputMaybe<AccountStatementPdfFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountStatementPdfsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAccountStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountStatementCondition>;
  filter?: InputMaybe<AccountStatementFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountStatementsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryBalancingAuthoritiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BalancingAuthorityCondition>;
  filter?: InputMaybe<BalancingAuthorityFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BalancingAuthoritiesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryBalancingAuthorityArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBalancingAuthorityByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBalancingAuthorityBySlugArgs = {
  slug: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastByLabelAndFacilityIdArgs = {
  facilityId: Scalars['Int'];
  label: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastEvaporatorArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastEvaporatorByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastEvaporatorsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BlastEvaporatorCondition>;
  filter?: InputMaybe<BlastEvaporatorFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BlastEvaporatorsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastPalletArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastPalletByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastPalletLocationArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastPalletLocationByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastPalletLocationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BlastPalletLocationCondition>;
  filter?: InputMaybe<BlastPalletLocationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BlastPalletLocationsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastPalletsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BlastPalletCondition>;
  filter?: InputMaybe<BlastPalletFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BlastPalletsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastRotationArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastRotationAlertArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastRotationAlertByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastRotationAlertsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BlastRotationAlertCondition>;
  filter?: InputMaybe<BlastRotationAlertFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BlastRotationAlertsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastRotationByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastRotationEventLogArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastRotationEventLogByBlastRotationIdAndDescriptionAndBlastRotationEventTypeIdArgs =
  {
    blastRotationEventTypeId: Scalars['String'];
    blastRotationId: Scalars['Int'];
    description: Scalars['String'];
  };

/** The root query type which gives access points into the data universe. */
export type QueryBlastRotationEventLogByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastRotationEventLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BlastRotationEventLogCondition>;
  filter?: InputMaybe<BlastRotationEventLogFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BlastRotationEventLogsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastRotationEventTypeArgs = {
  eventType: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastRotationEventTypeByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastRotationEventTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BlastRotationEventTypeCondition>;
  filter?: InputMaybe<BlastRotationEventTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BlastRotationEventTypesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastRotationPalletArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastRotationPalletByBlastRotationIdAndPalletIdArgs = {
  blastRotationId: Scalars['Int'];
  palletId: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastRotationPalletByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastRotationPalletsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BlastRotationPalletCondition>;
  filter?: InputMaybe<BlastRotationPalletFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BlastRotationPalletsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastRotationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BlastRotationCondition>;
  filter?: InputMaybe<BlastRotationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BlastRotationsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastTypeArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastTypeByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BlastTypeCondition>;
  filter?: InputMaybe<BlastTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BlastTypesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BlastCondition>;
  filter?: InputMaybe<BlastFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BlastsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryBuildingAreaArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBuildingAreaByFacilityIdAndLabelArgs = {
  facilityId: Scalars['Int'];
  label: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBuildingAreaByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBuildingAreaComplianceGroupArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBuildingAreaComplianceGroupByBuildingAreaIdAndComplianceTypeArgs =
  {
    buildingAreaId: Scalars['Int'];
    complianceType: ComplianceType;
  };

/** The root query type which gives access points into the data universe. */
export type QueryBuildingAreaComplianceGroupByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBuildingAreaComplianceGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BuildingAreaComplianceGroupCondition>;
  filter?: InputMaybe<BuildingAreaComplianceGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BuildingAreaComplianceGroupsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryBuildingAreaTypeArgs = {
  type: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBuildingAreaTypeByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBuildingAreaTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BuildingAreaTypeCondition>;
  filter?: InputMaybe<BuildingAreaTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BuildingAreaTypesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryBuildingAreasArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BuildingAreaCondition>;
  filter?: InputMaybe<BuildingAreaFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BuildingAreasOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryChartArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryChartByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryChartsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ChartCondition>;
  filter?: InputMaybe<ChartFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ChartsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryComplianceGroupArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryComplianceGroupByLabelArgs = {
  label: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryComplianceGroupByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryComplianceGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ComplianceGroupCondition>;
  filter?: InputMaybe<ComplianceGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ComplianceGroupsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryComplianceRangeArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryComplianceRangeByComplianceGroupIdAndLabelArgs = {
  complianceGroupId: Scalars['Int'];
  label: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryComplianceRangeByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryComplianceRangesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ComplianceRangeCondition>;
  filter?: InputMaybe<ComplianceRangeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ComplianceRangesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryComponentArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryComponentByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryComponentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ComponentCondition>;
  filter?: InputMaybe<ComponentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ComponentsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryCompressorArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryCompressorByFacilityIdAndLabelArgs = {
  facilityId: Scalars['Int'];
  label: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryCompressorByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryCompressorsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompressorCondition>;
  filter?: InputMaybe<CompressorFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompressorsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryControlEventArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryControlEventByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryControlEventLogArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryControlEventLogByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryControlEventStateTransitionByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryControlEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ControlEventCondition>;
  filter?: InputMaybe<ControlEventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ControlEventsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryCustomerArgs = {
  id: Scalars['BigInt'];
};

/** The root query type which gives access points into the data universe. */
export type QueryCustomerByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryCustomerBySourceIdArgs = {
  sourceId: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryCustomersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CustomerCondition>;
  filter?: InputMaybe<CustomerFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CustomersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryDashboardArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDashboardByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDashboardsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DashboardCondition>;
  filter?: InputMaybe<DashboardFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DashboardsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryDataPointArgs = {
  dataSourceName: Scalars['String'];
  name: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDataPointByIdArgs = {
  id: Scalars['BigInt'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDataPointByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDataPointTagArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDataPointTagByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDataPointTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DataPointTagCondition>;
  filter?: InputMaybe<DataPointTagFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DataPointTagsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryDataPointsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DataPointCondition>;
  filter?: InputMaybe<DataPointFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DataPointsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryDataSourceArgs = {
  name: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDataSourceByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDataSourcesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DataSourceCondition>;
  filter?: InputMaybe<DataSourceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DataSourcesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryDependenciesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DependencyCondition>;
  filter?: InputMaybe<DependencyFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DependenciesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryDependencyArgs = {
  id: Scalars['BigInt'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDependencyByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDependencyByPathArgs = {
  path: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDeriveStatementDateArgs = {
  intervalBegin: Scalars['Date'];
  intervalEnd: Scalars['Date'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDoorArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDoorByFacilityIdAndLabelArgs = {
  facilityId: Scalars['Int'];
  label: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDoorByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDoorsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DoorCondition>;
  filter?: InputMaybe<DoorFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DoorsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryEvaporatorArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryEvaporatorByFacilityIdAndLabelArgs = {
  facilityId: Scalars['Int'];
  label: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryEvaporatorByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryEvaporatorsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EvaporatorCondition>;
  filter?: InputMaybe<EvaporatorFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EvaporatorsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryEventArgs = {
  id: Scalars['BigInt'];
};

/** The root query type which gives access points into the data universe. */
export type QueryEventByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryEventHandlerArgs = {
  handler: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryEventHandlerByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryEventHandlerMetadatumArgs = {
  handler: Scalars['String'];
  type: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryEventHandlerMetadatumByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryEventTypeArgs = {
  name: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryEventTypeByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FacilityCondition>;
  filter?: InputMaybe<FacilityFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FacilitiesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityBySlugArgs = {
  slug: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityCommunicationArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityCommunicationByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityCommunicationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FacilityCommunicationCondition>;
  filter?: InputMaybe<FacilityCommunicationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FacilityCommunicationsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityConfigArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityConfigByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityConfigsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FacilityConfigCondition>;
  filter?: InputMaybe<FacilityConfigFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FacilityConfigsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityDataSourceArgs = {
  dataSourceName: Scalars['String'];
  facilityId: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityDataSourceByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityDataSourcesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FacilityDataSourceCondition>;
  filter?: InputMaybe<FacilityDataSourceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FacilityDataSourcesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityGroupArgs = {
  id: Scalars['BigInt'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityGroupByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FacilityGroupCondition>;
  filter?: InputMaybe<FacilityGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FacilityGroupsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityGroupsLinkerArgs = {
  facilityGroupingId: Scalars['BigInt'];
  facilityId: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityGroupsLinkerByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityGroupsLinkersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FacilityGroupsLinkerCondition>;
  filter?: InputMaybe<FacilityGroupsLinkerFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FacilityGroupsLinkersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityTaggedDataPointArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityTaggedDataPointByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityTaggedDataPointsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FacilityTaggedDataPointCondition>;
  filter?: InputMaybe<FacilityTaggedDataPointFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FacilityTaggedDataPointsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryGroupingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<JsonFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** The root query type which gives access points into the data universe. */
export type QueryGroupingsWithFacilitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  facilityFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filter?: InputMaybe<JsonFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** The root query type which gives access points into the data universe. */
export type QueryInboundOutboundLoadArgs = {
  id: Scalars['BigInt'];
};

/** The root query type which gives access points into the data universe. */
export type QueryInboundOutboundLoadByFacilityIdAndDirectionAndSourceIdArgs = {
  direction: WmsLoadDirectionType;
  facilityId: Scalars['Int'];
  sourceId: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryInboundOutboundLoadByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryInboundOutboundLoadsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<InboundOutboundLoadCondition>;
  filter?: InputMaybe<InboundOutboundLoadFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InboundOutboundLoadsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryMachineUserArgs = {
  id: Scalars['BigInt'];
};

/** The root query type which gives access points into the data universe. */
export type QueryMachineUserByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryMachineUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MachineUserCondition>;
  filter?: InputMaybe<MachineUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MachineUsersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryMainServiceArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryMainServiceByFacilityIdAndNameArgs = {
  facilityId: Scalars['Int'];
  name: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryMainServiceByFacilityIdAndUsageDataPointIdAndDemandDataPointIdArgs =
  {
    demandDataPointId: Scalars['Int'];
    facilityId: Scalars['Int'];
    usageDataPointId: Scalars['Int'];
  };

/** The root query type which gives access points into the data universe. */
export type QueryMainServiceByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryMainServicesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MainServiceCondition>;
  filter?: InputMaybe<MainServiceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MainServicesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryMeterChargeArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryMeterChargeByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryMeterChargesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MeterChargeCondition>;
  filter?: InputMaybe<MeterChargeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MeterChargesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryMeterStatementArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryMeterStatementByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryMeterStatementHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MeterStatementHistoryCondition>;
  filter?: InputMaybe<MeterStatementHistoryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MeterStatementHistoriesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryMeterStatementPdfArgs = {
  id: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryMeterStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MeterStatementCondition>;
  filter?: InputMaybe<MeterStatementFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MeterStatementsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryMeterUsageArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryMeterUsageByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryMeterUsagesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MeterUsageCondition>;
  filter?: InputMaybe<MeterUsageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MeterUsagesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryMetricDataArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: InputMaybe<MetricDataAggregationMethod>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  sourceId: Scalars['String'];
  to?: InputMaybe<Scalars['String']>;
  window?: InputMaybe<Scalars['String']>;
};

/** The root query type which gives access points into the data universe. */
export type QueryMetricMetadataArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MetricMetadatumCondition>;
  filter?: InputMaybe<MetricMetadatumFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MetricMetadataOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryMetricMetadatumArgs = {
  label: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryMetricMetadatumByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryNodeArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryPalletArgs = {
  id: Scalars['BigInt'];
};

/** The root query type which gives access points into the data universe. */
export type QueryPalletByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryPalletBySourceIdArgs = {
  sourceId: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryPalletHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PalletHistoryCondition>;
  filter?: InputMaybe<PalletHistoryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PalletHistoriesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryPalletHistoryArgs = {
  id: Scalars['BigInt'];
};

/** The root query type which gives access points into the data universe. */
export type QueryPalletHistoryByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryPalletHistoryBySourceIdArgs = {
  sourceId: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryPalletLocationArgs = {
  id: Scalars['BigInt'];
};

/** The root query type which gives access points into the data universe. */
export type QueryPalletLocationByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryPalletLocationBySourceIdArgs = {
  sourceId: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryPalletLocationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PalletLocationCondition>;
  filter?: InputMaybe<PalletLocationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PalletLocationsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryPalletsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PalletCondition>;
  filter?: InputMaybe<PalletFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PalletsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryPlatformAccessTokensArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PlatformAccessTokenCondition>;
  filter?: InputMaybe<PlatformAccessTokenFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformAccessTokensOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryPricingNodeArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryPricingNodeByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryPricingNodesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PricingNodeCondition>;
  filter?: InputMaybe<PricingNodeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricingNodesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryProductArgs = {
  id: Scalars['BigInt'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProductByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProductBySourceIdArgs = {
  sourceId: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProductsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProductCondition>;
  filter?: InputMaybe<ProductFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryProgramArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProgramByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProgramByProjectTypeIdAndNameArgs = {
  name: Scalars['String'];
  projectTypeId: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProgramEnrollmentArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProgramEnrollmentByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProgramEnrollmentByProgramIdAndNameArgs = {
  name: Scalars['String'];
  programId: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProgramEnrollmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProgramEnrollmentCondition>;
  filter?: InputMaybe<ProgramEnrollmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProgramEnrollmentsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryProgramsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProgramCondition>;
  filter?: InputMaybe<ProgramFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProgramsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectByFacilityIdAndProgramIdArgs = {
  facilityId: Scalars['Int'];
  programId: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectComponentArgs = {
  componentId: Scalars['Int'];
  projectId: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectComponentByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectConfigArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectConfigByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectConfigsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectConfigCondition>;
  filter?: InputMaybe<ProjectConfigFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectConfigsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectEnrollmentArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectEnrollmentByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectEnrollmentByProjectIdAndProgramEnrollmentIdArgs = {
  programEnrollmentId: Scalars['Int'];
  projectId: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectEnrollmentDataPointArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectEnrollmentDataPointByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectEnrollmentDataPointByProjectEnrollmentIdAndDataPointIdArgs =
  {
    dataPointId: Scalars['Int'];
    projectEnrollmentId: Scalars['Int'];
  };

/** The root query type which gives access points into the data universe. */
export type QueryProjectEnrollmentDataPointGroupArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectEnrollmentDataPointGroupByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectEnrollmentDataPointGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectEnrollmentDataPointGroupCondition>;
  filter?: InputMaybe<ProjectEnrollmentDataPointGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectEnrollmentDataPointGroupsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectEnrollmentDataPointsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectEnrollmentDataPointCondition>;
  filter?: InputMaybe<ProjectEnrollmentDataPointFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectEnrollmentDataPointsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectEnrollmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectEnrollmentCondition>;
  filter?: InputMaybe<ProjectEnrollmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectEnrollmentsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectTypeArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectTypeByNameArgs = {
  name: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectTypeByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectTypeCondition>;
  filter?: InputMaybe<ProjectTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectTypesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectWatcherArgs = {
  projectId: Scalars['Int'];
  userId: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectWatcherByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectWatchersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectWatcherCondition>;
  filter?: InputMaybe<ProjectWatcherFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectWatchersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectCondition>;
  filter?: InputMaybe<ProjectFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryReportArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryReportByLabelArgs = {
  label: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryReportByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryReportExecutionArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryReportExecutionByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryReportExecutionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReportExecutionCondition>;
  filter?: InputMaybe<ReportExecutionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReportExecutionsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryReportQueriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReportQueryCondition>;
  filter?: InputMaybe<ReportQueryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReportQueriesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryReportQueryArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryReportQueryByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryReportQueryByReportIdAndLabelArgs = {
  label: Scalars['String'];
  reportId: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryReportsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReportCondition>;
  filter?: InputMaybe<ReportFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReportsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerySavingsEventArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySavingsEventByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySavingsEventByProjectIdAndStartTimeAndEndTimeArgs = {
  endTime: Scalars['Datetime'];
  projectId: Scalars['Int'];
  startTime: Scalars['Datetime'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySavingsEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SavingsEventCondition>;
  filter?: InputMaybe<SavingsEventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SavingsEventsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerySourceDataArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: InputMaybe<MetricDataAggregationMethod>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  sourceId: Scalars['String'];
  to?: InputMaybe<Scalars['String']>;
  window?: InputMaybe<Scalars['String']>;
};

/** The root query type which gives access points into the data universe. */
export type QuerySuggestionArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySuggestionActivityLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SuggestionActivityLogCondition>;
  filter?: InputMaybe<SuggestionActivityLogFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SuggestionActivityLogsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerySuggestionByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySuggestionControlEventArgs = {
  controlEventId: Scalars['Int'];
  suggestionId: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySuggestionControlEventByControlEventIdArgs = {
  controlEventId: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySuggestionControlEventByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySuggestionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SuggestionCondition>;
  filter?: InputMaybe<SuggestionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SuggestionsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryTemperatureSensorArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryTemperatureSensorByFacilityIdAndLabelArgs = {
  facilityId: Scalars['Int'];
  label: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryTemperatureSensorByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryTemperatureSensorsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TemperatureSensorCondition>;
  filter?: InputMaybe<TemperatureSensorFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TemperatureSensorsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryTimezoneArgs = {
  name: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryTimezoneByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryTimezonesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimezoneCondition>;
  filter?: InputMaybe<TimezoneFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimezonesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryTrailerPositionArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryTrailerPositionByFacilityIdAndLabelArgs = {
  facilityId: Scalars['Int'];
  label: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryTrailerPositionByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryTrailerPositionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TrailerPositionCondition>;
  filter?: InputMaybe<TrailerPositionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TrailerPositionsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryUnitDimensionArgs = {
  name: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUnitDimensionByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUnitDimensionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UnitDimensionCondition>;
  filter?: InputMaybe<UnitDimensionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UnitDimensionsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryUnitGroupArgs = {
  name: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUnitGroupByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUnitGroupDimensionArgs = {
  unitDimension: Scalars['String'];
  unitGroup: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUnitGroupDimensionByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUnitGroupDimensionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UnitGroupDimensionCondition>;
  filter?: InputMaybe<UnitGroupDimensionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UnitGroupDimensionsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryUnitGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UnitGroupCondition>;
  filter?: InputMaybe<UnitGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UnitGroupsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryUserArgs = {
  id: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUserByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityAccountArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityAccountByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityAccountStatementArgs = {
  accountStatementId: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityAccountStatementByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityAccountStatementRollupArgs = {
  accountStatementId: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityAccountStatementRollupByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityAccountStatementRollupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UtilityAccountStatementRollupCondition>;
  filter?: InputMaybe<UtilityAccountStatementRollupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UtilityAccountStatementRollupsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityAccountStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UtilityAccountStatementCondition>;
  filter?: InputMaybe<UtilityAccountStatementFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UtilityAccountStatementsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityAccountsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UtilityAccountCondition>;
  filter?: InputMaybe<UtilityAccountFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UtilityAccountsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityMeterArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityMeterByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityMeterStatementArgs = {
  meterStatementId: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityMeterStatementByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityMeterStatementRollupArgs = {
  meterStatementId: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityMeterStatementRollupByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityMeterStatementRollupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UtilityMeterStatementRollupCondition>;
  filter?: InputMaybe<UtilityMeterStatementRollupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UtilityMeterStatementRollupsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityMeterStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UtilityMeterStatementCondition>;
  filter?: InputMaybe<UtilityMeterStatementFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UtilityMeterStatementsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityMetersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UtilityMeterCondition>;
  filter?: InputMaybe<UtilityMeterFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UtilityMetersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityProviderArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityProviderByNameArgs = {
  name: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityProviderByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityProvidersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UtilityProviderCondition>;
  filter?: InputMaybe<UtilityProviderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UtilityProvidersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryVendorUserArgs = {
  id: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryVendorUserByEmailArgs = {
  email: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryVendorUserByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryVendorUserMachineUserArgs = {
  machineUserId: Scalars['BigInt'];
  vendorUserId: Scalars['Int'];
};

/** The root query type which gives access points into the data universe. */
export type QueryVendorUserMachineUserByMachineUserIdArgs = {
  machineUserId: Scalars['BigInt'];
};

/** The root query type which gives access points into the data universe. */
export type QueryVendorUserMachineUserByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryVendorUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<VendorUserCondition>;
  filter?: InputMaybe<VendorUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VendorUsersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryVirtualPointIntervalArgs = {
  childId: Scalars['BigInt'];
  parentId: Scalars['BigInt'];
};

/** The root query type which gives access points into the data universe. */
export type QueryVirtualPointIntervalByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryVirtualPointIntervalsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<VirtualPointIntervalCondition>;
  filter?: InputMaybe<VirtualPointIntervalFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VirtualPointIntervalsOrderBy>>;
};

export type RegenerateAccessTokenInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['BigInt'];
};

export type RegisterProjectUsersInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  forceNotify?: InputMaybe<Scalars['Boolean']>;
  records: Array<BulkProjectUser>;
};

export type RegisterProjectUsersPayload = {
  __typename?: 'RegisterProjectUsersPayload';
  clientMutationId?: Maybe<Scalars['String']>;
};

/** All input for the `removeFavoriteFacility` mutation. */
export type RemoveFavoriteFacilityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  facilityId?: InputMaybe<Scalars['Int']>;
};

/** The output of our `removeFavoriteFacility` mutation. */
export type RemoveFavoriteFacilityPayload = {
  __typename?: 'RemoveFavoriteFacilityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};

/** The output of our `removeFavoriteFacility` mutation. */
export type RemoveFavoriteFacilityPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the `removeMetricMetadataDependency` mutation. */
export type RemoveMetricMetadataDependencyInput = {
  childMetric: Scalars['String'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  parentMetric: Scalars['String'];
};

/** The output of our `removeMetricMetadataDependency` mutation. */
export type RemoveMetricMetadataDependencyPayload = {
  __typename?: 'RemoveMetricMetadataDependencyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  metricMetadata?: Maybe<Array<MetricMetadatum>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type RemoveProjectControllerInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['Int'];
  userId: Scalars['String'];
};

export type RemoveProjectControllerPayload = {
  __typename?: 'RemoveProjectControllerPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  project: Project;
  user: User;
};

export type RemoveReportManagerInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  reportId: Scalars['Int'];
  userId: Scalars['String'];
};

export type RemoveReportManagerPayload = {
  __typename?: 'RemoveReportManagerPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  report: Report;
  user: User;
};

/** All input for the `reparentMeterStatement` mutation. */
export type ReparentMeterStatementInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  destAccountStatementId?: InputMaybe<Scalars['Int']>;
  destUtilityMeterId?: InputMaybe<Scalars['Int']>;
  meterStatementId?: InputMaybe<Scalars['Int']>;
};

/** The output of our `reparentMeterStatement` mutation. */
export type ReparentMeterStatementPayload = {
  __typename?: 'ReparentMeterStatementPayload';
  /** Reads a single `AccountStatement` that is related to this `MeterStatement`. */
  accountStatement?: Maybe<AccountStatement>;
  /** Reads a single `AccountStatementPdf` that is related to this `MeterStatement`. */
  accountStatementPdf?: Maybe<AccountStatementPdf>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  meterStatement?: Maybe<MeterStatement>;
  /** An edge for our `MeterStatement`. May be used by Relay 1. */
  meterStatementEdge?: Maybe<MeterStatementsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UtilityMeter` that is related to this `MeterStatement`. */
  utilityMeter?: Maybe<UtilityMeter>;
};

/** The output of our `reparentMeterStatement` mutation. */
export type ReparentMeterStatementPayloadMeterStatementEdgeArgs = {
  orderBy?: InputMaybe<Array<MeterStatementsOrderBy>>;
};

/** Parent table for generic reports. This gives us a way to store and generate arbitrary reports for customers, both internal and external. */
export type Report = Node & {
  __typename?: 'Report';
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Default parameter values for a report. */
  defaultParams?: Maybe<Scalars['JSON']>;
  description: Scalars['String'];
  /** Returns the estimated execution time of the report, in seconds. */
  estimatedExecutionTime?: Maybe<Scalars['BigFloat']>;
  /** The description of the report. */
  id: Scalars['Int'];
  /** The json schema that describes the parameters for this report */
  jsonSchema: Scalars['JSON'];
  /** The human readable name of the report. */
  label: Scalars['String'];
  managers: UsersConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Available permissions for the Report. */
  permissions?: Maybe<ReportPermissions>;
  /** Reads and enables pagination through a set of `ReportExecution`. */
  reportExecutions: ReportExecutionsConnection;
  /** Reads and enables pagination through a set of `ReportQuery`. */
  reportQueries: ReportQueriesConnection;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

/** Parent table for generic reports. This gives us a way to store and generate arbitrary reports for customers, both internal and external. */
export type ReportManagersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** Parent table for generic reports. This gives us a way to store and generate arbitrary reports for customers, both internal and external. */
export type ReportReportExecutionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReportExecutionCondition>;
  filter?: InputMaybe<ReportExecutionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReportExecutionsOrderBy>>;
};

/** Parent table for generic reports. This gives us a way to store and generate arbitrary reports for customers, both internal and external. */
export type ReportReportQueriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReportQueryCondition>;
  filter?: InputMaybe<ReportQueryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReportQueriesOrderBy>>;
};

/** A condition to be used against `Report` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ReportCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `defaultParams` field. */
  defaultParams?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `defaultParamsConfig` field. */
  defaultParamsConfig?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `jsonSchema` field. */
  jsonSchema?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Tracks status of all report executions. Stores reference to the resulting file when an execution is finished, as well as any errors encountered if applicable. */
export type ReportExecution = Node & {
  __typename?: 'ReportExecution';
  actor?: Maybe<Actor>;
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Any errors encountered during the report execution. */
  errors?: Maybe<Scalars['JSON']>;
  /** The file path of the report execution result. */
  filePath?: Maybe<Scalars['String']>;
  /** The id of the report execution. */
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Available permissions for the ReportExecution. */
  permissions?: Maybe<ReportExecutionPermissions>;
  /** Reads a single `Report` that is related to this `ReportExecution`. */
  report?: Maybe<Report>;
  /** The id of the associated report. */
  reportId?: Maybe<Scalars['Int']>;
  reportUri?: Maybe<Scalars['String']>;
  /** The status of the report execution. */
  status: Scalars['String'];
  updatedAt?: Maybe<Scalars['Datetime']>;
};

/**
 * A condition to be used against `ReportExecution` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ReportExecutionCondition = {
  /** Checks for equality with the object’s `actor` field. */
  actor?: InputMaybe<ActorInput>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `errors` field. */
  errors?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `filePath` field. */
  filePath?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `reportId` field. */
  reportId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `ReportExecution` object types. All fields are combined with a logical ‘and.’ */
export type ReportExecutionFilter = {
  /** Filter by the object’s `actor` field. */
  actor?: InputMaybe<ActorFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ReportExecutionFilter>>;
  /** Filter by the permission can_write */
  canWrite?: InputMaybe<PermissionBooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `errors` field. */
  errors?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `filePath` field. */
  filePath?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ReportExecutionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ReportExecutionFilter>>;
  /** Filter by the object’s `reportId` field. */
  reportId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ReportExecution` */
export type ReportExecutionInput = {
  /** Any errors encountered during the report execution. */
  errors?: InputMaybe<Scalars['JSON']>;
  /** The file path of the report execution result. */
  filePath?: InputMaybe<Scalars['String']>;
  /** The id of the associated report. */
  reportId?: InputMaybe<Scalars['Int']>;
  /** The status of the report execution. */
  status: Scalars['String'];
};

/** Represents an update to a `ReportExecution`. Fields that are set will be updated. */
export type ReportExecutionPatch = {
  /** Any errors encountered during the report execution. */
  errors?: InputMaybe<Scalars['JSON']>;
  /** The file path of the report execution result. */
  filePath?: InputMaybe<Scalars['String']>;
  /** The id of the associated report. */
  reportId?: InputMaybe<Scalars['Int']>;
  /** The status of the report execution. */
  status?: InputMaybe<Scalars['String']>;
};

/** Permissive capabilities on a ReportExecution. */
export type ReportExecutionPermissions = {
  __typename?: 'ReportExecutionPermissions';
  /** Whether a user can write to the report execution. */
  canWrite: Scalars['Boolean'];
};

/** A connection to a list of `ReportExecution` values. */
export type ReportExecutionsConnection = {
  __typename?: 'ReportExecutionsConnection';
  /** A list of edges which contains the `ReportExecution` and cursor to aid in pagination. */
  edges: Array<ReportExecutionsEdge>;
  /** A list of `ReportExecution` objects. */
  nodes: Array<ReportExecution>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ReportExecution` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ReportExecution` edge in the connection. */
export type ReportExecutionsEdge = {
  __typename?: 'ReportExecutionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ReportExecution` at the end of the edge. */
  node: ReportExecution;
};

/** Methods to use when ordering `ReportExecution`. */
export enum ReportExecutionsOrderBy {
  ACTOR_ASC = 'ACTOR_ASC',
  ACTOR_DESC = 'ACTOR_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ERRORS_ASC = 'ERRORS_ASC',
  ERRORS_DESC = 'ERRORS_DESC',
  FILE_PATH_ASC = 'FILE_PATH_ASC',
  FILE_PATH_DESC = 'FILE_PATH_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  REPORT_ID_ASC = 'REPORT_ID_ASC',
  REPORT_ID_DESC = 'REPORT_ID_DESC',
  STATUS_ASC = 'STATUS_ASC',
  STATUS_DESC = 'STATUS_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A filter to be used against `Report` object types. All fields are combined with a logical ‘and.’ */
export type ReportFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ReportFilter>>;
  /** Filter by the permission can_execute */
  canExecute?: InputMaybe<PermissionBooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `defaultParams` field. */
  defaultParams?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `defaultParamsConfig` field. */
  defaultParamsConfig?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `estimatedExecutionTime` field. */
  estimatedExecutionTime?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `jsonSchema` field. */
  jsonSchema?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ReportFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ReportFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Permissive capabilities on a Report. */
export type ReportPermissions = {
  __typename?: 'ReportPermissions';
  /** Whether a user can run the report */
  canExecute: Scalars['Boolean'];
};

/** A connection to a list of `ReportQuery` values. */
export type ReportQueriesConnection = {
  __typename?: 'ReportQueriesConnection';
  /** A list of edges which contains the `ReportQuery` and cursor to aid in pagination. */
  edges: Array<ReportQueriesEdge>;
  /** A list of `ReportQuery` objects. */
  nodes: Array<ReportQuery>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ReportQuery` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ReportQuery` edge in the connection. */
export type ReportQueriesEdge = {
  __typename?: 'ReportQueriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ReportQuery` at the end of the edge. */
  node: ReportQuery;
};

/** Methods to use when ordering `ReportQuery`. */
export enum ReportQueriesOrderBy {
  CHUNK_DURATION_ASC = 'CHUNK_DURATION_ASC',
  CHUNK_DURATION_DESC = 'CHUNK_DURATION_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DB_TYPE_ASC = 'DB_TYPE_ASC',
  DB_TYPE_DESC = 'DB_TYPE_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  EXPANDER_ASC = 'EXPANDER_ASC',
  EXPANDER_DESC = 'EXPANDER_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  QUERY_ASC = 'QUERY_ASC',
  QUERY_DESC = 'QUERY_DESC',
  REPORT_ID_ASC = 'REPORT_ID_ASC',
  REPORT_ID_DESC = 'REPORT_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

export type ReportQuery = Node & {
  __typename?: 'ReportQuery';
  /** Used to split the query into natural time-boundary chunks for simpler post-processing. */
  chunkDuration?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  /** The database the report query is associated with. */
  dbType: Scalars['String'];
  /** The description of the report query. */
  description?: Maybe<Scalars['String']>;
  /** Used to produced one or more parameterized versions of the final query. */
  expander?: Maybe<Scalars['String']>;
  /** The id of the report query. */
  id: Scalars['Int'];
  /** The label of the report query. */
  label: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The query to run. */
  query: Scalars['String'];
  /** Reads a single `Report` that is related to this `ReportQuery`. */
  report?: Maybe<Report>;
  /** The id of the associated report. */
  reportId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

/**
 * A condition to be used against `ReportQuery` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ReportQueryCondition = {
  /** Checks for equality with the object’s `chunkDuration` field. */
  chunkDuration?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `dbType` field. */
  dbType?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `expander` field. */
  expander?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `query` field. */
  query?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `reportId` field. */
  reportId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `ReportQuery` object types. All fields are combined with a logical ‘and.’ */
export type ReportQueryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ReportQueryFilter>>;
  /** Filter by the object’s `chunkDuration` field. */
  chunkDuration?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dbType` field. */
  dbType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `expander` field. */
  expander?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ReportQueryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ReportQueryFilter>>;
  /** Filter by the object’s `query` field. */
  query?: InputMaybe<StringFilter>;
  /** Filter by the object’s `reportId` field. */
  reportId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ReportQuery` */
export type ReportQueryInput = {
  /** Used to split the query into natural time-boundary chunks for simpler post-processing. */
  chunkDuration?: InputMaybe<Scalars['String']>;
  /** The database the report query is associated with. */
  dbType: Scalars['String'];
  /** The description of the report query. */
  description?: InputMaybe<Scalars['String']>;
  /** Used to produced one or more parameterized versions of the final query. */
  expander?: InputMaybe<Scalars['String']>;
  /** The label of the report query. */
  label: Scalars['String'];
  /** The query to run. */
  query: Scalars['String'];
  /** The id of the associated report. */
  reportId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `Report` values. */
export type ReportsConnection = {
  __typename?: 'ReportsConnection';
  /** A list of edges which contains the `Report` and cursor to aid in pagination. */
  edges: Array<ReportsEdge>;
  /** A list of `Report` objects. */
  nodes: Array<Report>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Report` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Report` edge in the connection. */
export type ReportsEdge = {
  __typename?: 'ReportsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Report` at the end of the edge. */
  node: Report;
};

/** Methods to use when ordering `Report`. */
export enum ReportsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DEFAULT_PARAMS_ASC = 'DEFAULT_PARAMS_ASC',
  DEFAULT_PARAMS_CONFIG_ASC = 'DEFAULT_PARAMS_CONFIG_ASC',
  DEFAULT_PARAMS_CONFIG_DESC = 'DEFAULT_PARAMS_CONFIG_DESC',
  DEFAULT_PARAMS_DESC = 'DEFAULT_PARAMS_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  JSON_SCHEMA_ASC = 'JSON_SCHEMA_ASC',
  JSON_SCHEMA_DESC = 'JSON_SCHEMA_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

export type RevokeAccessTokenInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['BigInt'];
};

/** This represents a period in time where an event happened that could realize savings, typically a load shed event. */
export type SavingsEvent = Node & {
  __typename?: 'SavingsEvent';
  /** The time the savings_event was created. */
  createdAt: Scalars['Datetime'];
  /** The current Project Enrollment associated with the savings event. */
  currentEnrollment?: Maybe<ProjectEnrollment>;
  /** The time that the savings_event ended */
  endTime: Scalars['Datetime'];
  id: Scalars['Int'];
  metadata?: Maybe<Scalars['JSON']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Project` that is related to this `SavingsEvent`. */
  project?: Maybe<Project>;
  /** This maps the savings_event to a project */
  projectId: Scalars['Int'];
  /** Aggregates a metric by label for the specified filter expression. */
  savingsEventData?: Maybe<MetricDataConnection>;
  /** The time that the savings_event started */
  startTime: Scalars['Datetime'];
  /** Returns the associated suggestion for the savings event. */
  suggestion?: Maybe<Suggestion>;
  /** The time the savings_event was updated. */
  updatedAt: Scalars['Datetime'];
};

/** This represents a period in time where an event happened that could realize savings, typically a load shed event. */
export type SavingsEventSavingsEventDataArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: InputMaybe<MetricDataAggregationMethod>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['String']>;
  inheritTimezone?: InputMaybe<Scalars['Boolean']>;
  label: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/**
 * A condition to be used against `SavingsEvent` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SavingsEventCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `endTime` field. */
  endTime?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `startTime` field. */
  startTime?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `SavingsEvent` object types. All fields are combined with a logical ‘and.’ */
export type SavingsEventFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SavingsEventFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `endTime` field. */
  endTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SavingsEventFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SavingsEventFilter>>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `startTime` field. */
  startTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `SavingsEvent` */
export type SavingsEventInput = {
  /** The time that the savings_event ended */
  endTime: Scalars['Datetime'];
  metadata?: InputMaybe<Scalars['JSON']>;
  /** This maps the savings_event to a project */
  projectId: Scalars['Int'];
  /** The time that the savings_event started */
  startTime: Scalars['Datetime'];
};

/** Represents an update to a `SavingsEvent`. Fields that are set will be updated. */
export type SavingsEventPatch = {
  /** The time that the savings_event ended */
  endTime?: InputMaybe<Scalars['Datetime']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  /** This maps the savings_event to a project */
  projectId?: InputMaybe<Scalars['Int']>;
  /** The time that the savings_event started */
  startTime?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `SavingsEvent` values. */
export type SavingsEventsConnection = {
  __typename?: 'SavingsEventsConnection';
  /** A list of edges which contains the `SavingsEvent` and cursor to aid in pagination. */
  edges: Array<SavingsEventsEdge>;
  /** A list of `SavingsEvent` objects. */
  nodes: Array<SavingsEvent>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Aggregates a metric by label for the specified filter expression. */
  savingsEventData?: Maybe<MetricDataConnection>;
  /** The count of *all* `SavingsEvent` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A connection to a list of `SavingsEvent` values. */
export type SavingsEventsConnectionSavingsEventDataArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
  unitGroup?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A `SavingsEvent` edge in the connection. */
export type SavingsEventsEdge = {
  __typename?: 'SavingsEventsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SavingsEvent` at the end of the edge. */
  node: SavingsEvent;
};

/** Methods to use when ordering `SavingsEvent`. */
export enum SavingsEventsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  END_TIME_ASC = 'END_TIME_ASC',
  END_TIME_DESC = 'END_TIME_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROJECT_ID_ASC = 'PROJECT_ID_ASC',
  PROJECT_ID_DESC = 'PROJECT_ID_DESC',
  START_TIME_ASC = 'START_TIME_ASC',
  START_TIME_DESC = 'START_TIME_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** All input for the `setFacilityConfig` mutation. */
export type SetFacilityConfigInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  facilityId?: InputMaybe<Scalars['Int']>;
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['JSON']>;
};

/** The output of our `setFacilityConfig` mutation. */
export type SetFacilityConfigPayload = {
  __typename?: 'SetFacilityConfigPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Facility` that is related to this `FacilityConfig`. */
  facility?: Maybe<Facility>;
  facilityConfig?: Maybe<FacilityConfig>;
  /** An edge for our `FacilityConfig`. May be used by Relay 1. */
  facilityConfigEdge?: Maybe<FacilityConfigsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our `setFacilityConfig` mutation. */
export type SetFacilityConfigPayloadFacilityConfigEdgeArgs = {
  orderBy?: InputMaybe<Array<FacilityConfigsOrderBy>>;
};

export type SetMachineUserCapabilityInput = {
  capabilities: Array<PlatformCapabilityAccessDefinition>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  machineUserId: Scalars['Int'];
};

export type SetMachineUserCapabilityPayload = {
  __typename?: 'SetMachineUserCapabilityPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  machineUser?: Maybe<MachineUser>;
};

/** All input for the `setProjectConfig` mutation. */
export type SetProjectConfigInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['JSON']>;
};

/** The output of our `setProjectConfig` mutation. */
export type SetProjectConfigPayload = {
  __typename?: 'SetProjectConfigPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Project` that is related to this `ProjectConfig`. */
  project?: Maybe<Project>;
  projectConfig?: Maybe<ProjectConfig>;
  /** An edge for our `ProjectConfig`. May be used by Relay 1. */
  projectConfigEdge?: Maybe<ProjectConfigsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our `setProjectConfig` mutation. */
export type SetProjectConfigPayloadProjectConfigEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectConfigsOrderBy>>;
};

export type SourceLabel = Node & {
  __typename?: 'SourceLabel';
  /** IoT device field name */
  label: Scalars['String'];
  nodeId: Scalars['ID'];
  /** IoT device name */
  sourceId: Scalars['String'];
};

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export type StringFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['String']>;
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: InputMaybe<Scalars['String']>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['String']>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['String']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['String']>;
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: InputMaybe<Scalars['String']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['String']>;
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: InputMaybe<Scalars['String']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['String']>;
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['String']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['String']>>;
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: InputMaybe<Array<Scalars['String']>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['String']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['String']>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['String']>;
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: InputMaybe<Scalars['String']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['String']>;
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['String']>;
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars['String']>;
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars['String']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['String']>;
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: InputMaybe<Scalars['String']>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['String']>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['String']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['String']>;
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: InputMaybe<Scalars['String']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['String']>>;
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: InputMaybe<Array<Scalars['String']>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['String']>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['String']>;
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars['String']>;
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars['String']>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['String']>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['String']>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['String']>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against String List fields. All fields are combined with a logical ‘and.’ */
export type StringListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Scalars['String']>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<Scalars['String']>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars['String']>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<Scalars['String']>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<Scalars['String']>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Scalars['String']>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** A suggestion for the associated optimization project. */
export type Suggestion = Node & {
  __typename?: 'Suggestion';
  /** Returns the timestamp at which an acknowledgement cannot occur past. */
  acknowledgementCutoff?: Maybe<Scalars['Datetime']>;
  /** The current acknowledgement status on the suggestion. */
  acknowledgementStatus: Acknowledgement;
  availableAcknowledgements: Array<Acknowledgement>;
  /** Reads and enables pagination through a set of `ControlEvent`. */
  controlEvents: ControlEventsConnection;
  /** Returns the control type of a suggestion. */
  controlType?: Maybe<ControlType>;
  /** The time the suggestion was created. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** The current Project Enrollment associated with the suggestion. */
  currentEnrollment?: Maybe<ProjectEnrollment>;
  /** The description of suggestions. */
  description?: Maybe<Scalars['String']>;
  /** The effectiveness of the taken action against the set target for the project fields */
  effectiveness?: Maybe<Scalars['Float']>;
  /** The date in which the suggestion event ends. */
  endTime?: Maybe<Scalars['Datetime']>;
  /** The `Facility` associated with the suggestion. */
  facility?: Maybe<Facility>;
  /** Facility Id */
  facilityId?: Maybe<Scalars['Int']>;
  /** Facility Name */
  facilityName?: Maybe<Scalars['String']>;
  /** The identifier of the suggestions. */
  id: Scalars['Int'];
  isAcknowledged?: Maybe<Scalars['Boolean']>;
  isRejected?: Maybe<Scalars['Boolean']>;
  /** Is current user is watching the suggestion’s project. */
  isWatching?: Maybe<Scalars['Boolean']>;
  isWithdrawn?: Maybe<Scalars['Boolean']>;
  metadata: Scalars['JSON'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Available permissions for the Suggestion. */
  permissions?: Maybe<SuggestionPermissions>;
  /** The program id for the associated project. */
  programId?: Maybe<Scalars['Int']>;
  /** Reads a single `Project` that is related to this `Suggestion`. */
  project?: Maybe<Project>;
  /** The identifier of the project. */
  projectId: Scalars['Int'];
  /** Project Name. */
  projectName?: Maybe<Scalars['String']>;
  /** Project Type */
  projectType?: Maybe<Scalars['String']>;
  /** Returns the associated savings event for the suggestion. */
  savingsEvent?: Maybe<SavingsEvent>;
  /** The time in which the suggestion event begins. */
  startTime: Scalars['Datetime'];
  /** The current state of the suggestion. */
  state?: Maybe<SuggestionState>;
  /** Reads and enables pagination through a set of `SuggestionActivityLog`. */
  suggestionActivityLogs: SuggestionActivityLogsConnection;
  /** The time the suggestion was updated. */
  updatedAt?: Maybe<Scalars['Datetime']>;
  /** The timestamp when the suggestion was withdrawn. */
  withdrawnAt?: Maybe<Scalars['Datetime']>;
};

/** A suggestion for the associated optimization project. */
export type SuggestionControlEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<ControlEventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** A suggestion for the associated optimization project. */
export type SuggestionSuggestionActivityLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SuggestionActivityLogCondition>;
  filter?: InputMaybe<SuggestionActivityLogFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SuggestionActivityLogsOrderBy>>;
};

export type SuggestionActivityLog = {
  __typename?: 'SuggestionActivityLog';
  /** The identifier of the actor who triggered the activity. */
  actor?: Maybe<Actor>;
  /** The time the suggestion activity event occurred. */
  createdAt: Scalars['Datetime'];
  /** Metadata about the activity. */
  metadata: Scalars['JSON'];
  /** Reads a single `Suggestion` that is related to this `SuggestionActivityLog`. */
  suggestion?: Maybe<Suggestion>;
  /** The identifier of the suggestion. */
  suggestionId: Scalars['Int'];
  /** The type of activity. */
  type: SuggestionActivityType;
};

/**
 * A condition to be used against `SuggestionActivityLog` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type SuggestionActivityLogCondition = {
  /** Checks for equality with the object’s `actor` field. */
  actor?: InputMaybe<ActorInput>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `suggestionId` field. */
  suggestionId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<SuggestionActivityType>;
};

/** A filter to be used against `SuggestionActivityLog` object types. All fields are combined with a logical ‘and.’ */
export type SuggestionActivityLogFilter = {
  /** Filter by the object’s `actor` field. */
  actor?: InputMaybe<ActorFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SuggestionActivityLogFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SuggestionActivityLogFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SuggestionActivityLogFilter>>;
  /** Filter by the object’s `suggestionId` field. */
  suggestionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<SuggestionActivityTypeFilter>;
};

/** An input for mutations affecting `SuggestionActivityLog` */
export type SuggestionActivityLogInput = {
  /** The identifier of the actor who triggered the activity. */
  actor?: InputMaybe<ActorInput>;
  /** The time the suggestion activity event occurred. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Metadata about the activity. */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Mutates a `Suggestion` as part of the payload */
  suggestion?: InputMaybe<SuggestionInput>;
  /** The identifier of the suggestion. */
  suggestionId?: InputMaybe<Scalars['Int']>;
  /** The type of activity. */
  type: SuggestionActivityType;
};

/** A connection to a list of `SuggestionActivityLog` values. */
export type SuggestionActivityLogsConnection = {
  __typename?: 'SuggestionActivityLogsConnection';
  /** A list of edges which contains the `SuggestionActivityLog` and cursor to aid in pagination. */
  edges: Array<SuggestionActivityLogsEdge>;
  /** A list of `SuggestionActivityLog` objects. */
  nodes: Array<SuggestionActivityLog>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SuggestionActivityLog` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SuggestionActivityLog` edge in the connection. */
export type SuggestionActivityLogsEdge = {
  __typename?: 'SuggestionActivityLogsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SuggestionActivityLog` at the end of the edge. */
  node: SuggestionActivityLog;
};

/** Methods to use when ordering `SuggestionActivityLog`. */
export enum SuggestionActivityLogsOrderBy {
  ACTOR_ASC = 'ACTOR_ASC',
  ACTOR_DESC = 'ACTOR_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  NATURAL = 'NATURAL',
  SUGGESTION_ID_ASC = 'SUGGESTION_ID_ASC',
  SUGGESTION_ID_DESC = 'SUGGESTION_ID_DESC',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC'
}

export enum SuggestionActivityType {
  ACKNOWLEDGED = 'ACKNOWLEDGED',
  REJECTED = 'REJECTED',
  UPDATED = 'UPDATED',
  WITHDRAWN = 'WITHDRAWN'
}

/** A filter to be used against SuggestionActivityType fields. All fields are combined with a logical ‘and.’ */
export type SuggestionActivityTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<SuggestionActivityType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<SuggestionActivityType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<SuggestionActivityType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<SuggestionActivityType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<SuggestionActivityType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<SuggestionActivityType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<SuggestionActivityType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<SuggestionActivityType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<SuggestionActivityType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<SuggestionActivityType>>;
};

/**
 * A condition to be used against `Suggestion` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type SuggestionCondition = {
  /** Checks for equality with the object’s `acknowledgementStatus` field. */
  acknowledgementStatus?: InputMaybe<Acknowledgement>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `effectiveness` field. */
  effectiveness?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `endTime` field. */
  endTime?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `startTime` field. */
  startTime?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `withdrawnAt` field. */
  withdrawnAt?: InputMaybe<Scalars['Datetime']>;
};

export type SuggestionControlEvent = Node & {
  __typename?: 'SuggestionControlEvent';
  /** Reads a single `ControlEvent` that is related to this `SuggestionControlEvent`. */
  controlEvent?: Maybe<ControlEvent>;
  controlEventId: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Suggestion` that is related to this `SuggestionControlEvent`. */
  suggestion?: Maybe<Suggestion>;
  suggestionId: Scalars['Int'];
};

/** An input for mutations affecting `SuggestionControlEvent` */
export type SuggestionControlEventInput = {
  /** Mutates a `ControlEvent` as part of the payload */
  controlEvent?: InputMaybe<ControlEventInput>;
  controlEventId?: InputMaybe<Scalars['Int']>;
  suggestionId: Scalars['Int'];
};

/** Represents an update to a `SuggestionControlEvent`. Fields that are set will be updated. */
export type SuggestionControlEventPatch = {
  controlEventId?: InputMaybe<Scalars['Int']>;
  suggestionId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `Suggestion` object types. All fields are combined with a logical ‘and.’ */
export type SuggestionFilter = {
  /** Filter by the object’s `acknowledgementCutoff` field. */
  acknowledgementCutoff?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `acknowledgementStatus` field. */
  acknowledgementStatus?: InputMaybe<AcknowledgementFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SuggestionFilter>>;
  /** Filter by the permission can_control */
  canControl?: InputMaybe<PermissionBooleanFilter>;
  /** Filter by the object’s `controlType` field. */
  controlType?: InputMaybe<ControlTypeFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `effectiveness` field. */
  effectiveness?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `endTime` field. */
  endTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `facilityName` field. */
  facilityName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isAcknowledged` field. */
  isAcknowledged?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isRejected` field. */
  isRejected?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isWatching` field. */
  isWatching?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isWithdrawn` field. */
  isWithdrawn?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SuggestionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SuggestionFilter>>;
  /** Filter by the object’s `programId` field. */
  programId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `projectName` field. */
  projectName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `projectType` field. */
  projectType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `startTime` field. */
  startTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<SuggestionStateFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `withdrawnAt` field. */
  withdrawnAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Suggestion` */
export type SuggestionInput = {
  /** The description of suggestions. */
  description?: InputMaybe<Scalars['String']>;
  /** The effectiveness of the taken action against the set target for the project fields */
  effectiveness?: InputMaybe<Scalars['Float']>;
  /** The date in which the suggestion event ends. */
  endTime?: InputMaybe<Scalars['Datetime']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  /** The identifier of the project. */
  projectId: Scalars['Int'];
  /** The time in which the suggestion event begins. */
  startTime: Scalars['Datetime'];
};

/** Represents an update to a `Suggestion`. Fields that are set will be updated. */
export type SuggestionPatch = {
  /** The description of suggestions. */
  description?: InputMaybe<Scalars['String']>;
  /** The effectiveness of the taken action against the set target for the project fields */
  effectiveness?: InputMaybe<Scalars['Float']>;
  /** The date in which the suggestion event ends. */
  endTime?: InputMaybe<Scalars['Datetime']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  /** The identifier of the project. */
  projectId?: InputMaybe<Scalars['Int']>;
  /** The time in which the suggestion event begins. */
  startTime?: InputMaybe<Scalars['Datetime']>;
};

/** Permissive capabilities on a Suggestion. */
export type SuggestionPermissions = {
  __typename?: 'SuggestionPermissions';
  /** Whether a user can approve and/or transition the suggestion. */
  canControl: Scalars['Boolean'];
};

export enum SuggestionState {
  ACTIVE = 'ACTIVE',
  PAST = 'PAST',
  UPCOMING = 'UPCOMING',
  WITHDRAWN = 'WITHDRAWN'
}

/** A filter to be used against SuggestionState fields. All fields are combined with a logical ‘and.’ */
export type SuggestionStateFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<SuggestionState>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<SuggestionState>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<SuggestionState>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<SuggestionState>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<SuggestionState>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<SuggestionState>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<SuggestionState>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<SuggestionState>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<SuggestionState>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<SuggestionState>>;
};

/** A connection to a list of `Suggestion` values. */
export type SuggestionsConnection = {
  __typename?: 'SuggestionsConnection';
  /** A list of edges which contains the `Suggestion` and cursor to aid in pagination. */
  edges: Array<SuggestionsEdge>;
  /** A list of `Suggestion` objects. */
  nodes: Array<Suggestion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Suggestion` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Suggestion` edge in the connection. */
export type SuggestionsEdge = {
  __typename?: 'SuggestionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Suggestion` at the end of the edge. */
  node: Suggestion;
};

/** Methods to use when ordering `Suggestion`. */
export enum SuggestionsOrderBy {
  ACKNOWLEDGEMENT_CUTOFF_ASC = 'ACKNOWLEDGEMENT_CUTOFF_ASC',
  ACKNOWLEDGEMENT_CUTOFF_DESC = 'ACKNOWLEDGEMENT_CUTOFF_DESC',
  ACKNOWLEDGEMENT_STATUS_ASC = 'ACKNOWLEDGEMENT_STATUS_ASC',
  ACKNOWLEDGEMENT_STATUS_DESC = 'ACKNOWLEDGEMENT_STATUS_DESC',
  CONTROL_TYPE_ASC = 'CONTROL_TYPE_ASC',
  CONTROL_TYPE_DESC = 'CONTROL_TYPE_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  EFFECTIVENESS_ASC = 'EFFECTIVENESS_ASC',
  EFFECTIVENESS_DESC = 'EFFECTIVENESS_DESC',
  END_TIME_ASC = 'END_TIME_ASC',
  END_TIME_DESC = 'END_TIME_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  FACILITY_NAME_ASC = 'FACILITY_NAME_ASC',
  FACILITY_NAME_DESC = 'FACILITY_NAME_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IS_WATCHING_ASC = 'IS_WATCHING_ASC',
  IS_WATCHING_DESC = 'IS_WATCHING_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROJECT_ID_ASC = 'PROJECT_ID_ASC',
  PROJECT_ID_DESC = 'PROJECT_ID_DESC',
  PROJECT_NAME_ASC = 'PROJECT_NAME_ASC',
  PROJECT_NAME_DESC = 'PROJECT_NAME_DESC',
  PROJECT_TYPE_ASC = 'PROJECT_TYPE_ASC',
  PROJECT_TYPE_DESC = 'PROJECT_TYPE_DESC',
  RELEVANCY_ASC = 'RELEVANCY_ASC',
  RELEVANCY_DESC = 'RELEVANCY_DESC',
  START_TIME_ASC = 'START_TIME_ASC',
  START_TIME_DESC = 'START_TIME_DESC',
  STATE_ASC = 'STATE_ASC',
  STATE_DESC = 'STATE_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  WITHDRAWN_AT_ASC = 'WITHDRAWN_AT_ASC',
  WITHDRAWN_AT_DESC = 'WITHDRAWN_AT_DESC'
}

/** This represents a wireless temperature sensor that exists in a facility */
export type TemperatureSensor = Node & {
  __typename?: 'TemperatureSensor';
  /** Reads a single `DataPoint` that is related to this `TemperatureSensor`. */
  battery?: Maybe<DataPoint>;
  /** The battery level */
  batteryId?: Maybe<Scalars['BigInt']>;
  /** The time at which the Temperature Sensor was created */
  createdAt: Scalars['Datetime'];
  /** Reads a single `Facility` that is related to this `TemperatureSensor`. */
  facility?: Maybe<Facility>;
  /** The facility where the temperature sensor is installed */
  facilityId?: Maybe<Scalars['Int']>;
  /** The GIS geometry specifies the physical location of where the sensor is installed */
  geometry?: Maybe<GeometryInterface>;
  /** The id of the temperature sensor */
  id: Scalars['Int'];
  /** The Human-readable label for the sensor */
  label: Scalars['String'];
  /** The metadata for the sensor */
  metadata?: Maybe<Scalars['JSON']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** A short link used for sensor provisioning */
  shortLink?: Maybe<Scalars['String']>;
  /** Reads a single `DataPoint` that is related to this `TemperatureSensor`. */
  signal?: Maybe<DataPoint>;
  /** The signal strength */
  signalId?: Maybe<Scalars['BigInt']>;
  /** Reads a single `DataPoint` that is related to this `TemperatureSensor`. */
  temperature?: Maybe<DataPoint>;
  /** The recorded temperature */
  temperatureId?: Maybe<Scalars['BigInt']>;
  /** The time at which the Temperature Sensor was updated */
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `TemperatureSensor` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type TemperatureSensorCondition = {
  /** Checks for equality with the object’s `batteryId` field. */
  batteryId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `geometry` field. */
  geometry?: InputMaybe<Scalars['GeoJSON']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `shortLink` field. */
  shortLink?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `signalId` field. */
  signalId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `temperatureId` field. */
  temperatureId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `TemperatureSensor` object types. All fields are combined with a logical ‘and.’ */
export type TemperatureSensorFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TemperatureSensorFilter>>;
  /** Filter by the object’s `batteryId` field. */
  batteryId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TemperatureSensorFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TemperatureSensorFilter>>;
  /** Filter by the object’s `shortLink` field. */
  shortLink?: InputMaybe<StringFilter>;
  /** Filter by the object’s `signalId` field. */
  signalId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `temperatureId` field. */
  temperatureId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `TemperatureSensor` */
export type TemperatureSensorInput = {
  /** The battery level */
  batteryId?: InputMaybe<Scalars['BigInt']>;
  /** Mutates a `DataPoint` as part of the payload */
  dataPoint?: InputMaybe<DataPointInput>;
  /** The facility where the temperature sensor is installed */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** The GIS geometry specifies the physical location of where the sensor is installed */
  geometry?: InputMaybe<Scalars['GeoJSON']>;
  /** The Human-readable label for the sensor */
  label: Scalars['String'];
  /** The metadata for the sensor */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** A short link used for sensor provisioning */
  shortLink?: InputMaybe<Scalars['String']>;
  /** The signal strength */
  signalId?: InputMaybe<Scalars['BigInt']>;
  /** The recorded temperature */
  temperatureId?: InputMaybe<Scalars['BigInt']>;
};

/** Represents an update to a `TemperatureSensor`. Fields that are set will be updated. */
export type TemperatureSensorPatch = {
  /** The battery level */
  batteryId?: InputMaybe<Scalars['BigInt']>;
  /** The facility where the temperature sensor is installed */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** The GIS geometry specifies the physical location of where the sensor is installed */
  geometry?: InputMaybe<Scalars['GeoJSON']>;
  /** The Human-readable label for the sensor */
  label?: InputMaybe<Scalars['String']>;
  /** The metadata for the sensor */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** A short link used for sensor provisioning */
  shortLink?: InputMaybe<Scalars['String']>;
  /** The signal strength */
  signalId?: InputMaybe<Scalars['BigInt']>;
  /** The recorded temperature */
  temperatureId?: InputMaybe<Scalars['BigInt']>;
};

/** A connection to a list of `TemperatureSensor` values. */
export type TemperatureSensorsConnection = {
  __typename?: 'TemperatureSensorsConnection';
  /** Returns the aggregate battery timeseries data for the TemperatureSensorsConnection  */
  battery?: Maybe<MetricDataConnection>;
  /** A list of edges which contains the `TemperatureSensor` and cursor to aid in pagination. */
  edges: Array<TemperatureSensorsEdge>;
  /** A list of `TemperatureSensor` objects. */
  nodes: Array<TemperatureSensor>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Returns the aggregate signal timeseries data for the TemperatureSensorsConnection  */
  signal?: Maybe<MetricDataConnection>;
  /** Returns the aggregate temperature timeseries data for the TemperatureSensorsConnection  */
  temperature?: Maybe<MetricDataConnection>;
  /** The count of *all* `TemperatureSensor` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A connection to a list of `TemperatureSensor` values. */
export type TemperatureSensorsConnectionBatteryArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `TemperatureSensor` values. */
export type TemperatureSensorsConnectionSignalArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `TemperatureSensor` values. */
export type TemperatureSensorsConnectionTemperatureArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A `TemperatureSensor` edge in the connection. */
export type TemperatureSensorsEdge = {
  __typename?: 'TemperatureSensorsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `TemperatureSensor` at the end of the edge. */
  node: TemperatureSensor;
};

/** Methods to use when ordering `TemperatureSensor`. */
export enum TemperatureSensorsOrderBy {
  BATTERY_ID_ASC = 'BATTERY_ID_ASC',
  BATTERY_ID_DESC = 'BATTERY_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  GEOMETRY_ASC = 'GEOMETRY_ASC',
  GEOMETRY_DESC = 'GEOMETRY_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SHORT_LINK_ASC = 'SHORT_LINK_ASC',
  SHORT_LINK_DESC = 'SHORT_LINK_DESC',
  SIGNAL_ID_ASC = 'SIGNAL_ID_ASC',
  SIGNAL_ID_DESC = 'SIGNAL_ID_DESC',
  TEMPERATURE_ID_ASC = 'TEMPERATURE_ID_ASC',
  TEMPERATURE_ID_DESC = 'TEMPERATURE_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** Represents a timezone type. */
export type Timezone = Node & {
  __typename?: 'Timezone';
  /** The abbreviation of the timezone. */
  abbreviation?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `Facility`. */
  facilitiesByTimezoneName: FacilitiesConnection;
  /** Whether the timezone follows daylight savings time (DST). */
  isDst?: Maybe<Scalars['Boolean']>;
  /** The name of the timezone. */
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The offset of the timezone as an interval. */
  utcOffset?: Maybe<Interval>;
};

/** Represents a timezone type. */
export type TimezoneFacilitiesByTimezoneNameArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FacilityCondition>;
  filter?: InputMaybe<FacilityFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FacilitiesOrderBy>>;
};

/**
 * A condition to be used against `Timezone` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type TimezoneCondition = {
  /** Checks for equality with the object’s `abbreviation` field. */
  abbreviation?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `isDst` field. */
  isDst?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `utcOffset` field. */
  utcOffset?: InputMaybe<IntervalInput>;
};

/** A filter to be used against `Timezone` object types. All fields are combined with a logical ‘and.’ */
export type TimezoneFilter = {
  /** Filter by the object’s `abbreviation` field. */
  abbreviation?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TimezoneFilter>>;
  /** Filter by the object’s `isDst` field. */
  isDst?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TimezoneFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TimezoneFilter>>;
  /** Filter by the object’s `utcOffset` field. */
  utcOffset?: InputMaybe<IntervalFilter>;
};

/** A connection to a list of `Timezone` values. */
export type TimezonesConnection = {
  __typename?: 'TimezonesConnection';
  /** A list of edges which contains the `Timezone` and cursor to aid in pagination. */
  edges: Array<TimezonesEdge>;
  /** A list of `Timezone` objects. */
  nodes: Array<Timezone>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Timezone` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Timezone` edge in the connection. */
export type TimezonesEdge = {
  __typename?: 'TimezonesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Timezone` at the end of the edge. */
  node: Timezone;
};

/** Methods to use when ordering `Timezone`. */
export enum TimezonesOrderBy {
  ABBREVIATION_ASC = 'ABBREVIATION_ASC',
  ABBREVIATION_DESC = 'ABBREVIATION_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_ADDRESS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_ADDRESS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_ADDRESS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_ADDRESS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_BONUS_LTR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_BONUS_LTR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_BONUS_LTR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_BONUS_LTR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_CITY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_CITY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_CITY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_CITY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_CONTXT_9249_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_CONTXT_9249_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_CONTXT_9249_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_CONTXT_9249_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_COUNTRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_COUNTRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_COUNTRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_COUNTRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_CREATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_CREATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_CREATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_CREATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_DATATYPE_1_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_DATATYPE_1_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_DATATYPE_1_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_DATATYPE_1_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_DATA_TYPE_2_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_DATA_TYPE_2_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_DATA_TYPE_2_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_DATA_TYPE_2_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_DATA_TYPE_3_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_DATA_TYPE_3_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_DATA_TYPE_3_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_DATA_TYPE_3_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_FACILITY_CONTACTS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_FACILITY_CONTACTS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_FACILITY_CONTACTS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_FACILITY_CONTACTS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_GEOMETRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_GEOMETRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_GEOMETRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_GEOMETRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_LATITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_LATITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_LATITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_LATITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_LINK_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_LINK_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_LINK_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_LINK_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_LONGITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_LONGITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_LONGITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_LONGITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_NOTE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_NOTE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_NOTE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_NOTE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_N_SIGHT_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_N_SIGHT_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_N_SIGHT_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_N_SIGHT_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_PRE_BONUS_EBITDA_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_PRE_BONUS_EBITDA_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_PRE_BONUS_EBITDA_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_PRE_BONUS_EBITDA_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_PRICING_NODE_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_PRICING_NODE_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_PRICING_NODE_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_PRICING_NODE_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_REAL_TIME_ENABLED_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_REAL_TIME_ENABLED_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_REAL_TIME_ENABLED_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_REAL_TIME_ENABLED_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_REFRIGERATIONVENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_REFRIGERATIONVENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_REFRIGERATIONVENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_REFRIGERATIONVENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_RETIRED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_RETIRED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_RETIRED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_RETIRED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_SLUG_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_SLUG_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_SLUG_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_SLUG_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_STATE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_STATE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_STATE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_STATE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_TIMEZONE_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_TIMEZONE_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_TIMEZONE_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_TIMEZONE_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_UNIT_GROUP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_UNIT_GROUP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_UNIT_GROUP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_UNIT_GROUP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_UPDATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_UPDATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_UPDATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_UPDATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_ZIP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_ZIP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_ZIP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_ZIP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_COUNT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_COUNT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_COUNT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_COUNT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_ADDRESS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_ADDRESS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_ADDRESS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_ADDRESS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_BONUS_LTR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_BONUS_LTR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_BONUS_LTR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_BONUS_LTR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_CITY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_CITY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_CITY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_CITY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_CONTXT_9249_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_CONTXT_9249_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_CONTXT_9249_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_CONTXT_9249_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNTRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNTRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNTRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNTRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_ADDRESS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_ADDRESS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_ADDRESS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_ADDRESS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_BONUS_LTR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_BONUS_LTR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_BONUS_LTR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_BONUS_LTR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_CITY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_CITY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_CITY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_CITY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_CONTXT_9249_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_CONTXT_9249_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_CONTXT_9249_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_CONTXT_9249_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_COUNTRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_COUNTRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_COUNTRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_COUNTRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_CREATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_CREATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_CREATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_CREATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_DATATYPE_1_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_DATATYPE_1_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_DATATYPE_1_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_DATATYPE_1_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_DATA_TYPE_2_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_DATA_TYPE_2_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_DATA_TYPE_2_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_DATA_TYPE_2_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_DATA_TYPE_3_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_DATA_TYPE_3_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_DATA_TYPE_3_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_DATA_TYPE_3_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_FACILITY_CONTACTS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_FACILITY_CONTACTS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_FACILITY_CONTACTS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_FACILITY_CONTACTS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_GEOMETRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_GEOMETRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_GEOMETRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_GEOMETRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_LATITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_LATITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_LATITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_LATITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_LINK_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_LINK_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_LINK_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_LINK_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_LONGITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_LONGITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_LONGITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_LONGITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_NOTE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_NOTE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_NOTE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_NOTE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_N_SIGHT_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_N_SIGHT_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_N_SIGHT_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_N_SIGHT_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_PRE_BONUS_EBITDA_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_PRE_BONUS_EBITDA_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_PRE_BONUS_EBITDA_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_PRE_BONUS_EBITDA_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_PRICING_NODE_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_PRICING_NODE_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_PRICING_NODE_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_PRICING_NODE_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_REAL_TIME_ENABLED_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_REAL_TIME_ENABLED_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_REAL_TIME_ENABLED_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_REAL_TIME_ENABLED_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_REFRIGERATIONVENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_REFRIGERATIONVENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_REFRIGERATIONVENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_REFRIGERATIONVENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_RETIRED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_RETIRED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_RETIRED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_RETIRED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_SLUG_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_SLUG_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_SLUG_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_SLUG_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_STATE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_STATE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_STATE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_STATE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_TIMEZONE_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_TIMEZONE_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_TIMEZONE_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_TIMEZONE_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_UNIT_GROUP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_UNIT_GROUP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_UNIT_GROUP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_UNIT_GROUP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_UPDATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_UPDATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_UPDATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_UPDATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_ZIP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_ZIP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_ZIP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_ZIP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_CREATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_CREATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_CREATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_CREATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_DATATYPE_1_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_DATATYPE_1_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_DATATYPE_1_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_DATATYPE_1_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_DATA_TYPE_2_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_DATA_TYPE_2_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_DATA_TYPE_2_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_DATA_TYPE_2_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_DATA_TYPE_3_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_DATA_TYPE_3_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_DATA_TYPE_3_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_DATA_TYPE_3_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_FACILITY_CONTACTS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_FACILITY_CONTACTS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_FACILITY_CONTACTS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_FACILITY_CONTACTS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_GEOMETRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_GEOMETRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_GEOMETRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_GEOMETRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_LATITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_LATITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_LATITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_LATITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_LINK_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_LINK_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_LINK_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_LINK_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_LONGITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_LONGITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_LONGITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_LONGITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_NOTE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_NOTE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_NOTE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_NOTE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_N_SIGHT_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_N_SIGHT_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_N_SIGHT_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_N_SIGHT_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_PRE_BONUS_EBITDA_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_PRE_BONUS_EBITDA_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_PRE_BONUS_EBITDA_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_PRE_BONUS_EBITDA_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_PRICING_NODE_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_PRICING_NODE_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_PRICING_NODE_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_PRICING_NODE_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_REAL_TIME_ENABLED_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_REAL_TIME_ENABLED_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_REAL_TIME_ENABLED_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_REAL_TIME_ENABLED_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_REFRIGERATIONVENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_REFRIGERATIONVENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_REFRIGERATIONVENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_REFRIGERATIONVENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_RETIRED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_RETIRED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_RETIRED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_RETIRED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_SLUG_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_SLUG_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_SLUG_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_SLUG_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_STATE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_STATE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_STATE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_STATE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_TIMEZONE_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_TIMEZONE_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_TIMEZONE_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_TIMEZONE_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_UNIT_GROUP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_UNIT_GROUP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_UNIT_GROUP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_UNIT_GROUP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_UPDATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_UPDATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_UPDATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_UPDATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_ZIP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_ZIP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_ZIP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_ZIP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_ADDRESS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_ADDRESS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_ADDRESS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_ADDRESS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_BONUS_LTR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_BONUS_LTR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_BONUS_LTR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_BONUS_LTR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_CITY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_CITY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_CITY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_CITY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_CONTXT_9249_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_CONTXT_9249_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_CONTXT_9249_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_CONTXT_9249_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_COUNTRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_COUNTRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_COUNTRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_COUNTRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_CREATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_CREATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_CREATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_CREATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_DATATYPE_1_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_DATATYPE_1_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_DATATYPE_1_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_DATATYPE_1_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_DATA_TYPE_2_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_DATA_TYPE_2_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_DATA_TYPE_2_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_DATA_TYPE_2_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_DATA_TYPE_3_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_DATA_TYPE_3_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_DATA_TYPE_3_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_DATA_TYPE_3_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_FACILITY_CONTACTS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_FACILITY_CONTACTS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_FACILITY_CONTACTS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_FACILITY_CONTACTS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_GEOMETRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_GEOMETRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_GEOMETRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_GEOMETRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_LATITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_LATITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_LATITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_LATITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_LINK_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_LINK_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_LINK_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_LINK_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_LONGITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_LONGITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_LONGITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_LONGITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_NOTE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_NOTE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_NOTE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_NOTE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_N_SIGHT_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_N_SIGHT_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_N_SIGHT_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_N_SIGHT_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_PRE_BONUS_EBITDA_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_PRE_BONUS_EBITDA_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_PRE_BONUS_EBITDA_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_PRE_BONUS_EBITDA_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_PRICING_NODE_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_PRICING_NODE_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_PRICING_NODE_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_PRICING_NODE_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_REAL_TIME_ENABLED_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_REAL_TIME_ENABLED_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_REAL_TIME_ENABLED_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_REAL_TIME_ENABLED_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_REFRIGERATIONVENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_REFRIGERATIONVENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_REFRIGERATIONVENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_REFRIGERATIONVENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_RETIRED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_RETIRED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_RETIRED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_RETIRED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_SLUG_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_SLUG_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_SLUG_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_SLUG_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_STATE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_STATE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_STATE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_STATE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_TIMEZONE_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_TIMEZONE_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_TIMEZONE_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_TIMEZONE_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_UNIT_GROUP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_UNIT_GROUP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_UNIT_GROUP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_UNIT_GROUP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_UPDATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_UPDATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_UPDATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_UPDATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_ZIP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_ZIP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_ZIP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_ZIP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_ADDRESS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_ADDRESS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_ADDRESS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_ADDRESS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_BONUS_LTR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_BONUS_LTR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_BONUS_LTR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_BONUS_LTR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_CITY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_CITY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_CITY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_CITY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_CONTXT_9249_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_CONTXT_9249_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_CONTXT_9249_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_CONTXT_9249_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_COUNTRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_COUNTRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_COUNTRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_COUNTRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_CREATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_CREATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_CREATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_CREATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_DATATYPE_1_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_DATATYPE_1_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_DATATYPE_1_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_DATATYPE_1_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_DATA_TYPE_2_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_DATA_TYPE_2_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_DATA_TYPE_2_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_DATA_TYPE_2_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_DATA_TYPE_3_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_DATA_TYPE_3_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_DATA_TYPE_3_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_DATA_TYPE_3_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_FACILITY_CONTACTS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_FACILITY_CONTACTS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_FACILITY_CONTACTS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_FACILITY_CONTACTS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_GEOMETRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_GEOMETRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_GEOMETRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_GEOMETRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_LATITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_LATITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_LATITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_LATITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_LINK_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_LINK_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_LINK_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_LINK_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_LONGITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_LONGITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_LONGITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_LONGITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_NOTE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_NOTE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_NOTE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_NOTE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_N_SIGHT_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_N_SIGHT_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_N_SIGHT_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_N_SIGHT_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_PRE_BONUS_EBITDA_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_PRE_BONUS_EBITDA_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_PRE_BONUS_EBITDA_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_PRE_BONUS_EBITDA_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_PRICING_NODE_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_PRICING_NODE_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_PRICING_NODE_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_PRICING_NODE_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_REAL_TIME_ENABLED_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_REAL_TIME_ENABLED_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_REAL_TIME_ENABLED_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_REAL_TIME_ENABLED_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_REFRIGERATIONVENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_REFRIGERATIONVENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_REFRIGERATIONVENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_REFRIGERATIONVENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_RETIRED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_RETIRED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_RETIRED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_RETIRED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_SLUG_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_SLUG_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_SLUG_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_SLUG_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_STATE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_STATE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_STATE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_STATE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_TIMEZONE_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_TIMEZONE_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_TIMEZONE_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_TIMEZONE_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_UNIT_GROUP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_UNIT_GROUP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_UNIT_GROUP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_UNIT_GROUP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_UPDATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_UPDATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_UPDATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_UPDATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_ZIP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_ZIP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_ZIP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_ZIP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_ADDRESS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_ADDRESS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_ADDRESS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_ADDRESS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_BONUS_LTR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_BONUS_LTR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_BONUS_LTR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_BONUS_LTR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_CITY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_CITY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_CITY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_CITY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_CONTXT_9249_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_CONTXT_9249_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_CONTXT_9249_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_CONTXT_9249_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_COUNTRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_COUNTRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_COUNTRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_COUNTRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_CREATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_CREATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_CREATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_CREATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_DATATYPE_1_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_DATATYPE_1_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_DATATYPE_1_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_DATATYPE_1_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_DATA_TYPE_2_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_DATA_TYPE_2_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_DATA_TYPE_2_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_DATA_TYPE_2_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_DATA_TYPE_3_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_DATA_TYPE_3_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_DATA_TYPE_3_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_DATA_TYPE_3_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_FACILITY_CONTACTS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_FACILITY_CONTACTS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_FACILITY_CONTACTS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_FACILITY_CONTACTS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_GEOMETRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_GEOMETRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_GEOMETRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_GEOMETRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_LATITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_LATITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_LATITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_LATITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_LINK_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_LINK_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_LINK_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_LINK_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_LONGITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_LONGITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_LONGITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_LONGITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_NOTE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_NOTE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_NOTE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_NOTE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_N_SIGHT_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_N_SIGHT_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_N_SIGHT_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_N_SIGHT_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_PRE_BONUS_EBITDA_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_PRE_BONUS_EBITDA_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_PRE_BONUS_EBITDA_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_PRE_BONUS_EBITDA_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_PRICING_NODE_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_PRICING_NODE_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_PRICING_NODE_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_PRICING_NODE_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_REAL_TIME_ENABLED_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_REAL_TIME_ENABLED_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_REAL_TIME_ENABLED_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_REAL_TIME_ENABLED_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_REFRIGERATIONVENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_REFRIGERATIONVENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_REFRIGERATIONVENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_REFRIGERATIONVENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_RETIRED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_RETIRED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_RETIRED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_RETIRED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_SLUG_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_SLUG_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_SLUG_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_SLUG_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_STATE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_STATE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_STATE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_STATE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_TIMEZONE_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_TIMEZONE_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_TIMEZONE_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_TIMEZONE_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_UNIT_GROUP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_UNIT_GROUP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_UNIT_GROUP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_UNIT_GROUP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_UPDATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_UPDATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_UPDATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_UPDATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_ZIP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_ZIP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_ZIP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_ZIP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_ADDRESS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_ADDRESS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_ADDRESS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_ADDRESS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_BONUS_LTR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_BONUS_LTR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_BONUS_LTR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_BONUS_LTR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_CITY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_CITY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_CITY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_CITY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_CONTXT_9249_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_CONTXT_9249_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_CONTXT_9249_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_CONTXT_9249_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_COUNTRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_COUNTRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_COUNTRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_COUNTRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_CREATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_CREATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_CREATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_CREATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_DATATYPE_1_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_DATATYPE_1_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_DATATYPE_1_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_DATATYPE_1_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_DATA_TYPE_2_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_DATA_TYPE_2_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_DATA_TYPE_2_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_DATA_TYPE_2_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_DATA_TYPE_3_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_DATA_TYPE_3_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_DATA_TYPE_3_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_DATA_TYPE_3_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_FACILITY_CONTACTS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_FACILITY_CONTACTS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_FACILITY_CONTACTS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_FACILITY_CONTACTS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_GEOMETRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_GEOMETRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_GEOMETRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_GEOMETRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_LATITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_LATITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_LATITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_LATITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_LINK_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_LINK_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_LINK_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_LINK_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_LONGITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_LONGITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_LONGITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_LONGITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_NOTE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_NOTE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_NOTE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_NOTE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_N_SIGHT_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_N_SIGHT_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_N_SIGHT_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_N_SIGHT_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_PRE_BONUS_EBITDA_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_PRE_BONUS_EBITDA_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_PRE_BONUS_EBITDA_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_PRE_BONUS_EBITDA_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_PRICING_NODE_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_PRICING_NODE_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_PRICING_NODE_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_PRICING_NODE_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_REAL_TIME_ENABLED_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_REAL_TIME_ENABLED_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_REAL_TIME_ENABLED_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_REAL_TIME_ENABLED_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_REFRIGERATIONVENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_REFRIGERATIONVENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_REFRIGERATIONVENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_REFRIGERATIONVENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_RETIRED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_RETIRED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_RETIRED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_RETIRED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_SLUG_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_SLUG_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_SLUG_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_SLUG_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_STATE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_STATE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_STATE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_STATE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_TIMEZONE_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_TIMEZONE_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_TIMEZONE_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_TIMEZONE_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_UNIT_GROUP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_UNIT_GROUP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_UNIT_GROUP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_UNIT_GROUP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_UPDATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_UPDATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_UPDATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_UPDATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_ZIP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_ZIP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_ZIP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_ZIP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_ADDRESS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_ADDRESS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_ADDRESS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_ADDRESS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_BONUS_LTR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_BONUS_LTR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_BONUS_LTR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_BONUS_LTR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_CITY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_CITY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_CITY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_CITY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_CONTXT_9249_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_CONTXT_9249_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_CONTXT_9249_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_CONTXT_9249_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_COUNTRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_COUNTRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_COUNTRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_COUNTRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_CREATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_CREATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_CREATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_CREATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_DATATYPE_1_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_DATATYPE_1_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_DATATYPE_1_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_DATATYPE_1_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_DATA_TYPE_2_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_DATA_TYPE_2_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_DATA_TYPE_2_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_DATA_TYPE_2_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_DATA_TYPE_3_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_DATA_TYPE_3_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_DATA_TYPE_3_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_DATA_TYPE_3_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_FACILITY_CONTACTS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_FACILITY_CONTACTS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_FACILITY_CONTACTS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_FACILITY_CONTACTS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_GEOMETRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_GEOMETRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_GEOMETRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_GEOMETRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_LATITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_LATITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_LATITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_LATITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_LINK_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_LINK_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_LINK_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_LINK_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_LONGITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_LONGITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_LONGITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_LONGITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_NOTE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_NOTE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_NOTE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_NOTE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_N_SIGHT_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_N_SIGHT_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_N_SIGHT_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_N_SIGHT_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_PRE_BONUS_EBITDA_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_PRE_BONUS_EBITDA_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_PRE_BONUS_EBITDA_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_PRE_BONUS_EBITDA_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_PRICING_NODE_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_PRICING_NODE_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_PRICING_NODE_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_PRICING_NODE_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_REAL_TIME_ENABLED_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_REAL_TIME_ENABLED_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_REAL_TIME_ENABLED_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_REAL_TIME_ENABLED_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_REFRIGERATIONVENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_REFRIGERATIONVENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_REFRIGERATIONVENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_REFRIGERATIONVENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_RETIRED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_RETIRED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_RETIRED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_RETIRED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_SLUG_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_SLUG_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_SLUG_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_SLUG_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_STATE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_STATE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_STATE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_STATE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_TIMEZONE_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_TIMEZONE_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_TIMEZONE_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_TIMEZONE_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_UNIT_GROUP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_UNIT_GROUP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_UNIT_GROUP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_UNIT_GROUP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_UPDATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_UPDATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_UPDATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_UPDATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_ZIP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_ZIP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_ZIP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_ZIP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_ADDRESS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_ADDRESS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_ADDRESS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_ADDRESS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_BONUS_LTR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_BONUS_LTR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_BONUS_LTR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_BONUS_LTR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_CITY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_CITY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_CITY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_CITY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_CONTXT_9249_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_CONTXT_9249_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_CONTXT_9249_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_CONTXT_9249_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_COUNTRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_COUNTRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_COUNTRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_COUNTRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_CREATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_CREATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_CREATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_CREATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_DATATYPE_1_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_DATATYPE_1_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_DATATYPE_1_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_DATATYPE_1_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_DATA_TYPE_2_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_DATA_TYPE_2_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_DATA_TYPE_2_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_DATA_TYPE_2_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_DATA_TYPE_3_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_DATA_TYPE_3_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_DATA_TYPE_3_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_DATA_TYPE_3_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_FACILITY_CONTACTS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_FACILITY_CONTACTS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_FACILITY_CONTACTS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_FACILITY_CONTACTS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_GEOMETRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_GEOMETRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_GEOMETRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_GEOMETRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_LATITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_LATITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_LATITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_LATITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_LINK_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_LINK_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_LINK_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_LINK_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_LONGITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_LONGITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_LONGITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_LONGITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_NOTE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_NOTE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_NOTE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_NOTE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_N_SIGHT_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_N_SIGHT_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_N_SIGHT_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_N_SIGHT_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_PRE_BONUS_EBITDA_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_PRE_BONUS_EBITDA_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_PRE_BONUS_EBITDA_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_PRE_BONUS_EBITDA_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_PRICING_NODE_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_PRICING_NODE_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_PRICING_NODE_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_PRICING_NODE_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_REAL_TIME_ENABLED_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_REAL_TIME_ENABLED_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_REAL_TIME_ENABLED_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_REAL_TIME_ENABLED_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_REFRIGERATIONVENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_REFRIGERATIONVENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_REFRIGERATIONVENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_REFRIGERATIONVENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_RETIRED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_RETIRED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_RETIRED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_RETIRED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_SLUG_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_SLUG_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_SLUG_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_SLUG_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_STATE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_STATE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_STATE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_STATE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_TIMEZONE_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_TIMEZONE_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_TIMEZONE_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_TIMEZONE_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_UNIT_GROUP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_UNIT_GROUP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_UNIT_GROUP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_UNIT_GROUP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_UPDATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_UPDATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_UPDATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_UPDATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_ZIP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_ZIP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_ZIP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_ZIP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_ADDRESS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_ADDRESS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_ADDRESS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_ADDRESS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_BONUS_LTR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_BONUS_LTR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_BONUS_LTR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_BONUS_LTR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_CITY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_CITY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_CITY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_CITY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_CONTXT_9249_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_CONTXT_9249_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_CONTXT_9249_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_CONTXT_9249_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_COUNTRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_COUNTRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_COUNTRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_COUNTRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_CREATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_CREATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_CREATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_CREATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_DATATYPE_1_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_DATATYPE_1_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_DATATYPE_1_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_DATATYPE_1_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_DATA_TYPE_2_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_DATA_TYPE_2_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_DATA_TYPE_2_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_DATA_TYPE_2_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_DATA_TYPE_3_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_DATA_TYPE_3_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_DATA_TYPE_3_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_DATA_TYPE_3_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_FACILITY_CONTACTS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_FACILITY_CONTACTS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_FACILITY_CONTACTS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_FACILITY_CONTACTS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_GEOMETRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_GEOMETRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_GEOMETRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_GEOMETRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_LATITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_LATITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_LATITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_LATITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_LINK_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_LINK_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_LINK_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_LINK_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_LONGITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_LONGITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_LONGITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_LONGITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_NOTE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_NOTE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_NOTE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_NOTE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_N_SIGHT_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_N_SIGHT_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_N_SIGHT_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_N_SIGHT_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_PRE_BONUS_EBITDA_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_PRE_BONUS_EBITDA_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_PRE_BONUS_EBITDA_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_PRE_BONUS_EBITDA_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_PRICING_NODE_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_PRICING_NODE_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_PRICING_NODE_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_PRICING_NODE_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_REAL_TIME_ENABLED_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_REAL_TIME_ENABLED_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_REAL_TIME_ENABLED_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_REAL_TIME_ENABLED_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_REFRIGERATIONVENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_REFRIGERATIONVENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_REFRIGERATIONVENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_REFRIGERATIONVENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_RETIRED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_RETIRED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_RETIRED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_RETIRED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_SLUG_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_SLUG_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_SLUG_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_SLUG_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_STATE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_STATE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_STATE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_STATE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_TIMEZONE_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_TIMEZONE_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_TIMEZONE_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_TIMEZONE_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_UNIT_GROUP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_UNIT_GROUP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_UNIT_GROUP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_UNIT_GROUP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_UPDATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_UPDATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_UPDATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_UPDATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_ZIP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_ZIP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_ZIP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_ZIP_DESC',
  IS_DST_ASC = 'IS_DST_ASC',
  IS_DST_DESC = 'IS_DST_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UTC_OFFSET_ASC = 'UTC_OFFSET_ASC',
  UTC_OFFSET_DESC = 'UTC_OFFSET_DESC'
}

/** This represents a physical location of a trailer at a door or yard position */
export type TrailerPosition = Node & {
  __typename?: 'TrailerPosition';
  /** The time at which the Trailer Position was created */
  createdAt: Scalars['Datetime'];
  /** Reads a single `Facility` that is related to this `TrailerPosition`. */
  facility?: Maybe<Facility>;
  /** The facility where the trailer position is located */
  facilityId?: Maybe<Scalars['Int']>;
  /** The GIS geometry specifies the physical location of the trailer position */
  geometry?: Maybe<GeometryInterface>;
  /** The id of the trailer position */
  id: Scalars['Int'];
  /** The Human-readable label for the trailer position */
  label: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `DataPoint` that is related to this `TrailerPosition`. */
  trailerIsPresent?: Maybe<DataPoint>;
  /** The state of the trailer position indicating if the position is occupied */
  trailerIsPresentId?: Maybe<Scalars['BigInt']>;
  /** The time at which the Trailer Position was updated */
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `TrailerPosition` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type TrailerPositionCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `geometry` field. */
  geometry?: InputMaybe<Scalars['GeoJSON']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `trailerIsPresentId` field. */
  trailerIsPresentId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `TrailerPosition` object types. All fields are combined with a logical ‘and.’ */
export type TrailerPositionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TrailerPositionFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TrailerPositionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TrailerPositionFilter>>;
  /** Filter by the object’s `trailerIsPresentId` field. */
  trailerIsPresentId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `TrailerPosition` */
export type TrailerPositionInput = {
  /** Mutates a `DataPoint` as part of the payload */
  dataPoint?: InputMaybe<DataPointInput>;
  /** The facility where the trailer position is located */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** The GIS geometry specifies the physical location of the trailer position */
  geometry?: InputMaybe<Scalars['GeoJSON']>;
  /** The Human-readable label for the trailer position */
  label: Scalars['String'];
  /** The state of the trailer position indicating if the position is occupied */
  trailerIsPresentId?: InputMaybe<Scalars['BigInt']>;
};

/** Represents an update to a `TrailerPosition`. Fields that are set will be updated. */
export type TrailerPositionPatch = {
  /** The facility where the trailer position is located */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** The GIS geometry specifies the physical location of the trailer position */
  geometry?: InputMaybe<Scalars['GeoJSON']>;
  /** The Human-readable label for the trailer position */
  label?: InputMaybe<Scalars['String']>;
  /** The state of the trailer position indicating if the position is occupied */
  trailerIsPresentId?: InputMaybe<Scalars['BigInt']>;
};

/** A connection to a list of `TrailerPosition` values. */
export type TrailerPositionsConnection = {
  __typename?: 'TrailerPositionsConnection';
  /** A list of edges which contains the `TrailerPosition` and cursor to aid in pagination. */
  edges: Array<TrailerPositionsEdge>;
  /** A list of `TrailerPosition` objects. */
  nodes: Array<TrailerPosition>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TrailerPosition` you could get from the connection. */
  totalCount: Scalars['Int'];
  /** Returns the aggregate trailerIsPresent timeseries data for the TrailerPositionsConnection  */
  trailerIsPresent?: Maybe<MetricDataConnection>;
};

/** A connection to a list of `TrailerPosition` values. */
export type TrailerPositionsConnectionTrailerIsPresentArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A `TrailerPosition` edge in the connection. */
export type TrailerPositionsEdge = {
  __typename?: 'TrailerPositionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `TrailerPosition` at the end of the edge. */
  node: TrailerPosition;
};

/** Methods to use when ordering `TrailerPosition`. */
export enum TrailerPositionsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  GEOMETRY_ASC = 'GEOMETRY_ASC',
  GEOMETRY_DESC = 'GEOMETRY_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  TRAILER_IS_PRESENT_ID_ASC = 'TRAILER_IS_PRESENT_ID_ASC',
  TRAILER_IS_PRESENT_ID_DESC = 'TRAILER_IS_PRESENT_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

export type TransitionControlEventInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  controlEventId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  state: ControlEventState;
};

/** A unit dimension that identifies the base of a unit. */
export type UnitDimension = Node & {
  __typename?: 'UnitDimension';
  /** Returns a distinct list of units that are in use across facilities. */
  activeMappings?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The name of a unit dimension. */
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `UnitGroupDimension`. */
  unitGroupDimensionsByUnitDimension: UnitGroupDimensionsConnection;
};

/** A unit dimension that identifies the base of a unit. */
export type UnitDimensionUnitGroupDimensionsByUnitDimensionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UnitGroupDimensionCondition>;
  filter?: InputMaybe<UnitGroupDimensionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UnitGroupDimensionsOrderBy>>;
};

/**
 * A condition to be used against `UnitDimension` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UnitDimensionCondition = {
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `UnitDimension` object types. All fields are combined with a logical ‘and.’ */
export type UnitDimensionFilter = {
  /** Filter by the object’s `activeMappings` field. */
  activeMappings?: InputMaybe<StringListFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UnitDimensionFilter>>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UnitDimensionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UnitDimensionFilter>>;
};

/** A connection to a list of `UnitDimension` values. */
export type UnitDimensionsConnection = {
  __typename?: 'UnitDimensionsConnection';
  /** A list of edges which contains the `UnitDimension` and cursor to aid in pagination. */
  edges: Array<UnitDimensionsEdge>;
  /** A list of `UnitDimension` objects. */
  nodes: Array<UnitDimension>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UnitDimension` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UnitDimension` edge in the connection. */
export type UnitDimensionsEdge = {
  __typename?: 'UnitDimensionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UnitDimension` at the end of the edge. */
  node: UnitDimension;
};

/** Methods to use when ordering `UnitDimension`. */
export enum UnitDimensionsOrderBy {
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** A grouping used to collect values for a set of unit dimensions. */
export type UnitGroup = Node & {
  __typename?: 'UnitGroup';
  /** Reads and enables pagination through a set of `Facility`. */
  facilitiesByUnitGroup: FacilitiesConnection;
  /** The name of a unique unit group. */
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `UnitGroupDimension`. */
  unitGroupDimensionsByUnitGroup: UnitGroupDimensionsConnection;
};

/** A grouping used to collect values for a set of unit dimensions. */
export type UnitGroupFacilitiesByUnitGroupArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FacilityCondition>;
  filter?: InputMaybe<FacilityFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FacilitiesOrderBy>>;
};

/** A grouping used to collect values for a set of unit dimensions. */
export type UnitGroupUnitGroupDimensionsByUnitGroupArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UnitGroupDimensionCondition>;
  filter?: InputMaybe<UnitGroupDimensionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UnitGroupDimensionsOrderBy>>;
};

/**
 * A condition to be used against `UnitGroup` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type UnitGroupCondition = {
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
};

/** A mapping of a unit dimension for a specific unit group. */
export type UnitGroupDimension = Node & {
  __typename?: 'UnitGroupDimension';
  /** The time the unit group dimension was created. */
  createdAt: Scalars['Datetime'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The value of the unit for the dimension. */
  unit: Scalars['String'];
  /** The associated unit dimension. */
  unitDimension: Scalars['String'];
  /** Reads a single `UnitDimension` that is related to this `UnitGroupDimension`. */
  unitDimensionByUnitDimension?: Maybe<UnitDimension>;
  /** The associated unit grouping. */
  unitGroup: Scalars['String'];
  /** Reads a single `UnitGroup` that is related to this `UnitGroupDimension`. */
  unitGroupByUnitGroup?: Maybe<UnitGroup>;
  /** The time the unit group dimension was updated. */
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `UnitGroupDimension` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UnitGroupDimensionCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `unit` field. */
  unit?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `unitDimension` field. */
  unitDimension?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `unitGroup` field. */
  unitGroup?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `UnitGroupDimension` object types. All fields are combined with a logical ‘and.’ */
export type UnitGroupDimensionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UnitGroupDimensionFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UnitGroupDimensionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UnitGroupDimensionFilter>>;
  /** Filter by the object’s `unit` field. */
  unit?: InputMaybe<StringFilter>;
  /** Filter by the object’s `unitDimension` field. */
  unitDimension?: InputMaybe<StringFilter>;
  /** Filter by the object’s `unitGroup` field. */
  unitGroup?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** A connection to a list of `UnitGroupDimension` values. */
export type UnitGroupDimensionsConnection = {
  __typename?: 'UnitGroupDimensionsConnection';
  /** A list of edges which contains the `UnitGroupDimension` and cursor to aid in pagination. */
  edges: Array<UnitGroupDimensionsEdge>;
  /** A list of `UnitGroupDimension` objects. */
  nodes: Array<UnitGroupDimension>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UnitGroupDimension` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UnitGroupDimension` edge in the connection. */
export type UnitGroupDimensionsEdge = {
  __typename?: 'UnitGroupDimensionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UnitGroupDimension` at the end of the edge. */
  node: UnitGroupDimension;
};

/** Methods to use when ordering `UnitGroupDimension`. */
export enum UnitGroupDimensionsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UNIT_ASC = 'UNIT_ASC',
  UNIT_DESC = 'UNIT_DESC',
  UNIT_DIMENSION_ASC = 'UNIT_DIMENSION_ASC',
  UNIT_DIMENSION_DESC = 'UNIT_DIMENSION_DESC',
  UNIT_GROUP_ASC = 'UNIT_GROUP_ASC',
  UNIT_GROUP_DESC = 'UNIT_GROUP_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A filter to be used against `UnitGroup` object types. All fields are combined with a logical ‘and.’ */
export type UnitGroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UnitGroupFilter>>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UnitGroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UnitGroupFilter>>;
};

/** A connection to a list of `UnitGroup` values. */
export type UnitGroupsConnection = {
  __typename?: 'UnitGroupsConnection';
  /** A list of edges which contains the `UnitGroup` and cursor to aid in pagination. */
  edges: Array<UnitGroupsEdge>;
  /** A list of `UnitGroup` objects. */
  nodes: Array<UnitGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UnitGroup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UnitGroup` edge in the connection. */
export type UnitGroupsEdge = {
  __typename?: 'UnitGroupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UnitGroup` at the end of the edge. */
  node: UnitGroup;
};

/** Methods to use when ordering `UnitGroup`. */
export enum UnitGroupsOrderBy {
  FACILITIES_BY_UNIT_GROUP_AVERAGE_ADDRESS_ASC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_ADDRESS_ASC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_ADDRESS_DESC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_ADDRESS_DESC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_BONUS_LTR_ASC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_BONUS_LTR_ASC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_BONUS_LTR_DESC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_BONUS_LTR_DESC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_CITY_ASC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_CITY_ASC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_CITY_DESC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_CITY_DESC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_CONTXT_9249_ASC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_CONTXT_9249_ASC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_CONTXT_9249_DESC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_CONTXT_9249_DESC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_COUNTRY_ASC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_COUNTRY_ASC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_COUNTRY_DESC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_COUNTRY_DESC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_CREATED_AT_ASC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_CREATED_AT_ASC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_CREATED_AT_DESC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_CREATED_AT_DESC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_DATATYPE_1_TEST_ASC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_DATATYPE_1_TEST_ASC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_DATATYPE_1_TEST_DESC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_DATATYPE_1_TEST_DESC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_DATA_TYPE_2_TEST_ASC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_DATA_TYPE_2_TEST_ASC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_DATA_TYPE_2_TEST_DESC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_DATA_TYPE_2_TEST_DESC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_DATA_TYPE_3_TEST_ASC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_DATA_TYPE_3_TEST_ASC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_DATA_TYPE_3_TEST_DESC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_DATA_TYPE_3_TEST_DESC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_FACILITY_CONTACTS_ASC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_FACILITY_CONTACTS_ASC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_FACILITY_CONTACTS_DESC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_FACILITY_CONTACTS_DESC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_GEOMETRY_ASC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_GEOMETRY_ASC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_GEOMETRY_DESC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_GEOMETRY_DESC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_ID_ASC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_ID_ASC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_ID_DESC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_ID_DESC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_LATITUDE_ASC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_LATITUDE_ASC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_LATITUDE_DESC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_LATITUDE_DESC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_LINK_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_LINK_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_LINK_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_LINK_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_LONGITUDE_ASC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_LONGITUDE_ASC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_LONGITUDE_DESC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_LONGITUDE_DESC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_NAME_ASC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_NAME_ASC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_NAME_DESC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_NAME_DESC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_NOTE_ASC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_NOTE_ASC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_NOTE_DESC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_NOTE_DESC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_N_SIGHT_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_N_SIGHT_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_N_SIGHT_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_N_SIGHT_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_PRE_BONUS_EBITDA_ASC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_PRE_BONUS_EBITDA_ASC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_PRE_BONUS_EBITDA_DESC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_PRE_BONUS_EBITDA_DESC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_PRICING_NODE_ID_ASC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_PRICING_NODE_ID_ASC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_PRICING_NODE_ID_DESC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_PRICING_NODE_ID_DESC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_REAL_TIME_ENABLED_ASC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_REAL_TIME_ENABLED_ASC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_REAL_TIME_ENABLED_DESC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_REAL_TIME_ENABLED_DESC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_REFRIGERATIONVENDOR_ASC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_REFRIGERATIONVENDOR_ASC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_REFRIGERATIONVENDOR_DESC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_REFRIGERATIONVENDOR_DESC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_RETIRED_AT_ASC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_RETIRED_AT_ASC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_RETIRED_AT_DESC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_RETIRED_AT_DESC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_SLUG_ASC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_SLUG_ASC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_SLUG_DESC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_SLUG_DESC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_STATE_ASC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_STATE_ASC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_STATE_DESC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_STATE_DESC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_TIMEZONE_NAME_ASC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_TIMEZONE_NAME_ASC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_TIMEZONE_NAME_DESC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_TIMEZONE_NAME_DESC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_UNIT_GROUP_ASC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_UNIT_GROUP_ASC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_UNIT_GROUP_DESC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_UNIT_GROUP_DESC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_UPDATED_AT_ASC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_UPDATED_AT_ASC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_UPDATED_AT_DESC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_UPDATED_AT_DESC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_ZIP_ASC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_ZIP_ASC',
  FACILITIES_BY_UNIT_GROUP_AVERAGE_ZIP_DESC = 'FACILITIES_BY_UNIT_GROUP_AVERAGE_ZIP_DESC',
  FACILITIES_BY_UNIT_GROUP_COUNT_ASC = 'FACILITIES_BY_UNIT_GROUP_COUNT_ASC',
  FACILITIES_BY_UNIT_GROUP_COUNT_DESC = 'FACILITIES_BY_UNIT_GROUP_COUNT_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_ADDRESS_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_ADDRESS_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_ADDRESS_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_ADDRESS_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_BONUS_LTR_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_BONUS_LTR_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_BONUS_LTR_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_BONUS_LTR_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_CITY_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_CITY_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_CITY_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_CITY_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_CONTXT_9249_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_CONTXT_9249_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_CONTXT_9249_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_CONTXT_9249_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNTRY_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNTRY_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNTRY_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNTRY_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_ADDRESS_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_ADDRESS_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_ADDRESS_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_ADDRESS_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_BONUS_LTR_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_BONUS_LTR_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_BONUS_LTR_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_BONUS_LTR_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_CITY_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_CITY_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_CITY_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_CITY_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_CONTXT_9249_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_CONTXT_9249_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_CONTXT_9249_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_CONTXT_9249_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_COUNTRY_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_COUNTRY_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_COUNTRY_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_COUNTRY_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_CREATED_AT_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_CREATED_AT_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_CREATED_AT_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_CREATED_AT_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_DATATYPE_1_TEST_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_DATATYPE_1_TEST_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_DATATYPE_1_TEST_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_DATATYPE_1_TEST_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_DATA_TYPE_2_TEST_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_DATA_TYPE_2_TEST_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_DATA_TYPE_2_TEST_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_DATA_TYPE_2_TEST_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_DATA_TYPE_3_TEST_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_DATA_TYPE_3_TEST_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_DATA_TYPE_3_TEST_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_DATA_TYPE_3_TEST_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_FACILITY_CONTACTS_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_FACILITY_CONTACTS_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_FACILITY_CONTACTS_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_FACILITY_CONTACTS_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_GEOMETRY_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_GEOMETRY_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_GEOMETRY_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_GEOMETRY_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_ID_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_ID_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_ID_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_ID_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_LATITUDE_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_LATITUDE_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_LATITUDE_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_LATITUDE_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_LINK_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_LINK_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_LINK_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_LINK_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_LONGITUDE_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_LONGITUDE_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_LONGITUDE_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_LONGITUDE_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_NAME_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_NAME_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_NAME_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_NAME_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_NOTE_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_NOTE_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_NOTE_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_NOTE_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_N_SIGHT_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_N_SIGHT_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_N_SIGHT_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_N_SIGHT_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_PRE_BONUS_EBITDA_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_PRE_BONUS_EBITDA_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_PRE_BONUS_EBITDA_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_PRE_BONUS_EBITDA_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_PRICING_NODE_ID_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_PRICING_NODE_ID_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_PRICING_NODE_ID_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_PRICING_NODE_ID_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_REAL_TIME_ENABLED_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_REAL_TIME_ENABLED_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_REAL_TIME_ENABLED_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_REAL_TIME_ENABLED_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_REFRIGERATIONVENDOR_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_REFRIGERATIONVENDOR_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_REFRIGERATIONVENDOR_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_REFRIGERATIONVENDOR_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_RETIRED_AT_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_RETIRED_AT_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_RETIRED_AT_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_RETIRED_AT_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_SLUG_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_SLUG_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_SLUG_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_SLUG_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_STATE_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_STATE_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_STATE_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_STATE_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_TIMEZONE_NAME_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_TIMEZONE_NAME_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_TIMEZONE_NAME_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_TIMEZONE_NAME_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_UNIT_GROUP_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_UNIT_GROUP_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_UNIT_GROUP_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_UNIT_GROUP_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_UPDATED_AT_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_UPDATED_AT_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_UPDATED_AT_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_UPDATED_AT_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_ZIP_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_ZIP_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_ZIP_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_COUNT_ZIP_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_CREATED_AT_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_CREATED_AT_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_CREATED_AT_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_CREATED_AT_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_DATATYPE_1_TEST_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_DATATYPE_1_TEST_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_DATATYPE_1_TEST_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_DATATYPE_1_TEST_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_DATA_TYPE_2_TEST_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_DATA_TYPE_2_TEST_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_DATA_TYPE_2_TEST_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_DATA_TYPE_2_TEST_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_DATA_TYPE_3_TEST_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_DATA_TYPE_3_TEST_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_DATA_TYPE_3_TEST_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_DATA_TYPE_3_TEST_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_FACILITY_CONTACTS_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_FACILITY_CONTACTS_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_FACILITY_CONTACTS_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_FACILITY_CONTACTS_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_GEOMETRY_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_GEOMETRY_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_GEOMETRY_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_GEOMETRY_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_ID_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_ID_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_ID_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_ID_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_LATITUDE_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_LATITUDE_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_LATITUDE_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_LATITUDE_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_LINK_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_LINK_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_LINK_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_LINK_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_LONGITUDE_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_LONGITUDE_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_LONGITUDE_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_LONGITUDE_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_NAME_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_NAME_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_NAME_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_NAME_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_NOTE_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_NOTE_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_NOTE_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_NOTE_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_N_SIGHT_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_N_SIGHT_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_N_SIGHT_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_N_SIGHT_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_PRE_BONUS_EBITDA_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_PRE_BONUS_EBITDA_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_PRE_BONUS_EBITDA_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_PRE_BONUS_EBITDA_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_PRICING_NODE_ID_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_PRICING_NODE_ID_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_PRICING_NODE_ID_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_PRICING_NODE_ID_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_REAL_TIME_ENABLED_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_REAL_TIME_ENABLED_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_REAL_TIME_ENABLED_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_REAL_TIME_ENABLED_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_REFRIGERATIONVENDOR_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_REFRIGERATIONVENDOR_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_REFRIGERATIONVENDOR_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_REFRIGERATIONVENDOR_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_RETIRED_AT_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_RETIRED_AT_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_RETIRED_AT_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_RETIRED_AT_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_SLUG_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_SLUG_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_SLUG_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_SLUG_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_STATE_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_STATE_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_STATE_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_STATE_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_TIMEZONE_NAME_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_TIMEZONE_NAME_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_TIMEZONE_NAME_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_TIMEZONE_NAME_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_UNIT_GROUP_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_UNIT_GROUP_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_UNIT_GROUP_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_UNIT_GROUP_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_UPDATED_AT_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_UPDATED_AT_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_UPDATED_AT_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_UPDATED_AT_DESC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_ZIP_ASC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_ZIP_ASC',
  FACILITIES_BY_UNIT_GROUP_DISTINCT_ZIP_DESC = 'FACILITIES_BY_UNIT_GROUP_DISTINCT_ZIP_DESC',
  FACILITIES_BY_UNIT_GROUP_MAX_ADDRESS_ASC = 'FACILITIES_BY_UNIT_GROUP_MAX_ADDRESS_ASC',
  FACILITIES_BY_UNIT_GROUP_MAX_ADDRESS_DESC = 'FACILITIES_BY_UNIT_GROUP_MAX_ADDRESS_DESC',
  FACILITIES_BY_UNIT_GROUP_MAX_BONUS_LTR_ASC = 'FACILITIES_BY_UNIT_GROUP_MAX_BONUS_LTR_ASC',
  FACILITIES_BY_UNIT_GROUP_MAX_BONUS_LTR_DESC = 'FACILITIES_BY_UNIT_GROUP_MAX_BONUS_LTR_DESC',
  FACILITIES_BY_UNIT_GROUP_MAX_CITY_ASC = 'FACILITIES_BY_UNIT_GROUP_MAX_CITY_ASC',
  FACILITIES_BY_UNIT_GROUP_MAX_CITY_DESC = 'FACILITIES_BY_UNIT_GROUP_MAX_CITY_DESC',
  FACILITIES_BY_UNIT_GROUP_MAX_CONTXT_9249_ASC = 'FACILITIES_BY_UNIT_GROUP_MAX_CONTXT_9249_ASC',
  FACILITIES_BY_UNIT_GROUP_MAX_CONTXT_9249_DESC = 'FACILITIES_BY_UNIT_GROUP_MAX_CONTXT_9249_DESC',
  FACILITIES_BY_UNIT_GROUP_MAX_COUNTRY_ASC = 'FACILITIES_BY_UNIT_GROUP_MAX_COUNTRY_ASC',
  FACILITIES_BY_UNIT_GROUP_MAX_COUNTRY_DESC = 'FACILITIES_BY_UNIT_GROUP_MAX_COUNTRY_DESC',
  FACILITIES_BY_UNIT_GROUP_MAX_CREATED_AT_ASC = 'FACILITIES_BY_UNIT_GROUP_MAX_CREATED_AT_ASC',
  FACILITIES_BY_UNIT_GROUP_MAX_CREATED_AT_DESC = 'FACILITIES_BY_UNIT_GROUP_MAX_CREATED_AT_DESC',
  FACILITIES_BY_UNIT_GROUP_MAX_DATATYPE_1_TEST_ASC = 'FACILITIES_BY_UNIT_GROUP_MAX_DATATYPE_1_TEST_ASC',
  FACILITIES_BY_UNIT_GROUP_MAX_DATATYPE_1_TEST_DESC = 'FACILITIES_BY_UNIT_GROUP_MAX_DATATYPE_1_TEST_DESC',
  FACILITIES_BY_UNIT_GROUP_MAX_DATA_TYPE_2_TEST_ASC = 'FACILITIES_BY_UNIT_GROUP_MAX_DATA_TYPE_2_TEST_ASC',
  FACILITIES_BY_UNIT_GROUP_MAX_DATA_TYPE_2_TEST_DESC = 'FACILITIES_BY_UNIT_GROUP_MAX_DATA_TYPE_2_TEST_DESC',
  FACILITIES_BY_UNIT_GROUP_MAX_DATA_TYPE_3_TEST_ASC = 'FACILITIES_BY_UNIT_GROUP_MAX_DATA_TYPE_3_TEST_ASC',
  FACILITIES_BY_UNIT_GROUP_MAX_DATA_TYPE_3_TEST_DESC = 'FACILITIES_BY_UNIT_GROUP_MAX_DATA_TYPE_3_TEST_DESC',
  FACILITIES_BY_UNIT_GROUP_MAX_FACILITY_CONTACTS_ASC = 'FACILITIES_BY_UNIT_GROUP_MAX_FACILITY_CONTACTS_ASC',
  FACILITIES_BY_UNIT_GROUP_MAX_FACILITY_CONTACTS_DESC = 'FACILITIES_BY_UNIT_GROUP_MAX_FACILITY_CONTACTS_DESC',
  FACILITIES_BY_UNIT_GROUP_MAX_GEOMETRY_ASC = 'FACILITIES_BY_UNIT_GROUP_MAX_GEOMETRY_ASC',
  FACILITIES_BY_UNIT_GROUP_MAX_GEOMETRY_DESC = 'FACILITIES_BY_UNIT_GROUP_MAX_GEOMETRY_DESC',
  FACILITIES_BY_UNIT_GROUP_MAX_ID_ASC = 'FACILITIES_BY_UNIT_GROUP_MAX_ID_ASC',
  FACILITIES_BY_UNIT_GROUP_MAX_ID_DESC = 'FACILITIES_BY_UNIT_GROUP_MAX_ID_DESC',
  FACILITIES_BY_UNIT_GROUP_MAX_LATITUDE_ASC = 'FACILITIES_BY_UNIT_GROUP_MAX_LATITUDE_ASC',
  FACILITIES_BY_UNIT_GROUP_MAX_LATITUDE_DESC = 'FACILITIES_BY_UNIT_GROUP_MAX_LATITUDE_DESC',
  FACILITIES_BY_UNIT_GROUP_MAX_LINK_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_MAX_LINK_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_MAX_LINK_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_MAX_LINK_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_MAX_LONGITUDE_ASC = 'FACILITIES_BY_UNIT_GROUP_MAX_LONGITUDE_ASC',
  FACILITIES_BY_UNIT_GROUP_MAX_LONGITUDE_DESC = 'FACILITIES_BY_UNIT_GROUP_MAX_LONGITUDE_DESC',
  FACILITIES_BY_UNIT_GROUP_MAX_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_MAX_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_MAX_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_MAX_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_MAX_NAME_ASC = 'FACILITIES_BY_UNIT_GROUP_MAX_NAME_ASC',
  FACILITIES_BY_UNIT_GROUP_MAX_NAME_DESC = 'FACILITIES_BY_UNIT_GROUP_MAX_NAME_DESC',
  FACILITIES_BY_UNIT_GROUP_MAX_NOTE_ASC = 'FACILITIES_BY_UNIT_GROUP_MAX_NOTE_ASC',
  FACILITIES_BY_UNIT_GROUP_MAX_NOTE_DESC = 'FACILITIES_BY_UNIT_GROUP_MAX_NOTE_DESC',
  FACILITIES_BY_UNIT_GROUP_MAX_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_MAX_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_MAX_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_MAX_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_MAX_N_SIGHT_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_MAX_N_SIGHT_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_MAX_N_SIGHT_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_MAX_N_SIGHT_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_MAX_PRE_BONUS_EBITDA_ASC = 'FACILITIES_BY_UNIT_GROUP_MAX_PRE_BONUS_EBITDA_ASC',
  FACILITIES_BY_UNIT_GROUP_MAX_PRE_BONUS_EBITDA_DESC = 'FACILITIES_BY_UNIT_GROUP_MAX_PRE_BONUS_EBITDA_DESC',
  FACILITIES_BY_UNIT_GROUP_MAX_PRICING_NODE_ID_ASC = 'FACILITIES_BY_UNIT_GROUP_MAX_PRICING_NODE_ID_ASC',
  FACILITIES_BY_UNIT_GROUP_MAX_PRICING_NODE_ID_DESC = 'FACILITIES_BY_UNIT_GROUP_MAX_PRICING_NODE_ID_DESC',
  FACILITIES_BY_UNIT_GROUP_MAX_REAL_TIME_ENABLED_ASC = 'FACILITIES_BY_UNIT_GROUP_MAX_REAL_TIME_ENABLED_ASC',
  FACILITIES_BY_UNIT_GROUP_MAX_REAL_TIME_ENABLED_DESC = 'FACILITIES_BY_UNIT_GROUP_MAX_REAL_TIME_ENABLED_DESC',
  FACILITIES_BY_UNIT_GROUP_MAX_REFRIGERATIONVENDOR_ASC = 'FACILITIES_BY_UNIT_GROUP_MAX_REFRIGERATIONVENDOR_ASC',
  FACILITIES_BY_UNIT_GROUP_MAX_REFRIGERATIONVENDOR_DESC = 'FACILITIES_BY_UNIT_GROUP_MAX_REFRIGERATIONVENDOR_DESC',
  FACILITIES_BY_UNIT_GROUP_MAX_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_BY_UNIT_GROUP_MAX_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_BY_UNIT_GROUP_MAX_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_BY_UNIT_GROUP_MAX_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_BY_UNIT_GROUP_MAX_RETIRED_AT_ASC = 'FACILITIES_BY_UNIT_GROUP_MAX_RETIRED_AT_ASC',
  FACILITIES_BY_UNIT_GROUP_MAX_RETIRED_AT_DESC = 'FACILITIES_BY_UNIT_GROUP_MAX_RETIRED_AT_DESC',
  FACILITIES_BY_UNIT_GROUP_MAX_SLUG_ASC = 'FACILITIES_BY_UNIT_GROUP_MAX_SLUG_ASC',
  FACILITIES_BY_UNIT_GROUP_MAX_SLUG_DESC = 'FACILITIES_BY_UNIT_GROUP_MAX_SLUG_DESC',
  FACILITIES_BY_UNIT_GROUP_MAX_STATE_ASC = 'FACILITIES_BY_UNIT_GROUP_MAX_STATE_ASC',
  FACILITIES_BY_UNIT_GROUP_MAX_STATE_DESC = 'FACILITIES_BY_UNIT_GROUP_MAX_STATE_DESC',
  FACILITIES_BY_UNIT_GROUP_MAX_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_BY_UNIT_GROUP_MAX_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_BY_UNIT_GROUP_MAX_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_BY_UNIT_GROUP_MAX_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_BY_UNIT_GROUP_MAX_TIMEZONE_NAME_ASC = 'FACILITIES_BY_UNIT_GROUP_MAX_TIMEZONE_NAME_ASC',
  FACILITIES_BY_UNIT_GROUP_MAX_TIMEZONE_NAME_DESC = 'FACILITIES_BY_UNIT_GROUP_MAX_TIMEZONE_NAME_DESC',
  FACILITIES_BY_UNIT_GROUP_MAX_UNIT_GROUP_ASC = 'FACILITIES_BY_UNIT_GROUP_MAX_UNIT_GROUP_ASC',
  FACILITIES_BY_UNIT_GROUP_MAX_UNIT_GROUP_DESC = 'FACILITIES_BY_UNIT_GROUP_MAX_UNIT_GROUP_DESC',
  FACILITIES_BY_UNIT_GROUP_MAX_UPDATED_AT_ASC = 'FACILITIES_BY_UNIT_GROUP_MAX_UPDATED_AT_ASC',
  FACILITIES_BY_UNIT_GROUP_MAX_UPDATED_AT_DESC = 'FACILITIES_BY_UNIT_GROUP_MAX_UPDATED_AT_DESC',
  FACILITIES_BY_UNIT_GROUP_MAX_ZIP_ASC = 'FACILITIES_BY_UNIT_GROUP_MAX_ZIP_ASC',
  FACILITIES_BY_UNIT_GROUP_MAX_ZIP_DESC = 'FACILITIES_BY_UNIT_GROUP_MAX_ZIP_DESC',
  FACILITIES_BY_UNIT_GROUP_MIN_ADDRESS_ASC = 'FACILITIES_BY_UNIT_GROUP_MIN_ADDRESS_ASC',
  FACILITIES_BY_UNIT_GROUP_MIN_ADDRESS_DESC = 'FACILITIES_BY_UNIT_GROUP_MIN_ADDRESS_DESC',
  FACILITIES_BY_UNIT_GROUP_MIN_BONUS_LTR_ASC = 'FACILITIES_BY_UNIT_GROUP_MIN_BONUS_LTR_ASC',
  FACILITIES_BY_UNIT_GROUP_MIN_BONUS_LTR_DESC = 'FACILITIES_BY_UNIT_GROUP_MIN_BONUS_LTR_DESC',
  FACILITIES_BY_UNIT_GROUP_MIN_CITY_ASC = 'FACILITIES_BY_UNIT_GROUP_MIN_CITY_ASC',
  FACILITIES_BY_UNIT_GROUP_MIN_CITY_DESC = 'FACILITIES_BY_UNIT_GROUP_MIN_CITY_DESC',
  FACILITIES_BY_UNIT_GROUP_MIN_CONTXT_9249_ASC = 'FACILITIES_BY_UNIT_GROUP_MIN_CONTXT_9249_ASC',
  FACILITIES_BY_UNIT_GROUP_MIN_CONTXT_9249_DESC = 'FACILITIES_BY_UNIT_GROUP_MIN_CONTXT_9249_DESC',
  FACILITIES_BY_UNIT_GROUP_MIN_COUNTRY_ASC = 'FACILITIES_BY_UNIT_GROUP_MIN_COUNTRY_ASC',
  FACILITIES_BY_UNIT_GROUP_MIN_COUNTRY_DESC = 'FACILITIES_BY_UNIT_GROUP_MIN_COUNTRY_DESC',
  FACILITIES_BY_UNIT_GROUP_MIN_CREATED_AT_ASC = 'FACILITIES_BY_UNIT_GROUP_MIN_CREATED_AT_ASC',
  FACILITIES_BY_UNIT_GROUP_MIN_CREATED_AT_DESC = 'FACILITIES_BY_UNIT_GROUP_MIN_CREATED_AT_DESC',
  FACILITIES_BY_UNIT_GROUP_MIN_DATATYPE_1_TEST_ASC = 'FACILITIES_BY_UNIT_GROUP_MIN_DATATYPE_1_TEST_ASC',
  FACILITIES_BY_UNIT_GROUP_MIN_DATATYPE_1_TEST_DESC = 'FACILITIES_BY_UNIT_GROUP_MIN_DATATYPE_1_TEST_DESC',
  FACILITIES_BY_UNIT_GROUP_MIN_DATA_TYPE_2_TEST_ASC = 'FACILITIES_BY_UNIT_GROUP_MIN_DATA_TYPE_2_TEST_ASC',
  FACILITIES_BY_UNIT_GROUP_MIN_DATA_TYPE_2_TEST_DESC = 'FACILITIES_BY_UNIT_GROUP_MIN_DATA_TYPE_2_TEST_DESC',
  FACILITIES_BY_UNIT_GROUP_MIN_DATA_TYPE_3_TEST_ASC = 'FACILITIES_BY_UNIT_GROUP_MIN_DATA_TYPE_3_TEST_ASC',
  FACILITIES_BY_UNIT_GROUP_MIN_DATA_TYPE_3_TEST_DESC = 'FACILITIES_BY_UNIT_GROUP_MIN_DATA_TYPE_3_TEST_DESC',
  FACILITIES_BY_UNIT_GROUP_MIN_FACILITY_CONTACTS_ASC = 'FACILITIES_BY_UNIT_GROUP_MIN_FACILITY_CONTACTS_ASC',
  FACILITIES_BY_UNIT_GROUP_MIN_FACILITY_CONTACTS_DESC = 'FACILITIES_BY_UNIT_GROUP_MIN_FACILITY_CONTACTS_DESC',
  FACILITIES_BY_UNIT_GROUP_MIN_GEOMETRY_ASC = 'FACILITIES_BY_UNIT_GROUP_MIN_GEOMETRY_ASC',
  FACILITIES_BY_UNIT_GROUP_MIN_GEOMETRY_DESC = 'FACILITIES_BY_UNIT_GROUP_MIN_GEOMETRY_DESC',
  FACILITIES_BY_UNIT_GROUP_MIN_ID_ASC = 'FACILITIES_BY_UNIT_GROUP_MIN_ID_ASC',
  FACILITIES_BY_UNIT_GROUP_MIN_ID_DESC = 'FACILITIES_BY_UNIT_GROUP_MIN_ID_DESC',
  FACILITIES_BY_UNIT_GROUP_MIN_LATITUDE_ASC = 'FACILITIES_BY_UNIT_GROUP_MIN_LATITUDE_ASC',
  FACILITIES_BY_UNIT_GROUP_MIN_LATITUDE_DESC = 'FACILITIES_BY_UNIT_GROUP_MIN_LATITUDE_DESC',
  FACILITIES_BY_UNIT_GROUP_MIN_LINK_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_MIN_LINK_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_MIN_LINK_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_MIN_LINK_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_MIN_LONGITUDE_ASC = 'FACILITIES_BY_UNIT_GROUP_MIN_LONGITUDE_ASC',
  FACILITIES_BY_UNIT_GROUP_MIN_LONGITUDE_DESC = 'FACILITIES_BY_UNIT_GROUP_MIN_LONGITUDE_DESC',
  FACILITIES_BY_UNIT_GROUP_MIN_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_MIN_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_MIN_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_MIN_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_MIN_NAME_ASC = 'FACILITIES_BY_UNIT_GROUP_MIN_NAME_ASC',
  FACILITIES_BY_UNIT_GROUP_MIN_NAME_DESC = 'FACILITIES_BY_UNIT_GROUP_MIN_NAME_DESC',
  FACILITIES_BY_UNIT_GROUP_MIN_NOTE_ASC = 'FACILITIES_BY_UNIT_GROUP_MIN_NOTE_ASC',
  FACILITIES_BY_UNIT_GROUP_MIN_NOTE_DESC = 'FACILITIES_BY_UNIT_GROUP_MIN_NOTE_DESC',
  FACILITIES_BY_UNIT_GROUP_MIN_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_MIN_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_MIN_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_MIN_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_MIN_N_SIGHT_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_MIN_N_SIGHT_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_MIN_N_SIGHT_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_MIN_N_SIGHT_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_MIN_PRE_BONUS_EBITDA_ASC = 'FACILITIES_BY_UNIT_GROUP_MIN_PRE_BONUS_EBITDA_ASC',
  FACILITIES_BY_UNIT_GROUP_MIN_PRE_BONUS_EBITDA_DESC = 'FACILITIES_BY_UNIT_GROUP_MIN_PRE_BONUS_EBITDA_DESC',
  FACILITIES_BY_UNIT_GROUP_MIN_PRICING_NODE_ID_ASC = 'FACILITIES_BY_UNIT_GROUP_MIN_PRICING_NODE_ID_ASC',
  FACILITIES_BY_UNIT_GROUP_MIN_PRICING_NODE_ID_DESC = 'FACILITIES_BY_UNIT_GROUP_MIN_PRICING_NODE_ID_DESC',
  FACILITIES_BY_UNIT_GROUP_MIN_REAL_TIME_ENABLED_ASC = 'FACILITIES_BY_UNIT_GROUP_MIN_REAL_TIME_ENABLED_ASC',
  FACILITIES_BY_UNIT_GROUP_MIN_REAL_TIME_ENABLED_DESC = 'FACILITIES_BY_UNIT_GROUP_MIN_REAL_TIME_ENABLED_DESC',
  FACILITIES_BY_UNIT_GROUP_MIN_REFRIGERATIONVENDOR_ASC = 'FACILITIES_BY_UNIT_GROUP_MIN_REFRIGERATIONVENDOR_ASC',
  FACILITIES_BY_UNIT_GROUP_MIN_REFRIGERATIONVENDOR_DESC = 'FACILITIES_BY_UNIT_GROUP_MIN_REFRIGERATIONVENDOR_DESC',
  FACILITIES_BY_UNIT_GROUP_MIN_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_BY_UNIT_GROUP_MIN_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_BY_UNIT_GROUP_MIN_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_BY_UNIT_GROUP_MIN_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_BY_UNIT_GROUP_MIN_RETIRED_AT_ASC = 'FACILITIES_BY_UNIT_GROUP_MIN_RETIRED_AT_ASC',
  FACILITIES_BY_UNIT_GROUP_MIN_RETIRED_AT_DESC = 'FACILITIES_BY_UNIT_GROUP_MIN_RETIRED_AT_DESC',
  FACILITIES_BY_UNIT_GROUP_MIN_SLUG_ASC = 'FACILITIES_BY_UNIT_GROUP_MIN_SLUG_ASC',
  FACILITIES_BY_UNIT_GROUP_MIN_SLUG_DESC = 'FACILITIES_BY_UNIT_GROUP_MIN_SLUG_DESC',
  FACILITIES_BY_UNIT_GROUP_MIN_STATE_ASC = 'FACILITIES_BY_UNIT_GROUP_MIN_STATE_ASC',
  FACILITIES_BY_UNIT_GROUP_MIN_STATE_DESC = 'FACILITIES_BY_UNIT_GROUP_MIN_STATE_DESC',
  FACILITIES_BY_UNIT_GROUP_MIN_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_BY_UNIT_GROUP_MIN_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_BY_UNIT_GROUP_MIN_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_BY_UNIT_GROUP_MIN_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_BY_UNIT_GROUP_MIN_TIMEZONE_NAME_ASC = 'FACILITIES_BY_UNIT_GROUP_MIN_TIMEZONE_NAME_ASC',
  FACILITIES_BY_UNIT_GROUP_MIN_TIMEZONE_NAME_DESC = 'FACILITIES_BY_UNIT_GROUP_MIN_TIMEZONE_NAME_DESC',
  FACILITIES_BY_UNIT_GROUP_MIN_UNIT_GROUP_ASC = 'FACILITIES_BY_UNIT_GROUP_MIN_UNIT_GROUP_ASC',
  FACILITIES_BY_UNIT_GROUP_MIN_UNIT_GROUP_DESC = 'FACILITIES_BY_UNIT_GROUP_MIN_UNIT_GROUP_DESC',
  FACILITIES_BY_UNIT_GROUP_MIN_UPDATED_AT_ASC = 'FACILITIES_BY_UNIT_GROUP_MIN_UPDATED_AT_ASC',
  FACILITIES_BY_UNIT_GROUP_MIN_UPDATED_AT_DESC = 'FACILITIES_BY_UNIT_GROUP_MIN_UPDATED_AT_DESC',
  FACILITIES_BY_UNIT_GROUP_MIN_ZIP_ASC = 'FACILITIES_BY_UNIT_GROUP_MIN_ZIP_ASC',
  FACILITIES_BY_UNIT_GROUP_MIN_ZIP_DESC = 'FACILITIES_BY_UNIT_GROUP_MIN_ZIP_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_ADDRESS_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_ADDRESS_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_ADDRESS_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_ADDRESS_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_BONUS_LTR_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_BONUS_LTR_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_BONUS_LTR_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_BONUS_LTR_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_CITY_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_CITY_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_CITY_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_CITY_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_CONTXT_9249_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_CONTXT_9249_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_CONTXT_9249_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_CONTXT_9249_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_COUNTRY_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_COUNTRY_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_COUNTRY_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_COUNTRY_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_CREATED_AT_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_CREATED_AT_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_CREATED_AT_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_CREATED_AT_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_DATATYPE_1_TEST_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_DATATYPE_1_TEST_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_DATATYPE_1_TEST_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_DATATYPE_1_TEST_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_DATA_TYPE_2_TEST_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_DATA_TYPE_2_TEST_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_DATA_TYPE_2_TEST_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_DATA_TYPE_2_TEST_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_DATA_TYPE_3_TEST_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_DATA_TYPE_3_TEST_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_DATA_TYPE_3_TEST_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_DATA_TYPE_3_TEST_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_FACILITY_CONTACTS_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_FACILITY_CONTACTS_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_FACILITY_CONTACTS_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_FACILITY_CONTACTS_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_GEOMETRY_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_GEOMETRY_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_GEOMETRY_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_GEOMETRY_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_ID_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_ID_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_ID_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_ID_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_LATITUDE_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_LATITUDE_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_LATITUDE_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_LATITUDE_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_LINK_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_LINK_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_LINK_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_LINK_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_LONGITUDE_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_LONGITUDE_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_LONGITUDE_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_LONGITUDE_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_NAME_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_NAME_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_NAME_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_NAME_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_NOTE_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_NOTE_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_NOTE_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_NOTE_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_N_SIGHT_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_N_SIGHT_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_N_SIGHT_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_N_SIGHT_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_PRE_BONUS_EBITDA_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_PRE_BONUS_EBITDA_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_PRE_BONUS_EBITDA_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_PRE_BONUS_EBITDA_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_PRICING_NODE_ID_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_PRICING_NODE_ID_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_PRICING_NODE_ID_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_PRICING_NODE_ID_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_REAL_TIME_ENABLED_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_REAL_TIME_ENABLED_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_REAL_TIME_ENABLED_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_REAL_TIME_ENABLED_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_REFRIGERATIONVENDOR_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_REFRIGERATIONVENDOR_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_REFRIGERATIONVENDOR_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_REFRIGERATIONVENDOR_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_RETIRED_AT_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_RETIRED_AT_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_RETIRED_AT_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_RETIRED_AT_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_SLUG_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_SLUG_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_SLUG_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_SLUG_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_STATE_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_STATE_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_STATE_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_STATE_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_TIMEZONE_NAME_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_TIMEZONE_NAME_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_TIMEZONE_NAME_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_TIMEZONE_NAME_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_UNIT_GROUP_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_UNIT_GROUP_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_UNIT_GROUP_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_UNIT_GROUP_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_UPDATED_AT_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_UPDATED_AT_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_UPDATED_AT_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_UPDATED_AT_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_ZIP_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_ZIP_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_ZIP_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_POPULATION_ZIP_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_ADDRESS_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_ADDRESS_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_ADDRESS_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_ADDRESS_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_BONUS_LTR_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_BONUS_LTR_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_BONUS_LTR_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_BONUS_LTR_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_CITY_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_CITY_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_CITY_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_CITY_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_CONTXT_9249_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_CONTXT_9249_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_CONTXT_9249_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_CONTXT_9249_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_COUNTRY_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_COUNTRY_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_COUNTRY_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_COUNTRY_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_CREATED_AT_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_CREATED_AT_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_CREATED_AT_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_CREATED_AT_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_DATATYPE_1_TEST_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_DATATYPE_1_TEST_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_DATATYPE_1_TEST_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_DATATYPE_1_TEST_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_DATA_TYPE_2_TEST_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_DATA_TYPE_2_TEST_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_DATA_TYPE_2_TEST_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_DATA_TYPE_2_TEST_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_DATA_TYPE_3_TEST_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_DATA_TYPE_3_TEST_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_DATA_TYPE_3_TEST_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_DATA_TYPE_3_TEST_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_FACILITY_CONTACTS_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_FACILITY_CONTACTS_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_FACILITY_CONTACTS_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_FACILITY_CONTACTS_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_GEOMETRY_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_GEOMETRY_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_GEOMETRY_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_GEOMETRY_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_ID_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_ID_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_ID_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_ID_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_LATITUDE_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_LATITUDE_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_LATITUDE_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_LATITUDE_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_LINK_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_LINK_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_LINK_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_LINK_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_LONGITUDE_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_LONGITUDE_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_LONGITUDE_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_LONGITUDE_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_NAME_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_NAME_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_NAME_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_NAME_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_NOTE_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_NOTE_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_NOTE_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_NOTE_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_N_SIGHT_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_N_SIGHT_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_N_SIGHT_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_N_SIGHT_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_PRE_BONUS_EBITDA_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_PRE_BONUS_EBITDA_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_PRE_BONUS_EBITDA_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_PRE_BONUS_EBITDA_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_PRICING_NODE_ID_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_PRICING_NODE_ID_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_PRICING_NODE_ID_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_PRICING_NODE_ID_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_REAL_TIME_ENABLED_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_REAL_TIME_ENABLED_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_REAL_TIME_ENABLED_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_REAL_TIME_ENABLED_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_REFRIGERATIONVENDOR_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_REFRIGERATIONVENDOR_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_REFRIGERATIONVENDOR_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_REFRIGERATIONVENDOR_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_RETIRED_AT_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_RETIRED_AT_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_RETIRED_AT_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_RETIRED_AT_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_SLUG_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_SLUG_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_SLUG_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_SLUG_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_STATE_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_STATE_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_STATE_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_STATE_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_TIMEZONE_NAME_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_TIMEZONE_NAME_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_TIMEZONE_NAME_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_TIMEZONE_NAME_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_UNIT_GROUP_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_UNIT_GROUP_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_UNIT_GROUP_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_UNIT_GROUP_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_UPDATED_AT_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_UPDATED_AT_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_UPDATED_AT_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_UPDATED_AT_DESC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_ZIP_ASC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_ZIP_ASC',
  FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_ZIP_DESC = 'FACILITIES_BY_UNIT_GROUP_STDDEV_SAMPLE_ZIP_DESC',
  FACILITIES_BY_UNIT_GROUP_SUM_ADDRESS_ASC = 'FACILITIES_BY_UNIT_GROUP_SUM_ADDRESS_ASC',
  FACILITIES_BY_UNIT_GROUP_SUM_ADDRESS_DESC = 'FACILITIES_BY_UNIT_GROUP_SUM_ADDRESS_DESC',
  FACILITIES_BY_UNIT_GROUP_SUM_BONUS_LTR_ASC = 'FACILITIES_BY_UNIT_GROUP_SUM_BONUS_LTR_ASC',
  FACILITIES_BY_UNIT_GROUP_SUM_BONUS_LTR_DESC = 'FACILITIES_BY_UNIT_GROUP_SUM_BONUS_LTR_DESC',
  FACILITIES_BY_UNIT_GROUP_SUM_CITY_ASC = 'FACILITIES_BY_UNIT_GROUP_SUM_CITY_ASC',
  FACILITIES_BY_UNIT_GROUP_SUM_CITY_DESC = 'FACILITIES_BY_UNIT_GROUP_SUM_CITY_DESC',
  FACILITIES_BY_UNIT_GROUP_SUM_CONTXT_9249_ASC = 'FACILITIES_BY_UNIT_GROUP_SUM_CONTXT_9249_ASC',
  FACILITIES_BY_UNIT_GROUP_SUM_CONTXT_9249_DESC = 'FACILITIES_BY_UNIT_GROUP_SUM_CONTXT_9249_DESC',
  FACILITIES_BY_UNIT_GROUP_SUM_COUNTRY_ASC = 'FACILITIES_BY_UNIT_GROUP_SUM_COUNTRY_ASC',
  FACILITIES_BY_UNIT_GROUP_SUM_COUNTRY_DESC = 'FACILITIES_BY_UNIT_GROUP_SUM_COUNTRY_DESC',
  FACILITIES_BY_UNIT_GROUP_SUM_CREATED_AT_ASC = 'FACILITIES_BY_UNIT_GROUP_SUM_CREATED_AT_ASC',
  FACILITIES_BY_UNIT_GROUP_SUM_CREATED_AT_DESC = 'FACILITIES_BY_UNIT_GROUP_SUM_CREATED_AT_DESC',
  FACILITIES_BY_UNIT_GROUP_SUM_DATATYPE_1_TEST_ASC = 'FACILITIES_BY_UNIT_GROUP_SUM_DATATYPE_1_TEST_ASC',
  FACILITIES_BY_UNIT_GROUP_SUM_DATATYPE_1_TEST_DESC = 'FACILITIES_BY_UNIT_GROUP_SUM_DATATYPE_1_TEST_DESC',
  FACILITIES_BY_UNIT_GROUP_SUM_DATA_TYPE_2_TEST_ASC = 'FACILITIES_BY_UNIT_GROUP_SUM_DATA_TYPE_2_TEST_ASC',
  FACILITIES_BY_UNIT_GROUP_SUM_DATA_TYPE_2_TEST_DESC = 'FACILITIES_BY_UNIT_GROUP_SUM_DATA_TYPE_2_TEST_DESC',
  FACILITIES_BY_UNIT_GROUP_SUM_DATA_TYPE_3_TEST_ASC = 'FACILITIES_BY_UNIT_GROUP_SUM_DATA_TYPE_3_TEST_ASC',
  FACILITIES_BY_UNIT_GROUP_SUM_DATA_TYPE_3_TEST_DESC = 'FACILITIES_BY_UNIT_GROUP_SUM_DATA_TYPE_3_TEST_DESC',
  FACILITIES_BY_UNIT_GROUP_SUM_FACILITY_CONTACTS_ASC = 'FACILITIES_BY_UNIT_GROUP_SUM_FACILITY_CONTACTS_ASC',
  FACILITIES_BY_UNIT_GROUP_SUM_FACILITY_CONTACTS_DESC = 'FACILITIES_BY_UNIT_GROUP_SUM_FACILITY_CONTACTS_DESC',
  FACILITIES_BY_UNIT_GROUP_SUM_GEOMETRY_ASC = 'FACILITIES_BY_UNIT_GROUP_SUM_GEOMETRY_ASC',
  FACILITIES_BY_UNIT_GROUP_SUM_GEOMETRY_DESC = 'FACILITIES_BY_UNIT_GROUP_SUM_GEOMETRY_DESC',
  FACILITIES_BY_UNIT_GROUP_SUM_ID_ASC = 'FACILITIES_BY_UNIT_GROUP_SUM_ID_ASC',
  FACILITIES_BY_UNIT_GROUP_SUM_ID_DESC = 'FACILITIES_BY_UNIT_GROUP_SUM_ID_DESC',
  FACILITIES_BY_UNIT_GROUP_SUM_LATITUDE_ASC = 'FACILITIES_BY_UNIT_GROUP_SUM_LATITUDE_ASC',
  FACILITIES_BY_UNIT_GROUP_SUM_LATITUDE_DESC = 'FACILITIES_BY_UNIT_GROUP_SUM_LATITUDE_DESC',
  FACILITIES_BY_UNIT_GROUP_SUM_LINK_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_SUM_LINK_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_SUM_LINK_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_SUM_LINK_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_SUM_LONGITUDE_ASC = 'FACILITIES_BY_UNIT_GROUP_SUM_LONGITUDE_ASC',
  FACILITIES_BY_UNIT_GROUP_SUM_LONGITUDE_DESC = 'FACILITIES_BY_UNIT_GROUP_SUM_LONGITUDE_DESC',
  FACILITIES_BY_UNIT_GROUP_SUM_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_SUM_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_SUM_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_SUM_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_SUM_NAME_ASC = 'FACILITIES_BY_UNIT_GROUP_SUM_NAME_ASC',
  FACILITIES_BY_UNIT_GROUP_SUM_NAME_DESC = 'FACILITIES_BY_UNIT_GROUP_SUM_NAME_DESC',
  FACILITIES_BY_UNIT_GROUP_SUM_NOTE_ASC = 'FACILITIES_BY_UNIT_GROUP_SUM_NOTE_ASC',
  FACILITIES_BY_UNIT_GROUP_SUM_NOTE_DESC = 'FACILITIES_BY_UNIT_GROUP_SUM_NOTE_DESC',
  FACILITIES_BY_UNIT_GROUP_SUM_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_SUM_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_SUM_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_SUM_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_SUM_N_SIGHT_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_SUM_N_SIGHT_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_SUM_N_SIGHT_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_SUM_N_SIGHT_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_SUM_PRE_BONUS_EBITDA_ASC = 'FACILITIES_BY_UNIT_GROUP_SUM_PRE_BONUS_EBITDA_ASC',
  FACILITIES_BY_UNIT_GROUP_SUM_PRE_BONUS_EBITDA_DESC = 'FACILITIES_BY_UNIT_GROUP_SUM_PRE_BONUS_EBITDA_DESC',
  FACILITIES_BY_UNIT_GROUP_SUM_PRICING_NODE_ID_ASC = 'FACILITIES_BY_UNIT_GROUP_SUM_PRICING_NODE_ID_ASC',
  FACILITIES_BY_UNIT_GROUP_SUM_PRICING_NODE_ID_DESC = 'FACILITIES_BY_UNIT_GROUP_SUM_PRICING_NODE_ID_DESC',
  FACILITIES_BY_UNIT_GROUP_SUM_REAL_TIME_ENABLED_ASC = 'FACILITIES_BY_UNIT_GROUP_SUM_REAL_TIME_ENABLED_ASC',
  FACILITIES_BY_UNIT_GROUP_SUM_REAL_TIME_ENABLED_DESC = 'FACILITIES_BY_UNIT_GROUP_SUM_REAL_TIME_ENABLED_DESC',
  FACILITIES_BY_UNIT_GROUP_SUM_REFRIGERATIONVENDOR_ASC = 'FACILITIES_BY_UNIT_GROUP_SUM_REFRIGERATIONVENDOR_ASC',
  FACILITIES_BY_UNIT_GROUP_SUM_REFRIGERATIONVENDOR_DESC = 'FACILITIES_BY_UNIT_GROUP_SUM_REFRIGERATIONVENDOR_DESC',
  FACILITIES_BY_UNIT_GROUP_SUM_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_BY_UNIT_GROUP_SUM_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_BY_UNIT_GROUP_SUM_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_BY_UNIT_GROUP_SUM_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_BY_UNIT_GROUP_SUM_RETIRED_AT_ASC = 'FACILITIES_BY_UNIT_GROUP_SUM_RETIRED_AT_ASC',
  FACILITIES_BY_UNIT_GROUP_SUM_RETIRED_AT_DESC = 'FACILITIES_BY_UNIT_GROUP_SUM_RETIRED_AT_DESC',
  FACILITIES_BY_UNIT_GROUP_SUM_SLUG_ASC = 'FACILITIES_BY_UNIT_GROUP_SUM_SLUG_ASC',
  FACILITIES_BY_UNIT_GROUP_SUM_SLUG_DESC = 'FACILITIES_BY_UNIT_GROUP_SUM_SLUG_DESC',
  FACILITIES_BY_UNIT_GROUP_SUM_STATE_ASC = 'FACILITIES_BY_UNIT_GROUP_SUM_STATE_ASC',
  FACILITIES_BY_UNIT_GROUP_SUM_STATE_DESC = 'FACILITIES_BY_UNIT_GROUP_SUM_STATE_DESC',
  FACILITIES_BY_UNIT_GROUP_SUM_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_BY_UNIT_GROUP_SUM_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_BY_UNIT_GROUP_SUM_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_BY_UNIT_GROUP_SUM_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_BY_UNIT_GROUP_SUM_TIMEZONE_NAME_ASC = 'FACILITIES_BY_UNIT_GROUP_SUM_TIMEZONE_NAME_ASC',
  FACILITIES_BY_UNIT_GROUP_SUM_TIMEZONE_NAME_DESC = 'FACILITIES_BY_UNIT_GROUP_SUM_TIMEZONE_NAME_DESC',
  FACILITIES_BY_UNIT_GROUP_SUM_UNIT_GROUP_ASC = 'FACILITIES_BY_UNIT_GROUP_SUM_UNIT_GROUP_ASC',
  FACILITIES_BY_UNIT_GROUP_SUM_UNIT_GROUP_DESC = 'FACILITIES_BY_UNIT_GROUP_SUM_UNIT_GROUP_DESC',
  FACILITIES_BY_UNIT_GROUP_SUM_UPDATED_AT_ASC = 'FACILITIES_BY_UNIT_GROUP_SUM_UPDATED_AT_ASC',
  FACILITIES_BY_UNIT_GROUP_SUM_UPDATED_AT_DESC = 'FACILITIES_BY_UNIT_GROUP_SUM_UPDATED_AT_DESC',
  FACILITIES_BY_UNIT_GROUP_SUM_ZIP_ASC = 'FACILITIES_BY_UNIT_GROUP_SUM_ZIP_ASC',
  FACILITIES_BY_UNIT_GROUP_SUM_ZIP_DESC = 'FACILITIES_BY_UNIT_GROUP_SUM_ZIP_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_ADDRESS_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_ADDRESS_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_ADDRESS_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_ADDRESS_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_BONUS_LTR_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_BONUS_LTR_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_BONUS_LTR_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_BONUS_LTR_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_CITY_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_CITY_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_CITY_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_CITY_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_CONTXT_9249_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_CONTXT_9249_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_CONTXT_9249_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_CONTXT_9249_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_COUNTRY_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_COUNTRY_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_COUNTRY_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_COUNTRY_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_CREATED_AT_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_CREATED_AT_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_CREATED_AT_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_CREATED_AT_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_DATATYPE_1_TEST_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_DATATYPE_1_TEST_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_DATATYPE_1_TEST_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_DATATYPE_1_TEST_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_DATA_TYPE_2_TEST_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_DATA_TYPE_2_TEST_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_DATA_TYPE_2_TEST_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_DATA_TYPE_2_TEST_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_DATA_TYPE_3_TEST_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_DATA_TYPE_3_TEST_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_DATA_TYPE_3_TEST_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_DATA_TYPE_3_TEST_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_FACILITY_CONTACTS_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_FACILITY_CONTACTS_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_FACILITY_CONTACTS_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_FACILITY_CONTACTS_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_GEOMETRY_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_GEOMETRY_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_GEOMETRY_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_GEOMETRY_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_ID_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_ID_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_ID_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_ID_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_LATITUDE_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_LATITUDE_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_LATITUDE_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_LATITUDE_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_LINK_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_LINK_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_LINK_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_LINK_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_LONGITUDE_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_LONGITUDE_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_LONGITUDE_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_LONGITUDE_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_NAME_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_NAME_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_NAME_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_NAME_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_NOTE_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_NOTE_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_NOTE_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_NOTE_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_N_SIGHT_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_N_SIGHT_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_N_SIGHT_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_N_SIGHT_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_PRE_BONUS_EBITDA_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_PRE_BONUS_EBITDA_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_PRE_BONUS_EBITDA_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_PRE_BONUS_EBITDA_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_PRICING_NODE_ID_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_PRICING_NODE_ID_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_PRICING_NODE_ID_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_PRICING_NODE_ID_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_REAL_TIME_ENABLED_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_REAL_TIME_ENABLED_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_REAL_TIME_ENABLED_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_REAL_TIME_ENABLED_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_REFRIGERATIONVENDOR_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_REFRIGERATIONVENDOR_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_REFRIGERATIONVENDOR_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_REFRIGERATIONVENDOR_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_RETIRED_AT_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_RETIRED_AT_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_RETIRED_AT_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_RETIRED_AT_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_SLUG_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_SLUG_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_SLUG_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_SLUG_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_STATE_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_STATE_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_STATE_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_STATE_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_TIMEZONE_NAME_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_TIMEZONE_NAME_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_TIMEZONE_NAME_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_TIMEZONE_NAME_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_UNIT_GROUP_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_UNIT_GROUP_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_UNIT_GROUP_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_UNIT_GROUP_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_UPDATED_AT_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_UPDATED_AT_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_UPDATED_AT_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_UPDATED_AT_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_ZIP_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_ZIP_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_ZIP_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_POPULATION_ZIP_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_ADDRESS_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_ADDRESS_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_ADDRESS_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_ADDRESS_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_BONUS_LTR_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_BONUS_LTR_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_BONUS_LTR_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_BONUS_LTR_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_CITY_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_CITY_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_CITY_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_CITY_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_CONTXT_9249_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_CONTXT_9249_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_CONTXT_9249_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_CONTXT_9249_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_COUNTRY_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_COUNTRY_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_COUNTRY_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_COUNTRY_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_CREATED_AT_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_CREATED_AT_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_CREATED_AT_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_CREATED_AT_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_DATATYPE_1_TEST_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_DATATYPE_1_TEST_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_DATATYPE_1_TEST_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_DATATYPE_1_TEST_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_DATA_TYPE_2_TEST_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_DATA_TYPE_2_TEST_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_DATA_TYPE_2_TEST_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_DATA_TYPE_2_TEST_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_DATA_TYPE_3_TEST_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_DATA_TYPE_3_TEST_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_DATA_TYPE_3_TEST_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_DATA_TYPE_3_TEST_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_FACILITY_CONTACTS_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_FACILITY_CONTACTS_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_FACILITY_CONTACTS_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_FACILITY_CONTACTS_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_GEOMETRY_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_GEOMETRY_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_GEOMETRY_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_GEOMETRY_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_ID_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_ID_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_ID_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_ID_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_LATITUDE_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_LATITUDE_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_LATITUDE_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_LATITUDE_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_LINK_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_LINK_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_LINK_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_LINK_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_LONGITUDE_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_LONGITUDE_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_LONGITUDE_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_LONGITUDE_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_NAME_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_NAME_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_NAME_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_NAME_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_NOTE_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_NOTE_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_NOTE_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_NOTE_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_N_SIGHT_ACTIVE_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_N_SIGHT_ACTIVE_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_N_SIGHT_ACTIVE_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_N_SIGHT_ACTIVE_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_PRE_BONUS_EBITDA_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_PRE_BONUS_EBITDA_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_PRE_BONUS_EBITDA_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_PRE_BONUS_EBITDA_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_PRICING_NODE_ID_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_PRICING_NODE_ID_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_PRICING_NODE_ID_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_PRICING_NODE_ID_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_REAL_TIME_ENABLED_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_REAL_TIME_ENABLED_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_REAL_TIME_ENABLED_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_REAL_TIME_ENABLED_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_REFRIGERATIONVENDOR_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_REFRIGERATIONVENDOR_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_REFRIGERATIONVENDOR_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_REFRIGERATIONVENDOR_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_RETIRED_AT_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_RETIRED_AT_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_RETIRED_AT_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_RETIRED_AT_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_SLUG_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_SLUG_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_SLUG_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_SLUG_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_STATE_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_STATE_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_STATE_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_STATE_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_TIMEZONE_NAME_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_TIMEZONE_NAME_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_TIMEZONE_NAME_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_TIMEZONE_NAME_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_UNIT_GROUP_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_UNIT_GROUP_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_UNIT_GROUP_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_UNIT_GROUP_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_UPDATED_AT_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_UPDATED_AT_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_UPDATED_AT_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_UPDATED_AT_DESC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_ZIP_ASC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_ZIP_ASC',
  FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_ZIP_DESC = 'FACILITIES_BY_UNIT_GROUP_VARIANCE_SAMPLE_ZIP_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** All input for the `updateAccountChargeByNodeId` mutation. */
export type UpdateAccountChargeByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `AccountCharge` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `AccountCharge` being updated. */
  patch: AccountChargePatch;
};

/** All input for the `updateAccountCharge` mutation. */
export type UpdateAccountChargeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `AccountCharge` being updated. */
  patch: AccountChargePatch;
};

/** The output of our update `AccountCharge` mutation. */
export type UpdateAccountChargePayload = {
  __typename?: 'UpdateAccountChargePayload';
  /** The `AccountCharge` that was updated by this mutation. */
  accountCharge?: Maybe<AccountCharge>;
  /** An edge for our `AccountCharge`. May be used by Relay 1. */
  accountChargeEdge?: Maybe<AccountChargesEdge>;
  /** Reads a single `AccountStatement` that is related to this `AccountCharge`. */
  accountStatement?: Maybe<AccountStatement>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `AccountCharge` mutation. */
export type UpdateAccountChargePayloadAccountChargeEdgeArgs = {
  orderBy?: InputMaybe<Array<AccountChargesOrderBy>>;
};

/** All input for the `updateAccountStatementByNodeId` mutation. */
export type UpdateAccountStatementByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `AccountStatement` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `AccountStatement` being updated. */
  patch: AccountStatementPatch;
};

/** All input for the `updateAccountStatement` mutation. */
export type UpdateAccountStatementInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `AccountStatement` being updated. */
  patch: AccountStatementPatch;
};

/** The output of our update `AccountStatement` mutation. */
export type UpdateAccountStatementPayload = {
  __typename?: 'UpdateAccountStatementPayload';
  /** The `AccountStatement` that was updated by this mutation. */
  accountStatement?: Maybe<AccountStatement>;
  /** An edge for our `AccountStatement`. May be used by Relay 1. */
  accountStatementEdge?: Maybe<AccountStatementsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UtilityAccount` that is related to this `AccountStatement`. */
  utilityAccount?: Maybe<UtilityAccount>;
};

/** The output of our update `AccountStatement` mutation. */
export type UpdateAccountStatementPayloadAccountStatementEdgeArgs = {
  orderBy?: InputMaybe<Array<AccountStatementsOrderBy>>;
};

/** All input for the `updateBalancingAuthorityByNodeId` mutation. */
export type UpdateBalancingAuthorityByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `BalancingAuthority` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `BalancingAuthority` being updated. */
  patch: BalancingAuthorityPatch;
};

/** All input for the `updateBalancingAuthorityBySlug` mutation. */
export type UpdateBalancingAuthorityBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `BalancingAuthority` being updated. */
  patch: BalancingAuthorityPatch;
  /** The slug identifier of the balancing authority. */
  slug: Scalars['String'];
};

/** All input for the `updateBalancingAuthority` mutation. */
export type UpdateBalancingAuthorityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The identifer of the balancing authority. */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `BalancingAuthority` being updated. */
  patch: BalancingAuthorityPatch;
};

/** The output of our update `BalancingAuthority` mutation. */
export type UpdateBalancingAuthorityPayload = {
  __typename?: 'UpdateBalancingAuthorityPayload';
  /** The `BalancingAuthority` that was updated by this mutation. */
  balancingAuthority?: Maybe<BalancingAuthority>;
  /** An edge for our `BalancingAuthority`. May be used by Relay 1. */
  balancingAuthorityEdge?: Maybe<BalancingAuthoritiesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `BalancingAuthority` mutation. */
export type UpdateBalancingAuthorityPayloadBalancingAuthorityEdgeArgs = {
  orderBy?: InputMaybe<Array<BalancingAuthoritiesOrderBy>>;
};

/** All input for the `updateBlastByLabelAndFacilityId` mutation. */
export type UpdateBlastByLabelAndFacilityIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The facility a blast is within */
  facilityId: Scalars['Int'];
  /** The unique local (facility-level) human-readable label of the blast */
  label: Scalars['String'];
  /** An object where the defined keys will be set on the `Blast` being updated. */
  patch: BlastPatch;
};

/** All input for the `updateBlastByNodeId` mutation. */
export type UpdateBlastByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Blast` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Blast` being updated. */
  patch: BlastPatch;
};

/** All input for the `updateBlastEvaporatorByNodeId` mutation. */
export type UpdateBlastEvaporatorByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `BlastEvaporator` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `BlastEvaporator` being updated. */
  patch: BlastEvaporatorPatch;
};

/** All input for the `updateBlastEvaporator` mutation. */
export type UpdateBlastEvaporatorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `BlastEvaporator` being updated. */
  patch: BlastEvaporatorPatch;
};

/** The output of our update `BlastEvaporator` mutation. */
export type UpdateBlastEvaporatorPayload = {
  __typename?: 'UpdateBlastEvaporatorPayload';
  /** Reads a single `Blast` that is related to this `BlastEvaporator`. */
  blast?: Maybe<Blast>;
  /** The `BlastEvaporator` that was updated by this mutation. */
  blastEvaporator?: Maybe<BlastEvaporator>;
  /** An edge for our `BlastEvaporator`. May be used by Relay 1. */
  blastEvaporatorEdge?: Maybe<BlastEvaporatorsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Evaporator` that is related to this `BlastEvaporator`. */
  evaporator?: Maybe<Evaporator>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `BlastEvaporator` mutation. */
export type UpdateBlastEvaporatorPayloadBlastEvaporatorEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastEvaporatorsOrderBy>>;
};

/** All input for the `updateBlast` mutation. */
export type UpdateBlastInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `Blast` being updated. */
  patch: BlastPatch;
};

/** All input for the `updateBlastPalletByNodeId` mutation. */
export type UpdateBlastPalletByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `BlastPallet` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `BlastPallet` being updated. */
  patch: BlastPalletPatch;
};

/** All input for the `updateBlastPallet` mutation. */
export type UpdateBlastPalletInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `BlastPallet` being updated. */
  patch: BlastPalletPatch;
};

/** All input for the `updateBlastPalletLocationByNodeId` mutation. */
export type UpdateBlastPalletLocationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `BlastPalletLocation` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `BlastPalletLocation` being updated. */
  patch: BlastPalletLocationPatch;
};

/** All input for the `updateBlastPalletLocation` mutation. */
export type UpdateBlastPalletLocationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `BlastPalletLocation` being updated. */
  patch: BlastPalletLocationPatch;
};

/** The output of our update `BlastPalletLocation` mutation. */
export type UpdateBlastPalletLocationPayload = {
  __typename?: 'UpdateBlastPalletLocationPayload';
  /** Reads a single `Blast` that is related to this `BlastPalletLocation`. */
  blast?: Maybe<Blast>;
  /** The `BlastPalletLocation` that was updated by this mutation. */
  blastPalletLocation?: Maybe<BlastPalletLocation>;
  /** An edge for our `BlastPalletLocation`. May be used by Relay 1. */
  blastPalletLocationEdge?: Maybe<BlastPalletLocationsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `PalletLocation` that is related to this `BlastPalletLocation`. */
  palletLocation?: Maybe<PalletLocation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `BlastPalletLocation` mutation. */
export type UpdateBlastPalletLocationPayloadBlastPalletLocationEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastPalletLocationsOrderBy>>;
};

/** The output of our update `BlastPallet` mutation. */
export type UpdateBlastPalletPayload = {
  __typename?: 'UpdateBlastPalletPayload';
  /** Reads a single `Blast` that is related to this `BlastPallet`. */
  blast?: Maybe<Blast>;
  /** The `BlastPallet` that was updated by this mutation. */
  blastPallet?: Maybe<BlastPallet>;
  /** An edge for our `BlastPallet`. May be used by Relay 1. */
  blastPalletEdge?: Maybe<BlastPalletsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Pallet` that is related to this `BlastPallet`. */
  pallet?: Maybe<Pallet>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `BlastPallet` mutation. */
export type UpdateBlastPalletPayloadBlastPalletEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastPalletsOrderBy>>;
};

/** The output of our update `Blast` mutation. */
export type UpdateBlastPayload = {
  __typename?: 'UpdateBlastPayload';
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  actualUtilization?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  automationState?: Maybe<DataPoint>;
  /** The `Blast` that was updated by this mutation. */
  blast?: Maybe<Blast>;
  /** An edge for our `Blast`. May be used by Relay 1. */
  blastEdge?: Maybe<BlastsEdge>;
  /** Reads a single `BlastType` that is related to this `Blast`. */
  blastType?: Maybe<BlastType>;
  /** Reads a single `BuildingArea` that is related to this `Blast`. */
  buildingArea?: Maybe<BuildingArea>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Component` that is related to this `Blast`. */
  component?: Maybe<Component>;
  /** Reads a single `Facility` that is related to this `Blast`. */
  facility?: Maybe<Facility>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  idealUtilization?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  stagingTimer?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  state?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  timer?: Maybe<DataPoint>;
};

/** The output of our update `Blast` mutation. */
export type UpdateBlastPayloadBlastEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastsOrderBy>>;
};

/** All input for the `updateBlastRotationAlertByNodeId` mutation. */
export type UpdateBlastRotationAlertByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `BlastRotationAlert` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `BlastRotationAlert` being updated. */
  patch: BlastRotationAlertPatch;
};

/** All input for the `updateBlastRotationAlert` mutation. */
export type UpdateBlastRotationAlertInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The identifer of the blast rotation alert */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `BlastRotationAlert` being updated. */
  patch: BlastRotationAlertPatch;
};

/** The output of our update `BlastRotationAlert` mutation. */
export type UpdateBlastRotationAlertPayload = {
  __typename?: 'UpdateBlastRotationAlertPayload';
  /** Reads a single `BlastRotation` that is related to this `BlastRotationAlert`. */
  blastRotation?: Maybe<BlastRotation>;
  /** The `BlastRotationAlert` that was updated by this mutation. */
  blastRotationAlert?: Maybe<BlastRotationAlert>;
  /** An edge for our `BlastRotationAlert`. May be used by Relay 1. */
  blastRotationAlertEdge?: Maybe<BlastRotationAlertsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `BlastRotationAlert` mutation. */
export type UpdateBlastRotationAlertPayloadBlastRotationAlertEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastRotationAlertsOrderBy>>;
};

/** All input for the `updateBlastRotationByNodeId` mutation. */
export type UpdateBlastRotationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `BlastRotation` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `BlastRotation` being updated. */
  patch: BlastRotationPatch;
};

/** All input for the `updateBlastRotationEventLogByBlastRotationIdAndDescriptionAndBlastRotationEventTypeId` mutation. */
export type UpdateBlastRotationEventLogByBlastRotationIdAndDescriptionAndBlastRotationEventTypeIdInput =
  {
    /** The type of event for this record */
    blastRotationEventTypeId: Scalars['String'];
    /** The associated blast rotation */
    blastRotationId: Scalars['Int'];
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars['String']>;
    /** A short description of the event */
    description: Scalars['String'];
    /** An object where the defined keys will be set on the `BlastRotationEventLog` being updated. */
    patch: BlastRotationEventLogPatch;
  };

/** All input for the `updateBlastRotationEventLogByNodeId` mutation. */
export type UpdateBlastRotationEventLogByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `BlastRotationEventLog` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `BlastRotationEventLog` being updated. */
  patch: BlastRotationEventLogPatch;
};

/** All input for the `updateBlastRotationEventLog` mutation. */
export type UpdateBlastRotationEventLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `BlastRotationEventLog` being updated. */
  patch: BlastRotationEventLogPatch;
};

/** The output of our update `BlastRotationEventLog` mutation. */
export type UpdateBlastRotationEventLogPayload = {
  __typename?: 'UpdateBlastRotationEventLogPayload';
  /** Reads a single `BlastRotation` that is related to this `BlastRotationEventLog`. */
  blastRotation?: Maybe<BlastRotation>;
  /** The `BlastRotationEventLog` that was updated by this mutation. */
  blastRotationEventLog?: Maybe<BlastRotationEventLog>;
  /** An edge for our `BlastRotationEventLog`. May be used by Relay 1. */
  blastRotationEventLogEdge?: Maybe<BlastRotationEventLogsEdge>;
  /** Reads a single `BlastRotationEventType` that is related to this `BlastRotationEventLog`. */
  blastRotationEventType?: Maybe<BlastRotationEventType>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `BlastRotationEventLog` mutation. */
export type UpdateBlastRotationEventLogPayloadBlastRotationEventLogEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastRotationEventLogsOrderBy>>;
};

/** All input for the `updateBlastRotationEventTypeByNodeId` mutation. */
export type UpdateBlastRotationEventTypeByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `BlastRotationEventType` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `BlastRotationEventType` being updated. */
  patch: BlastRotationEventTypePatch;
};

/** All input for the `updateBlastRotationEventType` mutation. */
export type UpdateBlastRotationEventTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** A unique, readable type of event that can occur within a blast rotation */
  eventType: Scalars['String'];
  /** An object where the defined keys will be set on the `BlastRotationEventType` being updated. */
  patch: BlastRotationEventTypePatch;
};

/** The output of our update `BlastRotationEventType` mutation. */
export type UpdateBlastRotationEventTypePayload = {
  __typename?: 'UpdateBlastRotationEventTypePayload';
  /** The `BlastRotationEventType` that was updated by this mutation. */
  blastRotationEventType?: Maybe<BlastRotationEventType>;
  /** An edge for our `BlastRotationEventType`. May be used by Relay 1. */
  blastRotationEventTypeEdge?: Maybe<BlastRotationEventTypesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `BlastRotationEventType` mutation. */
export type UpdateBlastRotationEventTypePayloadBlastRotationEventTypeEdgeArgs =
  {
    orderBy?: InputMaybe<Array<BlastRotationEventTypesOrderBy>>;
  };

/** All input for the `updateBlastRotation` mutation. */
export type UpdateBlastRotationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `BlastRotation` being updated. */
  patch: BlastRotationPatch;
};

/** All input for the `updateBlastRotationPalletByBlastRotationIdAndPalletId` mutation. */
export type UpdateBlastRotationPalletByBlastRotationIdAndPalletIdInput = {
  /** The associated blast rotation */
  blastRotationId: Scalars['Int'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The associated pallet */
  palletId: Scalars['Int'];
  /** An object where the defined keys will be set on the `BlastRotationPallet` being updated. */
  patch: BlastRotationPalletPatch;
};

/** All input for the `updateBlastRotationPalletByNodeId` mutation. */
export type UpdateBlastRotationPalletByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `BlastRotationPallet` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `BlastRotationPallet` being updated. */
  patch: BlastRotationPalletPatch;
};

/** All input for the `updateBlastRotationPallet` mutation. */
export type UpdateBlastRotationPalletInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `BlastRotationPallet` being updated. */
  patch: BlastRotationPalletPatch;
};

/** The output of our update `BlastRotationPallet` mutation. */
export type UpdateBlastRotationPalletPayload = {
  __typename?: 'UpdateBlastRotationPalletPayload';
  /** Reads a single `BlastRotation` that is related to this `BlastRotationPallet`. */
  blastRotation?: Maybe<BlastRotation>;
  /** The `BlastRotationPallet` that was updated by this mutation. */
  blastRotationPallet?: Maybe<BlastRotationPallet>;
  /** An edge for our `BlastRotationPallet`. May be used by Relay 1. */
  blastRotationPalletEdge?: Maybe<BlastRotationPalletsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Pallet` that is related to this `BlastRotationPallet`. */
  pallet?: Maybe<Pallet>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `BlastRotationPallet` mutation. */
export type UpdateBlastRotationPalletPayloadBlastRotationPalletEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastRotationPalletsOrderBy>>;
};

/** The output of our update `BlastRotation` mutation. */
export type UpdateBlastRotationPayload = {
  __typename?: 'UpdateBlastRotationPayload';
  /** Reads a single `Blast` that is related to this `BlastRotation`. */
  blast?: Maybe<Blast>;
  /** The `BlastRotation` that was updated by this mutation. */
  blastRotation?: Maybe<BlastRotation>;
  /** An edge for our `BlastRotation`. May be used by Relay 1. */
  blastRotationEdge?: Maybe<BlastRotationsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `BlastRotation` mutation. */
export type UpdateBlastRotationPayloadBlastRotationEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastRotationsOrderBy>>;
};

/** All input for the `updateBlastTypeByNodeId` mutation. */
export type UpdateBlastTypeByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `BlastType` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `BlastType` being updated. */
  patch: BlastTypePatch;
};

/** All input for the `updateBlastType` mutation. */
export type UpdateBlastTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `BlastType` being updated. */
  patch: BlastTypePatch;
};

/** The output of our update `BlastType` mutation. */
export type UpdateBlastTypePayload = {
  __typename?: 'UpdateBlastTypePayload';
  /** The `BlastType` that was updated by this mutation. */
  blastType?: Maybe<BlastType>;
  /** An edge for our `BlastType`. May be used by Relay 1. */
  blastTypeEdge?: Maybe<BlastTypesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `BlastType` mutation. */
export type UpdateBlastTypePayloadBlastTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastTypesOrderBy>>;
};

/** All input for the `updateBuildingAreaByFacilityIdAndLabel` mutation. */
export type UpdateBuildingAreaByFacilityIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** This represents the facility that the building area belongs to. */
  facilityId: Scalars['Int'];
  /** Human-readable label for the building area. */
  label: Scalars['String'];
  /** An object where the defined keys will be set on the `BuildingArea` being updated. */
  patch: BuildingAreaPatch;
};

/** All input for the `updateBuildingAreaByNodeId` mutation. */
export type UpdateBuildingAreaByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `BuildingArea` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `BuildingArea` being updated. */
  patch: BuildingAreaPatch;
};

/** All input for the `updateBuildingAreaComplianceGroupByBuildingAreaIdAndComplianceType` mutation. */
export type UpdateBuildingAreaComplianceGroupByBuildingAreaIdAndComplianceTypeInput =
  {
    /** The building area the compliance group applies to */
    buildingAreaId: Scalars['Int'];
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars['String']>;
    /** The type of compliance group for this relationship */
    complianceType: ComplianceType;
    /** An object where the defined keys will be set on the `BuildingAreaComplianceGroup` being updated. */
    patch: BuildingAreaComplianceGroupPatch;
  };

/** All input for the `updateBuildingAreaComplianceGroupByNodeId` mutation. */
export type UpdateBuildingAreaComplianceGroupByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `BuildingAreaComplianceGroup` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `BuildingAreaComplianceGroup` being updated. */
  patch: BuildingAreaComplianceGroupPatch;
};

/** All input for the `updateBuildingAreaComplianceGroup` mutation. */
export type UpdateBuildingAreaComplianceGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The id of the building area compliance group */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `BuildingAreaComplianceGroup` being updated. */
  patch: BuildingAreaComplianceGroupPatch;
};

/** The output of our update `BuildingAreaComplianceGroup` mutation. */
export type UpdateBuildingAreaComplianceGroupPayload = {
  __typename?: 'UpdateBuildingAreaComplianceGroupPayload';
  /** Reads a single `BuildingArea` that is related to this `BuildingAreaComplianceGroup`. */
  buildingArea?: Maybe<BuildingArea>;
  /** The `BuildingAreaComplianceGroup` that was updated by this mutation. */
  buildingAreaComplianceGroup?: Maybe<BuildingAreaComplianceGroup>;
  /** An edge for our `BuildingAreaComplianceGroup`. May be used by Relay 1. */
  buildingAreaComplianceGroupEdge?: Maybe<BuildingAreaComplianceGroupsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `ComplianceGroup` that is related to this `BuildingAreaComplianceGroup`. */
  complianceGroup?: Maybe<ComplianceGroup>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `BuildingAreaComplianceGroup` mutation. */
export type UpdateBuildingAreaComplianceGroupPayloadBuildingAreaComplianceGroupEdgeArgs =
  {
    orderBy?: InputMaybe<Array<BuildingAreaComplianceGroupsOrderBy>>;
  };

/** All input for the `updateBuildingArea` mutation. */
export type UpdateBuildingAreaInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `BuildingArea` being updated. */
  patch: BuildingAreaPatch;
};

/** The output of our update `BuildingArea` mutation. */
export type UpdateBuildingAreaPayload = {
  __typename?: 'UpdateBuildingAreaPayload';
  /** The `BuildingArea` that was updated by this mutation. */
  buildingArea?: Maybe<BuildingArea>;
  /** An edge for our `BuildingArea`. May be used by Relay 1. */
  buildingAreaEdge?: Maybe<BuildingAreasEdge>;
  /** Reads a single `BuildingAreaType` that is related to this `BuildingArea`. */
  buildingAreaType?: Maybe<BuildingAreaType>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Facility` that is related to this `BuildingArea`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `BuildingArea` mutation. */
export type UpdateBuildingAreaPayloadBuildingAreaEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingAreasOrderBy>>;
};

/** All input for the `updateBuildingAreaTypeByNodeId` mutation. */
export type UpdateBuildingAreaTypeByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `BuildingAreaType` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `BuildingAreaType` being updated. */
  patch: BuildingAreaTypePatch;
};

/** All input for the `updateBuildingAreaType` mutation. */
export type UpdateBuildingAreaTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `BuildingAreaType` being updated. */
  patch: BuildingAreaTypePatch;
  /** The short name of the building area type. */
  type: Scalars['String'];
};

/** The output of our update `BuildingAreaType` mutation. */
export type UpdateBuildingAreaTypePayload = {
  __typename?: 'UpdateBuildingAreaTypePayload';
  /** The `BuildingAreaType` that was updated by this mutation. */
  buildingAreaType?: Maybe<BuildingAreaType>;
  /** An edge for our `BuildingAreaType`. May be used by Relay 1. */
  buildingAreaTypeEdge?: Maybe<BuildingAreaTypesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `BuildingAreaType` mutation. */
export type UpdateBuildingAreaTypePayloadBuildingAreaTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingAreaTypesOrderBy>>;
};

/** All input for the `updateChartByNodeId` mutation. */
export type UpdateChartByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Chart` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Chart` being updated. */
  patch: ChartPatch;
};

/** All input for the `updateChart` mutation. */
export type UpdateChartInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `Chart` being updated. */
  patch: ChartPatch;
};

/** The output of our update `Chart` mutation. */
export type UpdateChartPayload = {
  __typename?: 'UpdateChartPayload';
  /** The `Chart` that was updated by this mutation. */
  chart?: Maybe<Chart>;
  /** An edge for our `Chart`. May be used by Relay 1. */
  chartEdge?: Maybe<ChartsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Facility` that is related to this `Chart`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `Chart` mutation. */
export type UpdateChartPayloadChartEdgeArgs = {
  orderBy?: InputMaybe<Array<ChartsOrderBy>>;
};

/** All input for the `updateComplianceGroupByLabel` mutation. */
export type UpdateComplianceGroupByLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The unique label of the compliance group (ex: Freezer, Cooler, Ice Cream Freezer) */
  label: Scalars['String'];
  /** An object where the defined keys will be set on the `ComplianceGroup` being updated. */
  patch: ComplianceGroupPatch;
};

/** All input for the `updateComplianceGroupByNodeId` mutation. */
export type UpdateComplianceGroupByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ComplianceGroup` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ComplianceGroup` being updated. */
  patch: ComplianceGroupPatch;
};

/** All input for the `updateComplianceGroup` mutation. */
export type UpdateComplianceGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The id of the compliance group */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `ComplianceGroup` being updated. */
  patch: ComplianceGroupPatch;
};

/** The output of our update `ComplianceGroup` mutation. */
export type UpdateComplianceGroupPayload = {
  __typename?: 'UpdateComplianceGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ComplianceGroup` that was updated by this mutation. */
  complianceGroup?: Maybe<ComplianceGroup>;
  /** An edge for our `ComplianceGroup`. May be used by Relay 1. */
  complianceGroupEdge?: Maybe<ComplianceGroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `ComplianceGroup` mutation. */
export type UpdateComplianceGroupPayloadComplianceGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<ComplianceGroupsOrderBy>>;
};

/** All input for the `updateComplianceRangeByComplianceGroupIdAndLabel` mutation. */
export type UpdateComplianceRangeByComplianceGroupIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The group this compliance range belongs to */
  complianceGroupId: Scalars['Int'];
  /** The unique label of the compliance range (ex: Out of Compliance, Above Compliance) */
  label: Scalars['String'];
  /** An object where the defined keys will be set on the `ComplianceRange` being updated. */
  patch: ComplianceRangePatch;
};

/** All input for the `updateComplianceRangeByNodeId` mutation. */
export type UpdateComplianceRangeByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ComplianceRange` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ComplianceRange` being updated. */
  patch: ComplianceRangePatch;
};

/** All input for the `updateComplianceRange` mutation. */
export type UpdateComplianceRangeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The id of the compliance range */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `ComplianceRange` being updated. */
  patch: ComplianceRangePatch;
};

/** The output of our update `ComplianceRange` mutation. */
export type UpdateComplianceRangePayload = {
  __typename?: 'UpdateComplianceRangePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `ComplianceGroup` that is related to this `ComplianceRange`. */
  complianceGroup?: Maybe<ComplianceGroup>;
  /** The `ComplianceRange` that was updated by this mutation. */
  complianceRange?: Maybe<ComplianceRange>;
  /** An edge for our `ComplianceRange`. May be used by Relay 1. */
  complianceRangeEdge?: Maybe<ComplianceRangesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `ComplianceRange` mutation. */
export type UpdateComplianceRangePayloadComplianceRangeEdgeArgs = {
  orderBy?: InputMaybe<Array<ComplianceRangesOrderBy>>;
};

/** All input for the `updateComponentByNodeId` mutation. */
export type UpdateComponentByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Component` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Component` being updated. */
  patch: ComponentPatch;
};

/** All input for the `updateComponent` mutation. */
export type UpdateComponentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The identifier of the component */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `Component` being updated. */
  patch: ComponentPatch;
};

/** The output of our update `Component` mutation. */
export type UpdateComponentPayload = {
  __typename?: 'UpdateComponentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Component` that was updated by this mutation. */
  component?: Maybe<Component>;
  /** An edge for our `Component`. May be used by Relay 1. */
  componentEdge?: Maybe<ComponentsEdge>;
  /** Reads a single `Facility` that is related to this `Component`. */
  facility?: Maybe<Facility>;
  /** Reads a single `MachineUser` that is related to this `Component`. */
  machineUser?: Maybe<MachineUser>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `Component` mutation. */
export type UpdateComponentPayloadComponentEdgeArgs = {
  orderBy?: InputMaybe<Array<ComponentsOrderBy>>;
};

/** All input for the `updateCompressorByFacilityIdAndLabel` mutation. */
export type UpdateCompressorByFacilityIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The facility a compressor is installed within */
  facilityId: Scalars['Int'];
  /** A human-readable label for a compressor */
  label: Scalars['String'];
  /** An object where the defined keys will be set on the `Compressor` being updated. */
  patch: CompressorPatch;
};

/** All input for the `updateCompressorByNodeId` mutation. */
export type UpdateCompressorByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Compressor` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Compressor` being updated. */
  patch: CompressorPatch;
};

/** All input for the `updateCompressor` mutation. */
export type UpdateCompressorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The id of the compressor. */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `Compressor` being updated. */
  patch: CompressorPatch;
};

/** The output of our update `Compressor` mutation. */
export type UpdateCompressorPayload = {
  __typename?: 'UpdateCompressorPayload';
  /** Reads a single `BuildingArea` that is related to this `Compressor`. */
  buildingArea?: Maybe<BuildingArea>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  capacity?: Maybe<DataPoint>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Compressor` that was updated by this mutation. */
  compressor?: Maybe<Compressor>;
  /** An edge for our `Compressor`. May be used by Relay 1. */
  compressorEdge?: Maybe<CompressorsEdge>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  controlMode?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  differentialPressure?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  dischargePressure?: Maybe<DataPoint>;
  /** Reads a single `Facility` that is related to this `Compressor`. */
  facility?: Maybe<Facility>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  kwDemand?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  motorAmps?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  motorState?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  oilPressure?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  oilTemperature?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  runtimeHours?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  setpoint?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  slideValvePosition?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  state?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  suctionPressure?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  suctionTemperature?: Maybe<DataPoint>;
};

/** The output of our update `Compressor` mutation. */
export type UpdateCompressorPayloadCompressorEdgeArgs = {
  orderBy?: InputMaybe<Array<CompressorsOrderBy>>;
};

/** All input for the `updateControlEventByNodeId` mutation. */
export type UpdateControlEventByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ControlEvent` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ControlEvent` being updated. */
  patch: ControlEventPatch;
};

/** All input for the `updateControlEvent` mutation. */
export type UpdateControlEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The identifier of the control event */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `ControlEvent` being updated. */
  patch: ControlEventPatch;
};

/** All input for the `updateControlEventLogByNodeId` mutation. */
export type UpdateControlEventLogByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ControlEventLog` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ControlEventLog` being updated. */
  patch: ControlEventLogPatch;
};

/** All input for the `updateControlEventLog` mutation. */
export type UpdateControlEventLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The identifier of the control event log entry */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `ControlEventLog` being updated. */
  patch: ControlEventLogPatch;
};

/** The output of our update `ControlEventLog` mutation. */
export type UpdateControlEventLogPayload = {
  __typename?: 'UpdateControlEventLogPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `ControlEvent` that is related to this `ControlEventLog`. */
  controlEvent?: Maybe<ControlEvent>;
  /** The `ControlEventLog` that was updated by this mutation. */
  controlEventLog?: Maybe<ControlEventLog>;
  /** An edge for our `ControlEventLog`. May be used by Relay 1. */
  controlEventLogEdge?: Maybe<ControlEventLogsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `ControlEventLog` mutation. */
export type UpdateControlEventLogPayloadControlEventLogEdgeArgs = {
  orderBy?: InputMaybe<Array<ControlEventLogsOrderBy>>;
};

/** The output of our update `ControlEvent` mutation. */
export type UpdateControlEventPayload = {
  __typename?: 'UpdateControlEventPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Component` that is related to this `ControlEvent`. */
  component?: Maybe<Component>;
  /** The `ControlEvent` that was updated by this mutation. */
  controlEvent?: Maybe<ControlEvent>;
  /** An edge for our `ControlEvent`. May be used by Relay 1. */
  controlEventEdge?: Maybe<ControlEventsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `ControlEvent` mutation. */
export type UpdateControlEventPayloadControlEventEdgeArgs = {
  orderBy?: InputMaybe<Array<ControlEventsOrderBy>>;
};

/** All input for the `updateCustomerByNodeId` mutation. */
export type UpdateCustomerByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Customer` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Customer` being updated. */
  patch: CustomerPatch;
};

/** All input for the `updateCustomerBySourceId` mutation. */
export type UpdateCustomerBySourceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Customer` being updated. */
  patch: CustomerPatch;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String'];
};

/** All input for the `updateCustomer` mutation. */
export type UpdateCustomerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['BigInt'];
  /** An object where the defined keys will be set on the `Customer` being updated. */
  patch: CustomerPatch;
};

/** The output of our update `Customer` mutation. */
export type UpdateCustomerPayload = {
  __typename?: 'UpdateCustomerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Customer` that was updated by this mutation. */
  customer?: Maybe<Customer>;
  /** An edge for our `Customer`. May be used by Relay 1. */
  customerEdge?: Maybe<CustomersEdge>;
  /** Reads a single `Facility` that is related to this `Customer`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `Customer` mutation. */
export type UpdateCustomerPayloadCustomerEdgeArgs = {
  orderBy?: InputMaybe<Array<CustomersOrderBy>>;
};

/** All input for the `updateDashboardByNodeId` mutation. */
export type UpdateDashboardByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Dashboard` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Dashboard` being updated. */
  patch: DashboardPatch;
};

/** All input for the `updateDashboard` mutation. */
export type UpdateDashboardInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `Dashboard` being updated. */
  patch: DashboardPatch;
};

/** The output of our update `Dashboard` mutation. */
export type UpdateDashboardPayload = {
  __typename?: 'UpdateDashboardPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Dashboard` that was updated by this mutation. */
  dashboard?: Maybe<Dashboard>;
  /** An edge for our `Dashboard`. May be used by Relay 1. */
  dashboardEdge?: Maybe<DashboardsEdge>;
  /** Reads a single `Facility` that is related to this `Dashboard`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `Dashboard` mutation. */
export type UpdateDashboardPayloadDashboardEdgeArgs = {
  orderBy?: InputMaybe<Array<DashboardsOrderBy>>;
};

/** All input for the `updateDataPointByDataSourceNameAndName` mutation. */
export type UpdateDataPointByDataSourceNameAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The name of the data source. */
  dataSourceName: Scalars['String'];
  /** The name of the data point. */
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `DataPoint` being updated. */
  patch: DataPointPatch;
};

/** All input for the `updateDataPointByNodeId` mutation. */
export type UpdateDataPointByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `DataPoint` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `DataPoint` being updated. */
  patch: DataPointPatch;
};

/** All input for the `updateDataPoint` mutation. */
export type UpdateDataPointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['BigInt'];
  /** An object where the defined keys will be set on the `DataPoint` being updated. */
  patch: DataPointPatch;
};

/** The output of our update `DataPoint` mutation. */
export type UpdateDataPointPayload = {
  __typename?: 'UpdateDataPointPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `DataPoint` that was updated by this mutation. */
  dataPoint?: Maybe<DataPoint>;
  /** An edge for our `DataPoint`. May be used by Relay 1. */
  dataPointEdge?: Maybe<DataPointsEdge>;
  /** Reads a single `DataSource` that is related to this `DataPoint`. */
  dataSourceByDataSourceName?: Maybe<DataSource>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `DataPoint` mutation. */
export type UpdateDataPointPayloadDataPointEdgeArgs = {
  orderBy?: InputMaybe<Array<DataPointsOrderBy>>;
};

/** All input for the `updateDependencyByNodeId` mutation. */
export type UpdateDependencyByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Dependency` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Dependency` being updated. */
  patch: DependencyPatch;
};

/** All input for the `updateDependencyByPath` mutation. */
export type UpdateDependencyByPathInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Dependency` being updated. */
  patch: DependencyPatch;
  path: Scalars['String'];
};

/** All input for the `updateDependency` mutation. */
export type UpdateDependencyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['BigInt'];
  /** An object where the defined keys will be set on the `Dependency` being updated. */
  patch: DependencyPatch;
};

/** The output of our update `Dependency` mutation. */
export type UpdateDependencyPayload = {
  __typename?: 'UpdateDependencyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Dependency` that was updated by this mutation. */
  dependency?: Maybe<Dependency>;
  /** An edge for our `Dependency`. May be used by Relay 1. */
  dependencyEdge?: Maybe<DependenciesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `Dependency` mutation. */
export type UpdateDependencyPayloadDependencyEdgeArgs = {
  orderBy?: InputMaybe<Array<DependenciesOrderBy>>;
};

/** All input for the `updateDoorByFacilityIdAndLabel` mutation. */
export type UpdateDoorByFacilityIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The facility where the door is located */
  facilityId: Scalars['Int'];
  /** The Human-readable label for the door */
  label: Scalars['String'];
  /** An object where the defined keys will be set on the `Door` being updated. */
  patch: DoorPatch;
};

/** All input for the `updateDoorByNodeId` mutation. */
export type UpdateDoorByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Door` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Door` being updated. */
  patch: DoorPatch;
};

/** All input for the `updateDoor` mutation. */
export type UpdateDoorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The id of the door */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `Door` being updated. */
  patch: DoorPatch;
};

/** The output of our update `Door` mutation. */
export type UpdateDoorPayload = {
  __typename?: 'UpdateDoorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Door` that was updated by this mutation. */
  door?: Maybe<Door>;
  /** An edge for our `Door`. May be used by Relay 1. */
  doorEdge?: Maybe<DoorsEdge>;
  /** Reads a single `DataPoint` that is related to this `Door`. */
  doorState?: Maybe<DataPoint>;
  /** Reads a single `Facility` that is related to this `Door`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `Door` mutation. */
export type UpdateDoorPayloadDoorEdgeArgs = {
  orderBy?: InputMaybe<Array<DoorsOrderBy>>;
};

/** All input for the `updateEvaporatorByFacilityIdAndLabel` mutation. */
export type UpdateEvaporatorByFacilityIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The facility an evaporator is installed within */
  facilityId: Scalars['Int'];
  /** A human-readable label */
  label: Scalars['String'];
  /** An object where the defined keys will be set on the `Evaporator` being updated. */
  patch: EvaporatorPatch;
};

/** All input for the `updateEvaporatorByNodeId` mutation. */
export type UpdateEvaporatorByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Evaporator` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Evaporator` being updated. */
  patch: EvaporatorPatch;
};

/** All input for the `updateEvaporator` mutation. */
export type UpdateEvaporatorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The id of the evaporator */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `Evaporator` being updated. */
  patch: EvaporatorPatch;
};

/** The output of our update `Evaporator` mutation. */
export type UpdateEvaporatorPayload = {
  __typename?: 'UpdateEvaporatorPayload';
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  ammoniaState?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  bleedSolenoid?: Maybe<DataPoint>;
  /** Reads a single `BuildingArea` that is related to this `Evaporator`. */
  buildingArea?: Maybe<BuildingArea>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  defrostState?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  defrostTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  defrostTimer?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  differentialAirTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  estimatedKwDemand?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  evapState?: Maybe<DataPoint>;
  /** The `Evaporator` that was updated by this mutation. */
  evaporator?: Maybe<Evaporator>;
  /** An edge for our `Evaporator`. May be used by Relay 1. */
  evaporatorEdge?: Maybe<EvaporatorsEdge>;
  /** Reads a single `Facility` that is related to this `Evaporator`. */
  facility?: Maybe<Facility>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  fanState?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  fanTimer?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  hotGasSolenoid?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  liquidFeedRuntime?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  liquidFeedRuntimeSetpoint?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  liquidSolenoid?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  returnAirTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  setpoint?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  softHotGasSolenoid?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  suctionSolenoid?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  suctionTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  supplyAirTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  zoneTemperature?: Maybe<DataPoint>;
};

/** The output of our update `Evaporator` mutation. */
export type UpdateEvaporatorPayloadEvaporatorEdgeArgs = {
  orderBy?: InputMaybe<Array<EvaporatorsOrderBy>>;
};

/** All input for the `updateFacilityByNodeId` mutation. */
export type UpdateFacilityByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Facility` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Facility` being updated. */
  patch: FacilityPatch;
};

/** All input for the `updateFacilityBySlug` mutation. */
export type UpdateFacilityBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Facility` being updated. */
  patch: FacilityPatch;
  /** The facility’s slug. */
  slug: Scalars['String'];
};

/** All input for the `updateFacilityGroupByNodeId` mutation. */
export type UpdateFacilityGroupByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `FacilityGroup` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `FacilityGroup` being updated. */
  patch: FacilityGroupPatch;
};

/** All input for the `updateFacilityGroup` mutation. */
export type UpdateFacilityGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The facility group’s id. */
  id: Scalars['BigInt'];
  /** An object where the defined keys will be set on the `FacilityGroup` being updated. */
  patch: FacilityGroupPatch;
};

/** The output of our update `FacilityGroup` mutation. */
export type UpdateFacilityGroupPayload = {
  __typename?: 'UpdateFacilityGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `FacilityGroup` that was updated by this mutation. */
  facilityGroup?: Maybe<FacilityGroup>;
  /** An edge for our `FacilityGroup`. May be used by Relay 1. */
  facilityGroupEdge?: Maybe<FacilityGroupsEdge>;
  /** Reads a single `FacilityGroup` that is related to this `FacilityGroup`. */
  parent?: Maybe<FacilityGroup>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `FacilityGroup` mutation. */
export type UpdateFacilityGroupPayloadFacilityGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<FacilityGroupsOrderBy>>;
};

/** All input for the `updateFacilityGroupsLinkerByNodeId` mutation. */
export type UpdateFacilityGroupsLinkerByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `FacilityGroupsLinker` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `FacilityGroupsLinker` being updated. */
  patch: FacilityGroupsLinkerPatch;
};

/** All input for the `updateFacilityGroupsLinker` mutation. */
export type UpdateFacilityGroupsLinkerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  facilityGroupingId: Scalars['BigInt'];
  facilityId: Scalars['Int'];
  /** An object where the defined keys will be set on the `FacilityGroupsLinker` being updated. */
  patch: FacilityGroupsLinkerPatch;
};

/** The output of our update `FacilityGroupsLinker` mutation. */
export type UpdateFacilityGroupsLinkerPayload = {
  __typename?: 'UpdateFacilityGroupsLinkerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Facility` that is related to this `FacilityGroupsLinker`. */
  facility?: Maybe<Facility>;
  /** Reads a single `FacilityGroup` that is related to this `FacilityGroupsLinker`. */
  facilityGrouping?: Maybe<FacilityGroup>;
  /** The `FacilityGroupsLinker` that was updated by this mutation. */
  facilityGroupsLinker?: Maybe<FacilityGroupsLinker>;
  /** An edge for our `FacilityGroupsLinker`. May be used by Relay 1. */
  facilityGroupsLinkerEdge?: Maybe<FacilityGroupsLinkersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `FacilityGroupsLinker` mutation. */
export type UpdateFacilityGroupsLinkerPayloadFacilityGroupsLinkerEdgeArgs = {
  orderBy?: InputMaybe<Array<FacilityGroupsLinkersOrderBy>>;
};

/** All input for the `updateFacility` mutation. */
export type UpdateFacilityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The primary unique identifier for the facility. */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `Facility` being updated. */
  patch: FacilityPatch;
};

/** The output of our update `Facility` mutation. */
export type UpdateFacilityPayload = {
  __typename?: 'UpdateFacilityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Facility` that was updated by this mutation. */
  facility?: Maybe<Facility>;
  /** An edge for our `Facility`. May be used by Relay 1. */
  facilityEdge?: Maybe<FacilitiesEdge>;
  /** Reads a single `PricingNode` that is related to this `Facility`. */
  pricingNode?: Maybe<PricingNode>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Timezone` that is related to this `Facility`. */
  timezone?: Maybe<Timezone>;
  /** Reads a single `UnitGroup` that is related to this `Facility`. */
  unitGroupByUnitGroup?: Maybe<UnitGroup>;
};

/** The output of our update `Facility` mutation. */
export type UpdateFacilityPayloadFacilityEdgeArgs = {
  orderBy?: InputMaybe<Array<FacilitiesOrderBy>>;
};

/** All input for the `updateFacilityTaggedDataPointByNodeId` mutation. */
export type UpdateFacilityTaggedDataPointByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `FacilityTaggedDataPoint` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `FacilityTaggedDataPoint` being updated. */
  patch: FacilityTaggedDataPointPatch;
};

/** All input for the `updateFacilityTaggedDataPoint` mutation. */
export type UpdateFacilityTaggedDataPointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `FacilityTaggedDataPoint` being updated. */
  patch: FacilityTaggedDataPointPatch;
};

/** The output of our update `FacilityTaggedDataPoint` mutation. */
export type UpdateFacilityTaggedDataPointPayload = {
  __typename?: 'UpdateFacilityTaggedDataPointPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `DataPoint` that is related to this `FacilityTaggedDataPoint`. */
  dataPoint?: Maybe<DataPoint>;
  /** Reads a single `Facility` that is related to this `FacilityTaggedDataPoint`. */
  facility?: Maybe<Facility>;
  /** The `FacilityTaggedDataPoint` that was updated by this mutation. */
  facilityTaggedDataPoint?: Maybe<FacilityTaggedDataPoint>;
  /** An edge for our `FacilityTaggedDataPoint`. May be used by Relay 1. */
  facilityTaggedDataPointEdge?: Maybe<FacilityTaggedDataPointsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPointTag` that is related to this `FacilityTaggedDataPoint`. */
  tag?: Maybe<DataPointTag>;
};

/** The output of our update `FacilityTaggedDataPoint` mutation. */
export type UpdateFacilityTaggedDataPointPayloadFacilityTaggedDataPointEdgeArgs =
  {
    orderBy?: InputMaybe<Array<FacilityTaggedDataPointsOrderBy>>;
  };

/** All input for the `updateInboundOutboundLoadByFacilityIdAndDirectionAndSourceId` mutation. */
export type UpdateInboundOutboundLoadByFacilityIdAndDirectionAndSourceIdInput =
  {
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars['String']>;
    /** The direction of load */
    direction: WmsLoadDirectionType;
    /** The facility where the order occurred */
    facilityId: Scalars['Int'];
    /** An object where the defined keys will be set on the `InboundOutboundLoad` being updated. */
    patch: InboundOutboundLoadPatch;
    /** The globally unique external identifier of the record from the original source system */
    sourceId: Scalars['String'];
  };

/** All input for the `updateInboundOutboundLoadByNodeId` mutation. */
export type UpdateInboundOutboundLoadByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `InboundOutboundLoad` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `InboundOutboundLoad` being updated. */
  patch: InboundOutboundLoadPatch;
};

/** All input for the `updateInboundOutboundLoad` mutation. */
export type UpdateInboundOutboundLoadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['BigInt'];
  /** An object where the defined keys will be set on the `InboundOutboundLoad` being updated. */
  patch: InboundOutboundLoadPatch;
};

/** The output of our update `InboundOutboundLoad` mutation. */
export type UpdateInboundOutboundLoadPayload = {
  __typename?: 'UpdateInboundOutboundLoadPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Facility` that is related to this `InboundOutboundLoad`. */
  facility?: Maybe<Facility>;
  /** The `InboundOutboundLoad` that was updated by this mutation. */
  inboundOutboundLoad?: Maybe<InboundOutboundLoad>;
  /** An edge for our `InboundOutboundLoad`. May be used by Relay 1. */
  inboundOutboundLoadEdge?: Maybe<InboundOutboundLoadsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `InboundOutboundLoad` mutation. */
export type UpdateInboundOutboundLoadPayloadInboundOutboundLoadEdgeArgs = {
  orderBy?: InputMaybe<Array<InboundOutboundLoadsOrderBy>>;
};

/** All input for the `updateMachineUserByNodeId` mutation. */
export type UpdateMachineUserByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `MachineUser` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `MachineUser` being updated. */
  patch: MachineUserPatch;
};

/** All input for the `updateMachineUser` mutation. */
export type UpdateMachineUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The identifier of the machine user. */
  id: Scalars['BigInt'];
  /** An object where the defined keys will be set on the `MachineUser` being updated. */
  patch: MachineUserPatch;
};

/** The output of our update `MachineUser` mutation. */
export type UpdateMachineUserPayload = {
  __typename?: 'UpdateMachineUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `MachineUser` that was updated by this mutation. */
  machineUser?: Maybe<MachineUser>;
  /** An edge for our `MachineUser`. May be used by Relay 1. */
  machineUserEdge?: Maybe<MachineUsersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `MachineUser` mutation. */
export type UpdateMachineUserPayloadMachineUserEdgeArgs = {
  orderBy?: InputMaybe<Array<MachineUsersOrderBy>>;
};

/** All input for the `updateMainServiceByFacilityIdAndName` mutation. */
export type UpdateMainServiceByFacilityIdAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The facility this main service belongs to */
  facilityId: Scalars['Int'];
  /** The name for this main service */
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `MainService` being updated. */
  patch: MainServicePatch;
};

/** All input for the `updateMainServiceByFacilityIdAndUsageDataPointIdAndDemandDataPointId` mutation. */
export type UpdateMainServiceByFacilityIdAndUsageDataPointIdAndDemandDataPointIdInput =
  {
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars['String']>;
    /** The demand data point that represents this main service's contribution to/from the facility */
    demandDataPointId: Scalars['Int'];
    /** The facility this main service belongs to */
    facilityId: Scalars['Int'];
    /** An object where the defined keys will be set on the `MainService` being updated. */
    patch: MainServicePatch;
    /** The usage data point that represents this main service's contribution to/from the facility */
    usageDataPointId: Scalars['Int'];
  };

/** All input for the `updateMainServiceByNodeId` mutation. */
export type UpdateMainServiceByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `MainService` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `MainService` being updated. */
  patch: MainServicePatch;
};

/** All input for the `updateMainService` mutation. */
export type UpdateMainServiceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The id of the main service */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `MainService` being updated. */
  patch: MainServicePatch;
};

/** The output of our update `MainService` mutation. */
export type UpdateMainServicePayload = {
  __typename?: 'UpdateMainServicePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  demand?: Maybe<DataPoint>;
  /** Reads a single `Facility` that is related to this `MainService`. */
  facility?: Maybe<Facility>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  gridDemand?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  gridUsage?: Maybe<DataPoint>;
  /** The `MainService` that was updated by this mutation. */
  mainService?: Maybe<MainService>;
  /** An edge for our `MainService`. May be used by Relay 1. */
  mainServiceEdge?: Maybe<MainServicesEdge>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  meterDemand?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  meterUsage?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  usage?: Maybe<DataPoint>;
};

/** The output of our update `MainService` mutation. */
export type UpdateMainServicePayloadMainServiceEdgeArgs = {
  orderBy?: InputMaybe<Array<MainServicesOrderBy>>;
};

/** All input for the `updateMeterChargeByNodeId` mutation. */
export type UpdateMeterChargeByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `MeterCharge` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `MeterCharge` being updated. */
  patch: MeterChargePatch;
};

/** All input for the `updateMeterCharge` mutation. */
export type UpdateMeterChargeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `MeterCharge` being updated. */
  patch: MeterChargePatch;
};

/** The output of our update `MeterCharge` mutation. */
export type UpdateMeterChargePayload = {
  __typename?: 'UpdateMeterChargePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `MeterCharge` that was updated by this mutation. */
  meterCharge?: Maybe<MeterCharge>;
  /** An edge for our `MeterCharge`. May be used by Relay 1. */
  meterChargeEdge?: Maybe<MeterChargesEdge>;
  /** Reads a single `MeterStatement` that is related to this `MeterCharge`. */
  meterStatement?: Maybe<MeterStatement>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `MeterCharge` mutation. */
export type UpdateMeterChargePayloadMeterChargeEdgeArgs = {
  orderBy?: InputMaybe<Array<MeterChargesOrderBy>>;
};

/** All input for the `updateMeterStatementByNodeId` mutation. */
export type UpdateMeterStatementByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `MeterStatement` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `MeterStatement` being updated. */
  patch: MeterStatementPatch;
};

/** All input for the `updateMeterStatement` mutation. */
export type UpdateMeterStatementInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `MeterStatement` being updated. */
  patch: MeterStatementPatch;
};

/** The output of our update `MeterStatement` mutation. */
export type UpdateMeterStatementPayload = {
  __typename?: 'UpdateMeterStatementPayload';
  /** Reads a single `AccountStatement` that is related to this `MeterStatement`. */
  accountStatement?: Maybe<AccountStatement>;
  /** Reads a single `AccountStatementPdf` that is related to this `MeterStatement`. */
  accountStatementPdf?: Maybe<AccountStatementPdf>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `MeterStatement` that was updated by this mutation. */
  meterStatement?: Maybe<MeterStatement>;
  /** An edge for our `MeterStatement`. May be used by Relay 1. */
  meterStatementEdge?: Maybe<MeterStatementsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UtilityMeter` that is related to this `MeterStatement`. */
  utilityMeter?: Maybe<UtilityMeter>;
};

/** The output of our update `MeterStatement` mutation. */
export type UpdateMeterStatementPayloadMeterStatementEdgeArgs = {
  orderBy?: InputMaybe<Array<MeterStatementsOrderBy>>;
};

/** All input for the `updateMeterUsageByNodeId` mutation. */
export type UpdateMeterUsageByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `MeterUsage` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `MeterUsage` being updated. */
  patch: MeterUsagePatch;
};

/** All input for the `updateMeterUsage` mutation. */
export type UpdateMeterUsageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `MeterUsage` being updated. */
  patch: MeterUsagePatch;
};

/** The output of our update `MeterUsage` mutation. */
export type UpdateMeterUsagePayload = {
  __typename?: 'UpdateMeterUsagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `MeterStatement` that is related to this `MeterUsage`. */
  meterStatement?: Maybe<MeterStatement>;
  /** The `MeterUsage` that was updated by this mutation. */
  meterUsage?: Maybe<MeterUsage>;
  /** An edge for our `MeterUsage`. May be used by Relay 1. */
  meterUsageEdge?: Maybe<MeterUsagesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `MeterUsage` mutation. */
export type UpdateMeterUsagePayloadMeterUsageEdgeArgs = {
  orderBy?: InputMaybe<Array<MeterUsagesOrderBy>>;
};

/** All input for the `updatePalletByNodeId` mutation. */
export type UpdatePalletByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Pallet` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Pallet` being updated. */
  patch: PalletPatch;
};

/** All input for the `updatePalletBySourceId` mutation. */
export type UpdatePalletBySourceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Pallet` being updated. */
  patch: PalletPatch;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String'];
};

/** All input for the `updatePalletHistoryByNodeId` mutation. */
export type UpdatePalletHistoryByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PalletHistory` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `PalletHistory` being updated. */
  patch: PalletHistoryPatch;
};

/** All input for the `updatePalletHistoryBySourceId` mutation. */
export type UpdatePalletHistoryBySourceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `PalletHistory` being updated. */
  patch: PalletHistoryPatch;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String'];
};

/** All input for the `updatePalletHistory` mutation. */
export type UpdatePalletHistoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['BigInt'];
  /** An object where the defined keys will be set on the `PalletHistory` being updated. */
  patch: PalletHistoryPatch;
};

/** The output of our update `PalletHistory` mutation. */
export type UpdatePalletHistoryPayload = {
  __typename?: 'UpdatePalletHistoryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `PalletHistory` that was updated by this mutation. */
  palletHistory?: Maybe<PalletHistory>;
  /** An edge for our `PalletHistory`. May be used by Relay 1. */
  palletHistoryEdge?: Maybe<PalletHistoriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `PalletHistory` mutation. */
export type UpdatePalletHistoryPayloadPalletHistoryEdgeArgs = {
  orderBy?: InputMaybe<Array<PalletHistoriesOrderBy>>;
};

/** All input for the `updatePallet` mutation. */
export type UpdatePalletInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['BigInt'];
  /** An object where the defined keys will be set on the `Pallet` being updated. */
  patch: PalletPatch;
};

/** All input for the `updatePalletLocationByNodeId` mutation. */
export type UpdatePalletLocationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PalletLocation` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `PalletLocation` being updated. */
  patch: PalletLocationPatch;
};

/** All input for the `updatePalletLocationBySourceId` mutation. */
export type UpdatePalletLocationBySourceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `PalletLocation` being updated. */
  patch: PalletLocationPatch;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String'];
};

/** All input for the `updatePalletLocation` mutation. */
export type UpdatePalletLocationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['BigInt'];
  /** An object where the defined keys will be set on the `PalletLocation` being updated. */
  patch: PalletLocationPatch;
};

/** The output of our update `PalletLocation` mutation. */
export type UpdatePalletLocationPayload = {
  __typename?: 'UpdatePalletLocationPayload';
  /** Reads a single `BuildingArea` that is related to this `PalletLocation`. */
  buildingArea?: Maybe<BuildingArea>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Facility` that is related to this `PalletLocation`. */
  facility?: Maybe<Facility>;
  /** The `PalletLocation` that was updated by this mutation. */
  palletLocation?: Maybe<PalletLocation>;
  /** An edge for our `PalletLocation`. May be used by Relay 1. */
  palletLocationEdge?: Maybe<PalletLocationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `PalletLocation` mutation. */
export type UpdatePalletLocationPayloadPalletLocationEdgeArgs = {
  orderBy?: InputMaybe<Array<PalletLocationsOrderBy>>;
};

/** The output of our update `Pallet` mutation. */
export type UpdatePalletPayload = {
  __typename?: 'UpdatePalletPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Pallet` that was updated by this mutation. */
  pallet?: Maybe<Pallet>;
  /** An edge for our `Pallet`. May be used by Relay 1. */
  palletEdge?: Maybe<PalletsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `Pallet` mutation. */
export type UpdatePalletPayloadPalletEdgeArgs = {
  orderBy?: InputMaybe<Array<PalletsOrderBy>>;
};

export type UpdatePhoneNumberInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  verificationCode: Scalars['String'];
};

export type UpdatePhoneNumberResponse = {
  __typename?: 'UpdatePhoneNumberResponse';
  clientMutationId?: Maybe<Scalars['String']>;
  user: User;
};

/** All input for the `updatePricingNodeByNodeId` mutation. */
export type UpdatePricingNodeByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PricingNode` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `PricingNode` being updated. */
  patch: PricingNodePatch;
};

/** All input for the `updatePricingNode` mutation. */
export type UpdatePricingNodeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The identifer of the pricing node. */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `PricingNode` being updated. */
  patch: PricingNodePatch;
};

/** The output of our update `PricingNode` mutation. */
export type UpdatePricingNodePayload = {
  __typename?: 'UpdatePricingNodePayload';
  /** Reads a single `BalancingAuthority` that is related to this `PricingNode`. */
  balancingAuthority?: Maybe<BalancingAuthority>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `PricingNode` that was updated by this mutation. */
  pricingNode?: Maybe<PricingNode>;
  /** An edge for our `PricingNode`. May be used by Relay 1. */
  pricingNodeEdge?: Maybe<PricingNodesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `PricingNode` mutation. */
export type UpdatePricingNodePayloadPricingNodeEdgeArgs = {
  orderBy?: InputMaybe<Array<PricingNodesOrderBy>>;
};

/** All input for the `updateProductByNodeId` mutation. */
export type UpdateProductByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Product` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Product` being updated. */
  patch: ProductPatch;
};

/** All input for the `updateProductBySourceId` mutation. */
export type UpdateProductBySourceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Product` being updated. */
  patch: ProductPatch;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String'];
};

/** All input for the `updateProduct` mutation. */
export type UpdateProductInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['BigInt'];
  /** An object where the defined keys will be set on the `Product` being updated. */
  patch: ProductPatch;
};

/** The output of our update `Product` mutation. */
export type UpdateProductPayload = {
  __typename?: 'UpdateProductPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Facility` that is related to this `Product`. */
  facility?: Maybe<Facility>;
  /** The `Product` that was updated by this mutation. */
  product?: Maybe<Product>;
  /** An edge for our `Product`. May be used by Relay 1. */
  productEdge?: Maybe<ProductsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `Product` mutation. */
export type UpdateProductPayloadProductEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};

/** All input for the `updateProgramByNodeId` mutation. */
export type UpdateProgramByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Program` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Program` being updated. */
  patch: ProgramPatch;
};

/** All input for the `updateProgramByProjectTypeIdAndName` mutation. */
export type UpdateProgramByProjectTypeIdAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The name of the program. */
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `Program` being updated. */
  patch: ProgramPatch;
  /** The id of the project type the program is associated with. */
  projectTypeId: Scalars['Int'];
};

/** All input for the `updateProgramEnrollmentByNodeId` mutation. */
export type UpdateProgramEnrollmentByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProgramEnrollment` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ProgramEnrollment` being updated. */
  patch: ProgramEnrollmentPatch;
};

/** All input for the `updateProgramEnrollmentByProgramIdAndName` mutation. */
export type UpdateProgramEnrollmentByProgramIdAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The name of this program enrollment. */
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `ProgramEnrollment` being updated. */
  patch: ProgramEnrollmentPatch;
  /** The program this program enrollment belongs to. */
  programId: Scalars['Int'];
};

/** All input for the `updateProgramEnrollment` mutation. */
export type UpdateProgramEnrollmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The identifer of the program enrollment. */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `ProgramEnrollment` being updated. */
  patch: ProgramEnrollmentPatch;
};

/** The output of our update `ProgramEnrollment` mutation. */
export type UpdateProgramEnrollmentPayload = {
  __typename?: 'UpdateProgramEnrollmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Program` that is related to this `ProgramEnrollment`. */
  program?: Maybe<Program>;
  /** The `ProgramEnrollment` that was updated by this mutation. */
  programEnrollment?: Maybe<ProgramEnrollment>;
  /** An edge for our `ProgramEnrollment`. May be used by Relay 1. */
  programEnrollmentEdge?: Maybe<ProgramEnrollmentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `ProgramEnrollment` mutation. */
export type UpdateProgramEnrollmentPayloadProgramEnrollmentEdgeArgs = {
  orderBy?: InputMaybe<Array<ProgramEnrollmentsOrderBy>>;
};

/** All input for the `updateProgram` mutation. */
export type UpdateProgramInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The identifer of the program. */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `Program` being updated. */
  patch: ProgramPatch;
};

/** The output of our update `Program` mutation. */
export type UpdateProgramPayload = {
  __typename?: 'UpdateProgramPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Program` that was updated by this mutation. */
  program?: Maybe<Program>;
  /** An edge for our `Program`. May be used by Relay 1. */
  programEdge?: Maybe<ProgramsEdge>;
  /** Reads a single `ProjectType` that is related to this `Program`. */
  projectType?: Maybe<ProjectType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `Program` mutation. */
export type UpdateProgramPayloadProgramEdgeArgs = {
  orderBy?: InputMaybe<Array<ProgramsOrderBy>>;
};

/** All input for the `updateProjectByFacilityIdAndProgramId` mutation. */
export type UpdateProjectByFacilityIdAndProgramIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The identifier of the facility. */
  facilityId: Scalars['Int'];
  /** An object where the defined keys will be set on the `Project` being updated. */
  patch: ProjectPatch;
  /** The id of the program the project is associated with */
  programId: Scalars['Int'];
};

/** All input for the `updateProjectByNodeId` mutation. */
export type UpdateProjectByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Project` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Project` being updated. */
  patch: ProjectPatch;
};

/** All input for the `updateProjectComponentByNodeId` mutation. */
export type UpdateProjectComponentByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProjectComponent` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ProjectComponent` being updated. */
  patch: ProjectComponentPatch;
};

/** All input for the `updateProjectComponent` mutation. */
export type UpdateProjectComponentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  componentId: Scalars['Int'];
  /** An object where the defined keys will be set on the `ProjectComponent` being updated. */
  patch: ProjectComponentPatch;
  projectId: Scalars['Int'];
};

/** The output of our update `ProjectComponent` mutation. */
export type UpdateProjectComponentPayload = {
  __typename?: 'UpdateProjectComponentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Component` that is related to this `ProjectComponent`. */
  component?: Maybe<Component>;
  /** Reads a single `Project` that is related to this `ProjectComponent`. */
  project?: Maybe<Project>;
  /** The `ProjectComponent` that was updated by this mutation. */
  projectComponent?: Maybe<ProjectComponent>;
  /** An edge for our `ProjectComponent`. May be used by Relay 1. */
  projectComponentEdge?: Maybe<ProjectComponentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `ProjectComponent` mutation. */
export type UpdateProjectComponentPayloadProjectComponentEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectComponentsOrderBy>>;
};

/** All input for the `updateProjectEnrollmentDataPointByNodeId` mutation. */
export type UpdateProjectEnrollmentDataPointByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProjectEnrollmentDataPoint` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ProjectEnrollmentDataPoint` being updated. */
  patch: ProjectEnrollmentDataPointPatch;
};

/** All input for the `updateProjectEnrollmentDataPointByProjectEnrollmentIdAndDataPointId` mutation. */
export type UpdateProjectEnrollmentDataPointByProjectEnrollmentIdAndDataPointIdInput =
  {
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars['String']>;
    /** The data point being referenced. */
    dataPointId: Scalars['Int'];
    /** An object where the defined keys will be set on the `ProjectEnrollmentDataPoint` being updated. */
    patch: ProjectEnrollmentDataPointPatch;
    /** The project enrollment this data point belongs to. */
    projectEnrollmentId: Scalars['Int'];
  };

/** All input for the `updateProjectEnrollmentDataPointGroupByNodeId` mutation. */
export type UpdateProjectEnrollmentDataPointGroupByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProjectEnrollmentDataPointGroup` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ProjectEnrollmentDataPointGroup` being updated. */
  patch: ProjectEnrollmentDataPointGroupPatch;
};

/** All input for the `updateProjectEnrollmentDataPointGroup` mutation. */
export type UpdateProjectEnrollmentDataPointGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The identifer of the project enrollment. */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `ProjectEnrollmentDataPointGroup` being updated. */
  patch: ProjectEnrollmentDataPointGroupPatch;
};

/** The output of our update `ProjectEnrollmentDataPointGroup` mutation. */
export type UpdateProjectEnrollmentDataPointGroupPayload = {
  __typename?: 'UpdateProjectEnrollmentDataPointGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ProjectEnrollmentDataPointGroup` that was updated by this mutation. */
  projectEnrollmentDataPointGroup?: Maybe<ProjectEnrollmentDataPointGroup>;
  /** An edge for our `ProjectEnrollmentDataPointGroup`. May be used by Relay 1. */
  projectEnrollmentDataPointGroupEdge?: Maybe<ProjectEnrollmentDataPointGroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `ProjectEnrollmentDataPointGroup` mutation. */
export type UpdateProjectEnrollmentDataPointGroupPayloadProjectEnrollmentDataPointGroupEdgeArgs =
  {
    orderBy?: InputMaybe<Array<ProjectEnrollmentDataPointGroupsOrderBy>>;
  };

/** All input for the `updateProjectEnrollmentDataPoint` mutation. */
export type UpdateProjectEnrollmentDataPointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The identifer of the project enrollment data point. */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `ProjectEnrollmentDataPoint` being updated. */
  patch: ProjectEnrollmentDataPointPatch;
};

/** The output of our update `ProjectEnrollmentDataPoint` mutation. */
export type UpdateProjectEnrollmentDataPointPayload = {
  __typename?: 'UpdateProjectEnrollmentDataPointPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `DataPoint` that is related to this `ProjectEnrollmentDataPoint`. */
  dataPoint?: Maybe<DataPoint>;
  /** Reads a single `ProjectEnrollmentDataPointGroup` that is related to this `ProjectEnrollmentDataPoint`. */
  group?: Maybe<ProjectEnrollmentDataPointGroup>;
  /** Reads a single `ProjectEnrollment` that is related to this `ProjectEnrollmentDataPoint`. */
  projectEnrollment?: Maybe<ProjectEnrollment>;
  /** The `ProjectEnrollmentDataPoint` that was updated by this mutation. */
  projectEnrollmentDataPoint?: Maybe<ProjectEnrollmentDataPoint>;
  /** An edge for our `ProjectEnrollmentDataPoint`. May be used by Relay 1. */
  projectEnrollmentDataPointEdge?: Maybe<ProjectEnrollmentDataPointsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `ProjectEnrollmentDataPoint` mutation. */
export type UpdateProjectEnrollmentDataPointPayloadProjectEnrollmentDataPointEdgeArgs =
  {
    orderBy?: InputMaybe<Array<ProjectEnrollmentDataPointsOrderBy>>;
  };

/** All input for the `updateProject` mutation. */
export type UpdateProjectInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The identifier of the optimization project. */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `Project` being updated. */
  patch: ProjectPatch;
};

/** The output of our update `Project` mutation. */
export type UpdateProjectPayload = {
  __typename?: 'UpdateProjectPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Facility` that is related to this `Project`. */
  facility?: Maybe<Facility>;
  /** Reads a single `Program` that is related to this `Project`. */
  program?: Maybe<Program>;
  /** The `Project` that was updated by this mutation. */
  project?: Maybe<Project>;
  /** An edge for our `Project`. May be used by Relay 1. */
  projectEdge?: Maybe<ProjectsEdge>;
  /** Reads a single `ProjectType` that is related to this `Project`. */
  projectType?: Maybe<ProjectType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `Project` mutation. */
export type UpdateProjectPayloadProjectEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};

/** All input for the `updateProjectWatcherByNodeId` mutation. */
export type UpdateProjectWatcherByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProjectWatcher` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ProjectWatcher` being updated. */
  patch: ProjectWatcherPatch;
};

/** All input for the `updateProjectWatcher` mutation. */
export type UpdateProjectWatcherInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `ProjectWatcher` being updated. */
  patch: ProjectWatcherPatch;
  projectId: Scalars['Int'];
  userId: Scalars['String'];
};

/** The output of our update `ProjectWatcher` mutation. */
export type UpdateProjectWatcherPayload = {
  __typename?: 'UpdateProjectWatcherPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Project` that is related to this `ProjectWatcher`. */
  project?: Maybe<Project>;
  /** The `ProjectWatcher` that was updated by this mutation. */
  projectWatcher?: Maybe<ProjectWatcher>;
  /** An edge for our `ProjectWatcher`. May be used by Relay 1. */
  projectWatcherEdge?: Maybe<ProjectWatchersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `ProjectWatcher`. */
  user?: Maybe<User>;
};

/** The output of our update `ProjectWatcher` mutation. */
export type UpdateProjectWatcherPayloadProjectWatcherEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectWatchersOrderBy>>;
};

/** All input for the `updateReportExecutionByNodeId` mutation. */
export type UpdateReportExecutionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ReportExecution` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ReportExecution` being updated. */
  patch: ReportExecutionPatch;
};

/** All input for the `updateReportExecution` mutation. */
export type UpdateReportExecutionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The id of the report execution. */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `ReportExecution` being updated. */
  patch: ReportExecutionPatch;
};

/** The output of our update `ReportExecution` mutation. */
export type UpdateReportExecutionPayload = {
  __typename?: 'UpdateReportExecutionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Report` that is related to this `ReportExecution`. */
  report?: Maybe<Report>;
  /** The `ReportExecution` that was updated by this mutation. */
  reportExecution?: Maybe<ReportExecution>;
  /** An edge for our `ReportExecution`. May be used by Relay 1. */
  reportExecutionEdge?: Maybe<ReportExecutionsEdge>;
};

/** The output of our update `ReportExecution` mutation. */
export type UpdateReportExecutionPayloadReportExecutionEdgeArgs = {
  orderBy?: InputMaybe<Array<ReportExecutionsOrderBy>>;
};

/** All input for the `updateSavingsEventByNodeId` mutation. */
export type UpdateSavingsEventByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SavingsEvent` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `SavingsEvent` being updated. */
  patch: SavingsEventPatch;
};

/** All input for the `updateSavingsEventByProjectIdAndStartTimeAndEndTime` mutation. */
export type UpdateSavingsEventByProjectIdAndStartTimeAndEndTimeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The time that the savings_event ended */
  endTime: Scalars['Datetime'];
  /** An object where the defined keys will be set on the `SavingsEvent` being updated. */
  patch: SavingsEventPatch;
  /** This maps the savings_event to a project */
  projectId: Scalars['Int'];
  /** The time that the savings_event started */
  startTime: Scalars['Datetime'];
};

/** All input for the `updateSavingsEvent` mutation. */
export type UpdateSavingsEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `SavingsEvent` being updated. */
  patch: SavingsEventPatch;
};

/** The output of our update `SavingsEvent` mutation. */
export type UpdateSavingsEventPayload = {
  __typename?: 'UpdateSavingsEventPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Project` that is related to this `SavingsEvent`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SavingsEvent` that was updated by this mutation. */
  savingsEvent?: Maybe<SavingsEvent>;
  /** An edge for our `SavingsEvent`. May be used by Relay 1. */
  savingsEventEdge?: Maybe<SavingsEventsEdge>;
};

/** The output of our update `SavingsEvent` mutation. */
export type UpdateSavingsEventPayloadSavingsEventEdgeArgs = {
  orderBy?: InputMaybe<Array<SavingsEventsOrderBy>>;
};

/** All input for the `updateSuggestionByNodeId` mutation. */
export type UpdateSuggestionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Suggestion` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Suggestion` being updated. */
  patch: SuggestionPatch;
};

/** All input for the `updateSuggestionControlEventByControlEventId` mutation. */
export type UpdateSuggestionControlEventByControlEventIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  controlEventId: Scalars['Int'];
  /** An object where the defined keys will be set on the `SuggestionControlEvent` being updated. */
  patch: SuggestionControlEventPatch;
};

/** All input for the `updateSuggestionControlEventByNodeId` mutation. */
export type UpdateSuggestionControlEventByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SuggestionControlEvent` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `SuggestionControlEvent` being updated. */
  patch: SuggestionControlEventPatch;
};

/** All input for the `updateSuggestionControlEvent` mutation. */
export type UpdateSuggestionControlEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  controlEventId: Scalars['Int'];
  /** An object where the defined keys will be set on the `SuggestionControlEvent` being updated. */
  patch: SuggestionControlEventPatch;
  suggestionId: Scalars['Int'];
};

/** The output of our update `SuggestionControlEvent` mutation. */
export type UpdateSuggestionControlEventPayload = {
  __typename?: 'UpdateSuggestionControlEventPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `ControlEvent` that is related to this `SuggestionControlEvent`. */
  controlEvent?: Maybe<ControlEvent>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Suggestion` that is related to this `SuggestionControlEvent`. */
  suggestion?: Maybe<Suggestion>;
  /** The `SuggestionControlEvent` that was updated by this mutation. */
  suggestionControlEvent?: Maybe<SuggestionControlEvent>;
};

/** All input for the `updateSuggestion` mutation. */
export type UpdateSuggestionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The identifier of the suggestions. */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `Suggestion` being updated. */
  patch: SuggestionPatch;
};

/** The output of our update `Suggestion` mutation. */
export type UpdateSuggestionPayload = {
  __typename?: 'UpdateSuggestionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Project` that is related to this `Suggestion`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Suggestion` that was updated by this mutation. */
  suggestion?: Maybe<Suggestion>;
  /** An edge for our `Suggestion`. May be used by Relay 1. */
  suggestionEdge?: Maybe<SuggestionsEdge>;
};

/** The output of our update `Suggestion` mutation. */
export type UpdateSuggestionPayloadSuggestionEdgeArgs = {
  orderBy?: InputMaybe<Array<SuggestionsOrderBy>>;
};

/** All input for the `updateTemperatureSensorByFacilityIdAndLabel` mutation. */
export type UpdateTemperatureSensorByFacilityIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The facility where the temperature sensor is installed */
  facilityId: Scalars['Int'];
  /** The Human-readable label for the sensor */
  label: Scalars['String'];
  /** An object where the defined keys will be set on the `TemperatureSensor` being updated. */
  patch: TemperatureSensorPatch;
};

/** All input for the `updateTemperatureSensorByNodeId` mutation. */
export type UpdateTemperatureSensorByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `TemperatureSensor` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `TemperatureSensor` being updated. */
  patch: TemperatureSensorPatch;
};

/** All input for the `updateTemperatureSensor` mutation. */
export type UpdateTemperatureSensorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The id of the temperature sensor */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `TemperatureSensor` being updated. */
  patch: TemperatureSensorPatch;
};

/** The output of our update `TemperatureSensor` mutation. */
export type UpdateTemperatureSensorPayload = {
  __typename?: 'UpdateTemperatureSensorPayload';
  /** Reads a single `DataPoint` that is related to this `TemperatureSensor`. */
  battery?: Maybe<DataPoint>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Facility` that is related to this `TemperatureSensor`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `TemperatureSensor`. */
  signal?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `TemperatureSensor`. */
  temperature?: Maybe<DataPoint>;
  /** The `TemperatureSensor` that was updated by this mutation. */
  temperatureSensor?: Maybe<TemperatureSensor>;
  /** An edge for our `TemperatureSensor`. May be used by Relay 1. */
  temperatureSensorEdge?: Maybe<TemperatureSensorsEdge>;
};

/** The output of our update `TemperatureSensor` mutation. */
export type UpdateTemperatureSensorPayloadTemperatureSensorEdgeArgs = {
  orderBy?: InputMaybe<Array<TemperatureSensorsOrderBy>>;
};

/** All input for the `updateTrailerPositionByFacilityIdAndLabel` mutation. */
export type UpdateTrailerPositionByFacilityIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The facility where the trailer position is located */
  facilityId: Scalars['Int'];
  /** The Human-readable label for the trailer position */
  label: Scalars['String'];
  /** An object where the defined keys will be set on the `TrailerPosition` being updated. */
  patch: TrailerPositionPatch;
};

/** All input for the `updateTrailerPositionByNodeId` mutation. */
export type UpdateTrailerPositionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `TrailerPosition` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `TrailerPosition` being updated. */
  patch: TrailerPositionPatch;
};

/** All input for the `updateTrailerPosition` mutation. */
export type UpdateTrailerPositionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The id of the trailer position */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `TrailerPosition` being updated. */
  patch: TrailerPositionPatch;
};

/** The output of our update `TrailerPosition` mutation. */
export type UpdateTrailerPositionPayload = {
  __typename?: 'UpdateTrailerPositionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Facility` that is related to this `TrailerPosition`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `TrailerPosition`. */
  trailerIsPresent?: Maybe<DataPoint>;
  /** The `TrailerPosition` that was updated by this mutation. */
  trailerPosition?: Maybe<TrailerPosition>;
  /** An edge for our `TrailerPosition`. May be used by Relay 1. */
  trailerPositionEdge?: Maybe<TrailerPositionsEdge>;
};

/** The output of our update `TrailerPosition` mutation. */
export type UpdateTrailerPositionPayloadTrailerPositionEdgeArgs = {
  orderBy?: InputMaybe<Array<TrailerPositionsOrderBy>>;
};

/** All input for the `updateUserByNodeId` mutation. */
export type UpdateUserByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `User` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `User` being updated. */
  patch: UserPatch;
};

/** All input for the `updateUser` mutation. */
export type UpdateUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The primary unique identifier of the user. */
  id: Scalars['String'];
  /** An object where the defined keys will be set on the `User` being updated. */
  patch: UserPatch;
};

/** The output of our update `User` mutation. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was updated by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};

/** The output of our update `User` mutation. */
export type UpdateUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the `updateUtilityAccountByNodeId` mutation. */
export type UpdateUtilityAccountByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `UtilityAccount` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `UtilityAccount` being updated. */
  patch: UtilityAccountPatch;
};

/** All input for the `updateUtilityAccount` mutation. */
export type UpdateUtilityAccountInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The primary unique identifier of the account. */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `UtilityAccount` being updated. */
  patch: UtilityAccountPatch;
};

/** The output of our update `UtilityAccount` mutation. */
export type UpdateUtilityAccountPayload = {
  __typename?: 'UpdateUtilityAccountPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UtilityAccount` that was updated by this mutation. */
  utilityAccount?: Maybe<UtilityAccount>;
  /** An edge for our `UtilityAccount`. May be used by Relay 1. */
  utilityAccountEdge?: Maybe<UtilityAccountsEdge>;
  /** Reads a single `UtilityProvider` that is related to this `UtilityAccount`. */
  utilityProvider?: Maybe<UtilityProvider>;
};

/** The output of our update `UtilityAccount` mutation. */
export type UpdateUtilityAccountPayloadUtilityAccountEdgeArgs = {
  orderBy?: InputMaybe<Array<UtilityAccountsOrderBy>>;
};

/** All input for the `updateUtilityMeterByNodeId` mutation. */
export type UpdateUtilityMeterByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `UtilityMeter` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `UtilityMeter` being updated. */
  patch: UtilityMeterPatch;
};

/** All input for the `updateUtilityMeter` mutation. */
export type UpdateUtilityMeterInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `UtilityMeter` being updated. */
  patch: UtilityMeterPatch;
};

/** The output of our update `UtilityMeter` mutation. */
export type UpdateUtilityMeterPayload = {
  __typename?: 'UpdateUtilityMeterPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Facility` that is related to this `UtilityMeter`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UtilityAccount` that is related to this `UtilityMeter`. */
  utilityAccount?: Maybe<UtilityAccount>;
  /** The `UtilityMeter` that was updated by this mutation. */
  utilityMeter?: Maybe<UtilityMeter>;
  /** An edge for our `UtilityMeter`. May be used by Relay 1. */
  utilityMeterEdge?: Maybe<UtilityMetersEdge>;
};

/** The output of our update `UtilityMeter` mutation. */
export type UpdateUtilityMeterPayloadUtilityMeterEdgeArgs = {
  orderBy?: InputMaybe<Array<UtilityMetersOrderBy>>;
};

/** All input for the `updateUtilityProviderByName` mutation. */
export type UpdateUtilityProviderByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The name of the provider. */
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `UtilityProvider` being updated. */
  patch: UtilityProviderPatch;
};

/** All input for the `updateUtilityProviderByNodeId` mutation. */
export type UpdateUtilityProviderByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `UtilityProvider` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `UtilityProvider` being updated. */
  patch: UtilityProviderPatch;
};

/** All input for the `updateUtilityProvider` mutation. */
export type UpdateUtilityProviderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The primary unique identifier for the provider. */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `UtilityProvider` being updated. */
  patch: UtilityProviderPatch;
};

/** The output of our update `UtilityProvider` mutation. */
export type UpdateUtilityProviderPayload = {
  __typename?: 'UpdateUtilityProviderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UtilityProvider` that was updated by this mutation. */
  utilityProvider?: Maybe<UtilityProvider>;
  /** An edge for our `UtilityProvider`. May be used by Relay 1. */
  utilityProviderEdge?: Maybe<UtilityProvidersEdge>;
};

/** The output of our update `UtilityProvider` mutation. */
export type UpdateUtilityProviderPayloadUtilityProviderEdgeArgs = {
  orderBy?: InputMaybe<Array<UtilityProvidersOrderBy>>;
};

/** All input for the `updateVendorUserByEmail` mutation. */
export type UpdateVendorUserByEmailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The email of the vendor user. */
  email: Scalars['String'];
  /** An object where the defined keys will be set on the `VendorUser` being updated. */
  patch: VendorUserPatch;
};

/** All input for the `updateVendorUserByNodeId` mutation. */
export type UpdateVendorUserByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `VendorUser` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `VendorUser` being updated. */
  patch: VendorUserPatch;
};

/** All input for the `updateVendorUser` mutation. */
export type UpdateVendorUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The id of the vendor user. */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `VendorUser` being updated. */
  patch: VendorUserPatch;
};

/** All input for the `updateVendorUserMachineUserByMachineUserId` mutation. */
export type UpdateVendorUserMachineUserByMachineUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The machine user associated with the vendor user. */
  machineUserId: Scalars['BigInt'];
  /** An object where the defined keys will be set on the `VendorUserMachineUser` being updated. */
  patch: VendorUserMachineUserPatch;
};

/** All input for the `updateVendorUserMachineUserByNodeId` mutation. */
export type UpdateVendorUserMachineUserByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `VendorUserMachineUser` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `VendorUserMachineUser` being updated. */
  patch: VendorUserMachineUserPatch;
};

/** All input for the `updateVendorUserMachineUser` mutation. */
export type UpdateVendorUserMachineUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The machine user associated with the vendor user. */
  machineUserId: Scalars['BigInt'];
  /** An object where the defined keys will be set on the `VendorUserMachineUser` being updated. */
  patch: VendorUserMachineUserPatch;
  /** The id of the vendor user. */
  vendorUserId: Scalars['Int'];
};

/** The output of our update `VendorUserMachineUser` mutation. */
export type UpdateVendorUserMachineUserPayload = {
  __typename?: 'UpdateVendorUserMachineUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VendorUserMachineUser` that was updated by this mutation. */
  vendorUserMachineUser?: Maybe<VendorUserMachineUser>;
};

/** The output of our update `VendorUser` mutation. */
export type UpdateVendorUserPayload = {
  __typename?: 'UpdateVendorUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VendorUser` that was updated by this mutation. */
  vendorUser?: Maybe<VendorUser>;
  /** An edge for our `VendorUser`. May be used by Relay 1. */
  vendorUserEdge?: Maybe<VendorUsersEdge>;
};

/** The output of our update `VendorUser` mutation. */
export type UpdateVendorUserPayloadVendorUserEdgeArgs = {
  orderBy?: InputMaybe<Array<VendorUsersOrderBy>>;
};

/** All input for the `updateVirtualPointIntervalByNodeId` mutation. */
export type UpdateVirtualPointIntervalByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `VirtualPointInterval` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `VirtualPointInterval` being updated. */
  patch: VirtualPointIntervalPatch;
};

/** All input for the `updateVirtualPointInterval` mutation. */
export type UpdateVirtualPointIntervalInput = {
  /** The id of the child data point. */
  childId: Scalars['BigInt'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The id of the VIRTUAL data point. */
  parentId: Scalars['BigInt'];
  /** An object where the defined keys will be set on the `VirtualPointInterval` being updated. */
  patch: VirtualPointIntervalPatch;
};

/** The output of our update `VirtualPointInterval` mutation. */
export type UpdateVirtualPointIntervalPayload = {
  __typename?: 'UpdateVirtualPointIntervalPayload';
  /** Reads a single `DataPoint` that is related to this `VirtualPointInterval`. */
  child?: Maybe<DataPoint>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `DataPoint` that is related to this `VirtualPointInterval`. */
  parent?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VirtualPointInterval` that was updated by this mutation. */
  virtualPointInterval?: Maybe<VirtualPointInterval>;
  /** An edge for our `VirtualPointInterval`. May be used by Relay 1. */
  virtualPointIntervalEdge?: Maybe<VirtualPointIntervalsEdge>;
};

/** The output of our update `VirtualPointInterval` mutation. */
export type UpdateVirtualPointIntervalPayloadVirtualPointIntervalEdgeArgs = {
  orderBy?: InputMaybe<Array<VirtualPointIntervalsOrderBy>>;
};

/** All input for the upsert `AccountCharge` mutation. */
export type UpsertAccountChargeInput = {
  /** The `AccountCharge` to be upserted by this mutation. */
  accountCharge: AccountChargeInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our upsert `AccountCharge` mutation. */
export type UpsertAccountChargePayload = {
  __typename?: 'UpsertAccountChargePayload';
  /** The `AccountCharge` that was upserted by this mutation. */
  accountCharge?: Maybe<AccountCharge>;
  /** An edge for our `AccountCharge`. May be used by Relay 1. */
  accountChargeEdge?: Maybe<AccountChargesEdge>;
  /** Reads a single `AccountStatement` that is related to this `AccountCharge`. */
  accountStatement?: Maybe<AccountStatement>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `AccountCharge` mutation. */
export type UpsertAccountChargePayloadAccountChargeEdgeArgs = {
  orderBy?: InputMaybe<Array<AccountChargesOrderBy>>;
};

/** Where conditions for the upsert `AccountCharge` mutation. */
export type UpsertAccountChargeWhere = {
  accountStatementId?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<UtilityAccountChargeCategory>;
  id?: InputMaybe<Scalars['Int']>;
  intervalEnd?: InputMaybe<Scalars['Date']>;
  intervalStart?: InputMaybe<Scalars['Date']>;
  label?: InputMaybe<Scalars['String']>;
  lineNumber?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `AccountStatement` mutation. */
export type UpsertAccountStatementInput = {
  /** The `AccountStatement` to be upserted by this mutation. */
  accountStatement: AccountStatementInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our upsert `AccountStatement` mutation. */
export type UpsertAccountStatementPayload = {
  __typename?: 'UpsertAccountStatementPayload';
  /** The `AccountStatement` that was upserted by this mutation. */
  accountStatement?: Maybe<AccountStatement>;
  /** An edge for our `AccountStatement`. May be used by Relay 1. */
  accountStatementEdge?: Maybe<AccountStatementsEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UtilityAccount` that is related to this `AccountStatement`. */
  utilityAccount?: Maybe<UtilityAccount>;
};

/** The output of our upsert `AccountStatement` mutation. */
export type UpsertAccountStatementPayloadAccountStatementEdgeArgs = {
  orderBy?: InputMaybe<Array<AccountStatementsOrderBy>>;
};

/** All input for the upsert `AccountStatementPdf` mutation. */
export type UpsertAccountStatementPdfInput = {
  /** The `AccountStatementPdf` to be upserted by this mutation. */
  accountStatementPdf: AccountStatementPdfInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our upsert `AccountStatementPdf` mutation. */
export type UpsertAccountStatementPdfPayload = {
  __typename?: 'UpsertAccountStatementPdfPayload';
  /** Reads a single `AccountStatement` that is related to this `AccountStatementPdf`. */
  accountStatement?: Maybe<AccountStatement>;
  /** The `AccountStatementPdf` that was upserted by this mutation. */
  accountStatementPdf?: Maybe<AccountStatementPdf>;
  /** An edge for our `AccountStatementPdf`. May be used by Relay 1. */
  accountStatementPdfEdge?: Maybe<AccountStatementPdfsEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `AccountStatementPdf` mutation. */
export type UpsertAccountStatementPdfPayloadAccountStatementPdfEdgeArgs = {
  orderBy?: InputMaybe<Array<AccountStatementPdfsOrderBy>>;
};

/** Where conditions for the upsert `AccountStatementPdf` mutation. */
export type UpsertAccountStatementPdfWhere = {
  accountStatementId?: InputMaybe<Scalars['Int']>;
  fileKey?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** Where conditions for the upsert `AccountStatement` mutation. */
export type UpsertAccountStatementWhere = {
  id?: InputMaybe<Scalars['Int']>;
  integration?: InputMaybe<UtilityIntegration>;
  integrationKey?: InputMaybe<Scalars['String']>;
};

/** All input for the upsert `BalancingAuthority` mutation. */
export type UpsertBalancingAuthorityInput = {
  /** The `BalancingAuthority` to be upserted by this mutation. */
  balancingAuthority: BalancingAuthorityInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our upsert `BalancingAuthority` mutation. */
export type UpsertBalancingAuthorityPayload = {
  __typename?: 'UpsertBalancingAuthorityPayload';
  /** The `BalancingAuthority` that was upserted by this mutation. */
  balancingAuthority?: Maybe<BalancingAuthority>;
  /** An edge for our `BalancingAuthority`. May be used by Relay 1. */
  balancingAuthorityEdge?: Maybe<BalancingAuthoritiesEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `BalancingAuthority` mutation. */
export type UpsertBalancingAuthorityPayloadBalancingAuthorityEdgeArgs = {
  orderBy?: InputMaybe<Array<BalancingAuthoritiesOrderBy>>;
};

/** Where conditions for the upsert `BalancingAuthority` mutation. */
export type UpsertBalancingAuthorityWhere = {
  id?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
};

/** All input for the upsert `BlastEvaporator` mutation. */
export type UpsertBlastEvaporatorInput = {
  /** The `BlastEvaporator` to be upserted by this mutation. */
  blastEvaporator: BlastEvaporatorInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our upsert `BlastEvaporator` mutation. */
export type UpsertBlastEvaporatorPayload = {
  __typename?: 'UpsertBlastEvaporatorPayload';
  /** Reads a single `Blast` that is related to this `BlastEvaporator`. */
  blast?: Maybe<Blast>;
  /** The `BlastEvaporator` that was upserted by this mutation. */
  blastEvaporator?: Maybe<BlastEvaporator>;
  /** An edge for our `BlastEvaporator`. May be used by Relay 1. */
  blastEvaporatorEdge?: Maybe<BlastEvaporatorsEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Evaporator` that is related to this `BlastEvaporator`. */
  evaporator?: Maybe<Evaporator>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `BlastEvaporator` mutation. */
export type UpsertBlastEvaporatorPayloadBlastEvaporatorEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastEvaporatorsOrderBy>>;
};

/** Where conditions for the upsert `BlastEvaporator` mutation. */
export type UpsertBlastEvaporatorWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `Blast` mutation. */
export type UpsertBlastInput = {
  /** The `Blast` to be upserted by this mutation. */
  blast: BlastInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** All input for the upsert `BlastPallet` mutation. */
export type UpsertBlastPalletInput = {
  /** The `BlastPallet` to be upserted by this mutation. */
  blastPallet: BlastPalletInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** All input for the upsert `BlastPalletLocation` mutation. */
export type UpsertBlastPalletLocationInput = {
  /** The `BlastPalletLocation` to be upserted by this mutation. */
  blastPalletLocation: BlastPalletLocationInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our upsert `BlastPalletLocation` mutation. */
export type UpsertBlastPalletLocationPayload = {
  __typename?: 'UpsertBlastPalletLocationPayload';
  /** Reads a single `Blast` that is related to this `BlastPalletLocation`. */
  blast?: Maybe<Blast>;
  /** The `BlastPalletLocation` that was upserted by this mutation. */
  blastPalletLocation?: Maybe<BlastPalletLocation>;
  /** An edge for our `BlastPalletLocation`. May be used by Relay 1. */
  blastPalletLocationEdge?: Maybe<BlastPalletLocationsEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `PalletLocation` that is related to this `BlastPalletLocation`. */
  palletLocation?: Maybe<PalletLocation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `BlastPalletLocation` mutation. */
export type UpsertBlastPalletLocationPayloadBlastPalletLocationEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastPalletLocationsOrderBy>>;
};

/** Where conditions for the upsert `BlastPalletLocation` mutation. */
export type UpsertBlastPalletLocationWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** The output of our upsert `BlastPallet` mutation. */
export type UpsertBlastPalletPayload = {
  __typename?: 'UpsertBlastPalletPayload';
  /** Reads a single `Blast` that is related to this `BlastPallet`. */
  blast?: Maybe<Blast>;
  /** The `BlastPallet` that was upserted by this mutation. */
  blastPallet?: Maybe<BlastPallet>;
  /** An edge for our `BlastPallet`. May be used by Relay 1. */
  blastPalletEdge?: Maybe<BlastPalletsEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Pallet` that is related to this `BlastPallet`. */
  pallet?: Maybe<Pallet>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `BlastPallet` mutation. */
export type UpsertBlastPalletPayloadBlastPalletEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastPalletsOrderBy>>;
};

/** Where conditions for the upsert `BlastPallet` mutation. */
export type UpsertBlastPalletWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** The output of our upsert `Blast` mutation. */
export type UpsertBlastPayload = {
  __typename?: 'UpsertBlastPayload';
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  actualUtilization?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  automationState?: Maybe<DataPoint>;
  /** The `Blast` that was upserted by this mutation. */
  blast?: Maybe<Blast>;
  /** An edge for our `Blast`. May be used by Relay 1. */
  blastEdge?: Maybe<BlastsEdge>;
  /** Reads a single `BlastType` that is related to this `Blast`. */
  blastType?: Maybe<BlastType>;
  /** Reads a single `BuildingArea` that is related to this `Blast`. */
  buildingArea?: Maybe<BuildingArea>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Component` that is related to this `Blast`. */
  component?: Maybe<Component>;
  /** Reads a single `Facility` that is related to this `Blast`. */
  facility?: Maybe<Facility>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  idealUtilization?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  stagingTimer?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  state?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  timer?: Maybe<DataPoint>;
};

/** The output of our upsert `Blast` mutation. */
export type UpsertBlastPayloadBlastEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastsOrderBy>>;
};

/** All input for the upsert `BlastRotationAlert` mutation. */
export type UpsertBlastRotationAlertInput = {
  /** The `BlastRotationAlert` to be upserted by this mutation. */
  blastRotationAlert: BlastRotationAlertInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our upsert `BlastRotationAlert` mutation. */
export type UpsertBlastRotationAlertPayload = {
  __typename?: 'UpsertBlastRotationAlertPayload';
  /** Reads a single `BlastRotation` that is related to this `BlastRotationAlert`. */
  blastRotation?: Maybe<BlastRotation>;
  /** The `BlastRotationAlert` that was upserted by this mutation. */
  blastRotationAlert?: Maybe<BlastRotationAlert>;
  /** An edge for our `BlastRotationAlert`. May be used by Relay 1. */
  blastRotationAlertEdge?: Maybe<BlastRotationAlertsEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `BlastRotationAlert` mutation. */
export type UpsertBlastRotationAlertPayloadBlastRotationAlertEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastRotationAlertsOrderBy>>;
};

/** Where conditions for the upsert `BlastRotationAlert` mutation. */
export type UpsertBlastRotationAlertWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `BlastRotationEventLog` mutation. */
export type UpsertBlastRotationEventLogInput = {
  /** The `BlastRotationEventLog` to be upserted by this mutation. */
  blastRotationEventLog: BlastRotationEventLogInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our upsert `BlastRotationEventLog` mutation. */
export type UpsertBlastRotationEventLogPayload = {
  __typename?: 'UpsertBlastRotationEventLogPayload';
  /** Reads a single `BlastRotation` that is related to this `BlastRotationEventLog`. */
  blastRotation?: Maybe<BlastRotation>;
  /** The `BlastRotationEventLog` that was upserted by this mutation. */
  blastRotationEventLog?: Maybe<BlastRotationEventLog>;
  /** An edge for our `BlastRotationEventLog`. May be used by Relay 1. */
  blastRotationEventLogEdge?: Maybe<BlastRotationEventLogsEdge>;
  /** Reads a single `BlastRotationEventType` that is related to this `BlastRotationEventLog`. */
  blastRotationEventType?: Maybe<BlastRotationEventType>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `BlastRotationEventLog` mutation. */
export type UpsertBlastRotationEventLogPayloadBlastRotationEventLogEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastRotationEventLogsOrderBy>>;
};

/** Where conditions for the upsert `BlastRotationEventLog` mutation. */
export type UpsertBlastRotationEventLogWhere = {
  blastRotationEventTypeId?: InputMaybe<Scalars['String']>;
  blastRotationId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `BlastRotationEventType` mutation. */
export type UpsertBlastRotationEventTypeInput = {
  /** The `BlastRotationEventType` to be upserted by this mutation. */
  blastRotationEventType: BlastRotationEventTypeInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our upsert `BlastRotationEventType` mutation. */
export type UpsertBlastRotationEventTypePayload = {
  __typename?: 'UpsertBlastRotationEventTypePayload';
  /** The `BlastRotationEventType` that was upserted by this mutation. */
  blastRotationEventType?: Maybe<BlastRotationEventType>;
  /** An edge for our `BlastRotationEventType`. May be used by Relay 1. */
  blastRotationEventTypeEdge?: Maybe<BlastRotationEventTypesEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `BlastRotationEventType` mutation. */
export type UpsertBlastRotationEventTypePayloadBlastRotationEventTypeEdgeArgs =
  {
    orderBy?: InputMaybe<Array<BlastRotationEventTypesOrderBy>>;
  };

/** Where conditions for the upsert `BlastRotationEventType` mutation. */
export type UpsertBlastRotationEventTypeWhere = {
  eventType?: InputMaybe<Scalars['String']>;
};

/** All input for the upsert `BlastRotation` mutation. */
export type UpsertBlastRotationInput = {
  /** The `BlastRotation` to be upserted by this mutation. */
  blastRotation: BlastRotationInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** All input for the upsert `BlastRotationPallet` mutation. */
export type UpsertBlastRotationPalletInput = {
  /** The `BlastRotationPallet` to be upserted by this mutation. */
  blastRotationPallet: BlastRotationPalletInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our upsert `BlastRotationPallet` mutation. */
export type UpsertBlastRotationPalletPayload = {
  __typename?: 'UpsertBlastRotationPalletPayload';
  /** Reads a single `BlastRotation` that is related to this `BlastRotationPallet`. */
  blastRotation?: Maybe<BlastRotation>;
  /** The `BlastRotationPallet` that was upserted by this mutation. */
  blastRotationPallet?: Maybe<BlastRotationPallet>;
  /** An edge for our `BlastRotationPallet`. May be used by Relay 1. */
  blastRotationPalletEdge?: Maybe<BlastRotationPalletsEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Pallet` that is related to this `BlastRotationPallet`. */
  pallet?: Maybe<Pallet>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `BlastRotationPallet` mutation. */
export type UpsertBlastRotationPalletPayloadBlastRotationPalletEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastRotationPalletsOrderBy>>;
};

/** Where conditions for the upsert `BlastRotationPallet` mutation. */
export type UpsertBlastRotationPalletWhere = {
  blastRotationId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  palletId?: InputMaybe<Scalars['Int']>;
};

/** The output of our upsert `BlastRotation` mutation. */
export type UpsertBlastRotationPayload = {
  __typename?: 'UpsertBlastRotationPayload';
  /** Reads a single `Blast` that is related to this `BlastRotation`. */
  blast?: Maybe<Blast>;
  /** The `BlastRotation` that was upserted by this mutation. */
  blastRotation?: Maybe<BlastRotation>;
  /** An edge for our `BlastRotation`. May be used by Relay 1. */
  blastRotationEdge?: Maybe<BlastRotationsEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `BlastRotation` mutation. */
export type UpsertBlastRotationPayloadBlastRotationEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastRotationsOrderBy>>;
};

/** Where conditions for the upsert `BlastRotation` mutation. */
export type UpsertBlastRotationWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `BlastType` mutation. */
export type UpsertBlastTypeInput = {
  /** The `BlastType` to be upserted by this mutation. */
  blastType: BlastTypeInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our upsert `BlastType` mutation. */
export type UpsertBlastTypePayload = {
  __typename?: 'UpsertBlastTypePayload';
  /** The `BlastType` that was upserted by this mutation. */
  blastType?: Maybe<BlastType>;
  /** An edge for our `BlastType`. May be used by Relay 1. */
  blastTypeEdge?: Maybe<BlastTypesEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `BlastType` mutation. */
export type UpsertBlastTypePayloadBlastTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastTypesOrderBy>>;
};

/** Where conditions for the upsert `BlastType` mutation. */
export type UpsertBlastTypeWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** Where conditions for the upsert `Blast` mutation. */
export type UpsertBlastWhere = {
  facilityId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
};

/** All input for the upsert `BuildingAreaComplianceGroup` mutation. */
export type UpsertBuildingAreaComplianceGroupInput = {
  /** The `BuildingAreaComplianceGroup` to be upserted by this mutation. */
  buildingAreaComplianceGroup: BuildingAreaComplianceGroupInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our upsert `BuildingAreaComplianceGroup` mutation. */
export type UpsertBuildingAreaComplianceGroupPayload = {
  __typename?: 'UpsertBuildingAreaComplianceGroupPayload';
  /** Reads a single `BuildingArea` that is related to this `BuildingAreaComplianceGroup`. */
  buildingArea?: Maybe<BuildingArea>;
  /** The `BuildingAreaComplianceGroup` that was upserted by this mutation. */
  buildingAreaComplianceGroup?: Maybe<BuildingAreaComplianceGroup>;
  /** An edge for our `BuildingAreaComplianceGroup`. May be used by Relay 1. */
  buildingAreaComplianceGroupEdge?: Maybe<BuildingAreaComplianceGroupsEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `ComplianceGroup` that is related to this `BuildingAreaComplianceGroup`. */
  complianceGroup?: Maybe<ComplianceGroup>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `BuildingAreaComplianceGroup` mutation. */
export type UpsertBuildingAreaComplianceGroupPayloadBuildingAreaComplianceGroupEdgeArgs =
  {
    orderBy?: InputMaybe<Array<BuildingAreaComplianceGroupsOrderBy>>;
  };

/** Where conditions for the upsert `BuildingAreaComplianceGroup` mutation. */
export type UpsertBuildingAreaComplianceGroupWhere = {
  buildingAreaId?: InputMaybe<Scalars['Int']>;
  complianceType?: InputMaybe<ComplianceType>;
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `BuildingArea` mutation. */
export type UpsertBuildingAreaInput = {
  /** The `BuildingArea` to be upserted by this mutation. */
  buildingArea: BuildingAreaInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our upsert `BuildingArea` mutation. */
export type UpsertBuildingAreaPayload = {
  __typename?: 'UpsertBuildingAreaPayload';
  /** The `BuildingArea` that was upserted by this mutation. */
  buildingArea?: Maybe<BuildingArea>;
  /** An edge for our `BuildingArea`. May be used by Relay 1. */
  buildingAreaEdge?: Maybe<BuildingAreasEdge>;
  /** Reads a single `BuildingAreaType` that is related to this `BuildingArea`. */
  buildingAreaType?: Maybe<BuildingAreaType>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Facility` that is related to this `BuildingArea`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `BuildingArea` mutation. */
export type UpsertBuildingAreaPayloadBuildingAreaEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingAreasOrderBy>>;
};

/** All input for the upsert `BuildingAreaType` mutation. */
export type UpsertBuildingAreaTypeInput = {
  /** The `BuildingAreaType` to be upserted by this mutation. */
  buildingAreaType: BuildingAreaTypeInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our upsert `BuildingAreaType` mutation. */
export type UpsertBuildingAreaTypePayload = {
  __typename?: 'UpsertBuildingAreaTypePayload';
  /** The `BuildingAreaType` that was upserted by this mutation. */
  buildingAreaType?: Maybe<BuildingAreaType>;
  /** An edge for our `BuildingAreaType`. May be used by Relay 1. */
  buildingAreaTypeEdge?: Maybe<BuildingAreaTypesEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `BuildingAreaType` mutation. */
export type UpsertBuildingAreaTypePayloadBuildingAreaTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingAreaTypesOrderBy>>;
};

/** Where conditions for the upsert `BuildingAreaType` mutation. */
export type UpsertBuildingAreaTypeWhere = {
  type?: InputMaybe<Scalars['String']>;
};

/** Where conditions for the upsert `BuildingArea` mutation. */
export type UpsertBuildingAreaWhere = {
  facilityId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
};

/** All input for the upsert `Chart` mutation. */
export type UpsertChartInput = {
  /** The `Chart` to be upserted by this mutation. */
  chart: ChartInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our upsert `Chart` mutation. */
export type UpsertChartPayload = {
  __typename?: 'UpsertChartPayload';
  /** The `Chart` that was upserted by this mutation. */
  chart?: Maybe<Chart>;
  /** An edge for our `Chart`. May be used by Relay 1. */
  chartEdge?: Maybe<ChartsEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Facility` that is related to this `Chart`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `Chart` mutation. */
export type UpsertChartPayloadChartEdgeArgs = {
  orderBy?: InputMaybe<Array<ChartsOrderBy>>;
};

/** Where conditions for the upsert `Chart` mutation. */
export type UpsertChartWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `ComplianceGroup` mutation. */
export type UpsertComplianceGroupInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ComplianceGroup` to be upserted by this mutation. */
  complianceGroup: ComplianceGroupInput;
};

/** The output of our upsert `ComplianceGroup` mutation. */
export type UpsertComplianceGroupPayload = {
  __typename?: 'UpsertComplianceGroupPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ComplianceGroup` that was upserted by this mutation. */
  complianceGroup?: Maybe<ComplianceGroup>;
  /** An edge for our `ComplianceGroup`. May be used by Relay 1. */
  complianceGroupEdge?: Maybe<ComplianceGroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `ComplianceGroup` mutation. */
export type UpsertComplianceGroupPayloadComplianceGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<ComplianceGroupsOrderBy>>;
};

/** Where conditions for the upsert `ComplianceGroup` mutation. */
export type UpsertComplianceGroupWhere = {
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
};

/** All input for the upsert `ComplianceRange` mutation. */
export type UpsertComplianceRangeInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ComplianceRange` to be upserted by this mutation. */
  complianceRange: ComplianceRangeInput;
};

/** The output of our upsert `ComplianceRange` mutation. */
export type UpsertComplianceRangePayload = {
  __typename?: 'UpsertComplianceRangePayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `ComplianceGroup` that is related to this `ComplianceRange`. */
  complianceGroup?: Maybe<ComplianceGroup>;
  /** The `ComplianceRange` that was upserted by this mutation. */
  complianceRange?: Maybe<ComplianceRange>;
  /** An edge for our `ComplianceRange`. May be used by Relay 1. */
  complianceRangeEdge?: Maybe<ComplianceRangesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `ComplianceRange` mutation. */
export type UpsertComplianceRangePayloadComplianceRangeEdgeArgs = {
  orderBy?: InputMaybe<Array<ComplianceRangesOrderBy>>;
};

/** Where conditions for the upsert `ComplianceRange` mutation. */
export type UpsertComplianceRangeWhere = {
  complianceGroupId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
};

/** All input for the upsert `Compressor` mutation. */
export type UpsertCompressorInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Compressor` to be upserted by this mutation. */
  compressor: CompressorInput;
};

/** The output of our upsert `Compressor` mutation. */
export type UpsertCompressorPayload = {
  __typename?: 'UpsertCompressorPayload';
  /** Reads a single `BuildingArea` that is related to this `Compressor`. */
  buildingArea?: Maybe<BuildingArea>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  capacity?: Maybe<DataPoint>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Compressor` that was upserted by this mutation. */
  compressor?: Maybe<Compressor>;
  /** An edge for our `Compressor`. May be used by Relay 1. */
  compressorEdge?: Maybe<CompressorsEdge>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  controlMode?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  differentialPressure?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  dischargePressure?: Maybe<DataPoint>;
  /** Reads a single `Facility` that is related to this `Compressor`. */
  facility?: Maybe<Facility>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  kwDemand?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  motorAmps?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  motorState?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  oilPressure?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  oilTemperature?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  runtimeHours?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  setpoint?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  slideValvePosition?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  state?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  suctionPressure?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  suctionTemperature?: Maybe<DataPoint>;
};

/** The output of our upsert `Compressor` mutation. */
export type UpsertCompressorPayloadCompressorEdgeArgs = {
  orderBy?: InputMaybe<Array<CompressorsOrderBy>>;
};

/** Where conditions for the upsert `Compressor` mutation. */
export type UpsertCompressorWhere = {
  facilityId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
};

/** All input for the upsert `Customer` mutation. */
export type UpsertCustomerInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Customer` to be upserted by this mutation. */
  customer: CustomerInput;
};

/** The output of our upsert `Customer` mutation. */
export type UpsertCustomerPayload = {
  __typename?: 'UpsertCustomerPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Customer` that was upserted by this mutation. */
  customer?: Maybe<Customer>;
  /** An edge for our `Customer`. May be used by Relay 1. */
  customerEdge?: Maybe<CustomersEdge>;
  /** Reads a single `Facility` that is related to this `Customer`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `Customer` mutation. */
export type UpsertCustomerPayloadCustomerEdgeArgs = {
  orderBy?: InputMaybe<Array<CustomersOrderBy>>;
};

/** Where conditions for the upsert `Customer` mutation. */
export type UpsertCustomerWhere = {
  id?: InputMaybe<Scalars['BigInt']>;
  sourceId?: InputMaybe<Scalars['String']>;
};

/** All input for the upsert `Dashboard` mutation. */
export type UpsertDashboardInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Dashboard` to be upserted by this mutation. */
  dashboard: DashboardInput;
};

/** The output of our upsert `Dashboard` mutation. */
export type UpsertDashboardPayload = {
  __typename?: 'UpsertDashboardPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Dashboard` that was upserted by this mutation. */
  dashboard?: Maybe<Dashboard>;
  /** An edge for our `Dashboard`. May be used by Relay 1. */
  dashboardEdge?: Maybe<DashboardsEdge>;
  /** Reads a single `Facility` that is related to this `Dashboard`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `Dashboard` mutation. */
export type UpsertDashboardPayloadDashboardEdgeArgs = {
  orderBy?: InputMaybe<Array<DashboardsOrderBy>>;
};

/** Where conditions for the upsert `Dashboard` mutation. */
export type UpsertDashboardWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `DataPoint` mutation. */
export type UpsertDataPointInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `DataPoint` to be upserted by this mutation. */
  dataPoint: DataPointInput;
};

/** The output of our upsert `DataPoint` mutation. */
export type UpsertDataPointPayload = {
  __typename?: 'UpsertDataPointPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `DataPoint` that was upserted by this mutation. */
  dataPoint?: Maybe<DataPoint>;
  /** An edge for our `DataPoint`. May be used by Relay 1. */
  dataPointEdge?: Maybe<DataPointsEdge>;
  /** Reads a single `DataSource` that is related to this `DataPoint`. */
  dataSourceByDataSourceName?: Maybe<DataSource>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `DataPoint` mutation. */
export type UpsertDataPointPayloadDataPointEdgeArgs = {
  orderBy?: InputMaybe<Array<DataPointsOrderBy>>;
};

/** Where conditions for the upsert `DataPoint` mutation. */
export type UpsertDataPointWhere = {
  dataSourceName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
};

/** All input for the upsert `Dependency` mutation. */
export type UpsertDependencyInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Dependency` to be upserted by this mutation. */
  dependency: DependencyInput;
};

/** The output of our upsert `Dependency` mutation. */
export type UpsertDependencyPayload = {
  __typename?: 'UpsertDependencyPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Dependency` that was upserted by this mutation. */
  dependency?: Maybe<Dependency>;
  /** An edge for our `Dependency`. May be used by Relay 1. */
  dependencyEdge?: Maybe<DependenciesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `Dependency` mutation. */
export type UpsertDependencyPayloadDependencyEdgeArgs = {
  orderBy?: InputMaybe<Array<DependenciesOrderBy>>;
};

/** Where conditions for the upsert `Dependency` mutation. */
export type UpsertDependencyWhere = {
  id?: InputMaybe<Scalars['BigInt']>;
  path?: InputMaybe<Scalars['String']>;
};

/** All input for the upsert `Door` mutation. */
export type UpsertDoorInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Door` to be upserted by this mutation. */
  door: DoorInput;
};

/** The output of our upsert `Door` mutation. */
export type UpsertDoorPayload = {
  __typename?: 'UpsertDoorPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Door` that was upserted by this mutation. */
  door?: Maybe<Door>;
  /** An edge for our `Door`. May be used by Relay 1. */
  doorEdge?: Maybe<DoorsEdge>;
  /** Reads a single `DataPoint` that is related to this `Door`. */
  doorState?: Maybe<DataPoint>;
  /** Reads a single `Facility` that is related to this `Door`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `Door` mutation. */
export type UpsertDoorPayloadDoorEdgeArgs = {
  orderBy?: InputMaybe<Array<DoorsOrderBy>>;
};

/** Where conditions for the upsert `Door` mutation. */
export type UpsertDoorWhere = {
  facilityId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
};

/** All input for the upsert `Evaporator` mutation. */
export type UpsertEvaporatorInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Evaporator` to be upserted by this mutation. */
  evaporator: EvaporatorInput;
};

/** The output of our upsert `Evaporator` mutation. */
export type UpsertEvaporatorPayload = {
  __typename?: 'UpsertEvaporatorPayload';
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  ammoniaState?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  bleedSolenoid?: Maybe<DataPoint>;
  /** Reads a single `BuildingArea` that is related to this `Evaporator`. */
  buildingArea?: Maybe<BuildingArea>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  defrostState?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  defrostTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  defrostTimer?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  differentialAirTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  estimatedKwDemand?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  evapState?: Maybe<DataPoint>;
  /** The `Evaporator` that was upserted by this mutation. */
  evaporator?: Maybe<Evaporator>;
  /** An edge for our `Evaporator`. May be used by Relay 1. */
  evaporatorEdge?: Maybe<EvaporatorsEdge>;
  /** Reads a single `Facility` that is related to this `Evaporator`. */
  facility?: Maybe<Facility>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  fanState?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  fanTimer?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  hotGasSolenoid?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  liquidFeedRuntime?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  liquidFeedRuntimeSetpoint?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  liquidSolenoid?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  returnAirTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  setpoint?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  softHotGasSolenoid?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  suctionSolenoid?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  suctionTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  supplyAirTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  zoneTemperature?: Maybe<DataPoint>;
};

/** The output of our upsert `Evaporator` mutation. */
export type UpsertEvaporatorPayloadEvaporatorEdgeArgs = {
  orderBy?: InputMaybe<Array<EvaporatorsOrderBy>>;
};

/** Where conditions for the upsert `Evaporator` mutation. */
export type UpsertEvaporatorWhere = {
  facilityId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
};

/** All input for the upsert `FacilityTaggedDataPoint` mutation. */
export type UpsertFacilityTaggedDataPointInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `FacilityTaggedDataPoint` to be upserted by this mutation. */
  facilityTaggedDataPoint: FacilityTaggedDataPointInput;
};

/** The output of our upsert `FacilityTaggedDataPoint` mutation. */
export type UpsertFacilityTaggedDataPointPayload = {
  __typename?: 'UpsertFacilityTaggedDataPointPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `DataPoint` that is related to this `FacilityTaggedDataPoint`. */
  dataPoint?: Maybe<DataPoint>;
  /** Reads a single `Facility` that is related to this `FacilityTaggedDataPoint`. */
  facility?: Maybe<Facility>;
  /** The `FacilityTaggedDataPoint` that was upserted by this mutation. */
  facilityTaggedDataPoint?: Maybe<FacilityTaggedDataPoint>;
  /** An edge for our `FacilityTaggedDataPoint`. May be used by Relay 1. */
  facilityTaggedDataPointEdge?: Maybe<FacilityTaggedDataPointsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPointTag` that is related to this `FacilityTaggedDataPoint`. */
  tag?: Maybe<DataPointTag>;
};

/** The output of our upsert `FacilityTaggedDataPoint` mutation. */
export type UpsertFacilityTaggedDataPointPayloadFacilityTaggedDataPointEdgeArgs =
  {
    orderBy?: InputMaybe<Array<FacilityTaggedDataPointsOrderBy>>;
  };

/** Where conditions for the upsert `FacilityTaggedDataPoint` mutation. */
export type UpsertFacilityTaggedDataPointWhere = {
  dataPointId?: InputMaybe<Scalars['BigInt']>;
  facilityId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  tagId?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `InboundOutboundLoad` mutation. */
export type UpsertInboundOutboundLoadInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `InboundOutboundLoad` to be upserted by this mutation. */
  inboundOutboundLoad: InboundOutboundLoadInput;
};

/** The output of our upsert `InboundOutboundLoad` mutation. */
export type UpsertInboundOutboundLoadPayload = {
  __typename?: 'UpsertInboundOutboundLoadPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Facility` that is related to this `InboundOutboundLoad`. */
  facility?: Maybe<Facility>;
  /** The `InboundOutboundLoad` that was upserted by this mutation. */
  inboundOutboundLoad?: Maybe<InboundOutboundLoad>;
  /** An edge for our `InboundOutboundLoad`. May be used by Relay 1. */
  inboundOutboundLoadEdge?: Maybe<InboundOutboundLoadsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `InboundOutboundLoad` mutation. */
export type UpsertInboundOutboundLoadPayloadInboundOutboundLoadEdgeArgs = {
  orderBy?: InputMaybe<Array<InboundOutboundLoadsOrderBy>>;
};

/** Where conditions for the upsert `InboundOutboundLoad` mutation. */
export type UpsertInboundOutboundLoadWhere = {
  direction?: InputMaybe<WmsLoadDirectionType>;
  facilityId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['BigInt']>;
  sourceId?: InputMaybe<Scalars['String']>;
};

/** All input for the upsert `MachineUser` mutation. */
export type UpsertMachineUserInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `MachineUser` to be upserted by this mutation. */
  machineUser: MachineUserInput;
};

/** The output of our upsert `MachineUser` mutation. */
export type UpsertMachineUserPayload = {
  __typename?: 'UpsertMachineUserPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `MachineUser` that was upserted by this mutation. */
  machineUser?: Maybe<MachineUser>;
  /** An edge for our `MachineUser`. May be used by Relay 1. */
  machineUserEdge?: Maybe<MachineUsersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `MachineUser` mutation. */
export type UpsertMachineUserPayloadMachineUserEdgeArgs = {
  orderBy?: InputMaybe<Array<MachineUsersOrderBy>>;
};

/** Where conditions for the upsert `MachineUser` mutation. */
export type UpsertMachineUserWhere = {
  id?: InputMaybe<Scalars['BigInt']>;
};

/** All input for the upsert `MainService` mutation. */
export type UpsertMainServiceInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `MainService` to be upserted by this mutation. */
  mainService: MainServiceInput;
};

/** The output of our upsert `MainService` mutation. */
export type UpsertMainServicePayload = {
  __typename?: 'UpsertMainServicePayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  demand?: Maybe<DataPoint>;
  /** Reads a single `Facility` that is related to this `MainService`. */
  facility?: Maybe<Facility>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  gridDemand?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  gridUsage?: Maybe<DataPoint>;
  /** The `MainService` that was upserted by this mutation. */
  mainService?: Maybe<MainService>;
  /** An edge for our `MainService`. May be used by Relay 1. */
  mainServiceEdge?: Maybe<MainServicesEdge>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  meterDemand?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  meterUsage?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  usage?: Maybe<DataPoint>;
};

/** The output of our upsert `MainService` mutation. */
export type UpsertMainServicePayloadMainServiceEdgeArgs = {
  orderBy?: InputMaybe<Array<MainServicesOrderBy>>;
};

/** Where conditions for the upsert `MainService` mutation. */
export type UpsertMainServiceWhere = {
  demandDataPointId?: InputMaybe<Scalars['Int']>;
  facilityId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  usageDataPointId?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `MeterCharge` mutation. */
export type UpsertMeterChargeInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `MeterCharge` to be upserted by this mutation. */
  meterCharge: MeterChargeInput;
};

/** The output of our upsert `MeterCharge` mutation. */
export type UpsertMeterChargePayload = {
  __typename?: 'UpsertMeterChargePayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `MeterCharge` that was upserted by this mutation. */
  meterCharge?: Maybe<MeterCharge>;
  /** An edge for our `MeterCharge`. May be used by Relay 1. */
  meterChargeEdge?: Maybe<MeterChargesEdge>;
  /** Reads a single `MeterStatement` that is related to this `MeterCharge`. */
  meterStatement?: Maybe<MeterStatement>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `MeterCharge` mutation. */
export type UpsertMeterChargePayloadMeterChargeEdgeArgs = {
  orderBy?: InputMaybe<Array<MeterChargesOrderBy>>;
};

/** Where conditions for the upsert `MeterCharge` mutation. */
export type UpsertMeterChargeWhere = {
  category?: InputMaybe<UtilityMeterChargeCategory>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  lineNumber?: InputMaybe<Scalars['Int']>;
  meterStatementId?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `MeterStatement` mutation. */
export type UpsertMeterStatementInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `MeterStatement` to be upserted by this mutation. */
  meterStatement: MeterStatementInput;
};

/** The output of our upsert `MeterStatement` mutation. */
export type UpsertMeterStatementPayload = {
  __typename?: 'UpsertMeterStatementPayload';
  /** Reads a single `AccountStatement` that is related to this `MeterStatement`. */
  accountStatement?: Maybe<AccountStatement>;
  /** Reads a single `AccountStatementPdf` that is related to this `MeterStatement`. */
  accountStatementPdf?: Maybe<AccountStatementPdf>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `MeterStatement` that was upserted by this mutation. */
  meterStatement?: Maybe<MeterStatement>;
  /** An edge for our `MeterStatement`. May be used by Relay 1. */
  meterStatementEdge?: Maybe<MeterStatementsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UtilityMeter` that is related to this `MeterStatement`. */
  utilityMeter?: Maybe<UtilityMeter>;
};

/** The output of our upsert `MeterStatement` mutation. */
export type UpsertMeterStatementPayloadMeterStatementEdgeArgs = {
  orderBy?: InputMaybe<Array<MeterStatementsOrderBy>>;
};

/** Where conditions for the upsert `MeterStatement` mutation. */
export type UpsertMeterStatementWhere = {
  id?: InputMaybe<Scalars['Int']>;
  integrationKey?: InputMaybe<Scalars['String']>;
  statementDate?: InputMaybe<Scalars['Date']>;
};

/** All input for the upsert `MeterUsage` mutation. */
export type UpsertMeterUsageInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `MeterUsage` to be upserted by this mutation. */
  meterUsage: MeterUsageInput;
};

/** The output of our upsert `MeterUsage` mutation. */
export type UpsertMeterUsagePayload = {
  __typename?: 'UpsertMeterUsagePayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `MeterStatement` that is related to this `MeterUsage`. */
  meterStatement?: Maybe<MeterStatement>;
  /** The `MeterUsage` that was upserted by this mutation. */
  meterUsage?: Maybe<MeterUsage>;
  /** An edge for our `MeterUsage`. May be used by Relay 1. */
  meterUsageEdge?: Maybe<MeterUsagesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `MeterUsage` mutation. */
export type UpsertMeterUsagePayloadMeterUsageEdgeArgs = {
  orderBy?: InputMaybe<Array<MeterUsagesOrderBy>>;
};

/** Where conditions for the upsert `MeterUsage` mutation. */
export type UpsertMeterUsageWhere = {
  category?: InputMaybe<UtilityMeterUsageCategory>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  lineNumber?: InputMaybe<Scalars['Int']>;
  meterStatementId?: InputMaybe<Scalars['Int']>;
  units?: InputMaybe<Scalars['String']>;
};

/** All input for the upsert `PalletHistory` mutation. */
export type UpsertPalletHistoryInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PalletHistory` to be upserted by this mutation. */
  palletHistory: PalletHistoryInput;
};

/** The output of our upsert `PalletHistory` mutation. */
export type UpsertPalletHistoryPayload = {
  __typename?: 'UpsertPalletHistoryPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `PalletHistory` that was upserted by this mutation. */
  palletHistory?: Maybe<PalletHistory>;
  /** An edge for our `PalletHistory`. May be used by Relay 1. */
  palletHistoryEdge?: Maybe<PalletHistoriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `PalletHistory` mutation. */
export type UpsertPalletHistoryPayloadPalletHistoryEdgeArgs = {
  orderBy?: InputMaybe<Array<PalletHistoriesOrderBy>>;
};

/** Where conditions for the upsert `PalletHistory` mutation. */
export type UpsertPalletHistoryWhere = {
  id?: InputMaybe<Scalars['BigInt']>;
  sourceId?: InputMaybe<Scalars['String']>;
};

/** All input for the upsert `Pallet` mutation. */
export type UpsertPalletInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Pallet` to be upserted by this mutation. */
  pallet: PalletInput;
};

/** All input for the upsert `PalletLocation` mutation. */
export type UpsertPalletLocationInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PalletLocation` to be upserted by this mutation. */
  palletLocation: PalletLocationInput;
};

/** The output of our upsert `PalletLocation` mutation. */
export type UpsertPalletLocationPayload = {
  __typename?: 'UpsertPalletLocationPayload';
  /** Reads a single `BuildingArea` that is related to this `PalletLocation`. */
  buildingArea?: Maybe<BuildingArea>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Facility` that is related to this `PalletLocation`. */
  facility?: Maybe<Facility>;
  /** The `PalletLocation` that was upserted by this mutation. */
  palletLocation?: Maybe<PalletLocation>;
  /** An edge for our `PalletLocation`. May be used by Relay 1. */
  palletLocationEdge?: Maybe<PalletLocationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `PalletLocation` mutation. */
export type UpsertPalletLocationPayloadPalletLocationEdgeArgs = {
  orderBy?: InputMaybe<Array<PalletLocationsOrderBy>>;
};

/** Where conditions for the upsert `PalletLocation` mutation. */
export type UpsertPalletLocationWhere = {
  id?: InputMaybe<Scalars['BigInt']>;
  sourceId?: InputMaybe<Scalars['String']>;
};

/** The output of our upsert `Pallet` mutation. */
export type UpsertPalletPayload = {
  __typename?: 'UpsertPalletPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Pallet` that was upserted by this mutation. */
  pallet?: Maybe<Pallet>;
  /** An edge for our `Pallet`. May be used by Relay 1. */
  palletEdge?: Maybe<PalletsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `Pallet` mutation. */
export type UpsertPalletPayloadPalletEdgeArgs = {
  orderBy?: InputMaybe<Array<PalletsOrderBy>>;
};

/** Where conditions for the upsert `Pallet` mutation. */
export type UpsertPalletWhere = {
  id?: InputMaybe<Scalars['BigInt']>;
  sourceId?: InputMaybe<Scalars['String']>;
};

/** All input for the upsert `PricingNode` mutation. */
export type UpsertPricingNodeInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PricingNode` to be upserted by this mutation. */
  pricingNode: PricingNodeInput;
};

/** The output of our upsert `PricingNode` mutation. */
export type UpsertPricingNodePayload = {
  __typename?: 'UpsertPricingNodePayload';
  /** Reads a single `BalancingAuthority` that is related to this `PricingNode`. */
  balancingAuthority?: Maybe<BalancingAuthority>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `PricingNode` that was upserted by this mutation. */
  pricingNode?: Maybe<PricingNode>;
  /** An edge for our `PricingNode`. May be used by Relay 1. */
  pricingNodeEdge?: Maybe<PricingNodesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `PricingNode` mutation. */
export type UpsertPricingNodePayloadPricingNodeEdgeArgs = {
  orderBy?: InputMaybe<Array<PricingNodesOrderBy>>;
};

/** Where conditions for the upsert `PricingNode` mutation. */
export type UpsertPricingNodeWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `Product` mutation. */
export type UpsertProductInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Product` to be upserted by this mutation. */
  product: ProductInput;
};

/** The output of our upsert `Product` mutation. */
export type UpsertProductPayload = {
  __typename?: 'UpsertProductPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Facility` that is related to this `Product`. */
  facility?: Maybe<Facility>;
  /** The `Product` that was upserted by this mutation. */
  product?: Maybe<Product>;
  /** An edge for our `Product`. May be used by Relay 1. */
  productEdge?: Maybe<ProductsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `Product` mutation. */
export type UpsertProductPayloadProductEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};

/** Where conditions for the upsert `Product` mutation. */
export type UpsertProductWhere = {
  id?: InputMaybe<Scalars['BigInt']>;
  sourceId?: InputMaybe<Scalars['String']>;
};

/** All input for the upsert `ProgramEnrollment` mutation. */
export type UpsertProgramEnrollmentInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProgramEnrollment` to be upserted by this mutation. */
  programEnrollment: ProgramEnrollmentInput;
};

/** The output of our upsert `ProgramEnrollment` mutation. */
export type UpsertProgramEnrollmentPayload = {
  __typename?: 'UpsertProgramEnrollmentPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Program` that is related to this `ProgramEnrollment`. */
  program?: Maybe<Program>;
  /** The `ProgramEnrollment` that was upserted by this mutation. */
  programEnrollment?: Maybe<ProgramEnrollment>;
  /** An edge for our `ProgramEnrollment`. May be used by Relay 1. */
  programEnrollmentEdge?: Maybe<ProgramEnrollmentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `ProgramEnrollment` mutation. */
export type UpsertProgramEnrollmentPayloadProgramEnrollmentEdgeArgs = {
  orderBy?: InputMaybe<Array<ProgramEnrollmentsOrderBy>>;
};

/** Where conditions for the upsert `ProgramEnrollment` mutation. */
export type UpsertProgramEnrollmentWhere = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  programId?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `Program` mutation. */
export type UpsertProgramInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Program` to be upserted by this mutation. */
  program: ProgramInput;
};

/** The output of our upsert `Program` mutation. */
export type UpsertProgramPayload = {
  __typename?: 'UpsertProgramPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Program` that was upserted by this mutation. */
  program?: Maybe<Program>;
  /** An edge for our `Program`. May be used by Relay 1. */
  programEdge?: Maybe<ProgramsEdge>;
  /** Reads a single `ProjectType` that is related to this `Program`. */
  projectType?: Maybe<ProjectType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `Program` mutation. */
export type UpsertProgramPayloadProgramEdgeArgs = {
  orderBy?: InputMaybe<Array<ProgramsOrderBy>>;
};

/** Where conditions for the upsert `Program` mutation. */
export type UpsertProgramWhere = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  projectTypeId?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `ProjectComponent` mutation. */
export type UpsertProjectComponentInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProjectComponent` to be upserted by this mutation. */
  projectComponent: ProjectComponentInput;
};

/** The output of our upsert `ProjectComponent` mutation. */
export type UpsertProjectComponentPayload = {
  __typename?: 'UpsertProjectComponentPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Component` that is related to this `ProjectComponent`. */
  component?: Maybe<Component>;
  /** Reads a single `Project` that is related to this `ProjectComponent`. */
  project?: Maybe<Project>;
  /** The `ProjectComponent` that was upserted by this mutation. */
  projectComponent?: Maybe<ProjectComponent>;
  /** An edge for our `ProjectComponent`. May be used by Relay 1. */
  projectComponentEdge?: Maybe<ProjectComponentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `ProjectComponent` mutation. */
export type UpsertProjectComponentPayloadProjectComponentEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectComponentsOrderBy>>;
};

/** Where conditions for the upsert `ProjectComponent` mutation. */
export type UpsertProjectComponentWhere = {
  componentId?: InputMaybe<Scalars['Int']>;
  projectId?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `ProjectEnrollmentDataPointGroup` mutation. */
export type UpsertProjectEnrollmentDataPointGroupInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProjectEnrollmentDataPointGroup` to be upserted by this mutation. */
  projectEnrollmentDataPointGroup: ProjectEnrollmentDataPointGroupInput;
};

/** The output of our upsert `ProjectEnrollmentDataPointGroup` mutation. */
export type UpsertProjectEnrollmentDataPointGroupPayload = {
  __typename?: 'UpsertProjectEnrollmentDataPointGroupPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ProjectEnrollmentDataPointGroup` that was upserted by this mutation. */
  projectEnrollmentDataPointGroup?: Maybe<ProjectEnrollmentDataPointGroup>;
  /** An edge for our `ProjectEnrollmentDataPointGroup`. May be used by Relay 1. */
  projectEnrollmentDataPointGroupEdge?: Maybe<ProjectEnrollmentDataPointGroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `ProjectEnrollmentDataPointGroup` mutation. */
export type UpsertProjectEnrollmentDataPointGroupPayloadProjectEnrollmentDataPointGroupEdgeArgs =
  {
    orderBy?: InputMaybe<Array<ProjectEnrollmentDataPointGroupsOrderBy>>;
  };

/** Where conditions for the upsert `ProjectEnrollmentDataPointGroup` mutation. */
export type UpsertProjectEnrollmentDataPointGroupWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `ProjectEnrollmentDataPoint` mutation. */
export type UpsertProjectEnrollmentDataPointInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProjectEnrollmentDataPoint` to be upserted by this mutation. */
  projectEnrollmentDataPoint: ProjectEnrollmentDataPointInput;
};

/** The output of our upsert `ProjectEnrollmentDataPoint` mutation. */
export type UpsertProjectEnrollmentDataPointPayload = {
  __typename?: 'UpsertProjectEnrollmentDataPointPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `DataPoint` that is related to this `ProjectEnrollmentDataPoint`. */
  dataPoint?: Maybe<DataPoint>;
  /** Reads a single `ProjectEnrollmentDataPointGroup` that is related to this `ProjectEnrollmentDataPoint`. */
  group?: Maybe<ProjectEnrollmentDataPointGroup>;
  /** Reads a single `ProjectEnrollment` that is related to this `ProjectEnrollmentDataPoint`. */
  projectEnrollment?: Maybe<ProjectEnrollment>;
  /** The `ProjectEnrollmentDataPoint` that was upserted by this mutation. */
  projectEnrollmentDataPoint?: Maybe<ProjectEnrollmentDataPoint>;
  /** An edge for our `ProjectEnrollmentDataPoint`. May be used by Relay 1. */
  projectEnrollmentDataPointEdge?: Maybe<ProjectEnrollmentDataPointsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `ProjectEnrollmentDataPoint` mutation. */
export type UpsertProjectEnrollmentDataPointPayloadProjectEnrollmentDataPointEdgeArgs =
  {
    orderBy?: InputMaybe<Array<ProjectEnrollmentDataPointsOrderBy>>;
  };

/** Where conditions for the upsert `ProjectEnrollmentDataPoint` mutation. */
export type UpsertProjectEnrollmentDataPointWhere = {
  dataPointId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  projectEnrollmentId?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `ProjectEnrollment` mutation. */
export type UpsertProjectEnrollmentInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProjectEnrollment` to be upserted by this mutation. */
  projectEnrollment: ProjectEnrollmentInput;
};

/** The output of our upsert `ProjectEnrollment` mutation. */
export type UpsertProjectEnrollmentPayload = {
  __typename?: 'UpsertProjectEnrollmentPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `ProgramEnrollment` that is related to this `ProjectEnrollment`. */
  programEnrollment?: Maybe<ProgramEnrollment>;
  /** Reads a single `Project` that is related to this `ProjectEnrollment`. */
  project?: Maybe<Project>;
  /** The `ProjectEnrollment` that was upserted by this mutation. */
  projectEnrollment?: Maybe<ProjectEnrollment>;
  /** An edge for our `ProjectEnrollment`. May be used by Relay 1. */
  projectEnrollmentEdge?: Maybe<ProjectEnrollmentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `ProjectEnrollment` mutation. */
export type UpsertProjectEnrollmentPayloadProjectEnrollmentEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectEnrollmentsOrderBy>>;
};

/** Where conditions for the upsert `ProjectEnrollment` mutation. */
export type UpsertProjectEnrollmentWhere = {
  id?: InputMaybe<Scalars['Int']>;
  programEnrollmentId?: InputMaybe<Scalars['Int']>;
  projectId?: InputMaybe<Scalars['Int']>;
};

/** All input for the `upsertProjectSubscription` mutation. */
export type UpsertProjectSubscriptionInput = {
  channels?: InputMaybe<Array<InputMaybe<UserSubscriptionChannel>>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['Int']>;
};

/** The output of our `upsertProjectSubscription` mutation. */
export type UpsertProjectSubscriptionPayload = {
  __typename?: 'UpsertProjectSubscriptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  userSubscriptions?: Maybe<Array<UserSubscription>>;
};

/** All input for the upsert `ProjectWatcher` mutation. */
export type UpsertProjectWatcherInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProjectWatcher` to be upserted by this mutation. */
  projectWatcher: ProjectWatcherInput;
};

/** The output of our upsert `ProjectWatcher` mutation. */
export type UpsertProjectWatcherPayload = {
  __typename?: 'UpsertProjectWatcherPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Project` that is related to this `ProjectWatcher`. */
  project?: Maybe<Project>;
  /** The `ProjectWatcher` that was upserted by this mutation. */
  projectWatcher?: Maybe<ProjectWatcher>;
  /** An edge for our `ProjectWatcher`. May be used by Relay 1. */
  projectWatcherEdge?: Maybe<ProjectWatchersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `ProjectWatcher`. */
  user?: Maybe<User>;
};

/** The output of our upsert `ProjectWatcher` mutation. */
export type UpsertProjectWatcherPayloadProjectWatcherEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectWatchersOrderBy>>;
};

/** Where conditions for the upsert `ProjectWatcher` mutation. */
export type UpsertProjectWatcherWhere = {
  projectId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** All input for the upsert `ReportExecution` mutation. */
export type UpsertReportExecutionInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ReportExecution` to be upserted by this mutation. */
  reportExecution: ReportExecutionInput;
};

/** The output of our upsert `ReportExecution` mutation. */
export type UpsertReportExecutionPayload = {
  __typename?: 'UpsertReportExecutionPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Report` that is related to this `ReportExecution`. */
  report?: Maybe<Report>;
  /** The `ReportExecution` that was upserted by this mutation. */
  reportExecution?: Maybe<ReportExecution>;
  /** An edge for our `ReportExecution`. May be used by Relay 1. */
  reportExecutionEdge?: Maybe<ReportExecutionsEdge>;
};

/** The output of our upsert `ReportExecution` mutation. */
export type UpsertReportExecutionPayloadReportExecutionEdgeArgs = {
  orderBy?: InputMaybe<Array<ReportExecutionsOrderBy>>;
};

/** Where conditions for the upsert `ReportExecution` mutation. */
export type UpsertReportExecutionWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `ReportQuery` mutation. */
export type UpsertReportQueryInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ReportQuery` to be upserted by this mutation. */
  reportQuery: ReportQueryInput;
};

/** The output of our upsert `ReportQuery` mutation. */
export type UpsertReportQueryPayload = {
  __typename?: 'UpsertReportQueryPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Report` that is related to this `ReportQuery`. */
  report?: Maybe<Report>;
  /** The `ReportQuery` that was upserted by this mutation. */
  reportQuery?: Maybe<ReportQuery>;
  /** An edge for our `ReportQuery`. May be used by Relay 1. */
  reportQueryEdge?: Maybe<ReportQueriesEdge>;
};

/** The output of our upsert `ReportQuery` mutation. */
export type UpsertReportQueryPayloadReportQueryEdgeArgs = {
  orderBy?: InputMaybe<Array<ReportQueriesOrderBy>>;
};

/** Where conditions for the upsert `ReportQuery` mutation. */
export type UpsertReportQueryWhere = {
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  reportId?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `SavingsEvent` mutation. */
export type UpsertSavingsEventInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SavingsEvent` to be upserted by this mutation. */
  savingsEvent: SavingsEventInput;
};

/** The output of our upsert `SavingsEvent` mutation. */
export type UpsertSavingsEventPayload = {
  __typename?: 'UpsertSavingsEventPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Project` that is related to this `SavingsEvent`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SavingsEvent` that was upserted by this mutation. */
  savingsEvent?: Maybe<SavingsEvent>;
  /** An edge for our `SavingsEvent`. May be used by Relay 1. */
  savingsEventEdge?: Maybe<SavingsEventsEdge>;
};

/** The output of our upsert `SavingsEvent` mutation. */
export type UpsertSavingsEventPayloadSavingsEventEdgeArgs = {
  orderBy?: InputMaybe<Array<SavingsEventsOrderBy>>;
};

/** Where conditions for the upsert `SavingsEvent` mutation. */
export type UpsertSavingsEventWhere = {
  endTime?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  projectId?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['Datetime']>;
};

/** All input for the upsert `SuggestionControlEvent` mutation. */
export type UpsertSuggestionControlEventInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SuggestionControlEvent` to be upserted by this mutation. */
  suggestionControlEvent: SuggestionControlEventInput;
};

/** The output of our upsert `SuggestionControlEvent` mutation. */
export type UpsertSuggestionControlEventPayload = {
  __typename?: 'UpsertSuggestionControlEventPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `ControlEvent` that is related to this `SuggestionControlEvent`. */
  controlEvent?: Maybe<ControlEvent>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Suggestion` that is related to this `SuggestionControlEvent`. */
  suggestion?: Maybe<Suggestion>;
  /** The `SuggestionControlEvent` that was upserted by this mutation. */
  suggestionControlEvent?: Maybe<SuggestionControlEvent>;
};

/** Where conditions for the upsert `SuggestionControlEvent` mutation. */
export type UpsertSuggestionControlEventWhere = {
  controlEventId?: InputMaybe<Scalars['Int']>;
  suggestionId?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `TemperatureSensor` mutation. */
export type UpsertTemperatureSensorInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TemperatureSensor` to be upserted by this mutation. */
  temperatureSensor: TemperatureSensorInput;
};

/** The output of our upsert `TemperatureSensor` mutation. */
export type UpsertTemperatureSensorPayload = {
  __typename?: 'UpsertTemperatureSensorPayload';
  /** Reads a single `DataPoint` that is related to this `TemperatureSensor`. */
  battery?: Maybe<DataPoint>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Facility` that is related to this `TemperatureSensor`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `TemperatureSensor`. */
  signal?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `TemperatureSensor`. */
  temperature?: Maybe<DataPoint>;
  /** The `TemperatureSensor` that was upserted by this mutation. */
  temperatureSensor?: Maybe<TemperatureSensor>;
  /** An edge for our `TemperatureSensor`. May be used by Relay 1. */
  temperatureSensorEdge?: Maybe<TemperatureSensorsEdge>;
};

/** The output of our upsert `TemperatureSensor` mutation. */
export type UpsertTemperatureSensorPayloadTemperatureSensorEdgeArgs = {
  orderBy?: InputMaybe<Array<TemperatureSensorsOrderBy>>;
};

/** Where conditions for the upsert `TemperatureSensor` mutation. */
export type UpsertTemperatureSensorWhere = {
  facilityId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
};

/** All input for the upsert `TrailerPosition` mutation. */
export type UpsertTrailerPositionInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TrailerPosition` to be upserted by this mutation. */
  trailerPosition: TrailerPositionInput;
};

/** The output of our upsert `TrailerPosition` mutation. */
export type UpsertTrailerPositionPayload = {
  __typename?: 'UpsertTrailerPositionPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Facility` that is related to this `TrailerPosition`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `TrailerPosition`. */
  trailerIsPresent?: Maybe<DataPoint>;
  /** The `TrailerPosition` that was upserted by this mutation. */
  trailerPosition?: Maybe<TrailerPosition>;
  /** An edge for our `TrailerPosition`. May be used by Relay 1. */
  trailerPositionEdge?: Maybe<TrailerPositionsEdge>;
};

/** The output of our upsert `TrailerPosition` mutation. */
export type UpsertTrailerPositionPayloadTrailerPositionEdgeArgs = {
  orderBy?: InputMaybe<Array<TrailerPositionsOrderBy>>;
};

/** Where conditions for the upsert `TrailerPosition` mutation. */
export type UpsertTrailerPositionWhere = {
  facilityId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
};

/** All input for the `upsertUrjanetUtilityProvider` mutation. */
export type UpsertUrjanetUtilityProviderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  urjanetSlug: Scalars['String'];
};

/** The output of our `upsertUrjanetUtilityProvider` mutation. */
export type UpsertUrjanetUtilityProviderPayload = {
  __typename?: 'UpsertUrjanetUtilityProviderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  recordId?: Maybe<Scalars['Int']>;
};

/** All input for the upsert `UtilityAccount` mutation. */
export type UpsertUtilityAccountInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UtilityAccount` to be upserted by this mutation. */
  utilityAccount: UtilityAccountInput;
};

/** The output of our upsert `UtilityAccount` mutation. */
export type UpsertUtilityAccountPayload = {
  __typename?: 'UpsertUtilityAccountPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UtilityAccount` that was upserted by this mutation. */
  utilityAccount?: Maybe<UtilityAccount>;
  /** An edge for our `UtilityAccount`. May be used by Relay 1. */
  utilityAccountEdge?: Maybe<UtilityAccountsEdge>;
  /** Reads a single `UtilityProvider` that is related to this `UtilityAccount`. */
  utilityProvider?: Maybe<UtilityProvider>;
};

/** The output of our upsert `UtilityAccount` mutation. */
export type UpsertUtilityAccountPayloadUtilityAccountEdgeArgs = {
  orderBy?: InputMaybe<Array<UtilityAccountsOrderBy>>;
};

/** Where conditions for the upsert `UtilityAccount` mutation. */
export type UpsertUtilityAccountWhere = {
  id?: InputMaybe<Scalars['Int']>;
  integration?: InputMaybe<UtilityIntegration>;
  integrationAccountKey?: InputMaybe<Scalars['String']>;
};

/** All input for the upsert `UtilityMeter` mutation. */
export type UpsertUtilityMeterInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UtilityMeter` to be upserted by this mutation. */
  utilityMeter: UtilityMeterInput;
};

/** The output of our upsert `UtilityMeter` mutation. */
export type UpsertUtilityMeterPayload = {
  __typename?: 'UpsertUtilityMeterPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Facility` that is related to this `UtilityMeter`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UtilityAccount` that is related to this `UtilityMeter`. */
  utilityAccount?: Maybe<UtilityAccount>;
  /** The `UtilityMeter` that was upserted by this mutation. */
  utilityMeter?: Maybe<UtilityMeter>;
  /** An edge for our `UtilityMeter`. May be used by Relay 1. */
  utilityMeterEdge?: Maybe<UtilityMetersEdge>;
};

/** The output of our upsert `UtilityMeter` mutation. */
export type UpsertUtilityMeterPayloadUtilityMeterEdgeArgs = {
  orderBy?: InputMaybe<Array<UtilityMetersOrderBy>>;
};

/** Where conditions for the upsert `UtilityMeter` mutation. */
export type UpsertUtilityMeterWhere = {
  id?: InputMaybe<Scalars['Int']>;
  integrationMeterKey?: InputMaybe<Scalars['String']>;
  serviceType?: InputMaybe<UtilityMeterServiceType>;
  utilityAccountId?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `UtilityProvider` mutation. */
export type UpsertUtilityProviderInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UtilityProvider` to be upserted by this mutation. */
  utilityProvider: UtilityProviderInput;
};

/** The output of our upsert `UtilityProvider` mutation. */
export type UpsertUtilityProviderPayload = {
  __typename?: 'UpsertUtilityProviderPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UtilityProvider` that was upserted by this mutation. */
  utilityProvider?: Maybe<UtilityProvider>;
  /** An edge for our `UtilityProvider`. May be used by Relay 1. */
  utilityProviderEdge?: Maybe<UtilityProvidersEdge>;
};

/** The output of our upsert `UtilityProvider` mutation. */
export type UpsertUtilityProviderPayloadUtilityProviderEdgeArgs = {
  orderBy?: InputMaybe<Array<UtilityProvidersOrderBy>>;
};

/** Where conditions for the upsert `UtilityProvider` mutation. */
export type UpsertUtilityProviderWhere = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** All input for the upsert `VendorUserMachineUser` mutation. */
export type UpsertVendorUserMachineUserInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `VendorUserMachineUser` to be upserted by this mutation. */
  vendorUserMachineUser: VendorUserMachineUserInput;
};

/** The output of our upsert `VendorUserMachineUser` mutation. */
export type UpsertVendorUserMachineUserPayload = {
  __typename?: 'UpsertVendorUserMachineUserPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VendorUserMachineUser` that was upserted by this mutation. */
  vendorUserMachineUser?: Maybe<VendorUserMachineUser>;
};

/** Where conditions for the upsert `VendorUserMachineUser` mutation. */
export type UpsertVendorUserMachineUserWhere = {
  machineUserId?: InputMaybe<Scalars['BigInt']>;
  vendorUserId?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `VirtualPointInterval` mutation. */
export type UpsertVirtualPointIntervalInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `VirtualPointInterval` to be upserted by this mutation. */
  virtualPointInterval: VirtualPointIntervalInput;
};

/** The output of our upsert `VirtualPointInterval` mutation. */
export type UpsertVirtualPointIntervalPayload = {
  __typename?: 'UpsertVirtualPointIntervalPayload';
  /** Reads a single `DataPoint` that is related to this `VirtualPointInterval`. */
  child?: Maybe<DataPoint>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `DataPoint` that is related to this `VirtualPointInterval`. */
  parent?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VirtualPointInterval` that was upserted by this mutation. */
  virtualPointInterval?: Maybe<VirtualPointInterval>;
  /** An edge for our `VirtualPointInterval`. May be used by Relay 1. */
  virtualPointIntervalEdge?: Maybe<VirtualPointIntervalsEdge>;
};

/** The output of our upsert `VirtualPointInterval` mutation. */
export type UpsertVirtualPointIntervalPayloadVirtualPointIntervalEdgeArgs = {
  orderBy?: InputMaybe<Array<VirtualPointIntervalsOrderBy>>;
};

/** Where conditions for the upsert `VirtualPointInterval` mutation. */
export type UpsertVirtualPointIntervalWhere = {
  childId?: InputMaybe<Scalars['BigInt']>;
  parentId?: InputMaybe<Scalars['BigInt']>;
};

/** A user. */
export type User = Node & {
  __typename?: 'User';
  /** Returns the user`s access tokens. */
  accessTokens: PlatformAccessTokensConnection;
  /** The time the user was created. */
  createdAt: Scalars['Datetime'];
  /** The user’s email address. */
  email?: Maybe<Scalars['String']>;
  /** Returns the facilities that the user has favorited. */
  favoriteFacilities: FacilitiesConnection;
  /** The user’s first name. */
  firstName?: Maybe<Scalars['String']>;
  /** The primary unique identifier of the user. */
  id: Scalars['String'];
  /** The user’s last name. */
  lastName?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Available permissions for the User. */
  permissions?: Maybe<UserPermissions>;
  /** The user’s phone number. */
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumberValidated: Scalars['Boolean'];
  preferredLocale?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `ProjectWatcher`. */
  projectWatchers: ProjectWatchersConnection;
  /** The time the user was updated . */
  updatedAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `Project`. */
  watchedProjects: ProjectsConnection;
};

/** A user. */
export type UserAccessTokensArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<PlatformAccessTokenFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** A user. */
export type UserFavoriteFacilitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<FacilityFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** A user. */
export type UserProjectWatchersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectWatcherCondition>;
  filter?: InputMaybe<ProjectWatcherFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectWatchersOrderBy>>;
};

/** A user. */
export type UserWatchedProjectsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<ProjectFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** A condition to be used against `User` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type UserCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `lastName` field. */
  lastName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `phoneNumber` field. */
  phoneNumber?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `phoneNumberValidated` field. */
  phoneNumberValidated?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `preferredLocale` field. */
  preferredLocale?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `User` object types. All fields are combined with a logical ‘and.’ */
export type UserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserFilter>>;
  /** Filter by the permission canEdit */
  canEdit?: InputMaybe<PermissionBooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `firstName` field. */
  firstName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lastName` field. */
  lastName?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserFilter>>;
  /** Filter by the object’s `phoneNumber` field. */
  phoneNumber?: InputMaybe<StringFilter>;
  /** Filter by the object’s `phoneNumberValidated` field. */
  phoneNumberValidated?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `preferredLocale` field. */
  preferredLocale?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

export type UserIdentity = Identity & {
  __typename?: 'UserIdentity';
  authorizationType: Scalars['String'];
  id: Scalars['String'];
  type: AccessTokenType;
  user: User;
};

/** Represents an update to a `User`. Fields that are set will be updated. */
export type UserPatch = {
  phoneNumberValidated?: InputMaybe<Scalars['Boolean']>;
  preferredLocale?: InputMaybe<Scalars['String']>;
};

/** Permissive capabilities on a User. */
export type UserPermissions = {
  __typename?: 'UserPermissions';
  /** Whether a user can edit the settings of a user. */
  canEdit: Scalars['Boolean'];
};

/** A user subscription for a specific event type and action. */
export type UserSubscription = Node & {
  __typename?: 'UserSubscription';
  /** The associated action. */
  action?: Maybe<Scalars['String']>;
  channels: Scalars['JSON'];
  /** The time the subscription was created. */
  createdAt: Scalars['Datetime'];
  /** Reads a single `EventType` that is related to this `UserSubscription`. */
  eventTypeByType?: Maybe<EventType>;
  /** The identifier of the subscription. */
  id: Scalars['BigInt'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  scope: Scalars['JSON'];
  /** The type of event. */
  type: Scalars['String'];
  /** The time the subscription was updated. */
  updatedAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `UserSubscription`. */
  user?: Maybe<User>;
  /** The associated User. */
  userId: Scalars['String'];
};

export enum UserSubscriptionChannel {
  EMAIL = 'EMAIL',
  SMS = 'SMS'
}

/** A filter to be used against UserSubscriptionChannel List fields. All fields are combined with a logical ‘and.’ */
export type UserSubscriptionChannelListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<UserSubscriptionChannel>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<UserSubscriptionChannel>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<UserSubscriptionChannel>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<UserSubscriptionChannel>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<UserSubscriptionChannel>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<UserSubscriptionChannel>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<UserSubscriptionChannel>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<UserSubscriptionChannel>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<UserSubscriptionChannel>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<UserSubscriptionChannel>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<UserSubscriptionChannel>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<UserSubscriptionChannel>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<UserSubscriptionChannel>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<UserSubscriptionChannel>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<UserSubscriptionChannel>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<UserSubscriptionChannel>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<UserSubscriptionChannel>>>;
};

/** A filter to be used against `UserSubscription` object types. All fields are combined with a logical ‘and.’ */
export type UserSubscriptionFilter = {
  /** Filter by the object’s `action` field. */
  action?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserSubscriptionFilter>>;
  /** Filter by the object’s `channels` field. */
  channels?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserSubscriptionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserSubscriptionFilter>>;
  /** Filter by the object’s `scope` field. */
  scope?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<StringFilter>;
};

/** A connection to a list of `UserSubscription` values. */
export type UserSubscriptionsConnection = {
  __typename?: 'UserSubscriptionsConnection';
  /** A list of edges which contains the `UserSubscription` and cursor to aid in pagination. */
  edges: Array<UserSubscriptionsEdge>;
  /** A list of `UserSubscription` objects. */
  nodes: Array<UserSubscription>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserSubscription` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserSubscription` edge in the connection. */
export type UserSubscriptionsEdge = {
  __typename?: 'UserSubscriptionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserSubscription` at the end of the edge. */
  node: UserSubscription;
};

/** A connection to a list of `User` values. */
export type UsersConnection = {
  __typename?: 'UsersConnection';
  /** A list of edges which contains the `User` and cursor to aid in pagination. */
  edges: Array<UsersEdge>;
  /** A list of `User` objects. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection. */
export type UsersEdge = {
  __typename?: 'UsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: User;
};

/** Methods to use when ordering `User`. */
export enum UsersOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  EMAIL_ASC = 'EMAIL_ASC',
  EMAIL_DESC = 'EMAIL_DESC',
  FIRST_NAME_ASC = 'FIRST_NAME_ASC',
  FIRST_NAME_DESC = 'FIRST_NAME_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LAST_NAME_ASC = 'LAST_NAME_ASC',
  LAST_NAME_DESC = 'LAST_NAME_DESC',
  NATURAL = 'NATURAL',
  PHONE_NUMBER_ASC = 'PHONE_NUMBER_ASC',
  PHONE_NUMBER_DESC = 'PHONE_NUMBER_DESC',
  PHONE_NUMBER_VALIDATED_ASC = 'PHONE_NUMBER_VALIDATED_ASC',
  PHONE_NUMBER_VALIDATED_DESC = 'PHONE_NUMBER_VALIDATED_DESC',
  PREFERRED_LOCALE_ASC = 'PREFERRED_LOCALE_ASC',
  PREFERRED_LOCALE_DESC = 'PREFERRED_LOCALE_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A utility account. */
export type UtilityAccount = Node & {
  __typename?: 'UtilityAccount';
  /** The account’s number. */
  accountNumber: Scalars['String'];
  /** Reads and enables pagination through a set of `AccountStatement`. */
  accountStatements: AccountStatementsConnection;
  /** The time the account was created. */
  createdAt: Scalars['Datetime'];
  /** The time the account was deleted. */
  deletedAt?: Maybe<Scalars['Datetime']>;
  displayName?: Maybe<Scalars['String']>;
  /** The primary unique identifier of the account. */
  id: Scalars['Int'];
  /** The integration that owns the account. */
  integration: UtilityIntegration;
  /** The identifier in the integration’s system. */
  integrationAccountKey: Scalars['String'];
  /** Extra metadata about the account. */
  metadata: Scalars['JSON'];
  /** Returns a set of year/month combinations that are missing as statements across all meters for a given account. Also provides a list of `UtilityMeters` that correspond to the missing bills for each year/month combiantion. */
  missingStatements: AccountMissingStatementsConnection;
  /** The account’s name. */
  name?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The time the account was updated. */
  updatedAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `UtilityAccountStatementRollup`. */
  utilityAccountStatementRollups: UtilityAccountStatementRollupsConnection;
  /** Reads and enables pagination through a set of `UtilityAccountStatement`. */
  utilityAccountStatements: UtilityAccountStatementsConnection;
  /** Reads and enables pagination through a set of `UtilityMeterStatementRollup`. */
  utilityMeterStatementRollups: UtilityMeterStatementRollupsConnection;
  /** Reads and enables pagination through a set of `UtilityMeterStatement`. */
  utilityMeterStatements: UtilityMeterStatementsConnection;
  /** Reads and enables pagination through a set of `UtilityMeter`. */
  utilityMeters: UtilityMetersConnection;
  /** Reads a single `UtilityProvider` that is related to this `UtilityAccount`. */
  utilityProvider?: Maybe<UtilityProvider>;
  /** The account’s provider. */
  utilityProviderId: Scalars['Int'];
};

/** A utility account. */
export type UtilityAccountAccountStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountStatementCondition>;
  filter?: InputMaybe<AccountStatementFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountStatementsOrderBy>>;
};

/** A utility account. */
export type UtilityAccountMissingStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  facilityId?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<AccountMissingStatementFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** A utility account. */
export type UtilityAccountUtilityAccountStatementRollupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UtilityAccountStatementRollupCondition>;
  filter?: InputMaybe<UtilityAccountStatementRollupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UtilityAccountStatementRollupsOrderBy>>;
};

/** A utility account. */
export type UtilityAccountUtilityAccountStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UtilityAccountStatementCondition>;
  filter?: InputMaybe<UtilityAccountStatementFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UtilityAccountStatementsOrderBy>>;
};

/** A utility account. */
export type UtilityAccountUtilityMeterStatementRollupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UtilityMeterStatementRollupCondition>;
  filter?: InputMaybe<UtilityMeterStatementRollupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UtilityMeterStatementRollupsOrderBy>>;
};

/** A utility account. */
export type UtilityAccountUtilityMeterStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UtilityMeterStatementCondition>;
  filter?: InputMaybe<UtilityMeterStatementFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UtilityMeterStatementsOrderBy>>;
};

/** A utility account. */
export type UtilityAccountUtilityMetersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UtilityMeterCondition>;
  filter?: InputMaybe<UtilityMeterFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UtilityMetersOrderBy>>;
};

export enum UtilityAccountChargeCategory {
  CREDITS = 'CREDITS',
  DEMAND = 'DEMAND',
  FEES = 'FEES',
  TAXES = 'TAXES',
  USAGE = 'USAGE'
}

/** A filter to be used against UtilityAccountChargeCategory fields. All fields are combined with a logical ‘and.’ */
export type UtilityAccountChargeCategoryFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<UtilityAccountChargeCategory>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<UtilityAccountChargeCategory>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<UtilityAccountChargeCategory>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<UtilityAccountChargeCategory>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<UtilityAccountChargeCategory>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<UtilityAccountChargeCategory>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<UtilityAccountChargeCategory>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<UtilityAccountChargeCategory>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<UtilityAccountChargeCategory>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<UtilityAccountChargeCategory>>;
};

/**
 * A condition to be used against `UtilityAccount` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UtilityAccountCondition = {
  /** Checks for equality with the object’s `accountNumber` field. */
  accountNumber?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `integration` field. */
  integration?: InputMaybe<UtilityIntegration>;
  /** Checks for equality with the object’s `integrationAccountKey` field. */
  integrationAccountKey?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `utilityProviderId` field. */
  utilityProviderId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `UtilityAccount` object types. All fields are combined with a logical ‘and.’ */
export type UtilityAccountFilter = {
  /** Filter by the object’s `accountNumber` field. */
  accountNumber?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UtilityAccountFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `displayName` field. */
  displayName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `integration` field. */
  integration?: InputMaybe<UtilityIntegrationFilter>;
  /** Filter by the object’s `integrationAccountKey` field. */
  integrationAccountKey?: InputMaybe<StringFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UtilityAccountFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UtilityAccountFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `utilityProviderId` field. */
  utilityProviderId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `UtilityAccount` */
export type UtilityAccountInput = {
  /** The account’s number. */
  accountNumber: Scalars['String'];
  /** The primary unique identifier of the account. */
  id?: InputMaybe<Scalars['Int']>;
  /** The integration that owns the account. */
  integration: UtilityIntegration;
  /** The identifier in the integration’s system. */
  integrationAccountKey?: InputMaybe<Scalars['String']>;
  /** Extra metadata about the account. */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** The account’s name. */
  name?: InputMaybe<Scalars['String']>;
  /** Mutates a `UtilityProvider` as part of the payload */
  utilityProvider?: InputMaybe<UtilityProviderInput>;
  /** The account’s provider. */
  utilityProviderId?: InputMaybe<Scalars['Int']>;
};

/** Represents an update to a `UtilityAccount`. Fields that are set will be updated. */
export type UtilityAccountPatch = {
  /** Extra metadata about the account. */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** The account’s name. */
  name?: InputMaybe<Scalars['String']>;
  /** The account’s provider. */
  utilityProviderId?: InputMaybe<Scalars['Int']>;
};

export type UtilityAccountStatement = Node & {
  __typename?: 'UtilityAccountStatement';
  accountLabel?: Maybe<Scalars['String']>;
  /** Reads a single `AccountStatement` that is related to this `UtilityAccountStatement`. */
  accountStatement?: Maybe<AccountStatement>;
  accountStatementId: Scalars['Int'];
  billArrivalDate?: Maybe<Scalars['Datetime']>;
  /** Returns the total charges of a given utility_account_statements (view) row. */
  billCost?: Maybe<Scalars['Float']>;
  /** Returns the total credits of a given utility_account_statements (view) row. */
  credits?: Maybe<Scalars['Float']>;
  currencyCode?: Maybe<Scalars['String']>;
  /** Returns the total fee charges of a given utility_account_statements (view) row. */
  fees?: Maybe<Scalars['Float']>;
  intervalEnd?: Maybe<Scalars['Date']>;
  intervalStart?: Maybe<Scalars['Date']>;
  isValidated?: Maybe<Scalars['Boolean']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  provider?: Maybe<Scalars['String']>;
  serviceTypes?: Maybe<Array<Maybe<UtilityMeterServiceType>>>;
  statementMonth?: Maybe<Scalars['Int']>;
  statementYear?: Maybe<Scalars['Int']>;
  /** Returns the total tax charges of a given utility_account_statements (view) row. */
  taxes?: Maybe<Scalars['Float']>;
  /** Reads a single `UtilityAccount` that is related to this `UtilityAccountStatement`. */
  utilityAccount?: Maybe<UtilityAccount>;
  utilityAccountId?: Maybe<Scalars['Int']>;
};

export type UtilityAccountStatementAggregates = {
  __typename?: 'UtilityAccountStatementAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<UtilityAccountStatementAverageAggregates>;
  /** Distinct aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinct?: Maybe<UtilityAccountStatementDistinctAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<UtilityAccountStatementDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<UtilityAccountStatementMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<UtilityAccountStatementMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<UtilityAccountStatementStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<UtilityAccountStatementStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<UtilityAccountStatementSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<UtilityAccountStatementVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<UtilityAccountStatementVarianceSampleAggregates>;
};

export type UtilityAccountStatementAverageAggregates = {
  __typename?: 'UtilityAccountStatementAverageAggregates';
  /** Mean average of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']>;
  /**
   * Mean average of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_account_statements (view) row.
   */
  billCost?: Maybe<Scalars['Float']>;
  /**
   * Mean average of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_account_statements (view) row.
   */
  credits?: Maybe<Scalars['Float']>;
  /**
   * Mean average of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_account_statements (view) row.
   */
  fees?: Maybe<Scalars['Float']>;
  /** Mean average of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']>;
  /** Mean average of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']>;
  /**
   * Mean average of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_account_statements (view) row.
   */
  taxes?: Maybe<Scalars['Float']>;
  /** Mean average of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']>;
};

/**
 * A condition to be used against `UtilityAccountStatement` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type UtilityAccountStatementCondition = {
  /** Checks for equality with the object’s `accountLabel` field. */
  accountLabel?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `accountStatementId` field. */
  accountStatementId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `billArrivalDate` field. */
  billArrivalDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `intervalEnd` field. */
  intervalEnd?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `intervalStart` field. */
  intervalStart?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `isValidated` field. */
  isValidated?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `provider` field. */
  provider?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `statementMonth` field. */
  statementMonth?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `statementYear` field. */
  statementYear?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `utilityAccountId` field. */
  utilityAccountId?: InputMaybe<Scalars['Int']>;
};

export type UtilityAccountStatementDistinctAggregates = {
  __typename?: 'UtilityAccountStatementDistinctAggregates';
  /** Distinct of accountLabel across the matching connection */
  accountLabel?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Distinct of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Distinct of billArrivalDate across the matching connection */
  billArrivalDate?: Maybe<Scalars['JSON']>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_account_statements (view) row.
   */
  billCost?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_account_statements (view) row.
   */
  credits?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Distinct of currencyCode across the matching connection */
  currencyCode?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_account_statements (view) row.
   */
  fees?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Distinct of intervalEnd across the matching connection */
  intervalEnd?: Maybe<Scalars['JSON']>;
  /** Distinct of intervalStart across the matching connection */
  intervalStart?: Maybe<Scalars['JSON']>;
  /** Distinct of isValidated across the matching connection */
  isValidated?: Maybe<Scalars['JSON']>;
  /** Distinct of provider across the matching connection */
  provider?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Distinct of this field across the matching connection. */
  serviceTypes?: Maybe<Scalars['JSON']>;
  /** Distinct of statementMonth across the matching connection */
  statementMonth?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Distinct of statementYear across the matching connection */
  statementYear?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_account_statements (view) row.
   */
  taxes?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Distinct of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type UtilityAccountStatementDistinctCountAggregates = {
  __typename?: 'UtilityAccountStatementDistinctCountAggregates';
  /** Distinct count of accountLabel across the matching connection */
  accountLabel?: Maybe<Scalars['BigInt']>;
  /** Distinct count of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of billArrivalDate across the matching connection */
  billArrivalDate?: Maybe<Scalars['BigInt']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_account_statements (view) row.
   */
  billCost?: Maybe<Scalars['BigInt']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_account_statements (view) row.
   */
  credits?: Maybe<Scalars['BigInt']>;
  /** Distinct count of currencyCode across the matching connection */
  currencyCode?: Maybe<Scalars['BigInt']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_account_statements (view) row.
   */
  fees?: Maybe<Scalars['BigInt']>;
  /** Distinct count of intervalEnd across the matching connection */
  intervalEnd?: Maybe<Scalars['BigInt']>;
  /** Distinct count of intervalStart across the matching connection */
  intervalStart?: Maybe<Scalars['BigInt']>;
  /** Distinct count of isValidated across the matching connection */
  isValidated?: Maybe<Scalars['BigInt']>;
  /** Distinct count of provider across the matching connection */
  provider?: Maybe<Scalars['BigInt']>;
  /** Distinct count of this field across the matching connection. */
  serviceTypes?: Maybe<Scalars['BigInt']>;
  /** Distinct count of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigInt']>;
  /** Distinct count of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigInt']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_account_statements (view) row.
   */
  taxes?: Maybe<Scalars['BigInt']>;
  /** Distinct count of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigInt']>;
};

/** A filter to be used against `UtilityAccountStatement` object types. All fields are combined with a logical ‘and.’ */
export type UtilityAccountStatementFilter = {
  /** Filter by the object’s `accountLabel` field. */
  accountLabel?: InputMaybe<StringFilter>;
  /** Filter by the object’s `accountStatementId` field. */
  accountStatementId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UtilityAccountStatementFilter>>;
  /** Filter by the object’s `billArrivalDate` field. */
  billArrivalDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `billCost` field. */
  billCost?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `credits` field. */
  credits?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fees` field. */
  fees?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `intervalEnd` field. */
  intervalEnd?: InputMaybe<DateFilter>;
  /** Filter by the object’s `intervalStart` field. */
  intervalStart?: InputMaybe<DateFilter>;
  /** Filter by the object’s `isValidated` field. */
  isValidated?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UtilityAccountStatementFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UtilityAccountStatementFilter>>;
  /** Filter by the object’s `provider` field. */
  provider?: InputMaybe<StringFilter>;
  /** Filter by the object’s `serviceTypes` field. */
  serviceTypes?: InputMaybe<UtilityMeterServiceTypeListFilter>;
  /** Filter by the object’s `statementMonth` field. */
  statementMonth?: InputMaybe<IntFilter>;
  /** Filter by the object’s `statementYear` field. */
  statementYear?: InputMaybe<IntFilter>;
  /** Filter by the object’s `taxes` field. */
  taxes?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `utilityAccountId` field. */
  utilityAccountId?: InputMaybe<IntFilter>;
};

export type UtilityAccountStatementMaxAggregates = {
  __typename?: 'UtilityAccountStatementMaxAggregates';
  /** Maximum of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['Int']>;
  /**
   * Maximum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_account_statements (view) row.
   */
  billCost?: Maybe<Scalars['Float']>;
  /**
   * Maximum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_account_statements (view) row.
   */
  credits?: Maybe<Scalars['Float']>;
  /**
   * Maximum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_account_statements (view) row.
   */
  fees?: Maybe<Scalars['Float']>;
  /** Maximum of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['Int']>;
  /** Maximum of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['Int']>;
  /**
   * Maximum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_account_statements (view) row.
   */
  taxes?: Maybe<Scalars['Float']>;
  /** Maximum of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['Int']>;
};

export type UtilityAccountStatementMinAggregates = {
  __typename?: 'UtilityAccountStatementMinAggregates';
  /** Minimum of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['Int']>;
  /**
   * Minimum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_account_statements (view) row.
   */
  billCost?: Maybe<Scalars['Float']>;
  /**
   * Minimum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_account_statements (view) row.
   */
  credits?: Maybe<Scalars['Float']>;
  /**
   * Minimum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_account_statements (view) row.
   */
  fees?: Maybe<Scalars['Float']>;
  /** Minimum of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['Int']>;
  /** Minimum of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['Int']>;
  /**
   * Minimum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_account_statements (view) row.
   */
  taxes?: Maybe<Scalars['Float']>;
  /** Minimum of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['Int']>;
};

export type UtilityAccountStatementRollup = Node & {
  __typename?: 'UtilityAccountStatementRollup';
  accountLabel?: Maybe<Scalars['String']>;
  /** Reads a single `AccountStatement` that is related to this `UtilityAccountStatementRollup`. */
  accountStatement?: Maybe<AccountStatement>;
  accountStatementId: Scalars['Int'];
  billArrivalDate?: Maybe<Scalars['Datetime']>;
  billCost?: Maybe<Scalars['Float']>;
  billDemandCost?: Maybe<Scalars['Float']>;
  billUsageCost?: Maybe<Scalars['Float']>;
  credits?: Maybe<Scalars['Float']>;
  currencyCode?: Maybe<Scalars['String']>;
  fees?: Maybe<Scalars['Float']>;
  intervalEnd?: Maybe<Scalars['Date']>;
  intervalStart?: Maybe<Scalars['Date']>;
  isValidated?: Maybe<Scalars['Boolean']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  percentChange?: Maybe<Scalars['Float']>;
  provider?: Maybe<Scalars['String']>;
  serviceTypes?: Maybe<Array<Maybe<UtilityMeterServiceType>>>;
  statementMonth?: Maybe<Scalars['Int']>;
  statementYear?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Float']>;
  /** Reads a single `UtilityAccount` that is related to this `UtilityAccountStatementRollup`. */
  utilityAccount?: Maybe<UtilityAccount>;
  utilityAccountId?: Maybe<Scalars['Int']>;
};

export type UtilityAccountStatementRollupAggregates = {
  __typename?: 'UtilityAccountStatementRollupAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<UtilityAccountStatementRollupAverageAggregates>;
  /** Distinct aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinct?: Maybe<UtilityAccountStatementRollupDistinctAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<UtilityAccountStatementRollupDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<UtilityAccountStatementRollupMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<UtilityAccountStatementRollupMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<UtilityAccountStatementRollupStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<UtilityAccountStatementRollupStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<UtilityAccountStatementRollupSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<UtilityAccountStatementRollupVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<UtilityAccountStatementRollupVarianceSampleAggregates>;
};

export type UtilityAccountStatementRollupAverageAggregates = {
  __typename?: 'UtilityAccountStatementRollupAverageAggregates';
  /** Mean average of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']>;
  /** Mean average of billCost across the matching connection */
  billCost?: Maybe<Scalars['Float']>;
  /** Mean average of billDemandCost across the matching connection */
  billDemandCost?: Maybe<Scalars['Float']>;
  /** Mean average of billUsageCost across the matching connection */
  billUsageCost?: Maybe<Scalars['Float']>;
  /** Mean average of credits across the matching connection */
  credits?: Maybe<Scalars['Float']>;
  /** Mean average of fees across the matching connection */
  fees?: Maybe<Scalars['Float']>;
  /** Mean average of percentChange across the matching connection */
  percentChange?: Maybe<Scalars['Float']>;
  /** Mean average of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']>;
  /** Mean average of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']>;
  /** Mean average of taxes across the matching connection */
  taxes?: Maybe<Scalars['Float']>;
  /** Mean average of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']>;
};

/**
 * A condition to be used against `UtilityAccountStatementRollup` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type UtilityAccountStatementRollupCondition = {
  /** Checks for equality with the object’s `accountLabel` field. */
  accountLabel?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `accountStatementId` field. */
  accountStatementId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `billArrivalDate` field. */
  billArrivalDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `billCost` field. */
  billCost?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `billDemandCost` field. */
  billDemandCost?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `billUsageCost` field. */
  billUsageCost?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `credits` field. */
  credits?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `fees` field. */
  fees?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `intervalEnd` field. */
  intervalEnd?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `intervalStart` field. */
  intervalStart?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `isValidated` field. */
  isValidated?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `percentChange` field. */
  percentChange?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `provider` field. */
  provider?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `statementMonth` field. */
  statementMonth?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `statementYear` field. */
  statementYear?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `taxes` field. */
  taxes?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `utilityAccountId` field. */
  utilityAccountId?: InputMaybe<Scalars['Int']>;
};

export type UtilityAccountStatementRollupDistinctAggregates = {
  __typename?: 'UtilityAccountStatementRollupDistinctAggregates';
  /** Distinct of accountLabel across the matching connection */
  accountLabel?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Distinct of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Distinct of billArrivalDate across the matching connection */
  billArrivalDate?: Maybe<Scalars['JSON']>;
  /** Distinct of billCost across the matching connection */
  billCost?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Distinct of billDemandCost across the matching connection */
  billDemandCost?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Distinct of billUsageCost across the matching connection */
  billUsageCost?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Distinct of credits across the matching connection */
  credits?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Distinct of currencyCode across the matching connection */
  currencyCode?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Distinct of fees across the matching connection */
  fees?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Distinct of intervalEnd across the matching connection */
  intervalEnd?: Maybe<Scalars['JSON']>;
  /** Distinct of intervalStart across the matching connection */
  intervalStart?: Maybe<Scalars['JSON']>;
  /** Distinct of isValidated across the matching connection */
  isValidated?: Maybe<Scalars['JSON']>;
  /** Distinct of percentChange across the matching connection */
  percentChange?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Distinct of provider across the matching connection */
  provider?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Distinct of this field across the matching connection. */
  serviceTypes?: Maybe<Scalars['JSON']>;
  /** Distinct of statementMonth across the matching connection */
  statementMonth?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Distinct of statementYear across the matching connection */
  statementYear?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Distinct of taxes across the matching connection */
  taxes?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Distinct of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type UtilityAccountStatementRollupDistinctCountAggregates = {
  __typename?: 'UtilityAccountStatementRollupDistinctCountAggregates';
  /** Distinct count of accountLabel across the matching connection */
  accountLabel?: Maybe<Scalars['BigInt']>;
  /** Distinct count of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of billArrivalDate across the matching connection */
  billArrivalDate?: Maybe<Scalars['BigInt']>;
  /** Distinct count of billCost across the matching connection */
  billCost?: Maybe<Scalars['BigInt']>;
  /** Distinct count of billDemandCost across the matching connection */
  billDemandCost?: Maybe<Scalars['BigInt']>;
  /** Distinct count of billUsageCost across the matching connection */
  billUsageCost?: Maybe<Scalars['BigInt']>;
  /** Distinct count of credits across the matching connection */
  credits?: Maybe<Scalars['BigInt']>;
  /** Distinct count of currencyCode across the matching connection */
  currencyCode?: Maybe<Scalars['BigInt']>;
  /** Distinct count of fees across the matching connection */
  fees?: Maybe<Scalars['BigInt']>;
  /** Distinct count of intervalEnd across the matching connection */
  intervalEnd?: Maybe<Scalars['BigInt']>;
  /** Distinct count of intervalStart across the matching connection */
  intervalStart?: Maybe<Scalars['BigInt']>;
  /** Distinct count of isValidated across the matching connection */
  isValidated?: Maybe<Scalars['BigInt']>;
  /** Distinct count of percentChange across the matching connection */
  percentChange?: Maybe<Scalars['BigInt']>;
  /** Distinct count of provider across the matching connection */
  provider?: Maybe<Scalars['BigInt']>;
  /** Distinct count of this field across the matching connection. */
  serviceTypes?: Maybe<Scalars['BigInt']>;
  /** Distinct count of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigInt']>;
  /** Distinct count of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigInt']>;
  /** Distinct count of taxes across the matching connection */
  taxes?: Maybe<Scalars['BigInt']>;
  /** Distinct count of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigInt']>;
};

/** A filter to be used against `UtilityAccountStatementRollup` object types. All fields are combined with a logical ‘and.’ */
export type UtilityAccountStatementRollupFilter = {
  /** Filter by the object’s `accountLabel` field. */
  accountLabel?: InputMaybe<StringFilter>;
  /** Filter by the object’s `accountStatementId` field. */
  accountStatementId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UtilityAccountStatementRollupFilter>>;
  /** Filter by the object’s `billArrivalDate` field. */
  billArrivalDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `billCost` field. */
  billCost?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `billDemandCost` field. */
  billDemandCost?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `billUsageCost` field. */
  billUsageCost?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `credits` field. */
  credits?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fees` field. */
  fees?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `intervalEnd` field. */
  intervalEnd?: InputMaybe<DateFilter>;
  /** Filter by the object’s `intervalStart` field. */
  intervalStart?: InputMaybe<DateFilter>;
  /** Filter by the object’s `isValidated` field. */
  isValidated?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UtilityAccountStatementRollupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UtilityAccountStatementRollupFilter>>;
  /** Filter by the object’s `percentChange` field. */
  percentChange?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `provider` field. */
  provider?: InputMaybe<StringFilter>;
  /** Filter by the object’s `serviceTypes` field. */
  serviceTypes?: InputMaybe<UtilityMeterServiceTypeListFilter>;
  /** Filter by the object’s `statementMonth` field. */
  statementMonth?: InputMaybe<IntFilter>;
  /** Filter by the object’s `statementYear` field. */
  statementYear?: InputMaybe<IntFilter>;
  /** Filter by the object’s `taxes` field. */
  taxes?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `utilityAccountId` field. */
  utilityAccountId?: InputMaybe<IntFilter>;
};

export type UtilityAccountStatementRollupMaxAggregates = {
  __typename?: 'UtilityAccountStatementRollupMaxAggregates';
  /** Maximum of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['Int']>;
  /** Maximum of billCost across the matching connection */
  billCost?: Maybe<Scalars['Float']>;
  /** Maximum of billDemandCost across the matching connection */
  billDemandCost?: Maybe<Scalars['Float']>;
  /** Maximum of billUsageCost across the matching connection */
  billUsageCost?: Maybe<Scalars['Float']>;
  /** Maximum of credits across the matching connection */
  credits?: Maybe<Scalars['Float']>;
  /** Maximum of fees across the matching connection */
  fees?: Maybe<Scalars['Float']>;
  /** Maximum of percentChange across the matching connection */
  percentChange?: Maybe<Scalars['Float']>;
  /** Maximum of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['Int']>;
  /** Maximum of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['Int']>;
  /** Maximum of taxes across the matching connection */
  taxes?: Maybe<Scalars['Float']>;
  /** Maximum of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['Int']>;
};

export type UtilityAccountStatementRollupMinAggregates = {
  __typename?: 'UtilityAccountStatementRollupMinAggregates';
  /** Minimum of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['Int']>;
  /** Minimum of billCost across the matching connection */
  billCost?: Maybe<Scalars['Float']>;
  /** Minimum of billDemandCost across the matching connection */
  billDemandCost?: Maybe<Scalars['Float']>;
  /** Minimum of billUsageCost across the matching connection */
  billUsageCost?: Maybe<Scalars['Float']>;
  /** Minimum of credits across the matching connection */
  credits?: Maybe<Scalars['Float']>;
  /** Minimum of fees across the matching connection */
  fees?: Maybe<Scalars['Float']>;
  /** Minimum of percentChange across the matching connection */
  percentChange?: Maybe<Scalars['Float']>;
  /** Minimum of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['Int']>;
  /** Minimum of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['Int']>;
  /** Minimum of taxes across the matching connection */
  taxes?: Maybe<Scalars['Float']>;
  /** Minimum of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['Int']>;
};

export type UtilityAccountStatementRollupStddevPopulationAggregates = {
  __typename?: 'UtilityAccountStatementRollupStddevPopulationAggregates';
  /** Population standard deviation of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of billCost across the matching connection */
  billCost?: Maybe<Scalars['Float']>;
  /** Population standard deviation of billDemandCost across the matching connection */
  billDemandCost?: Maybe<Scalars['Float']>;
  /** Population standard deviation of billUsageCost across the matching connection */
  billUsageCost?: Maybe<Scalars['Float']>;
  /** Population standard deviation of credits across the matching connection */
  credits?: Maybe<Scalars['Float']>;
  /** Population standard deviation of fees across the matching connection */
  fees?: Maybe<Scalars['Float']>;
  /** Population standard deviation of percentChange across the matching connection */
  percentChange?: Maybe<Scalars['Float']>;
  /** Population standard deviation of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of taxes across the matching connection */
  taxes?: Maybe<Scalars['Float']>;
  /** Population standard deviation of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']>;
};

export type UtilityAccountStatementRollupStddevSampleAggregates = {
  __typename?: 'UtilityAccountStatementRollupStddevSampleAggregates';
  /** Sample standard deviation of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of billCost across the matching connection */
  billCost?: Maybe<Scalars['Float']>;
  /** Sample standard deviation of billDemandCost across the matching connection */
  billDemandCost?: Maybe<Scalars['Float']>;
  /** Sample standard deviation of billUsageCost across the matching connection */
  billUsageCost?: Maybe<Scalars['Float']>;
  /** Sample standard deviation of credits across the matching connection */
  credits?: Maybe<Scalars['Float']>;
  /** Sample standard deviation of fees across the matching connection */
  fees?: Maybe<Scalars['Float']>;
  /** Sample standard deviation of percentChange across the matching connection */
  percentChange?: Maybe<Scalars['Float']>;
  /** Sample standard deviation of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of taxes across the matching connection */
  taxes?: Maybe<Scalars['Float']>;
  /** Sample standard deviation of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']>;
};

export type UtilityAccountStatementRollupSumAggregates = {
  __typename?: 'UtilityAccountStatementRollupSumAggregates';
  /** Sum of accountStatementId across the matching connection */
  accountStatementId: Scalars['BigInt'];
  /** Sum of billCost across the matching connection */
  billCost: Scalars['Float'];
  /** Sum of billDemandCost across the matching connection */
  billDemandCost: Scalars['Float'];
  /** Sum of billUsageCost across the matching connection */
  billUsageCost: Scalars['Float'];
  /** Sum of credits across the matching connection */
  credits: Scalars['Float'];
  /** Sum of fees across the matching connection */
  fees: Scalars['Float'];
  /** Sum of percentChange across the matching connection */
  percentChange: Scalars['Float'];
  /** Sum of statementMonth across the matching connection */
  statementMonth: Scalars['BigInt'];
  /** Sum of statementYear across the matching connection */
  statementYear: Scalars['BigInt'];
  /** Sum of taxes across the matching connection */
  taxes: Scalars['Float'];
  /** Sum of utilityAccountId across the matching connection */
  utilityAccountId: Scalars['BigInt'];
};

export type UtilityAccountStatementRollupVariancePopulationAggregates = {
  __typename?: 'UtilityAccountStatementRollupVariancePopulationAggregates';
  /** Population variance of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']>;
  /** Population variance of billCost across the matching connection */
  billCost?: Maybe<Scalars['Float']>;
  /** Population variance of billDemandCost across the matching connection */
  billDemandCost?: Maybe<Scalars['Float']>;
  /** Population variance of billUsageCost across the matching connection */
  billUsageCost?: Maybe<Scalars['Float']>;
  /** Population variance of credits across the matching connection */
  credits?: Maybe<Scalars['Float']>;
  /** Population variance of fees across the matching connection */
  fees?: Maybe<Scalars['Float']>;
  /** Population variance of percentChange across the matching connection */
  percentChange?: Maybe<Scalars['Float']>;
  /** Population variance of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']>;
  /** Population variance of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']>;
  /** Population variance of taxes across the matching connection */
  taxes?: Maybe<Scalars['Float']>;
  /** Population variance of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']>;
};

export type UtilityAccountStatementRollupVarianceSampleAggregates = {
  __typename?: 'UtilityAccountStatementRollupVarianceSampleAggregates';
  /** Sample variance of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of billCost across the matching connection */
  billCost?: Maybe<Scalars['Float']>;
  /** Sample variance of billDemandCost across the matching connection */
  billDemandCost?: Maybe<Scalars['Float']>;
  /** Sample variance of billUsageCost across the matching connection */
  billUsageCost?: Maybe<Scalars['Float']>;
  /** Sample variance of credits across the matching connection */
  credits?: Maybe<Scalars['Float']>;
  /** Sample variance of fees across the matching connection */
  fees?: Maybe<Scalars['Float']>;
  /** Sample variance of percentChange across the matching connection */
  percentChange?: Maybe<Scalars['Float']>;
  /** Sample variance of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of taxes across the matching connection */
  taxes?: Maybe<Scalars['Float']>;
  /** Sample variance of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']>;
};

/** A connection to a list of `UtilityAccountStatementRollup` values. */
export type UtilityAccountStatementRollupsConnection = {
  __typename?: 'UtilityAccountStatementRollupsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<UtilityAccountStatementRollupAggregates>;
  /** A list of edges which contains the `UtilityAccountStatementRollup` and cursor to aid in pagination. */
  edges: Array<UtilityAccountStatementRollupsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<UtilityAccountStatementRollupAggregates>>;
  /** A list of `UtilityAccountStatementRollup` objects. */
  nodes: Array<UtilityAccountStatementRollup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UtilityAccountStatementRollup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A connection to a list of `UtilityAccountStatementRollup` values. */
export type UtilityAccountStatementRollupsConnectionGroupedAggregatesArgs = {
  groupBy: Array<UtilityAccountStatementRollupsGroupBy>;
  having?: InputMaybe<UtilityAccountStatementRollupsHavingInput>;
};

/** A `UtilityAccountStatementRollup` edge in the connection. */
export type UtilityAccountStatementRollupsEdge = {
  __typename?: 'UtilityAccountStatementRollupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UtilityAccountStatementRollup` at the end of the edge. */
  node: UtilityAccountStatementRollup;
};

/** Grouping methods for `UtilityAccountStatementRollup` for usage during aggregation. */
export enum UtilityAccountStatementRollupsGroupBy {
  ACCOUNT_LABEL = 'ACCOUNT_LABEL',
  ACCOUNT_LABEL_DISTINCT = 'ACCOUNT_LABEL_DISTINCT',
  ACCOUNT_STATEMENT_ID = 'ACCOUNT_STATEMENT_ID',
  ACCOUNT_STATEMENT_ID_DISTINCT = 'ACCOUNT_STATEMENT_ID_DISTINCT',
  BILL_ARRIVAL_DATE = 'BILL_ARRIVAL_DATE',
  BILL_ARRIVAL_DATE_DISTINCT = 'BILL_ARRIVAL_DATE_DISTINCT',
  BILL_ARRIVAL_DATE_TRUNCATED_TO_DAY = 'BILL_ARRIVAL_DATE_TRUNCATED_TO_DAY',
  BILL_ARRIVAL_DATE_TRUNCATED_TO_HOUR = 'BILL_ARRIVAL_DATE_TRUNCATED_TO_HOUR',
  BILL_COST = 'BILL_COST',
  BILL_COST_DISTINCT = 'BILL_COST_DISTINCT',
  BILL_DEMAND_COST = 'BILL_DEMAND_COST',
  BILL_DEMAND_COST_DISTINCT = 'BILL_DEMAND_COST_DISTINCT',
  BILL_USAGE_COST = 'BILL_USAGE_COST',
  BILL_USAGE_COST_DISTINCT = 'BILL_USAGE_COST_DISTINCT',
  CREDITS = 'CREDITS',
  CREDITS_DISTINCT = 'CREDITS_DISTINCT',
  CURRENCY_CODE = 'CURRENCY_CODE',
  CURRENCY_CODE_DISTINCT = 'CURRENCY_CODE_DISTINCT',
  FEES = 'FEES',
  FEES_DISTINCT = 'FEES_DISTINCT',
  INTERVAL_END = 'INTERVAL_END',
  INTERVAL_END_DISTINCT = 'INTERVAL_END_DISTINCT',
  INTERVAL_START = 'INTERVAL_START',
  INTERVAL_START_DISTINCT = 'INTERVAL_START_DISTINCT',
  IS_VALIDATED = 'IS_VALIDATED',
  IS_VALIDATED_DISTINCT = 'IS_VALIDATED_DISTINCT',
  PERCENT_CHANGE = 'PERCENT_CHANGE',
  PERCENT_CHANGE_DISTINCT = 'PERCENT_CHANGE_DISTINCT',
  PROVIDER = 'PROVIDER',
  PROVIDER_DISTINCT = 'PROVIDER_DISTINCT',
  STATEMENT_MONTH = 'STATEMENT_MONTH',
  STATEMENT_MONTH_DISTINCT = 'STATEMENT_MONTH_DISTINCT',
  STATEMENT_YEAR = 'STATEMENT_YEAR',
  STATEMENT_YEAR_DISTINCT = 'STATEMENT_YEAR_DISTINCT',
  TAXES = 'TAXES',
  TAXES_DISTINCT = 'TAXES_DISTINCT',
  UTILITY_ACCOUNT_ID = 'UTILITY_ACCOUNT_ID',
  UTILITY_ACCOUNT_ID_DISTINCT = 'UTILITY_ACCOUNT_ID_DISTINCT'
}

export type UtilityAccountStatementRollupsHavingAverageInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

export type UtilityAccountStatementRollupsHavingDistinctCountInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

export type UtilityAccountStatementRollupsHavingDistinctInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `UtilityAccountStatementRollup` aggregates. */
export type UtilityAccountStatementRollupsHavingInput = {
  AND?: InputMaybe<Array<UtilityAccountStatementRollupsHavingInput>>;
  OR?: InputMaybe<Array<UtilityAccountStatementRollupsHavingInput>>;
  average?: InputMaybe<UtilityAccountStatementRollupsHavingAverageInput>;
  distinct?: InputMaybe<UtilityAccountStatementRollupsHavingDistinctInput>;
  distinctCount?: InputMaybe<UtilityAccountStatementRollupsHavingDistinctCountInput>;
  max?: InputMaybe<UtilityAccountStatementRollupsHavingMaxInput>;
  min?: InputMaybe<UtilityAccountStatementRollupsHavingMinInput>;
  stddevPopulation?: InputMaybe<UtilityAccountStatementRollupsHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<UtilityAccountStatementRollupsHavingStddevSampleInput>;
  sum?: InputMaybe<UtilityAccountStatementRollupsHavingSumInput>;
  variancePopulation?: InputMaybe<UtilityAccountStatementRollupsHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<UtilityAccountStatementRollupsHavingVarianceSampleInput>;
};

export type UtilityAccountStatementRollupsHavingMaxInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

export type UtilityAccountStatementRollupsHavingMinInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

export type UtilityAccountStatementRollupsHavingStddevPopulationInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

export type UtilityAccountStatementRollupsHavingStddevSampleInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

export type UtilityAccountStatementRollupsHavingSumInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

export type UtilityAccountStatementRollupsHavingVariancePopulationInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

export type UtilityAccountStatementRollupsHavingVarianceSampleInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

/** Methods to use when ordering `UtilityAccountStatementRollup`. */
export enum UtilityAccountStatementRollupsOrderBy {
  ACCOUNT_LABEL_ASC = 'ACCOUNT_LABEL_ASC',
  ACCOUNT_LABEL_DESC = 'ACCOUNT_LABEL_DESC',
  ACCOUNT_STATEMENT_ID_ASC = 'ACCOUNT_STATEMENT_ID_ASC',
  ACCOUNT_STATEMENT_ID_DESC = 'ACCOUNT_STATEMENT_ID_DESC',
  BILL_ARRIVAL_DATE_ASC = 'BILL_ARRIVAL_DATE_ASC',
  BILL_ARRIVAL_DATE_DESC = 'BILL_ARRIVAL_DATE_DESC',
  BILL_COST_ASC = 'BILL_COST_ASC',
  BILL_COST_DESC = 'BILL_COST_DESC',
  BILL_DEMAND_COST_ASC = 'BILL_DEMAND_COST_ASC',
  BILL_DEMAND_COST_DESC = 'BILL_DEMAND_COST_DESC',
  BILL_USAGE_COST_ASC = 'BILL_USAGE_COST_ASC',
  BILL_USAGE_COST_DESC = 'BILL_USAGE_COST_DESC',
  CREDITS_ASC = 'CREDITS_ASC',
  CREDITS_DESC = 'CREDITS_DESC',
  CURRENCY_CODE_ASC = 'CURRENCY_CODE_ASC',
  CURRENCY_CODE_DESC = 'CURRENCY_CODE_DESC',
  FEES_ASC = 'FEES_ASC',
  FEES_DESC = 'FEES_DESC',
  INTERVAL_END_ASC = 'INTERVAL_END_ASC',
  INTERVAL_END_DESC = 'INTERVAL_END_DESC',
  INTERVAL_START_ASC = 'INTERVAL_START_ASC',
  INTERVAL_START_DESC = 'INTERVAL_START_DESC',
  IS_VALIDATED_ASC = 'IS_VALIDATED_ASC',
  IS_VALIDATED_DESC = 'IS_VALIDATED_DESC',
  NATURAL = 'NATURAL',
  PERCENT_CHANGE_ASC = 'PERCENT_CHANGE_ASC',
  PERCENT_CHANGE_DESC = 'PERCENT_CHANGE_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROVIDER_ASC = 'PROVIDER_ASC',
  PROVIDER_DESC = 'PROVIDER_DESC',
  STATEMENT_MONTH_ASC = 'STATEMENT_MONTH_ASC',
  STATEMENT_MONTH_DESC = 'STATEMENT_MONTH_DESC',
  STATEMENT_YEAR_ASC = 'STATEMENT_YEAR_ASC',
  STATEMENT_YEAR_DESC = 'STATEMENT_YEAR_DESC',
  TAXES_ASC = 'TAXES_ASC',
  TAXES_DESC = 'TAXES_DESC',
  UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_ID_DESC'
}

export type UtilityAccountStatementStddevPopulationAggregates = {
  __typename?: 'UtilityAccountStatementStddevPopulationAggregates';
  /** Population standard deviation of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']>;
  /**
   * Population standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_account_statements (view) row.
   */
  billCost?: Maybe<Scalars['Float']>;
  /**
   * Population standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_account_statements (view) row.
   */
  credits?: Maybe<Scalars['Float']>;
  /**
   * Population standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_account_statements (view) row.
   */
  fees?: Maybe<Scalars['Float']>;
  /** Population standard deviation of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']>;
  /**
   * Population standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_account_statements (view) row.
   */
  taxes?: Maybe<Scalars['Float']>;
  /** Population standard deviation of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']>;
};

export type UtilityAccountStatementStddevSampleAggregates = {
  __typename?: 'UtilityAccountStatementStddevSampleAggregates';
  /** Sample standard deviation of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']>;
  /**
   * Sample standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_account_statements (view) row.
   */
  billCost?: Maybe<Scalars['Float']>;
  /**
   * Sample standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_account_statements (view) row.
   */
  credits?: Maybe<Scalars['Float']>;
  /**
   * Sample standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_account_statements (view) row.
   */
  fees?: Maybe<Scalars['Float']>;
  /** Sample standard deviation of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']>;
  /**
   * Sample standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_account_statements (view) row.
   */
  taxes?: Maybe<Scalars['Float']>;
  /** Sample standard deviation of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']>;
};

export type UtilityAccountStatementSumAggregates = {
  __typename?: 'UtilityAccountStatementSumAggregates';
  /** Sum of accountStatementId across the matching connection */
  accountStatementId: Scalars['BigInt'];
  /**
   * Sum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_account_statements (view) row.
   */
  billCost?: Maybe<Scalars['Float']>;
  /**
   * Sum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_account_statements (view) row.
   */
  credits?: Maybe<Scalars['Float']>;
  /**
   * Sum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_account_statements (view) row.
   */
  fees?: Maybe<Scalars['Float']>;
  /** Sum of statementMonth across the matching connection */
  statementMonth: Scalars['BigInt'];
  /** Sum of statementYear across the matching connection */
  statementYear: Scalars['BigInt'];
  /**
   * Sum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_account_statements (view) row.
   */
  taxes?: Maybe<Scalars['Float']>;
  /** Sum of utilityAccountId across the matching connection */
  utilityAccountId: Scalars['BigInt'];
};

export type UtilityAccountStatementVariancePopulationAggregates = {
  __typename?: 'UtilityAccountStatementVariancePopulationAggregates';
  /** Population variance of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']>;
  /**
   * Population variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_account_statements (view) row.
   */
  billCost?: Maybe<Scalars['Float']>;
  /**
   * Population variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_account_statements (view) row.
   */
  credits?: Maybe<Scalars['Float']>;
  /**
   * Population variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_account_statements (view) row.
   */
  fees?: Maybe<Scalars['Float']>;
  /** Population variance of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']>;
  /** Population variance of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']>;
  /**
   * Population variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_account_statements (view) row.
   */
  taxes?: Maybe<Scalars['Float']>;
  /** Population variance of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']>;
};

export type UtilityAccountStatementVarianceSampleAggregates = {
  __typename?: 'UtilityAccountStatementVarianceSampleAggregates';
  /** Sample variance of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']>;
  /**
   * Sample variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_account_statements (view) row.
   */
  billCost?: Maybe<Scalars['Float']>;
  /**
   * Sample variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_account_statements (view) row.
   */
  credits?: Maybe<Scalars['Float']>;
  /**
   * Sample variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_account_statements (view) row.
   */
  fees?: Maybe<Scalars['Float']>;
  /** Sample variance of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']>;
  /**
   * Sample variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_account_statements (view) row.
   */
  taxes?: Maybe<Scalars['Float']>;
  /** Sample variance of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']>;
};

/** A connection to a list of `UtilityAccountStatement` values. */
export type UtilityAccountStatementsConnection = {
  __typename?: 'UtilityAccountStatementsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<UtilityAccountStatementAggregates>;
  /** A list of edges which contains the `UtilityAccountStatement` and cursor to aid in pagination. */
  edges: Array<UtilityAccountStatementsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<UtilityAccountStatementAggregates>>;
  /** A list of `UtilityAccountStatement` objects. */
  nodes: Array<UtilityAccountStatement>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UtilityAccountStatement` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A connection to a list of `UtilityAccountStatement` values. */
export type UtilityAccountStatementsConnectionGroupedAggregatesArgs = {
  groupBy: Array<UtilityAccountStatementsGroupBy>;
  having?: InputMaybe<UtilityAccountStatementsHavingInput>;
};

/** A `UtilityAccountStatement` edge in the connection. */
export type UtilityAccountStatementsEdge = {
  __typename?: 'UtilityAccountStatementsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UtilityAccountStatement` at the end of the edge. */
  node: UtilityAccountStatement;
};

/** Grouping methods for `UtilityAccountStatement` for usage during aggregation. */
export enum UtilityAccountStatementsGroupBy {
  ACCOUNT_LABEL = 'ACCOUNT_LABEL',
  ACCOUNT_LABEL_DISTINCT = 'ACCOUNT_LABEL_DISTINCT',
  ACCOUNT_STATEMENT_ID = 'ACCOUNT_STATEMENT_ID',
  ACCOUNT_STATEMENT_ID_DISTINCT = 'ACCOUNT_STATEMENT_ID_DISTINCT',
  BILL_ARRIVAL_DATE = 'BILL_ARRIVAL_DATE',
  BILL_ARRIVAL_DATE_DISTINCT = 'BILL_ARRIVAL_DATE_DISTINCT',
  BILL_ARRIVAL_DATE_TRUNCATED_TO_DAY = 'BILL_ARRIVAL_DATE_TRUNCATED_TO_DAY',
  BILL_ARRIVAL_DATE_TRUNCATED_TO_HOUR = 'BILL_ARRIVAL_DATE_TRUNCATED_TO_HOUR',
  CURRENCY_CODE = 'CURRENCY_CODE',
  CURRENCY_CODE_DISTINCT = 'CURRENCY_CODE_DISTINCT',
  INTERVAL_END = 'INTERVAL_END',
  INTERVAL_END_DISTINCT = 'INTERVAL_END_DISTINCT',
  INTERVAL_START = 'INTERVAL_START',
  INTERVAL_START_DISTINCT = 'INTERVAL_START_DISTINCT',
  IS_VALIDATED = 'IS_VALIDATED',
  IS_VALIDATED_DISTINCT = 'IS_VALIDATED_DISTINCT',
  PROVIDER = 'PROVIDER',
  PROVIDER_DISTINCT = 'PROVIDER_DISTINCT',
  STATEMENT_MONTH = 'STATEMENT_MONTH',
  STATEMENT_MONTH_DISTINCT = 'STATEMENT_MONTH_DISTINCT',
  STATEMENT_YEAR = 'STATEMENT_YEAR',
  STATEMENT_YEAR_DISTINCT = 'STATEMENT_YEAR_DISTINCT',
  UTILITY_ACCOUNT_ID = 'UTILITY_ACCOUNT_ID',
  UTILITY_ACCOUNT_ID_DISTINCT = 'UTILITY_ACCOUNT_ID_DISTINCT'
}

export type UtilityAccountStatementsHavingAverageInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityAccountStatementsHavingAverageUtilityAccountStatementsBillCostInput>;
  credits?: InputMaybe<UtilityAccountStatementsHavingAverageUtilityAccountStatementsCreditsInput>;
  fees?: InputMaybe<UtilityAccountStatementsHavingAverageUtilityAccountStatementsFeesInput>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityAccountStatementsHavingAverageUtilityAccountStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

export type UtilityAccountStatementsHavingAverageUtilityAccountStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingAverageUtilityAccountStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingAverageUtilityAccountStatementsFeesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingAverageUtilityAccountStatementsTaxesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingDistinctCountInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityAccountStatementsHavingDistinctCountUtilityAccountStatementsBillCostInput>;
  credits?: InputMaybe<UtilityAccountStatementsHavingDistinctCountUtilityAccountStatementsCreditsInput>;
  fees?: InputMaybe<UtilityAccountStatementsHavingDistinctCountUtilityAccountStatementsFeesInput>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityAccountStatementsHavingDistinctCountUtilityAccountStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

export type UtilityAccountStatementsHavingDistinctCountUtilityAccountStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingDistinctCountUtilityAccountStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingDistinctCountUtilityAccountStatementsFeesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingDistinctCountUtilityAccountStatementsTaxesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingDistinctInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityAccountStatementsHavingDistinctUtilityAccountStatementsBillCostInput>;
  credits?: InputMaybe<UtilityAccountStatementsHavingDistinctUtilityAccountStatementsCreditsInput>;
  fees?: InputMaybe<UtilityAccountStatementsHavingDistinctUtilityAccountStatementsFeesInput>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityAccountStatementsHavingDistinctUtilityAccountStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

export type UtilityAccountStatementsHavingDistinctUtilityAccountStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingDistinctUtilityAccountStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingDistinctUtilityAccountStatementsFeesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingDistinctUtilityAccountStatementsTaxesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

/** Conditions for `UtilityAccountStatement` aggregates. */
export type UtilityAccountStatementsHavingInput = {
  AND?: InputMaybe<Array<UtilityAccountStatementsHavingInput>>;
  OR?: InputMaybe<Array<UtilityAccountStatementsHavingInput>>;
  average?: InputMaybe<UtilityAccountStatementsHavingAverageInput>;
  distinct?: InputMaybe<UtilityAccountStatementsHavingDistinctInput>;
  distinctCount?: InputMaybe<UtilityAccountStatementsHavingDistinctCountInput>;
  max?: InputMaybe<UtilityAccountStatementsHavingMaxInput>;
  min?: InputMaybe<UtilityAccountStatementsHavingMinInput>;
  stddevPopulation?: InputMaybe<UtilityAccountStatementsHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<UtilityAccountStatementsHavingStddevSampleInput>;
  sum?: InputMaybe<UtilityAccountStatementsHavingSumInput>;
  variancePopulation?: InputMaybe<UtilityAccountStatementsHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<UtilityAccountStatementsHavingVarianceSampleInput>;
};

export type UtilityAccountStatementsHavingMaxInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityAccountStatementsHavingMaxUtilityAccountStatementsBillCostInput>;
  credits?: InputMaybe<UtilityAccountStatementsHavingMaxUtilityAccountStatementsCreditsInput>;
  fees?: InputMaybe<UtilityAccountStatementsHavingMaxUtilityAccountStatementsFeesInput>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityAccountStatementsHavingMaxUtilityAccountStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

export type UtilityAccountStatementsHavingMaxUtilityAccountStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingMaxUtilityAccountStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingMaxUtilityAccountStatementsFeesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingMaxUtilityAccountStatementsTaxesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingMinInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityAccountStatementsHavingMinUtilityAccountStatementsBillCostInput>;
  credits?: InputMaybe<UtilityAccountStatementsHavingMinUtilityAccountStatementsCreditsInput>;
  fees?: InputMaybe<UtilityAccountStatementsHavingMinUtilityAccountStatementsFeesInput>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityAccountStatementsHavingMinUtilityAccountStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

export type UtilityAccountStatementsHavingMinUtilityAccountStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingMinUtilityAccountStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingMinUtilityAccountStatementsFeesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingMinUtilityAccountStatementsTaxesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingStddevPopulationInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityAccountStatementsHavingStddevPopulationUtilityAccountStatementsBillCostInput>;
  credits?: InputMaybe<UtilityAccountStatementsHavingStddevPopulationUtilityAccountStatementsCreditsInput>;
  fees?: InputMaybe<UtilityAccountStatementsHavingStddevPopulationUtilityAccountStatementsFeesInput>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityAccountStatementsHavingStddevPopulationUtilityAccountStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

export type UtilityAccountStatementsHavingStddevPopulationUtilityAccountStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingStddevPopulationUtilityAccountStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingStddevPopulationUtilityAccountStatementsFeesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingStddevPopulationUtilityAccountStatementsTaxesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingStddevSampleInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityAccountStatementsHavingStddevSampleUtilityAccountStatementsBillCostInput>;
  credits?: InputMaybe<UtilityAccountStatementsHavingStddevSampleUtilityAccountStatementsCreditsInput>;
  fees?: InputMaybe<UtilityAccountStatementsHavingStddevSampleUtilityAccountStatementsFeesInput>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityAccountStatementsHavingStddevSampleUtilityAccountStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

export type UtilityAccountStatementsHavingStddevSampleUtilityAccountStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingStddevSampleUtilityAccountStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingStddevSampleUtilityAccountStatementsFeesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingStddevSampleUtilityAccountStatementsTaxesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingSumInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityAccountStatementsHavingSumUtilityAccountStatementsBillCostInput>;
  credits?: InputMaybe<UtilityAccountStatementsHavingSumUtilityAccountStatementsCreditsInput>;
  fees?: InputMaybe<UtilityAccountStatementsHavingSumUtilityAccountStatementsFeesInput>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityAccountStatementsHavingSumUtilityAccountStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

export type UtilityAccountStatementsHavingSumUtilityAccountStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingSumUtilityAccountStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingSumUtilityAccountStatementsFeesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingSumUtilityAccountStatementsTaxesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingVariancePopulationInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityAccountStatementsHavingVariancePopulationUtilityAccountStatementsBillCostInput>;
  credits?: InputMaybe<UtilityAccountStatementsHavingVariancePopulationUtilityAccountStatementsCreditsInput>;
  fees?: InputMaybe<UtilityAccountStatementsHavingVariancePopulationUtilityAccountStatementsFeesInput>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityAccountStatementsHavingVariancePopulationUtilityAccountStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

export type UtilityAccountStatementsHavingVariancePopulationUtilityAccountStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingVariancePopulationUtilityAccountStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingVariancePopulationUtilityAccountStatementsFeesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingVariancePopulationUtilityAccountStatementsTaxesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingVarianceSampleInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityAccountStatementsHavingVarianceSampleUtilityAccountStatementsBillCostInput>;
  credits?: InputMaybe<UtilityAccountStatementsHavingVarianceSampleUtilityAccountStatementsCreditsInput>;
  fees?: InputMaybe<UtilityAccountStatementsHavingVarianceSampleUtilityAccountStatementsFeesInput>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityAccountStatementsHavingVarianceSampleUtilityAccountStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

export type UtilityAccountStatementsHavingVarianceSampleUtilityAccountStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingVarianceSampleUtilityAccountStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingVarianceSampleUtilityAccountStatementsFeesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingVarianceSampleUtilityAccountStatementsTaxesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

/** Methods to use when ordering `UtilityAccountStatement`. */
export enum UtilityAccountStatementsOrderBy {
  ACCOUNT_LABEL_ASC = 'ACCOUNT_LABEL_ASC',
  ACCOUNT_LABEL_DESC = 'ACCOUNT_LABEL_DESC',
  ACCOUNT_STATEMENT_ID_ASC = 'ACCOUNT_STATEMENT_ID_ASC',
  ACCOUNT_STATEMENT_ID_DESC = 'ACCOUNT_STATEMENT_ID_DESC',
  BILL_ARRIVAL_DATE_ASC = 'BILL_ARRIVAL_DATE_ASC',
  BILL_ARRIVAL_DATE_DESC = 'BILL_ARRIVAL_DATE_DESC',
  CURRENCY_CODE_ASC = 'CURRENCY_CODE_ASC',
  CURRENCY_CODE_DESC = 'CURRENCY_CODE_DESC',
  INTERVAL_END_ASC = 'INTERVAL_END_ASC',
  INTERVAL_END_DESC = 'INTERVAL_END_DESC',
  INTERVAL_START_ASC = 'INTERVAL_START_ASC',
  INTERVAL_START_DESC = 'INTERVAL_START_DESC',
  IS_VALIDATED_ASC = 'IS_VALIDATED_ASC',
  IS_VALIDATED_DESC = 'IS_VALIDATED_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROVIDER_ASC = 'PROVIDER_ASC',
  PROVIDER_DESC = 'PROVIDER_DESC',
  STATEMENT_MONTH_ASC = 'STATEMENT_MONTH_ASC',
  STATEMENT_MONTH_DESC = 'STATEMENT_MONTH_DESC',
  STATEMENT_YEAR_ASC = 'STATEMENT_YEAR_ASC',
  STATEMENT_YEAR_DESC = 'STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_ID_DESC'
}

/** A connection to a list of `UtilityAccount` values. */
export type UtilityAccountsConnection = {
  __typename?: 'UtilityAccountsConnection';
  /** A list of edges which contains the `UtilityAccount` and cursor to aid in pagination. */
  edges: Array<UtilityAccountsEdge>;
  /** A list of `UtilityAccount` objects. */
  nodes: Array<UtilityAccount>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UtilityAccount` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UtilityAccount` edge in the connection. */
export type UtilityAccountsEdge = {
  __typename?: 'UtilityAccountsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UtilityAccount` at the end of the edge. */
  node: UtilityAccount;
};

/** Methods to use when ordering `UtilityAccount`. */
export enum UtilityAccountsOrderBy {
  ACCOUNT_NUMBER_ASC = 'ACCOUNT_NUMBER_ASC',
  ACCOUNT_NUMBER_DESC = 'ACCOUNT_NUMBER_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DELETED_AT_ASC = 'DELETED_AT_ASC',
  DELETED_AT_DESC = 'DELETED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  INTEGRATION_ACCOUNT_KEY_ASC = 'INTEGRATION_ACCOUNT_KEY_ASC',
  INTEGRATION_ACCOUNT_KEY_DESC = 'INTEGRATION_ACCOUNT_KEY_DESC',
  INTEGRATION_ASC = 'INTEGRATION_ASC',
  INTEGRATION_DESC = 'INTEGRATION_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_COUNT_ASC = 'UTILITY_ACCOUNT_STATEMENTS_COUNT_ASC',
  UTILITY_ACCOUNT_STATEMENTS_COUNT_DESC = 'UTILITY_ACCOUNT_STATEMENTS_COUNT_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_BILL_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_BILL_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_BILL_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_BILL_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_CREDITS_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_CREDITS_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_CREDITS_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_CREDITS_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_FEES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_FEES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_FEES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_FEES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_PERCENT_CHANGE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_PERCENT_CHANGE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_PERCENT_CHANGE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_PERCENT_CHANGE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_TAXES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_TAXES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_TAXES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_TAXES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_COUNT_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_COUNT_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_COUNT_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_COUNT_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_BILL_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_BILL_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_BILL_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_BILL_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_CREDITS_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_CREDITS_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_CREDITS_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_CREDITS_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_FEES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_FEES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_FEES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_FEES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_PERCENT_CHANGE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_PERCENT_CHANGE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_PERCENT_CHANGE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_PERCENT_CHANGE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_TAXES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_TAXES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_TAXES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_TAXES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_CREDITS_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_CREDITS_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_CREDITS_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_CREDITS_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_FEES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_FEES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_FEES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_FEES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_PERCENT_CHANGE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_PERCENT_CHANGE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_PERCENT_CHANGE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_PERCENT_CHANGE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_TAXES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_TAXES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_TAXES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_TAXES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_BILL_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_BILL_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_BILL_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_BILL_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_BILL_USAGE_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_BILL_USAGE_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_BILL_USAGE_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_BILL_USAGE_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_CREDITS_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_CREDITS_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_CREDITS_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_CREDITS_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_FEES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_FEES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_FEES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_FEES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_PERCENT_CHANGE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_PERCENT_CHANGE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_PERCENT_CHANGE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_PERCENT_CHANGE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_TAXES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_TAXES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_TAXES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_TAXES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_BILL_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_BILL_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_BILL_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_BILL_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_BILL_USAGE_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_BILL_USAGE_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_BILL_USAGE_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_BILL_USAGE_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_CREDITS_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_CREDITS_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_CREDITS_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_CREDITS_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_FEES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_FEES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_FEES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_FEES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_PERCENT_CHANGE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_PERCENT_CHANGE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_PERCENT_CHANGE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_PERCENT_CHANGE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_TAXES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_TAXES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_TAXES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_TAXES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_CREDITS_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_CREDITS_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_CREDITS_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_CREDITS_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_FEES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_FEES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_FEES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_FEES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_PERCENT_CHANGE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_PERCENT_CHANGE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_PERCENT_CHANGE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_PERCENT_CHANGE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_TAXES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_TAXES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_TAXES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_TAXES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CREDITS_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CREDITS_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CREDITS_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CREDITS_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FEES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FEES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FEES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FEES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PERCENT_CHANGE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PERCENT_CHANGE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PERCENT_CHANGE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PERCENT_CHANGE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_TAXES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_TAXES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_TAXES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_TAXES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_BILL_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_BILL_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_BILL_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_BILL_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_BILL_USAGE_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_BILL_USAGE_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_BILL_USAGE_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_BILL_USAGE_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_CREDITS_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_CREDITS_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_CREDITS_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_CREDITS_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_FEES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_FEES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_FEES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_FEES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_PERCENT_CHANGE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_PERCENT_CHANGE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_PERCENT_CHANGE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_PERCENT_CHANGE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_TAXES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_TAXES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_TAXES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_TAXES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CREDITS_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CREDITS_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CREDITS_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CREDITS_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FEES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FEES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FEES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FEES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PERCENT_CHANGE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PERCENT_CHANGE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PERCENT_CHANGE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PERCENT_CHANGE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_TAXES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_TAXES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_TAXES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_TAXES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CREDITS_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CREDITS_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CREDITS_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CREDITS_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FEES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FEES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FEES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FEES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PERCENT_CHANGE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PERCENT_CHANGE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PERCENT_CHANGE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PERCENT_CHANGE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_TAXES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_TAXES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_TAXES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_TAXES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_COUNT_ASC = 'UTILITY_METER_STATEMENTS_COUNT_ASC',
  UTILITY_METER_STATEMENTS_COUNT_DESC = 'UTILITY_METER_STATEMENTS_COUNT_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_MAX_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_MAX_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_MAX_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_MAX_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_MAX_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_MAX_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_MAX_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_MAX_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_MAX_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_MAX_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_MAX_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_MAX_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_MAX_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_MAX_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_MAX_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_MAX_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_MAX_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_MAX_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_MAX_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_MAX_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_MAX_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_MAX_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_MAX_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_MAX_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_MAX_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_MAX_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_MAX_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_MAX_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_MAX_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_MAX_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_MAX_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_MAX_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_MAX_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_MAX_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_MAX_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_MAX_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_MAX_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_MAX_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_MAX_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_MAX_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_MAX_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_MAX_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_MAX_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_MAX_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_MAX_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_MAX_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_MAX_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_MAX_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_MAX_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_MAX_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_MAX_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_MAX_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_MAX_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_MAX_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_MAX_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_MAX_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_MAX_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_MAX_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_MAX_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_MIN_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_MIN_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_MIN_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_MIN_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_MIN_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_MIN_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_MIN_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_MIN_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_MIN_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_MIN_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_MIN_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_MIN_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_MIN_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_MIN_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_MIN_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_MIN_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_MIN_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_MIN_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_MIN_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_MIN_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_MIN_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_MIN_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_MIN_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_MIN_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_MIN_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_MIN_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_MIN_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_MIN_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_MIN_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_MIN_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_MIN_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_MIN_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_MIN_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_MIN_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_MIN_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_MIN_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_MIN_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_MIN_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_MIN_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_MIN_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_MIN_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_MIN_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_MIN_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_MIN_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_MIN_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_MIN_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_MIN_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_MIN_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_MIN_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_MIN_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_MIN_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_MIN_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_MIN_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_MIN_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_MIN_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_MIN_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_MIN_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_MIN_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_MIN_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_SUM_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_SUM_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_SUM_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_SUM_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_SUM_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_SUM_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_SUM_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_SUM_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_SUM_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_SUM_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_SUM_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_SUM_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_SUM_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_SUM_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_SUM_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_SUM_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_SUM_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_SUM_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_SUM_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_SUM_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_SUM_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_SUM_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_SUM_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_SUM_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_SUM_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_SUM_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_SUM_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_SUM_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_SUM_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_SUM_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_SUM_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_SUM_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_SUM_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_SUM_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_SUM_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_SUM_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_SUM_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_SUM_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_SUM_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_SUM_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_SUM_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_SUM_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_SUM_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_SUM_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_SUM_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_SUM_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_SUM_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_SUM_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_SUM_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_SUM_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_SUM_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_SUM_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_SUM_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_SUM_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_SUM_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_SUM_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_SUM_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_SUM_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_SUM_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_COUNT_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_COUNT_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_COUNT_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_COUNT_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_METER_ID_DESC',
  UTILITY_PROVIDER_ID_ASC = 'UTILITY_PROVIDER_ID_ASC',
  UTILITY_PROVIDER_ID_DESC = 'UTILITY_PROVIDER_ID_DESC'
}

export enum UtilityIntegration {
  MANUAL = 'MANUAL',
  URJANET = 'URJANET'
}

/** A filter to be used against UtilityIntegration fields. All fields are combined with a logical ‘and.’ */
export type UtilityIntegrationFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<UtilityIntegration>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<UtilityIntegration>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<UtilityIntegration>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<UtilityIntegration>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<UtilityIntegration>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<UtilityIntegration>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<UtilityIntegration>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<UtilityIntegration>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<UtilityIntegration>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<UtilityIntegration>>;
};

export type UtilityMeter = Node & {
  __typename?: 'UtilityMeter';
  activeEnd?: Maybe<Scalars['Date']>;
  activeStart: Scalars['Date'];
  /** The time the meter was created. */
  createdAt: Scalars['Datetime'];
  /** Default units for meter demand. */
  defaultDemandUnits?: Maybe<Scalars['String']>;
  /** Default units for meter usage. */
  defaultUsageUnits?: Maybe<Scalars['String']>;
  /** Returns the deleted_at column of this record or its parent */
  deletedAt?: Maybe<Scalars['Datetime']>;
  /** Used to indicate whether this utility meter contributes to carbon reporting based on its location in the facility. */
  excludeCarbon?: Maybe<Scalars['Boolean']>;
  /** Indicates that the meter`s usage should not be included in calcuations. */
  excludeUsage: Scalars['Boolean'];
  /** Reads a single `Facility` that is related to this `UtilityMeter`. */
  facility?: Maybe<Facility>;
  facilityId: Scalars['Int'];
  id: Scalars['Int'];
  integrationMeterKey: Scalars['String'];
  metadata: Scalars['JSON'];
  meterNumber: Scalars['String'];
  /** Reads and enables pagination through a set of `MeterStatement`. */
  meterStatements: MeterStatementsConnection;
  /** Returns a set of year/month combinations that are missing as statements for a given meter. */
  missingStatements: UtilityMetersMissingStatementsConnection;
  name?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  overrideAt?: Maybe<Scalars['Datetime']>;
  /** The service type of the meter. */
  serviceType: UtilityMeterServiceType;
  /** The time the meter was updated. */
  updatedAt: Scalars['Datetime'];
  /** Reads a single `UtilityAccount` that is related to this `UtilityMeter`. */
  utilityAccount?: Maybe<UtilityAccount>;
  utilityAccountId: Scalars['Int'];
  /** Reads and enables pagination through a set of `UtilityMeterStatementRollup`. */
  utilityMeterStatementRollups: UtilityMeterStatementRollupsConnection;
  /** Reads and enables pagination through a set of `UtilityMeterStatement`. */
  utilityMeterStatements: UtilityMeterStatementsConnection;
};

export type UtilityMeterMeterStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MeterStatementCondition>;
  filter?: InputMaybe<MeterStatementFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MeterStatementsOrderBy>>;
};

export type UtilityMeterMissingStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<UtilityMetersMissingStatementsRecordFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type UtilityMeterUtilityMeterStatementRollupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UtilityMeterStatementRollupCondition>;
  filter?: InputMaybe<UtilityMeterStatementRollupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UtilityMeterStatementRollupsOrderBy>>;
};

export type UtilityMeterUtilityMeterStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UtilityMeterStatementCondition>;
  filter?: InputMaybe<UtilityMeterStatementFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UtilityMeterStatementsOrderBy>>;
};

export enum UtilityMeterChargeCategory {
  CREDITS = 'CREDITS',
  DEMAND = 'DEMAND',
  FEES = 'FEES',
  TAXES = 'TAXES',
  USAGE = 'USAGE'
}

/** A filter to be used against UtilityMeterChargeCategory fields. All fields are combined with a logical ‘and.’ */
export type UtilityMeterChargeCategoryFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<UtilityMeterChargeCategory>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<UtilityMeterChargeCategory>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<UtilityMeterChargeCategory>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<UtilityMeterChargeCategory>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<UtilityMeterChargeCategory>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<UtilityMeterChargeCategory>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<UtilityMeterChargeCategory>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<UtilityMeterChargeCategory>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<UtilityMeterChargeCategory>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<UtilityMeterChargeCategory>>;
};

/**
 * A condition to be used against `UtilityMeter` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UtilityMeterCondition = {
  /** Checks for equality with the object’s `activeEnd` field. */
  activeEnd?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `activeStart` field. */
  activeStart?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `defaultDemandUnits` field. */
  defaultDemandUnits?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `defaultUsageUnits` field. */
  defaultUsageUnits?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `excludeCarbon` field. */
  excludeCarbon?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `excludeUsage` field. */
  excludeUsage?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `integrationMeterKey` field. */
  integrationMeterKey?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `overrideAt` field. */
  overrideAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `serviceType` field. */
  serviceType?: InputMaybe<UtilityMeterServiceType>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `utilityAccountId` field. */
  utilityAccountId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `UtilityMeter` object types. All fields are combined with a logical ‘and.’ */
export type UtilityMeterFilter = {
  /** Filter by the object’s `activeEnd` field. */
  activeEnd?: InputMaybe<DateFilter>;
  /** Filter by the object’s `activeStart` field. */
  activeStart?: InputMaybe<DateFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UtilityMeterFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `defaultDemandUnits` field. */
  defaultDemandUnits?: InputMaybe<StringFilter>;
  /** Filter by the object’s `defaultUsageUnits` field. */
  defaultUsageUnits?: InputMaybe<StringFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `excludeCarbon` field. */
  excludeCarbon?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `excludeUsage` field. */
  excludeUsage?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `integrationMeterKey` field. */
  integrationMeterKey?: InputMaybe<StringFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Filter by the object's `meterNumber` field. */
  meterNumber?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UtilityMeterFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UtilityMeterFilter>>;
  /** Filter by the object’s `overrideAt` field. */
  overrideAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `serviceType` field. */
  serviceType?: InputMaybe<UtilityMeterServiceTypeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `utilityAccountId` field. */
  utilityAccountId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `UtilityMeter` */
export type UtilityMeterInput = {
  activeEnd?: InputMaybe<Scalars['Date']>;
  activeStart?: InputMaybe<Scalars['Date']>;
  /** Default units for meter demand. */
  defaultDemandUnits?: InputMaybe<Scalars['String']>;
  /** Default units for meter usage. */
  defaultUsageUnits?: InputMaybe<Scalars['String']>;
  /** Used to indicate whether this utility meter contributes to carbon reporting based on its location in the facility. */
  excludeCarbon?: InputMaybe<Scalars['Boolean']>;
  /** Indicates that the meter`s usage should not be included in calcuations. */
  excludeUsage?: InputMaybe<Scalars['Boolean']>;
  facilityId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  integrationMeterKey?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  meterNumber: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  overrideAt?: InputMaybe<Scalars['Datetime']>;
  /** The service type of the meter. */
  serviceType: UtilityMeterServiceType;
  /** Mutates a `UtilityAccount` as part of the payload */
  utilityAccount?: InputMaybe<UtilityAccountInput>;
  utilityAccountId?: InputMaybe<Scalars['Int']>;
};

/** Represents an update to a `UtilityMeter`. Fields that are set will be updated. */
export type UtilityMeterPatch = {
  activeEnd?: InputMaybe<Scalars['Date']>;
  activeStart?: InputMaybe<Scalars['Date']>;
  /** Default units for meter demand. */
  defaultDemandUnits?: InputMaybe<Scalars['String']>;
  /** Default units for meter usage. */
  defaultUsageUnits?: InputMaybe<Scalars['String']>;
  /** Used to indicate whether this utility meter contributes to carbon reporting based on its location in the facility. */
  excludeCarbon?: InputMaybe<Scalars['Boolean']>;
  /** Indicates that the meter`s usage should not be included in calcuations. */
  excludeUsage?: InputMaybe<Scalars['Boolean']>;
  facilityId?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Overrides the original meter_number. */
  meterNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  overrideAt?: InputMaybe<Scalars['Datetime']>;
  /** The service type of the meter. */
  serviceType?: InputMaybe<UtilityMeterServiceType>;
};

export enum UtilityMeterServiceType {
  ELECTRIC = 'ELECTRIC',
  IRRIGATION = 'IRRIGATION',
  LIGHTING = 'LIGHTING',
  NATURAL_GAS = 'NATURAL_GAS',
  OTHER = 'OTHER',
  PROPANE = 'PROPANE',
  SANITATION = 'SANITATION',
  SEWER = 'SEWER',
  SOLAR = 'SOLAR',
  WATER = 'WATER'
}

/** A filter to be used against UtilityMeterServiceType fields. All fields are combined with a logical ‘and.’ */
export type UtilityMeterServiceTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<UtilityMeterServiceType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<UtilityMeterServiceType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<UtilityMeterServiceType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<UtilityMeterServiceType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<UtilityMeterServiceType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<UtilityMeterServiceType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<UtilityMeterServiceType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<UtilityMeterServiceType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<UtilityMeterServiceType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<UtilityMeterServiceType>>;
};

/** A filter to be used against UtilityMeterServiceType List fields. All fields are combined with a logical ‘and.’ */
export type UtilityMeterServiceTypeListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<UtilityMeterServiceType>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<UtilityMeterServiceType>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<UtilityMeterServiceType>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<UtilityMeterServiceType>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<UtilityMeterServiceType>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<UtilityMeterServiceType>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
};

export type UtilityMeterStatement = Node & {
  __typename?: 'UtilityMeterStatement';
  accountLabel?: Maybe<Scalars['String']>;
  /** Reads a single `AccountStatement` that is related to this `UtilityMeterStatement`. */
  accountStatement?: Maybe<AccountStatement>;
  accountStatementId?: Maybe<Scalars['Int']>;
  billArrivalDate?: Maybe<Scalars['Datetime']>;
  /** Returns the total charges of a given utility_meter_statements (view) row. */
  billCost?: Maybe<Scalars['Float']>;
  billDemand?: Maybe<Scalars['Float']>;
  /** Returns the total demand charges of a given utility_meter_statements (view) row. */
  billDemandCost?: Maybe<Scalars['Float']>;
  /** Returns the total demand of a given utility_meter_statements (view) row. */
  billUsage?: Maybe<Scalars['Float']>;
  /** Returns the total usage charges of a given utility_meter_statements (view) row. */
  billUsageCost?: Maybe<Scalars['Float']>;
  /** Returns the total credits of a given utility_meter_statements (view) row. */
  credits?: Maybe<Scalars['Float']>;
  currencyCode?: Maybe<Scalars['String']>;
  daysInBill?: Maybe<Scalars['Int']>;
  demandUnits?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Date']>;
  excludeUsage?: Maybe<Scalars['Boolean']>;
  /** Reads a single `Facility` that is related to this `UtilityMeterStatement`. */
  facility?: Maybe<Facility>;
  facilityId?: Maybe<Scalars['Int']>;
  /** Returns the total fee charges of a given utility_meter_statements (view) row. */
  fees?: Maybe<Scalars['Float']>;
  isValidated?: Maybe<Scalars['Boolean']>;
  meterEndDateSet?: Maybe<Scalars['Boolean']>;
  meterLabel?: Maybe<Scalars['String']>;
  /** Reads a single `MeterStatement` that is related to this `UtilityMeterStatement`. */
  meterStatement?: Maybe<MeterStatement>;
  meterStatementId: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  provider?: Maybe<Scalars['String']>;
  serviceType?: Maybe<UtilityMeterServiceType>;
  startDate?: Maybe<Scalars['Date']>;
  statementMonth?: Maybe<Scalars['Int']>;
  statementYear?: Maybe<Scalars['Int']>;
  /** Returns the total tax charges of a given utility_meter_statements (view) row. */
  taxes?: Maybe<Scalars['Float']>;
  usageUnits?: Maybe<Scalars['String']>;
  /** Reads a single `UtilityAccount` that is related to this `UtilityMeterStatement`. */
  utilityAccount?: Maybe<UtilityAccount>;
  utilityAccountId?: Maybe<Scalars['Int']>;
  /** Reads a single `UtilityMeter` that is related to this `UtilityMeterStatement`. */
  utilityMeter?: Maybe<UtilityMeter>;
  utilityMeterId?: Maybe<Scalars['Int']>;
};

export type UtilityMeterStatementAggregates = {
  __typename?: 'UtilityMeterStatementAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<UtilityMeterStatementAverageAggregates>;
  /** Distinct aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinct?: Maybe<UtilityMeterStatementDistinctAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<UtilityMeterStatementDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<UtilityMeterStatementMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<UtilityMeterStatementMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<UtilityMeterStatementStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<UtilityMeterStatementStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<UtilityMeterStatementSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<UtilityMeterStatementVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<UtilityMeterStatementVarianceSampleAggregates>;
};

export type UtilityMeterStatementAverageAggregates = {
  __typename?: 'UtilityMeterStatementAverageAggregates';
  /** Mean average of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']>;
  /**
   * Mean average of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_meter_statements (view) row.
   */
  billCost?: Maybe<Scalars['Float']>;
  /** Mean average of this field across the matching connection. */
  billDemand?: Maybe<Scalars['Float']>;
  /**
   * Mean average of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand charges of a given utility_meter_statements (view) row.
   */
  billDemandCost?: Maybe<Scalars['Float']>;
  /**
   * Mean average of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand of a given utility_meter_statements (view) row.
   */
  billUsage?: Maybe<Scalars['Float']>;
  /**
   * Mean average of this field across the matching connection.
   *
   * ---
   *
   * Returns the total usage charges of a given utility_meter_statements (view) row.
   */
  billUsageCost?: Maybe<Scalars['Float']>;
  /**
   * Mean average of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_meter_statements (view) row.
   */
  credits?: Maybe<Scalars['Float']>;
  /** Mean average of daysInBill across the matching connection */
  daysInBill?: Maybe<Scalars['BigFloat']>;
  /** Mean average of facilityId across the matching connection */
  facilityId?: Maybe<Scalars['BigFloat']>;
  /**
   * Mean average of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_meter_statements (view) row.
   */
  fees?: Maybe<Scalars['Float']>;
  /** Mean average of meterStatementId across the matching connection */
  meterStatementId?: Maybe<Scalars['BigFloat']>;
  /** Mean average of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']>;
  /** Mean average of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']>;
  /**
   * Mean average of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_meter_statements (view) row.
   */
  taxes?: Maybe<Scalars['Float']>;
  /** Mean average of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']>;
  /** Mean average of utilityMeterId across the matching connection */
  utilityMeterId?: Maybe<Scalars['BigFloat']>;
};

/**
 * A condition to be used against `UtilityMeterStatement` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type UtilityMeterStatementCondition = {
  /** Checks for equality with the object’s `accountLabel` field. */
  accountLabel?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `accountStatementId` field. */
  accountStatementId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `billArrivalDate` field. */
  billArrivalDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `daysInBill` field. */
  daysInBill?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `demandUnits` field. */
  demandUnits?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `endDate` field. */
  endDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `excludeUsage` field. */
  excludeUsage?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `isValidated` field. */
  isValidated?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `meterEndDateSet` field. */
  meterEndDateSet?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `meterLabel` field. */
  meterLabel?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `meterStatementId` field. */
  meterStatementId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `provider` field. */
  provider?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `serviceType` field. */
  serviceType?: InputMaybe<UtilityMeterServiceType>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `statementMonth` field. */
  statementMonth?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `statementYear` field. */
  statementYear?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `usageUnits` field. */
  usageUnits?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `utilityAccountId` field. */
  utilityAccountId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `utilityMeterId` field. */
  utilityMeterId?: InputMaybe<Scalars['Int']>;
};

export type UtilityMeterStatementDistinctAggregates = {
  __typename?: 'UtilityMeterStatementDistinctAggregates';
  /** Distinct of accountLabel across the matching connection */
  accountLabel?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Distinct of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Distinct of billArrivalDate across the matching connection */
  billArrivalDate?: Maybe<Scalars['JSON']>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_meter_statements (view) row.
   */
  billCost?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Distinct of this field across the matching connection. */
  billDemand?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand charges of a given utility_meter_statements (view) row.
   */
  billDemandCost?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand of a given utility_meter_statements (view) row.
   */
  billUsage?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * Returns the total usage charges of a given utility_meter_statements (view) row.
   */
  billUsageCost?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_meter_statements (view) row.
   */
  credits?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Distinct of currencyCode across the matching connection */
  currencyCode?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Distinct of daysInBill across the matching connection */
  daysInBill?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Distinct of demandUnits across the matching connection */
  demandUnits?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Distinct of endDate across the matching connection */
  endDate?: Maybe<Scalars['JSON']>;
  /** Distinct of excludeUsage across the matching connection */
  excludeUsage?: Maybe<Scalars['JSON']>;
  /** Distinct of facilityId across the matching connection */
  facilityId?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_meter_statements (view) row.
   */
  fees?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Distinct of isValidated across the matching connection */
  isValidated?: Maybe<Scalars['JSON']>;
  /** Distinct of meterEndDateSet across the matching connection */
  meterEndDateSet?: Maybe<Scalars['JSON']>;
  /** Distinct of meterLabel across the matching connection */
  meterLabel?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Distinct of meterStatementId across the matching connection */
  meterStatementId?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Distinct of provider across the matching connection */
  provider?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Distinct of serviceType across the matching connection */
  serviceType?: Maybe<Scalars['JSON']>;
  /** Distinct of startDate across the matching connection */
  startDate?: Maybe<Scalars['JSON']>;
  /** Distinct of statementMonth across the matching connection */
  statementMonth?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Distinct of statementYear across the matching connection */
  statementYear?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_meter_statements (view) row.
   */
  taxes?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Distinct of usageUnits across the matching connection */
  usageUnits?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Distinct of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Distinct of utilityMeterId across the matching connection */
  utilityMeterId?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type UtilityMeterStatementDistinctCountAggregates = {
  __typename?: 'UtilityMeterStatementDistinctCountAggregates';
  /** Distinct count of accountLabel across the matching connection */
  accountLabel?: Maybe<Scalars['BigInt']>;
  /** Distinct count of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of billArrivalDate across the matching connection */
  billArrivalDate?: Maybe<Scalars['BigInt']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_meter_statements (view) row.
   */
  billCost?: Maybe<Scalars['BigInt']>;
  /** Distinct count of this field across the matching connection. */
  billDemand?: Maybe<Scalars['BigInt']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand charges of a given utility_meter_statements (view) row.
   */
  billDemandCost?: Maybe<Scalars['BigInt']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand of a given utility_meter_statements (view) row.
   */
  billUsage?: Maybe<Scalars['BigInt']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * Returns the total usage charges of a given utility_meter_statements (view) row.
   */
  billUsageCost?: Maybe<Scalars['BigInt']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_meter_statements (view) row.
   */
  credits?: Maybe<Scalars['BigInt']>;
  /** Distinct count of currencyCode across the matching connection */
  currencyCode?: Maybe<Scalars['BigInt']>;
  /** Distinct count of daysInBill across the matching connection */
  daysInBill?: Maybe<Scalars['BigInt']>;
  /** Distinct count of demandUnits across the matching connection */
  demandUnits?: Maybe<Scalars['BigInt']>;
  /** Distinct count of endDate across the matching connection */
  endDate?: Maybe<Scalars['BigInt']>;
  /** Distinct count of excludeUsage across the matching connection */
  excludeUsage?: Maybe<Scalars['BigInt']>;
  /** Distinct count of facilityId across the matching connection */
  facilityId?: Maybe<Scalars['BigInt']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_meter_statements (view) row.
   */
  fees?: Maybe<Scalars['BigInt']>;
  /** Distinct count of isValidated across the matching connection */
  isValidated?: Maybe<Scalars['BigInt']>;
  /** Distinct count of meterEndDateSet across the matching connection */
  meterEndDateSet?: Maybe<Scalars['BigInt']>;
  /** Distinct count of meterLabel across the matching connection */
  meterLabel?: Maybe<Scalars['BigInt']>;
  /** Distinct count of meterStatementId across the matching connection */
  meterStatementId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of provider across the matching connection */
  provider?: Maybe<Scalars['BigInt']>;
  /** Distinct count of serviceType across the matching connection */
  serviceType?: Maybe<Scalars['BigInt']>;
  /** Distinct count of startDate across the matching connection */
  startDate?: Maybe<Scalars['BigInt']>;
  /** Distinct count of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigInt']>;
  /** Distinct count of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigInt']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_meter_statements (view) row.
   */
  taxes?: Maybe<Scalars['BigInt']>;
  /** Distinct count of usageUnits across the matching connection */
  usageUnits?: Maybe<Scalars['BigInt']>;
  /** Distinct count of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of utilityMeterId across the matching connection */
  utilityMeterId?: Maybe<Scalars['BigInt']>;
};

/** A filter to be used against `UtilityMeterStatement` object types. All fields are combined with a logical ‘and.’ */
export type UtilityMeterStatementFilter = {
  /** Filter by the object’s `accountLabel` field. */
  accountLabel?: InputMaybe<StringFilter>;
  /** Filter by the object’s `accountStatementId` field. */
  accountStatementId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UtilityMeterStatementFilter>>;
  /** Filter by the object’s `billArrivalDate` field. */
  billArrivalDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `billCost` field. */
  billCost?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `billDemand` field. */
  billDemand?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `billDemandCost` field. */
  billDemandCost?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `billUsage` field. */
  billUsage?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `billUsageCost` field. */
  billUsageCost?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `credits` field. */
  credits?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `daysInBill` field. */
  daysInBill?: InputMaybe<IntFilter>;
  /** Filter by the object’s `demandUnits` field. */
  demandUnits?: InputMaybe<StringFilter>;
  /** Filter by the object’s `endDate` field. */
  endDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `excludeUsage` field. */
  excludeUsage?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `fees` field. */
  fees?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `isValidated` field. */
  isValidated?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `meterEndDateSet` field. */
  meterEndDateSet?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `meterLabel` field. */
  meterLabel?: InputMaybe<StringFilter>;
  /** Filter by the object’s `meterStatementId` field. */
  meterStatementId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UtilityMeterStatementFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UtilityMeterStatementFilter>>;
  /** Filter by the object’s `provider` field. */
  provider?: InputMaybe<StringFilter>;
  /** Filter by the object’s `serviceType` field. */
  serviceType?: InputMaybe<UtilityMeterServiceTypeFilter>;
  /** Filter by the object’s `startDate` field. */
  startDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `statementMonth` field. */
  statementMonth?: InputMaybe<IntFilter>;
  /** Filter by the object’s `statementYear` field. */
  statementYear?: InputMaybe<IntFilter>;
  /** Filter by the object’s `taxes` field. */
  taxes?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `usageUnits` field. */
  usageUnits?: InputMaybe<StringFilter>;
  /** Filter by the object’s `utilityAccountId` field. */
  utilityAccountId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `utilityMeterId` field. */
  utilityMeterId?: InputMaybe<IntFilter>;
};

export type UtilityMeterStatementMaxAggregates = {
  __typename?: 'UtilityMeterStatementMaxAggregates';
  /** Maximum of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['Int']>;
  /**
   * Maximum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_meter_statements (view) row.
   */
  billCost?: Maybe<Scalars['Float']>;
  /** Maximum of this field across the matching connection. */
  billDemand?: Maybe<Scalars['Float']>;
  /**
   * Maximum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand charges of a given utility_meter_statements (view) row.
   */
  billDemandCost?: Maybe<Scalars['Float']>;
  /**
   * Maximum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand of a given utility_meter_statements (view) row.
   */
  billUsage?: Maybe<Scalars['Float']>;
  /**
   * Maximum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total usage charges of a given utility_meter_statements (view) row.
   */
  billUsageCost?: Maybe<Scalars['Float']>;
  /**
   * Maximum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_meter_statements (view) row.
   */
  credits?: Maybe<Scalars['Float']>;
  /** Maximum of daysInBill across the matching connection */
  daysInBill?: Maybe<Scalars['Int']>;
  /** Maximum of facilityId across the matching connection */
  facilityId?: Maybe<Scalars['Int']>;
  /**
   * Maximum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_meter_statements (view) row.
   */
  fees?: Maybe<Scalars['Float']>;
  /** Maximum of meterStatementId across the matching connection */
  meterStatementId?: Maybe<Scalars['Int']>;
  /** Maximum of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['Int']>;
  /** Maximum of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['Int']>;
  /**
   * Maximum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_meter_statements (view) row.
   */
  taxes?: Maybe<Scalars['Float']>;
  /** Maximum of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['Int']>;
  /** Maximum of utilityMeterId across the matching connection */
  utilityMeterId?: Maybe<Scalars['Int']>;
};

export type UtilityMeterStatementMinAggregates = {
  __typename?: 'UtilityMeterStatementMinAggregates';
  /** Minimum of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['Int']>;
  /**
   * Minimum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_meter_statements (view) row.
   */
  billCost?: Maybe<Scalars['Float']>;
  /** Minimum of this field across the matching connection. */
  billDemand?: Maybe<Scalars['Float']>;
  /**
   * Minimum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand charges of a given utility_meter_statements (view) row.
   */
  billDemandCost?: Maybe<Scalars['Float']>;
  /**
   * Minimum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand of a given utility_meter_statements (view) row.
   */
  billUsage?: Maybe<Scalars['Float']>;
  /**
   * Minimum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total usage charges of a given utility_meter_statements (view) row.
   */
  billUsageCost?: Maybe<Scalars['Float']>;
  /**
   * Minimum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_meter_statements (view) row.
   */
  credits?: Maybe<Scalars['Float']>;
  /** Minimum of daysInBill across the matching connection */
  daysInBill?: Maybe<Scalars['Int']>;
  /** Minimum of facilityId across the matching connection */
  facilityId?: Maybe<Scalars['Int']>;
  /**
   * Minimum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_meter_statements (view) row.
   */
  fees?: Maybe<Scalars['Float']>;
  /** Minimum of meterStatementId across the matching connection */
  meterStatementId?: Maybe<Scalars['Int']>;
  /** Minimum of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['Int']>;
  /** Minimum of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['Int']>;
  /**
   * Minimum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_meter_statements (view) row.
   */
  taxes?: Maybe<Scalars['Float']>;
  /** Minimum of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['Int']>;
  /** Minimum of utilityMeterId across the matching connection */
  utilityMeterId?: Maybe<Scalars['Int']>;
};

export type UtilityMeterStatementRollup = Node & {
  __typename?: 'UtilityMeterStatementRollup';
  accountLabel?: Maybe<Scalars['String']>;
  accountStatementId?: Maybe<Scalars['Int']>;
  billArrivalDate?: Maybe<Scalars['Datetime']>;
  billCost?: Maybe<Scalars['Float']>;
  billDemand?: Maybe<Scalars['Float']>;
  billDemandCost?: Maybe<Scalars['Float']>;
  billUsage?: Maybe<Scalars['Float']>;
  billUsageCost?: Maybe<Scalars['Float']>;
  blendedRate?: Maybe<Scalars['Float']>;
  credits?: Maybe<Scalars['Float']>;
  currencyCode?: Maybe<Scalars['String']>;
  daysInBill?: Maybe<Scalars['Int']>;
  demandUnits?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Date']>;
  /** Reads a single `Facility` that is related to this `UtilityMeterStatementRollup`. */
  facility?: Maybe<Facility>;
  facilityId?: Maybe<Scalars['Int']>;
  /** The name of the facility associated with the meter statement. */
  facilityName?: Maybe<Scalars['String']>;
  fees?: Maybe<Scalars['Float']>;
  isValidated?: Maybe<Scalars['Boolean']>;
  loadFactor?: Maybe<Scalars['Float']>;
  meterEndDateSet?: Maybe<Scalars['Boolean']>;
  meterLabel?: Maybe<Scalars['String']>;
  /** Reads a single `MeterStatement` that is related to this `UtilityMeterStatementRollup`. */
  meterStatement?: Maybe<MeterStatement>;
  meterStatementId: Scalars['Int'];
  /** The nsight2 active status of the rows facility. */
  nSight2Active?: Maybe<Scalars['Boolean']>;
  netBillUsage?: Maybe<Scalars['Float']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  percentChange?: Maybe<Scalars['Float']>;
  provider?: Maybe<Scalars['String']>;
  serviceType?: Maybe<UtilityMeterServiceType>;
  startDate?: Maybe<Scalars['Date']>;
  /** The statement date of the meter statement. */
  statementDate?: Maybe<Scalars['String']>;
  statementMonth?: Maybe<Scalars['Int']>;
  statementYear?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Float']>;
  usageUnits?: Maybe<Scalars['String']>;
  /** Reads a single `UtilityAccount` that is related to this `UtilityMeterStatementRollup`. */
  utilityAccount?: Maybe<UtilityAccount>;
  utilityAccountId?: Maybe<Scalars['Int']>;
  /** Reads a single `UtilityMeter` that is related to this `UtilityMeterStatementRollup`. */
  utilityMeter?: Maybe<UtilityMeter>;
  utilityMeterId?: Maybe<Scalars['Int']>;
};

export type UtilityMeterStatementRollupAggregates = {
  __typename?: 'UtilityMeterStatementRollupAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<UtilityMeterStatementRollupAverageAggregates>;
  /** Distinct aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinct?: Maybe<UtilityMeterStatementRollupDistinctAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<UtilityMeterStatementRollupDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<UtilityMeterStatementRollupMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<UtilityMeterStatementRollupMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<UtilityMeterStatementRollupStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<UtilityMeterStatementRollupStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<UtilityMeterStatementRollupSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<UtilityMeterStatementRollupVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<UtilityMeterStatementRollupVarianceSampleAggregates>;
};

export type UtilityMeterStatementRollupAverageAggregates = {
  __typename?: 'UtilityMeterStatementRollupAverageAggregates';
  /** Mean average of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']>;
  /** Mean average of billCost across the matching connection */
  billCost?: Maybe<Scalars['Float']>;
  /** Mean average of billDemand across the matching connection */
  billDemand?: Maybe<Scalars['Float']>;
  /** Mean average of billDemandCost across the matching connection */
  billDemandCost?: Maybe<Scalars['Float']>;
  /** Mean average of billUsage across the matching connection */
  billUsage?: Maybe<Scalars['Float']>;
  /** Mean average of billUsageCost across the matching connection */
  billUsageCost?: Maybe<Scalars['Float']>;
  /** Mean average of blendedRate across the matching connection */
  blendedRate?: Maybe<Scalars['Float']>;
  /** Mean average of credits across the matching connection */
  credits?: Maybe<Scalars['Float']>;
  /** Mean average of daysInBill across the matching connection */
  daysInBill?: Maybe<Scalars['BigFloat']>;
  /** Mean average of facilityId across the matching connection */
  facilityId?: Maybe<Scalars['BigFloat']>;
  /** Mean average of fees across the matching connection */
  fees?: Maybe<Scalars['Float']>;
  /** Mean average of loadFactor across the matching connection */
  loadFactor?: Maybe<Scalars['Float']>;
  /** Mean average of meterStatementId across the matching connection */
  meterStatementId?: Maybe<Scalars['BigFloat']>;
  /** Mean average of netBillUsage across the matching connection */
  netBillUsage?: Maybe<Scalars['Float']>;
  /** Mean average of percentChange across the matching connection */
  percentChange?: Maybe<Scalars['Float']>;
  /** Mean average of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']>;
  /** Mean average of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']>;
  /** Mean average of taxes across the matching connection */
  taxes?: Maybe<Scalars['Float']>;
  /** Mean average of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']>;
  /** Mean average of utilityMeterId across the matching connection */
  utilityMeterId?: Maybe<Scalars['BigFloat']>;
};

/**
 * A condition to be used against `UtilityMeterStatementRollup` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type UtilityMeterStatementRollupCondition = {
  /** Checks for equality with the object’s `accountLabel` field. */
  accountLabel?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `accountStatementId` field. */
  accountStatementId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `billArrivalDate` field. */
  billArrivalDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `billCost` field. */
  billCost?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `billDemand` field. */
  billDemand?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `billDemandCost` field. */
  billDemandCost?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `billUsage` field. */
  billUsage?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `billUsageCost` field. */
  billUsageCost?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `blendedRate` field. */
  blendedRate?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `credits` field. */
  credits?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `daysInBill` field. */
  daysInBill?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `demandUnits` field. */
  demandUnits?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `endDate` field. */
  endDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `fees` field. */
  fees?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `isValidated` field. */
  isValidated?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `loadFactor` field. */
  loadFactor?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `meterEndDateSet` field. */
  meterEndDateSet?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `meterLabel` field. */
  meterLabel?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `meterStatementId` field. */
  meterStatementId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `netBillUsage` field. */
  netBillUsage?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `percentChange` field. */
  percentChange?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `provider` field. */
  provider?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `serviceType` field. */
  serviceType?: InputMaybe<UtilityMeterServiceType>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `statementMonth` field. */
  statementMonth?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `statementYear` field. */
  statementYear?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `taxes` field. */
  taxes?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `usageUnits` field. */
  usageUnits?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `utilityAccountId` field. */
  utilityAccountId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `utilityMeterId` field. */
  utilityMeterId?: InputMaybe<Scalars['Int']>;
};

export type UtilityMeterStatementRollupDistinctAggregates = {
  __typename?: 'UtilityMeterStatementRollupDistinctAggregates';
  /** Distinct of accountLabel across the matching connection */
  accountLabel?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Distinct of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Distinct of billArrivalDate across the matching connection */
  billArrivalDate?: Maybe<Scalars['JSON']>;
  /** Distinct of billCost across the matching connection */
  billCost?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Distinct of billDemand across the matching connection */
  billDemand?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Distinct of billDemandCost across the matching connection */
  billDemandCost?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Distinct of billUsage across the matching connection */
  billUsage?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Distinct of billUsageCost across the matching connection */
  billUsageCost?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Distinct of blendedRate across the matching connection */
  blendedRate?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Distinct of credits across the matching connection */
  credits?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Distinct of currencyCode across the matching connection */
  currencyCode?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Distinct of daysInBill across the matching connection */
  daysInBill?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Distinct of demandUnits across the matching connection */
  demandUnits?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Distinct of endDate across the matching connection */
  endDate?: Maybe<Scalars['JSON']>;
  /** Distinct of facilityId across the matching connection */
  facilityId?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * The name of the facility associated with the meter statement.
   */
  facilityName?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Distinct of fees across the matching connection */
  fees?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Distinct of isValidated across the matching connection */
  isValidated?: Maybe<Scalars['JSON']>;
  /** Distinct of loadFactor across the matching connection */
  loadFactor?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Distinct of meterEndDateSet across the matching connection */
  meterEndDateSet?: Maybe<Scalars['JSON']>;
  /** Distinct of meterLabel across the matching connection */
  meterLabel?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Distinct of meterStatementId across the matching connection */
  meterStatementId?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * The nsight2 active status of the rows facility.
   */
  nSight2Active?: Maybe<Scalars['JSON']>;
  /** Distinct of netBillUsage across the matching connection */
  netBillUsage?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Distinct of percentChange across the matching connection */
  percentChange?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Distinct of provider across the matching connection */
  provider?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Distinct of serviceType across the matching connection */
  serviceType?: Maybe<Scalars['JSON']>;
  /** Distinct of startDate across the matching connection */
  startDate?: Maybe<Scalars['JSON']>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * The statement date of the meter statement.
   */
  statementDate?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Distinct of statementMonth across the matching connection */
  statementMonth?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Distinct of statementYear across the matching connection */
  statementYear?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Distinct of taxes across the matching connection */
  taxes?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Distinct of usageUnits across the matching connection */
  usageUnits?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Distinct of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Distinct of utilityMeterId across the matching connection */
  utilityMeterId?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type UtilityMeterStatementRollupDistinctCountAggregates = {
  __typename?: 'UtilityMeterStatementRollupDistinctCountAggregates';
  /** Distinct count of accountLabel across the matching connection */
  accountLabel?: Maybe<Scalars['BigInt']>;
  /** Distinct count of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of billArrivalDate across the matching connection */
  billArrivalDate?: Maybe<Scalars['BigInt']>;
  /** Distinct count of billCost across the matching connection */
  billCost?: Maybe<Scalars['BigInt']>;
  /** Distinct count of billDemand across the matching connection */
  billDemand?: Maybe<Scalars['BigInt']>;
  /** Distinct count of billDemandCost across the matching connection */
  billDemandCost?: Maybe<Scalars['BigInt']>;
  /** Distinct count of billUsage across the matching connection */
  billUsage?: Maybe<Scalars['BigInt']>;
  /** Distinct count of billUsageCost across the matching connection */
  billUsageCost?: Maybe<Scalars['BigInt']>;
  /** Distinct count of blendedRate across the matching connection */
  blendedRate?: Maybe<Scalars['BigInt']>;
  /** Distinct count of credits across the matching connection */
  credits?: Maybe<Scalars['BigInt']>;
  /** Distinct count of currencyCode across the matching connection */
  currencyCode?: Maybe<Scalars['BigInt']>;
  /** Distinct count of daysInBill across the matching connection */
  daysInBill?: Maybe<Scalars['BigInt']>;
  /** Distinct count of demandUnits across the matching connection */
  demandUnits?: Maybe<Scalars['BigInt']>;
  /** Distinct count of endDate across the matching connection */
  endDate?: Maybe<Scalars['BigInt']>;
  /** Distinct count of facilityId across the matching connection */
  facilityId?: Maybe<Scalars['BigInt']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * The name of the facility associated with the meter statement.
   */
  facilityName?: Maybe<Scalars['BigInt']>;
  /** Distinct count of fees across the matching connection */
  fees?: Maybe<Scalars['BigInt']>;
  /** Distinct count of isValidated across the matching connection */
  isValidated?: Maybe<Scalars['BigInt']>;
  /** Distinct count of loadFactor across the matching connection */
  loadFactor?: Maybe<Scalars['BigInt']>;
  /** Distinct count of meterEndDateSet across the matching connection */
  meterEndDateSet?: Maybe<Scalars['BigInt']>;
  /** Distinct count of meterLabel across the matching connection */
  meterLabel?: Maybe<Scalars['BigInt']>;
  /** Distinct count of meterStatementId across the matching connection */
  meterStatementId?: Maybe<Scalars['BigInt']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * The nsight2 active status of the rows facility.
   */
  nSight2Active?: Maybe<Scalars['BigInt']>;
  /** Distinct count of netBillUsage across the matching connection */
  netBillUsage?: Maybe<Scalars['BigInt']>;
  /** Distinct count of percentChange across the matching connection */
  percentChange?: Maybe<Scalars['BigInt']>;
  /** Distinct count of provider across the matching connection */
  provider?: Maybe<Scalars['BigInt']>;
  /** Distinct count of serviceType across the matching connection */
  serviceType?: Maybe<Scalars['BigInt']>;
  /** Distinct count of startDate across the matching connection */
  startDate?: Maybe<Scalars['BigInt']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * The statement date of the meter statement.
   */
  statementDate?: Maybe<Scalars['BigInt']>;
  /** Distinct count of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigInt']>;
  /** Distinct count of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigInt']>;
  /** Distinct count of taxes across the matching connection */
  taxes?: Maybe<Scalars['BigInt']>;
  /** Distinct count of usageUnits across the matching connection */
  usageUnits?: Maybe<Scalars['BigInt']>;
  /** Distinct count of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of utilityMeterId across the matching connection */
  utilityMeterId?: Maybe<Scalars['BigInt']>;
};

/** A filter to be used against `UtilityMeterStatementRollup` object types. All fields are combined with a logical ‘and.’ */
export type UtilityMeterStatementRollupFilter = {
  /** Filter by the object’s `accountLabel` field. */
  accountLabel?: InputMaybe<StringFilter>;
  /** Filter by the object’s `accountStatementId` field. */
  accountStatementId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UtilityMeterStatementRollupFilter>>;
  /** Filter by the object’s `billArrivalDate` field. */
  billArrivalDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `billCost` field. */
  billCost?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `billDemand` field. */
  billDemand?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `billDemandCost` field. */
  billDemandCost?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `billUsage` field. */
  billUsage?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `billUsageCost` field. */
  billUsageCost?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `blendedRate` field. */
  blendedRate?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `credits` field. */
  credits?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `daysInBill` field. */
  daysInBill?: InputMaybe<IntFilter>;
  /** Filter by the object’s `demandUnits` field. */
  demandUnits?: InputMaybe<StringFilter>;
  /** Filter by the object’s `endDate` field. */
  endDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `facilityName` field. */
  facilityName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fees` field. */
  fees?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `isValidated` field. */
  isValidated?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `loadFactor` field. */
  loadFactor?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `meterEndDateSet` field. */
  meterEndDateSet?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `meterLabel` field. */
  meterLabel?: InputMaybe<StringFilter>;
  /** Filter by the object’s `meterStatementId` field. */
  meterStatementId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `nSight2Active` field. */
  nSight2Active?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `netBillUsage` field. */
  netBillUsage?: InputMaybe<FloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UtilityMeterStatementRollupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UtilityMeterStatementRollupFilter>>;
  /** Filter by the object’s `percentChange` field. */
  percentChange?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `provider` field. */
  provider?: InputMaybe<StringFilter>;
  /** Filter by the object’s `serviceType` field. */
  serviceType?: InputMaybe<UtilityMeterServiceTypeFilter>;
  /** Filter by the object’s `startDate` field. */
  startDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `statementDate` field. */
  statementDate?: InputMaybe<StringFilter>;
  /** Filter by the object’s `statementMonth` field. */
  statementMonth?: InputMaybe<IntFilter>;
  /** Filter by the object’s `statementYear` field. */
  statementYear?: InputMaybe<IntFilter>;
  /** Filter by the object’s `taxes` field. */
  taxes?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `usageUnits` field. */
  usageUnits?: InputMaybe<StringFilter>;
  /** Filter by the object’s `utilityAccountId` field. */
  utilityAccountId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `utilityMeterId` field. */
  utilityMeterId?: InputMaybe<IntFilter>;
};

export type UtilityMeterStatementRollupMaxAggregates = {
  __typename?: 'UtilityMeterStatementRollupMaxAggregates';
  /** Maximum of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['Int']>;
  /** Maximum of billCost across the matching connection */
  billCost?: Maybe<Scalars['Float']>;
  /** Maximum of billDemand across the matching connection */
  billDemand?: Maybe<Scalars['Float']>;
  /** Maximum of billDemandCost across the matching connection */
  billDemandCost?: Maybe<Scalars['Float']>;
  /** Maximum of billUsage across the matching connection */
  billUsage?: Maybe<Scalars['Float']>;
  /** Maximum of billUsageCost across the matching connection */
  billUsageCost?: Maybe<Scalars['Float']>;
  /** Maximum of blendedRate across the matching connection */
  blendedRate?: Maybe<Scalars['Float']>;
  /** Maximum of credits across the matching connection */
  credits?: Maybe<Scalars['Float']>;
  /** Maximum of daysInBill across the matching connection */
  daysInBill?: Maybe<Scalars['Int']>;
  /** Maximum of facilityId across the matching connection */
  facilityId?: Maybe<Scalars['Int']>;
  /** Maximum of fees across the matching connection */
  fees?: Maybe<Scalars['Float']>;
  /** Maximum of loadFactor across the matching connection */
  loadFactor?: Maybe<Scalars['Float']>;
  /** Maximum of meterStatementId across the matching connection */
  meterStatementId?: Maybe<Scalars['Int']>;
  /** Maximum of netBillUsage across the matching connection */
  netBillUsage?: Maybe<Scalars['Float']>;
  /** Maximum of percentChange across the matching connection */
  percentChange?: Maybe<Scalars['Float']>;
  /** Maximum of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['Int']>;
  /** Maximum of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['Int']>;
  /** Maximum of taxes across the matching connection */
  taxes?: Maybe<Scalars['Float']>;
  /** Maximum of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['Int']>;
  /** Maximum of utilityMeterId across the matching connection */
  utilityMeterId?: Maybe<Scalars['Int']>;
};

export type UtilityMeterStatementRollupMinAggregates = {
  __typename?: 'UtilityMeterStatementRollupMinAggregates';
  /** Minimum of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['Int']>;
  /** Minimum of billCost across the matching connection */
  billCost?: Maybe<Scalars['Float']>;
  /** Minimum of billDemand across the matching connection */
  billDemand?: Maybe<Scalars['Float']>;
  /** Minimum of billDemandCost across the matching connection */
  billDemandCost?: Maybe<Scalars['Float']>;
  /** Minimum of billUsage across the matching connection */
  billUsage?: Maybe<Scalars['Float']>;
  /** Minimum of billUsageCost across the matching connection */
  billUsageCost?: Maybe<Scalars['Float']>;
  /** Minimum of blendedRate across the matching connection */
  blendedRate?: Maybe<Scalars['Float']>;
  /** Minimum of credits across the matching connection */
  credits?: Maybe<Scalars['Float']>;
  /** Minimum of daysInBill across the matching connection */
  daysInBill?: Maybe<Scalars['Int']>;
  /** Minimum of facilityId across the matching connection */
  facilityId?: Maybe<Scalars['Int']>;
  /** Minimum of fees across the matching connection */
  fees?: Maybe<Scalars['Float']>;
  /** Minimum of loadFactor across the matching connection */
  loadFactor?: Maybe<Scalars['Float']>;
  /** Minimum of meterStatementId across the matching connection */
  meterStatementId?: Maybe<Scalars['Int']>;
  /** Minimum of netBillUsage across the matching connection */
  netBillUsage?: Maybe<Scalars['Float']>;
  /** Minimum of percentChange across the matching connection */
  percentChange?: Maybe<Scalars['Float']>;
  /** Minimum of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['Int']>;
  /** Minimum of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['Int']>;
  /** Minimum of taxes across the matching connection */
  taxes?: Maybe<Scalars['Float']>;
  /** Minimum of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['Int']>;
  /** Minimum of utilityMeterId across the matching connection */
  utilityMeterId?: Maybe<Scalars['Int']>;
};

export type UtilityMeterStatementRollupStddevPopulationAggregates = {
  __typename?: 'UtilityMeterStatementRollupStddevPopulationAggregates';
  /** Population standard deviation of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of billCost across the matching connection */
  billCost?: Maybe<Scalars['Float']>;
  /** Population standard deviation of billDemand across the matching connection */
  billDemand?: Maybe<Scalars['Float']>;
  /** Population standard deviation of billDemandCost across the matching connection */
  billDemandCost?: Maybe<Scalars['Float']>;
  /** Population standard deviation of billUsage across the matching connection */
  billUsage?: Maybe<Scalars['Float']>;
  /** Population standard deviation of billUsageCost across the matching connection */
  billUsageCost?: Maybe<Scalars['Float']>;
  /** Population standard deviation of blendedRate across the matching connection */
  blendedRate?: Maybe<Scalars['Float']>;
  /** Population standard deviation of credits across the matching connection */
  credits?: Maybe<Scalars['Float']>;
  /** Population standard deviation of daysInBill across the matching connection */
  daysInBill?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of facilityId across the matching connection */
  facilityId?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of fees across the matching connection */
  fees?: Maybe<Scalars['Float']>;
  /** Population standard deviation of loadFactor across the matching connection */
  loadFactor?: Maybe<Scalars['Float']>;
  /** Population standard deviation of meterStatementId across the matching connection */
  meterStatementId?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of netBillUsage across the matching connection */
  netBillUsage?: Maybe<Scalars['Float']>;
  /** Population standard deviation of percentChange across the matching connection */
  percentChange?: Maybe<Scalars['Float']>;
  /** Population standard deviation of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of taxes across the matching connection */
  taxes?: Maybe<Scalars['Float']>;
  /** Population standard deviation of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of utilityMeterId across the matching connection */
  utilityMeterId?: Maybe<Scalars['BigFloat']>;
};

export type UtilityMeterStatementRollupStddevSampleAggregates = {
  __typename?: 'UtilityMeterStatementRollupStddevSampleAggregates';
  /** Sample standard deviation of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of billCost across the matching connection */
  billCost?: Maybe<Scalars['Float']>;
  /** Sample standard deviation of billDemand across the matching connection */
  billDemand?: Maybe<Scalars['Float']>;
  /** Sample standard deviation of billDemandCost across the matching connection */
  billDemandCost?: Maybe<Scalars['Float']>;
  /** Sample standard deviation of billUsage across the matching connection */
  billUsage?: Maybe<Scalars['Float']>;
  /** Sample standard deviation of billUsageCost across the matching connection */
  billUsageCost?: Maybe<Scalars['Float']>;
  /** Sample standard deviation of blendedRate across the matching connection */
  blendedRate?: Maybe<Scalars['Float']>;
  /** Sample standard deviation of credits across the matching connection */
  credits?: Maybe<Scalars['Float']>;
  /** Sample standard deviation of daysInBill across the matching connection */
  daysInBill?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of facilityId across the matching connection */
  facilityId?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of fees across the matching connection */
  fees?: Maybe<Scalars['Float']>;
  /** Sample standard deviation of loadFactor across the matching connection */
  loadFactor?: Maybe<Scalars['Float']>;
  /** Sample standard deviation of meterStatementId across the matching connection */
  meterStatementId?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of netBillUsage across the matching connection */
  netBillUsage?: Maybe<Scalars['Float']>;
  /** Sample standard deviation of percentChange across the matching connection */
  percentChange?: Maybe<Scalars['Float']>;
  /** Sample standard deviation of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of taxes across the matching connection */
  taxes?: Maybe<Scalars['Float']>;
  /** Sample standard deviation of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of utilityMeterId across the matching connection */
  utilityMeterId?: Maybe<Scalars['BigFloat']>;
};

export type UtilityMeterStatementRollupSumAggregates = {
  __typename?: 'UtilityMeterStatementRollupSumAggregates';
  /** Sum of accountStatementId across the matching connection */
  accountStatementId: Scalars['BigInt'];
  /** Sum of billCost across the matching connection */
  billCost: Scalars['Float'];
  /** Sum of billDemand across the matching connection */
  billDemand: Scalars['Float'];
  /** Sum of billDemandCost across the matching connection */
  billDemandCost: Scalars['Float'];
  /** Sum of billUsage across the matching connection */
  billUsage: Scalars['Float'];
  /** Sum of billUsageCost across the matching connection */
  billUsageCost: Scalars['Float'];
  /** Sum of blendedRate across the matching connection */
  blendedRate: Scalars['Float'];
  /** Sum of credits across the matching connection */
  credits: Scalars['Float'];
  /** Sum of daysInBill across the matching connection */
  daysInBill: Scalars['BigInt'];
  /** Sum of facilityId across the matching connection */
  facilityId: Scalars['BigInt'];
  /** Sum of fees across the matching connection */
  fees: Scalars['Float'];
  /** Sum of loadFactor across the matching connection */
  loadFactor: Scalars['Float'];
  /** Sum of meterStatementId across the matching connection */
  meterStatementId: Scalars['BigInt'];
  /** Sum of netBillUsage across the matching connection */
  netBillUsage: Scalars['Float'];
  /** Sum of percentChange across the matching connection */
  percentChange: Scalars['Float'];
  /** Sum of statementMonth across the matching connection */
  statementMonth: Scalars['BigInt'];
  /** Sum of statementYear across the matching connection */
  statementYear: Scalars['BigInt'];
  /** Sum of taxes across the matching connection */
  taxes: Scalars['Float'];
  /** Sum of utilityAccountId across the matching connection */
  utilityAccountId: Scalars['BigInt'];
  /** Sum of utilityMeterId across the matching connection */
  utilityMeterId: Scalars['BigInt'];
};

export type UtilityMeterStatementRollupVariancePopulationAggregates = {
  __typename?: 'UtilityMeterStatementRollupVariancePopulationAggregates';
  /** Population variance of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']>;
  /** Population variance of billCost across the matching connection */
  billCost?: Maybe<Scalars['Float']>;
  /** Population variance of billDemand across the matching connection */
  billDemand?: Maybe<Scalars['Float']>;
  /** Population variance of billDemandCost across the matching connection */
  billDemandCost?: Maybe<Scalars['Float']>;
  /** Population variance of billUsage across the matching connection */
  billUsage?: Maybe<Scalars['Float']>;
  /** Population variance of billUsageCost across the matching connection */
  billUsageCost?: Maybe<Scalars['Float']>;
  /** Population variance of blendedRate across the matching connection */
  blendedRate?: Maybe<Scalars['Float']>;
  /** Population variance of credits across the matching connection */
  credits?: Maybe<Scalars['Float']>;
  /** Population variance of daysInBill across the matching connection */
  daysInBill?: Maybe<Scalars['BigFloat']>;
  /** Population variance of facilityId across the matching connection */
  facilityId?: Maybe<Scalars['BigFloat']>;
  /** Population variance of fees across the matching connection */
  fees?: Maybe<Scalars['Float']>;
  /** Population variance of loadFactor across the matching connection */
  loadFactor?: Maybe<Scalars['Float']>;
  /** Population variance of meterStatementId across the matching connection */
  meterStatementId?: Maybe<Scalars['BigFloat']>;
  /** Population variance of netBillUsage across the matching connection */
  netBillUsage?: Maybe<Scalars['Float']>;
  /** Population variance of percentChange across the matching connection */
  percentChange?: Maybe<Scalars['Float']>;
  /** Population variance of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']>;
  /** Population variance of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']>;
  /** Population variance of taxes across the matching connection */
  taxes?: Maybe<Scalars['Float']>;
  /** Population variance of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']>;
  /** Population variance of utilityMeterId across the matching connection */
  utilityMeterId?: Maybe<Scalars['BigFloat']>;
};

export type UtilityMeterStatementRollupVarianceSampleAggregates = {
  __typename?: 'UtilityMeterStatementRollupVarianceSampleAggregates';
  /** Sample variance of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of billCost across the matching connection */
  billCost?: Maybe<Scalars['Float']>;
  /** Sample variance of billDemand across the matching connection */
  billDemand?: Maybe<Scalars['Float']>;
  /** Sample variance of billDemandCost across the matching connection */
  billDemandCost?: Maybe<Scalars['Float']>;
  /** Sample variance of billUsage across the matching connection */
  billUsage?: Maybe<Scalars['Float']>;
  /** Sample variance of billUsageCost across the matching connection */
  billUsageCost?: Maybe<Scalars['Float']>;
  /** Sample variance of blendedRate across the matching connection */
  blendedRate?: Maybe<Scalars['Float']>;
  /** Sample variance of credits across the matching connection */
  credits?: Maybe<Scalars['Float']>;
  /** Sample variance of daysInBill across the matching connection */
  daysInBill?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of facilityId across the matching connection */
  facilityId?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of fees across the matching connection */
  fees?: Maybe<Scalars['Float']>;
  /** Sample variance of loadFactor across the matching connection */
  loadFactor?: Maybe<Scalars['Float']>;
  /** Sample variance of meterStatementId across the matching connection */
  meterStatementId?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of netBillUsage across the matching connection */
  netBillUsage?: Maybe<Scalars['Float']>;
  /** Sample variance of percentChange across the matching connection */
  percentChange?: Maybe<Scalars['Float']>;
  /** Sample variance of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of taxes across the matching connection */
  taxes?: Maybe<Scalars['Float']>;
  /** Sample variance of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of utilityMeterId across the matching connection */
  utilityMeterId?: Maybe<Scalars['BigFloat']>;
};

/** A connection to a list of `UtilityMeterStatementRollup` values. */
export type UtilityMeterStatementRollupsConnection = {
  __typename?: 'UtilityMeterStatementRollupsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<UtilityMeterStatementRollupAggregates>;
  /** A list of edges which contains the `UtilityMeterStatementRollup` and cursor to aid in pagination. */
  edges: Array<UtilityMeterStatementRollupsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<UtilityMeterStatementRollupAggregates>>;
  /** A list of `UtilityMeterStatementRollup` objects. */
  nodes: Array<UtilityMeterStatementRollup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UtilityMeterStatementRollup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A connection to a list of `UtilityMeterStatementRollup` values. */
export type UtilityMeterStatementRollupsConnectionGroupedAggregatesArgs = {
  groupBy: Array<UtilityMeterStatementRollupsGroupBy>;
  having?: InputMaybe<UtilityMeterStatementRollupsHavingInput>;
};

/** A `UtilityMeterStatementRollup` edge in the connection. */
export type UtilityMeterStatementRollupsEdge = {
  __typename?: 'UtilityMeterStatementRollupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UtilityMeterStatementRollup` at the end of the edge. */
  node: UtilityMeterStatementRollup;
};

/** Grouping methods for `UtilityMeterStatementRollup` for usage during aggregation. */
export enum UtilityMeterStatementRollupsGroupBy {
  ACCOUNT_LABEL = 'ACCOUNT_LABEL',
  ACCOUNT_LABEL_DISTINCT = 'ACCOUNT_LABEL_DISTINCT',
  ACCOUNT_STATEMENT_ID = 'ACCOUNT_STATEMENT_ID',
  ACCOUNT_STATEMENT_ID_DISTINCT = 'ACCOUNT_STATEMENT_ID_DISTINCT',
  BILL_ARRIVAL_DATE = 'BILL_ARRIVAL_DATE',
  BILL_ARRIVAL_DATE_DISTINCT = 'BILL_ARRIVAL_DATE_DISTINCT',
  BILL_ARRIVAL_DATE_TRUNCATED_TO_DAY = 'BILL_ARRIVAL_DATE_TRUNCATED_TO_DAY',
  BILL_ARRIVAL_DATE_TRUNCATED_TO_HOUR = 'BILL_ARRIVAL_DATE_TRUNCATED_TO_HOUR',
  BILL_COST = 'BILL_COST',
  BILL_COST_DISTINCT = 'BILL_COST_DISTINCT',
  BILL_DEMAND = 'BILL_DEMAND',
  BILL_DEMAND_COST = 'BILL_DEMAND_COST',
  BILL_DEMAND_COST_DISTINCT = 'BILL_DEMAND_COST_DISTINCT',
  BILL_DEMAND_DISTINCT = 'BILL_DEMAND_DISTINCT',
  BILL_USAGE = 'BILL_USAGE',
  BILL_USAGE_COST = 'BILL_USAGE_COST',
  BILL_USAGE_COST_DISTINCT = 'BILL_USAGE_COST_DISTINCT',
  BILL_USAGE_DISTINCT = 'BILL_USAGE_DISTINCT',
  BLENDED_RATE = 'BLENDED_RATE',
  BLENDED_RATE_DISTINCT = 'BLENDED_RATE_DISTINCT',
  CREDITS = 'CREDITS',
  CREDITS_DISTINCT = 'CREDITS_DISTINCT',
  CURRENCY_CODE = 'CURRENCY_CODE',
  CURRENCY_CODE_DISTINCT = 'CURRENCY_CODE_DISTINCT',
  DAYS_IN_BILL = 'DAYS_IN_BILL',
  DAYS_IN_BILL_DISTINCT = 'DAYS_IN_BILL_DISTINCT',
  DEMAND_UNITS = 'DEMAND_UNITS',
  DEMAND_UNITS_DISTINCT = 'DEMAND_UNITS_DISTINCT',
  END_DATE = 'END_DATE',
  END_DATE_DISTINCT = 'END_DATE_DISTINCT',
  FACILITY_ID = 'FACILITY_ID',
  FACILITY_ID_DISTINCT = 'FACILITY_ID_DISTINCT',
  FEES = 'FEES',
  FEES_DISTINCT = 'FEES_DISTINCT',
  IS_VALIDATED = 'IS_VALIDATED',
  IS_VALIDATED_DISTINCT = 'IS_VALIDATED_DISTINCT',
  LOAD_FACTOR = 'LOAD_FACTOR',
  LOAD_FACTOR_DISTINCT = 'LOAD_FACTOR_DISTINCT',
  METER_END_DATE_SET = 'METER_END_DATE_SET',
  METER_END_DATE_SET_DISTINCT = 'METER_END_DATE_SET_DISTINCT',
  METER_LABEL = 'METER_LABEL',
  METER_LABEL_DISTINCT = 'METER_LABEL_DISTINCT',
  METER_STATEMENT_ID = 'METER_STATEMENT_ID',
  METER_STATEMENT_ID_DISTINCT = 'METER_STATEMENT_ID_DISTINCT',
  NET_BILL_USAGE = 'NET_BILL_USAGE',
  NET_BILL_USAGE_DISTINCT = 'NET_BILL_USAGE_DISTINCT',
  PERCENT_CHANGE = 'PERCENT_CHANGE',
  PERCENT_CHANGE_DISTINCT = 'PERCENT_CHANGE_DISTINCT',
  PROVIDER = 'PROVIDER',
  PROVIDER_DISTINCT = 'PROVIDER_DISTINCT',
  SERVICE_TYPE = 'SERVICE_TYPE',
  SERVICE_TYPE_DISTINCT = 'SERVICE_TYPE_DISTINCT',
  START_DATE = 'START_DATE',
  START_DATE_DISTINCT = 'START_DATE_DISTINCT',
  STATEMENT_MONTH = 'STATEMENT_MONTH',
  STATEMENT_MONTH_DISTINCT = 'STATEMENT_MONTH_DISTINCT',
  STATEMENT_YEAR = 'STATEMENT_YEAR',
  STATEMENT_YEAR_DISTINCT = 'STATEMENT_YEAR_DISTINCT',
  TAXES = 'TAXES',
  TAXES_DISTINCT = 'TAXES_DISTINCT',
  USAGE_UNITS = 'USAGE_UNITS',
  USAGE_UNITS_DISTINCT = 'USAGE_UNITS_DISTINCT',
  UTILITY_ACCOUNT_ID = 'UTILITY_ACCOUNT_ID',
  UTILITY_ACCOUNT_ID_DISTINCT = 'UTILITY_ACCOUNT_ID_DISTINCT',
  UTILITY_METER_ID = 'UTILITY_METER_ID',
  UTILITY_METER_ID_DISTINCT = 'UTILITY_METER_ID_DISTINCT'
}

export type UtilityMeterStatementRollupsHavingAverageInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemand?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billUsage?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  blendedRate?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  loadFactor?: InputMaybe<HavingFloatFilter>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  netBillUsage?: InputMaybe<HavingFloatFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

export type UtilityMeterStatementRollupsHavingDistinctCountInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemand?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billUsage?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  blendedRate?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  loadFactor?: InputMaybe<HavingFloatFilter>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  netBillUsage?: InputMaybe<HavingFloatFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

export type UtilityMeterStatementRollupsHavingDistinctInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemand?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billUsage?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  blendedRate?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  loadFactor?: InputMaybe<HavingFloatFilter>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  netBillUsage?: InputMaybe<HavingFloatFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `UtilityMeterStatementRollup` aggregates. */
export type UtilityMeterStatementRollupsHavingInput = {
  AND?: InputMaybe<Array<UtilityMeterStatementRollupsHavingInput>>;
  OR?: InputMaybe<Array<UtilityMeterStatementRollupsHavingInput>>;
  average?: InputMaybe<UtilityMeterStatementRollupsHavingAverageInput>;
  distinct?: InputMaybe<UtilityMeterStatementRollupsHavingDistinctInput>;
  distinctCount?: InputMaybe<UtilityMeterStatementRollupsHavingDistinctCountInput>;
  max?: InputMaybe<UtilityMeterStatementRollupsHavingMaxInput>;
  min?: InputMaybe<UtilityMeterStatementRollupsHavingMinInput>;
  stddevPopulation?: InputMaybe<UtilityMeterStatementRollupsHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<UtilityMeterStatementRollupsHavingStddevSampleInput>;
  sum?: InputMaybe<UtilityMeterStatementRollupsHavingSumInput>;
  variancePopulation?: InputMaybe<UtilityMeterStatementRollupsHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<UtilityMeterStatementRollupsHavingVarianceSampleInput>;
};

export type UtilityMeterStatementRollupsHavingMaxInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemand?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billUsage?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  blendedRate?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  loadFactor?: InputMaybe<HavingFloatFilter>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  netBillUsage?: InputMaybe<HavingFloatFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

export type UtilityMeterStatementRollupsHavingMinInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemand?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billUsage?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  blendedRate?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  loadFactor?: InputMaybe<HavingFloatFilter>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  netBillUsage?: InputMaybe<HavingFloatFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

export type UtilityMeterStatementRollupsHavingStddevPopulationInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemand?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billUsage?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  blendedRate?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  loadFactor?: InputMaybe<HavingFloatFilter>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  netBillUsage?: InputMaybe<HavingFloatFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

export type UtilityMeterStatementRollupsHavingStddevSampleInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemand?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billUsage?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  blendedRate?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  loadFactor?: InputMaybe<HavingFloatFilter>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  netBillUsage?: InputMaybe<HavingFloatFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

export type UtilityMeterStatementRollupsHavingSumInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemand?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billUsage?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  blendedRate?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  loadFactor?: InputMaybe<HavingFloatFilter>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  netBillUsage?: InputMaybe<HavingFloatFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

export type UtilityMeterStatementRollupsHavingVariancePopulationInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemand?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billUsage?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  blendedRate?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  loadFactor?: InputMaybe<HavingFloatFilter>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  netBillUsage?: InputMaybe<HavingFloatFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

export type UtilityMeterStatementRollupsHavingVarianceSampleInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemand?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billUsage?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  blendedRate?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  loadFactor?: InputMaybe<HavingFloatFilter>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  netBillUsage?: InputMaybe<HavingFloatFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

/** Methods to use when ordering `UtilityMeterStatementRollup`. */
export enum UtilityMeterStatementRollupsOrderBy {
  ACCOUNT_LABEL_ASC = 'ACCOUNT_LABEL_ASC',
  ACCOUNT_LABEL_DESC = 'ACCOUNT_LABEL_DESC',
  ACCOUNT_STATEMENT_ID_ASC = 'ACCOUNT_STATEMENT_ID_ASC',
  ACCOUNT_STATEMENT_ID_DESC = 'ACCOUNT_STATEMENT_ID_DESC',
  BILL_ARRIVAL_DATE_ASC = 'BILL_ARRIVAL_DATE_ASC',
  BILL_ARRIVAL_DATE_DESC = 'BILL_ARRIVAL_DATE_DESC',
  BILL_COST_ASC = 'BILL_COST_ASC',
  BILL_COST_DESC = 'BILL_COST_DESC',
  BILL_DEMAND_ASC = 'BILL_DEMAND_ASC',
  BILL_DEMAND_COST_ASC = 'BILL_DEMAND_COST_ASC',
  BILL_DEMAND_COST_DESC = 'BILL_DEMAND_COST_DESC',
  BILL_DEMAND_DESC = 'BILL_DEMAND_DESC',
  BILL_USAGE_ASC = 'BILL_USAGE_ASC',
  BILL_USAGE_COST_ASC = 'BILL_USAGE_COST_ASC',
  BILL_USAGE_COST_DESC = 'BILL_USAGE_COST_DESC',
  BILL_USAGE_DESC = 'BILL_USAGE_DESC',
  BLENDED_RATE_ASC = 'BLENDED_RATE_ASC',
  BLENDED_RATE_DESC = 'BLENDED_RATE_DESC',
  CREDITS_ASC = 'CREDITS_ASC',
  CREDITS_DESC = 'CREDITS_DESC',
  CURRENCY_CODE_ASC = 'CURRENCY_CODE_ASC',
  CURRENCY_CODE_DESC = 'CURRENCY_CODE_DESC',
  DAYS_IN_BILL_ASC = 'DAYS_IN_BILL_ASC',
  DAYS_IN_BILL_DESC = 'DAYS_IN_BILL_DESC',
  DEMAND_UNITS_ASC = 'DEMAND_UNITS_ASC',
  DEMAND_UNITS_DESC = 'DEMAND_UNITS_DESC',
  END_DATE_ASC = 'END_DATE_ASC',
  END_DATE_DESC = 'END_DATE_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  FACILITY_NAME_ASC = 'FACILITY_NAME_ASC',
  FACILITY_NAME_DESC = 'FACILITY_NAME_DESC',
  FEES_ASC = 'FEES_ASC',
  FEES_DESC = 'FEES_DESC',
  IS_VALIDATED_ASC = 'IS_VALIDATED_ASC',
  IS_VALIDATED_DESC = 'IS_VALIDATED_DESC',
  LOAD_FACTOR_ASC = 'LOAD_FACTOR_ASC',
  LOAD_FACTOR_DESC = 'LOAD_FACTOR_DESC',
  METER_END_DATE_SET_ASC = 'METER_END_DATE_SET_ASC',
  METER_END_DATE_SET_DESC = 'METER_END_DATE_SET_DESC',
  METER_LABEL_ASC = 'METER_LABEL_ASC',
  METER_LABEL_DESC = 'METER_LABEL_DESC',
  METER_STATEMENT_ID_ASC = 'METER_STATEMENT_ID_ASC',
  METER_STATEMENT_ID_DESC = 'METER_STATEMENT_ID_DESC',
  NATURAL = 'NATURAL',
  NET_BILL_USAGE_ASC = 'NET_BILL_USAGE_ASC',
  NET_BILL_USAGE_DESC = 'NET_BILL_USAGE_DESC',
  N_SIGHT2_ACTIVE_ASC = 'N_SIGHT2_ACTIVE_ASC',
  N_SIGHT2_ACTIVE_DESC = 'N_SIGHT2_ACTIVE_DESC',
  PERCENT_CHANGE_ASC = 'PERCENT_CHANGE_ASC',
  PERCENT_CHANGE_DESC = 'PERCENT_CHANGE_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROVIDER_ASC = 'PROVIDER_ASC',
  PROVIDER_DESC = 'PROVIDER_DESC',
  SERVICE_TYPE_ASC = 'SERVICE_TYPE_ASC',
  SERVICE_TYPE_DESC = 'SERVICE_TYPE_DESC',
  START_DATE_ASC = 'START_DATE_ASC',
  START_DATE_DESC = 'START_DATE_DESC',
  STATEMENT_DATE_ASC = 'STATEMENT_DATE_ASC',
  STATEMENT_DATE_DESC = 'STATEMENT_DATE_DESC',
  STATEMENT_MONTH_ASC = 'STATEMENT_MONTH_ASC',
  STATEMENT_MONTH_DESC = 'STATEMENT_MONTH_DESC',
  STATEMENT_YEAR_ASC = 'STATEMENT_YEAR_ASC',
  STATEMENT_YEAR_DESC = 'STATEMENT_YEAR_DESC',
  TAXES_ASC = 'TAXES_ASC',
  TAXES_DESC = 'TAXES_DESC',
  USAGE_UNITS_ASC = 'USAGE_UNITS_ASC',
  USAGE_UNITS_DESC = 'USAGE_UNITS_DESC',
  UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_ID_ASC = 'UTILITY_METER_ID_ASC',
  UTILITY_METER_ID_DESC = 'UTILITY_METER_ID_DESC'
}

export type UtilityMeterStatementStddevPopulationAggregates = {
  __typename?: 'UtilityMeterStatementStddevPopulationAggregates';
  /** Population standard deviation of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']>;
  /**
   * Population standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_meter_statements (view) row.
   */
  billCost?: Maybe<Scalars['Float']>;
  /** Population standard deviation of this field across the matching connection. */
  billDemand?: Maybe<Scalars['Float']>;
  /**
   * Population standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand charges of a given utility_meter_statements (view) row.
   */
  billDemandCost?: Maybe<Scalars['Float']>;
  /**
   * Population standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand of a given utility_meter_statements (view) row.
   */
  billUsage?: Maybe<Scalars['Float']>;
  /**
   * Population standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total usage charges of a given utility_meter_statements (view) row.
   */
  billUsageCost?: Maybe<Scalars['Float']>;
  /**
   * Population standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_meter_statements (view) row.
   */
  credits?: Maybe<Scalars['Float']>;
  /** Population standard deviation of daysInBill across the matching connection */
  daysInBill?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of facilityId across the matching connection */
  facilityId?: Maybe<Scalars['BigFloat']>;
  /**
   * Population standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_meter_statements (view) row.
   */
  fees?: Maybe<Scalars['Float']>;
  /** Population standard deviation of meterStatementId across the matching connection */
  meterStatementId?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']>;
  /**
   * Population standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_meter_statements (view) row.
   */
  taxes?: Maybe<Scalars['Float']>;
  /** Population standard deviation of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of utilityMeterId across the matching connection */
  utilityMeterId?: Maybe<Scalars['BigFloat']>;
};

export type UtilityMeterStatementStddevSampleAggregates = {
  __typename?: 'UtilityMeterStatementStddevSampleAggregates';
  /** Sample standard deviation of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']>;
  /**
   * Sample standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_meter_statements (view) row.
   */
  billCost?: Maybe<Scalars['Float']>;
  /** Sample standard deviation of this field across the matching connection. */
  billDemand?: Maybe<Scalars['Float']>;
  /**
   * Sample standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand charges of a given utility_meter_statements (view) row.
   */
  billDemandCost?: Maybe<Scalars['Float']>;
  /**
   * Sample standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand of a given utility_meter_statements (view) row.
   */
  billUsage?: Maybe<Scalars['Float']>;
  /**
   * Sample standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total usage charges of a given utility_meter_statements (view) row.
   */
  billUsageCost?: Maybe<Scalars['Float']>;
  /**
   * Sample standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_meter_statements (view) row.
   */
  credits?: Maybe<Scalars['Float']>;
  /** Sample standard deviation of daysInBill across the matching connection */
  daysInBill?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of facilityId across the matching connection */
  facilityId?: Maybe<Scalars['BigFloat']>;
  /**
   * Sample standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_meter_statements (view) row.
   */
  fees?: Maybe<Scalars['Float']>;
  /** Sample standard deviation of meterStatementId across the matching connection */
  meterStatementId?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']>;
  /**
   * Sample standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_meter_statements (view) row.
   */
  taxes?: Maybe<Scalars['Float']>;
  /** Sample standard deviation of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of utilityMeterId across the matching connection */
  utilityMeterId?: Maybe<Scalars['BigFloat']>;
};

export type UtilityMeterStatementSumAggregates = {
  __typename?: 'UtilityMeterStatementSumAggregates';
  /** Sum of accountStatementId across the matching connection */
  accountStatementId: Scalars['BigInt'];
  /**
   * Sum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_meter_statements (view) row.
   */
  billCost?: Maybe<Scalars['Float']>;
  /** Sum of this field across the matching connection. */
  billDemand?: Maybe<Scalars['Float']>;
  /**
   * Sum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand charges of a given utility_meter_statements (view) row.
   */
  billDemandCost?: Maybe<Scalars['Float']>;
  /**
   * Sum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand of a given utility_meter_statements (view) row.
   */
  billUsage?: Maybe<Scalars['Float']>;
  /**
   * Sum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total usage charges of a given utility_meter_statements (view) row.
   */
  billUsageCost?: Maybe<Scalars['Float']>;
  /**
   * Sum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_meter_statements (view) row.
   */
  credits?: Maybe<Scalars['Float']>;
  /** Sum of daysInBill across the matching connection */
  daysInBill: Scalars['BigInt'];
  /** Sum of facilityId across the matching connection */
  facilityId: Scalars['BigInt'];
  /**
   * Sum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_meter_statements (view) row.
   */
  fees?: Maybe<Scalars['Float']>;
  /** Sum of meterStatementId across the matching connection */
  meterStatementId: Scalars['BigInt'];
  /** Sum of statementMonth across the matching connection */
  statementMonth: Scalars['BigInt'];
  /** Sum of statementYear across the matching connection */
  statementYear: Scalars['BigInt'];
  /**
   * Sum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_meter_statements (view) row.
   */
  taxes?: Maybe<Scalars['Float']>;
  /** Sum of utilityAccountId across the matching connection */
  utilityAccountId: Scalars['BigInt'];
  /** Sum of utilityMeterId across the matching connection */
  utilityMeterId: Scalars['BigInt'];
};

export type UtilityMeterStatementVariancePopulationAggregates = {
  __typename?: 'UtilityMeterStatementVariancePopulationAggregates';
  /** Population variance of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']>;
  /**
   * Population variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_meter_statements (view) row.
   */
  billCost?: Maybe<Scalars['Float']>;
  /** Population variance of this field across the matching connection. */
  billDemand?: Maybe<Scalars['Float']>;
  /**
   * Population variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand charges of a given utility_meter_statements (view) row.
   */
  billDemandCost?: Maybe<Scalars['Float']>;
  /**
   * Population variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand of a given utility_meter_statements (view) row.
   */
  billUsage?: Maybe<Scalars['Float']>;
  /**
   * Population variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total usage charges of a given utility_meter_statements (view) row.
   */
  billUsageCost?: Maybe<Scalars['Float']>;
  /**
   * Population variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_meter_statements (view) row.
   */
  credits?: Maybe<Scalars['Float']>;
  /** Population variance of daysInBill across the matching connection */
  daysInBill?: Maybe<Scalars['BigFloat']>;
  /** Population variance of facilityId across the matching connection */
  facilityId?: Maybe<Scalars['BigFloat']>;
  /**
   * Population variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_meter_statements (view) row.
   */
  fees?: Maybe<Scalars['Float']>;
  /** Population variance of meterStatementId across the matching connection */
  meterStatementId?: Maybe<Scalars['BigFloat']>;
  /** Population variance of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']>;
  /** Population variance of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']>;
  /**
   * Population variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_meter_statements (view) row.
   */
  taxes?: Maybe<Scalars['Float']>;
  /** Population variance of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']>;
  /** Population variance of utilityMeterId across the matching connection */
  utilityMeterId?: Maybe<Scalars['BigFloat']>;
};

export type UtilityMeterStatementVarianceSampleAggregates = {
  __typename?: 'UtilityMeterStatementVarianceSampleAggregates';
  /** Sample variance of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']>;
  /**
   * Sample variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_meter_statements (view) row.
   */
  billCost?: Maybe<Scalars['Float']>;
  /** Sample variance of this field across the matching connection. */
  billDemand?: Maybe<Scalars['Float']>;
  /**
   * Sample variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand charges of a given utility_meter_statements (view) row.
   */
  billDemandCost?: Maybe<Scalars['Float']>;
  /**
   * Sample variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand of a given utility_meter_statements (view) row.
   */
  billUsage?: Maybe<Scalars['Float']>;
  /**
   * Sample variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total usage charges of a given utility_meter_statements (view) row.
   */
  billUsageCost?: Maybe<Scalars['Float']>;
  /**
   * Sample variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_meter_statements (view) row.
   */
  credits?: Maybe<Scalars['Float']>;
  /** Sample variance of daysInBill across the matching connection */
  daysInBill?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of facilityId across the matching connection */
  facilityId?: Maybe<Scalars['BigFloat']>;
  /**
   * Sample variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_meter_statements (view) row.
   */
  fees?: Maybe<Scalars['Float']>;
  /** Sample variance of meterStatementId across the matching connection */
  meterStatementId?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']>;
  /**
   * Sample variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_meter_statements (view) row.
   */
  taxes?: Maybe<Scalars['Float']>;
  /** Sample variance of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of utilityMeterId across the matching connection */
  utilityMeterId?: Maybe<Scalars['BigFloat']>;
};

/** A connection to a list of `UtilityMeterStatement` values. */
export type UtilityMeterStatementsConnection = {
  __typename?: 'UtilityMeterStatementsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<UtilityMeterStatementAggregates>;
  /** A list of edges which contains the `UtilityMeterStatement` and cursor to aid in pagination. */
  edges: Array<UtilityMeterStatementsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<UtilityMeterStatementAggregates>>;
  /** A list of `UtilityMeterStatement` objects. */
  nodes: Array<UtilityMeterStatement>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UtilityMeterStatement` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A connection to a list of `UtilityMeterStatement` values. */
export type UtilityMeterStatementsConnectionGroupedAggregatesArgs = {
  groupBy: Array<UtilityMeterStatementsGroupBy>;
  having?: InputMaybe<UtilityMeterStatementsHavingInput>;
};

/** A `UtilityMeterStatement` edge in the connection. */
export type UtilityMeterStatementsEdge = {
  __typename?: 'UtilityMeterStatementsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UtilityMeterStatement` at the end of the edge. */
  node: UtilityMeterStatement;
};

/** Grouping methods for `UtilityMeterStatement` for usage during aggregation. */
export enum UtilityMeterStatementsGroupBy {
  ACCOUNT_LABEL = 'ACCOUNT_LABEL',
  ACCOUNT_LABEL_DISTINCT = 'ACCOUNT_LABEL_DISTINCT',
  ACCOUNT_STATEMENT_ID = 'ACCOUNT_STATEMENT_ID',
  ACCOUNT_STATEMENT_ID_DISTINCT = 'ACCOUNT_STATEMENT_ID_DISTINCT',
  BILL_ARRIVAL_DATE = 'BILL_ARRIVAL_DATE',
  BILL_ARRIVAL_DATE_DISTINCT = 'BILL_ARRIVAL_DATE_DISTINCT',
  BILL_ARRIVAL_DATE_TRUNCATED_TO_DAY = 'BILL_ARRIVAL_DATE_TRUNCATED_TO_DAY',
  BILL_ARRIVAL_DATE_TRUNCATED_TO_HOUR = 'BILL_ARRIVAL_DATE_TRUNCATED_TO_HOUR',
  CURRENCY_CODE = 'CURRENCY_CODE',
  CURRENCY_CODE_DISTINCT = 'CURRENCY_CODE_DISTINCT',
  DAYS_IN_BILL = 'DAYS_IN_BILL',
  DAYS_IN_BILL_DISTINCT = 'DAYS_IN_BILL_DISTINCT',
  DEMAND_UNITS = 'DEMAND_UNITS',
  DEMAND_UNITS_DISTINCT = 'DEMAND_UNITS_DISTINCT',
  END_DATE = 'END_DATE',
  END_DATE_DISTINCT = 'END_DATE_DISTINCT',
  EXCLUDE_USAGE = 'EXCLUDE_USAGE',
  EXCLUDE_USAGE_DISTINCT = 'EXCLUDE_USAGE_DISTINCT',
  FACILITY_ID = 'FACILITY_ID',
  FACILITY_ID_DISTINCT = 'FACILITY_ID_DISTINCT',
  IS_VALIDATED = 'IS_VALIDATED',
  IS_VALIDATED_DISTINCT = 'IS_VALIDATED_DISTINCT',
  METER_END_DATE_SET = 'METER_END_DATE_SET',
  METER_END_DATE_SET_DISTINCT = 'METER_END_DATE_SET_DISTINCT',
  METER_LABEL = 'METER_LABEL',
  METER_LABEL_DISTINCT = 'METER_LABEL_DISTINCT',
  METER_STATEMENT_ID = 'METER_STATEMENT_ID',
  METER_STATEMENT_ID_DISTINCT = 'METER_STATEMENT_ID_DISTINCT',
  PROVIDER = 'PROVIDER',
  PROVIDER_DISTINCT = 'PROVIDER_DISTINCT',
  SERVICE_TYPE = 'SERVICE_TYPE',
  SERVICE_TYPE_DISTINCT = 'SERVICE_TYPE_DISTINCT',
  START_DATE = 'START_DATE',
  START_DATE_DISTINCT = 'START_DATE_DISTINCT',
  STATEMENT_MONTH = 'STATEMENT_MONTH',
  STATEMENT_MONTH_DISTINCT = 'STATEMENT_MONTH_DISTINCT',
  STATEMENT_YEAR = 'STATEMENT_YEAR',
  STATEMENT_YEAR_DISTINCT = 'STATEMENT_YEAR_DISTINCT',
  USAGE_UNITS = 'USAGE_UNITS',
  USAGE_UNITS_DISTINCT = 'USAGE_UNITS_DISTINCT',
  UTILITY_ACCOUNT_ID = 'UTILITY_ACCOUNT_ID',
  UTILITY_ACCOUNT_ID_DISTINCT = 'UTILITY_ACCOUNT_ID_DISTINCT',
  UTILITY_METER_ID = 'UTILITY_METER_ID',
  UTILITY_METER_ID_DISTINCT = 'UTILITY_METER_ID_DISTINCT'
}

export type UtilityMeterStatementsHavingAverageInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityMeterStatementsHavingAverageUtilityMeterStatementsBillCostInput>;
  billDemand?: InputMaybe<UtilityMeterStatementsHavingAverageUtilityMeterStatementsBillDemandInput>;
  billDemandCost?: InputMaybe<UtilityMeterStatementsHavingAverageUtilityMeterStatementsBillDemandCostInput>;
  billUsage?: InputMaybe<UtilityMeterStatementsHavingAverageUtilityMeterStatementsBillUsageInput>;
  billUsageCost?: InputMaybe<UtilityMeterStatementsHavingAverageUtilityMeterStatementsBillUsageCostInput>;
  credits?: InputMaybe<UtilityMeterStatementsHavingAverageUtilityMeterStatementsCreditsInput>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<UtilityMeterStatementsHavingAverageUtilityMeterStatementsFeesInput>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityMeterStatementsHavingAverageUtilityMeterStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

export type UtilityMeterStatementsHavingAverageUtilityMeterStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingAverageUtilityMeterStatementsBillDemandCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingAverageUtilityMeterStatementsBillDemandInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingAverageUtilityMeterStatementsBillUsageCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingAverageUtilityMeterStatementsBillUsageInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingAverageUtilityMeterStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingAverageUtilityMeterStatementsFeesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingAverageUtilityMeterStatementsTaxesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingDistinctCountInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityMeterStatementsHavingDistinctCountUtilityMeterStatementsBillCostInput>;
  billDemand?: InputMaybe<UtilityMeterStatementsHavingDistinctCountUtilityMeterStatementsBillDemandInput>;
  billDemandCost?: InputMaybe<UtilityMeterStatementsHavingDistinctCountUtilityMeterStatementsBillDemandCostInput>;
  billUsage?: InputMaybe<UtilityMeterStatementsHavingDistinctCountUtilityMeterStatementsBillUsageInput>;
  billUsageCost?: InputMaybe<UtilityMeterStatementsHavingDistinctCountUtilityMeterStatementsBillUsageCostInput>;
  credits?: InputMaybe<UtilityMeterStatementsHavingDistinctCountUtilityMeterStatementsCreditsInput>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<UtilityMeterStatementsHavingDistinctCountUtilityMeterStatementsFeesInput>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityMeterStatementsHavingDistinctCountUtilityMeterStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

export type UtilityMeterStatementsHavingDistinctCountUtilityMeterStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingDistinctCountUtilityMeterStatementsBillDemandCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingDistinctCountUtilityMeterStatementsBillDemandInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingDistinctCountUtilityMeterStatementsBillUsageCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingDistinctCountUtilityMeterStatementsBillUsageInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingDistinctCountUtilityMeterStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingDistinctCountUtilityMeterStatementsFeesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingDistinctCountUtilityMeterStatementsTaxesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingDistinctInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityMeterStatementsHavingDistinctUtilityMeterStatementsBillCostInput>;
  billDemand?: InputMaybe<UtilityMeterStatementsHavingDistinctUtilityMeterStatementsBillDemandInput>;
  billDemandCost?: InputMaybe<UtilityMeterStatementsHavingDistinctUtilityMeterStatementsBillDemandCostInput>;
  billUsage?: InputMaybe<UtilityMeterStatementsHavingDistinctUtilityMeterStatementsBillUsageInput>;
  billUsageCost?: InputMaybe<UtilityMeterStatementsHavingDistinctUtilityMeterStatementsBillUsageCostInput>;
  credits?: InputMaybe<UtilityMeterStatementsHavingDistinctUtilityMeterStatementsCreditsInput>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<UtilityMeterStatementsHavingDistinctUtilityMeterStatementsFeesInput>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityMeterStatementsHavingDistinctUtilityMeterStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

export type UtilityMeterStatementsHavingDistinctUtilityMeterStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingDistinctUtilityMeterStatementsBillDemandCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingDistinctUtilityMeterStatementsBillDemandInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingDistinctUtilityMeterStatementsBillUsageCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingDistinctUtilityMeterStatementsBillUsageInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingDistinctUtilityMeterStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingDistinctUtilityMeterStatementsFeesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingDistinctUtilityMeterStatementsTaxesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

/** Conditions for `UtilityMeterStatement` aggregates. */
export type UtilityMeterStatementsHavingInput = {
  AND?: InputMaybe<Array<UtilityMeterStatementsHavingInput>>;
  OR?: InputMaybe<Array<UtilityMeterStatementsHavingInput>>;
  average?: InputMaybe<UtilityMeterStatementsHavingAverageInput>;
  distinct?: InputMaybe<UtilityMeterStatementsHavingDistinctInput>;
  distinctCount?: InputMaybe<UtilityMeterStatementsHavingDistinctCountInput>;
  max?: InputMaybe<UtilityMeterStatementsHavingMaxInput>;
  min?: InputMaybe<UtilityMeterStatementsHavingMinInput>;
  stddevPopulation?: InputMaybe<UtilityMeterStatementsHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<UtilityMeterStatementsHavingStddevSampleInput>;
  sum?: InputMaybe<UtilityMeterStatementsHavingSumInput>;
  variancePopulation?: InputMaybe<UtilityMeterStatementsHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<UtilityMeterStatementsHavingVarianceSampleInput>;
};

export type UtilityMeterStatementsHavingMaxInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityMeterStatementsHavingMaxUtilityMeterStatementsBillCostInput>;
  billDemand?: InputMaybe<UtilityMeterStatementsHavingMaxUtilityMeterStatementsBillDemandInput>;
  billDemandCost?: InputMaybe<UtilityMeterStatementsHavingMaxUtilityMeterStatementsBillDemandCostInput>;
  billUsage?: InputMaybe<UtilityMeterStatementsHavingMaxUtilityMeterStatementsBillUsageInput>;
  billUsageCost?: InputMaybe<UtilityMeterStatementsHavingMaxUtilityMeterStatementsBillUsageCostInput>;
  credits?: InputMaybe<UtilityMeterStatementsHavingMaxUtilityMeterStatementsCreditsInput>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<UtilityMeterStatementsHavingMaxUtilityMeterStatementsFeesInput>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityMeterStatementsHavingMaxUtilityMeterStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

export type UtilityMeterStatementsHavingMaxUtilityMeterStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingMaxUtilityMeterStatementsBillDemandCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingMaxUtilityMeterStatementsBillDemandInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingMaxUtilityMeterStatementsBillUsageCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingMaxUtilityMeterStatementsBillUsageInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingMaxUtilityMeterStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingMaxUtilityMeterStatementsFeesInput = {
  filter?: InputMaybe<HavingFloatFilter>;
};

export type UtilityMeterStatementsHavingMaxUtilityMeterStatementsTaxesInput = {
  filter?: InputMaybe<HavingFloatFilter>;
};

export type UtilityMeterStatementsHavingMinInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityMeterStatementsHavingMinUtilityMeterStatementsBillCostInput>;
  billDemand?: InputMaybe<UtilityMeterStatementsHavingMinUtilityMeterStatementsBillDemandInput>;
  billDemandCost?: InputMaybe<UtilityMeterStatementsHavingMinUtilityMeterStatementsBillDemandCostInput>;
  billUsage?: InputMaybe<UtilityMeterStatementsHavingMinUtilityMeterStatementsBillUsageInput>;
  billUsageCost?: InputMaybe<UtilityMeterStatementsHavingMinUtilityMeterStatementsBillUsageCostInput>;
  credits?: InputMaybe<UtilityMeterStatementsHavingMinUtilityMeterStatementsCreditsInput>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<UtilityMeterStatementsHavingMinUtilityMeterStatementsFeesInput>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityMeterStatementsHavingMinUtilityMeterStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

export type UtilityMeterStatementsHavingMinUtilityMeterStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingMinUtilityMeterStatementsBillDemandCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingMinUtilityMeterStatementsBillDemandInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingMinUtilityMeterStatementsBillUsageCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingMinUtilityMeterStatementsBillUsageInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingMinUtilityMeterStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingMinUtilityMeterStatementsFeesInput = {
  filter?: InputMaybe<HavingFloatFilter>;
};

export type UtilityMeterStatementsHavingMinUtilityMeterStatementsTaxesInput = {
  filter?: InputMaybe<HavingFloatFilter>;
};

export type UtilityMeterStatementsHavingStddevPopulationInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityMeterStatementsHavingStddevPopulationUtilityMeterStatementsBillCostInput>;
  billDemand?: InputMaybe<UtilityMeterStatementsHavingStddevPopulationUtilityMeterStatementsBillDemandInput>;
  billDemandCost?: InputMaybe<UtilityMeterStatementsHavingStddevPopulationUtilityMeterStatementsBillDemandCostInput>;
  billUsage?: InputMaybe<UtilityMeterStatementsHavingStddevPopulationUtilityMeterStatementsBillUsageInput>;
  billUsageCost?: InputMaybe<UtilityMeterStatementsHavingStddevPopulationUtilityMeterStatementsBillUsageCostInput>;
  credits?: InputMaybe<UtilityMeterStatementsHavingStddevPopulationUtilityMeterStatementsCreditsInput>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<UtilityMeterStatementsHavingStddevPopulationUtilityMeterStatementsFeesInput>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityMeterStatementsHavingStddevPopulationUtilityMeterStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

export type UtilityMeterStatementsHavingStddevPopulationUtilityMeterStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingStddevPopulationUtilityMeterStatementsBillDemandCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingStddevPopulationUtilityMeterStatementsBillDemandInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingStddevPopulationUtilityMeterStatementsBillUsageCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingStddevPopulationUtilityMeterStatementsBillUsageInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingStddevPopulationUtilityMeterStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingStddevPopulationUtilityMeterStatementsFeesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingStddevPopulationUtilityMeterStatementsTaxesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingStddevSampleInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityMeterStatementsHavingStddevSampleUtilityMeterStatementsBillCostInput>;
  billDemand?: InputMaybe<UtilityMeterStatementsHavingStddevSampleUtilityMeterStatementsBillDemandInput>;
  billDemandCost?: InputMaybe<UtilityMeterStatementsHavingStddevSampleUtilityMeterStatementsBillDemandCostInput>;
  billUsage?: InputMaybe<UtilityMeterStatementsHavingStddevSampleUtilityMeterStatementsBillUsageInput>;
  billUsageCost?: InputMaybe<UtilityMeterStatementsHavingStddevSampleUtilityMeterStatementsBillUsageCostInput>;
  credits?: InputMaybe<UtilityMeterStatementsHavingStddevSampleUtilityMeterStatementsCreditsInput>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<UtilityMeterStatementsHavingStddevSampleUtilityMeterStatementsFeesInput>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityMeterStatementsHavingStddevSampleUtilityMeterStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

export type UtilityMeterStatementsHavingStddevSampleUtilityMeterStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingStddevSampleUtilityMeterStatementsBillDemandCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingStddevSampleUtilityMeterStatementsBillDemandInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingStddevSampleUtilityMeterStatementsBillUsageCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingStddevSampleUtilityMeterStatementsBillUsageInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingStddevSampleUtilityMeterStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingStddevSampleUtilityMeterStatementsFeesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingStddevSampleUtilityMeterStatementsTaxesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingSumInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityMeterStatementsHavingSumUtilityMeterStatementsBillCostInput>;
  billDemand?: InputMaybe<UtilityMeterStatementsHavingSumUtilityMeterStatementsBillDemandInput>;
  billDemandCost?: InputMaybe<UtilityMeterStatementsHavingSumUtilityMeterStatementsBillDemandCostInput>;
  billUsage?: InputMaybe<UtilityMeterStatementsHavingSumUtilityMeterStatementsBillUsageInput>;
  billUsageCost?: InputMaybe<UtilityMeterStatementsHavingSumUtilityMeterStatementsBillUsageCostInput>;
  credits?: InputMaybe<UtilityMeterStatementsHavingSumUtilityMeterStatementsCreditsInput>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<UtilityMeterStatementsHavingSumUtilityMeterStatementsFeesInput>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityMeterStatementsHavingSumUtilityMeterStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

export type UtilityMeterStatementsHavingSumUtilityMeterStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingSumUtilityMeterStatementsBillDemandCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingSumUtilityMeterStatementsBillDemandInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingSumUtilityMeterStatementsBillUsageCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingSumUtilityMeterStatementsBillUsageInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingSumUtilityMeterStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingSumUtilityMeterStatementsFeesInput = {
  filter?: InputMaybe<HavingFloatFilter>;
};

export type UtilityMeterStatementsHavingSumUtilityMeterStatementsTaxesInput = {
  filter?: InputMaybe<HavingFloatFilter>;
};

export type UtilityMeterStatementsHavingVariancePopulationInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityMeterStatementsHavingVariancePopulationUtilityMeterStatementsBillCostInput>;
  billDemand?: InputMaybe<UtilityMeterStatementsHavingVariancePopulationUtilityMeterStatementsBillDemandInput>;
  billDemandCost?: InputMaybe<UtilityMeterStatementsHavingVariancePopulationUtilityMeterStatementsBillDemandCostInput>;
  billUsage?: InputMaybe<UtilityMeterStatementsHavingVariancePopulationUtilityMeterStatementsBillUsageInput>;
  billUsageCost?: InputMaybe<UtilityMeterStatementsHavingVariancePopulationUtilityMeterStatementsBillUsageCostInput>;
  credits?: InputMaybe<UtilityMeterStatementsHavingVariancePopulationUtilityMeterStatementsCreditsInput>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<UtilityMeterStatementsHavingVariancePopulationUtilityMeterStatementsFeesInput>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityMeterStatementsHavingVariancePopulationUtilityMeterStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

export type UtilityMeterStatementsHavingVariancePopulationUtilityMeterStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingVariancePopulationUtilityMeterStatementsBillDemandCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingVariancePopulationUtilityMeterStatementsBillDemandInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingVariancePopulationUtilityMeterStatementsBillUsageCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingVariancePopulationUtilityMeterStatementsBillUsageInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingVariancePopulationUtilityMeterStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingVariancePopulationUtilityMeterStatementsFeesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingVariancePopulationUtilityMeterStatementsTaxesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingVarianceSampleInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityMeterStatementsHavingVarianceSampleUtilityMeterStatementsBillCostInput>;
  billDemand?: InputMaybe<UtilityMeterStatementsHavingVarianceSampleUtilityMeterStatementsBillDemandInput>;
  billDemandCost?: InputMaybe<UtilityMeterStatementsHavingVarianceSampleUtilityMeterStatementsBillDemandCostInput>;
  billUsage?: InputMaybe<UtilityMeterStatementsHavingVarianceSampleUtilityMeterStatementsBillUsageInput>;
  billUsageCost?: InputMaybe<UtilityMeterStatementsHavingVarianceSampleUtilityMeterStatementsBillUsageCostInput>;
  credits?: InputMaybe<UtilityMeterStatementsHavingVarianceSampleUtilityMeterStatementsCreditsInput>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<UtilityMeterStatementsHavingVarianceSampleUtilityMeterStatementsFeesInput>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityMeterStatementsHavingVarianceSampleUtilityMeterStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

export type UtilityMeterStatementsHavingVarianceSampleUtilityMeterStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingVarianceSampleUtilityMeterStatementsBillDemandCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingVarianceSampleUtilityMeterStatementsBillDemandInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingVarianceSampleUtilityMeterStatementsBillUsageCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingVarianceSampleUtilityMeterStatementsBillUsageInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingVarianceSampleUtilityMeterStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingVarianceSampleUtilityMeterStatementsFeesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingVarianceSampleUtilityMeterStatementsTaxesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

/** Methods to use when ordering `UtilityMeterStatement`. */
export enum UtilityMeterStatementsOrderBy {
  ACCOUNT_LABEL_ASC = 'ACCOUNT_LABEL_ASC',
  ACCOUNT_LABEL_DESC = 'ACCOUNT_LABEL_DESC',
  ACCOUNT_STATEMENT_ID_ASC = 'ACCOUNT_STATEMENT_ID_ASC',
  ACCOUNT_STATEMENT_ID_DESC = 'ACCOUNT_STATEMENT_ID_DESC',
  BILL_ARRIVAL_DATE_ASC = 'BILL_ARRIVAL_DATE_ASC',
  BILL_ARRIVAL_DATE_DESC = 'BILL_ARRIVAL_DATE_DESC',
  CURRENCY_CODE_ASC = 'CURRENCY_CODE_ASC',
  CURRENCY_CODE_DESC = 'CURRENCY_CODE_DESC',
  DAYS_IN_BILL_ASC = 'DAYS_IN_BILL_ASC',
  DAYS_IN_BILL_DESC = 'DAYS_IN_BILL_DESC',
  DEMAND_UNITS_ASC = 'DEMAND_UNITS_ASC',
  DEMAND_UNITS_DESC = 'DEMAND_UNITS_DESC',
  END_DATE_ASC = 'END_DATE_ASC',
  END_DATE_DESC = 'END_DATE_DESC',
  EXCLUDE_USAGE_ASC = 'EXCLUDE_USAGE_ASC',
  EXCLUDE_USAGE_DESC = 'EXCLUDE_USAGE_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  IS_VALIDATED_ASC = 'IS_VALIDATED_ASC',
  IS_VALIDATED_DESC = 'IS_VALIDATED_DESC',
  METER_END_DATE_SET_ASC = 'METER_END_DATE_SET_ASC',
  METER_END_DATE_SET_DESC = 'METER_END_DATE_SET_DESC',
  METER_LABEL_ASC = 'METER_LABEL_ASC',
  METER_LABEL_DESC = 'METER_LABEL_DESC',
  METER_STATEMENT_ID_ASC = 'METER_STATEMENT_ID_ASC',
  METER_STATEMENT_ID_DESC = 'METER_STATEMENT_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROVIDER_ASC = 'PROVIDER_ASC',
  PROVIDER_DESC = 'PROVIDER_DESC',
  SERVICE_TYPE_ASC = 'SERVICE_TYPE_ASC',
  SERVICE_TYPE_DESC = 'SERVICE_TYPE_DESC',
  START_DATE_ASC = 'START_DATE_ASC',
  START_DATE_DESC = 'START_DATE_DESC',
  STATEMENT_MONTH_ASC = 'STATEMENT_MONTH_ASC',
  STATEMENT_MONTH_DESC = 'STATEMENT_MONTH_DESC',
  STATEMENT_YEAR_ASC = 'STATEMENT_YEAR_ASC',
  STATEMENT_YEAR_DESC = 'STATEMENT_YEAR_DESC',
  USAGE_UNITS_ASC = 'USAGE_UNITS_ASC',
  USAGE_UNITS_DESC = 'USAGE_UNITS_DESC',
  UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_ID_ASC = 'UTILITY_METER_ID_ASC',
  UTILITY_METER_ID_DESC = 'UTILITY_METER_ID_DESC'
}

export enum UtilityMeterUsageCategory {
  DEMAND = 'DEMAND',
  USAGE = 'USAGE'
}

/** A filter to be used against UtilityMeterUsageCategory fields. All fields are combined with a logical ‘and.’ */
export type UtilityMeterUsageCategoryFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<UtilityMeterUsageCategory>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<UtilityMeterUsageCategory>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<UtilityMeterUsageCategory>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<UtilityMeterUsageCategory>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<UtilityMeterUsageCategory>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<UtilityMeterUsageCategory>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<UtilityMeterUsageCategory>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<UtilityMeterUsageCategory>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<UtilityMeterUsageCategory>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<UtilityMeterUsageCategory>>;
};

/** A connection to a list of `UtilityMeter` values. */
export type UtilityMetersConnection = {
  __typename?: 'UtilityMetersConnection';
  /** A list of edges which contains the `UtilityMeter` and cursor to aid in pagination. */
  edges: Array<UtilityMetersEdge>;
  /** A list of `UtilityMeter` objects. */
  nodes: Array<UtilityMeter>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UtilityMeter` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UtilityMeter` edge in the connection. */
export type UtilityMetersEdge = {
  __typename?: 'UtilityMetersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UtilityMeter` at the end of the edge. */
  node: UtilityMeter;
};

/** A `UtilityMetersMissingStatementsRecord` edge in the connection. */
export type UtilityMetersMissingStatementEdge = {
  __typename?: 'UtilityMetersMissingStatementEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UtilityMetersMissingStatementsRecord` at the end of the edge. */
  node: UtilityMetersMissingStatementsRecord;
};

/** A connection to a list of `UtilityMetersMissingStatementsRecord` values. */
export type UtilityMetersMissingStatementsConnection = {
  __typename?: 'UtilityMetersMissingStatementsConnection';
  /** A list of edges which contains the `UtilityMetersMissingStatementsRecord` and cursor to aid in pagination. */
  edges: Array<UtilityMetersMissingStatementEdge>;
  /** A list of `UtilityMetersMissingStatementsRecord` objects. */
  nodes: Array<UtilityMetersMissingStatementsRecord>;
  /** The count of *all* `UtilityMetersMissingStatementsRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** The return type of our `missingStatements` query. */
export type UtilityMetersMissingStatementsRecord = {
  __typename?: 'UtilityMetersMissingStatementsRecord';
  facilityId?: Maybe<Scalars['Int']>;
  statementDate?: Maybe<Scalars['Date']>;
  statementMonth?: Maybe<Scalars['Int']>;
  statementYear?: Maybe<Scalars['Int']>;
  utilityMeterId?: Maybe<Scalars['Int']>;
};

/** A filter to be used against `UtilityMetersMissingStatementsRecord` object types. All fields are combined with a logical ‘and.’ */
export type UtilityMetersMissingStatementsRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UtilityMetersMissingStatementsRecordFilter>>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UtilityMetersMissingStatementsRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UtilityMetersMissingStatementsRecordFilter>>;
  /** Filter by the object’s `statementDate` field. */
  statementDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `statementMonth` field. */
  statementMonth?: InputMaybe<IntFilter>;
  /** Filter by the object’s `statementYear` field. */
  statementYear?: InputMaybe<IntFilter>;
  /** Filter by the object’s `utilityMeterId` field. */
  utilityMeterId?: InputMaybe<IntFilter>;
};

/** Methods to use when ordering `UtilityMeter`. */
export enum UtilityMetersOrderBy {
  ACTIVE_END_ASC = 'ACTIVE_END_ASC',
  ACTIVE_END_DESC = 'ACTIVE_END_DESC',
  ACTIVE_START_ASC = 'ACTIVE_START_ASC',
  ACTIVE_START_DESC = 'ACTIVE_START_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DEFAULT_DEMAND_UNITS_ASC = 'DEFAULT_DEMAND_UNITS_ASC',
  DEFAULT_DEMAND_UNITS_DESC = 'DEFAULT_DEMAND_UNITS_DESC',
  DEFAULT_USAGE_UNITS_ASC = 'DEFAULT_USAGE_UNITS_ASC',
  DEFAULT_USAGE_UNITS_DESC = 'DEFAULT_USAGE_UNITS_DESC',
  DELETED_AT_ASC = 'DELETED_AT_ASC',
  DELETED_AT_DESC = 'DELETED_AT_DESC',
  EXCLUDE_CARBON_ASC = 'EXCLUDE_CARBON_ASC',
  EXCLUDE_CARBON_DESC = 'EXCLUDE_CARBON_DESC',
  EXCLUDE_USAGE_ASC = 'EXCLUDE_USAGE_ASC',
  EXCLUDE_USAGE_DESC = 'EXCLUDE_USAGE_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  INTEGRATION_METER_KEY_ASC = 'INTEGRATION_METER_KEY_ASC',
  INTEGRATION_METER_KEY_DESC = 'INTEGRATION_METER_KEY_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  METER_NUMBER_ASC = 'METER_NUMBER_ASC',
  METER_NUMBER_DESC = 'METER_NUMBER_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  OVERRIDE_AT_ASC = 'OVERRIDE_AT_ASC',
  OVERRIDE_AT_DESC = 'OVERRIDE_AT_DESC',
  OVERRIDE_METER_NUMBER_ASC = 'OVERRIDE_METER_NUMBER_ASC',
  OVERRIDE_METER_NUMBER_DESC = 'OVERRIDE_METER_NUMBER_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SERVICE_TYPE_ASC = 'SERVICE_TYPE_ASC',
  SERVICE_TYPE_DESC = 'SERVICE_TYPE_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_COUNT_ASC = 'UTILITY_METER_STATEMENTS_COUNT_ASC',
  UTILITY_METER_STATEMENTS_COUNT_DESC = 'UTILITY_METER_STATEMENTS_COUNT_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_MAX_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_MAX_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_MAX_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_MAX_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_MAX_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_MAX_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_MAX_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_MAX_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_MAX_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_MAX_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_MAX_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_MAX_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_MAX_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_MAX_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_MAX_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_MAX_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_MAX_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_MAX_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_MAX_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_MAX_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_MAX_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_MAX_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_MAX_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_MAX_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_MAX_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_MAX_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_MAX_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_MAX_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_MAX_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_MAX_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_MAX_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_MAX_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_MAX_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_MAX_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_MAX_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_MAX_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_MAX_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_MAX_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_MAX_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_MAX_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_MAX_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_MAX_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_MAX_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_MAX_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_MAX_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_MAX_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_MAX_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_MAX_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_MAX_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_MAX_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_MAX_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_MAX_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_MAX_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_MAX_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_MAX_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_MAX_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_MAX_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_MAX_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_MAX_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_MIN_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_MIN_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_MIN_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_MIN_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_MIN_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_MIN_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_MIN_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_MIN_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_MIN_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_MIN_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_MIN_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_MIN_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_MIN_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_MIN_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_MIN_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_MIN_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_MIN_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_MIN_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_MIN_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_MIN_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_MIN_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_MIN_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_MIN_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_MIN_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_MIN_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_MIN_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_MIN_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_MIN_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_MIN_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_MIN_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_MIN_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_MIN_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_MIN_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_MIN_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_MIN_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_MIN_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_MIN_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_MIN_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_MIN_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_MIN_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_MIN_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_MIN_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_MIN_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_MIN_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_MIN_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_MIN_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_MIN_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_MIN_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_MIN_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_MIN_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_MIN_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_MIN_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_MIN_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_MIN_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_MIN_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_MIN_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_MIN_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_MIN_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_MIN_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_SUM_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_SUM_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_SUM_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_SUM_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_SUM_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_SUM_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_SUM_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_SUM_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_SUM_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_SUM_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_SUM_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_SUM_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_SUM_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_SUM_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_SUM_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_SUM_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_SUM_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_SUM_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_SUM_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_SUM_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_SUM_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_SUM_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_SUM_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_SUM_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_SUM_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_SUM_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_SUM_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_SUM_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_SUM_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_SUM_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_SUM_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_SUM_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_SUM_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_SUM_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_SUM_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_SUM_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_SUM_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_SUM_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_SUM_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_SUM_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_SUM_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_SUM_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_SUM_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_SUM_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_SUM_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_SUM_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_SUM_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_SUM_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_SUM_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_SUM_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_SUM_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_SUM_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_SUM_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_SUM_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_SUM_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_SUM_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_SUM_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_SUM_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_SUM_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_COUNT_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_COUNT_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_COUNT_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_COUNT_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_METER_ID_DESC'
}

/** A utility provider. */
export type UtilityProvider = Node & {
  __typename?: 'UtilityProvider';
  /** The time this provider was created. */
  createdAt: Scalars['Datetime'];
  /** The primary unique identifier for the provider. */
  id: Scalars['Int'];
  /** The name of the provider. */
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The time this provider was updated. */
  updatedAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `UtilityAccount`. */
  utilityAccounts: UtilityAccountsConnection;
};

/** A utility provider. */
export type UtilityProviderUtilityAccountsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UtilityAccountCondition>;
  filter?: InputMaybe<UtilityAccountFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UtilityAccountsOrderBy>>;
};

/**
 * A condition to be used against `UtilityProvider` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UtilityProviderCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `UtilityProvider` object types. All fields are combined with a logical ‘and.’ */
export type UtilityProviderFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UtilityProviderFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UtilityProviderFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UtilityProviderFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `UtilityProvider` */
export type UtilityProviderInput = {
  /** The primary unique identifier for the provider. */
  id?: InputMaybe<Scalars['Int']>;
  /** The name of the provider. */
  name: Scalars['String'];
};

/** Represents an update to a `UtilityProvider`. Fields that are set will be updated. */
export type UtilityProviderPatch = {
  /** The name of the provider. */
  name?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `UtilityProvider` values. */
export type UtilityProvidersConnection = {
  __typename?: 'UtilityProvidersConnection';
  /** A list of edges which contains the `UtilityProvider` and cursor to aid in pagination. */
  edges: Array<UtilityProvidersEdge>;
  /** A list of `UtilityProvider` objects. */
  nodes: Array<UtilityProvider>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UtilityProvider` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UtilityProvider` edge in the connection. */
export type UtilityProvidersEdge = {
  __typename?: 'UtilityProvidersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UtilityProvider` at the end of the edge. */
  node: UtilityProvider;
};

/** Methods to use when ordering `UtilityProvider`. */
export enum UtilityProvidersOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** External vendor users that may access the plaform via machine users. */
export type VendorUser = Node & {
  __typename?: 'VendorUser';
  /** The company in which the vendor user belongs. */
  company: Scalars['String'];
  /** The time the vendor user was created. */
  createdAt: Scalars['Datetime'];
  /** The email of the vendor user. */
  email: Scalars['String'];
  /** The first name of the vendor user. */
  firstName?: Maybe<Scalars['String']>;
  /** The id of the vendor user. */
  id: Scalars['Int'];
  /** The last name of the vendor user. */
  lastName?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `MachineUser`. */
  machineUsers: MachineUsersConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Available permissions for the VendorUser. */
  permissions?: Maybe<VendorUserPermissions>;
  /** The time the vendor user was updated. */
  updatedAt: Scalars['Datetime'];
};

/** External vendor users that may access the plaform via machine users. */
export type VendorUserMachineUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<MachineUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/**
 * A condition to be used against `VendorUser` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type VendorUserCondition = {
  /** Checks for equality with the object’s `company` field. */
  company?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `lastName` field. */
  lastName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `VendorUser` object types. All fields are combined with a logical ‘and.’ */
export type VendorUserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VendorUserFilter>>;
  /** Filter by the permission can_write */
  canWrite?: InputMaybe<PermissionBooleanFilter>;
  /** Filter by the object’s `company` field. */
  company?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `firstName` field. */
  firstName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lastName` field. */
  lastName?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VendorUserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VendorUserFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `VendorUser` */
export type VendorUserInput = {
  /** The company in which the vendor user belongs. */
  company: Scalars['String'];
  /** The email of the vendor user. */
  email: Scalars['String'];
  /** The first name of the vendor user. */
  firstName?: InputMaybe<Scalars['String']>;
  /** The last name of the vendor user. */
  lastName?: InputMaybe<Scalars['String']>;
};

export type VendorUserMachineUser = Node & {
  __typename?: 'VendorUserMachineUser';
  /** The machine user associated with the vendor user. */
  machineUserId: Scalars['BigInt'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The id of the vendor user. */
  vendorUserId: Scalars['Int'];
};

/** An input for mutations affecting `VendorUserMachineUser` */
export type VendorUserMachineUserInput = {
  /** The machine user associated with the vendor user. */
  machineUserId: Scalars['BigInt'];
  /** The id of the vendor user. */
  vendorUserId: Scalars['Int'];
};

/** Represents an update to a `VendorUserMachineUser`. Fields that are set will be updated. */
export type VendorUserMachineUserPatch = {
  /** The machine user associated with the vendor user. */
  machineUserId?: InputMaybe<Scalars['BigInt']>;
  /** The id of the vendor user. */
  vendorUserId?: InputMaybe<Scalars['Int']>;
};

/** Represents an update to a `VendorUser`. Fields that are set will be updated. */
export type VendorUserPatch = {
  /** The company in which the vendor user belongs. */
  company?: InputMaybe<Scalars['String']>;
  /** The email of the vendor user. */
  email?: InputMaybe<Scalars['String']>;
  /** The first name of the vendor user. */
  firstName?: InputMaybe<Scalars['String']>;
  /** The last name of the vendor user. */
  lastName?: InputMaybe<Scalars['String']>;
};

/** Permissive capabilities on a VendorUser. */
export type VendorUserPermissions = {
  __typename?: 'VendorUserPermissions';
  /** Whether a user can write a vendor user */
  canWrite: Scalars['Boolean'];
};

/** A connection to a list of `VendorUser` values. */
export type VendorUsersConnection = {
  __typename?: 'VendorUsersConnection';
  /** A list of edges which contains the `VendorUser` and cursor to aid in pagination. */
  edges: Array<VendorUsersEdge>;
  /** A list of `VendorUser` objects. */
  nodes: Array<VendorUser>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VendorUser` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `VendorUser` edge in the connection. */
export type VendorUsersEdge = {
  __typename?: 'VendorUsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `VendorUser` at the end of the edge. */
  node: VendorUser;
};

/** Methods to use when ordering `VendorUser`. */
export enum VendorUsersOrderBy {
  COMPANY_ASC = 'COMPANY_ASC',
  COMPANY_DESC = 'COMPANY_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  EMAIL_ASC = 'EMAIL_ASC',
  EMAIL_DESC = 'EMAIL_DESC',
  FIRST_NAME_ASC = 'FIRST_NAME_ASC',
  FIRST_NAME_DESC = 'FIRST_NAME_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LAST_NAME_ASC = 'LAST_NAME_ASC',
  LAST_NAME_DESC = 'LAST_NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

export type VerifyPhoneNumberInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
};

export type VerifyPhoneNumberResponse = {
  __typename?: 'VerifyPhoneNumberResponse';
  attempts: Scalars['Int'];
  clientMutationId?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  verificationId: Scalars['String'];
};

/** Maps VIRTUAL data points to time bounded child data points which creates a single virtual data stream. */
export type VirtualPointInterval = Node & {
  __typename?: 'VirtualPointInterval';
  /** Reads a single `DataPoint` that is related to this `VirtualPointInterval`. */
  child?: Maybe<DataPoint>;
  /** The id of the child data point. */
  childId: Scalars['BigInt'];
  /** The upper bound of datetime window to apply to child data stream. */
  endTime?: Maybe<Scalars['Datetime']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `DataPoint` that is related to this `VirtualPointInterval`. */
  parent?: Maybe<DataPoint>;
  /** The id of the VIRTUAL data point. */
  parentId: Scalars['BigInt'];
  /** The lower bound of datetime window to apply to child data stream. */
  startTime: Scalars['Datetime'];
};

/**
 * A condition to be used against `VirtualPointInterval` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type VirtualPointIntervalCondition = {
  /** Checks for equality with the object’s `childId` field. */
  childId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `endTime` field. */
  endTime?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `parentId` field. */
  parentId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `startTime` field. */
  startTime?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `VirtualPointInterval` object types. All fields are combined with a logical ‘and.’ */
export type VirtualPointIntervalFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VirtualPointIntervalFilter>>;
  /** Filter by the object’s `childId` field. */
  childId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `endTime` field. */
  endTime?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VirtualPointIntervalFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VirtualPointIntervalFilter>>;
  /** Filter by the object’s `parentId` field. */
  parentId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `startTime` field. */
  startTime?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `VirtualPointInterval` */
export type VirtualPointIntervalInput = {
  /** The id of the child data point. */
  childId?: InputMaybe<Scalars['BigInt']>;
  /** Mutates a `DataPoint` as part of the payload */
  dataPoint?: InputMaybe<DataPointInput>;
  /** The upper bound of datetime window to apply to child data stream. */
  endTime?: InputMaybe<Scalars['Datetime']>;
  /** The id of the VIRTUAL data point. */
  parentId?: InputMaybe<Scalars['BigInt']>;
  /** The lower bound of datetime window to apply to child data stream. */
  startTime: Scalars['Datetime'];
};

/** Represents an update to a `VirtualPointInterval`. Fields that are set will be updated. */
export type VirtualPointIntervalPatch = {
  /** The id of the child data point. */
  childId?: InputMaybe<Scalars['BigInt']>;
  /** The upper bound of datetime window to apply to child data stream. */
  endTime?: InputMaybe<Scalars['Datetime']>;
  /** The id of the VIRTUAL data point. */
  parentId?: InputMaybe<Scalars['BigInt']>;
  /** The lower bound of datetime window to apply to child data stream. */
  startTime?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `VirtualPointInterval` values. */
export type VirtualPointIntervalsConnection = {
  __typename?: 'VirtualPointIntervalsConnection';
  /** Returns the aggregate child timeseries data for the VirtualPointIntervalsConnection  */
  child?: Maybe<MetricDataConnection>;
  /** A list of edges which contains the `VirtualPointInterval` and cursor to aid in pagination. */
  edges: Array<VirtualPointIntervalsEdge>;
  /** A list of `VirtualPointInterval` objects. */
  nodes: Array<VirtualPointInterval>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Returns the aggregate parent timeseries data for the VirtualPointIntervalsConnection  */
  parent?: Maybe<MetricDataConnection>;
  /** The count of *all* `VirtualPointInterval` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A connection to a list of `VirtualPointInterval` values. */
export type VirtualPointIntervalsConnectionChildArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A connection to a list of `VirtualPointInterval` values. */
export type VirtualPointIntervalsConnectionParentArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  window?: Scalars['String'];
};

/** A `VirtualPointInterval` edge in the connection. */
export type VirtualPointIntervalsEdge = {
  __typename?: 'VirtualPointIntervalsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `VirtualPointInterval` at the end of the edge. */
  node: VirtualPointInterval;
};

/** Methods to use when ordering `VirtualPointInterval`. */
export enum VirtualPointIntervalsOrderBy {
  CHILD_ID_ASC = 'CHILD_ID_ASC',
  CHILD_ID_DESC = 'CHILD_ID_DESC',
  END_TIME_ASC = 'END_TIME_ASC',
  END_TIME_DESC = 'END_TIME_DESC',
  NATURAL = 'NATURAL',
  PARENT_ID_ASC = 'PARENT_ID_ASC',
  PARENT_ID_DESC = 'PARENT_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  START_TIME_ASC = 'START_TIME_ASC',
  START_TIME_DESC = 'START_TIME_DESC'
}

export enum WmsLoadDirectionType {
  INBOUND = 'INBOUND',
  OUTBOUND = 'OUTBOUND'
}

/** A filter to be used against WMSLoadDirectionType fields. All fields are combined with a logical ‘and.’ */
export type WmsLoadDirectionTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<WmsLoadDirectionType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<WmsLoadDirectionType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<WmsLoadDirectionType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<WmsLoadDirectionType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<WmsLoadDirectionType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<WmsLoadDirectionType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<WmsLoadDirectionType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<WmsLoadDirectionType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<WmsLoadDirectionType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<WmsLoadDirectionType>>;
};

export type WithdrawSuggestionInput = {
  id: Scalars['Int'];
};

/** One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string. */
export type __EnumValue = {
  __typename?: '__EnumValue';
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  isDeprecated: Scalars['Boolean'];
  deprecationReason?: Maybe<Scalars['String']>;
};

/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __Field = {
  __typename?: '__Field';
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  args: Array<__InputValue>;
  type: __Type;
  isDeprecated: Scalars['Boolean'];
  deprecationReason?: Maybe<Scalars['String']>;
};

/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __FieldArgsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']>;
};

/** Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value. */
export type __InputValue = {
  __typename?: '__InputValue';
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type: __Type;
  /** A GraphQL-formatted string representing the default value for this input value. */
  defaultValue?: Maybe<Scalars['String']>;
  isDeprecated: Scalars['Boolean'];
  deprecationReason?: Maybe<Scalars['String']>;
};

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __Type = {
  __typename?: '__Type';
  kind: __TypeKind;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  specifiedByURL?: Maybe<Scalars['String']>;
  fields?: Maybe<Array<__Field>>;
  interfaces?: Maybe<Array<__Type>>;
  possibleTypes?: Maybe<Array<__Type>>;
  enumValues?: Maybe<Array<__EnumValue>>;
  inputFields?: Maybe<Array<__InputValue>>;
  ofType?: Maybe<__Type>;
  isOneOf?: Maybe<Scalars['Boolean']>;
};

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']>;
};

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeEnumValuesArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']>;
};

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeInputFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']>;
};

/** An enum describing what kind of type a given `__Type` is. */
export enum __TypeKind {
  /** Indicates this type is a scalar. */
  SCALAR = 'SCALAR',
  /** Indicates this type is an object. `fields` and `interfaces` are valid fields. */
  OBJECT = 'OBJECT',
  /** Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields. */
  INTERFACE = 'INTERFACE',
  /** Indicates this type is a union. `possibleTypes` is a valid field. */
  UNION = 'UNION',
  /** Indicates this type is an enum. `enumValues` is a valid field. */
  ENUM = 'ENUM',
  /** Indicates this type is an input object. `inputFields` is a valid field. */
  INPUT_OBJECT = 'INPUT_OBJECT',
  /** Indicates this type is a list. `ofType` is a valid field. */
  LIST = 'LIST',
  /** Indicates this type is a non-null. `ofType` is a valid field. */
  NON_NULL = 'NON_NULL'
}

export type AllFaciltiesQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<FacilitiesOrderBy> | FacilitiesOrderBy>;
}>;

export type AllFaciltiesQuery = {
  __typename?: 'Query';
  facilities?: {
    __typename?: 'FacilitiesConnection';
    nodes: Array<{ __typename?: 'Facility'; id: number; name: string }>;
  } | null;
};

export type ExtendMutationVariables = Exact<{
  payload: Scalars['String'];
  failOnExists?: InputMaybe<Scalars['Boolean']>;
}>;

export type ExtendMutation = {
  __typename?: 'Mutation';
  extend?: boolean | null;
};

export type GetFacilitySchemaQueryVariables = Exact<{ [key: string]: never }>;

export type GetFacilitySchemaQuery = {
  __typename?: 'Query';
  __type?: {
    __typename?: '__Type';
    fields?: Array<{
      __typename?: '__Field';
      name: string;
      description?: string | null;
      type: {
        __typename?: '__Type';
        name?: string | null;
        kind: __TypeKind;
        ofType?: {
          __typename?: '__Type';
          name?: string | null;
          kind: __TypeKind;
        } | null;
      };
    }> | null;
  } | null;
};

export type AllFacilitiesWithAddressQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AllFacilitiesWithAddressQuery = {
  __typename?: 'Query';
  facilities?: {
    __typename?: 'FacilitiesConnection';
    nodes: Array<{
      __typename?: 'Facility';
      id: number;
      slug: string;
      name: string;
      address?: string | null;
    }>;
  } | null;
};

export type DeleteFacilityByNodeIdMutationVariables = Exact<{
  input: DeleteFacilityByNodeIdInput;
}>;

export type DeleteFacilityByNodeIdMutation = {
  __typename?: 'Mutation';
  deleteFacilityByNodeId?: {
    __typename?: 'DeleteFacilityPayload';
    deletedFacilityNodeId?: string | null;
  } | null;
};

export type GetTimezonesQueryVariables = Exact<{ [key: string]: never }>;

export type GetTimezonesQuery = {
  __typename?: 'Query';
  timezones?: {
    __typename?: 'TimezonesConnection';
    nodes: Array<{
      __typename?: 'Timezone';
      abbreviation?: string | null;
      name: string;
      isDst?: boolean | null;
      utcOffset?: { __typename?: 'Interval'; hours?: number | null } | null;
    }>;
  } | null;
};

export type FacilityGroupByIdQueryVariables = Exact<{
  facilityGroupByIdId: Scalars['BigInt'];
}>;

export type FacilityGroupByIdQuery = {
  __typename?: 'Query';
  facilityGroup?: {
    __typename?: 'FacilityGroup';
    facilities: {
      __typename?: 'FacilitiesConnection';
      nodes: Array<{
        __typename?: 'Facility';
        id: number;
        name: string;
        city?: string | null;
        state?: string | null;
        zip?: string | null;
      }>;
    };
  } | null;
};

export type AllFacilitiesQueryVariables = Exact<{ [key: string]: never }>;

export type AllFacilitiesQuery = {
  __typename?: 'Query';
  facilities?: {
    __typename?: 'FacilitiesConnection';
    nodes: Array<{
      __typename?: 'Facility';
      name: string;
      address?: string | null;
      city?: string | null;
      state?: string | null;
      zip?: string | null;
      slug: string;
      id: number;
      facilityGroups: {
        __typename?: 'FacilityGroupsConnection';
        nodes: Array<{ __typename?: 'FacilityGroup'; id: any; name: string }>;
      };
    }>;
  } | null;
};

export type CreateFacilityGroupMutationVariables = Exact<{
  input: CreateFacilityGroupInput;
}>;

export type CreateFacilityGroupMutation = {
  __typename?: 'Mutation';
  createFacilityGroup?: {
    __typename?: 'CreateFacilityGroupPayload';
    facilityGroup?: {
      __typename?: 'FacilityGroup';
      name: string;
      parentId?: any | null;
      id: any;
    } | null;
  } | null;
};

export type UpdateFacilityGroupByIdMutationVariables = Exact<{
  input: UpdateFacilityGroupInput;
}>;

export type UpdateFacilityGroupByIdMutation = {
  __typename?: 'Mutation';
  updateFacilityGroup?: {
    __typename?: 'UpdateFacilityGroupPayload';
    facilityGroup?: {
      __typename?: 'FacilityGroup';
      id: any;
      name: string;
      parent?: { __typename?: 'FacilityGroup'; id: any; name: string } | null;
    } | null;
  } | null;
};

export type AllGroupsQueryVariables = Exact<{ [key: string]: never }>;

export type AllGroupsQuery = {
  __typename?: 'Query';
  facilityGroups?: {
    __typename?: 'FacilityGroupsConnection';
    nodes: Array<{
      __typename?: 'FacilityGroup';
      id: any;
      name: string;
      parentId?: any | null;
      facilities: {
        __typename?: 'FacilitiesConnection';
        nodes: Array<{
          __typename?: 'Facility';
          id: number;
          name: string;
          address?: string | null;
          city?: string | null;
          state?: string | null;
          zip?: string | null;
          slug: string;
          facilityGroups: {
            __typename?: 'FacilityGroupsConnection';
            nodes: Array<{ __typename?: 'FacilityGroup'; id: any }>;
          };
        }>;
      };
    }>;
  } | null;
};

export type AddFacilityToGroupMutationVariables = Exact<{
  input: CreateFacilityGroupsLinkerInput;
}>;

export type AddFacilityToGroupMutation = {
  __typename?: 'Mutation';
  createFacilityGroupsLinker?: {
    __typename?: 'CreateFacilityGroupsLinkerPayload';
    facilityGroupsLinker?: {
      __typename?: 'FacilityGroupsLinker';
      facilityGroupingId: any;
      facilityId: number;
    } | null;
  } | null;
};

export type RemoveFacilityFromGroupMutationVariables = Exact<{
  input: DeleteFacilityGroupsLinkerInput;
}>;

export type RemoveFacilityFromGroupMutation = {
  __typename?: 'Mutation';
  deleteFacilityGroupsLinker?: {
    __typename?: 'DeleteFacilityGroupsLinkerPayload';
    facilityGroupsLinker?: {
      __typename?: 'FacilityGroupsLinker';
      facilityGroupingId: any;
      facilityId: number;
    } | null;
  } | null;
};

export type DeleteFacilityGroupByIdMutationVariables = Exact<{
  input: DeleteFacilityGroupInput;
}>;

export type DeleteFacilityGroupByIdMutation = {
  __typename?: 'Mutation';
  deleteFacilityGroup?: {
    __typename?: 'DeleteFacilityGroupPayload';
    facilityGroup?: {
      __typename?: 'FacilityGroup';
      name: string;
      id: any;
    } | null;
  } | null;
};

export const AllFaciltiesDocument = gql`
  query AllFacilties($orderBy: [FacilitiesOrderBy!]) {
    facilities(orderBy: $orderBy) {
      nodes {
        id
        name
      }
    }
  }
`;

/**
 * __useAllFaciltiesQuery__
 *
 * To run a query within a React component, call `useAllFaciltiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllFaciltiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllFaciltiesQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useAllFaciltiesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AllFaciltiesQuery,
    AllFaciltiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AllFaciltiesQuery, AllFaciltiesQueryVariables>(
    AllFaciltiesDocument,
    options
  );
}
export function useAllFaciltiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AllFaciltiesQuery,
    AllFaciltiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AllFaciltiesQuery, AllFaciltiesQueryVariables>(
    AllFaciltiesDocument,
    options
  );
}
export type AllFaciltiesQueryHookResult = ReturnType<
  typeof useAllFaciltiesQuery
>;
export type AllFaciltiesLazyQueryHookResult = ReturnType<
  typeof useAllFaciltiesLazyQuery
>;
export type AllFaciltiesQueryResult = Apollo.QueryResult<
  AllFaciltiesQuery,
  AllFaciltiesQueryVariables
>;
export const ExtendDocument = gql`
  mutation Extend($payload: String!, $failOnExists: Boolean) {
    extend(payload: $payload, failOnExists: $failOnExists)
  }
`;
export type ExtendMutationFn = Apollo.MutationFunction<
  ExtendMutation,
  ExtendMutationVariables
>;

/**
 * __useExtendMutation__
 *
 * To run a mutation, you first call `useExtendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExtendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [extendMutation, { data, loading, error }] = useExtendMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *      failOnExists: // value for 'failOnExists'
 *   },
 * });
 */
export function useExtendMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExtendMutation,
    ExtendMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ExtendMutation, ExtendMutationVariables>(
    ExtendDocument,
    options
  );
}
export type ExtendMutationHookResult = ReturnType<typeof useExtendMutation>;
export type ExtendMutationResult = Apollo.MutationResult<ExtendMutation>;
export type ExtendMutationOptions = Apollo.BaseMutationOptions<
  ExtendMutation,
  ExtendMutationVariables
>;
export const GetFacilitySchemaDocument = gql`
  query getFacilitySchema {
    __type(name: "Facility") {
      fields {
        name
        description
        type {
          name
          kind
          ofType {
            name
            kind
          }
        }
      }
    }
  }
`;

/**
 * __useGetFacilitySchemaQuery__
 *
 * To run a query within a React component, call `useGetFacilitySchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFacilitySchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFacilitySchemaQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFacilitySchemaQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetFacilitySchemaQuery,
    GetFacilitySchemaQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetFacilitySchemaQuery,
    GetFacilitySchemaQueryVariables
  >(GetFacilitySchemaDocument, options);
}
export function useGetFacilitySchemaLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFacilitySchemaQuery,
    GetFacilitySchemaQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFacilitySchemaQuery,
    GetFacilitySchemaQueryVariables
  >(GetFacilitySchemaDocument, options);
}
export type GetFacilitySchemaQueryHookResult = ReturnType<
  typeof useGetFacilitySchemaQuery
>;
export type GetFacilitySchemaLazyQueryHookResult = ReturnType<
  typeof useGetFacilitySchemaLazyQuery
>;
export type GetFacilitySchemaQueryResult = Apollo.QueryResult<
  GetFacilitySchemaQuery,
  GetFacilitySchemaQueryVariables
>;
export const AllFacilitiesWithAddressDocument = gql`
  query AllFacilitiesWithAddress {
    facilities {
      nodes {
        id
        slug
        name
        address
      }
    }
  }
`;

/**
 * __useAllFacilitiesWithAddressQuery__
 *
 * To run a query within a React component, call `useAllFacilitiesWithAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllFacilitiesWithAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllFacilitiesWithAddressQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllFacilitiesWithAddressQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AllFacilitiesWithAddressQuery,
    AllFacilitiesWithAddressQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AllFacilitiesWithAddressQuery,
    AllFacilitiesWithAddressQueryVariables
  >(AllFacilitiesWithAddressDocument, options);
}
export function useAllFacilitiesWithAddressLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AllFacilitiesWithAddressQuery,
    AllFacilitiesWithAddressQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AllFacilitiesWithAddressQuery,
    AllFacilitiesWithAddressQueryVariables
  >(AllFacilitiesWithAddressDocument, options);
}
export type AllFacilitiesWithAddressQueryHookResult = ReturnType<
  typeof useAllFacilitiesWithAddressQuery
>;
export type AllFacilitiesWithAddressLazyQueryHookResult = ReturnType<
  typeof useAllFacilitiesWithAddressLazyQuery
>;
export type AllFacilitiesWithAddressQueryResult = Apollo.QueryResult<
  AllFacilitiesWithAddressQuery,
  AllFacilitiesWithAddressQueryVariables
>;
export const DeleteFacilityByNodeIdDocument = gql`
  mutation DeleteFacilityByNodeId($input: DeleteFacilityByNodeIdInput!) {
    deleteFacilityByNodeId(input: $input) {
      deletedFacilityNodeId
    }
  }
`;
export type DeleteFacilityByNodeIdMutationFn = Apollo.MutationFunction<
  DeleteFacilityByNodeIdMutation,
  DeleteFacilityByNodeIdMutationVariables
>;

/**
 * __useDeleteFacilityByNodeIdMutation__
 *
 * To run a mutation, you first call `useDeleteFacilityByNodeIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFacilityByNodeIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFacilityByNodeIdMutation, { data, loading, error }] = useDeleteFacilityByNodeIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFacilityByNodeIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteFacilityByNodeIdMutation,
    DeleteFacilityByNodeIdMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteFacilityByNodeIdMutation,
    DeleteFacilityByNodeIdMutationVariables
  >(DeleteFacilityByNodeIdDocument, options);
}
export type DeleteFacilityByNodeIdMutationHookResult = ReturnType<
  typeof useDeleteFacilityByNodeIdMutation
>;
export type DeleteFacilityByNodeIdMutationResult =
  Apollo.MutationResult<DeleteFacilityByNodeIdMutation>;
export type DeleteFacilityByNodeIdMutationOptions = Apollo.BaseMutationOptions<
  DeleteFacilityByNodeIdMutation,
  DeleteFacilityByNodeIdMutationVariables
>;
export const GetTimezonesDocument = gql`
  query getTimezones {
    timezones {
      nodes {
        abbreviation
        name
        isDst
        utcOffset {
          hours
        }
      }
    }
  }
`;

/**
 * __useGetTimezonesQuery__
 *
 * To run a query within a React component, call `useGetTimezonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimezonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimezonesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTimezonesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetTimezonesQuery,
    GetTimezonesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTimezonesQuery, GetTimezonesQueryVariables>(
    GetTimezonesDocument,
    options
  );
}
export function useGetTimezonesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTimezonesQuery,
    GetTimezonesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTimezonesQuery, GetTimezonesQueryVariables>(
    GetTimezonesDocument,
    options
  );
}
export type GetTimezonesQueryHookResult = ReturnType<
  typeof useGetTimezonesQuery
>;
export type GetTimezonesLazyQueryHookResult = ReturnType<
  typeof useGetTimezonesLazyQuery
>;
export type GetTimezonesQueryResult = Apollo.QueryResult<
  GetTimezonesQuery,
  GetTimezonesQueryVariables
>;
export const FacilityGroupByIdDocument = gql`
  query FacilityGroupById($facilityGroupByIdId: BigInt!) {
    facilityGroup(id: $facilityGroupByIdId) {
      facilities {
        nodes {
          id
          name
          city
          state
          zip
        }
      }
    }
  }
`;

/**
 * __useFacilityGroupByIdQuery__
 *
 * To run a query within a React component, call `useFacilityGroupByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacilityGroupByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacilityGroupByIdQuery({
 *   variables: {
 *      facilityGroupByIdId: // value for 'facilityGroupByIdId'
 *   },
 * });
 */
export function useFacilityGroupByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    FacilityGroupByIdQuery,
    FacilityGroupByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FacilityGroupByIdQuery,
    FacilityGroupByIdQueryVariables
  >(FacilityGroupByIdDocument, options);
}
export function useFacilityGroupByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FacilityGroupByIdQuery,
    FacilityGroupByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FacilityGroupByIdQuery,
    FacilityGroupByIdQueryVariables
  >(FacilityGroupByIdDocument, options);
}
export type FacilityGroupByIdQueryHookResult = ReturnType<
  typeof useFacilityGroupByIdQuery
>;
export type FacilityGroupByIdLazyQueryHookResult = ReturnType<
  typeof useFacilityGroupByIdLazyQuery
>;
export type FacilityGroupByIdQueryResult = Apollo.QueryResult<
  FacilityGroupByIdQuery,
  FacilityGroupByIdQueryVariables
>;
export const AllFacilitiesDocument = gql`
  query AllFacilities {
    facilities {
      nodes {
        name
        address
        city
        state
        zip
        slug
        id
        facilityGroups {
          nodes {
            id
            name
          }
        }
      }
    }
  }
`;

/**
 * __useAllFacilitiesQuery__
 *
 * To run a query within a React component, call `useAllFacilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllFacilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllFacilitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllFacilitiesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AllFacilitiesQuery,
    AllFacilitiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AllFacilitiesQuery, AllFacilitiesQueryVariables>(
    AllFacilitiesDocument,
    options
  );
}
export function useAllFacilitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AllFacilitiesQuery,
    AllFacilitiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AllFacilitiesQuery, AllFacilitiesQueryVariables>(
    AllFacilitiesDocument,
    options
  );
}
export type AllFacilitiesQueryHookResult = ReturnType<
  typeof useAllFacilitiesQuery
>;
export type AllFacilitiesLazyQueryHookResult = ReturnType<
  typeof useAllFacilitiesLazyQuery
>;
export type AllFacilitiesQueryResult = Apollo.QueryResult<
  AllFacilitiesQuery,
  AllFacilitiesQueryVariables
>;
export const CreateFacilityGroupDocument = gql`
  mutation CreateFacilityGroup($input: CreateFacilityGroupInput!) {
    createFacilityGroup(input: $input) {
      facilityGroup {
        name
        parentId
        id
      }
    }
  }
`;
export type CreateFacilityGroupMutationFn = Apollo.MutationFunction<
  CreateFacilityGroupMutation,
  CreateFacilityGroupMutationVariables
>;

/**
 * __useCreateFacilityGroupMutation__
 *
 * To run a mutation, you first call `useCreateFacilityGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFacilityGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFacilityGroupMutation, { data, loading, error }] = useCreateFacilityGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFacilityGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFacilityGroupMutation,
    CreateFacilityGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateFacilityGroupMutation,
    CreateFacilityGroupMutationVariables
  >(CreateFacilityGroupDocument, options);
}
export type CreateFacilityGroupMutationHookResult = ReturnType<
  typeof useCreateFacilityGroupMutation
>;
export type CreateFacilityGroupMutationResult =
  Apollo.MutationResult<CreateFacilityGroupMutation>;
export type CreateFacilityGroupMutationOptions = Apollo.BaseMutationOptions<
  CreateFacilityGroupMutation,
  CreateFacilityGroupMutationVariables
>;
export const UpdateFacilityGroupByIdDocument = gql`
  mutation UpdateFacilityGroupById($input: UpdateFacilityGroupInput!) {
    updateFacilityGroup(input: $input) {
      facilityGroup {
        id
        name
        parent {
          id
          name
        }
      }
    }
  }
`;
export type UpdateFacilityGroupByIdMutationFn = Apollo.MutationFunction<
  UpdateFacilityGroupByIdMutation,
  UpdateFacilityGroupByIdMutationVariables
>;

/**
 * __useUpdateFacilityGroupByIdMutation__
 *
 * To run a mutation, you first call `useUpdateFacilityGroupByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFacilityGroupByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFacilityGroupByIdMutation, { data, loading, error }] = useUpdateFacilityGroupByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFacilityGroupByIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateFacilityGroupByIdMutation,
    UpdateFacilityGroupByIdMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateFacilityGroupByIdMutation,
    UpdateFacilityGroupByIdMutationVariables
  >(UpdateFacilityGroupByIdDocument, options);
}
export type UpdateFacilityGroupByIdMutationHookResult = ReturnType<
  typeof useUpdateFacilityGroupByIdMutation
>;
export type UpdateFacilityGroupByIdMutationResult =
  Apollo.MutationResult<UpdateFacilityGroupByIdMutation>;
export type UpdateFacilityGroupByIdMutationOptions = Apollo.BaseMutationOptions<
  UpdateFacilityGroupByIdMutation,
  UpdateFacilityGroupByIdMutationVariables
>;
export const AllGroupsDocument = gql`
  query AllGroups {
    facilityGroups {
      nodes {
        id
        name
        parentId
        facilities {
          nodes {
            id
            name
            address
            city
            state
            zip
            slug
            facilityGroups {
              nodes {
                id
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useAllGroupsQuery__
 *
 * To run a query within a React component, call `useAllGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<AllGroupsQuery, AllGroupsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AllGroupsQuery, AllGroupsQueryVariables>(
    AllGroupsDocument,
    options
  );
}
export function useAllGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AllGroupsQuery,
    AllGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AllGroupsQuery, AllGroupsQueryVariables>(
    AllGroupsDocument,
    options
  );
}
export type AllGroupsQueryHookResult = ReturnType<typeof useAllGroupsQuery>;
export type AllGroupsLazyQueryHookResult = ReturnType<
  typeof useAllGroupsLazyQuery
>;
export type AllGroupsQueryResult = Apollo.QueryResult<
  AllGroupsQuery,
  AllGroupsQueryVariables
>;
export const AddFacilityToGroupDocument = gql`
  mutation AddFacilityToGroup($input: CreateFacilityGroupsLinkerInput!) {
    createFacilityGroupsLinker(input: $input) {
      facilityGroupsLinker {
        facilityGroupingId
        facilityId
      }
    }
  }
`;
export type AddFacilityToGroupMutationFn = Apollo.MutationFunction<
  AddFacilityToGroupMutation,
  AddFacilityToGroupMutationVariables
>;

/**
 * __useAddFacilityToGroupMutation__
 *
 * To run a mutation, you first call `useAddFacilityToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFacilityToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFacilityToGroupMutation, { data, loading, error }] = useAddFacilityToGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddFacilityToGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddFacilityToGroupMutation,
    AddFacilityToGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddFacilityToGroupMutation,
    AddFacilityToGroupMutationVariables
  >(AddFacilityToGroupDocument, options);
}
export type AddFacilityToGroupMutationHookResult = ReturnType<
  typeof useAddFacilityToGroupMutation
>;
export type AddFacilityToGroupMutationResult =
  Apollo.MutationResult<AddFacilityToGroupMutation>;
export type AddFacilityToGroupMutationOptions = Apollo.BaseMutationOptions<
  AddFacilityToGroupMutation,
  AddFacilityToGroupMutationVariables
>;
export const RemoveFacilityFromGroupDocument = gql`
  mutation RemoveFacilityFromGroup($input: DeleteFacilityGroupsLinkerInput!) {
    deleteFacilityGroupsLinker(input: $input) {
      facilityGroupsLinker {
        facilityGroupingId
        facilityId
      }
    }
  }
`;
export type RemoveFacilityFromGroupMutationFn = Apollo.MutationFunction<
  RemoveFacilityFromGroupMutation,
  RemoveFacilityFromGroupMutationVariables
>;

/**
 * __useRemoveFacilityFromGroupMutation__
 *
 * To run a mutation, you first call `useRemoveFacilityFromGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFacilityFromGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFacilityFromGroupMutation, { data, loading, error }] = useRemoveFacilityFromGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveFacilityFromGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveFacilityFromGroupMutation,
    RemoveFacilityFromGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveFacilityFromGroupMutation,
    RemoveFacilityFromGroupMutationVariables
  >(RemoveFacilityFromGroupDocument, options);
}
export type RemoveFacilityFromGroupMutationHookResult = ReturnType<
  typeof useRemoveFacilityFromGroupMutation
>;
export type RemoveFacilityFromGroupMutationResult =
  Apollo.MutationResult<RemoveFacilityFromGroupMutation>;
export type RemoveFacilityFromGroupMutationOptions = Apollo.BaseMutationOptions<
  RemoveFacilityFromGroupMutation,
  RemoveFacilityFromGroupMutationVariables
>;
export const DeleteFacilityGroupByIdDocument = gql`
  mutation DeleteFacilityGroupById($input: DeleteFacilityGroupInput!) {
    deleteFacilityGroup(input: $input) {
      facilityGroup {
        name
        id
      }
    }
  }
`;
export type DeleteFacilityGroupByIdMutationFn = Apollo.MutationFunction<
  DeleteFacilityGroupByIdMutation,
  DeleteFacilityGroupByIdMutationVariables
>;

/**
 * __useDeleteFacilityGroupByIdMutation__
 *
 * To run a mutation, you first call `useDeleteFacilityGroupByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFacilityGroupByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFacilityGroupByIdMutation, { data, loading, error }] = useDeleteFacilityGroupByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFacilityGroupByIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteFacilityGroupByIdMutation,
    DeleteFacilityGroupByIdMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteFacilityGroupByIdMutation,
    DeleteFacilityGroupByIdMutationVariables
  >(DeleteFacilityGroupByIdDocument, options);
}
export type DeleteFacilityGroupByIdMutationHookResult = ReturnType<
  typeof useDeleteFacilityGroupByIdMutation
>;
export type DeleteFacilityGroupByIdMutationResult =
  Apollo.MutationResult<DeleteFacilityGroupByIdMutation>;
export type DeleteFacilityGroupByIdMutationOptions = Apollo.BaseMutationOptions<
  DeleteFacilityGroupByIdMutation,
  DeleteFacilityGroupByIdMutationVariables
>;
